$wj([2],{

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var reactive_1 = __webpack_require__(1593);
exports.reactive = reactive_1.default;


/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
// Create a Lazy editor plugin type
// Parameters:
//  lazyModule: lazyModule from which to get the PluginClass
//  getter: function to get the PluginClass from the lazyModule once it is loaded
//  importTrigger: (optional) a function to check if the real plugin need to be loaded. If null, the plugin will be loaded immediately when initialize
// Usage:
//  (Suppose MyPlugin is the type of real plugin, myImportTrigger is the trigger function)
//
// import * as MyPluginModule from './MyPlugin';
//
// const lazyModule = new LazyModule(() =>
//     System.import<typeof MyPluginModule>(
//         /* webpackChunkName: "MyPlugin" */ './MyPlugin'
//     )
// );
//
// export let LazyMyPluginClass = createLazyPlugin(
//     lazyModule,
//     m => m.default,
//     myImportTrigger);
//
// When use this plugin:
//    let myPlugin: LazyMyPlugin = new LazyMyPluginClass(...);
//    let myRealPlugin = await myPlugin.getPlugin();
function createLazyPlugin(lazyModule, getter, importTrigger) {
    return /** @class */ (function () {
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this.onImportedCallbacks = [];
            this.args = args;
        }
        class_1.prototype.initialize = function (editor) {
            this.editor = editor;
            if (this.pluginInstance) {
                this.initializeAndCallback();
            }
            else if (!importTrigger) {
                this.internalImport();
            }
        };
        class_1.prototype.dispose = function () {
            if (this.pluginInstance) {
                this.pluginInstance.dispose();
                this.pluginInstance = null;
            }
            this.editor = null;
            this.importPluginPromise = null;
            // reset to empty array in case this plugin is reused
            this.onImportedCallbacks = [];
        };
        class_1.prototype.setPluginUtils = function (pluginUtils) {
            this.pluginUtils = pluginUtils;
            if (this.pluginInstance) {
                var pluginEx = this.pluginInstance;
                if (pluginEx.setPluginUtils) {
                    pluginEx.setPluginUtils(this.pluginUtils);
                }
            }
        };
        class_1.prototype.onPluginEvent = function (event) {
            if (this.pluginInstance) {
                if (this.pluginInstance.onPluginEvent) {
                    this.pluginInstance.onPluginEvent(event);
                }
            }
            else if (importTrigger && importTrigger(event, this.editor)) {
                this.internalImport(event);
            }
        };
        class_1.prototype.willHandleEventExclusively = function (event) {
            if (this.pluginInstance && this.pluginInstance.willHandleEventExclusively) {
                return this.pluginInstance.willHandleEventExclusively(event);
            }
            else {
                return false;
            }
        };
        class_1.prototype.getPlugin = function () {
            if (this.pluginInstance) {
                return Promise.resolve(this.pluginInstance);
            }
            else {
                return this.internalImport();
            }
        };
        class_1.prototype.isImported = function () {
            return !!this.pluginInstance;
        };
        class_1.prototype.addOnImportedCallback = function (callback) {
            if (this.isImported()) {
                callback(this.pluginInstance);
            }
            else if (this.onImportedCallbacks) {
                this.onImportedCallbacks.push(callback);
            }
        };
        class_1.prototype.initializeAndCallback = function () {
            var _this = this;
            this.pluginInstance.initialize(this.editor);
            this.onImportedCallbacks.forEach(function (callback) { return callback(_this.pluginInstance); });
        };
        class_1.prototype.internalImport = function (event) {
            var _this = this;
            if (!this.importPluginPromise) {
                this.importPluginPromise = new owa_bundling_1.LazyImport(lazyModule, getter)
                    .import()
                    .then(function (PluginClass) {
                    _this.pluginInstance = new (PluginClass.bind.apply(PluginClass, [void 0].concat(_this.args)))();
                    var pluginEx = _this.pluginInstance;
                    if (pluginEx.setPluginUtils) {
                        pluginEx.setPluginUtils(_this.pluginUtils);
                    }
                    if (_this.editor) {
                        _this.initializeAndCallback();
                        if (event) {
                            _this.pluginInstance.onPluginEvent(event);
                        }
                    }
                    return _this.pluginInstance;
                });
            }
            return this.importPluginPromise;
        };
        return class_1;
    }());
}
exports.default = createLazyPlugin;
//# sourceMappingURL=createLazyPlugin.js.map

/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1586), exports);
//# sourceMappingURL=Label.js.map

/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1744), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function findPeopleJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'FindPeopleJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = findPeopleJsonRequest;


/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1751), exports);
tslib_1.__exportStar(__webpack_require__(1563), exports);
tslib_1.__exportStar(__webpack_require__(1564), exports);
tslib_1.__exportStar(__webpack_require__(671), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var DialogContent_types_1 = __webpack_require__(671);
var Button_1 = __webpack_require__(62);
var DialogFooter_1 = __webpack_require__(1564);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogContent = /** @class */ (function (_super) {
    tslib_1.__extends(DialogContent, _super);
    function DialogContent(props) {
        return _super.call(this, props) || this;
    }
    DialogContent.prototype.render = function () {
        var _a = this.props, showCloseButton = _a.showCloseButton, closeButtonAriaLabel = _a.closeButtonAriaLabel, onDismiss = _a.onDismiss, subTextId = _a.subTextId, subText = _a.subText, titleId = _a.titleId, title = _a.title, type = _a.type;
        var groupings = this._groupChildren();
        var subTextContent;
        if (subText) {
            subTextContent = React.createElement("p", { className: Utilities_1.css('ms-Dialog-subText', styles.subText), id: subTextId }, subText);
        }
        var contentClassName = Utilities_1.css(this.props.className, (_b = {},
            _b['ms-Dialog--lgHeader ' + styles.isLargeHeader] = type === DialogContent_types_1.DialogType.largeHeader,
            _b['ms-Dialog--close ' + styles.isClose] = type === DialogContent_types_1.DialogType.close,
            _b));
        return (React.createElement("div", { className: Utilities_1.css(contentClassName) },
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-header', styles.header) },
                React.createElement("p", { className: Utilities_1.css('ms-Dialog-title', styles.title), id: titleId, role: 'heading' }, title),
                React.createElement("div", { className: Utilities_1.css('ms-Dialog-topButton', styles.topButton) },
                    this.props.topButtonsProps.map(function (props) { return (React.createElement(Button_1.IconButton, tslib_1.__assign({}, props))); }),
                    (type === DialogContent_types_1.DialogType.close || (showCloseButton && type !== DialogContent_types_1.DialogType.largeHeader)) &&
                        React.createElement(Button_1.IconButton, { className: Utilities_1.css('ms-Dialog-button ms-Dialog-button--close', styles.button), iconProps: { iconName: 'Cancel' }, ariaLabel: closeButtonAriaLabel, onClick: onDismiss }))),
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-inner', styles.inner) },
                React.createElement("div", { className: Utilities_1.css('ms-Dialog-content', styles.content, this.props.className) },
                    subTextContent,
                    groupings.contents),
                groupings.footers)));
        var _b;
    };
    // @TODO - typing the footers as an array of DialogFooter is difficult because
    // casing "child as DialogFooter" causes a problem because
    // "Neither type 'ReactElement<any>' nor type 'DialogFooter' is assignable to the other."
    DialogContent.prototype._groupChildren = function () {
        var groupings = {
            footers: [],
            contents: []
        };
        React.Children.map(this.props.children, function (child) {
            if (typeof child === 'object' && child !== null && child.type === DialogFooter_1.DialogFooter) {
                groupings.footers.push(child);
            }
            else {
                groupings.contents.push(child);
            }
        });
        return groupings;
    };
    DialogContent.defaultProps = {
        showCloseButton: false,
        className: '',
        topButtonsProps: [],
        closeButtonAriaLabel: 'Close'
    };
    DialogContent = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], DialogContent);
    return DialogContent;
}(Utilities_1.BaseComponent));
exports.DialogContent = DialogContent;
//# sourceMappingURL=DialogContent.js.map

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogFooter = /** @class */ (function (_super) {
    tslib_1.__extends(DialogFooter, _super);
    function DialogFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFooter.prototype.render = function () {
        return (React.createElement("div", { className: Utilities_1.css('ms-Dialog-actions', styles.actions) },
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-actionsRight', styles.actionsRight) }, this._renderChildrenAsActions())));
    };
    DialogFooter.prototype._renderChildrenAsActions = function () {
        return React.Children.map(this.props.children, function (child) {
            return child && React.createElement("span", { className: Utilities_1.css('ms-Dialog-action', styles.action) }, child);
        });
    };
    return DialogFooter;
}(Utilities_1.BaseComponent));
exports.DialogFooter = DialogFooter;
//# sourceMappingURL=DialogFooter.js.map

/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PanelType;
(function (PanelType) {
    /**
     * Renders the panel in 'small' mode, anchored to the far side (right in LTR mode), and has a fluid width.
     * Only used on Small screen breakpoints.
     * Small: 320-479px width (full screen), 16px Left/Right padding
     * Medium: <unused>
     * Large: <unused>
     * XLarge: <unused>
     * XXLarge: <unused>
     */
    PanelType[PanelType["smallFluid"] = 0] = "smallFluid";
    /**
     * Renders the panel in 'small' mode, anchored to the far side (right in LTR mode), and has a fixed width.
     * Small: 272px width, 16px Left/Right padding
     * Medium: 340px width, 16px Left/Right padding
     * Large: 340px width, 32px Left/Right padding
     * XLarge: 340px width, 32px Left/Right padding
     * XXLarge: 340px width, 40px Left/Right padding
     */
    PanelType[PanelType["smallFixedFar"] = 1] = "smallFixedFar";
    /**
     * Renders the panel in 'small' mode, anchored to the near side (left in LTR mode), and has a fixed width.
     * Small: 272px width, 16px Left/Right padding
     * Medium: 272px width, 16px Left/Right padding
     * Large: 272px width, 32px Left/Right padding
     * XLarge: 272px width, 32px Left/Right padding
     * XXLarge: 272px width, 32px Left/Right padding
     */
    PanelType[PanelType["smallFixedNear"] = 2] = "smallFixedNear";
    /**
     * Renders the panel in 'medium' mode, anchored to the far side (right in LTR mode).
     * Small: <adapts to smallFluid>
     * Medium: <adapts to smallFixedFar>
     * Large: 48px fixed left margin, 32px Left/Right padding
     * XLarge: 644px width, 32px Left/Right padding
     * XXLarge: 643px width, 40px Left/Right padding
     */
    PanelType[PanelType["medium"] = 3] = "medium";
    /**
     * Renders the panel in 'large' mode, anchored to the far side (right in LTR mode), and is fluid at XXX-Large breakpoint.
     * Small: <adapts to smallFluid>
     * Medium:  <adapts to smallFixedFar>
     * Large: <adapts to medium>
     * XLarge: 48px fixed left margin, 32px Left/Right padding
     * XXLarge: 48px fixed left margin, 32px Left/Right padding
     * XXXLarge: 48px fixed left margin, (no redlines for padding, assuming previous breakpoint)
     */
    PanelType[PanelType["large"] = 4] = "large";
    /**
     * Renders the panel in 'large' mode, anchored to the far side (right in LTR mode), and is fixed at XXX-Large breakpoint.
     * Small: <adapts to smallFluid>
     * Medium:  <adapts to smallFixedFar>
     * Large: <adapts to medium>
     * XLarge: 48px fixed left margin, 32px Left/Right padding
     * XXLarge: 48px fixed left margin, 32px Left/Right padding
     * XXXLarge: 940px width, (no redlines for padding, assuming previous breakpoint)
     */
    PanelType[PanelType["largeFixed"] = 5] = "largeFixed";
    /**
     * Renders the panel in 'extra large' mode, anchored to the far side (right in LTR mode).
     * Small: <adapts to smallFluid>
     * Medium: <adapts to smallFixedFar>
     * Large: <adapts to medium>
     * XLarge: <adapts to large>
     * XXLarge: 176px fixed left margin, 40px Left/Right padding
     * XXXLarge: 176px fixed left margin, 40px Left/Right padding
     */
    PanelType[PanelType["extraLarge"] = 6] = "extraLarge";
    /**
     * Renders the panel in 'custom' mode using customWidth, anchored to the far side (right in LTR mode).
     * Small: <adapts to smallFluid>
     * Medium: <adapts to smallFixedFar>
     * Large: 48px fixed left margin, 32px Left/Right padding
     * XLarge: 644px width, 32px Left/Right padding
     * XXLarge: 643px width, 40px Left/Right padding
     */
    PanelType[PanelType["custom"] = 7] = "custom";
})(PanelType = exports.PanelType || (exports.PanelType = {}));
//# sourceMappingURL=Panel.types.js.map

/***/ }),

/***/ 1573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1576), exports);
tslib_1.__exportStar(__webpack_require__(629), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Spinner_types_1 = __webpack_require__(629);
var stylesImport = __webpack_require__(1577);
var styles = stylesImport;
var Spinner = /** @class */ (function (_super) {
    tslib_1.__extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props, type = _a.type, size = _a.size, label = _a.label, className = _a.className, ariaLive = _a.ariaLive, ariaLabel = _a.ariaLabel; // TODO remove deprecated type property at >= 2.0.0
        var statusMessage = ariaLabel || label;
        return (React.createElement("div", { className: Utilities_1.css('ms-Spinner', styles.root, className) },
            React.createElement("div", { className: Utilities_1.css('ms-Spinner-circle', styles.circle, (_b = {},
                    _b['ms-Spinner--xSmall ' + styles.circleIsXSmall] = size === Spinner_types_1.SpinnerSize.xSmall,
                    _b['ms-Spinner--small ' + styles.circleIsSmall] = size === Spinner_types_1.SpinnerSize.small,
                    _b['ms-Spinner--medium ' + styles.circleIsMedium] = size === Spinner_types_1.SpinnerSize.medium,
                    _b['ms-Spinner--large ' + styles.circleIsLarge] = size === Spinner_types_1.SpinnerSize.large,
                    _b['ms-Spinner--normal ' + styles.circleIsTypeMedium] = type === Spinner_types_1.SpinnerType.normal,
                    _b['ms-Spinner--large ' + styles.circleIsTypeLarge] = type === Spinner_types_1.SpinnerType.large // TODO remove deprecated value at >= 2.0.0
                ,
                    _b)) }),
            label && React.createElement("div", { className: Utilities_1.css('ms-Spinner-label', styles.label) }, label),
            statusMessage &&
                React.createElement("div", { role: 'status', "aria-live": ariaLive },
                    React.createElement(Utilities_1.DelayedRender, null,
                        React.createElement("div", { className: styles.screenReaderOnly }, statusMessage)))));
        var _b;
    };
    Spinner.defaultProps = {
        size: Spinner_types_1.SpinnerSize.medium,
        ariaLive: 'polite'
    };
    return Spinner;
}(Utilities_1.BaseComponent));
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map

/***/ }),

/***/ 1577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": "@-webkit-keyframes spinAnimation_4865f20c{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinAnimation_4865f20c{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.root_4865f20c>.circle_4865f20c{margin:auto;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:50%;width:100%;height:100%;border:1.5px solid " }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";border-top-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";-webkit-animation:spinAnimation_4865f20c 1.3s infinite cubic-bezier(0.53, 0.21, 0.29, 0.67);animation:spinAnimation_4865f20c 1.3s infinite cubic-bezier(0.53, 0.21, 0.29, 0.67)}.root_4865f20c>.circle_4865f20c.circleIsXSmall_4865f20c{width:12px;height:12px}.root_4865f20c>.circle_4865f20c.circleIsSmall_4865f20c{width:16px;height:16px}.root_4865f20c>.circle_4865f20c.circleIsTypeMedium_4865f20c,.root_4865f20c>.circle_4865f20c.circleIsMedium_4865f20c{width:20px;height:20px}.root_4865f20c>.circle_4865f20c.circleIsTypeLarge_4865f20c,.root_4865f20c>.circle_4865f20c.circleIsLarge_4865f20c{width:28px;height:28px}.root_4865f20c .label_4865f20c{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";margin-top:10px;text-align:center}.root_4865f20c .screenReaderOnly_4865f20c{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}@media screen and (-ms-high-contrast: active){.root_4865f20c>.circle_4865f20c{border-top-color:Highlight}}\n" }]);
exports.root = "root_4865f20c";
exports.circle = "circle_4865f20c";
exports.spinAnimation = "spinAnimation_4865f20c";
exports.circleIsXSmall = "circleIsXSmall_4865f20c";
exports.circleIsSmall = "circleIsSmall_4865f20c";
exports.circleIsTypeMedium = "circleIsTypeMedium_4865f20c";
exports.circleIsMedium = "circleIsMedium_4865f20c";
exports.circleIsTypeLarge = "circleIsTypeLarge_4865f20c";
exports.circleIsLarge = "circleIsLarge_4865f20c";
exports.label = "label_4865f20c";
exports.screenReaderOnly = "screenReaderOnly_4865f20c";
//# sourceMappingURL=Spinner.scss.js.map

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getUserConfiguration_1 = __webpack_require__(9);
var owa_controls_feature_flags_1 = __webpack_require__(33);
function getHexConsumerIdForUser(emailAddress) {
    if (!owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl') || !emailAddress) {
        return undefined;
    }
    var userConfig = getUserConfiguration_1.default();
    if (!userConfig || !userConfig.SessionSettings) {
        return undefined;
    }
    // If the persona is yourself, return the current user hex id.
    if (isSameStringIgnoreCase(emailAddress, userConfig.SessionSettings.UserEmailAddress)) {
        return userConfig.HexCID;
    }
    return undefined;
}
exports.default = getHexConsumerIdForUser;
function isSameStringIgnoreCase(str1, str2) {
    return str1 && str2 && str1.toLowerCase() == str2.toLowerCase();
}
//# sourceMappingURL=getHexConsumerIdForUser.js.map

/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = __webpack_require__(360);
var SelectionLayout = /** @class */ (function () {
    function SelectionLayout(direction) {
        this._direction = direction;
    }
    SelectionLayout.prototype.getItemIndexAbove = function (focusIndex, items) {
        return (this._direction === interfaces_1.SelectionDirection.vertical) ? Math.max(0, focusIndex - 1) : focusIndex;
    };
    SelectionLayout.prototype.getItemIndexBelow = function (focusIndex, items) {
        return (this._direction === interfaces_1.SelectionDirection.vertical) ? Math.min(items.length - 1, focusIndex + 1) : focusIndex;
    };
    SelectionLayout.prototype.getItemIndexLeft = function (focusIndex, items) {
        return (this._direction === interfaces_1.SelectionDirection.vertical) ? focusIndex : Math.max(0, focusIndex - 1);
    };
    SelectionLayout.prototype.getItemIndexRight = function (focusIndex, items) {
        return (this._direction === interfaces_1.SelectionDirection.vertical) ? focusIndex : Math.min(items.length - 1, focusIndex + 1);
    };
    return SelectionLayout;
}());
exports.SelectionLayout = SelectionLayout;
//# sourceMappingURL=SelectionLayout.js.map

/***/ }),

/***/ 1586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1587), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Label_classNames_1 = __webpack_require__(1588);
var Label = /** @class */ (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, required = _a.required, children = _a.children, className = _a.className, theme = _a.theme;
        return (React.createElement("label", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { className: Label_classNames_1.getLabelClassNames(theme, className, !!disabled, !!required).root }), children));
    };
    Label = tslib_1.__decorate([
        Utilities_1.customizable('Label', ['theme'])
    ], Label);
    return Label;
}(Utilities_1.BaseComponent));
exports.Label = Label;
//# sourceMappingURL=Label.js.map

/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
exports.getLabelClassNames = Utilities_1.memoizeFunction(function (theme, className, disabled, required) {
    return Styling_1.mergeStyleSets({
        root: ['ms-Label',
            {
                color: theme.semanticColors.bodyText,
                boxSizing: 'border-box',
                boxShadow: 'none',
                margin: 0,
                display: 'block',
                padding: '5px 0',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
            },
            disabled && {
                color: theme.semanticColors.disabledBodyText,
                selectors: (_a = {},
                    _a[Styling_1.HighContrastSelector] = {
                        color: 'GrayText'
                    },
                    _a)
            },
            required && {
                selectors: {
                    '::after': {
                        content: "' *'",
                        color: theme.semanticColors.errorText,
                        paddingRight: 12
                    }
                }
            },
            className]
    });
    var _a;
});
//# sourceMappingURL=Label.classNames.js.map

/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultFileProvider_1 = __webpack_require__(1803);
exports.getDefaultFileProvider = getDefaultFileProvider_1.default;
var FilePickerAction_1 = __webpack_require__(1778);
exports.FilePickerAction = FilePickerAction_1.default;
var FilePickerResult_1 = __webpack_require__(1797);
exports.SelectedFilesSource = FilePickerResult_1.SelectedFilesSource;
var FilePickerViewSwitcher_1 = __webpack_require__(1591);
exports.FilePickerViewType = FilePickerViewSwitcher_1.FilePickerViewType;
var lazyAddFileProviderHelper_1 = __webpack_require__(1804);
var owa_bundling_1 = __webpack_require__(6);
var owa_fileprovider_store_1 = __webpack_require__(597);
exports.FileSelectionFilter = owa_fileprovider_store_1.FileSelectionFilter;
var FileProviderItemViewState_1 = __webpack_require__(1762);
exports.FileProviderItemType = FileProviderItemViewState_1.FileProviderItemType;
var filePickerConstants_1 = __webpack_require__(1755);
exports.FacebookDataProviderItemType = filePickerConstants_1.FacebookDataProviderItemType;
exports.FacebookProviderScopeType = filePickerConstants_1.FacebookProviderScopeType;
exports.SizeLimitInKbToSuggestSharing = filePickerConstants_1.SizeLimitInKbToSuggestSharing;
/* This package SHOULD contain minimal attachment related logic. It should NOT take any dependencies on the attachment package.
   It is supposed to be self contained and possibly reusable outside OWA for picking files from different providers */
owa_bundling_1.preloadScriptChunk('FilePicker');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 2247));
});
lazyAddFileProviderHelper_1.initAddFileProvider();
// Delay loaded action
exports.lazyRemoveFileProvider = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.removeFileProvider; });
// Delay loaded imports
exports.lazyGetGDriveFileProviderItems = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getGDriveFileProviderItems; });
exports.lazyGetFileProviderItemsServiceCall = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getFileProviderItemsServiceCall; });
exports.lazyGetFileProviderItems = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getFileProviderItems; });
exports.lazyCreateFileProviderItemsViewState = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.createFileProviderItemsViewState; });
exports.lazyPreloadFilePicker = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.preloadFilePicker; });
exports.lazyAddAndSelectFileProvider = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.addAndSelectFileProvider; });
exports.lazyGetUserPreferredFilePickerAction = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getUserPreferredFilePickerAction; });
var filePickerStore_1 = __webpack_require__(1779);
exports.filePickerStore = filePickerStore_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = __webpack_require__(22);
var FilePickerViewType;
(function (FilePickerViewType) {
    FilePickerViewType[FilePickerViewType["List"] = 0] = "List";
    FilePickerViewType[FilePickerViewType["Tile"] = 1] = "Tile";
})(FilePickerViewType = exports.FilePickerViewType || (exports.FilePickerViewType = {}));
// Used for ariaLabel and title (hover tooltip) of viewSwitcher icon.
exports.viewTypeDisplayStrings = (_a = {},
    _a[FilePickerViewType.List] = function () { return owa_mail_strings_1.default.ViewSwitcherListView_TitleText; },
    _a[FilePickerViewType.Tile] = function () { return owa_mail_strings_1.default.ViewSwitcherTileView_TitleText; },
    _a);
var _a;
//# sourceMappingURL=FilePickerViewSwitcher.js.map

/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var globalContext_1 = __webpack_require__(60);
var mobx_react_1 = __webpack_require__(11);
function setPropAccessors(props, selector) {
    var newProps = {};
    Object.keys(props).forEach(function (key) {
        newProps[key] = props[key];
    });
    Object.keys(selector).forEach(function (key) {
        var getter = selector[key];
        if (typeof newProps[key] === typeof undefined) {
            Object.defineProperty(newProps, key, {
                enumerable: true,
                get: function () { return getter.call(null, newProps); },
            });
        }
    });
    return newProps;
}
function createNewConstructor(original, selector) {
    if (!selector) {
        return original;
    }
    return (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(original, setPropAccessors(this.props, selector));
        };
        return class_1;
    }(React.Component));
}
function createNewFunctionalComponent(original, selector) {
    if (!selector) {
        return original;
    }
    return function (props) {
        var newProps = setPropAccessors(props, selector);
        return original.call(original, newProps);
    };
}
function isReactComponent(target) {
    return target && target.prototype && target.prototype.isReactComponent;
}
function isFunction(target) {
    return target instanceof Function;
}
function reactive(selectorOrComponentClass) {
    if (isReactComponent(selectorOrComponentClass)) {
        var componentClass = selectorOrComponentClass;
        return mobx_react_1.observer(componentClass);
    }
    return function (target) {
        if (globalContext_1.getGlobalContext().legacyTestMode) {
            if (isReactComponent(target)) {
                return mobx_react_1.observer(target);
            }
            else if (isFunction(target)) {
                return mobx_react_1.observer(target);
            }
            return target;
        }
        var newComponent;
        if (isReactComponent(target)) {
            newComponent = mobx_react_1.observer(createNewConstructor(mobx_react_1.observer(target), selectorOrComponentClass));
            newComponent.nonReactiveComponent = target;
            return newComponent;
        }
        else if (isFunction(target)) {
            newComponent = mobx_react_1.observer(createNewFunctionalComponent(target, selectorOrComponentClass));
            newComponent.nonReactiveStatelessComponent = target;
            return newComponent;
        }
        return newComponent;
    };
}
exports.default = reactive;


/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AriaRoles = {
    /** http://www.w3.org/TR/wai-aria/roles#alert */
    alert: 'alert',
    /** http://www.w3.org/TR/wai-aria/roles#alertdialog */
    alertdialog: 'alertdialog',
    /** http://www.w3.org/TR/wai-aria/roles#application */
    application: 'application',
    /** http://www.w3.org/TR/wai-aria/roles#article */
    article: 'article',
    /** http://www.w3.org/TR/wai-aria/roles#banner */
    banner: 'banner',
    /** http://www.w3.org/TR/wai-aria/roles#button */
    button: 'button',
    /** http://www.w3.org/TR/wai-aria/roles#checkbox */
    checkbox: 'checkbox',
    /** http://www.w3.org/TR/wai-aria/roles#columnheader */
    columnheader: 'columnheader',
    /** http://www.w3.org/TR/wai-aria/roles#combobox */
    combobox: 'combobox',
    /** http://www.w3.org/TR/wai-aria/roles#complementary */
    complementary: 'complementary',
    /** http://www.w3.org/TR/wai-aria/roles#contentinfo */
    contentinfo: 'contentinfo',
    /** http://www.w3.org/TR/wai-aria/roles#definition */
    definition: 'definition',
    /** http://www.w3.org/TR/wai-aria/roles#dialog */
    dialog: 'dialog',
    /** http://www.w3.org/TR/wai-aria/roles#directory */
    directory: 'directory',
    /** http://www.w3.org/TR/wai-aria/roles#document */
    document: 'document',
    /** http://www.w3.org/TR/wai-aria/roles#form */
    form: 'form',
    /** http://www.w3.org/TR/wai-aria/roles#grid */
    grid: 'grid',
    /** http://www.w3.org/TR/wai-aria/roles#gridcell */
    gridcell: 'gridcell',
    /** http://www.w3.org/TR/wai-aria/roles#group */
    group: 'group',
    /** http://www.w3.org/TR/wai-aria/roles#heading */
    heading: 'heading',
    /** http://www.w3.org/TR/wai-aria/roles#img */
    img: 'img',
    /** http://www.w3.org/TR/wai-aria/roles#link */
    link: 'link',
    /** http://www.w3.org/TR/wai-aria/roles#list */
    list: 'list',
    /** http://www.w3.org/TR/wai-aria/roles#listbox */
    listbox: 'listbox',
    /** http://www.w3.org/TR/wai-aria/roles#listitem */
    listitem: 'listitem',
    /** http://www.w3.org/TR/wai-aria/roles#log */
    log: 'log',
    /** http://www.w3.org/TR/wai-aria/roles#main */
    main: 'main',
    /** http://www.w3.org/TR/wai-aria/roles#marquee */
    marquee: 'marquee',
    /** http://www.w3.org/TR/wai-aria/roles#math */
    math: 'math',
    /** http://www.w3.org/TR/wai-aria/roles#menu */
    menu: 'menu',
    /** http://www.w3.org/TR/wai-aria/roles#menubar */
    menubar: 'menubar',
    /** http://www.w3.org/TR/wai-aria/roles#menuitem */
    menuitem: 'menuitem',
    /** http://www.w3.org/TR/wai-aria/roles#menuitemcheckbox */
    menuitemcheckbox: 'menuitemcheckbox',
    /** http://www.w3.org/TR/wai-aria/roles#menuitemradio */
    menuitemradio: 'menuitemradio',
    /** http://www.w3.org/TR/wai-aria/roles#navigation */
    navigation: 'navigation',
    /** http://www.w3.org/TR/wai-aria/roles#note */
    note: 'note',
    /** http://www.w3.org/TR/wai-aria/roles#option */
    option: 'option',
    /** http://www.w3.org/TR/wai-aria/roles#presentation */
    presentation: 'presentation',
    /** http://www.w3.org/TR/wai-aria/roles#progressbar */
    progressbar: 'progressbar',
    /** http://www.w3.org/TR/wai-aria/roles#radio */
    radio: 'radio',
    /** http://www.w3.org/TR/wai-aria/roles#radiogroup */
    radiogroup: 'radiogroup',
    /** http://www.w3.org/TR/wai-aria/roles#region */
    region: 'region',
    /** http://www.w3.org/TR/wai-aria/roles#row */
    row: 'row',
    /** http://www.w3.org/TR/wai-aria/roles#rowgroup */
    rowgroup: 'rowgroup',
    /** http://www.w3.org/TR/wai-aria/roles#rowheader */
    rowheader: 'rowheader',
    /** http://www.w3.org/TR/wai-aria/roles#scrollbar */
    scrollbar: 'scrollbar',
    /** http://www.w3.org/TR/wai-aria/roles#search */
    search: 'search',
    /** http://www.w3.org/TR/wai-aria/roles#separator */
    separator: 'separator',
    /** http://www.w3.org/TR/wai-aria/roles#slider */
    slider: 'slider',
    /** http://www.w3.org/TR/wai-aria/roles#spinbutton */
    spinbutton: 'spinbutton',
    /** http://www.w3.org/TR/wai-aria/roles#status */
    status: 'status',
    /** http://www.w3.org/TR/wai-aria/roles#tab */
    tab: 'tab',
    /** http://www.w3.org/TR/wai-aria/roles#tablist */
    tablist: 'tablist',
    /** http://www.w3.org/TR/wai-aria/roles#tabpanel */
    tabpanel: 'tabpanel',
    /** http://www.w3.org/TR/wai-aria/roles#textbox */
    textbox: 'textbox',
    /** http://www.w3.org/TR/wai-aria/roles#timer */
    timer: 'timer',
    /** http://www.w3.org/TR/wai-aria/roles#toolbar */
    toolbar: 'toolbar',
    /** http://www.w3.org/TR/wai-aria/roles#tooltip */
    tooltip: 'tooltip',
    /** http://www.w3.org/TR/wai-aria/roles#tree */
    tree: 'tree',
    /** http://www.w3.org/TR/wai-aria/roles#treegrid */
    treegrid: 'treegrid',
    /** http://www.w3.org/TR/wai-aria/roles#treeitem */
    treeitem: 'treeitem',
};
//# sourceMappingURL=ariaRoles.js.map

/***/ }),

/***/ 1595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var id = 0;
function generateNewId(prefix) {
    if (prefix === void 0) { prefix = 'id'; }
    return "" + prefix + id++;
}
exports.generateNewId = generateNewId;
//# sourceMappingURL=generateNewId.js.map

/***/ }),

/***/ 1596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function joinListOfTokens(tokens) {
    if (Array.isArray(tokens)) {
        return tokens.join(' ');
    }
    else {
        return tokens;
    }
}
function generateDomPropertiesForAria(ariaProps) {
    if (!ariaProps) {
        return null;
    }
    var domProperties = {};
    var ariaKeys = Object.keys(ariaProps);
    /* tslint:disable:no-string-literal */
    /* Can't access or assign 'aria-*' properties without string literals */
    for (var i = 0; i < ariaKeys.length; i++) {
        var key = ariaKeys[i];
        switch (key) {
            case 'role':
                domProperties['role'] = ariaProps.role;
                break;
            case 'id':
                domProperties['id'] = ariaProps.id;
                break;
            case 'activeDescendant':
                domProperties['aria-activedescendant'] = ariaProps.activeDescendant;
                break;
            case 'atomic':
                domProperties['aria-atomic'] = ariaProps.atomic;
                break;
            case 'autocomplete':
                domProperties['aria-autocomplete'] = ariaProps.autocomplete;
                break;
            case 'busy':
                domProperties['aria-busy'] = ariaProps.busy;
                break;
            case 'checked':
                domProperties['aria-checked'] = ariaProps.checked;
                break;
            case 'controls':
                domProperties['aria-controls'] = joinListOfTokens(ariaProps.controls);
                break;
            case 'describedBy':
                domProperties['aria-describedby'] = joinListOfTokens(ariaProps.describedBy);
                break;
            case 'disabled':
                domProperties['aria-disabled'] = ariaProps.disabled;
                break;
            case 'dropEffect':
                domProperties['aria-dropeffect'] = joinListOfTokens(ariaProps.dropEffect);
                break;
            case 'expanded':
                domProperties['aria-expanded'] = ariaProps.expanded;
                break;
            case 'flowTo':
                domProperties['aria-flowto'] = joinListOfTokens(ariaProps.flowTo);
                break;
            case 'grabbed':
                domProperties['aria-grabbed'] = ariaProps.grabbed;
                break;
            case 'hasPopup':
                domProperties['aria-haspopup'] = ariaProps.hasPopup;
                break;
            case 'hidden':
                domProperties['aria-hidden'] = ariaProps.hidden;
                break;
            case 'invalid':
                domProperties['aria-invalid'] = ariaProps.invalid;
                break;
            case 'label':
                domProperties['aria-label'] = ariaProps.label;
                break;
            case 'labelledBy':
                domProperties['aria-labelledby'] = joinListOfTokens(ariaProps.labelledBy);
                break;
            case 'level':
                domProperties['aria-level'] = ariaProps.level;
                break;
            case 'live':
                domProperties['aria-live'] = ariaProps.live;
                break;
            case 'multiline':
                domProperties['aria-multiline'] = ariaProps.multiline;
                break;
            case 'multiselectable':
                domProperties['aria-multiselectable'] = ariaProps.multiselectable;
                break;
            case 'orientation':
                domProperties['aria-orientation'] = ariaProps.orientation;
                break;
            case 'owns':
                domProperties['aria-owns'] = joinListOfTokens(ariaProps.owns);
                break;
            case 'positionInSet':
                domProperties['aria-posinset'] = ariaProps.positionInSet;
                break;
            case 'pressed':
                domProperties['aria-pressed'] = ariaProps.pressed;
                break;
            case 'readonly':
                domProperties['aria-readonly'] = ariaProps.readonly;
                break;
            case 'relevant':
                domProperties['aria-relevant'] = joinListOfTokens(ariaProps.relevant);
                break;
            case 'required':
                domProperties['aria-required'] = ariaProps.required;
                break;
            case 'selected':
                domProperties['aria-selected'] = ariaProps.selected;
                break;
            case 'setSize':
                domProperties['aria-setsize'] = ariaProps.setSize;
                break;
            case 'sort':
                domProperties['aria-sort'] = ariaProps.sort;
                break;
            case 'valueMax':
                domProperties['aria-valuemax'] = ariaProps.valueMax;
                break;
            case 'valueMin':
                domProperties['aria-valuemin'] = ariaProps.valueMin;
                break;
            case 'valueNow':
                domProperties['aria-valuenow'] = ariaProps.valueNow;
                break;
            case 'valueText':
                domProperties['aria-valuetext'] = ariaProps.valueText;
                break;
        }
    }
    /* tslint:enable:no-string-literal */
    return domProperties;
}
exports.generateDomPropertiesForAria = generateDomPropertiesForAria;
//# sourceMappingURL=generateDomPropertiesForAria.js.map

/***/ }),

/***/ 1597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getPersonaFromHexCID_1 = __webpack_require__(1598);
var getPersonaPhotoQueue_1 = __webpack_require__(588);
var mapPersonaToPersonaViewState_1 = __webpack_require__(1599);
var Store_1 = __webpack_require__(327);
var getPersonaControlKey_1 = __webpack_require__(332);
var legacy_1 = __webpack_require__(1);
/**
 * Gets the persona photo
 * @param name of the persona
 * @param emailAddress email address of the persona
 * @param size the size of the persona
 * @param hexCID hex id for a persona
 */
exports.default = legacy_1.select({
    personaViewStates: function () { return Store_1.default.viewStates; },
})(legacy_1.action('getPersonaPhoto')(function getPersonaPhoto(name, emailAddress, size, hexCID, state) {
    var personaKey = getPersonaControlKey_1.default(emailAddress, size, name);
    var personaViewState = state.personaViewStates.get(personaKey);
    if (!personaViewState) {
        personaViewState = mapPersonaToPersonaViewState_1.default(name, hexCID, emailAddress, size, personaKey);
        state.personaViewStates.set(personaKey, personaViewState);
    }
    if (personaViewState.hexConsumerIdForUser) {
        getPersonaFromHexCID_1.default(personaViewState);
    }
    else {
        getPersonaPhotoQueue_1.default.add({ name: name, emailAddress: emailAddress, size: size });
    }
}));
//# sourceMappingURL=getPersonaPhoto.js.map

/***/ }),

/***/ 1598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getPersonaPhotoUrl_1 = __webpack_require__(345);
var legacy_1 = __webpack_require__(1);
var MIN_PHOTO_DIMENSION = 5;
function cleanUpPersonaPseudoFetch(personaBlob, loadingElement) {
    personaBlob.isPendingFetch = false;
    document.body.removeChild(loadingElement);
}
var onConsumerPhotoLoad = legacy_1.action('onConsumerPhotoLoad')(function onConsumerPhotoLoad(photoUrl, personaBlob, loadingElement) {
    personaBlob.hasFetchFailed =
        loadingElement.width < MIN_PHOTO_DIMENSION || loadingElement.height < MIN_PHOTO_DIMENSION;
    personaBlob.blobUrl = personaBlob.hasFetchFailed ? null : photoUrl;
    cleanUpPersonaPseudoFetch(personaBlob, loadingElement);
});
var onConsumerPhotoError = legacy_1.action('onConsumerPhotoError')(function onConsumerPhotoError(personaBlob, loadingElement) {
    personaBlob.hasFetchFailed = true;
    cleanUpPersonaPseudoFetch(personaBlob, loadingElement);
});
/**
 * Gets persona photo from hex consumer id
 * @param personaViewState the viewState for persona
 */
function getPersonaFromHexCID(personaViewState) {
    var personaBlob = personaViewState.personaBlob;
    // If it already has a pending request or has failed before, simply return.
    // No need to keep re-trying on the failed ones, since some users don't have photos.
    if (personaBlob.isPendingFetch || personaBlob.hasFetchFailed) {
        return;
    }
    var photoUrl = getPersonaPhotoUrl_1.getPersonaPhotoUrlFromhexCID(personaViewState.hexConsumerIdForUser, personaViewState.size);
    // Handle a consumer user's own persona photo
    // This is a horrible hack, because the OneDrive url will return a 1x1 gif if no photo is set,
    // and the lack of CORS headers prevents us from using fetch/XHR in the same way as enterprise
    var consumerPersonaImg = document.createElement('img');
    consumerPersonaImg.src = photoUrl;
    consumerPersonaImg.onload = function () {
        return onConsumerPhotoLoad(photoUrl, personaBlob, consumerPersonaImg);
    };
    consumerPersonaImg.onerror = function () { return onConsumerPhotoError(personaBlob, consumerPersonaImg); };
    consumerPersonaImg.style.visibility = 'hidden';
    document.body.appendChild(consumerPersonaImg);
}
exports.default = getPersonaFromHexCID;
//# sourceMappingURL=getPersonaFromHexCID.js.map

/***/ }),

/***/ 1599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates the persona view state and stores it in the store
 * @param name of the persona
 * @param hexCID hex id for a persona
 * @param emailAddress email address of the persona
 * @param size the size of the persona
 */
function mapPersonaToPersonaViewState(name, hexCID, emailAddress, size, personaKey) {
    var personaBlob = {
        blobUrl: null,
        isPendingFetch: false,
        hasFetchFailed: false,
    };
    return {
        emailAddress: emailAddress,
        hexConsumerIdForUser: hexCID,
        name: name,
        personaBlob: personaBlob,
        size: size,
    };
}
exports.default = mapPersonaToPersonaViewState;
//# sourceMappingURL=mapPersonaToPersonaViewState.js.map

/***/ }),

/***/ 1600:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1601);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 1601:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".e9fvQDlOQViPpEK_Z5GHb .ms-Persona-initials{color:#fff}", ""]);

// exports
exports.locals = {
	"persona": "e9fvQDlOQViPpEK_Z5GHb"
};

/***/ }),

/***/ 1602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DateValues_1 = __webpack_require__(361);
exports.DayOfWeek = DateValues_1.DayOfWeek;
exports.FirstWeekOfYear = DateValues_1.FirstWeekOfYear;
exports.DateRangeType = DateValues_1.DateRangeType;
//# sourceMappingURL=Calendar.types.js.map

/***/ }),

/***/ 1603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.getStore = satcheljs_1.createStore('lightningState', {
    unseenItems: null,
    lightedCount: 0,
    lastShownId: null,
});
exports.store = exports.getStore();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 1607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setMailboxMessageConfigurationRequest(data) {
    var result = tslib_1.__assign({ __type: 'SetMailboxMessageConfigurationRequest:#Exchange' }, data);
    return result;
}
exports.default = setMailboxMessageConfigurationRequest;


/***/ }),

/***/ 1608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HeaderCharmType_1 = __webpack_require__(1624);
exports.HeaderCharmType = HeaderCharmType_1.default;
var deactivateCharm_1 = __webpack_require__(1625);
exports.deactivateCharm = deactivateCharm_1.default;
var toggleCharm_1 = __webpack_require__(1626);
exports.toggleCharm = toggleCharm_1.default;
var store_1 = __webpack_require__(370);
exports.headerStore = store_1.store;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_lightning_core_1 = __webpack_require__(1622);
var EventEmitter = __webpack_require__(587);
function lightable(target) {
    var render = target.prototype.render;
    target.prototype.render = function () {
        if (owa_lightning_core_1.store.unseenItems) {
            var viewState = owa_lightning_core_1.store.unseenItems.get(this.props.lid);
            if (viewState && viewState.visible) {
                return render.call(this, arguments);
            }
        }
        return null;
    };
    var onMount = target.prototype.componentDidMount;
    target.prototype.componentDidMount = function () {
        if (onMount) {
            onMount.call(this, arguments);
        }
        owa_lightning_core_1.beginLightning.importAndExecute(this.props.lid, this.props.when, this.props.series);
    };
    var onUnmount = target.prototype.componentWillUnmount;
    target.prototype.componentWillUnmount = function () {
        if (onUnmount) {
            onUnmount.call(this, arguments);
        }
        owa_lightning_core_1.endLightning.importAndExecute(this.props.lid);
    };
    return target;
}
exports.lightable = lightable;
function lighted(lid) {
    owa_lightning_core_1.endLightning.importAndExecute(lid);
}
exports.lighted = lighted;
exports.eventMgr = new EventEmitter();
exports.SettingPanelFirstRunCalloutDismissedEvent = 'SettingPanelFirstRunCalloutDismissed';
//# sourceMappingURL=lightning.js.map

/***/ }),

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 2075));
});
var store_1 = __webpack_require__(1603);
exports.store = store_1.store;
exports.beginLightning = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.beginLightningImp; });
exports.endLightning = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.endLightningImp; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LightningId;
(function (LightningId) {
    // First satisfation survey
    LightningId["UserVoiceSatisfactionFirstRun"] = "0";
    // Second satisfaction survey
    LightningId["UserVoiceSatisfactionSecondRun"] = "1";
    // Static Image first-run experience for consumer refresh opt-in
    LightningId["ConsumerRefreshFRE"] = "2";
    // Animated first-run experience for consumer refresh opt-in
    LightningId["AnimatedConsumerRefreshFRE"] = "3";
    // Animated first-run experience for consumer refresh opt-in
    LightningId["AnimatedConsumerRefreshFRE2"] = "4";
    // Setting panel first run callout
    LightningId["SettingPanelFirstRunCallout"] = "5";
    // Setting icon first run callout
    LightningId["SettingIconFirstRunCallout"] = "6";
    // Callout for add storage account
    LightningId["AddStorageAccountCallout"] = "7";
})(LightningId = exports.LightningId || (exports.LightningId = {}));
//# sourceMappingURL=LightningId.js.map

/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HeaderCharmType;
(function (HeaderCharmType) {
    HeaderCharmType[HeaderCharmType["FeedbackCharm"] = 0] = "FeedbackCharm";
    HeaderCharmType[HeaderCharmType["FeatureFlagsCharm"] = 1] = "FeatureFlagsCharm";
    HeaderCharmType[HeaderCharmType["HelpCharm"] = 2] = "HelpCharm";
    HeaderCharmType[HeaderCharmType["PersonaCharm"] = 3] = "PersonaCharm";
    HeaderCharmType[HeaderCharmType["SettingsCharm"] = 4] = "SettingsCharm";
    HeaderCharmType[HeaderCharmType["WaffleCharm"] = 5] = "WaffleCharm";
    HeaderCharmType[HeaderCharmType["DiagnosticsCharm"] = 6] = "DiagnosticsCharm";
    HeaderCharmType[HeaderCharmType["GetStartedCharm"] = 7] = "GetStartedCharm";
})(HeaderCharmType || (HeaderCharmType = {}));
exports.default = HeaderCharmType;
//# sourceMappingURL=HeaderCharmType.js.map

/***/ }),

/***/ 1625:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(370);
exports.default = legacy_1.action('deactivateCharm')(legacy_1.select({
    store: function () { return store_1.store; },
})(function deactivateCharm(charm, state) {
    if (state.store.activeCharm === charm) {
        state.store.activeCharm = null;
    }
}));
//# sourceMappingURL=deactivateCharm.js.map

/***/ }),

/***/ 1626:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(370);
exports.default = legacy_1.action('toggleCharm')(legacy_1.select({
    store: function () { return store_1.store; },
})(function toggleCharm(charm, state) {
    if (state.store.activeCharm === charm) {
        state.store.activeCharm = null;
    }
    else {
        state.store.activeCharm = charm;
    }
}));
//# sourceMappingURL=toggleCharm.js.map

/***/ }),

/***/ 1627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1632), exports);
//# sourceMappingURL=TeachingBubble.js.map

/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(590);
function getTheme() {
    return store_1.store.theme;
}
exports.default = getTheme;
//# sourceMappingURL=getTheme.js.map

/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1633), exports);
tslib_1.__exportStar(__webpack_require__(653), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* tslint:disable:no-unused-variable */
var React = __webpack_require__(3);
/* tslint:enable:no-unused-variable */
var Utilities_1 = __webpack_require__(7);
var TeachingBubbleContent_1 = __webpack_require__(653);
var Callout_1 = __webpack_require__(157);
var stylesImport = __webpack_require__(654);
var styles = stylesImport;
var TeachingBubble = /** @class */ (function (_super) {
    tslib_1.__extends(TeachingBubble, _super);
    // Constructor
    function TeachingBubble(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    TeachingBubble.prototype.render = function () {
        var _a = this.props, calloutProps = _a.calloutProps, targetElement = _a.targetElement;
        return (React.createElement(Callout_1.Callout, tslib_1.__assign({ className: Utilities_1.css('ms-TeachingBubble', styles.root, this.props.isWide ? styles.wideCallout : null), ref: this._resolveRef('_callout'), target: targetElement }, calloutProps),
            React.createElement(TeachingBubbleContent_1.TeachingBubbleContent, tslib_1.__assign({}, this.props))));
    };
    // Specify default props values
    TeachingBubble.defaultProps = {
        calloutProps: {
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false,
            directionalHint: 12 /* rightCenter */
        }
    };
    return TeachingBubble;
}(Utilities_1.BaseComponent));
exports.TeachingBubble = TeachingBubble;
//# sourceMappingURL=TeachingBubble.js.map

/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Draggable_1 = __webpack_require__(1868);
var Droppable_1 = __webpack_require__(1718);
var constants_1 = __webpack_require__(2076);
// TODO: Bug 14032: Consider a framework-independent design of owa-dnd
var DragAndDroppable = /** @class */ (function (_super) {
    tslib_1.__extends(DragAndDroppable, _super);
    function DragAndDroppable(props) {
        var _this = _super.call(this, props) || this;
        _this.dragCore = new Draggable_1.DraggableCore(props);
        _this.dropCore = new Droppable_1.DroppableCore(props);
        return _this;
    }
    DragAndDroppable.prototype.render = function () {
        return constants_1.IsSetDragImageSupported ? (React.createElement("div", { draggable: true, className: this.props.classNames, ref: this.dragCore.refCallback, onDragStart: this.dragCore.onDragStart, onDragEnd: this.dragCore.onDragEnd, onDrop: this.dropCore.onDrop, onDragOver: this.dropCore.onDragOver, onDragEnter: this.dropCore.onDragEnter, onDragLeave: this.dropCore.onDragLeave }, this.props.children)) : (React.createElement("div", { className: this.props.classNames, ref: this.dragCore.refCallback, onDragEnd: this.dragCore.onDragEnd, onDrop: this.dropCore.onDrop, onDragOver: this.dropCore.onDragOver, onDragEnter: this.dropCore.onDragEnter, onDragLeave: this.dropCore.onDragLeave }, this.props.children));
    };
    DragAndDroppable.prototype.componentWillUnmount = function () {
        this.dragCore.onUnmount();
    };
    DragAndDroppable.prototype.getDiv = function () {
        return this.dragCore.getDiv();
    };
    return DragAndDroppable;
}(React.Component));
exports.default = DragAndDroppable;
//# sourceMappingURL=DragAndDroppable.js.map

/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['callout_Gotit', 'callout_Notnow', 'callout_Panel_Title', 'callout_Panel_Body', 'callout_Icon_Title', 'callout_Icon_Body'];
var stringModule = index_1.registerStringPackage('owa-configurator-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 1705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(15);
var satcheljs_1 = __webpack_require__(2);
// Import mutators so they are initialized at the same time as the store
__webpack_require__(2153);
__webpack_require__(2154);
__webpack_require__(2155);
var storeData = {
    selectedConversationId: undefined,
    isLoading: false,
    isError: false,
    emailRecipientConversations: mobx_1.map({}),
};
exports.getStore = satcheljs_1.createStore('subjectPicker', storeData);
var store = exports.getStore();
exports.default = store;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 1714:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(628), exports);
//# sourceMappingURL=Selection.js.map

/***/ }),

/***/ 1715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dragData;
function setDragData(data) {
    dragData = data;
}
exports.setDragData = setDragData;
function getDragData() {
    return dragData;
}
exports.getDragData = getDragData;
//# sourceMappingURL=dragDataUtil.js.map

/***/ }),

/***/ 1718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var LocalFilesDragData_1 = __webpack_require__(1844);
var setDropState_1 = __webpack_require__(1845);
var dragDataUtil_1 = __webpack_require__(1715);
var userAgent_1 = __webpack_require__(148);
var DRAG_LEAVE_HANDLER_DELAY_IN_MILLISECONDS = 50;
// This is a helper class for better code reusing, this should be only invoked from owadnd classes
var DroppableCore = /** @class */ (function () {
    function DroppableCore(props) {
        var _this = this;
        this.props = props;
        // OnDragEnter event handler
        this.onDragEnter = function (dragEvent) {
            dragEvent.preventDefault();
            // TODO: VSO 14014: owa-dnd - Investigate if we can use only dataTransfer to transfer drag data
            if (!dragDataUtil_1.getDragData() && dragEvent.dataTransfer.files) {
                dragDataUtil_1.setDragData(LocalFilesDragData_1.default(dragEvent.dataTransfer.files));
            }
        };
        // OnDragLeave event handler
        this.onDragLeave = function (dragEvent) {
            // The HTML5 API will fire onDragLeave when the user drags over any children of the droppable
            // We want to ignore this here and treat this as being still inside the droppable area.
            if (_this.props.greedy && !_this.isReallyLeavingDroppable(dragEvent)) {
                return;
            }
            var dragData = dragDataUtil_1.getDragData();
            if (!_this.shouldHandleEvents(dragData)) {
                return;
            }
            var handler = function () {
                if (_this.props.onDragLeave) {
                    _this.props.onDragLeave(dragDataUtil_1.getDragData(), dragEvent.currentTarget);
                }
                setDropState_1.default(_this.props.dropViewState, false /*isDragOver*/, null /*draggableItemType*/);
                _this.pendingDragLeaveHandler = null;
            };
            if (!_this.props.shouldIgnoreTransientOnDragLeave) {
                handler();
            }
            else if (!_this.pendingDragLeaveHandler) {
                _this.pendingDragLeaveHandler = setTimeout(handler, DRAG_LEAVE_HANDLER_DELAY_IN_MILLISECONDS);
            }
        };
        // OnDragOver event handler
        this.onDragOver = function (dragEvent) {
            dragEvent.preventDefault(); // adding preventDefault allows the drop to happen
            var dragData = dragDataUtil_1.getDragData();
            // TODO - 9123 IE does not allow setting drop effect
            // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/9123
            // e.dataTransfer.dropEffect = "move";
            if (!_this.shouldHandleEvents(dragData)) {
                if (_this.props.showDefaultNoDropImage && !userAgent_1.isBrowserIE()) {
                    // This is needed to get the default no-drop image in firefox
                    dragEvent.dataTransfer.dropEffect = 'none';
                }
                return;
            }
            if (_this.props.shouldUseCopyAsDropEffect && !userAgent_1.isBrowserIE()) {
                dragEvent.dataTransfer.dropEffect = 'copy';
            }
            if (_this.props.onDragOver) {
                _this.props.onDragOver(dragData, dragEvent.pageX, dragEvent.pageY, dragEvent.currentTarget);
            }
            _this.cancelPendingDragLeaveHandler();
            setDropState_1.default(_this.props.dropViewState, true /*isDragOver*/, dragData.itemType);
        };
        // OnDrop event handler
        this.onDrop = function (dragEvent) {
            var dragData = null;
            if (dragEvent.dataTransfer.files && dragEvent.dataTransfer.files.length > 0) {
                // We need to get the dragData from dragEvent.dataTransfer.files on Drop event
                // as dragEvent.dataTransfer.files is empty on DropEnter event
                dragData = LocalFilesDragData_1.default(dragEvent.dataTransfer.files);
            }
            else {
                dragData = dragDataUtil_1.getDragData();
            }
            // Need this, otherwise FireFox gets redirected.
            dragEvent.preventDefault();
            if (!_this.shouldHandleEvents(dragData)) {
                return;
            }
            // TODO: VSO 14018: Try remove the check to isDragOver in Droppable.onDrop
            if (_this.props.dropViewState.isDragOver) {
                _this.props.onDrop(dragData, dragEvent.pageX, dragEvent.pageY, dragEvent.currentTarget);
                // TODO VSO 13903: Some times components need extra info to determine if the dropping action is on the component itself
                // or another component which shares the same store object
                // We call this callback here to allow the component do some extra work.
                if (_this.props.onDragLeave) {
                    _this.props.onDragLeave(dragData, dragEvent.currentTarget);
                }
                _this.cancelPendingDragLeaveHandler();
                setDropState_1.default(_this.props.dropViewState, false /*isDragOver*/, null /*draggableItemType*/);
            }
        };
        this.refCallback = function (ref) {
            _this.div = ref;
        };
    }
    DroppableCore.prototype.getDiv = function () {
        return this.div;
    };
    DroppableCore.prototype.cancelPendingDragLeaveHandler = function () {
        if (this.pendingDragLeaveHandler) {
            clearTimeout(this.pendingDragLeaveHandler);
            this.pendingDragLeaveHandler = null;
        }
    };
    /**
     * Check whether we are *really* leaving the droppable area during a dragleave event
     * @param dragEvent The dragleave event
     * @returns True if we are in fact leaving the droppable, false otherwise
     */
    DroppableCore.prototype.isReallyLeavingDroppable = function (dragEvent) {
        var hoveredElement = document.elementFromPoint(dragEvent.pageX, dragEvent.pageY);
        return !this.isDescendantOrSelf(hoveredElement, dragEvent.currentTarget);
    };
    DroppableCore.prototype.isDescendantOrSelf = function (element, ancestor) {
        if (!element || !ancestor) {
            return false;
        }
        if (element == ancestor) {
            return true;
        }
        var parent = element;
        while ((parent = parent.parentElement)) {
            if (parent == ancestor) {
                return true;
            }
        }
        return false;
    };
    DroppableCore.prototype.shouldHandleEvents = function (dragData) {
        // DragData can be null, if the drag has happened not from the dragContext source.
        return dragData && (!this.props.canDrop || this.props.canDrop(dragData));
    };
    return DroppableCore;
}());
exports.DroppableCore = DroppableCore;
// TODO: Bug 14032: Consider a framework-independent design of owa-dnd
var Droppable = /** @class */ (function (_super) {
    tslib_1.__extends(Droppable, _super);
    function Droppable(props) {
        var _this = _super.call(this, props) || this;
        _this.core = new DroppableCore(props);
        return _this;
    }
    Droppable.prototype.render = function () {
        return (React.createElement("div", { ref: this.core.refCallback, className: this.props.classNames, style: this.props.style, onDrop: this.core.onDrop, onDragOver: this.core.onDragOver, onDragEnter: this.core.onDragEnter, onDragLeave: this.core.onDragLeave }, this.props.children));
    };
    Droppable.prototype.getDiv = function () {
        return this.core.getDiv();
    };
    return Droppable;
}(React.Component));
exports.default = Droppable;
//# sourceMappingURL=Droppable.js.map

/***/ }),

/***/ 1736:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubCategoryState_1 = __webpack_require__(1824);
exports.SubCategoryState = SubCategoryState_1.default;
var QuickSettingOrder_1 = __webpack_require__(1825);
exports.QuickSettingOrder = QuickSettingOrder_1.default;
// Export service helpers
var updateUserConfiguration_1 = __webpack_require__(1826);
exports.updateUserConfiguration = updateUserConfiguration_1.default;
var setMailboxMessageConfiguration_1 = __webpack_require__(1827);
exports.setMailboxMessageConfiguration = setMailboxMessageConfiguration_1.default;
// Export utils
var getFallbackValueIfNull_1 = __webpack_require__(1830);
exports.getFallbackValueIfNull = getFallbackValueIfNull_1.default;
var updateSessionSettings_1 = __webpack_require__(1831);
exports.updateSessionSettings = updateSessionSettings_1.default;
var updateUserOptions_1 = __webpack_require__(1832);
exports.updateUserOptions = updateUserOptions_1.default;
var OptionConfirmationDialog_1 = __webpack_require__(1833);
exports.confirmOptionNavigation = OptionConfirmationDialog_1.default;
var isAnyOptionDirty_1 = __webpack_require__(1836);
exports.isAnyOptionDirty = isAnyOptionDirty_1.default;
var hideSaveDiscardButtons_1 = __webpack_require__(1837);
exports.hideSaveDiscardButtons = hideSaveDiscardButtons_1.default;
var shouldDisableSaveButton_1 = __webpack_require__(1838);
exports.shouldDisableSaveButton = shouldDisableSaveButton_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['options_appearance_weekstartdayLabel', 'options_appearance_dimpasteventsLabel', 'optionTitle_appearance', 'optionTitle_weather', 'optionTitle_eventsForEmail', 'optionTitle_reminders', 'optionSubcategory_personalization', 'optionSubcategory_automaticProcessing', 'optionSubcategory_notifications', 'options_txp_description', 'options_txp_disable', 'options_txp_enable', 'options_txp_addEventsTitle', 'options_txp_flights', 'options_txp_hotelReservations', 'options_txp_carRentals', 'options_txp_packageDelivery', 'options_txp_diningReservations', 'options_txp_events', 'options_txp_bills', 'options_txp_markEventsPrivate', 'options_weather_toggleLabel', 'options_weather_enabled', 'options_weather_disabled', 'options_weather_unitLabel', 'options_weather_fahrenheit', 'options_weather_celsius', 'optionCategory_General', 'optionCategory_Mail', 'optionCategory_Calendar', 'optionCategory_People', 'optionTitle_personal', 'optionTitle_mailboxUsage', 'optionTitle_regional', 'optionTitle_Theme', 'optionSearch_Theme', 'optionTitle_accessibility', 'optionTitle_shortcuts', 'optionTitle_skypeNotifications', 'options_premium_Title', 'options_premium_subTitle1', 'options_premium_StorageContentPart1', 'options_premium_StorageContentPart2', 'options_premium_subTitle2', 'options_premium_SubscriptionContent', 'options_premium_buttonText', 'options_premium_subTitle3', 'options_premium_AdvancedSecurityContent_part1', 'options_premium_AdvancedSecurityContent_part2', 'options_premium_AdvancedSecurityContent_LearnMore', 'option_regional_language', 'option_regional_renameDefaultFolders', 'option_regional_languageReload', 'option_regional_languageHotReload', 'option_regional_dateFormat', 'option_regional_timeFormat', 'option_regional_timeZone', 'options_shortcuts_description', 'options_shortcuts_label', 'options_shortcut_choice_hotmail', 'options_shortcut_choice_yahoo', 'options_shortcut_choice_gmail', 'options_shortcut_choice_outlook', 'options_shortcut_choice_off', 'options_skype_ImNotifityTitle', 'options_skype_CallNotifityTitle', 'options_skype_NotifyAll', 'options_skype_NotifyToast', 'options_skype_ImNotifyNone', 'optionSubcategory_account', 'optionSubcategory_appearance', 'optionSubcategory_configuration', 'optionSubcategory_skype', 'optionSubcategory_premium', 'themeTitleLabel', 'themeDisplayName_angular', 'themeDisplayName_balloons', 'themeDisplayName_base', 'themeDisplayName_beach', 'themeDisplayName_black', 'themeDisplayName_blueberry', 'themeDisplayName_blueprint', 'themeDisplayName_bricks', 'themeDisplayName_cats', 'themeDisplayName_chevron', 'themeDisplayName_circuit', 'themeDisplayName_comic', 'themeDisplayName_contrast', 'themeDisplayName_cordovan', 'themeDisplayName_crayon', 'themeDisplayName_cubes', 'themeDisplayName_cubism', 'themeDisplayName_darkcordovan', 'themeDisplayName_darkorange', 'themeDisplayName_diamonds', 'themeDisplayName_far', 'themeDisplayName_grape', 'themeDisplayName_jelly', 'themeDisplayName_lightblue', 'themeDisplayName_lightgreen', 'themeDisplayName_lite', 'themeDisplayName_mediumdarkblue', 'themeDisplayName_minimal', 'themeDisplayName_modern', 'themeDisplayName_mountain', 'themeDisplayName_orange', 'themeDisplayName_paint', 'themeDisplayName_pink', 'themeDisplayName_pixel', 'themeDisplayName_polka', 'themeDisplayName_pomegranate', 'themeDisplayName_primary', 'themeDisplayName_raspberry', 'themeDisplayName_robot', 'themeDisplayName_simple', 'themeDisplayName_spectrum', 'themeDisplayName_strawberry', 'themeDisplayName_super', 'themeDisplayName_teagarden', 'themeDisplayName_teal', 'themeDisplayName_watermelon', 'themeDisplayName_whale', 'themeDisplayName_whimsical', 'themeDisplayName_wntrlnd', 'themeDisplayName_wrld', 'themeExpandLabel', 'themeCollapseLabel', 'options_attachmentPreferences_localLabel', 'options_attachmentPreferences_cloudLabel', 'options_attachmentPreferences_askOption', 'options_attachmentPreferences_shareOption', 'options_attachmentPreferences_attachOption', 'options_blockAllow_moveEmail', 'options_blockAllow_dontMoveEmail', 'options_blockAllow_trustEmailFromContacts', 'options_blockAllow_onlyTrustEmailFromSafeSenders', 'options_blockAllow_junkMailFilteringEnabled', 'options_blockAllow_junkMailFilteringDisabled', 'options_callout_addStorageAccount_title', 'options_callout_addStorageAccount_body', 'options_callout_addStorageAccount_button', 'options_common_addSenderOrDomainPlaceholder', 'options_common_addSenderPlaceholder', 'options_common_addDomainPlaceholder', 'options_common_addButtonLabel', 'options_common_invalidAddressError', 'options_common_invalidDomainError', 'options_common_invalidAddressOrDomainError', 'options_common_invalidIsSelfError', 'options_common_editEmailAddressOrDomainButtonTitle', 'options_common_removeEmailAddressOrDomainButtonTitle', 'options_conversations_sortOrderLabel', 'options_conversations_sortOrderTop', 'options_conversations_sortOrderBottom', 'options_conversations_quick_label', 'options_conversations_quick_tooltip', 'options_conversations_quick_sortOrderTop', 'options_conversations_quick_sortOrderBottom', 'options_conversations_quick_messageView', 'options_conversations_deletedItemsLabel', 'options_conversations_deletedItemsShow', 'options_conversations_deletedItemsHide', 'options_dateHeaders_enabled', 'options_dateHeaders_disabled', 'options_dateHeaders_quick_label', 'options_focused_label', 'options_focused_enabled', 'options_focused_disabled', 'options_format_showBcc', 'options_format_showFrom', 'options_format_formatLabel_front', 'options_format_formatLabel_back', 'options_format_dropdown_html', 'options_format_dropdown_plaintext', 'options_format_sampleText_1', 'options_format_sampleText_2', 'options_inboxRules_description', 'options_inboxRules_if', 'options_inboxRules_exceptWhen', 'options_inboxRules_and', 'options_inboxRules_or', 'options_inboxRules_addNewRule', 'options_inboxRules_noRules', 'options_inboxRules_loadingRulesError', 'options_inboxRules_deleteRuleAriaText', 'options_inboxRules_ruleDisabledAriaText', 'options_inboxRules_ruleEnabledAriaText', 'options_inboxRules_tryAgain', 'options_inboxRules_generateReport', 'options_inboxRules_generateReportPending', 'options_inboxRules_generateReportSuccess', 'options_inboxRules_generateReportFail', 'options_inboxRules_backToRulesList', 'options_inboxRules_clauseValueDropdownPlaceholder', 'options_inboxRules_clauseTypeDropdownPlaceholder', 'options_inboxRules_addressIncludesOptionPlaceholder', 'options_inboxRules_containsOptionPlaceholder', 'options_inboxRules_conditionsHeader', 'options_inboxRules_conditionsInfo', 'options_inboxRules_selectCondition', 'options_inboxRules_addCondition', 'options_inboxRules_actionsHeader', 'options_inboxRules_actionsInfo', 'options_inboxRules_selectAction', 'options_inboxRules_addAction', 'options_inboxRules_exceptionsHeader', 'options_inboxRules_exceptionsInfo', 'options_inboxRules_selectException', 'options_inboxRules_addException', 'options_inboxRules_addExceptionSection', 'options_inboxRules_nameRule', 'options_inboxRules_ignoreSubsequentRules', 'options_inboxRules_stopProcessingRules', 'options_inboxRules_learnMore', 'options_inboxRules_addresses', 'options_inboxRules_people', 'options_inboxRules_from', 'options_inboxRules_to', 'options_inboxRules_myNameIs', 'options_inboxRules_toOrCcLine', 'options_inboxRules_onlyRecipient', 'options_inboxRules_toLine', 'options_inboxRules_ccLine', 'options_inboxRules_notToLine', 'options_inboxRules_fromAccount', 'options_inboxRules_subject', 'options_inboxRules_subjectIncludes', 'options_inboxRules_subjectOrBodyIncludes', 'options_inboxRules_includesWords', 'options_inboxRules_inBody', 'options_inboxRules_inSenderAddress', 'options_inboxRules_inRecipientAddress', 'options_inboxRules_inMessageHeader', 'options_inboxRules_markedWith', 'options_inboxRules_importance', 'options_inboxRules_sensitivity', 'options_inboxRules_low', 'options_inboxRules_normal', 'options_inboxRules_high', 'options_inboxRules_personal', 'options_inboxRules_private', 'options_inboxRules_companyConfidential', 'options_inboxRules_messageIncludes', 'options_inboxRules_classification', 'options_inboxRules_flag', 'options_inboxRules_any', 'options_inboxRules_call', 'options_inboxRules_doNotForward', 'options_inboxRules_followUp', 'options_inboxRules_forYourInformation', 'options_inboxRules_forward', 'options_inboxRules_noResponseNecessary', 'options_inboxRules_read', 'options_inboxRules_reply', 'options_inboxRules_replyToAll', 'options_inboxRules_review', 'options_inboxRules_type', 'options_inboxRules_automaticReply', 'options_inboxRules_automaticallyForwarded', 'options_inboxRules_encrypted', 'options_inboxRules_invitation', 'options_inboxRules_eventResponse', 'options_inboxRules_permissionControlled', 'options_inboxRules_voiceMail', 'options_inboxRules_signed', 'options_inboxRules_requestForApproval', 'options_inboxRules_readReceipt', 'options_inboxRules_nonDeliveryReport', 'options_inboxRules_attachment', 'options_inboxRules_messageSize', 'options_inboxRules_atLeast', 'options_inboxRules_atMost', 'options_inboxRules_kb', 'options_inboxRules_received', 'options_inboxRules_before', 'options_inboxRules_after', 'options_inboxRules_organize', 'options_inboxRules_moveTo', 'options_inboxRules_copyTo', 'options_inboxRules_delete', 'options_inboxRules_pinToTop', 'options_inboxRules_markMessage', 'options_inboxRules_junk', 'options_inboxRules_category', 'options_inboxRules_route', 'options_inboxRules_forwardTo', 'options_inboxRules_forwardAsAttachmentTo', 'options_inboxRules_redirectTo', 'options_inboxRules_sendTextMessageTo', 'options_inboxRules_emptyNameError', 'options_inboxRules_emptyDropdownError', 'options_inboxRules_emptyPersonaError', 'options_inboxRules_emptyFromError', 'options_inboxRules_emptyToError', 'options_inboxRules_emptyPhraseError', 'options_inboxRules_messageSizeNotANumber', 'options_inboxRules_messageSizeTooLarge', 'options_inboxRules_messageSizeInvalid', 'options_inboxRules_fixBrokenRuleError', 'options_inboxRules_differentOutlookError', 'options_inboxRules_manageRules', 'options_inlinePreviews_enabled', 'options_inlinePreviews_disabled', 'options_inlinePreviews_quick_setting_label', 'options_junk_reportDescription', 'options_junk_reportLabel', 'options_junk_reportOptionAsk', 'options_junk_reportOptionAlways', 'options_junk_reportNever', 'options_junk_shareDescription', 'options_junk_shareHelpLink', 'options_junk_shareOptionAlways', 'options_junk_shareOptionNever', 'options_junkEmail_blockedSenders', 'options_junkEmail_blockedDomains', 'options_mail_linkPreviewDescription', 'options_mail_linkPreviewHelpLink', 'options_mail_linkPreviewCheckboxLabel', 'options_mail_markAsReadInstant', 'options_mail_markAsReadDelayed', 'options_mail_markAsReadSelectionChange', 'options_mail_markAsReadNever', 'option_mail_AfterMove_Next', 'option_mail_AfterMove_Previous', 'option_mail_AfterMove_ReturnToView', 'option_mail_AfterMove_Title', 'option_mail_NotifyTitle', 'option_mail_NotifySound', 'option_mail_NotifyToast', 'option_mail_LogOutTitle', 'option_mail_EmptyDeletedOnLogOut', 'options_messageOrganization_positionLabel', 'options_messageOrganization_showAsConversation', 'options_messageOrganization_showAsMessage', 'options_messageList_previewLabel', 'options_messageList_previewShow', 'options_messageList_previewHide', 'optionSearchTerms_blockedDomains', 'optionSearchTerms_blockedSenders', 'optionTitle_automaticReplies', 'optionTitle_sweep', 'optionTitle_junk', 'optionTitle_signature', 'optionTitle_markAsRead', 'optionTitle_reply', 'optionTitle_message', 'optionTitle_readReceipts', 'optionTitle_quickActions', 'optionTitle_blockAllow', 'optionTitle_connected', 'optionTitle_forwarding', 'optionTitle_attachmentPreferences', 'optionTitle_storageAccounts', 'optionTitle_conversations', 'optionTitle_focusedInbox', 'optionTitle_messageFormat', 'optionTitle_messageList', 'optionTitle_readingPane', 'optionTitle_linkPreview', 'optionTitle_quickSuggestions', 'optionTitle_inlinePreviews', 'optionTitle_dateHeaders', 'optionTitle_blockedDomains', 'optionTitle_blockedSenders', 'optionTitle_trustedSenders', 'optionTitle_enableJunkMailFiltering', 'optionTitle_blockedSendersAndDomains', 'optionTitle_messageOrganization', 'optionTitle_inboxRules', 'optionTitle_senderSubjectOrder', 'optionTitle_messagePreview', 'optionTitle_senderImage', 'optionTitle_readSurfaceActions', 'optionTitle_composeSurfaceActions', 'options_mail_quickSuggestionsDescription', 'options_mail_quickSuggestionsEnable', 'options_mail_quickSuggestionsLocation', 'options_readingPane_positionLabel', 'options_readingPane_positionRight', 'options_readingPane_positionBottom', 'options_readingPane_positionHide', 'options_readingPane_afterMove_next', 'options_readingPane_afterMove_previous', 'options_readingPane_afterMove_returnToView', 'options_readingPane_afterMove_title', 'options_readingPane_actionOnLoadLabel', 'options_readingPane_actionOnLoadFirstItem', 'options_readingPane_actionOnLoadNoAction', 'options_readingPane_quickSetting_effortless', 'options_readingPane_quickSetting_label', 'options_readingPane_quickSetting_classic', 'options_readingPane_quickSetting_right', 'options_readingPane_quickSetting_bottom', 'options_mail_ReadReceiptPrompt', 'options_mail_ReadReceiptAlways', 'options_mail_ReadReceiptNever', 'options_mail_ReadReceiptTitle', 'options_mail_Reply', 'options_mail_ReplyAll', 'options_mail_ReplyOptionLabel', 'options_messageList_senderImageLabel', 'options_messageList_showSenderImage', 'options_messageList_hideSenderImage', 'options_messageList_firstLineLabel', 'options_messageList_firstLineSender', 'options_messageList_firstLineSubject', 'options_signature_title', 'options_signature_signNewMails', 'options_signature_signReplies', 'options_storageAccounts_addAccountHeader', 'options_storageAccounts_primaryAccount', 'options_storageAccounts_otherAccounts', 'optionSubcategory_automation', 'optionSubcategory_handling', 'optionSubcategory_accounts', 'optionSubcategory_attachments', 'optionSubcategory_layout', 'optionSubcategory_messageContent', 'optionSubcategory_rules', 'optionSubcategory_blockAllow', 'optionSubcategory_junkEmail', 'optionSubcategory_surfaceActions', 'options_title', 'optionsConfirmationDialog_title', 'optionsConfirmationDialog_subtitle', 'optionsConfirmationDialog_save', 'optionsConfirmationDialog_discard', 'optionsConfirmationDialog_cancel', 'optionsFlex_title', 'optionsFlex_searchPlaceholder', 'optionsFlex_goToFullOptions', 'optionsFull_save', 'optionsFull_cancel', 'optionsFull_searchPlaceholder', 'optionsFull_goToQuickOptions', 'optionsFull_subCategory_loading', 'optionsFull_subCategory_error'];
var stringModule = index_1.registerStringPackage('owa-options-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 1738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
exports.React = React;
var AddinCommandSurfaceAction_1 = __webpack_require__(2133);
exports.convertToIContextualMenuItem = AddinCommandSurfaceAction_1.convertToIContextualMenuItem;
var ExtensibilityModeEnum_1 = __webpack_require__(2044);
exports.ExtensibilityModeEnum = ExtensibilityModeEnum_1.default;
var ApiError_1 = __webpack_require__(2130);
exports.ApiError = ApiError_1.default;
var ApiErrorCode_1 = __webpack_require__(2111);
exports.ApiErrorCode = ApiErrorCode_1.default;
var HighlightableTermsObserver_1 = __webpack_require__(2145);
exports.whenItemHasContextualAddinKeywords = HighlightableTermsObserver_1.default;
__webpack_require__(6);
var owa_bundling_1 = __webpack_require__(6);
var HostItemIndex_1 = __webpack_require__(2147);
exports.getComposeHostItemIndex = HostItemIndex_1.getComposeHostItemIndex;
exports.getReadHostItemIndex = HostItemIndex_1.getReadHostItemIndex;
var UserType_1 = __webpack_require__(2138);
exports.UserType = UserType_1.UserType;
var OnHostItemChanged_1 = __webpack_require__(2139);
exports.OnHostItemChangedStatus = OnHostItemChanged_1.OnHostItemChangedStatus;
var ExtensibilityNotificationManager_1 = __webpack_require__(2119);
exports.getExtensibilityNotification = ExtensibilityNotificationManager_1.getExtensibilityNotification;
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 2561));
});
exports.AddinBarView = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.AddinBarView; });
exports.lazyInitAddinsForItem = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.initializeAddinsForItem; });
exports.lazyDeinitAddinsForItem = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.deInitializeAddinsForItem; });
exports.onComposeClose = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.OnComposeClose; });
exports.onItemChanged = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.OnHostItemChanged; });
exports.initExtensibilityContext = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.initializeExtensibilityContext; });
exports.openContextualAddinCallout = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.OpenContextualCallout; });
exports.shouldAddinsActivate = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.shouldActivate; });
exports.lazyRemoveExtensibilityNotification = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.removeExtensibilityNotification; });
exports.lazyUpdatePersistentNotifications = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.updatePersistentNotifications; });
exports.lazyAddinCommandSurfaceActionsObserver = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.observeAddinCommandSurfaceActions; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1740:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EnabledAddinCommands_1 = __webpack_require__(2137);
var satcheljs_1 = __webpack_require__(2);
var ContextualCalloutState_1 = __webpack_require__(2146);
var mobx_1 = __webpack_require__(15);
var store = satcheljs_1.createStore('extensibility', {
    EnabledAddinCommands: new EnabledAddinCommands_1.default(),
    HostItems: mobx_1.map({}),
    IsPreinstalledTeachingUIAvailable: false,
    Context: null,
    runningTaskPaneAddinCommand: null,
    activeDialog: null,
    contextualCalloutState: ContextualCalloutState_1.InitializeContextualCalloutState(),
    runningContextualAddinCommand: null,
    runningUILessAddinCommands: mobx_1.map({}),
})();
exports.default = store;
//# sourceMappingURL=Store.js.map

/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1752), exports);
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 1742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1562), exports);
var index_1 = __webpack_require__(1562);
exports.default = index_1.Dialog;
//# sourceMappingURL=Dialog.js.map

/***/ }),

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1560), exports);
var index_1 = __webpack_require__(1560);
exports.default = index_1.Modal;
//# sourceMappingURL=Modal.js.map

/***/ }),

/***/ 1744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var index_1 = __webpack_require__(674);
var Overlay_1 = __webpack_require__(675);
var Layer_1 = __webpack_require__(331);
var index_2 = __webpack_require__(599);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(1745);
var styles = stylesImport;
var Modal = /** @class */ (function (_super) {
    tslib_1.__extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            id: Utilities_1.getId('Modal'),
            isOpen: props.isOpen,
            isVisible: props.isOpen,
        };
        return _this;
    }
    Modal.prototype.componentWillReceiveProps = function (newProps) {
        clearTimeout(this._onModalCloseTimer);
        // Opening the dialog
        if (newProps.isOpen) {
            if (!this.state.isOpen) {
                // First Open
                this.setState({
                    isOpen: true
                });
            }
            else {
                // Reopen during closing
                this.setState({
                    isVisible: true
                });
            }
        }
        // Closing the dialog
        if (!newProps.isOpen && this.state.isOpen) {
            this._onModalCloseTimer = this._async.setTimeout(this._onModalClose, parseFloat(styles.duration) * 1000);
            this.setState({
                isVisible: false
            });
        }
    };
    Modal.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!prevProps.isOpen && !prevState.isVisible) {
            this.setState({
                isVisible: true
            });
        }
    };
    Modal.prototype.render = function () {
        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, onDismiss = _a.onDismiss, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, titleAriaId = _a.titleAriaId, subtitleAriaId = _a.subtitleAriaId;
        var _b = this.state, isOpen = _b.isOpen, isVisible = _b.isVisible;
        var modalClassName = Utilities_1.css('ms-Modal', styles.root, this.props.className, !!isOpen && 'is-open', !!isVisible && styles.rootIsVisible);
        if (!isOpen) {
            return null;
        }
        // @temp tuatology - Will adjust this to be a panel at certain breakpoints
        if (responsiveMode >= withResponsiveMode_1.ResponsiveMode.small) {
            return (React.createElement(Layer_1.Layer, { onLayerDidMount: onLayerDidMount },
                React.createElement(index_2.Popup, { role: isBlocking ? 'alertdialog' : 'dialog', ariaLabelledBy: titleAriaId, ariaDescribedBy: subtitleAriaId, onDismiss: onDismiss },
                    React.createElement("div", { className: modalClassName },
                        React.createElement(Overlay_1.Overlay, { isDarkThemed: isDarkOverlay, onClick: isBlocking ? undefined : onDismiss }),
                        React.createElement(index_1.FocusTrapZone, { componentRef: this._resolveRef('_focusTrapZone'), className: Utilities_1.css('ms-Dialog-main', styles.main, this.props.containerClassName), elementToFocusOnDismiss: elementToFocusOnDismiss, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap ? isClickableOutsideFocusTrap : !isBlocking, ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector }, this.props.children)))));
        }
        return null;
    };
    Modal.prototype.focus = function () {
        this._focusTrapZone && this._focusTrapZone.focus();
    };
    // Watch for completed animations and set the state
    Modal.prototype._onModalClose = function () {
        this.setState({
            isOpen: false
        });
        // Call the onDismiss callback
        if (this.props.onDismissed) {
            this.props.onDismissed();
        }
    };
    Modal.defaultProps = {
        isOpen: false,
        isDarkOverlay: true,
        isBlocking: false,
        className: '',
        containerClassName: '',
    };
    Modal = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], Modal);
    return Modal;
}(Utilities_1.BaseComponent));
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map

/***/ }),

/***/ 1745:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_561423dc{background-color:transparent;position:fixed;height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;opacity:0;pointer-events:none;-webkit-transition:opacity .267s;transition:opacity .267s}.root_561423dc .ms-Button.ms-Button--compound{display:block}[dir='ltr'] .root_561423dc .ms-Button.ms-Button--compound{margin-left:0}[dir='rtl'] .root_561423dc .ms-Button.ms-Button--compound{margin-right:0}@media screen and (-ms-high-contrast: active){.root_561423dc .ms-Overlay{opacity:0}}.rootIsVisible_561423dc{opacity:1;pointer-events:auto}.main_561423dc{background-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;outline:3px solid transparent;max-height:100%;overflow-y:auto}[dir='ltr'] .main_561423dc{-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,0.4);box-shadow:0 0 5px 0 rgba(0,0,0,0.4)}[dir='rtl'] .main_561423dc{-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,0.4);box-shadow:0 0 5px 0 rgba(0,0,0,0.4)}[dir='ltr'] .main_561423dc{text-align:left}[dir='rtl'] .main_561423dc{text-align:right}\n" }]);
exports.duration = ".267s";
exports.root = "root_561423dc";
exports.rootIsVisible = "rootIsVisible_561423dc";
exports.main = "main_561423dc";
//# sourceMappingURL=Modal.scss.js.map

/***/ }),

/***/ 1746:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2121), exports);
//# sourceMappingURL=List.js.map

/***/ }),

/***/ 1747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1756), exports);
//# sourceMappingURL=Panel.js.map

/***/ }),

/***/ 1748:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function findPeopleRequest(data) {
    var result = tslib_1.__assign({ __type: 'FindPeopleRequest:#Exchange' }, data);
    return result;
}
exports.default = findPeopleRequest;


/***/ }),

/***/ 1749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function personaResponseShape(data) {
    var result = tslib_1.__assign({ __type: 'PersonaResponseShape:#Exchange' }, data);
    return result;
}
exports.default = personaResponseShape;


/***/ }),

/***/ 1750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var findPeopleJsonRequest_1 = __webpack_require__(1561);
function findPeopleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = findPeopleJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("FindPeople", req, options);
}
exports.default = findPeopleOperation;


/***/ }),

/***/ 1751:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var DialogContent_types_1 = __webpack_require__(671);
var Modal_1 = __webpack_require__(1743);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogContent_1 = __webpack_require__(1563);
var Dialog = /** @class */ (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this._getSubTextId = function () {
            var _a = _this.props, ariaDescribedById = _a.ariaDescribedById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, subText = _a.subText;
            var id = ariaDescribedById || (modalProps && modalProps.subtitleAriaId);
            if (!id) {
                id = (subText || (dialogContentProps && dialogContentProps.subText)) && _this._defaultSubTextId;
            }
            return id;
        };
        _this._getTitleTextId = function () {
            var _a = _this.props, ariaLabelledById = _a.ariaLabelledById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, title = _a.title;
            var id = ariaLabelledById || (modalProps && modalProps.titleAriaId);
            if (!id) {
                id = (title || (dialogContentProps && dialogContentProps.title)) && _this._defaultTitleTextId;
            }
            return id;
        };
        _this._id = Utilities_1.getId('Dialog');
        _this._defaultTitleTextId = _this._id + '-title';
        _this._defaultSubTextId = _this._id + '-subText';
        _this._warnDeprecations({
            'isOpen': 'hidden',
            'type': 'dialogContentProps.type',
            'subText': 'dialogContentProps.subText',
            'contentClassName': 'dialogContentProps.className',
            'topButtonsProps': 'dialogContentProps.topButtonsProps',
            'className': 'modalProps.className',
            'isDarkOverlay': 'modalProps.isDarkOverlay',
            'isBlocking': 'modalProps.isBlocking',
            'containerClassName': 'modalProps.containerClassName',
            'onDismissed': 'modalProps.onDismissed',
            'onLayerDidMount': 'modalProps.onLayerDidMount',
            'ariaDescribedById': 'modalProps.subtitleAriaId',
            'ariaLabelledById': 'modalProps.titleAriaId'
        });
        return _this;
    }
    Dialog.prototype.render = function () {
        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, isOpen = _a.isOpen, className = _a.className, onDismiss = _a.onDismiss, onDismissed = _a.onDismissed, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, subText = _a.subText, title = _a.title, type = _a.type, contentClassName = _a.contentClassName, topButtonsProps = _a.topButtonsProps, dialogContentProps = _a.dialogContentProps, modalProps = _a.modalProps, containerClassName = _a.containerClassName, hidden = _a.hidden;
        return (React.createElement(Modal_1.Modal, tslib_1.__assign({ elementToFocusOnDismiss: elementToFocusOnDismiss, firstFocusableSelector: firstFocusableSelector, forceFocusInsideTrap: forceFocusInsideTrap, ignoreExternalFocusing: ignoreExternalFocusing, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap, onDismissed: onDismissed, onLayerDidMount: onLayerDidMount, responsiveMode: responsiveMode }, modalProps, { isDarkOverlay: isDarkOverlay !== undefined ? isDarkOverlay : modalProps.isDarkOverlay, isBlocking: isBlocking !== undefined ? isBlocking : modalProps.isBlocking, isOpen: isOpen !== undefined ? isOpen : !hidden, className: Utilities_1.css('ms-Dialog', className ? className : modalProps.className), containerClassName: Utilities_1.css(styles.main, containerClassName ? containerClassName : modalProps.containerClassName), onDismiss: onDismiss ? onDismiss : modalProps.onDismiss, subtitleAriaId: this._getSubTextId(), titleAriaId: this._getTitleTextId() }),
            React.createElement(DialogContent_1.DialogContent, tslib_1.__assign({ titleId: this._defaultTitleTextId, subTextId: this._defaultSubTextId, title: title, subText: subText, showCloseButton: isBlocking !== undefined ? !isBlocking : !modalProps.isBlocking, topButtonsProps: topButtonsProps ? topButtonsProps : dialogContentProps.topButtonsProps, type: type !== undefined ? type : dialogContentProps.type, onDismiss: onDismiss ? onDismiss : dialogContentProps.onDismiss, className: Utilities_1.css(contentClassName ? contentClassName : dialogContentProps.className) }, dialogContentProps), this.props.children)));
    };
    Dialog.defaultProps = {
        modalProps: {
            isDarkOverlay: true,
            isBlocking: false,
            className: '',
            containerClassName: ''
        },
        dialogContentProps: {
            type: DialogContent_types_1.DialogType.normal,
            className: '',
            topButtonsProps: [],
        },
        hidden: true,
    };
    Dialog = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], Dialog);
    return Dialog;
}(Utilities_1.BaseComponent));
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map

/***/ }),

/***/ 1752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1753), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Label_1 = __webpack_require__(1559);
var Icon_1 = __webpack_require__(43);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(1754);
var styles = stylesImport;
var Styling_1 = __webpack_require__(21);
var TextField = /** @class */ (function (_super) {
    tslib_1.__extends(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({
            'iconClass': 'iconProps',
            'addonString': 'prefix',
            'onRenderAddon': 'onRenderPrefix'
        });
        _this._warnMutuallyExclusive({
            'value': 'defaultValue'
        });
        _this._id = Utilities_1.getId('TextField');
        _this._descriptionId = Utilities_1.getId('TextFieldDescription');
        _this.state = {
            value: props.value || props.defaultValue || '',
            isFocused: false,
            errorMessage: ''
        };
        _this._onInputChange = _this._onInputChange.bind(_this);
        _this._onFocus = _this._onFocus.bind(_this);
        _this._onBlur = _this._onBlur.bind(_this);
        _this._delayedValidate = _this._async.debounce(_this._validate, _this.props.deferredValidationTime);
        _this._lastValidation = 0;
        _this._isDescriptionAvailable = false;
        return _this;
    }
    Object.defineProperty(TextField.prototype, "value", {
        /**
         * Gets the current value of the text field.
         */
        get: function () {
            return this.state.value;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype.componentDidMount = function () {
        this._isMounted = true;
        this._adjustInputHeight();
        if (this.props.validateOnLoad) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype.componentWillReceiveProps = function (newProps) {
        var onBeforeChange = this.props.onBeforeChange;
        if (newProps.value !== undefined && newProps.value !== this.state.value) {
            if (onBeforeChange) {
                onBeforeChange(newProps.value);
            }
            this._latestValue = newProps.value;
            this.setState({
                value: newProps.value,
                errorMessage: ''
            });
            this._delayedValidate(newProps.value);
        }
    };
    TextField.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    TextField.prototype.render = function () {
        var _a = this.props, className = _a.className, description = _a.description, disabled = _a.disabled, iconClass = _a.iconClass, iconProps = _a.iconProps, multiline = _a.multiline, required = _a.required, underlined = _a.underlined, borderless = _a.borderless, addonString = _a.addonString, // @deprecated
        prefix = _a.prefix, suffix = _a.suffix, _b = _a.onRenderAddon, onRenderAddon = _b === void 0 ? this._onRenderAddon : _b, // @deprecated
        _c = _a.onRenderPrefix, // @deprecated
        onRenderPrefix = _c === void 0 ? this._onRenderPrefix : _c, _d = _a.onRenderSuffix, onRenderSuffix = _d === void 0 ? this._onRenderSuffix : _d, _e = _a.onRenderLabel, onRenderLabel = _e === void 0 ? this._onRenderLabel : _e;
        var isFocused = this.state.isFocused;
        var errorMessage = this._errorMessage;
        this._isDescriptionAvailable = Boolean(description || errorMessage);
        var renderProps = tslib_1.__assign({}, this.props, { componentId: this._id });
        var textFieldClassName = Utilities_1.css('ms-TextField', styles.root, className, (_f = {},
            _f['is-required ' + styles.rootIsRequiredLabel] = this.props.label && required,
            _f['is-required ' + styles.rootIsRequiredPlaceholderOnly] = !this.props.label && required,
            _f['is-disabled ' + styles.rootIsDisabled] = disabled,
            _f['is-active ' + styles.rootIsActive] = isFocused,
            _f['ms-TextField--multiline ' + styles.rootIsMultiline] = multiline,
            _f['ms-TextField--underlined ' + styles.rootIsUnderlined] = underlined,
            _f['ms-TextField--borderless ' + styles.rootIsBorderless] = borderless,
            _f));
        return (React.createElement("div", { className: textFieldClassName },
            React.createElement("div", { className: Utilities_1.css('ms-TextField-wrapper', styles.wrapper, underlined ? errorMessage && styles.invalid : '') },
                onRenderLabel(renderProps, this._onRenderLabel),
                React.createElement("div", { className: Utilities_1.css('ms-TextField-fieldGroup', styles.fieldGroup, isFocused && styles.fieldGroupIsFocused, errorMessage && styles.invalid) },
                    (addonString !== undefined || this.props.onRenderAddon) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-prefix', styles.fieldPrefixSuffix) }, onRenderAddon(this.props, this._onRenderAddon))),
                    (prefix !== undefined || this.props.onRenderPrefix) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-prefix', styles.fieldPrefixSuffix) }, onRenderPrefix(this.props, this._onRenderPrefix))),
                    multiline ? this._renderTextArea() : this._renderInput(),
                    (iconClass || iconProps) && React.createElement(Icon_1.Icon, tslib_1.__assign({ className: Utilities_1.css(iconClass, styles.icon) }, iconProps)),
                    (suffix !== undefined || this.props.onRenderSuffix) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-suffix', styles.fieldPrefixSuffix) }, onRenderSuffix(this.props, this._onRenderSuffix))))),
            this._isDescriptionAvailable &&
                React.createElement("span", { id: this._descriptionId },
                    description && React.createElement("span", { className: Utilities_1.css('ms-TextField-description', styles.description) }, description),
                    errorMessage &&
                        React.createElement("div", null,
                            React.createElement(Utilities_1.DelayedRender, null,
                                React.createElement("p", { className: Utilities_1.css('ms-TextField-errorMessage', Styling_1.AnimationClassNames.slideDownIn20, styles.errorMessage) },
                                    React.createElement("span", { "aria-live": 'assertive', className: styles.errorText, "data-automation-id": 'error-message' }, errorMessage)))))));
        var _f;
    };
    /**
     * Sets focus on the text field
     */
    TextField.prototype.focus = function () {
        if (this._textElement) {
            this._textElement.focus();
        }
    };
    /**
     * Selects the text field
     */
    TextField.prototype.select = function () {
        if (this._textElement) {
            this._textElement.select();
        }
    };
    /**
     * Sets the selection start of the text field to a specified value
     */
    TextField.prototype.setSelectionStart = function (value) {
        if (this._textElement) {
            this._textElement.selectionStart = value;
        }
    };
    /**
     * Sets the selection end of the text field to a specified value
     */
    TextField.prototype.setSelectionEnd = function (value) {
        if (this._textElement) {
            this._textElement.selectionEnd = value;
        }
    };
    Object.defineProperty(TextField.prototype, "selectionStart", {
        /**
         * Gets the selection start of the text field
         */
        get: function () {
            return this._textElement ? this._textElement.selectionStart : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextField.prototype, "selectionEnd", {
        /**
         * Gets the selection end of the text field
         */
        get: function () {
            return this._textElement ? this._textElement.selectionEnd : -1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the start and end positions of a selection in a text field.
     * @param start Index of the start of the selection.
     * @param end Index of the end of the selection.
     */
    TextField.prototype.setSelectionRange = function (start, end) {
        if (this._textElement) {
            this._textElement.setSelectionRange(start, end);
        }
    };
    TextField.prototype._onFocus = function (ev) {
        if (this.props.onFocus) {
            this.props.onFocus(ev);
        }
        this.setState({ isFocused: true });
        if (this.props.validateOnFocusIn) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype._onBlur = function (ev) {
        if (this.props.onBlur) {
            this.props.onBlur(ev);
        }
        this.setState({ isFocused: false });
        if (this.props.validateOnFocusOut) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype._onRenderLabel = function (props) {
        var label = props.label, componentId = props.componentId;
        if (label) {
            return (React.createElement(Label_1.Label, { htmlFor: componentId }, label));
        }
        return null;
    };
    // @deprecated
    TextField.prototype._onRenderAddon = function (props) {
        var addonString = props.addonString;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, addonString));
    };
    TextField.prototype._onRenderPrefix = function (props) {
        var prefix = props.prefix;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, prefix));
    };
    TextField.prototype._onRenderSuffix = function (props) {
        var suffix = props.suffix;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, suffix));
    };
    TextField.prototype._getTextElementClassName = function () {
        var textFieldClassName;
        if (this.props.multiline && !this.props.resizable) {
            textFieldClassName = Utilities_1.css('ms-TextField-field ms-TextField-field--unresizable', styles.field, styles.fieldIsUnresizable);
        }
        else {
            textFieldClassName = Utilities_1.css('ms-TextField-field', styles.field);
        }
        return Utilities_1.css(textFieldClassName, this.props.inputClassName, (_a = {},
            _a[styles.hasIcon] = !!this.props.iconClass,
            _a));
        var _a;
    };
    Object.defineProperty(TextField.prototype, "_errorMessage", {
        get: function () {
            var errorMessage = this.state.errorMessage;
            if (!errorMessage) {
                errorMessage = this.props.errorMessage;
            }
            return errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype._renderTextArea = function () {
        var textAreaProps = Utilities_1.getNativeProps(this.props, Utilities_1.textAreaProperties, ['defaultValue']);
        return (React.createElement("textarea", tslib_1.__assign({ id: this._id }, textAreaProps, { ref: this._resolveRef('_textElement'), value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._getTextElementClassName(), "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : null, "aria-invalid": !!this.state.errorMessage, "aria-label": this.props.ariaLabel, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextField.prototype._renderInput = function () {
        var inputProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['defaultValue']);
        return (React.createElement("input", tslib_1.__assign({ type: 'text', id: this._id }, inputProps, { ref: this._resolveRef('_textElement'), value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._getTextElementClassName(), "aria-label": this.props.ariaLabel, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : null, "aria-invalid": !!this.state.errorMessage, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextField.prototype._onInputChange = function (event) {
        var _this = this;
        var element = event.target;
        var value = element.value;
        // Avoid doing unnecessary work when the value has not changed.
        if (value === this._latestValue) {
            return;
        }
        this._latestValue = value;
        this.setState({
            value: value,
            errorMessage: ''
        }, function () {
            _this._adjustInputHeight();
            if (_this.props.onChanged) {
                _this.props.onChanged(value);
            }
        });
        var _a = this.props, validateOnFocusIn = _a.validateOnFocusIn, validateOnFocusOut = _a.validateOnFocusOut;
        if (!(validateOnFocusIn || validateOnFocusOut)) {
            this._delayedValidate(value);
        }
        var onBeforeChange = this.props.onBeforeChange;
        onBeforeChange(value);
    };
    TextField.prototype._validate = function (value) {
        var _this = this;
        // In case of _validate called multi-times during executing validate logic with promise return.
        if (this._latestValidateValue === value) {
            return;
        }
        this._latestValidateValue = value;
        var onGetErrorMessage = this.props.onGetErrorMessage;
        var result = onGetErrorMessage(value || '');
        if (result !== undefined) {
            if (typeof result === 'string') {
                this.setState({
                    errorMessage: result
                });
                this._notifyAfterValidate(value, result);
            }
            else {
                var currentValidation_1 = ++this._lastValidation;
                result.then(function (errorMessage) {
                    if (_this._isMounted && currentValidation_1 === _this._lastValidation) {
                        _this.setState({ errorMessage: errorMessage });
                    }
                    _this._notifyAfterValidate(value, errorMessage);
                });
            }
        }
        else {
            this._notifyAfterValidate(value, '');
        }
    };
    TextField.prototype._notifyAfterValidate = function (value, errorMessage) {
        if (this._isMounted &&
            value === this.state.value &&
            this.props.onNotifyValidationResult) {
            this.props.onNotifyValidationResult(errorMessage, value);
        }
    };
    TextField.prototype._adjustInputHeight = function () {
        if (this._textElement && this.props.autoAdjustHeight && this.props.multiline) {
            var textField = this._textElement;
            textField.style.height = '';
            var scrollHeight = textField.scrollHeight + 2; // +2 to avoid vertical scroll bars
            textField.style.height = scrollHeight + 'px';
        }
    };
    TextField.defaultProps = {
        multiline: false,
        resizable: true,
        autoAdjustHeight: false,
        underlined: false,
        borderless: false,
        onChanged: function () { },
        onBeforeChange: function () { },
        onNotifyValidationResult: function () { },
        onGetErrorMessage: function () { return undefined; },
        deferredValidationTime: 200,
        errorMessage: '',
        validateOnFocusIn: false,
        validateOnFocusOut: false,
        validateOnLoad: true,
    };
    return TextField;
}(Utilities_1.BaseComponent));
exports.TextField = TextField;
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 1754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;position:relative}.screenReaderOnly_5c753ca1{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.fieldGroup_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;border:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";background:" }, { "theme": "bodyBackground", "defaultValue": "#ffffff" }, { "rawString": ";height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;position:relative}.fieldGroup_5c753ca1:hover{border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}.fieldGroup_5c753ca1.fieldGroupIsFocused_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}.rootIsDisabled_5c753ca1 .fieldGroup_5c753ca1{background-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";border-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}@media screen and (-ms-high-contrast: active){.fieldGroup_5c753ca1:hover,.fieldGroup_5c753ca1.fieldGroupIsFocused_5c753ca1{border-color:Highlight}}.fieldGroup_5c753ca1::-ms-clear{display:none}.root_5c753ca1.rootIsDisabled_5c753ca1 .field{background-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";border-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}.fieldPrefixSuffix_5c753ca1{background:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 10px;line-height:1}.field_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;font-size:14px;border-radius:0;border:none;background:none;color:" }, { "theme": "bodyText", "defaultValue": "#333333" }, { "rawString": ";padding:0 12px 0 12px;width:100%;text-overflow:ellipsis;outline:0}[dir='rtl'] .field_5c753ca1{padding:0 12px 0 12px}.field_5c753ca1:active,.field_5c753ca1:focus,.field_5c753ca1:hover{outline:0}[dir='ltr'] .field_5c753ca1.hasIcon_5c753ca1{padding-right:24px}[dir='rtl'] .field_5c753ca1.hasIcon_5c753ca1{padding-left:24px}.field_5c753ca1[disabled]{background-color:transparent;border-color:transparent;pointer-events:none;cursor:default}.field_5c753ca1 .field_5c753ca1::-webkit-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1:-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1::-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field::-webkit-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field:-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field::-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1::placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsRequiredLabel_5c753ca1 .ms-Label::after{content:' *';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{content:'*';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": ";position:absolute;top:-5px}[dir='ltr'] .root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{right:-10px}[dir='rtl'] .root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{left:-10px}.root_5c753ca1.rootIsActive_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}.icon_5c753ca1{pointer-events:none;position:absolute;bottom:5px;top:auto;font-size:16px;line-height:18px}html[dir='ltr'] .icon_5c753ca1{right:8px}html[dir='rtl'] .icon_5c753ca1{left:8px}.description_5c753ca1{color:" }, { "theme": "bodySubtext", "defaultValue": "#666666" }, { "rawString": ";font-size:11px}.rootIsBorderless_5c753ca1 .fieldGroup_5c753ca1{border-color:transparent;border-width:0}.root_5c753ca1.rootIsUnderlined_5c753ca1{border-width:0px}.root_5c753ca1.rootIsUnderlined_5c753ca1:hover:not(.rootIsDisabled_5c753ca1){border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_5c753ca1.rootIsUnderlined_5c753ca1:hover:not(.rootIsDisabled_5c753ca1){border-color:Highlight}}.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1{display:-webkit-box;display:-ms-flexbox;display:flex;border-bottom:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";width:100%}.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1,.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1:focus,.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1:hover{border-bottom:1px solid " }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{font-size:14px;line-height:22px;height:32px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{margin-right:8px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{margin-left:8px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:12px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:12px}.root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0px;border-width:0}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{text-align:left}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{text-align:right}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1{border-bottom-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .ms-Label{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .field_5c753ca1{background-color:transparent;color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .fieldGroup_5c753ca1{background-color:transparent}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsActive_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsActive_5c753ca1{border-color:Highlight}}.root_5c753ca1.rootIsMultiline_5c753ca1 .fieldGroup_5c753ca1{min-height:60px;height:auto;display:-webkit-box;display:-ms-flexbox;display:flex}.root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1{line-height:17px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding-top:6px;overflow:auto;width:100%}[dir='ltr'] .root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.hasIcon_5c753ca1{padding-right:40px}[dir='rtl'] .root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.hasIcon_5c753ca1{padding-left:40px}.errorMessage_5c753ca1{font-size:12px;font-weight:400;color:" }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": ";margin:0;padding-top:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.invalid_5c753ca1,.invalid_5c753ca1:focus,.invalid_5c753ca1:hover{border-color:" }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": "}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:12px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:12px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:0}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:0}html[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .field_5c753ca1{text-align:left}html[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .field_5c753ca1{text-align:right}.root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-bottom:8px;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}[dir='ltr'] .root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-right:24px}[dir='rtl'] .root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-left:24px}.root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.fieldIsUnresizable_5c753ca1{resize:none}.hidden_5c753ca1{display:none}\n" }]);
exports.root = "root_5c753ca1";
exports.screenReaderOnly = "screenReaderOnly_5c753ca1";
exports.fieldGroup = "fieldGroup_5c753ca1";
exports.fieldGroupIsFocused = "fieldGroupIsFocused_5c753ca1";
exports.rootIsDisabled = "rootIsDisabled_5c753ca1";
exports.fieldPrefixSuffix = "fieldPrefixSuffix_5c753ca1";
exports.field = "field_5c753ca1";
exports.hasIcon = "hasIcon_5c753ca1";
exports.rootIsRequiredLabel = "rootIsRequiredLabel_5c753ca1";
exports.rootIsRequiredPlaceholderOnly = "rootIsRequiredPlaceholderOnly_5c753ca1";
exports.rootIsActive = "rootIsActive_5c753ca1";
exports.icon = "icon_5c753ca1";
exports.description = "description_5c753ca1";
exports.rootIsBorderless = "rootIsBorderless_5c753ca1";
exports.rootIsUnderlined = "rootIsUnderlined_5c753ca1";
exports.wrapper = "wrapper_5c753ca1";
exports.invalid = "invalid_5c753ca1";
exports.rootIsMultiline = "rootIsMultiline_5c753ca1";
exports.errorMessage = "errorMessage_5c753ca1";
exports.fieldIsUnresizable = "fieldIsUnresizable_5c753ca1";
exports.hidden = "hidden_5c753ca1";
//# sourceMappingURL=TextField.scss.js.map

/***/ }),

/***/ 1755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookDataProviderItemType = 'FacebookDataProviderItem:#Exchange';
exports.FacebookProviderScopeType = 'FacebookProviderScope:#Exchange';
exports.FileAttachmentDataProviderItemType = 'FileAttachmentDataProviderItem:#Exchange';
exports.FolderAttachmentDataProviderItemType = 'FolderAttachmentDataProviderItem:#Exchange';
exports.GDriveDataProviderItemType = 'GDriveDataProviderItem:#Exchange';
exports.OneDriveProScopeName = 'OneDriveProScope:#Exchange';
exports.ScopeBreadcrumbId = 'scopeId';
exports.SearchBreadcrumbId = 'searchId';
exports.SizeLimitInKbToSuggestSharing = 5 * 1024;
//# sourceMappingURL=filePickerConstants.js.map

/***/ }),

/***/ 1756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1757), exports);
tslib_1.__exportStar(__webpack_require__(1566), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* tslint:disable:no-unused-variable */
var React = __webpack_require__(3);
/* tslint:enable:no-unused-variable */
var Utilities_1 = __webpack_require__(7);
var index_1 = __webpack_require__(674);
var Panel_types_1 = __webpack_require__(1566);
var Layer_1 = __webpack_require__(333);
var Overlay_1 = __webpack_require__(675);
var Popup_1 = __webpack_require__(601);
var Button_1 = __webpack_require__(62);
var Styling_1 = __webpack_require__(21);
var stylesImport = __webpack_require__(1758);
var styles = stylesImport;
var theme = Styling_1.getTheme();
var Panel = /** @class */ (function (_super) {
    tslib_1.__extends(Panel, _super);
    function Panel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFooterSticky: false,
            isOpen: false,
            isAnimating: false,
            id: Utilities_1.getId('Panel')
        };
        return _this;
    }
    Panel.prototype.componentDidMount = function () {
        this._events.on(window, 'resize', this._updateFooterPosition);
        if (this.props.isOpen) {
            this.open();
        }
    };
    Panel.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.isOpen !== this.state.isOpen) {
            if (newProps.isOpen) {
                this.open();
            }
            else {
                this.dismiss();
            }
        }
    };
    Panel.prototype.render = function () {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? '' : _b, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, hasCloseButton = _a.hasCloseButton, headerText = _a.headerText, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isLightDismiss = _a.isLightDismiss, isHiddenOnDismiss = _a.isHiddenOnDismiss, layerProps = _a.layerProps, type = _a.type, customWidth = _a.customWidth, _c = _a.onLightDismissClick, onLightDismissClick = _c === void 0 ? this._onPanelClick : _c, _d = _a.onRenderNavigation, onRenderNavigation = _d === void 0 ? this._onRenderNavigation : _d, _e = _a.onRenderHeader, onRenderHeader = _e === void 0 ? this._onRenderHeader : _e, _f = _a.onRenderBody, onRenderBody = _f === void 0 ? this._onRenderBody : _f, _g = _a.onRenderFooter, onRenderFooter = _g === void 0 ? this._onRenderFooter : _g;
        var _h = this.state, isOpen = _h.isOpen, isAnimating = _h.isAnimating, id = _h.id;
        var isLeft = type === Panel_types_1.PanelType.smallFixedNear ? true : false;
        var isRTL = Utilities_1.getRTL();
        var isOnRightSide = isRTL ? isLeft : !isLeft;
        var headerTextId = id + '-headerText';
        var customWidthStyles = (type === Panel_types_1.PanelType.custom) ? { width: customWidth } : {};
        var renderProps = tslib_1.__assign({}, this.props, { componentId: id });
        if (!isOpen && !isAnimating && !isHiddenOnDismiss) {
            return null;
        }
        var overlay;
        if (isBlocking && isOpen) {
            overlay = (React.createElement(Overlay_1.Overlay, { className: Utilities_1.css(styles.overlay, isOpen && isAnimating && Styling_1.AnimationClassNames.fadeIn200, !isOpen && isAnimating && Styling_1.AnimationClassNames.fadeOut200), isDarkThemed: false, onClick: isLightDismiss ? onLightDismissClick : undefined }));
        }
        return (React.createElement(Layer_1.Layer, tslib_1.__assign({}, layerProps),
            React.createElement(Popup_1.Popup, { role: 'dialog', ariaLabelledBy: headerText && headerTextId, onDismiss: this.dismiss, className: Utilities_1.css(!isOpen && !isAnimating && isHiddenOnDismiss && styles.hiddenPanel) },
                React.createElement("div", { className: Utilities_1.css('ms-Panel', styles.root, className, 
                    // because the RTL animations are not being used, we need to set a class
                    isOpen && ('is-open ' + styles.rootIsOpen), type === Panel_types_1.PanelType.smallFluid && ('ms-Panel--smFluid ' + styles.rootIsSmallFluid), type === Panel_types_1.PanelType.smallFixedNear && ('ms-Panel--smLeft ' + styles.rootIsSmallLeft), type === Panel_types_1.PanelType.smallFixedFar && ('ms-Panel--sm ' + styles.rootIsSmall), type === Panel_types_1.PanelType.medium && ('ms-Panel--md ' + styles.rootIsMedium), (type === Panel_types_1.PanelType.large || type === Panel_types_1.PanelType.largeFixed) && ('ms-Panel--lg ' + styles.rootIsLarge), type === Panel_types_1.PanelType.largeFixed && ('ms-Panel--fixed ' + styles.rootIsFixed), type === Panel_types_1.PanelType.extraLarge && ('ms-Panel--xl ' + styles.rootIsXLarge), type === Panel_types_1.PanelType.custom && ('ms-Panel--custom ' + styles.rootIsCustom), hasCloseButton && ('ms-Panel--hasCloseButton ' + styles.rootHasCloseButton), !isOpen && !isAnimating && isHiddenOnDismiss && styles.hiddenPanel) },
                    overlay,
                    React.createElement(index_1.FocusTrapZone, { className: Utilities_1.css('ms-Panel-main', styles.main, isOpen && isAnimating && !isOnRightSide && Styling_1.AnimationClassNames.slideRightIn40, isOpen && isAnimating && isOnRightSide && Styling_1.AnimationClassNames.slideLeftIn40, !isOpen && isAnimating && !isOnRightSide && Styling_1.AnimationClassNames.slideLeftOut40, !isOpen && isAnimating && isOnRightSide && Styling_1.AnimationClassNames.slideRightOut40), style: customWidthStyles, elementToFocusOnDismiss: elementToFocusOnDismiss, isClickableOutsideFocusTrap: isLightDismiss || isHiddenOnDismiss, ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector },
                        React.createElement("div", { className: Utilities_1.css('ms-Panel-commands'), "data-is-visible": true }, onRenderNavigation(renderProps, this._onRenderNavigation)),
                        React.createElement("div", { className: Utilities_1.css('ms-Panel-contentInner', styles.contentInner) },
                            onRenderHeader(renderProps, this._onRenderHeader),
                            onRenderBody(renderProps, this._onRenderBody),
                            onRenderFooter(renderProps, this._onRenderFooter)))))));
    };
    Panel.prototype.open = function () {
        var _this = this;
        if (!this.state.isOpen) {
            this.setState({
                isOpen: true,
                isAnimating: true
            }, function () {
                _this._async.setTimeout(_this._onTransitionComplete, 200);
            });
        }
    };
    Panel.prototype.dismiss = function () {
        var _this = this;
        if (this.state.isOpen) {
            this.setState({
                isOpen: false,
                isAnimating: true
            }, function () {
                _this._async.setTimeout(_this._onTransitionComplete, 200);
            });
            if (this.props.onDismiss) {
                this.props.onDismiss();
            }
        }
    };
    Panel.prototype._onRenderNavigation = function (props) {
        var closeButtonAriaLabel = props.closeButtonAriaLabel, hasCloseButton = props.hasCloseButton;
        if (hasCloseButton) {
            return (React.createElement("div", { className: Utilities_1.css('ms-Panel-navigation', styles.navigation) },
                React.createElement(Button_1.IconButton, { styles: {
                        root: {
                            height: 'auto',
                            width: '44px',
                            color: theme.palette.neutralSecondary,
                            fontSize: Styling_1.IconFontSizes.large,
                        },
                        rootHovered: {
                            color: theme.palette.neutralPrimary
                        }
                    }, className: Utilities_1.css('ms-Panel-closeButton ms-PanelAction-close'), onClick: this._onPanelClick, ariaLabel: closeButtonAriaLabel, "data-is-visible": true, iconProps: { iconName: 'Cancel' } })));
        }
        return null;
    };
    Panel.prototype._onRenderHeader = function (props) {
        var headerText = props.headerText, componentId = props.componentId, _a = props.headerClassName, headerClassName = _a === void 0 ? '' : _a;
        if (headerText) {
            return (React.createElement("div", { className: Utilities_1.css('ms-Panel-header', styles.header) },
                React.createElement("p", { className: Utilities_1.css('ms-Panel-headerText', styles.headerText, headerClassName), id: componentId + '-headerText', role: 'heading' }, headerText)));
        }
        return null;
    };
    Panel.prototype._onRenderBody = function (props) {
        var contentClass = Utilities_1.css('ms-Panel-content', styles.content, props.isFooterAtBottom && styles.contentGrow);
        return (React.createElement("div", { ref: this._resolveRef('_content'), className: contentClass }, props.children));
    };
    Panel.prototype._onRenderFooter = function (props) {
        var isFooterSticky = this.state.isFooterSticky;
        var _a = this.props.onRenderFooterContent, onRenderFooterContent = _a === void 0 ? null : _a;
        if (onRenderFooterContent) {
            return (React.createElement("div", { className: Utilities_1.css('ms-Panel-footer', styles.footer, isFooterSticky && styles.footerIsSticky) },
                React.createElement("div", { className: Utilities_1.css('ms-Panel-footerInner', styles.footerInner) }, onRenderFooterContent())));
        }
        return null;
    };
    Panel.prototype._updateFooterPosition = function () {
        var _content = this._content;
        if (_content) {
            var height = _content.clientHeight;
            var innerHeight_1 = _content.scrollHeight;
            this.setState({
                isFooterSticky: height < innerHeight_1 ? true : false
            });
        }
    };
    Panel.prototype._onPanelClick = function () {
        this.dismiss();
    };
    Panel.prototype._onTransitionComplete = function () {
        this.setState({
            isAnimating: false
        });
        if (!this.state.isOpen && this.props.onDismissed) {
            this.props.onDismissed();
        }
    };
    Panel.defaultProps = {
        isHiddenOnDismiss: false,
        isOpen: false,
        isBlocking: true,
        hasCloseButton: true,
        type: Panel_types_1.PanelType.smallFixedFar,
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "dismiss", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onRenderNavigation", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onRenderHeader", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onRenderBody", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onRenderFooter", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onPanelClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onTransitionComplete", null);
    return Panel;
}(Utilities_1.BaseComponent));
exports.Panel = Panel;
//# sourceMappingURL=Panel.js.map

/***/ }),

/***/ 1758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".hiddenPanel_86324e19{visibility:hidden}.root_86324e19{pointer-events:none;position:absolute;top:0;left:0;right:0;bottom:0}.root_86324e19 .overlay_86324e19{pointer-events:none;opacity:1;cursor:pointer;-webkit-transition:opacity .367s cubic-bezier(0.1, 0.9, 0.2, 1);transition:opacity .367s cubic-bezier(0.1, 0.9, 0.2, 1)}.main_86324e19{background-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";position:absolute;width:100%;bottom:0;top:0;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}[dir='ltr'] .main_86324e19{right:0}[dir='rtl'] .main_86324e19{left:0}@media (min-width: 480px){.main_86324e19{border-left:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";border-right:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";pointer-events:auto;width:340px}[dir='ltr'] .main_86324e19{-webkit-box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2)}[dir='rtl'] .main_86324e19{-webkit-box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2)}[dir='ltr'] .main_86324e19{left:auto}[dir='rtl'] .main_86324e19{right:auto}}.root_86324e19.rootIsSmall_86324e19 .main_86324e19{width:272px}@media (min-width: 480px){.root_86324e19.rootIsSmall_86324e19 .main_86324e19{width:340px}}.root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{width:272px}[dir='ltr'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{right:auto}[dir='rtl'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{left:auto}[dir='ltr'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{left:0}[dir='rtl'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{right:0}[dir='ltr'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{-webkit-box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2)}[dir='rtl'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{-webkit-box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2)}.root_86324e19.rootIsSmallFluid_86324e19 .main_86324e19{width:100%}@media (min-width: 768px){.root_86324e19.rootIsMedium_86324e19 .main_86324e19,.root_86324e19.rootIsLarge_86324e19 .main_86324e19,.root_86324e19.rootIsXLarge_86324e19 .main_86324e19,.root_86324e19.rootIsCustom_86324e19 .main_86324e19{width:auto}[dir='ltr'] .root_86324e19.rootIsMedium_86324e19 .main_86324e19,[dir='ltr'] .root_86324e19.rootIsLarge_86324e19 .main_86324e19,[dir='ltr'] .root_86324e19.rootIsXLarge_86324e19 .main_86324e19,[dir='ltr'] .root_86324e19.rootIsCustom_86324e19 .main_86324e19{left:48px}[dir='rtl'] .root_86324e19.rootIsMedium_86324e19 .main_86324e19,[dir='rtl'] .root_86324e19.rootIsLarge_86324e19 .main_86324e19,[dir='rtl'] .root_86324e19.rootIsXLarge_86324e19 .main_86324e19,[dir='rtl'] .root_86324e19.rootIsCustom_86324e19 .main_86324e19{right:48px}}@media (min-width: 1024px){.root_86324e19.rootIsMedium_86324e19 .main_86324e19{width:643px}[dir='ltr'] .root_86324e19.rootIsMedium_86324e19 .main_86324e19{left:auto}[dir='rtl'] .root_86324e19.rootIsMedium_86324e19 .main_86324e19{right:auto}}@media (min-width: 1366px){[dir='ltr'] .root_86324e19.rootIsLarge_86324e19 .main_86324e19{left:428px}[dir='rtl'] .root_86324e19.rootIsLarge_86324e19 .main_86324e19{right:428px}}@media (min-width: 1366px){.root_86324e19.rootIsLarge_86324e19.rootIsFixed_86324e19 .main_86324e19{width:940px}[dir='ltr'] .root_86324e19.rootIsLarge_86324e19.rootIsFixed_86324e19 .main_86324e19{left:auto}[dir='rtl'] .root_86324e19.rootIsLarge_86324e19.rootIsFixed_86324e19 .main_86324e19{right:auto}}@media (min-width: 1366px){[dir='ltr'] .root_86324e19.rootIsXLarge_86324e19 .main_86324e19{left:176px}[dir='rtl'] .root_86324e19.rootIsXLarge_86324e19 .main_86324e19{right:176px}}@media (min-width: 1024px){[dir='ltr'] .root_86324e19.rootIsCustom_86324e19 .main_86324e19{left:auto}[dir='rtl'] .root_86324e19.rootIsCustom_86324e19 .main_86324e19{right:auto}}.root_86324e19.rootIsOpen_86324e19 .main_86324e19{pointer-events:auto}.root_86324e19.rootIsOpen_86324e19 .overlay_86324e19{cursor:pointer;pointer-events:auto}@media screen and (-ms-high-contrast: active){.root_86324e19.rootIsOpen_86324e19 .overlay_86324e19{opacity:0}}.navigation_86324e19{padding:0 5px;height:44px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.contentInner_86324e19{position:absolute;top:0;bottom:0;left:0;right:0;overflow-y:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-overflow-scrolling:touch;-webkit-transform:translateZ(0);transform:translateZ(0)}.rootHasCloseButton_86324e19 .contentInner_86324e19{top:44px}.header_86324e19,.content_86324e19,.footerInner_86324e19{padding-left:16px;padding-right:16px}@media (min-width: 768px){.header_86324e19,.content_86324e19,.footerInner_86324e19{padding-left:32px;padding-right:32px}}@media (min-width: 1366px){.header_86324e19,.content_86324e19,.footerInner_86324e19{padding-left:40px;padding-right:40px}}.header_86324e19{margin:14px 0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}@media (min-width: 1024px){.header_86324e19{margin-top:30px}}.content_86324e19{margin-bottom:0;padding-bottom:20px;overflow-y:auto}.contentGrow_86324e19{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.footer_86324e19{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;border-top:1px solid transparent;-webkit-transition:border .367s cubic-bezier(0.1, 0.25, 0.75, 0.9);transition:border .367s cubic-bezier(0.1, 0.25, 0.75, 0.9)}.footerInner_86324e19{padding-bottom:20px;padding-top:20px}.footerIsSticky_86324e19{background:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";border-top-color:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.headerText_86324e19{font-size:21px;font-weight:100;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";line-height:32px;margin:0}\n" }]);
exports.hiddenPanel = "hiddenPanel_86324e19";
exports.root = "root_86324e19";
exports.overlay = "overlay_86324e19";
exports.main = "main_86324e19";
exports.rootIsSmall = "rootIsSmall_86324e19";
exports.rootIsSmallLeft = "rootIsSmallLeft_86324e19";
exports.rootIsSmallFluid = "rootIsSmallFluid_86324e19";
exports.rootIsMedium = "rootIsMedium_86324e19";
exports.rootIsLarge = "rootIsLarge_86324e19";
exports.rootIsXLarge = "rootIsXLarge_86324e19";
exports.rootIsCustom = "rootIsCustom_86324e19";
exports.rootIsFixed = "rootIsFixed_86324e19";
exports.rootIsOpen = "rootIsOpen_86324e19";
exports.navigation = "navigation_86324e19";
exports.contentInner = "contentInner_86324e19";
exports.rootHasCloseButton = "rootHasCloseButton_86324e19";
exports.header = "header_86324e19";
exports.content = "content_86324e19";
exports.footerInner = "footerInner_86324e19";
exports.contentGrow = "contentGrow_86324e19";
exports.footer = "footer_86324e19";
exports.footerIsSticky = "footerIsSticky_86324e19";
exports.headerText = "headerText_86324e19";
//# sourceMappingURL=Panel.scss.js.map

/***/ }),

/***/ 1762:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileProviderItemType;
(function (FileProviderItemType) {
    FileProviderItemType[FileProviderItemType["File"] = 0] = "File";
    FileProviderItemType[FileProviderItemType["Folder"] = 1] = "Folder";
})(FileProviderItemType = exports.FileProviderItemType || (exports.FileProviderItemType = {}));
var ImageLoadState;
(function (ImageLoadState) {
    ImageLoadState[ImageLoadState["NotLoaded"] = 0] = "NotLoaded";
    ImageLoadState[ImageLoadState["Loaded"] = 1] = "Loaded";
    ImageLoadState[ImageLoadState["ErrorLoading"] = 2] = "ErrorLoading";
})(ImageLoadState = exports.ImageLoadState || (exports.ImageLoadState = {}));
//# sourceMappingURL=FileProviderItemViewState.js.map

/***/ }),

/***/ 1777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var config = {};
function initializePersona(inputConfig) {
    config = inputConfig;
}
exports.initializePersona = initializePersona;
function getConfig() {
    return config;
}
exports.getConfig = getConfig;
//# sourceMappingURL=personaConfig.js.map

/***/ }),

/***/ 1778:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FilePickerAction;
(function (FilePickerAction) {
    FilePickerAction[FilePickerAction["Attach"] = 0] = "Attach";
    FilePickerAction[FilePickerAction["Share"] = 1] = "Share";
    FilePickerAction[FilePickerAction["Insert"] = 2] = "Insert";
    FilePickerAction[FilePickerAction["AttachAndShare"] = 3] = "AttachAndShare";
})(FilePickerAction || (FilePickerAction = {}));
exports.default = FilePickerAction;
//# sourceMappingURL=FilePickerAction.js.map

/***/ }),

/***/ 1779:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FilePickerViewSwitcher_1 = __webpack_require__(1591);
var owa_fileprovider_store_1 = __webpack_require__(597);
var satcheljs_1 = __webpack_require__(2);
var filePickerStoreData = {
    viewState: {
        isOpen: false,
        fileSelectionFilter: owa_fileprovider_store_1.FileSelectionFilter.None,
        selectedFileProvider: null,
        selectedProviderScope: null,
        filePickerViewState: {
            breadcrumbs: [],
            columnSorting: null,
            fileProviderItems: [],
            isLoadingItems: false,
            pagingMetadata: null,
            selectedFileProviderItems: [],
            selectedFolder: null,
            selectedView: null,
            supportedActions: [],
            supportedActionsMessages: [],
            supportedViews: [],
            totalItemsCount: 0,
            userPreferredViewType: FilePickerViewSwitcher_1.FilePickerViewType.List,
            searchViewState: {
                searchQuery: '',
                isInSearchMode: false,
            },
            filterOptionsState: {
                showFilterOptions: false,
                selectedFilterOption: 0 /* None */,
            },
        },
        fileProviderPaneViewState: {
            fileProvidersToDisplay: [],
        },
        filePickerErrorMessageViewState: {
            isShown: false,
            message: null,
        },
        filePickerActionsViewState: {
            isOpen: false,
            saveUserChoice: false,
            isCalloutVisible: false,
            uploadFolderName: null,
        },
    },
};
var filePickerStore = satcheljs_1.createStore('filepicker', filePickerStoreData)();
exports.default = filePickerStore;
//# sourceMappingURL=filePickerStore.js.map

/***/ }),

/***/ 1780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = __webpack_require__(360);
var Utilities_1 = __webpack_require__(7);
var Selection = /** @class */ (function () {
    function Selection(options) {
        if (options === void 0) { options = {}; }
        var onSelectionChanged = options.onSelectionChanged, getKey = options.getKey, _a = options.canSelectItem, canSelectItem = _a === void 0 ? function (item) { return true; } : _a, _b = options.selectionMode, selectionMode = _b === void 0 ? interfaces_1.SelectionMode.multiple : _b;
        this.mode = selectionMode;
        this._getKey = getKey || defaultGetKey;
        this._changeEventSuppressionCount = 0;
        this._exemptedCount = 0;
        this._anchoredIndex = 0;
        this._unselectableCount = 0;
        this._onSelectionChanged = onSelectionChanged;
        this._canSelectItem = canSelectItem;
        this._isModal = false;
        this.setItems([], true);
    }
    Selection.prototype.canSelectItem = function (item) {
        return this._canSelectItem(item);
    };
    Selection.prototype.getKey = function (item, index) {
        var key = this._getKey(item, index);
        return (typeof key === 'number' || key) ?
            "" + key :
            '';
    };
    Selection.prototype.setChangeEvents = function (isEnabled, suppressChange) {
        this._changeEventSuppressionCount += isEnabled ? -1 : 1;
        if (this._changeEventSuppressionCount === 0 && this._hasChanged) {
            this._hasChanged = false;
            if (!suppressChange) {
                this._change();
            }
        }
    };
    Selection.prototype.isModal = function () {
        return this._isModal;
    };
    Selection.prototype.setModal = function (isModal) {
        if (this._isModal !== isModal) {
            this.setChangeEvents(true);
            this._isModal = isModal;
            if (!isModal) {
                this.setAllSelected(false);
            }
            this._change();
            this.setChangeEvents(false);
        }
    };
    /**
     * Selection needs the items, call this method to set them. If the set
     * of items is the same, this will re-evaluate selection and index maps.
     * Otherwise, shouldClear should be set to true, so that selection is
     * cleared.
     */
    Selection.prototype.setItems = function (items, shouldClear) {
        if (shouldClear === void 0) { shouldClear = true; }
        var newKeyToIndexMap = {};
        var newUnselectableIndices = {};
        var hasSelectionChanged = false;
        this.setChangeEvents(false);
        // Reset the unselectable count.
        this._unselectableCount = 0;
        // Build lookup table for quick selection evaluation.
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item) {
                var key = this.getKey(item, i);
                if (key) {
                    newKeyToIndexMap[key] = i;
                }
            }
            newUnselectableIndices[i] = item && !this.canSelectItem(item);
            if (newUnselectableIndices[i]) {
                this._unselectableCount++;
            }
        }
        if (shouldClear) {
            this.setAllSelected(false);
        }
        // Check the exemption list for discrepencies.
        var newExemptedIndicies = {};
        for (var indexProperty in this._exemptedIndices) {
            if (this._exemptedIndices.hasOwnProperty(indexProperty)) {
                var index = Number(indexProperty);
                var item = this._items[index];
                var exemptKey = item ? this.getKey(item, Number(index)) : undefined;
                var newIndex = exemptKey ? newKeyToIndexMap[exemptKey] : index;
                if (newIndex === undefined) {
                    // We don't know the index of the item any more so it's either moved or removed.
                    // In this case we reset the entire selection.
                    this.setAllSelected(false);
                    break;
                }
                else {
                    // We know the new index of the item. update the existing exemption table.
                    newExemptedIndicies[newIndex] = true;
                    hasSelectionChanged = hasSelectionChanged || (newIndex !== index);
                }
            }
        }
        this._exemptedIndices = newExemptedIndicies;
        this._keyToIndexMap = newKeyToIndexMap;
        this._unselectableIndices = newUnselectableIndices;
        this._items = items || [];
        this._selectedItems = null;
        if (hasSelectionChanged) {
            this._change();
        }
        this.setChangeEvents(true);
    };
    Selection.prototype.getItems = function () {
        return this._items;
    };
    Selection.prototype.getSelection = function () {
        if (!this._selectedItems) {
            this._selectedItems = [];
            var items = this._items;
            if (items) {
                for (var i = 0; i < items.length; i++) {
                    if (this.isIndexSelected(i)) {
                        this._selectedItems.push(items[i]);
                    }
                }
            }
        }
        return this._selectedItems;
    };
    Selection.prototype.getSelectedCount = function () {
        return this._isAllSelected ? (this._items.length - this._exemptedCount - this._unselectableCount) : (this._exemptedCount);
    };
    Selection.prototype.getSelectedIndices = function () {
        if (!this._selectedIndices) {
            this._selectedIndices = [];
            var items = this._items;
            if (items) {
                for (var i = 0; i < items.length; i++) {
                    if (this.isIndexSelected(i)) {
                        this._selectedIndices.push(i);
                    }
                }
            }
        }
        return this._selectedIndices;
    };
    Selection.prototype.isRangeSelected = function (fromIndex, count) {
        if (count === 0) {
            return false;
        }
        var endIndex = fromIndex + count;
        for (var i = fromIndex; i < endIndex; i++) {
            if (!this.isIndexSelected(i)) {
                return false;
            }
        }
        return true;
    };
    Selection.prototype.isAllSelected = function () {
        var selectableCount = this._items.length - this._unselectableCount;
        // In single mode, we can only have a max of 1 item.
        if (this.mode === interfaces_1.SelectionMode.single) {
            selectableCount = Math.min(selectableCount, 1);
        }
        return ((this.count > 0) &&
            (this._isAllSelected && this._exemptedCount === 0) ||
            (!this._isAllSelected && (this._exemptedCount === selectableCount) && selectableCount > 0));
    };
    Selection.prototype.isKeySelected = function (key) {
        var index = this._keyToIndexMap[key];
        return this.isIndexSelected(index);
    };
    Selection.prototype.isIndexSelected = function (index) {
        return !!((this.count > 0) &&
            (this._isAllSelected && !this._exemptedIndices[index] && !this._unselectableIndices[index]) ||
            (!this._isAllSelected && this._exemptedIndices[index]));
    };
    Selection.prototype.setAllSelected = function (isAllSelected) {
        if (isAllSelected && this.mode !== interfaces_1.SelectionMode.multiple) {
            return;
        }
        var selectableCount = this._items ? (this._items.length - this._unselectableCount) : 0;
        this.setChangeEvents(false);
        if (selectableCount > 0 && (this._exemptedCount > 0 || isAllSelected !== this._isAllSelected)) {
            this._exemptedIndices = {};
            if (isAllSelected !== this._isAllSelected || this._exemptedCount > 0) {
                this._exemptedCount = 0;
                this._isAllSelected = isAllSelected;
                this._change();
            }
            this._updateCount();
        }
        this.setChangeEvents(true);
    };
    Selection.prototype.setKeySelected = function (key, isSelected, shouldAnchor) {
        var index = this._keyToIndexMap[key];
        if (index >= 0) {
            this.setIndexSelected(index, isSelected, shouldAnchor);
        }
    };
    Selection.prototype.setIndexSelected = function (index, isSelected, shouldAnchor) {
        if (this.mode === interfaces_1.SelectionMode.none) {
            return;
        }
        // Clamp the index.
        index = Math.min(Math.max(0, index), this._items.length - 1);
        // No-op on out of bounds selections.
        if (index < 0 || index >= this._items.length) {
            return;
        }
        this.setChangeEvents(false);
        var isExempt = this._exemptedIndices[index];
        var hasChanged = false;
        var canSelect = !this._unselectableIndices[index];
        if (canSelect) {
            if (isSelected && this.mode === interfaces_1.SelectionMode.single) {
                // If this is single-select, the previous selection should be removed.
                this.setAllSelected(false);
            }
            // Determine if we need to remove the exemption.
            if (isExempt && ((isSelected && this._isAllSelected) ||
                (!isSelected && !this._isAllSelected))) {
                hasChanged = true;
                delete this._exemptedIndices[index];
                this._exemptedCount--;
            }
            // Determine if we need to add the exemption.
            if (!isExempt && ((isSelected && !this._isAllSelected) ||
                (!isSelected && this._isAllSelected))) {
                hasChanged = true;
                this._exemptedIndices[index] = true;
                this._exemptedCount++;
            }
            if (shouldAnchor) {
                this._anchoredIndex = index;
            }
        }
        this._updateCount();
        this.setChangeEvents(true);
    };
    Selection.prototype.selectToKey = function (key, clearSelection) {
        this.selectToIndex(this._keyToIndexMap[key], clearSelection);
    };
    Selection.prototype.selectToIndex = function (index, clearSelection) {
        if (this.mode === interfaces_1.SelectionMode.none) {
            return;
        }
        if (this.mode === interfaces_1.SelectionMode.single) {
            this.setIndexSelected(index, true, true);
            return;
        }
        var anchorIndex = this._anchoredIndex || 0;
        var startIndex = Math.min(index, anchorIndex);
        var endIndex = Math.max(index, anchorIndex);
        this.setChangeEvents(false);
        if (clearSelection) {
            this.setAllSelected(false);
        }
        for (; startIndex <= endIndex; startIndex++) {
            this.setIndexSelected(startIndex, true, false);
        }
        this.setChangeEvents(true);
    };
    Selection.prototype.toggleAllSelected = function () {
        this.setAllSelected(!this.isAllSelected());
    };
    Selection.prototype.toggleKeySelected = function (key) {
        this.setKeySelected(key, !this.isKeySelected(key), true);
    };
    Selection.prototype.toggleIndexSelected = function (index) {
        this.setIndexSelected(index, !this.isIndexSelected(index), true);
    };
    Selection.prototype.toggleRangeSelected = function (fromIndex, count) {
        if (this.mode === interfaces_1.SelectionMode.none) {
            return;
        }
        var isRangeSelected = this.isRangeSelected(fromIndex, count);
        var endIndex = fromIndex + count;
        if (this.mode === interfaces_1.SelectionMode.single && count > 1) {
            return;
        }
        this.setChangeEvents(false);
        for (var i = fromIndex; i < endIndex; i++) {
            this.setIndexSelected(i, !isRangeSelected, false);
        }
        this.setChangeEvents(true);
    };
    Selection.prototype._updateCount = function () {
        var count = this.getSelectedCount();
        if (count !== this.count) {
            this.count = count;
            this._change();
        }
        if (!this.count) {
            this.setModal(false);
        }
    };
    Selection.prototype._change = function () {
        if (this._changeEventSuppressionCount === 0) {
            this._selectedItems = null;
            this._selectedIndices = undefined;
            Utilities_1.EventGroup.raise(this, interfaces_1.SELECTION_CHANGE);
            if (this._onSelectionChanged) {
                this._onSelectionChanged();
            }
        }
        else {
            this._hasChanged = true;
        }
    };
    return Selection;
}());
exports.Selection = Selection;
function defaultGetKey(item, index) {
    return item && item.key ?
        item.key :
        "" + index;
}
//# sourceMappingURL=Selection.js.map

/***/ }),

/***/ 1781:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var SelectionLayout_1 = __webpack_require__(1580);
var interfaces_1 = __webpack_require__(360);
// Selection definitions:
//
// Anchor index: the point from which a range selection starts.
// Focus index: the point from which layout movement originates from.
//
// These two can differ. Tests:
//
// If you start at index 5
// Shift click to index 10
//    The focus is 10, the anchor is 5.
// If you shift click at index 0
//    The anchor remains at 5, the items between 0 and 5 are selected and everything else is cleared.
// If you click index 8
//    The anchor and focus are set to 8.
var SELECTION_DISABLED_ATTRIBUTE_NAME = 'data-selection-disabled';
var SELECTION_INDEX_ATTRIBUTE_NAME = 'data-selection-index';
var SELECTION_TOGGLE_ATTRIBUTE_NAME = 'data-selection-toggle';
var SELECTION_INVOKE_ATTRIBUTE_NAME = 'data-selection-invoke';
var SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME = 'data-selection-all-toggle';
var SelectionZone = /** @class */ (function (_super) {
    tslib_1.__extends(SelectionZone, _super);
    function SelectionZone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectionZone.prototype.componentDidMount = function () {
        var win = Utilities_1.getWindow(this.refs.root);
        var scrollElement = Utilities_1.findScrollableParent(this.refs.root);
        // Track the latest modifier keys globally.
        this._events.on(win, 'keydown, keyup', this._updateModifiers, true);
        this._events.on(scrollElement, 'click', this._tryClearOnEmptyClick);
    };
    SelectionZone.prototype.render = function () {
        return (React.createElement("div", tslib_1.__assign({ className: 'ms-SelectionZone', ref: 'root', onKeyDown: this._onKeyDown, onMouseDown: this._onMouseDown, onKeyDownCapture: this._onKeyDownCapture, onTouchStartCapture: this._onTouchStartCapture, onTouchEndCapture: this._onTouchStartCapture, onClick: this._onClick, role: 'presentation', onDoubleClick: this._onDoubleClick, onContextMenu: this._onContextMenu }, {
            onMouseDownCapture: this._onMouseDownCapture,
            onFocusCapture: this._onFocus
        }), this.props.children));
    };
    /**
     * In some cases, the consuming scenario requires to set focus on a row without having SelectionZone
     * react to the event. Note that focus events in IE <= 11 will occur asynchronously after .focus() has
     * been called on an element, so we need a flag to store the idea that we will bypass the "next"
     * focus event that occurs. This method does that.
     */
    SelectionZone.prototype.ignoreNextFocus = function () {
        this._handleNextFocus(false);
    };
    SelectionZone.prototype._onMouseDownCapture = function (ev) {
        if (document.activeElement !== ev.target && !Utilities_1.elementContains(document.activeElement, ev.target)) {
            this.ignoreNextFocus();
            return;
        }
        if (!Utilities_1.elementContains(ev.target, this.refs.root)) {
            return;
        }
        var target = ev.target;
        while (target !== this.refs.root) {
            if (this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                this.ignoreNextFocus();
                break;
            }
            target = Utilities_1.getParent(target);
        }
    };
    /**
     * When we focus an item, for single/multi select scenarios, we should try to select it immediately
     * as long as the focus did not originate from a mouse down/touch event. For those cases, we handle them
     * specially.
     */
    SelectionZone.prototype._onFocus = function (ev) {
        var target = ev.target;
        var selection = this.props.selection;
        var isToggleModifierPressed = this._isCtrlPressed || this._isMetaPressed;
        var selectionMode = this._getSelectionMode();
        if (this._shouldHandleFocus && selectionMode !== interfaces_1.SelectionMode.none) {
            var isToggle = this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME);
            var itemRoot = this._findItemRoot(target);
            if (!isToggle && itemRoot) {
                var index = this._getItemIndex(itemRoot);
                if (isToggleModifierPressed) {
                    // set anchor only.
                    selection.setIndexSelected(index, selection.isIndexSelected(index), true);
                    if (this.props.enterModalOnTouch && this._isTouch && selection.setModal) {
                        selection.setModal(true);
                        this._setIsTouch(false);
                    }
                }
                else {
                    if (this.props.isSelectedOnFocus) {
                        this._onItemSurfaceClick(ev, index);
                    }
                }
            }
        }
        this._handleNextFocus(false);
    };
    SelectionZone.prototype._onMouseDown = function (ev) {
        this._updateModifiers(ev);
        var target = ev.target;
        var itemRoot = this._findItemRoot(target);
        while (target !== this.refs.root) {
            if (this._hasAttribute(target, SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME)) {
                break;
            }
            else if (itemRoot) {
                if (this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
                    break;
                }
                else if (this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                    break;
                }
                else if (target === itemRoot && !this._isShiftPressed && !this._isCtrlPressed) {
                    this._onInvokeMouseDown(ev, this._getItemIndex(itemRoot));
                    break;
                }
            }
            target = Utilities_1.getParent(target);
        }
    };
    SelectionZone.prototype._onTouchStartCapture = function (ev) {
        this._setIsTouch(true);
    };
    SelectionZone.prototype._onClick = function (ev) {
        this._updateModifiers(ev);
        var target = ev.target;
        var itemRoot = this._findItemRoot(target);
        // No-op if selection is disabled
        if (this._isSelectionDisabled(target)) {
            return;
        }
        while (target !== this.refs.root) {
            if (this._hasAttribute(target, SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME)) {
                this._onToggleAllClick(ev);
                break;
            }
            else if (itemRoot) {
                var index = this._getItemIndex(itemRoot);
                if (this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
                    if (this._isShiftPressed) {
                        this._onItemSurfaceClick(ev, index);
                    }
                    else {
                        this._onToggleClick(ev, index);
                    }
                    break;
                }
                else if (this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                    this._onInvokeClick(ev, index);
                    break;
                }
                else if (target === itemRoot) {
                    this._onItemSurfaceClick(ev, index);
                    break;
                }
            }
            target = Utilities_1.getParent(target);
        }
    };
    SelectionZone.prototype._onContextMenu = function (ev) {
        var target = ev.target;
        var _a = this.props, onItemContextMenu = _a.onItemContextMenu, selection = _a.selection;
        if (onItemContextMenu) {
            var itemRoot = this._findItemRoot(target);
            if (itemRoot) {
                var index = this._getItemIndex(itemRoot);
                var skipPreventDefault = onItemContextMenu(selection.getItems()[index], index, ev.nativeEvent);
                // In order to keep back compat, if the value here is undefined, then we should still
                // call preventDefault(). Only in the case where true is explicitly returned should
                // the call be skipped.
                if (!skipPreventDefault) {
                    ev.preventDefault();
                }
            }
        }
    };
    SelectionZone.prototype._isSelectionDisabled = function (target) {
        while (target !== this.refs.root) {
            if (this._hasAttribute(target, SELECTION_DISABLED_ATTRIBUTE_NAME)) {
                return true;
            }
            target = Utilities_1.getParent(target);
        }
        return false;
    };
    /**
     * In multi selection, if you double click within an item's root (but not within the invoke element or input elements),
     * we should execute the invoke handler.
     */
    SelectionZone.prototype._onDoubleClick = function (ev) {
        var target = ev.target;
        if (this._isSelectionDisabled(target)) {
            return;
        }
        var onItemInvoked = this.props.onItemInvoked;
        var itemRoot = this._findItemRoot(target);
        var selectionMode = this._getSelectionMode();
        if (itemRoot && onItemInvoked && selectionMode !== interfaces_1.SelectionMode.none && !this._isInputElement(target)) {
            var index = this._getItemIndex(itemRoot);
            while (target !== this.refs.root) {
                if (this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME) ||
                    this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                    break;
                }
                else if (target === itemRoot) {
                    this._onInvokeClick(ev, index);
                    break;
                }
                target = Utilities_1.getParent(target);
            }
            target = Utilities_1.getParent(target);
        }
    };
    SelectionZone.prototype._onKeyDownCapture = function (ev) {
        this._updateModifiers(ev);
        this._handleNextFocus(true);
    };
    SelectionZone.prototype._onKeyDown = function (ev) {
        this._updateModifiers(ev);
        var target = ev.target;
        if (this._isSelectionDisabled(target)) {
            return;
        }
        var selection = this.props.selection;
        var isSelectAllKey = ev.which === 65 /* a */ && (this._isCtrlPressed || this._isMetaPressed);
        var isClearSelectionKey = ev.which === 27 /* escape */;
        // Ignore key downs from input elements.
        if (this._isInputElement(target)) {
            // A key was pressed while an item in this zone was focused.
            return;
        }
        var selectionMode = this._getSelectionMode();
        // If ctrl-a is pressed, select all (if all are not already selected.)
        if (isSelectAllKey && selectionMode === interfaces_1.SelectionMode.multiple && !selection.isAllSelected()) {
            selection.setAllSelected(true);
            ev.stopPropagation();
            ev.preventDefault();
            return;
        }
        // If escape is pressed, clear selection (if any are selected.)
        if (isClearSelectionKey && selection.getSelectedCount() > 0) {
            selection.setAllSelected(false);
            ev.stopPropagation();
            ev.preventDefault();
            return;
        }
        var itemRoot = this._findItemRoot(target);
        // If a key was pressed within an item, we should treat "enters" as invokes and "space" as toggle
        if (itemRoot) {
            var index = this._getItemIndex(itemRoot);
            while (target !== this.refs.root) {
                if (this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
                    // For toggle elements, assuming they are rendered as buttons, they will generate a click event,
                    // so we can no-op for any keydowns in this case.
                    break;
                }
                else if ((ev.which === 13 /* enter */ || ev.which === 32 /* space */) &&
                    (target.tagName === 'BUTTON' || target.tagName === 'A' || target.tagName === 'INPUT')) {
                    return false;
                }
                else if (target === itemRoot) {
                    if (ev.which === 13 /* enter */) {
                        this._onInvokeClick(ev, index);
                        ev.preventDefault();
                        return;
                    }
                    else if (ev.which === 32 /* space */) {
                        this._onToggleClick(ev, index);
                        ev.preventDefault();
                        return;
                    }
                    break;
                }
                target = Utilities_1.getParent(target);
            }
        }
    };
    SelectionZone.prototype._onToggleAllClick = function (ev) {
        var selection = this.props.selection;
        var selectionMode = this._getSelectionMode();
        if (selectionMode === interfaces_1.SelectionMode.multiple) {
            selection.toggleAllSelected();
            ev.stopPropagation();
            ev.preventDefault();
        }
    };
    SelectionZone.prototype._onToggleClick = function (ev, index) {
        var selection = this.props.selection;
        var selectionMode = this._getSelectionMode();
        selection.setChangeEvents(false);
        if (this.props.enterModalOnTouch && this._isTouch && !selection.isIndexSelected(index) && selection.setModal) {
            selection.setModal(true);
            this._setIsTouch(false);
        }
        if (selectionMode === interfaces_1.SelectionMode.multiple) {
            selection.toggleIndexSelected(index);
        }
        else if (selectionMode === interfaces_1.SelectionMode.single) {
            var isSelected = selection.isIndexSelected(index);
            selection.setAllSelected(false);
            selection.setIndexSelected(index, !isSelected, true);
        }
        else {
            selection.setChangeEvents(true);
            return;
        }
        selection.setChangeEvents(true);
        ev.stopPropagation();
        // NOTE: ev.preventDefault is not called for toggle clicks, because this will kill the browser behavior
        // for checkboxes if you use a checkbox for the toggle.
    };
    SelectionZone.prototype._onInvokeClick = function (ev, index) {
        var _a = this.props, selection = _a.selection, onItemInvoked = _a.onItemInvoked;
        if (onItemInvoked) {
            onItemInvoked(selection.getItems()[index], index, ev.nativeEvent);
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    SelectionZone.prototype._onItemSurfaceClick = function (ev, index) {
        var selection = this.props.selection;
        var isToggleModifierPressed = this._isCtrlPressed || this._isMetaPressed;
        var selectionMode = this._getSelectionMode();
        if (selectionMode === interfaces_1.SelectionMode.multiple) {
            if (this._isShiftPressed) {
                selection.selectToIndex(index, !isToggleModifierPressed);
            }
            else if (isToggleModifierPressed) {
                selection.toggleIndexSelected(index);
            }
            else {
                this._clearAndSelectIndex(index);
            }
        }
        else if (selectionMode === interfaces_1.SelectionMode.single) {
            this._clearAndSelectIndex(index);
        }
    };
    SelectionZone.prototype._onInvokeMouseDown = function (ev, index) {
        var selection = this.props.selection;
        // Only do work if item is not selected.
        if (selection.isIndexSelected(index)) {
            return;
        }
        this._clearAndSelectIndex(index);
    };
    SelectionZone.prototype._tryClearOnEmptyClick = function (ev) {
        if (!this.props.selectionPreservedOnEmptyClick &&
            this._isNonHandledClick(ev.target)) {
            this.props.selection.setAllSelected(false);
        }
    };
    SelectionZone.prototype._clearAndSelectIndex = function (index) {
        var selection = this.props.selection;
        var isAlreadySingleSelected = selection.getSelectedCount() === 1 && selection.isIndexSelected(index);
        if (!isAlreadySingleSelected) {
            selection.setChangeEvents(false);
            selection.setAllSelected(false);
            selection.setIndexSelected(index, true, true);
            if (this.props.enterModalOnTouch && this._isTouch && selection.setModal) {
                selection.setModal(true);
                this._setIsTouch(false);
            }
            selection.setChangeEvents(true);
        }
    };
    /**
     * We need to track the modifier key states so that when focus events occur, which do not contain
     * modifier states in the Event object, we know how to behave.
     */
    SelectionZone.prototype._updateModifiers = function (ev) {
        this._isShiftPressed = ev.shiftKey;
        this._isCtrlPressed = ev.ctrlKey;
        this._isMetaPressed = ev.metaKey;
    };
    SelectionZone.prototype._findItemRoot = function (target) {
        var selection = this.props.selection;
        while (target !== this.refs.root) {
            var indexValue = target.getAttribute(SELECTION_INDEX_ATTRIBUTE_NAME);
            var index = Number(indexValue);
            if (indexValue !== null && index >= 0 && index < selection.getItems().length) {
                break;
            }
            target = Utilities_1.getParent(target);
        }
        if (target === this.refs.root) {
            return undefined;
        }
        return target;
    };
    SelectionZone.prototype._getItemIndex = function (itemRoot) {
        return Number(itemRoot.getAttribute(SELECTION_INDEX_ATTRIBUTE_NAME));
    };
    SelectionZone.prototype._hasAttribute = function (element, attributeName) {
        var isToggle = false;
        while (!isToggle && element !== this.refs.root) {
            isToggle = element.getAttribute(attributeName) === 'true';
            element = Utilities_1.getParent(element);
        }
        return isToggle;
    };
    SelectionZone.prototype._isInputElement = function (element) {
        return element.tagName === 'INPUT' || element.tagName === 'TEXTAREA';
    };
    SelectionZone.prototype._isNonHandledClick = function (element) {
        var doc = Utilities_1.getDocument();
        if (doc && element) {
            while (element && element !== doc.documentElement) {
                if (Utilities_1.isElementTabbable(element)) {
                    return false;
                }
                element = Utilities_1.getParent(element);
            }
        }
        return true;
    };
    SelectionZone.prototype._handleNextFocus = function (handleFocus) {
        var _this = this;
        if (this._shouldHandleFocusTimeoutId) {
            this._async.clearTimeout(this._shouldHandleFocusTimeoutId);
            this._shouldHandleFocusTimeoutId = undefined;
        }
        this._shouldHandleFocus = handleFocus;
        if (handleFocus) {
            this._async.setTimeout(function () {
                _this._shouldHandleFocus = false;
            }, 100);
        }
    };
    SelectionZone.prototype._setIsTouch = function (isTouch) {
        var _this = this;
        if (this._isTouchTimeoutId) {
            this._async.clearTimeout(this._isTouchTimeoutId);
            this._isTouchTimeoutId = undefined;
        }
        this._isTouch = true;
        if (isTouch) {
            this._async.setTimeout(function () {
                _this._isTouch = false;
            }, 300);
        }
    };
    SelectionZone.prototype._getSelectionMode = function () {
        var selection = this.props.selection;
        var _a = this.props.selectionMode, selectionMode = _a === void 0 ? selection ? selection.mode : interfaces_1.SelectionMode.none : _a;
        return selectionMode;
    };
    SelectionZone.defaultProps = {
        layout: new SelectionLayout_1.SelectionLayout(interfaces_1.SelectionDirection.vertical),
        isMultiSelectEnabled: true,
        isSelectedOnFocus: true,
        selectionMode: interfaces_1.SelectionMode.multiple
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "ignoreNextFocus", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onMouseDownCapture", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onFocus", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onMouseDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onTouchStartCapture", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onContextMenu", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onDoubleClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onKeyDownCapture", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SelectionZone.prototype, "_onKeyDown", null);
    return SelectionZone;
}(Utilities_1.BaseComponent));
exports.SelectionZone = SelectionZone;
//# sourceMappingURL=SelectionZone.js.map

/***/ }),

/***/ 1797:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SelectedFilesSource;
(function (SelectedFilesSource) {
    SelectedFilesSource[SelectedFilesSource["LocalComputerFiles"] = 0] = "LocalComputerFiles";
    SelectedFilesSource[SelectedFilesSource["ProviderFiles"] = 1] = "ProviderFiles";
})(SelectedFilesSource = exports.SelectedFilesSource || (exports.SelectedFilesSource = {}));
//# sourceMappingURL=FilePickerResult.js.map

/***/ }),

/***/ 1798:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var fileProviderStoreData = {
    fileProvidersViewState: [],
    addableFileProvidersViewState: [],
    isFileProvidersLoadingInProgress: false,
    areFileProvidersLoaded: false,
};
var fileProviderStore = satcheljs_1.createStore('fileProviderStore', fileProviderStoreData)();
exports.default = fileProviderStore;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 1803:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getDefaultFileProvider(fileProvidersViewState) {
    if (fileProvidersViewState.length !== 0) {
        return fileProvidersViewState[0];
    }
    return null;
}
exports.default = getDefaultFileProvider;
//# sourceMappingURL=getDefaultFileProvider.js.map

/***/ }),

/***/ 1804:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_filepicker_add_fileprovider_1 = __webpack_require__(226);
var addFileProvider = null;
// Importing it here because addAndSelectFileProvider needs to call the addFileProvider in the same context as the event
// that triggered it. This is done to ensure that popup blocker does not get invoked.
function initAddFileProvider() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            owa_filepicker_add_fileprovider_1.lazyAddFileProvider.import().then(function (func) { return (addFileProvider = func); });
            return [2 /*return*/];
        });
    });
}
exports.initAddFileProvider = initAddFileProvider;
// If the addFileProvider function was loaded early then return that so that
// the popup blocker does not get invoked else we load it and return it
// which will invoke the popup blocker but that is much less likely to happen.
function getAddFileProvider() {
    return addFileProvider
        ? { isAsync: false, result: addFileProvider }
        : { isAsync: true, result: owa_filepicker_add_fileprovider_1.lazyAddFileProvider.import() };
}
exports.getAddFileProvider = getAddFileProvider;
//# sourceMappingURL=lazyAddFileProviderHelper.js.map

/***/ }),

/***/ 1805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileSelectionFilter;
(function (FileSelectionFilter) {
    FileSelectionFilter[FileSelectionFilter["None"] = 0] = "None";
    FileSelectionFilter[FileSelectionFilter["Images"] = 1] = "Images";
})(FileSelectionFilter || (FileSelectionFilter = {}));
exports.default = FileSelectionFilter;
//# sourceMappingURL=FileSelectionFilter.js.map

/***/ }),

/***/ 1806:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.fileProvidersLoaded = satcheljs_1.action('fileProvidersLoaded', function (fileProviders) { return ({
    fileProviders: fileProviders,
}); });
//# sourceMappingURL=fileProvidersLoaded.js.map

/***/ }),

/***/ 1807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1815), exports);
//# sourceMappingURL=Calendar.js.map

/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['doneText', 'addRemoveTimezonesText', 'timezonesSearchHintText', 'localTimeText', 'timeZoneText', 'todayStringLowerCaseText', 'allDayDurationText', 'cancelLowerCaseText', 'previousMonthText', 'nextMonthText', 'selectDateAriaLabelText', 'cancelMeetingText', 'closeText', 'deleteEventConfirmationTitleText', 'deleteSeriesConfirmationTitleText', 'deleteEventConfirmationSubText', 'deleteEventSeriesConfirmationSubText', 'calendarModuleNameText', 'newCalendarEventText', 'calendarEllipsisAriaLabelText', 'calendarsAreNotAvailable', 'tryAgainByRefreshingBrowser', 'calendarLoadingEvents', 'calendarText', 'myCalendarsText', 'otherCalendarsText', 'peoplesCalendarsText', 'selectedCalendarText', 'notSelectedCalendarText', 'failedCreateCalendarGroupText', 'failedDeleteCalendarGroupText', 'failedCreateCalendarText', 'failedDeleteCalendarText', 'failedRenameCalendarText', 'failedRenameCalendarGroupText', 'failedSetCalendarColorText', 'failedUpdateCalendarText', 'open', 'openOccurrence', 'openSeries', 'charm', 'freeBusyItemSelectedScreenReaderText', 'freeBusyItemNotSelectedScreenReaderText', 'lightBlueCalendarColorText', 'lightGreenCalendarColorText', 'redCalendarColorText', 'darkBlueCalendarColorText', 'yellowCalendarColorText', 'tealCalendarColorText', 'lightPinkCalendarColorText', 'brownCalendarColorText', 'darkPinkCalendarColorText', 'blueCalendarColorText', 'greenCalendarColorText', 'indigoCalendarColorText', 'grayCalendarColorText', 'pinkCalendarColorText', 'orangeCalendarColorText', 'violetCalendarColorText', 'charmsCatAriaText', 'charmsDogAriaText', 'charmsPlaneAriaText', 'charmsCalculatorAriaText', 'charmsMedicalAriaText', 'charmsTrophyAriaText', 'charmsHouseAriaText', 'charmsMedicineAriaText', 'charmsBriefcaseAriaText', 'charmsCoffeeAriaText', 'charmsPeopleAriaText', 'charmsStopwatchAriaText', 'charmsMusicAriaText', 'charmsShoppingAriaText', 'charmsCarAriaText', 'charmsStarAriaText', 'charmsNoteAriaText', 'charmsPersonAriaText', 'charmsBalloonsAriaText', 'charmsForkAndKnifeAriaText', 'charmsHeartAriaText', 'charmsSoccerBallAriaText', 'charmsFilmAriaText', 'charmsChartAriaText', 'charmsBooksAriaText', 'charmsCakeAriaText', 'charmsTvPanelAriaText', 'charmsTravelAriaText', 'charmsPackageDeliveryAriaText', 'charmsPromotionAriaText', 'charmsEventAriaText', 'charmsHotelAriaText', 'sundayAbbreviated', 'mondayAbbreviated', 'tuesdayAbbreviated', 'wednesdayAbbreviated', 'thursdayAbbreviated', 'fridayAbbreviated', 'saturdayAbbreviated', 'organizerInvitedYou', 'youAreOrganizer', 'eventPartOfSeries', 'noResponseReceivedAttendeesLabelAndCount', 'declinedAttendeesLabelAndCount', 'tentativelyAcceptedAttendeesLabelAndCount', 'acceptedAttendeesLabelAndCount', 'acceptedTime', 'tenativelyAcceptedTime', 'cancelledTime', 'edit', 'cancel', 'cancelError', 'thisEvent', 'allEventsInSeries', 'editorPlaceholderText', 'cancelEdit', 'cancelSendNow', 'cancelEditorText', 'cancelOccurrenceEditorText', 'cancelSeriesEditorText', 'delete', 'createError', 'deleteError', 'updateError', 'removeFromCalendar', 'removeSeriesFromCalendar', 'respondWithMessage', 'sendResponseNow', 'noSendResponse', 'cancelWithMessage', 'cancelNow', 'responseEditorWatermark', 'sendButtonString', 'discardButtonString', 'openItemButtonAriaLabel', 'acceptButtonText', 'acceptButtonAriaLabel', 'tentativeButtonText', 'tentativeButtonAriaLabel', 'declineButtonText', 'declineButtonAriaLabel', 'itemDeleteConfirmationDescriptionText', 'itemCancelConfirmationDescriptionText', 'itemDeleteConfirmationBackText', 'acceptedButtonLabel', 'tentativeButtonLabel', 'declineButtonLabel', 'acceptEvent', 'tentativelyAcceptEvent', 'declineEvent', 'acceptEventAndAddMessage', 'tentativelyAcceptEventAndAddMessage', 'declineEventAndAddMessage', 'acceptOccurrenceAndAddMessage', 'tentativelyAcceptOccurrenceAndAddMessage', 'declineOccurrenceAndAddMessage', 'acceptSeriesAndAddMessage', 'tentativelyAcceptSeriesAndAddMessage', 'declineSeriesAndAddMessage', 'addLocationText', 'addToCalendarText', 'durationDay', 'durationFirstPluralDays', 'durationSecondGenitivePluralDays', 'durationHour', 'durationFirstPluralHours', 'durationSecondGenitivePluralHours', 'reminderDay', 'reminderSingularHour', 'reminderSingularWeek', 'reminderFirstPluralHours', 'reminderSecondGenitivePluralHours', 'reminderFirstPluralMin', 'reminderSecondGenitiveMin', 'reminderBefore', 'reminderAfter', 'reminderDayOfEvent', 'reminderDayBeforeEvent', 'reminderWeekBeforeEvent', 'addToCalendar', 'allDay', 'atTimeOfEvent', 'custom', 'remindMe', 'repeat', 'noReminder', 'repeatNever', 'repeatNeverAriaText', 'repeatDaily', 'repeatWeekly', 'repeatMonthly', 'repeatYearly', 'recurrenceDropdownAriaText', 'repeatsWithEndAriaPlaceHolder', 'repeatsWithoutEndPlaceHolder', 'occursPlaceHolder', 'occursAriaPlaceHolder', 'occursUntilPlaceHolder', 'occursUntilAriaPlaceHolder', 'chooseEndDateLabel', 'save', 'discard', 'moreDetails', 'durationLabel', 'startTimeLabel', 'endTimeLabel', 'timeOptionsLabel', 'startDateLabel', 'endDateLabel', 'subjectDetailsLabel', 'selectEventCharmLabel', 'selectEventCalendarLabel', 'infoMessageEditOccurrence', 'infoMessageEditSeries', 'toText', 'changeRecurrenceConfirmationTitleText', 'changeRecurrenceSubText', 'titlePlaceholderText', 'goToTodayStringLowerCaseText', 'switchToDayText', 'switchToWeekText', 'switchToMonthText', 'goToPreviousDayStringLowerCaseText', 'goToNextDayStringLowerCaseText', 'goToPreviousWeekStringLowerCaseText', 'goToNextWeekStringLowerCaseText', 'goToPreviousMonthStringLowerCaseText', 'goToNextMonthStringLowerCaseText', 'goToPreviousYearStringLowerCaseText', 'goToNextYearStringLowerCaseText', 'am', 'pm', 'newCalendarString', 'newCalendarGroupString', 'renameCalendarGroupString', 'deleteCalendarGroupString', 'renameCalendarString', 'removeCalendarString', 'changeCalendarColorString', 'automaticColorString', 'toggleLeftPaneAriaLabel', 'eventLocationAriaText', 'eventOrganizerAriaText', 'eventDescriptionAriaText', 'allDayEventDescriptionAriaText', 'singleDayEventDescriptionAriaText', 'whenStartEndsSameDayLongAriaText', 'whenStartEndsDifferentDayLongAriaText', 'whenStartEndsDifferentDayDateOnlyLongAriaText', 'surfaceItemRecurrenceIconTitle', 'surfaceItemRecurrenceExceptionIconTitle', 'surfaceItemAttachmentIconTitle', 'surfaceItemPrivateIconTitle', 'leftRailRegionName', 'commandBarRegionName', 'newEventSkipLinkName', 'miniMonthRegionName', 'calendarPickerRegionName', 'surfaceCommandBarRegionName', 'timestripRegionName', 'calendarSurfaceRegionName', 'eventsLoadedLiveNotification', 'DiscoverCalendarsText', 'AddAndDiscoverCalendarsText', 'PoweredByText', 'BingText', 'PopularCalendarsText', 'PopularText', 'AddCalendarErrorText', 'RemoveCalendarErrorText', 'GetInterestingCalendarsErrorText', 'DataFromText', 'HolidaysText', 'AddCalendarText', 'FromFileText', 'FromWebText', 'ICErrorText', 'HolidaysErrorText', 'CancelText', 'ImportFromFileText', 'ImportFromWebText', 'ImportEventsText', 'ChooseICSFileText', 'ImportToText', 'BrowseText', 'ImportText', 'ImportingText', 'NoFileSelectedText', 'ICSFileTooLargeText', 'ICSFileErrorText', 'ImportedText', 'SubscribeOnlineText', 'LinkToCalendarText', 'LinkToCalendarPlaceholderText', 'CalendarNameText', 'CalendarNamePlaceholderText', 'WebcalSuccessText', 'WebcalSubscriptionExistsText', 'WebcalUrlErrorText', 'addALocationText', 'suggestedLocationsText', 'useThisLocationText', 'findLocationInfo_Searching', 'findLocationInfo_NoMatchFound', 'findLocationInfo_Loading', 'resolvedLocationAriaLabel', 'multipleLocationsFoundAriaLabel', 'locationSelectedAriaLabel', 'locationCardInformationLabel', 'locationCardMapLabel', 'attendeeWellTitle', 'sortByString', 'sortByDisplayName', 'sortByStatus', 'sortByOrderAdded', 'organizer', 'noResponseStatus', 'acceptedStatus', 'declinedStatus', 'tentativeStatus', 'showAsDropDownTitle', 'showAsFree', 'showAsWorkingElsewhere', 'showAsTentative', 'showAsBusy', 'showAsAway', 'reminderDropDownTitle', 'meetingFormEllipsisAriaLabelText', 'privateControlAltText', 'privateControlHoverTextForPrivate', 'privateControlHoverTextForNonPrivate', 'infobarCannotEditPublicMeeting', 'infobarCancelledMeeting', 'infobarEventInPast', 'infobarNoResponseRequested', 'infobarNoResponseReuqestedOrganizer', 'infobarAcceptedByUser', 'infobarAcceptedByDelegate', 'infobarTentativelyAcceptedByUser', 'infobarTentativelyAcceptedByDelegate', 'infobarDeclinedByUser', 'infobarDeclinedByDelegate', 'infobarViewSeries', 'noLocationText'];
var stringModule = index_1.registerStringPackage('owa-calendar-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 1812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1813), exports);
//# sourceMappingURL=DatePicker.js.map

/***/ }),

/***/ 1813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1814), exports);
tslib_1.__exportStar(__webpack_require__(1602), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1814:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Calendar_1 = __webpack_require__(1807);
var DateValues_1 = __webpack_require__(361);
var Callout_1 = __webpack_require__(157);
var TextField_1 = __webpack_require__(1741);
var Utilities_1 = __webpack_require__(7);
var DateMath_1 = __webpack_require__(598);
var stylesImport = __webpack_require__(1820);
var styles = stylesImport;
var DEFAULT_STRINGS = {
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    shortMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ],
    shortDays: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    goToToday: 'Go to today',
    prevMonthAriaLabel: 'Go to previous month',
    nextMonthAriaLabel: 'Go to next month',
    prevYearAriaLabel: 'Go to previous year',
    nextYearAriaLabel: 'Go to next year'
};
var DatePicker = /** @class */ (function (_super) {
    tslib_1.__extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this) || this;
        var formatDate = props.formatDate, value = props.value;
        _this.state = {
            selectedDate: value || new Date(),
            formattedDate: (formatDate && value) ? formatDate(value) : '',
            isDatePickerShown: false,
            errorMessage: undefined
        };
        _this._preventFocusOpeningPicker = false;
        return _this;
    }
    DatePicker.prototype.componentWillReceiveProps = function (nextProps) {
        var formatDate = nextProps.formatDate, isRequired = nextProps.isRequired, strings = nextProps.strings, value = nextProps.value, minDate = nextProps.minDate, maxDate = nextProps.maxDate;
        var errorMessage = (isRequired && !value) ? (strings.isRequiredErrorMessage || '*') : undefined;
        if (!errorMessage && value) {
            errorMessage = this._isDateOutOfBounds(value, minDate, maxDate) ? strings.isOutOfBoundsErrorMessage || '*' : undefined;
        }
        // Set error message
        this.setState({
            errorMessage: errorMessage
        });
        // Issue# 1274: Check if the date value changed from old value, i.e., if indeed a new date is being
        // passed in or if the formatting function was modified. We only update the selected date if either of these
        // had a legit change. Note tha the bug will still repro when only the formatDate was passed in props and this
        // is the result of the onSelectDate callback, but this should be a rare scenario.
        var oldValue = this.state.selectedDate;
        if (!DateMath_1.compareDates(oldValue, value) || this.props.formatDate !== formatDate) {
            this.setState({
                selectedDate: value || new Date(),
                formattedDate: (formatDate && value) ? formatDate(value) : '',
            });
        }
    };
    DatePicker.prototype.render = function () {
        var _a = this.props, firstDayOfWeek = _a.firstDayOfWeek, strings = _a.strings, label = _a.label, isRequired = _a.isRequired, disabled = _a.disabled, ariaLabel = _a.ariaLabel, pickerAriaLabel = _a.pickerAriaLabel, placeholder = _a.placeholder, allowTextInput = _a.allowTextInput, borderless = _a.borderless, className = _a.className, minDate = _a.minDate, maxDate = _a.maxDate, calendarProps = _a.calendarProps;
        var _b = this.state, isDatePickerShown = _b.isDatePickerShown, formattedDate = _b.formattedDate, selectedDate = _b.selectedDate, errorMessage = _b.errorMessage;
        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker', styles.root, className), ref: this._resolveRef('_root') },
            React.createElement("div", { ref: this._resolveRef('_datepicker') },
                React.createElement(TextField_1.TextField, { className: styles.textField, ariaLabel: ariaLabel, "aria-haspopup": 'true', "aria-expanded": isDatePickerShown, required: isRequired, disabled: disabled, onKeyDown: this._onTextFieldKeyDown, onFocus: this._onTextFieldFocus, onBlur: this._onTextFieldBlur, onClick: this._onTextFieldClick, onChanged: this._onTextFieldChanged, errorMessage: errorMessage, label: label, placeholder: placeholder, borderless: borderless, iconProps: {
                        iconName: 'Calendar',
                        onClick: this._onIconClick,
                        className: Utilities_1.css(label ? 'ms-DatePicker-event--with-label' : 'ms-DatePicker-event--without-label', label ? styles.eventWithLabel : styles.eventWithoutLabel)
                    }, readOnly: !allowTextInput, value: formattedDate, ref: this._resolveRef('_textField'), role: allowTextInput ? 'combobox' : 'menu' })),
            isDatePickerShown && (React.createElement(Callout_1.Callout, { role: 'dialog', ariaLabel: pickerAriaLabel, isBeakVisible: false, className: Utilities_1.css('ms-DatePicker-callout'), gapSpace: 0, doNotLayer: false, target: this._datepicker, directionalHint: 4 /* bottomLeftEdge */, onDismiss: this._calendarDismissed, onPositioned: this._onCalloutPositioned },
                React.createElement(Calendar_1.Calendar, tslib_1.__assign({}, calendarProps, { onSelectDate: this._onSelectDate, onDismiss: this._calendarDismissed, isMonthPickerVisible: this.props.isMonthPickerVisible, showMonthPickerAsOverlay: this.props.showMonthPickerAsOverlay, today: this.props.today, value: selectedDate, firstDayOfWeek: firstDayOfWeek, strings: strings, highlightCurrentMonth: this.props.highlightCurrentMonth, showWeekNumbers: this.props.showWeekNumbers, firstWeekOfYear: this.props.firstWeekOfYear, showGoToToday: this.props.showGoToToday, dateTimeFormatter: this.props.dateTimeFormatter, minDate: minDate, maxDate: maxDate, ref: this._resolveRef('_calendar') }))))));
    };
    DatePicker.prototype._onSelectDate = function (date) {
        var _a = this.props, formatDate = _a.formatDate, onSelectDate = _a.onSelectDate;
        this.setState({
            selectedDate: date,
            isDatePickerShown: false,
            formattedDate: formatDate && date ? formatDate(date) : '',
        }, function () {
            if (onSelectDate) {
                onSelectDate(date);
            }
        });
    };
    DatePicker.prototype._onCalloutPositioned = function () {
        this._calendar.focus();
    };
    DatePicker.prototype._onTextFieldFocus = function (ev) {
        if (this.props.disableAutoFocus) {
            return;
        }
        if (!this.props.allowTextInput) {
            if (!this._preventFocusOpeningPicker) {
                this._showDatePickerPopup();
            }
            else {
                this._preventFocusOpeningPicker = false;
            }
        }
    };
    DatePicker.prototype._onTextFieldBlur = function (ev) {
        this._validateTextInput();
    };
    DatePicker.prototype._onTextFieldChanged = function (newValue) {
        if (this.props.allowTextInput) {
            if (this.state.isDatePickerShown) {
                this._dismissDatePickerPopup();
            }
            var _a = this.props, isRequired = _a.isRequired, value = _a.value, strings = _a.strings;
            this.setState({
                errorMessage: (isRequired && !value) ? (strings.isRequiredErrorMessage || '*') : undefined,
                formattedDate: newValue
            });
        }
    };
    DatePicker.prototype._onTextFieldKeyDown = function (ev) {
        switch (ev.which) {
            case 13 /* enter */:
                ev.preventDefault();
                ev.stopPropagation();
                if (!this.state.isDatePickerShown) {
                    this._showDatePickerPopup();
                }
                else {
                    // When DatePicker allows input date string directly,
                    // it is expected to hit another enter to close the popup
                    if (this.props.allowTextInput) {
                        this._dismissDatePickerPopup();
                    }
                }
                break;
            case 27 /* escape */:
                this._handleEscKey(ev);
                break;
            default:
                break;
        }
    };
    DatePicker.prototype._onTextFieldClick = function (ev) {
        if (!this.state.isDatePickerShown) {
            this._showDatePickerPopup();
        }
        else {
            if (this.props.allowTextInput) {
                this.setState({
                    isDatePickerShown: false
                });
            }
        }
    };
    DatePicker.prototype._onIconClick = function (ev) {
        ev.stopPropagation();
        this._onTextFieldClick(ev);
    };
    DatePicker.prototype._showDatePickerPopup = function () {
        if (!this.state.isDatePickerShown) {
            this._preventFocusOpeningPicker = true;
            this._focusOnSelectedDateOnUpdate = true;
            this.setState({
                isDatePickerShown: true,
                navigatedDate: this.state.selectedDate,
                errorMessage: ''
            });
        }
    };
    DatePicker.prototype._dismissDatePickerPopup = function () {
        if (this.state.isDatePickerShown) {
            this.setState({
                isDatePickerShown: false
            });
            this._validateTextInput();
        }
    };
    /**
     * Callback for closing the calendar callout
     */
    DatePicker.prototype._calendarDismissed = function () {
        this._preventFocusOpeningPicker = true;
        this._dismissDatePickerPopup();
        if (this._textField) {
            this._textField.focus();
        }
    };
    DatePicker.prototype._handleEscKey = function (ev) {
        this._calendarDismissed();
    };
    DatePicker.prototype._validateTextInput = function () {
        var _a = this.props, isRequired = _a.isRequired, allowTextInput = _a.allowTextInput, strings = _a.strings, parseDateFromString = _a.parseDateFromString, onSelectDate = _a.onSelectDate, formatDate = _a.formatDate, minDate = _a.minDate, maxDate = _a.maxDate;
        var inputValue = this.state.formattedDate;
        // Do validation only if DatePicker's popup is dismissed
        if (this.state.isDatePickerShown) {
            return;
        }
        // Check when DatePicker is a required field but has NO input value
        if (isRequired && !inputValue) {
            this.setState({
                // Since fabic react doesn't have loc support yet
                // use the symbol '*' to represent error message
                errorMessage: strings.isRequiredErrorMessage || '*'
            });
            return;
        }
        if (allowTextInput) {
            var date = null;
            if (inputValue) {
                // Don't parse if the selected date has the same formatted string as what we're about to parse.
                // The formatted string might be ambiguous (ex: "1/2/3" or "New Year Eve") and the parser might
                // not be able to come up with the exact same date.
                if (this.state.selectedDate && formatDate && formatDate(this.state.selectedDate) === inputValue) {
                    date = this.state.selectedDate;
                }
                else {
                    date = parseDateFromString(inputValue);
                    // Check if date is null, or date is Invalid Date
                    if (!date || isNaN(date.getTime())) {
                        // Reset invalid input field, if formatting is available
                        if (formatDate) {
                            date = this.state.selectedDate;
                            this.setState({
                                formattedDate: formatDate(date).toString()
                            });
                        }
                        this.setState({
                            errorMessage: strings.invalidInputErrorMessage || '*'
                        });
                    }
                    else {
                        // Check against optional date boundaries
                        if (this._isDateOutOfBounds(date, minDate, maxDate)) {
                            this.setState({
                                errorMessage: strings.isOutOfBoundsErrorMessage || '*'
                            });
                        }
                        else {
                            this.setState({
                                selectedDate: date,
                                errorMessage: ''
                            });
                            // When formatting is available. If formatted date is valid, but is different from input, update with formatted date
                            // This occurs when an invalid date is entered twice
                            if (formatDate && formatDate(date) !== inputValue) {
                                this.setState({
                                    formattedDate: formatDate(date).toString()
                                });
                            }
                        }
                    }
                }
            }
            else {
                // No input date string shouldn't be an error if field is not required
                this.setState({
                    errorMessage: ''
                });
            }
            // Execute onSelectDate callback
            if (onSelectDate) {
                // If no input date string or input date string is invalid
                // date variable will be null, callback should expect null value for this case
                onSelectDate(date);
            }
        }
    };
    DatePicker.prototype._isDateOutOfBounds = function (date, minDate, maxDate) {
        return ((!!minDate && DateMath_1.compareDatePart(minDate, date) > 0) || (!!maxDate && DateMath_1.compareDatePart(maxDate, date) < 0));
    };
    DatePicker.defaultProps = {
        allowTextInput: false,
        formatDate: function (date) {
            if (date) {
                return date.toDateString();
            }
            return '';
        },
        parseDateFromString: function (dateStr) {
            var date = Date.parse(dateStr);
            if (date) {
                return new Date(date);
            }
            return null;
        },
        firstDayOfWeek: Calendar_1.DayOfWeek.Sunday,
        isRequired: false,
        isMonthPickerVisible: true,
        showMonthPickerAsOverlay: false,
        strings: DEFAULT_STRINGS,
        highlightCurrentMonth: false,
        borderless: false,
        pickerAriaLabel: 'Calender',
        showWeekNumbers: false,
        firstWeekOfYear: DateValues_1.FirstWeekOfYear.FirstDay,
        showGoToToday: true,
        dateTimeFormatter: undefined
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_onSelectDate", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_onCalloutPositioned", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_onTextFieldFocus", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_onTextFieldBlur", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_onTextFieldChanged", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_onTextFieldKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_onTextFieldClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_onIconClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_dismissDatePickerPopup", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_calendarDismissed", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_handleEscKey", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], DatePicker.prototype, "_validateTextInput", null);
    return DatePicker;
}(Utilities_1.BaseComponent));
exports.DatePicker = DatePicker;
//# sourceMappingURL=DatePicker.js.map

/***/ }),

/***/ 1815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1816), exports);
tslib_1.__exportStar(__webpack_require__(1602), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var DateValues_1 = __webpack_require__(361);
var CalendarDay_1 = __webpack_require__(1817);
var CalendarMonth_1 = __webpack_require__(1819);
var DateMath_1 = __webpack_require__(598);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(680);
var styles = stylesImport;
var leftArrow = 'Up';
var rightArrow = 'Down';
var iconStrings = {
    leftNavigation: leftArrow,
    rightNavigation: rightArrow
};
var dateTimeFormatterCallbacks = {
    formatMonthDayYear: function (date, strings) { return (strings.months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear()); },
    formatMonthYear: function (date, strings) { return (strings.months[date.getMonth()] + ' ' + date.getFullYear()); },
    formatDay: function (date) { return date.getDate().toString(); },
    formatYear: function (date) { return date.getFullYear().toString(); }
};
var Calendar = /** @class */ (function (_super) {
    tslib_1.__extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        var currentDate = props.value && !isNaN(props.value.getTime()) ? props.value : (props.today || new Date());
        _this.state = {
            selectedDate: currentDate,
            navigatedDate: currentDate,
            /** When showMonthPickerAsOverlay is active it overrides isMonthPickerVisible/isDayPickerVisible props (These props permanently set the visibility of their respective calendars). */
            isMonthPickerVisible: _this.props.showMonthPickerAsOverlay ? false : _this.props.isMonthPickerVisible,
            isDayPickerVisible: _this.props.showMonthPickerAsOverlay ? true : _this.props.isDayPickerVisible
        };
        _this._focusOnUpdate = false;
        return _this;
    }
    Calendar.prototype.componentWillReceiveProps = function (nextProps) {
        var autoNavigateOnSelection = nextProps.autoNavigateOnSelection, value = nextProps.value, _a = nextProps.today, today = _a === void 0 ? new Date() : _a;
        // Make sure auto-navigation is supported for programmatic changes to selected date, i.e.,
        // if selected date is updated via props, we may need to modify the navigated date
        var overrideNavigatedDate = (autoNavigateOnSelection && !DateMath_1.compareDates(value, this.props.value));
        if (overrideNavigatedDate) {
            this.setState({
                navigatedDate: value
            });
        }
        this.setState({
            selectedDate: value || today
        });
    };
    Calendar.prototype.componentDidUpdate = function () {
        if (this._focusOnUpdate) {
            // if the day picker is shown, focus on it
            if (this.refs.dayPicker) {
                this.refs.dayPicker.focus();
            }
            else if (this.refs.monthPicker) {
                this.refs.monthPicker.focus();
            }
            this._focusOnUpdate = false;
        }
    };
    Calendar.prototype.render = function () {
        var rootClass = 'ms-DatePicker';
        var _a = this.props, firstDayOfWeek = _a.firstDayOfWeek, dateRangeType = _a.dateRangeType, strings = _a.strings, showMonthPickerAsOverlay = _a.showMonthPickerAsOverlay, autoNavigateOnSelection = _a.autoNavigateOnSelection, showGoToToday = _a.showGoToToday, highlightCurrentMonth = _a.highlightCurrentMonth, navigationIcons = _a.navigationIcons, minDate = _a.minDate, maxDate = _a.maxDate;
        var _b = this.state, selectedDate = _b.selectedDate, navigatedDate = _b.navigatedDate, isMonthPickerVisible = _b.isMonthPickerVisible, isDayPickerVisible = _b.isDayPickerVisible;
        var onHeaderSelect = showMonthPickerAsOverlay ? this._onHeaderSelect : undefined;
        var monthPickerOnly = !showMonthPickerAsOverlay && !isDayPickerVisible;
        return (React.createElement("div", { className: Utilities_1.css(rootClass, styles.root), ref: 'root', role: 'application' },
            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-picker ms-DatePicker-picker--opened ms-DatePicker-picker--focused', styles.picker, styles.pickerIsOpened, styles.pickerIsFocused, isMonthPickerVisible && ('ms-DatePicker-monthPickerVisible ' + styles.monthPickerVisible), isMonthPickerVisible && isDayPickerVisible && ('ms-DatePicker-calendarsInline ' + styles.calendarsInline), monthPickerOnly && ('ms-DatePicker-monthPickerOnly ' + styles.monthPickerOnly), showMonthPickerAsOverlay && ('ms-DatePicker-monthPickerAsOverlay ' + styles.monthPickerAsOverlay)) },
                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-holder ms-slideDownIn10', styles.holder), onKeyDown: this._onDatePickerPopupKeyDown },
                    React.createElement("div", { className: Utilities_1.css('ms-DatePicker-frame', styles.frame) },
                        React.createElement("div", { className: Utilities_1.css('ms-DatePicker-wrap', styles.wrap, showGoToToday && styles.goTodaySpacing) },
                            isDayPickerVisible && React.createElement(CalendarDay_1.CalendarDay, { selectedDate: selectedDate, navigatedDate: navigatedDate, today: this.props.today, onSelectDate: this._onSelectDate, onNavigateDate: this._onNavigateDate, onDismiss: this.props.onDismiss, firstDayOfWeek: firstDayOfWeek, dateRangeType: dateRangeType, autoNavigateOnSelection: autoNavigateOnSelection, strings: strings, onHeaderSelect: onHeaderSelect, navigationIcons: navigationIcons, showWeekNumbers: this.props.showWeekNumbers, firstWeekOfYear: this.props.firstWeekOfYear, dateTimeFormatter: this.props.dateTimeFormatter, showSixWeeksByDefault: this.props.showSixWeeksByDefault, minDate: minDate, maxDate: maxDate, ref: 'dayPicker' }),
                            isMonthPickerVisible && React.createElement(CalendarMonth_1.CalendarMonth, { navigatedDate: navigatedDate, strings: strings, onNavigateDate: this._onNavigateDate, today: this.props.today, highlightCurrentMonth: highlightCurrentMonth, onHeaderSelect: onHeaderSelect, navigationIcons: navigationIcons, dateTimeFormatter: this.props.dateTimeFormatter, minDate: minDate, maxDate: maxDate, ref: 'monthPicker' }),
                            showGoToToday &&
                                React.createElement("span", { role: 'button', className: Utilities_1.css('ms-DatePicker-goToday js-goToday', styles.goToday), onClick: this._onGotoToday, onKeyDown: this._onGotoTodayKeyDown, tabIndex: 0 }, strings.goToToday)))))));
    };
    Calendar.prototype.focus = function () {
        if (this.refs.dayPicker) {
            this.refs.dayPicker.focus();
        }
    };
    Calendar.prototype._navigateDay = function (date) {
        this.setState({
            navigatedDate: date
        });
    };
    Calendar.prototype._onNavigateDate = function (date, focusOnNavigatedDay) {
        if (this.props.isDayPickerVisible || (!this.props.isDayPickerVisible && !focusOnNavigatedDay)) {
            this._navigateDay(date);
            this._focusOnUpdate = focusOnNavigatedDay;
        }
        else {
            // if only the month picker is shown, select the chosen month
            this._onSelectDate(date);
        }
    };
    Calendar.prototype._onSelectDate = function (date, selectedDateRangeArray) {
        var onSelectDate = this.props.onSelectDate;
        this.setState({
            selectedDate: date
        });
        if (onSelectDate) {
            onSelectDate(date, selectedDateRangeArray);
        }
    };
    Calendar.prototype._onHeaderSelect = function (focus) {
        this.setState({
            isDayPickerVisible: !this.state.isDayPickerVisible,
            isMonthPickerVisible: !this.state.isMonthPickerVisible
        });
        if (focus) {
            this._focusOnUpdate = true;
        }
    };
    Calendar.prototype._onGotoToday = function () {
        var _a = this.props, dateRangeType = _a.dateRangeType, firstDayOfWeek = _a.firstDayOfWeek, today = _a.today;
        var dates = DateMath_1.getDateRangeArray(today, dateRangeType, firstDayOfWeek);
        this._onSelectDate(today, dates);
    };
    Calendar.prototype._onGotoTodayKeyDown = function (ev) {
        if (ev.which === 13 /* enter */ || ev.which === 32 /* space */) {
            ev.preventDefault();
            this._onGotoToday();
        }
        else if (ev.which === 9 /* tab */ && !ev.shiftKey) {
            if (this.props.onDismiss) {
                ev.stopPropagation();
                ev.preventDefault();
                this.props.onDismiss();
            }
        }
    };
    Calendar.prototype._onDatePickerPopupKeyDown = function (ev) {
        switch (ev.which) {
            case 13 /* enter */:
                ev.preventDefault();
                break;
            case 8 /* backspace */:
                ev.preventDefault();
                break;
            case 27 /* escape */:
                this._handleEscKey(ev);
                break;
            default:
                break;
        }
    };
    Calendar.prototype._handleEscKey = function (ev) {
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    };
    Calendar.defaultProps = {
        onSelectDate: undefined,
        onDismiss: undefined,
        isMonthPickerVisible: true,
        isDayPickerVisible: true,
        showMonthPickerAsOverlay: false,
        value: undefined,
        today: new Date(),
        firstDayOfWeek: DateValues_1.DayOfWeek.Sunday,
        dateRangeType: DateValues_1.DateRangeType.Day,
        autoNavigateOnSelection: false,
        showGoToToday: true,
        strings: null,
        highlightCurrentMonth: false,
        navigationIcons: iconStrings,
        showWeekNumbers: false,
        firstWeekOfYear: DateValues_1.FirstWeekOfYear.FirstDay,
        dateTimeFormatter: dateTimeFormatterCallbacks,
        showSixWeeksByDefault: false,
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Calendar.prototype, "_navigateDay", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Calendar.prototype, "_onNavigateDate", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Calendar.prototype, "_onSelectDate", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Calendar.prototype, "_onHeaderSelect", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Calendar.prototype, "_onGotoToday", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Calendar.prototype, "_onGotoTodayKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Calendar.prototype, "_onDatePickerPopupKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Calendar.prototype, "_handleEscKey", null);
    return Calendar;
}(Utilities_1.BaseComponent));
exports.Calendar = Calendar;
//# sourceMappingURL=Calendar.js.map

/***/ }),

/***/ 1817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var DateValues_1 = __webpack_require__(361);
var FocusZone_1 = __webpack_require__(78);
var Icon_1 = __webpack_require__(43);
var DateMath_1 = __webpack_require__(598);
var stylesImport = __webpack_require__(680);
var styles = stylesImport;
var DAYS_IN_WEEK = 7;
var CalendarDay = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarDay, _super);
    function CalendarDay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeDescendantId: Utilities_1.getId('DatePickerDay-active'),
            weeks: _this._getWeeks(props)
        };
        _this._onSelectNextMonth = _this._onSelectNextMonth.bind(_this);
        _this._onSelectPrevMonth = _this._onSelectPrevMonth.bind(_this);
        return _this;
    }
    CalendarDay.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            weeks: this._getWeeks(nextProps)
        });
    };
    CalendarDay.prototype.render = function () {
        var _this = this;
        var _a = this.state, activeDescendantId = _a.activeDescendantId, weeks = _a.weeks;
        var _b = this.props, firstDayOfWeek = _b.firstDayOfWeek, strings = _b.strings, navigatedDate = _b.navigatedDate, selectedDate = _b.selectedDate, dateRangeType = _b.dateRangeType, navigationIcons = _b.navigationIcons, showWeekNumbers = _b.showWeekNumbers, firstWeekOfYear = _b.firstWeekOfYear, dateTimeFormatter = _b.dateTimeFormatter, minDate = _b.minDate, maxDate = _b.maxDate;
        var dayPickerId = Utilities_1.getId('DatePickerDay-dayPicker');
        var monthAndYearId = Utilities_1.getId('DatePickerDay-monthAndYear');
        var leftNavigationIcon = navigationIcons.leftNavigation;
        var rightNavigationIcon = navigationIcons.rightNavigation;
        var weekNumbers = showWeekNumbers ? DateMath_1.getWeekNumbersInMonth(weeks.length, firstDayOfWeek, firstWeekOfYear, navigatedDate) : null;
        var selectedDateWeekNumber = showWeekNumbers ? DateMath_1.getWeekNumber(selectedDate, firstDayOfWeek, firstWeekOfYear) : undefined;
        // When the month is highlighted get the corner dates so that styles can be added to them
        var weekCorners = {};
        if (dateRangeType === DateValues_1.DateRangeType.Month && selectedDate.getMonth() === navigatedDate.getMonth() && selectedDate.getFullYear() === navigatedDate.getFullYear()) {
            // navigatedDate is on the current month and current year
            weekCorners = this._getWeekCornerStyles(weeks);
        }
        // determine if previous/next months are in bounds
        var prevMonthInBounds = minDate ? DateMath_1.compareDatePart(minDate, DateMath_1.getMonthStart(navigatedDate)) < 0 : true;
        var nextMonthInBounds = maxDate ? DateMath_1.compareDatePart(DateMath_1.getMonthEnd(navigatedDate), maxDate) < 0 : true;
        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-dayPicker', styles.dayPicker, showWeekNumbers && 'ms-DatePicker-showWeekNumbers' && styles.showWeekNumbers), id: dayPickerId },
            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-monthComponents', styles.monthComponents) },
                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-navContainer', styles.navContainer) },
                    React.createElement("span", { className: Utilities_1.css('ms-DatePicker-prevMonth js-prevMonth', styles.prevMonth, (_c = {},
                            _c['ms-DatePicker-prevMonth--disabled ' + styles.prevMonthIsDisabled] = !prevMonthInBounds,
                            _c)), onClick: this._onSelectPrevMonth, onKeyDown: this._onPrevMonthKeyDown, "aria-controls": dayPickerId, "aria-label": strings.prevMonthAriaLabel ? strings.prevMonthAriaLabel + ' ' + strings.months[DateMath_1.addMonths(navigatedDate, -1).getMonth()] : undefined, role: 'button', tabIndex: 0 },
                        React.createElement(Icon_1.Icon, { iconName: Utilities_1.getRTL() ? rightNavigationIcon : leftNavigationIcon })),
                    React.createElement("span", { className: Utilities_1.css('ms-DatePicker-nextMonth js-nextMonth', styles.nextMonth, (_d = {},
                            _d['ms-DatePicker-nextMonth--disabled ' + styles.nextMonthIsDisabled] = !nextMonthInBounds,
                            _d)), onClick: this._onSelectNextMonth, onKeyDown: this._onNextMonthKeyDown, "aria-controls": dayPickerId, "aria-label": strings.nextMonthAriaLabel ? strings.nextMonthAriaLabel + ' ' + strings.months[DateMath_1.addMonths(navigatedDate, 1).getMonth()] : undefined, role: 'button', tabIndex: 0 },
                        React.createElement(Icon_1.Icon, { iconName: Utilities_1.getRTL() ? leftNavigationIcon : rightNavigationIcon })))),
            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-header', styles.header) },
                React.createElement("div", { "aria-live": 'polite', "aria-relevant": 'text', "aria-atomic": 'true', id: monthAndYearId }, this.props.onHeaderSelect ?
                    React.createElement("div", { className: Utilities_1.css('ms-DatePicker-monthAndYear js-showMonthPicker', styles.monthAndYear, styles.headerToggleView), onClick: this._onHeaderSelect, onKeyDown: this._onHeaderKeyDown, "aria-label": dateTimeFormatter.formatMonthYear(navigatedDate, strings), role: 'button', tabIndex: 0 }, dateTimeFormatter.formatMonthYear(navigatedDate, strings))
                    :
                        React.createElement("div", { className: Utilities_1.css('ms-DatePicker-monthAndYear', styles.monthAndYear) }, dateTimeFormatter.formatMonthYear(navigatedDate, strings)))),
            React.createElement(FocusZone_1.FocusZone, null,
                showWeekNumbers ?
                    React.createElement("table", { className: Utilities_1.css('ms-DatePicker-weekNumbers', styles.weekNumbers, 'ms-DatePicker-table', styles.table) },
                        React.createElement("tbody", null, weekNumbers.map(function (weekNumber, index) {
                            return React.createElement("tr", { key: index },
                                React.createElement("td", null,
                                    React.createElement("div", { className: Utilities_1.css('ms-DatePicker-day', styles.day, (_a = {},
                                            _a['ms-DatePicker-week--highlighted ' + styles.weekIsHighlighted] = selectedDateWeekNumber === weekNumber,
                                            _a)) },
                                        React.createElement("span", null, weekNumber))));
                            var _a;
                        })))
                    : null,
                React.createElement("table", { className: Utilities_1.css('ms-DatePicker-table', styles.table), "aria-readonly": 'true', "aria-multiselectable": 'false', "aria-labelledby": monthAndYearId, "aria-activedescendant": activeDescendantId },
                    React.createElement("thead", null,
                        React.createElement("tr", null, strings.shortDays.map(function (val, index) {
                            return React.createElement("th", { className: Utilities_1.css('ms-DatePicker-weekday', styles.weekday), role: 'grid', scope: 'col', key: index, title: strings.days[(index + firstDayOfWeek) % DAYS_IN_WEEK], "aria-label": strings.days[(index + firstDayOfWeek) % DAYS_IN_WEEK] }, strings.shortDays[(index + firstDayOfWeek) % DAYS_IN_WEEK]);
                        }))),
                    React.createElement("tbody", null, weeks.map(function (week, weekIndex) {
                        return React.createElement("tr", { key: weekIndex, role: 'row' }, week.map(function (day, dayIndex) {
                            var isNavigatedDate = DateMath_1.compareDates(navigatedDate, day.originalDate);
                            return React.createElement("td", { key: day.key, className: Utilities_1.css((_a = {},
                                    _a['ms-DatePicker-weekBackground ' + styles.weekBackground] = day.isSelected && dateRangeType === DateValues_1.DateRangeType.Week,
                                    _a['ms-DatePicker-monthBackground ' + styles.monthBackground + ' ' + _this._getHighlightedCornerStyle(weekCorners, dayIndex, weekIndex)] = day.isInMonth && day.isSelected && dateRangeType === DateValues_1.DateRangeType.Month,
                                    _a['ms-DatePicker-dayBackground ' + styles.dayBackground] = day.isSelected && dateRangeType === DateValues_1.DateRangeType.Day,
                                    _a)) },
                                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-day', styles.day, (_b = {},
                                        _b['ms-DatePicker-day--disabled ' + styles.dayIsDisabled] = !day.isInBounds,
                                        _b['ms-DatePicker-day--infocus ' + styles.dayIsFocused] = day.isInBounds && day.isInMonth,
                                        _b['ms-DatePicker-day--outfocus ' + styles.dayIsUnfocused] = day.isInBounds && !day.isInMonth,
                                        _b['ms-DatePicker-day--today ' + styles.dayIsToday] = day.isToday,
                                        _b['ms-DatePicker-day--highlighted ' + styles.dayIsHighlighted] = day.isSelected && dateRangeType === DateValues_1.DateRangeType.Day,
                                        _b)), role: 'gridcell', onClick: day.isInBounds ? day.onSelected : undefined, onKeyDown: _this._onDayKeyDown(day.originalDate, weekIndex, dayIndex), "aria-label": dateTimeFormatter.formatMonthDayYear(day.originalDate, strings), id: isNavigatedDate ? activeDescendantId : undefined, "aria-selected": day.isInBounds ? day.isSelected : undefined, "data-is-focusable": day.isInBounds ? true : undefined, ref: isNavigatedDate ? 'navigatedDay' : undefined, key: isNavigatedDate ? 'navigatedDay' : undefined },
                                    React.createElement("span", { "aria-hidden": 'true' }, dateTimeFormatter.formatDay(day.originalDate))));
                            var _a, _b;
                        }));
                    }))))));
        var _c, _d;
    };
    CalendarDay.prototype.focus = function () {
        if (this.refs.navigatedDay) {
            this.refs.navigatedDay.tabIndex = 0;
            this.refs.navigatedDay.focus();
        }
    };
    CalendarDay.prototype._findCornerIndexes = function (week) {
        var cornerIndexes = [];
        for (var i = 0, length_1 = week.length; i < length_1; i++) {
            var day = week[i];
            if (day.isInMonth) {
                cornerIndexes.push(i);
            }
        }
        if (cornerIndexes.length > 2) {
            cornerIndexes.splice(1, cornerIndexes.length - 2);
        }
        return cornerIndexes;
    };
    CalendarDay.prototype._populateCornerStyles = function (weekCornersStyled, weekIndex, cornerIndexes, singleCornerStyle, leftCornerStyle, rightCornerStyle) {
        var cornersLength = cornerIndexes.length;
        if (cornersLength > 0) {
            if (cornersLength === 1) {
                weekCornersStyled[weekIndex + '_' + cornerIndexes[0]] = singleCornerStyle;
            }
            else if (cornersLength === 2) {
                weekCornersStyled[weekIndex + '_' + cornerIndexes[0]] = leftCornerStyle;
                weekCornersStyled[weekIndex + '_' + cornerIndexes[1]] = rightCornerStyle;
            }
            if (weekIndex === 0) {
                // check if second week needs corner styles
                if (cornerIndexes[0] !== 0) {
                    weekCornersStyled['1_0'] = leftCornerStyle;
                }
            }
            else {
                // Assume we are on the last week. Check if second-to-last week needs corner styles
                var lastDayIndex = DAYS_IN_WEEK - 1;
                if (cornerIndexes[cornersLength - 1] !== lastDayIndex) {
                    weekCornersStyled[(weekIndex - 1) + '_' + lastDayIndex] = rightCornerStyle;
                }
            }
        }
    };
    CalendarDay.prototype._getWeekCornerStyles = function (weeks) {
        var weekCornersStyled = {};
        var numberOfWeeks = weeks.length;
        var indexesFirstWeek = this._findCornerIndexes(weeks[0]);
        var indexesLastWeek = this._findCornerIndexes(weeks[numberOfWeeks - 1]);
        this._populateCornerStyles(weekCornersStyled, 0 /* week index */, indexesFirstWeek, 'ms-DatePicker-singleTopDate ' + styles.singleTopDate, 'ms-DatePicker-topLeftCornerDate ' + styles.topLeftCornerDate, 'ms-DatePicker-topRightCornerDate ' + styles.topRightCornerDate);
        this._populateCornerStyles(weekCornersStyled, weeks.length - 1 /* week index */, indexesLastWeek, 'ms-DatePicker-singleBottomDate ' + styles.singleBottomDate, 'ms-DatePicker-bottomLeftCornerDate ' + styles.bottomLeftCornerDate, 'ms-DatePicker-bottomRightCornerDate ' + styles.bottomRightCornerDate);
        return weekCornersStyled;
    };
    CalendarDay.prototype._getHighlightedCornerStyle = function (weekCorners, dayIndex, weekIndex) {
        var cornerStyle = weekCorners[weekIndex + '_' + dayIndex] ? weekCorners[weekIndex + '_' + dayIndex] : '';
        return cornerStyle;
    };
    CalendarDay.prototype._navigateMonthEdge = function (ev, date, weekIndex, dayIndex) {
        var _a = this.props, minDate = _a.minDate, maxDate = _a.maxDate;
        var targetDate = undefined;
        if (weekIndex === 0 && ev.which === 38 /* up */) {
            targetDate = DateMath_1.addWeeks(date, -1);
        }
        else if (weekIndex === (this.state.weeks.length - 1) && ev.which === 40 /* down */) {
            targetDate = DateMath_1.addWeeks(date, 1);
        }
        else if (dayIndex === 0 && ev.which === Utilities_1.getRTLSafeKeyCode(37 /* left */)) {
            targetDate = DateMath_1.addDays(date, -1);
        }
        else if (dayIndex === (DAYS_IN_WEEK - 1) && ev.which === Utilities_1.getRTLSafeKeyCode(39 /* right */)) {
            targetDate = DateMath_1.addDays(date, 1);
        }
        // Don't navigate to out-of-bounds date
        if (targetDate && (minDate ? DateMath_1.compareDatePart(minDate, targetDate) < 1 : true) && (maxDate ? DateMath_1.compareDatePart(targetDate, maxDate) < 1 : true)) {
            this.props.onNavigateDate(targetDate, true);
            ev.preventDefault();
        }
    };
    CalendarDay.prototype._onKeyDown = function (callback, ev) {
        if (ev.which === 13 /* enter */ || ev.which === 32 /* space */) {
            callback();
        }
    };
    CalendarDay.prototype._onDayKeyDown = function (originalDate, weekIndex, dayIndex) {
        var _this = this;
        return function (ev) {
            _this._navigateMonthEdge(ev, originalDate, weekIndex, dayIndex);
        };
    };
    CalendarDay.prototype._onSelectDate = function (selectedDate) {
        var _a = this.props, onSelectDate = _a.onSelectDate, dateRangeType = _a.dateRangeType, firstDayOfWeek = _a.firstDayOfWeek, navigatedDate = _a.navigatedDate, autoNavigateOnSelection = _a.autoNavigateOnSelection, minDate = _a.minDate, maxDate = _a.maxDate;
        var dateRange = DateMath_1.getDateRangeArray(selectedDate, dateRangeType, firstDayOfWeek);
        if (dateRangeType !== DateValues_1.DateRangeType.Day) {
            dateRange = this._getBoundedDateRange(dateRange, minDate, maxDate);
        }
        if (onSelectDate) {
            onSelectDate(selectedDate, dateRange);
        }
        // Navigate to next or previous month if needed
        if (autoNavigateOnSelection && selectedDate.getMonth() !== navigatedDate.getMonth()) {
            var compareResult = DateMath_1.compareDatePart(selectedDate, navigatedDate);
            if (compareResult < 0) {
                this._onSelectPrevMonth();
            }
            else if (compareResult > 0) {
                this._onSelectNextMonth();
            }
        }
    };
    CalendarDay.prototype._onSelectNextMonth = function () {
        this.props.onNavigateDate(DateMath_1.addMonths(this.props.navigatedDate, 1), false);
    };
    CalendarDay.prototype._onSelectPrevMonth = function () {
        this.props.onNavigateDate(DateMath_1.addMonths(this.props.navigatedDate, -1), false);
    };
    CalendarDay.prototype._onHeaderSelect = function () {
        var onHeaderSelect = this.props.onHeaderSelect;
        if (onHeaderSelect) {
            onHeaderSelect(true);
        }
    };
    CalendarDay.prototype._onHeaderKeyDown = function (ev) {
        var onHeaderSelect = this.props.onHeaderSelect;
        if (onHeaderSelect && (ev.which === 13 /* enter */ || ev.which === 32 /* space */)) {
            onHeaderSelect(true);
        }
    };
    CalendarDay.prototype._onPrevMonthKeyDown = function (ev) {
        this._onKeyDown(this._onSelectPrevMonth, ev);
    };
    CalendarDay.prototype._onNextMonthKeyDown = function (ev) {
        this._onKeyDown(this._onSelectNextMonth, ev);
    };
    CalendarDay.prototype._getWeeks = function (propsToUse) {
        var navigatedDate = propsToUse.navigatedDate, selectedDate = propsToUse.selectedDate, dateRangeType = propsToUse.dateRangeType, firstDayOfWeek = propsToUse.firstDayOfWeek, today = propsToUse.today, minDate = propsToUse.minDate, maxDate = propsToUse.maxDate, showSixWeeksByDefault = propsToUse.showSixWeeksByDefault;
        var date = new Date(navigatedDate.getFullYear(), navigatedDate.getMonth(), 1);
        var todaysDate = today || new Date();
        var weeks = [];
        // Cycle the date backwards to get to the first day of the week.
        while (date.getDay() !== firstDayOfWeek) {
            date.setDate(date.getDate() - 1);
        }
        // a flag to indicate whether all days of the week are in the month
        var isAllDaysOfWeekOutOfMonth = false;
        var selectedDates = DateMath_1.getDateRangeArray(selectedDate, dateRangeType, firstDayOfWeek);
        if (dateRangeType !== DateValues_1.DateRangeType.Day) {
            selectedDates = this._getBoundedDateRange(selectedDates, minDate, maxDate);
        }
        var shouldGetWeeks = true;
        for (var weekIndex = 0; shouldGetWeeks; weekIndex++) {
            var week = [];
            isAllDaysOfWeekOutOfMonth = true;
            for (var dayIndex = 0; dayIndex < DAYS_IN_WEEK; dayIndex++) {
                var originalDate = new Date(date.toString());
                var dayInfo = {
                    key: date.toString(),
                    date: date.getDate().toString(),
                    originalDate: originalDate,
                    isInMonth: date.getMonth() === navigatedDate.getMonth(),
                    isToday: DateMath_1.compareDates(todaysDate, date),
                    isSelected: DateMath_1.isInDateRangeArray(date, selectedDates),
                    onSelected: this._onSelectDate.bind(this, originalDate),
                    isInBounds: (minDate ? DateMath_1.compareDatePart(minDate, date) < 1 : true) && (maxDate ? DateMath_1.compareDatePart(date, maxDate) < 1 : true)
                };
                week.push(dayInfo);
                if (dayInfo.isInMonth) {
                    isAllDaysOfWeekOutOfMonth = false;
                }
                date.setDate(date.getDate() + 1);
            }
            // We append the condition of the loop depending upon the showSixWeeksByDefault prop.
            shouldGetWeeks = showSixWeeksByDefault ? (!isAllDaysOfWeekOutOfMonth || weekIndex <= 5) : !isAllDaysOfWeekOutOfMonth;
            if (shouldGetWeeks) {
                weeks.push(week);
            }
        }
        return weeks;
    };
    CalendarDay.prototype._getBoundedDateRange = function (dateRange, minDate, maxDate) {
        var boundedDateRange = dateRange.slice();
        if (minDate) {
            boundedDateRange = boundedDateRange.filter(function (date) { return DateMath_1.compareDatePart(date, minDate) >= 0; });
        }
        if (maxDate) {
            boundedDateRange = boundedDateRange.filter(function (date) { return DateMath_1.compareDatePart(date, maxDate) <= 0; });
        }
        return boundedDateRange;
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onDayKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onSelectDate", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onSelectNextMonth", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onSelectPrevMonth", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onHeaderSelect", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onHeaderKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onPrevMonthKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarDay.prototype, "_onNextMonthKeyDown", null);
    return CalendarDay;
}(Utilities_1.BaseComponent));
exports.CalendarDay = CalendarDay;
//# sourceMappingURL=CalendarDay.js.map

/***/ }),

/***/ 1818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Common constants and methods
 */
var TimeConstants = {
    MillisecondsInOneDay: 86400000,
    MillisecondsIn1Sec: 1000,
    MillisecondsIn1Min: 60000,
    MillisecondsIn30Mins: 1800000,
    MillisecondsIn1Hour: 3600000,
    MinutesInOneDay: 1440,
    MinutesInOneHour: 60,
    DaysInOneWeek: 7,
    MonthInOneYear: 12
};
exports.default = TimeConstants;
//# sourceMappingURL=TimeConstants.js.map

/***/ }),

/***/ 1819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var FocusZone_1 = __webpack_require__(78);
var DateMath_1 = __webpack_require__(598);
var Icon_1 = __webpack_require__(43);
var stylesImport = __webpack_require__(680);
var styles = stylesImport;
var CalendarMonth = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarMonth, _super);
    function CalendarMonth(props) {
        var _this = _super.call(this, props) || this;
        _this._selectMonthCallbacks = [];
        props.strings.shortMonths.map(function (month, index) {
            _this._selectMonthCallbacks[index] = _this._onSelectMonth.bind(_this, index);
        });
        _this._isCurrentMonth = _this._isCurrentMonth.bind(_this);
        _this._onSelectNextYear = _this._onSelectNextYear.bind(_this);
        _this._onSelectPrevYear = _this._onSelectPrevYear.bind(_this);
        _this._onSelectMonth = _this._onSelectMonth.bind(_this);
        return _this;
    }
    CalendarMonth.prototype.render = function () {
        var _this = this;
        var _a = this.props, navigatedDate = _a.navigatedDate, strings = _a.strings, today = _a.today, highlightCurrentMonth = _a.highlightCurrentMonth, navigationIcons = _a.navigationIcons, dateTimeFormatter = _a.dateTimeFormatter, minDate = _a.minDate, maxDate = _a.maxDate;
        var leftNavigationIcon = navigationIcons.leftNavigation;
        var rightNavigationIcon = navigationIcons.rightNavigation;
        // determine if previous/next years are in bounds
        var isPrevYearInBounds = minDate ? DateMath_1.compareDatePart(minDate, DateMath_1.getYearStart(navigatedDate)) < 0 : true;
        var isNextYearInBounds = maxDate ? DateMath_1.compareDatePart(DateMath_1.getYearEnd(navigatedDate), maxDate) < 0 : true;
        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-monthPicker', styles.monthPicker) },
            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-yearComponents', styles.yearComponents) },
                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-navContainer', styles.navContainer) },
                    React.createElement("span", { className: Utilities_1.css('ms-DatePicker-prevYear js-prevYear', styles.prevYear, (_b = {},
                            _b['ms-DatePicker-prevYear--disabled ' + styles.prevYearIsDisabled] = !isPrevYearInBounds,
                            _b)), onClick: this._onSelectPrevYear, onKeyDown: this._onSelectPrevYearKeyDown, "aria-label": strings.prevYearAriaLabel ? strings.prevYearAriaLabel + ' ' + dateTimeFormatter.formatYear(DateMath_1.addYears(navigatedDate, -1)) : undefined, role: 'button', tabIndex: 0 },
                        React.createElement(Icon_1.Icon, { iconName: Utilities_1.getRTL() ? rightNavigationIcon : leftNavigationIcon })),
                    React.createElement("span", { className: Utilities_1.css('ms-DatePicker-nextYear js-nextYear', styles.nextYear, (_c = {},
                            _c['ms-DatePicker-nextYear--disabled ' + styles.nextYearIsDisabled] = !isNextYearInBounds,
                            _c)), onClick: this._onSelectNextYear, onKeyDown: this._onSelectNextYearKeyDown, "aria-label": strings.nextYearAriaLabel ? strings.nextYearAriaLabel + ' ' + dateTimeFormatter.formatYear(DateMath_1.addYears(navigatedDate, 1)) : undefined, role: 'button', tabIndex: 0 },
                        React.createElement(Icon_1.Icon, { iconName: Utilities_1.getRTL() ? leftNavigationIcon : rightNavigationIcon })))),
            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-header', styles.header) }, this.props.onHeaderSelect ?
                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-currentYear js-showYearPicker', styles.currentYear, styles.headerToggleView), onClick: this._onHeaderSelect, onKeyDown: this._onHeaderKeyDown, "aria-label": dateTimeFormatter.formatYear(navigatedDate), role: 'button', tabIndex: 0 }, dateTimeFormatter.formatYear(navigatedDate))
                :
                    React.createElement("div", { className: Utilities_1.css('ms-DatePicker-currentYear js-showYearPicker', styles.currentYear) }, dateTimeFormatter.formatYear(navigatedDate))),
            React.createElement(FocusZone_1.FocusZone, null,
                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-optionGrid', styles.optionGrid), role: 'grid' }, strings.shortMonths.map(function (month, index) {
                    var indexedMonth = DateMath_1.setMonth(navigatedDate, index);
                    var isCurrentMonth = _this._isCurrentMonth(index, navigatedDate.getFullYear(), today);
                    var isNavigatedMonth = navigatedDate.getMonth() === index;
                    var isInBounds = (minDate ? DateMath_1.compareDatePart(minDate, DateMath_1.getMonthEnd(indexedMonth)) < 1 : true) &&
                        (maxDate ? DateMath_1.compareDatePart(DateMath_1.getMonthStart(indexedMonth), maxDate) < 1 : true);
                    return React.createElement("span", { role: 'gridcell', className: Utilities_1.css('ms-DatePicker-monthOption', styles.monthOption, (_a = {},
                            _a['ms-DatePicker-day--today ' + styles.monthIsCurrentMonth] = highlightCurrentMonth && isCurrentMonth,
                            _a['ms-DatePicker-day--highlighted ' + styles.monthIsHighlighted] = highlightCurrentMonth && isNavigatedMonth,
                            _a['ms-DatePicker-monthOption--disabled ' + styles.monthOptionIsDisabled] = !isInBounds,
                            _a)), key: index, onClick: isInBounds ? _this._selectMonthCallbacks[index] : undefined, "aria-label": dateTimeFormatter.formatMonthYear(indexedMonth, strings), "aria-selected": isCurrentMonth || isNavigatedMonth, "data-is-focusable": isInBounds ? true : undefined, ref: isNavigatedMonth ? 'navigatedMonth' : undefined }, month);
                    var _a;
                })))));
        var _b, _c;
    };
    CalendarMonth.prototype.focus = function () {
        if (this.refs.navigatedMonth) {
            this.refs.navigatedMonth.tabIndex = 0;
            this.refs.navigatedMonth.focus();
        }
    };
    CalendarMonth.prototype._isCurrentMonth = function (month, year, today) {
        return today.getFullYear() === year && today.getMonth() === month;
    };
    CalendarMonth.prototype._onKeyDown = function (callback, ev) {
        if (ev.which === 13 /* enter */ || ev.which === 32 /* space */) {
            callback();
        }
    };
    CalendarMonth.prototype._onSelectNextYear = function () {
        var _a = this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate;
        onNavigateDate(DateMath_1.addYears(navigatedDate, 1), false);
    };
    CalendarMonth.prototype._onSelectNextYearKeyDown = function (ev) {
        this._onKeyDown(this._onSelectNextYear, ev);
    };
    CalendarMonth.prototype._onSelectPrevYear = function () {
        var _a = this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate;
        onNavigateDate(DateMath_1.addYears(navigatedDate, -1), false);
    };
    CalendarMonth.prototype._onSelectPrevYearKeyDown = function (ev) {
        this._onKeyDown(this._onSelectPrevYear, ev);
    };
    CalendarMonth.prototype._onSelectMonth = function (newMonth) {
        var _a = this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate, onHeaderSelect = _a.onHeaderSelect;
        // If header is clickable the calendars are overlayed, switch back to day picker when month is clicked
        if (onHeaderSelect) {
            onHeaderSelect(true);
        }
        onNavigateDate(DateMath_1.setMonth(navigatedDate, newMonth), true);
    };
    CalendarMonth.prototype._onHeaderSelect = function () {
        var onHeaderSelect = this.props.onHeaderSelect;
        if (onHeaderSelect) {
            onHeaderSelect(true);
        }
    };
    CalendarMonth.prototype._onHeaderKeyDown = function (ev) {
        var onHeaderSelect = this.props.onHeaderSelect;
        if (onHeaderSelect && (ev.which === 13 /* enter */ || ev.which === 32 /* space */)) {
            onHeaderSelect(true);
        }
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarMonth.prototype, "_onKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarMonth.prototype, "_onSelectNextYear", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarMonth.prototype, "_onSelectNextYearKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarMonth.prototype, "_onSelectPrevYear", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarMonth.prototype, "_onSelectPrevYearKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarMonth.prototype, "_onSelectMonth", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarMonth.prototype, "_onHeaderSelect", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], CalendarMonth.prototype, "_onHeaderKeyDown", null);
    return CalendarMonth;
}(Utilities_1.BaseComponent));
exports.CalendarMonth = CalendarMonth;
//# sourceMappingURL=CalendarMonth.js.map

/***/ }),

/***/ 1820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_0d3725cb{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0}.textField_0d3725cb{position:relative}.textField_0d3725cb input::-ms-clear{display:none}.textField_0d3725cb input[readonly]{cursor:pointer}.eventWithLabel_0d3725cb{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";font-size:16px;line-height:18px;pointer-events:none;position:absolute;pointer-events:initial;cursor:pointer;bottom:5px}[dir='ltr'] .eventWithLabel_0d3725cb{right:9px}[dir='rtl'] .eventWithLabel_0d3725cb{left:9px}.eventWithoutLabel_0d3725cb{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";font-size:16px;line-height:18px;pointer-events:none;position:absolute;top:7px}[dir='ltr'] .eventWithoutLabel_0d3725cb{right:9px}[dir='rtl'] .eventWithoutLabel_0d3725cb{left:9px}\n" }]);
exports.root = "root_0d3725cb";
exports.textField = "textField_0d3725cb";
exports.eventWithLabel = "eventWithLabel_0d3725cb";
exports.eventWithoutLabel = "eventWithoutLabel_0d3725cb";
//# sourceMappingURL=DatePicker.scss.js.map

/***/ }),

/***/ 1824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubCategoryState;
(function (SubCategoryState) {
    SubCategoryState[SubCategoryState["Loading"] = 0] = "Loading";
    SubCategoryState[SubCategoryState["Loaded"] = 1] = "Loaded";
    SubCategoryState[SubCategoryState["Error"] = 2] = "Error";
})(SubCategoryState || (SubCategoryState = {}));
exports.default = SubCategoryState;
//# sourceMappingURL=SubCategoryState.js.map

/***/ }),

/***/ 1825:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Enum to order the settings shown within the quick settings pane.
 * Each setting that is shown in the quick settings pane should have a unique entry
 * in the enum, and in the order to be shown in the quick settings pane.
 */
var QuickSettingOrder;
(function (QuickSettingOrder) {
    // All workloads
    QuickSettingOrder[QuickSettingOrder["Theme"] = 0] = "Theme";
    // Mail workload
    QuickSettingOrder[QuickSettingOrder["Conversations"] = 1] = "Conversations";
    QuickSettingOrder[QuickSettingOrder["ReadingPane"] = 2] = "ReadingPane";
    QuickSettingOrder[QuickSettingOrder["Focused"] = 3] = "Focused";
    QuickSettingOrder[QuickSettingOrder["SenderImage"] = 4] = "SenderImage";
    QuickSettingOrder[QuickSettingOrder["DateHeaders"] = 5] = "DateHeaders";
    QuickSettingOrder[QuickSettingOrder["InlinePreview"] = 6] = "InlinePreview";
    QuickSettingOrder[QuickSettingOrder["PreviewText"] = 7] = "PreviewText";
})(QuickSettingOrder || (QuickSettingOrder = {}));
exports.default = QuickSettingOrder;
//# sourceMappingURL=QuickSettingOrder.js.map

/***/ }),

/***/ 1826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = __webpack_require__(116);
var userConfigurationDictionaryObject_1 = __webpack_require__(117);
var updateUserConfiguration_1 = __webpack_require__(153);
function updateUserConfiguration(settingUpdates, configurationName) {
    if (configurationName === void 0) { configurationName = 'OWA.UserOptions'; }
    return updateUserConfiguration_1.default(configurationName, settingUpdates.map(function (update) {
        return userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: [update.propertyName],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: update.propertyType,
                Value: Array.isArray(update.propertyValue)
                    ? update.propertyValue
                    : [update.propertyValue],
            }),
        });
    }));
}
exports.default = updateUserConfiguration;
//# sourceMappingURL=updateUserConfiguration.js.map

/***/ }),

/***/ 1827:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mailboxMessageConfigurationOptions_1 = __webpack_require__(1828);
var setMailboxMessageConfigurationRequest_1 = __webpack_require__(1607);
var setMailboxMessageConfigurationOperation_1 = __webpack_require__(1829);
var ServiceRequestUtils_1 = __webpack_require__(31);
function setMailboxMessageConfiguration(newOptions) {
    return setMailboxMessageConfigurationOperation_1.default(setMailboxMessageConfigurationRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Options: mailboxMessageConfigurationOptions_1.default(newOptions),
    }));
}
exports.default = setMailboxMessageConfiguration;
//# sourceMappingURL=setMailboxMessageConfiguration.js.map

/***/ }),

/***/ 1828:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function mailboxMessageConfigurationOptions(data) {
    var result = tslib_1.__assign({ __type: 'MailboxMessageConfigurationOptions:#Exchange' }, data);
    return result;
}
exports.default = mailboxMessageConfigurationOptions;


/***/ }),

/***/ 1829:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var setMailboxMessageConfigurationRequest_1 = __webpack_require__(1607);
function setMailboxMessageConfigurationOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = setMailboxMessageConfigurationRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("SetMailboxMessageConfiguration", req, options);
}
exports.default = setMailboxMessageConfigurationOperation;


/***/ }),

/***/ 1830:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getFallbackValueIfNull(value, fallback) {
    return value === null ? fallback : value;
}
exports.default = getFallbackValueIfNull;
//# sourceMappingURL=getFallbackValueIfNull.js.map

/***/ }),

/***/ 1831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var owa_session_store_1 = __webpack_require__(151);
var assign = __webpack_require__(26);
exports.default = satcheljs_1.mutatorAction('updateSessionSettings', function updateSessionSettings(newSessionSettings) {
    assign(owa_session_store_1.getUserConfiguration().SessionSettings, newSessionSettings);
});
//# sourceMappingURL=updateSessionSettings.js.map

/***/ }),

/***/ 1832:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var owa_session_store_1 = __webpack_require__(151);
var assign = __webpack_require__(26);
exports.default = satcheljs_1.mutatorAction('updateUserOptions', function updateUserOptions(newUserOptions) {
    assign(owa_session_store_1.getUserConfiguration().UserOptions, newUserOptions);
});
//# sourceMappingURL=updateUserOptions.js.map

/***/ }),

/***/ 1833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var Dialog_1 = __webpack_require__(1742);
var Utilities_1 = __webpack_require__(7);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var styles = __webpack_require__(1834);
/**
 * A Dialog to show three options: save your current changes, discard them, or go back and edit them.
 * This is implemented rather than using owa-confirm-dialog because that system doesn't support three options,
 * and would add unneeded complexity to that package for a one-off scenario.
 * Additionally, this may end up styled differently in the future, with stacked full-width buttons, rather than
 * using the default Dialog styling of a row of footer buttons.
 */
var OptionConfirmationDialog = /** @class */ (function (_super) {
    tslib_1.__extends(OptionConfirmationDialog, _super);
    function OptionConfirmationDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShown: false,
        };
        return _this;
    }
    OptionConfirmationDialog.prototype.componentDidMount = function () {
        this.setState({
            isShown: true,
        });
    };
    OptionConfirmationDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(Dialog_1.Dialog, { isOpen: this.state.isShown, type: Dialog_1.DialogType.normal, onDismiss: this.onDismiss, onDismissed: this.onDismissed, className: styles.dialog, title: owa_options_strings_1.default.optionsConfirmationDialog_title, subText: owa_options_strings_1.default.optionsConfirmationDialog_subtitle },
            React.createElement(Dialog_1.DialogFooter, null,
                React.createElement(Button_1.PrimaryButton, { className: styles.footerButton, text: owa_options_strings_1.default.optionsConfirmationDialog_save, onClick: this.onSave, disabled: this.props.shouldDisableSaveButton }),
                React.createElement(Button_1.DefaultButton, { className: styles.footerButton, text: owa_options_strings_1.default.optionsConfirmationDialog_discard, onClick: this.onDiscard }),
                React.createElement(Button_1.DefaultButton, { className: styles.footerButton, text: owa_options_strings_1.default.optionsConfirmationDialog_cancel, onClick: function () { return _this.setState({ isShown: false }); } }))));
    };
    OptionConfirmationDialog.prototype.onSave = function () {
        this.onDismiss();
        this.props.onSave();
    };
    OptionConfirmationDialog.prototype.onDiscard = function () {
        this.onDismiss();
        this.props.onDiscard();
    };
    OptionConfirmationDialog.prototype.onDismiss = function () {
        this.setState({
            isShown: false,
        });
    };
    OptionConfirmationDialog.prototype.onDismissed = function () {
        this.props.onClose();
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OptionConfirmationDialog.prototype, "onSave", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OptionConfirmationDialog.prototype, "onDiscard", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OptionConfirmationDialog.prototype, "onDismiss", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OptionConfirmationDialog.prototype, "onDismissed", null);
    OptionConfirmationDialog = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionConfirmationDialog);
    return OptionConfirmationDialog;
}(React.Component));
var confirmOptionContainer;
function confirmOptionNavigation(props) {
    if (!confirmOptionContainer) {
        confirmOptionContainer = document.createElement('div');
        document.body.appendChild(confirmOptionContainer);
    }
    ReactDOM.render(React.createElement(OptionConfirmationDialog, tslib_1.__assign({}, props, { onClose: function () {
            ReactDOM.unmountComponentAtNode(confirmOptionContainer);
        } })), confirmOptionContainer);
}
exports.default = confirmOptionNavigation;
//# sourceMappingURL=OptionConfirmationDialog.js.map

/***/ }),

/***/ 1834:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1835);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 1835:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._2E--KoJqbPsPTFNbEdXz2y .ms-Dialog-action,html[dir] ._2E--KoJqbPsPTFNbEdXz2y .ms-Dialog-actionsRight{margin:initial}._2E--KoJqbPsPTFNbEdXz2y ._2yuVMd_4TXbou8DycF_FD1{width:100%}html[dir] ._2E--KoJqbPsPTFNbEdXz2y ._2yuVMd_4TXbou8DycF_FD1{margin:10px 0}", ""]);

// exports
exports.locals = {
	"dialog": "_2E--KoJqbPsPTFNbEdXz2y",
	"footerButton": "_2yuVMd_4TXbou8DycF_FD1"
};

/***/ }),

/***/ 1836:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isAnyOptionDirty(currentSubcategory) {
    return currentSubcategory.options.reduce(function (state, option) { return state || option.fullOptionFormSettings.isDirty(); }, false);
}
exports.default = isAnyOptionDirty;
//# sourceMappingURL=isAnyOptionDirty.js.map

/***/ }),

/***/ 1837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function hideSaveDiscardButtons(currentSubcategory) {
    return currentSubcategory.options.reduce(function (state, option) {
        return state &&
            !!option.fullOptionFormSettings.hideSaveDiscard &&
            option.fullOptionFormSettings.hideSaveDiscard();
    }, true);
}
exports.default = hideSaveDiscardButtons;
//# sourceMappingURL=hideSaveDiscardButtons.js.map

/***/ }),

/***/ 1838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function shouldDisableSaveButton(currentSubcategory) {
    return currentSubcategory.options
        .filter(function (option) { return option.fullOptionFormSettings.isDirty(); })
        .reduce(function (state, option) {
        return state &&
            !!option.fullOptionFormSettings.disableSave &&
            option.fullOptionFormSettings.disableSave();
    }, true);
}
exports.default = shouldDisableSaveButton;
//# sourceMappingURL=shouldDisableSaveButton.js.map

/***/ }),

/***/ 1844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DraggableItemTypes_1 = __webpack_require__(349);
function getLocalFilesDragData(files) {
    return {
        itemType: DraggableItemTypes_1.DraggableItemTypes.LocalFile,
        files: files,
    };
}
exports.default = getLocalFilesDragData;
//# sourceMappingURL=LocalFilesDragData.js.map

/***/ }),

/***/ 1845:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
// Set Drop state, should be called only from Droppable component
exports.default = legacy_1.action('setDropState')(function (viewState, isDragOver, draggableItemType) {
    viewState.isDragOver = isDragOver;
    viewState.draggableItemType = draggableItemType;
});
//# sourceMappingURL=setDropState.js.map

/***/ }),

/***/ 1865:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var setFocusedInboxConfigurationRequest_1 = __webpack_require__(1866);
function setFocusedInboxConfigurationOperation(req, options) {
    if (req.request !== undefined && !req.request["__type"]) {
        req.request = setFocusedInboxConfigurationRequest_1.default(req.request);
    }
    return ServiceRequest_1.makeServiceRequest("SetFocusedInboxConfiguration", req, options);
}
exports.default = setFocusedInboxConfigurationOperation;


/***/ }),

/***/ 1866:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setFocusedInboxConfigurationRequest(data) {
    var result = tslib_1.__assign({ __type: 'SetFocusedInboxConfigurationRequest:#Exchange' }, data);
    return result;
}
exports.default = setFocusedInboxConfigurationRequest;


/***/ }),

/***/ 1868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var setDragState_1 = __webpack_require__(2302);
var dragDataUtil_1 = __webpack_require__(1715);
var constants_1 = __webpack_require__(2076);
var userAgent_1 = __webpack_require__(148);
var styles = __webpack_require__(2303);
// This is a helper class for better code reusing, this should be only invoked from owadnd classes
var DraggableCore = /** @class */ (function () {
    function DraggableCore(props) {
        var _this = this;
        this.props = props;
        this.initialPageX = 0;
        this.initialPageY = 0;
        this.dragHelperElement = null;
        this.isPotentialDrag = false;
        this.documentCssClass = document.body.className;
        this.onDragStart = function (dragEvent) {
            dragEvent.dataTransfer.clearData();
            if (_this.isDragAllowed()) {
                dragEvent.stopPropagation();
                // this is required for D&D to work in Firefox
                dragEvent.dataTransfer.setData('text', 'dragStarted');
                _this.setDragStateAndData();
                // TODO - 9122 https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/9122
                dragEvent.dataTransfer.effectAllowed = 'copyMove';
                _this.onDragStartInternal(dragEvent.pageX, dragEvent.pageY);
                _this.overrideDefaultDragPreviewImage(dragEvent.dataTransfer);
            }
            else if (_this.props.showDefaultNoDragImage) {
                // Drag is not allowed, show the default no-drag image
                _this.overrideDefaultNoDragImage(dragEvent.dataTransfer);
                // this is required for the no-drop image to work in Firefox
                dragEvent.dataTransfer.setData('text', 'nodrop');
                dragEvent.dataTransfer.effectAllowed = 'none';
            }
        };
        this.onDragEnd = function (dragEvent) {
            // TODO: We had to comment this out because onDragEnd is being called from
            // onUnmount. This seems a bit unnatural but there is some code in mail module
            // that depends on this and a call to canDrag during onUnmount will fail in such
            // cases. We will revisit this very shortly to find a better solution for this issue.
            //if (this.isDragAllowed()) {
            var onDragEnd = _this.props.onDragEnd;
            if (onDragEnd) {
                onDragEnd(dragDataUtil_1.getDragData());
            }
            //}
            _this.resetDragStateAndData();
            _this.removeDragHelperElement();
        };
        this.onMouseDown = function (mouseDownEvent) {
            if (!constants_1.IsSetDragImageSupported &&
                mouseDownEvent.button == 0 &&
                (_this.isDragAllowed() || _this.props.showDefaultNoDragImage)) {
                // If this is a left mouse click, there could be a potential for drag
                // We use event.button property instead of event.which as event.button is
                // now a standard
                _this.initialPageX = mouseDownEvent.pageX;
                _this.initialPageY = mouseDownEvent.pageY;
                _this.isPotentialDrag = true;
                document.addEventListener('mousemove', _this.onMouseMove);
                document.addEventListener('mouseup', _this.onMouseUp);
            }
            if (_this.props.onMouseDown) {
                _this.props.onMouseDown(mouseDownEvent);
            }
        };
        this.refCallback = function (ref) {
            _this.div = ref;
            if (_this.div) {
                _this.div.addEventListener('mousedown', _this.onMouseDown);
            }
        };
        this.onMouseMove = function (mouseMoveEvent) {
            var pageX = mouseMoveEvent.pageX;
            var pageY = mouseMoveEvent.pageY;
            // Only if the mouse has moved enough we detect this as a potential drag and
            // call dragDrop on the helper element
            if (Math.abs(_this.initialPageX - pageX) >= constants_1.MIN_MOUSE_MOVE_FOR_DRAG ||
                Math.abs(_this.initialPageY - pageY) >= constants_1.MIN_MOUSE_MOVE_FOR_DRAG) {
                if (_this.isDragAllowed()) {
                    _this.removeMouseMoveAndUpEventListeners();
                }
                if (_this.isPotentialDrag) {
                    _this.isPotentialDrag = false;
                    // In Edge, if user has text selection in somewhere, it will be used as drag preview image and cover DragHelperElement.
                    // To resolve this issue, we clear text selection on each potential drag. This is also needed for IE for cases when
                    // user cannot drag and we want to show the no-drag cursor without selecting text
                    if (userAgent_1.isBrowserEdge() || userAgent_1.isBrowserIE()) {
                        window.getSelection().removeAllRanges();
                    }
                    if (_this.isDragAllowed()) {
                        _this.setDragStateAndData();
                        _this.dragHelperElement = _this.getDragHelperElement();
                        document.body.appendChild(_this.dragHelperElement);
                        _this.onDragStartInternal(pageX, pageY);
                    }
                    else if (_this.props.showDefaultNoDragImage) {
                        // Set no drop cursor
                        document.body.className = _this.documentCssClass + ' ' + styles.disableDrag;
                    }
                }
                /* If we do not have a drag helper template we should call
                dragDrop on actual element there is no scenario for this yet
                and hence I am not calling it as of now */
                if (_this.dragHelperElement) {
                    /* DOMElement.DragDrop() is a block call and will not
                    return until user release the mouse button. Call
                    dragEnd explicitly so that the helper gets removed. */
                    _this.dragHelperElement.dragDrop();
                    setTimeout(_this.onDragEnd, 0);
                }
            }
        };
        this.onMouseUp = function (mouseUpEvent) {
            _this.removeMouseMoveAndUpEventListeners();
            if (!_this.isDragAllowed() && _this.props.showDefaultNoDragImage) {
                // Reset drag cursor
                document.body.className = _this.documentCssClass;
            }
        };
        this.removeMouseMoveAndUpEventListeners = function () {
            document.removeEventListener('mousemove', _this.onMouseMove);
            document.removeEventListener('mouseup', _this.onMouseUp);
        };
        this.removeDragHelperElement = function () {
            if (document.body.contains(_this.dragHelperElement)) {
                document.body.removeChild(_this.dragHelperElement);
                _this.dragHelperElement = null;
            }
        };
    }
    DraggableCore.prototype.onUnmount = function () {
        this.onDragEnd(null);
        if (!constants_1.IsSetDragImageSupported) {
            this.removeMouseMoveAndUpEventListeners();
        }
        this.div.removeEventListener('mousedown', this.onMouseDown);
    };
    DraggableCore.prototype.getDiv = function () {
        return this.div;
    };
    DraggableCore.prototype.onDragStartInternal = function (pageX, pageY) {
        var onDragStart = this.props.onDragStart;
        if (onDragStart) {
            onDragStart(dragDataUtil_1.getDragData(), pageX, pageY);
        }
    };
    DraggableCore.prototype.setDragStateAndData = function () {
        var dragViewState = this.props.dragViewState;
        if (dragViewState) {
            setDragState_1.default(this.props.dragViewState, true /*isBeingDragged*/);
        }
        // set drag data in store
        // TODO: VSO 14014: owa-dnd - Investigate if we can use only dataTransfer to transfer drag data
        dragDataUtil_1.setDragData(this.props.getDragData());
    };
    DraggableCore.prototype.resetDragStateAndData = function () {
        var dragViewState = this.props.dragViewState;
        if (dragViewState) {
            // clear dragging state
            setDragState_1.default(this.props.dragViewState, false /*isBeingDragged*/);
        }
        // clear drag store
        dragDataUtil_1.setDragData(null);
    };
    DraggableCore.prototype.overrideDefaultDragPreviewImage = function (dataTransfer) {
        if (constants_1.IsSetDragImageSupported) {
            this.dragHelperElement = this.getDragHelperElement();
            document.body.appendChild(this.dragHelperElement);
            var xOffset = this.props.xOffset ? this.props.xOffset : 0;
            var yOffset = this.props.yOffset ? this.props.yOffset : 0;
            dataTransfer.setDragImage(this.dragHelperElement, xOffset, yOffset);
        }
    };
    DraggableCore.prototype.overrideDefaultNoDragImage = function (dataTransfer) {
        if (constants_1.IsSetDragImageSupported) {
            this.dragHelperElement = document.createElement('div');
            this.dragHelperElement.style.display = 'none';
            document.body.appendChild(this.dragHelperElement);
            dataTransfer.setDragImage(this.dragHelperElement, 0, 0);
        }
    };
    DraggableCore.prototype.getDragHelperElement = function () {
        // Always get the drag preview as it could be different for each drag instance
        var dragHelperElement = this.props.getDragPreview(dragDataUtil_1.getDragData());
        dragHelperElement.style.top = '0px';
        dragHelperElement.style.left = '0px';
        dragHelperElement.style.zIndex = '-1000';
        dragHelperElement.style.position = 'fixed';
        return dragHelperElement;
    };
    DraggableCore.prototype.isDragAllowed = function () {
        return !this.props.canDrag || this.props.canDrag();
    };
    return DraggableCore;
}());
exports.DraggableCore = DraggableCore;
// TODO: Bug 14032: Consider a framework-independent design of owa-dnd
var Draggable = /** @class */ (function (_super) {
    tslib_1.__extends(Draggable, _super);
    function Draggable(props) {
        var _this = _super.call(this, props) || this;
        _this.core = new DraggableCore(props);
        return _this;
    }
    Draggable.prototype.render = function () {
        return constants_1.IsSetDragImageSupported ? (React.createElement("div", { draggable: true, className: this.props.classNames, ref: this.core.refCallback, onDragStart: this.core.onDragStart, onDragEnd: this.core.onDragEnd }, this.props.children)) : (React.createElement("div", { className: this.props.classNames, ref: this.core.refCallback }, this.props.children));
    };
    Draggable.prototype.componentWillUnmount = function () {
        this.core.onUnmount();
    };
    Draggable.prototype.getDiv = function () {
        return this.core.getDiv();
    };
    return Draggable;
}(React.Component));
exports.default = Draggable;
//# sourceMappingURL=Draggable.js.map

/***/ }),

/***/ 1869:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OWADatePicker_1 = __webpack_require__(1870);
exports.default = OWADatePicker_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1870:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var DatePicker_1 = __webpack_require__(1812);
var owa_calendar_strings_1 = __webpack_require__(1809);
var owa_common_strings_1 = __webpack_require__(37);
var React = __webpack_require__(3);
var mobx_1 = __webpack_require__(15);
var OWADatePicker = /** @class */ (function (_super) {
    tslib_1.__extends(OWADatePicker, _super);
    function OWADatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OWADatePicker.prototype, "datePickerStrings", {
        get: function () {
            return {
                months: [
                    owa_common_strings_1.default.januaryUppercase,
                    owa_common_strings_1.default.februaryUppercase,
                    owa_common_strings_1.default.marchUppercase,
                    owa_common_strings_1.default.aprilUppercase,
                    owa_common_strings_1.default.mayUppercase,
                    owa_common_strings_1.default.juneUppercase,
                    owa_common_strings_1.default.julyUppercase,
                    owa_common_strings_1.default.augustUppercase,
                    owa_common_strings_1.default.septemberUppercase,
                    owa_common_strings_1.default.octoberUppercase,
                    owa_common_strings_1.default.novemberUppercase,
                    owa_common_strings_1.default.decemberUppercase,
                ],
                shortMonths: [
                    owa_common_strings_1.default.januaryAbbreviatedUppercase,
                    owa_common_strings_1.default.februaryAbbreviatedUppercase,
                    owa_common_strings_1.default.marchAbbreviatedUppercase,
                    owa_common_strings_1.default.aprilAbbreviatedUppercase,
                    owa_common_strings_1.default.mayAbbreviatedUppercase,
                    owa_common_strings_1.default.juneAbbreviatedUppercase,
                    owa_common_strings_1.default.julyAbbreviatedUppercase,
                    owa_common_strings_1.default.augustAbbreviatedUppercase,
                    owa_common_strings_1.default.septemberAbbreviatedUppercase,
                    owa_common_strings_1.default.octoberAbbreviatedUppercase,
                    owa_common_strings_1.default.novemberAbbreviatedUppercase,
                    owa_common_strings_1.default.decemberAbbreviatedUppercase,
                ],
                days: [
                    owa_common_strings_1.default.sundayUppercase,
                    owa_common_strings_1.default.mondayUppercase,
                    owa_common_strings_1.default.tuesdayUppercase,
                    owa_common_strings_1.default.wednesdayUppercase,
                    owa_common_strings_1.default.thursdayUppercase,
                    owa_common_strings_1.default.fridayUppercase,
                    owa_common_strings_1.default.saturdayUppercase,
                ],
                shortDays: [
                    owa_common_strings_1.default.sundaySingleLetterAbbreviation,
                    owa_common_strings_1.default.mondaySingleLetterAbbreviation,
                    owa_common_strings_1.default.tuesdaySingleLetterAbbreviation,
                    owa_common_strings_1.default.wednesdaySingleLetterAbbreviation,
                    owa_common_strings_1.default.thursdaySingleLetterAbbreviation,
                    owa_common_strings_1.default.fridaySingleLetterAbbreviation,
                    owa_common_strings_1.default.saturdaySingleLetterAbbreviation,
                ],
                goToToday: owa_calendar_strings_1.default.goToTodayStringLowerCaseText,
            };
        },
        enumerable: true,
        configurable: true
    });
    OWADatePicker.prototype.render = function () {
        return React.createElement(DatePicker_1.DatePicker, tslib_1.__assign({}, this.props, { strings: this.datePickerStrings }));
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], OWADatePicker.prototype, "datePickerStrings", null);
    OWADatePicker = tslib_1.__decorate([
        mobx_react_1.observer
    ], OWADatePicker);
    return OWADatePicker;
}(React.Component));
exports.default = OWADatePicker;
//# sourceMappingURL=OWADatePicker.js.map

/***/ }),

/***/ 1891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var saveReadingPaneOption_1 = __webpack_require__(3282);
exports.saveReadingPaneOptionQuick = saveReadingPaneOption_1.saveReadingPaneOptionQuick;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2043:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(1740);
function getExtensibilityState() {
    return Store_1.default;
}
exports.default = getExtensibilityState;
//# sourceMappingURL=getExtensibilityState.js.map

/***/ }),

/***/ 2044:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// This enum needs to stay synced with ExtensibilityScenario in ExtensibilityEnums.cs
var ExtensibilityModeEnum;
(function (ExtensibilityModeEnum) {
    ExtensibilityModeEnum[ExtensibilityModeEnum["Unknown"] = 0] = "Unknown";
    ExtensibilityModeEnum[ExtensibilityModeEnum["AppointmentOrganizer"] = 1] = "AppointmentOrganizer";
    ExtensibilityModeEnum[ExtensibilityModeEnum["AppointmentAttendee"] = 2] = "AppointmentAttendee";
    ExtensibilityModeEnum[ExtensibilityModeEnum["MessageCompose"] = 3] = "MessageCompose";
    ExtensibilityModeEnum[ExtensibilityModeEnum["MessageRead"] = 4] = "MessageRead";
    ExtensibilityModeEnum[ExtensibilityModeEnum["MeetingRequest"] = 5] = "MeetingRequest";
    ExtensibilityModeEnum[ExtensibilityModeEnum["TrapOnSendEvent"] = 6] = "TrapOnSendEvent";
    ExtensibilityModeEnum[ExtensibilityModeEnum["DetectedEntity"] = 7] = "DetectedEntity";
})(ExtensibilityModeEnum = exports.ExtensibilityModeEnum || (exports.ExtensibilityModeEnum = {}));
exports.default = ExtensibilityModeEnum;
//# sourceMappingURL=ExtensibilityModeEnum.js.map

/***/ }),

/***/ 2045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// The enum is defined on the server, and should be kept in sync
// In the server-ows-api project: src/Microsoft.OWS.UserSettings/Models/OutlookOptions/OutlookSettingsFactory.cs
// Work item 11646 in Outlook Web tracks improving this
var OwsOptionsFeatureType;
(function (OwsOptionsFeatureType) {
    OwsOptionsFeatureType[OwsOptionsFeatureType["TestFeature"] = 1] = "TestFeature";
    OwsOptionsFeatureType[OwsOptionsFeatureType["SmartSuggestions"] = 2] = "SmartSuggestions";
    OwsOptionsFeatureType[OwsOptionsFeatureType["DiverseEmojis"] = 4] = "DiverseEmojis";
    OwsOptionsFeatureType[OwsOptionsFeatureType["SurfaceActions"] = 5] = "SurfaceActions";
    OwsOptionsFeatureType[OwsOptionsFeatureType["SkypeNotifications"] = 6] = "SkypeNotifications";
})(OwsOptionsFeatureType = exports.OwsOptionsFeatureType || (exports.OwsOptionsFeatureType = {}));
//# sourceMappingURL=OwsOptionsFeatureType.js.map

/***/ }),

/***/ 2046:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReadWriteRecipientWellViewState_1 = __webpack_require__(2114);
var isValidEmailAddress_1 = __webpack_require__(2112);
/*
 * Invokes initializeReadWriteRecipientWellWithFindControl.
*/
function createRecipientWell(initialEmails, contactPickerState) {
    var recipientWell = {
        queryString: '',
        recipients: [],
        isDirty: false,
        shouldShowFindResult: false,
        shouldShowContactPicker: false,
        findResultSet: [],
        findResultType: ReadWriteRecipientWellViewState_1.FindRecipientResultType.None,
        findResultHightlightIndex: -1,
        isSearching: false,
        hasSearchedDirectory: false,
        contactPicker: contactPickerState
            ? contactPickerState
            : { contacts: [], isLoading: false, maxForSession: -1 },
    };
    if (initialEmails) {
        for (var _i = 0, initialEmails_1 = initialEmails; _i < initialEmails_1.length; _i++) {
            var email = initialEmails_1[_i];
            var recipient = {
                displayText: email.Name,
                persona: { EmailAddress: email, PersonaId: email.ItemId },
                isContextMenuOpen: false,
                isValid: isValidEmailAddress_1.default(email.EmailAddress),
                isSelected: false,
                isExpanding: false,
            };
            recipientWell.recipients.push(recipient);
        }
    }
    return recipientWell;
}
exports.default = createRecipientWell;
//# sourceMappingURL=createRecipientWell.js.map

/***/ }),

/***/ 2047:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.action('CONVERSATIONS_LOADED_ACTION', function (recipientEmail, recipientName, conversations) {
    return {
        recipientEmail: recipientEmail,
        recipientName: recipientName,
        conversations: conversations,
    };
});
//# sourceMappingURL=conversationsLoadedAction.js.map

/***/ }),

/***/ 2048:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.action('ONE_RECIPIENT_SELECTED_ACTION', function (persona) {
    return {
        persona: persona,
    };
});
//# sourceMappingURL=oneRecipientSelectedAction.js.map

/***/ }),

/***/ 2049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.action('ON_SUBJECT_CONVERSATION_SELECTED_ACTION', function (conversationId) {
    return {
        conversationId: conversationId,
    };
});
//# sourceMappingURL=onSubjectConversationSelectedAction.js.map

/***/ }),

/***/ 2076:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Mininum mouse movement for the potential drag
exports.MIN_MOUSE_MOVE_FOR_DRAG = 5;
// Whether SetDragImage is supported by this browser
// see http://caniuse.com/#feat=dragndrop
// Check window undefined for when this is server-side rendering
exports.IsSetDragImageSupported = typeof window !== typeof undefined &&
    window.hasOwnProperty('DataTransfer') &&
    DataTransfer.prototype.setDragImage;
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 2109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var adapters = {};
function addAdapter(hostItemIndex, adapter) {
    if (isAdapterPresent(hostItemIndex)) {
        deleteAdapter(hostItemIndex);
    }
    adapters[hostItemIndex] = adapter;
}
exports.addAdapter = addAdapter;
function deleteAdapter(hostItemIndex) {
    delete adapters[hostItemIndex];
}
exports.deleteAdapter = deleteAdapter;
function getAdapter(hostItemIndex) {
    return adapters[hostItemIndex];
}
exports.getAdapter = getAdapter;
function isAdapterPresent(hostItemIndex) {
    return adapters[hostItemIndex] !== undefined;
}
//# sourceMappingURL=AdapterManager.js.map

/***/ }),

/***/ 2110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OwsOptionsFeatureType_1 = __webpack_require__(2045);
exports.OwsOptionsFeatureType = OwsOptionsFeatureType_1.OwsOptionsFeatureType;
var owa_bundling_1 = __webpack_require__(6);
var owa_delayed_initialization_1 = __webpack_require__(28);
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 2560));
});
exports.lazyCreateOrUpdateOptionsForFeature = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.createOrUpdateOptionsForFeature; });
// Synchronous exports
var getOptionsForFeature_1 = __webpack_require__(2134);
exports.getOptionsForFeature = getOptionsForFeature_1.default;
// Load the options after bootstrap
// We may, in the future, move this to bootstrap and block boot on its resolution
//
// 'loadOptions' is intentionally not exported, as it should only be called by the following
// 'runAfterBootstrap' callback
var lazyLoadOptions = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.loadOptions; });
owa_delayed_initialization_1.runAfterBootstrap(function () {
    lazyLoadOptions.importAndExecute();
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ApiErrorCode;
(function (ApiErrorCode) {
    ApiErrorCode[ApiErrorCode["OoeInvalidDataFormat"] = 2006] = "OoeInvalidDataFormat";
    ApiErrorCode[ApiErrorCode["AttachmentSizeExceeded"] = 9000] = "AttachmentSizeExceeded";
    ApiErrorCode[ApiErrorCode["NumberOfAttachmentsExceeded"] = 9001] = "NumberOfAttachmentsExceeded";
    ApiErrorCode[ApiErrorCode["InvalidAttachmentId"] = 9003] = "InvalidAttachmentId";
    ApiErrorCode[ApiErrorCode["InvalidAttachmentPath"] = 9004] = "InvalidAttachmentPath";
    ApiErrorCode[ApiErrorCode["CannotAddAttachmentBeforeUpgrade"] = 9005] = "CannotAddAttachmentBeforeUpgrade";
    ApiErrorCode[ApiErrorCode["AttachmentDeletedBeforeUploadCompletes"] = 9006] = "AttachmentDeletedBeforeUploadCompletes";
    ApiErrorCode[ApiErrorCode["AttachmentUploadGeneralFailure"] = 9007] = "AttachmentUploadGeneralFailure";
    ApiErrorCode[ApiErrorCode["AttachmentToDeleteDoesNotExist"] = 9008] = "AttachmentToDeleteDoesNotExist";
    ApiErrorCode[ApiErrorCode["AttachmentDeleteGeneralFailure"] = 9009] = "AttachmentDeleteGeneralFailure";
    ApiErrorCode[ApiErrorCode["HtmlSanitizationFailure"] = 9011] = "HtmlSanitizationFailure";
    ApiErrorCode[ApiErrorCode["CursorPositionChanged"] = 9014] = "CursorPositionChanged";
    ApiErrorCode[ApiErrorCode["ComposeFormNotReadyForAttachments"] = 9015] = "ComposeFormNotReadyForAttachments";
    ApiErrorCode[ApiErrorCode["InvalidSelection"] = 9016] = "InvalidSelection";
    ApiErrorCode[ApiErrorCode["GenericTokenError"] = 9018] = "GenericTokenError";
    ApiErrorCode[ApiErrorCode["GenericSettingsError"] = 9019] = "GenericSettingsError";
    ApiErrorCode[ApiErrorCode["GenericResponseError"] = 9020] = "GenericResponseError";
    ApiErrorCode[ApiErrorCode["SaveError"] = 9021] = "SaveError";
    ApiErrorCode[ApiErrorCode["DuplicateNotificationKey"] = 9023] = "DuplicateNotificationKey";
    ApiErrorCode[ApiErrorCode["NotificationKeyNotFound"] = 9024] = "NotificationKeyNotFound";
    ApiErrorCode[ApiErrorCode["NumberOfNotificationsExceeded"] = 9025] = "NumberOfNotificationsExceeded";
    ApiErrorCode[ApiErrorCode["PersistedNotificationArrayReadError"] = 9026] = "PersistedNotificationArrayReadError";
    ApiErrorCode[ApiErrorCode["PersistedNotificationArraySaveError"] = 9027] = "PersistedNotificationArraySaveError";
    ApiErrorCode[ApiErrorCode["CannotPersistPropertyInUnsavedDraftError"] = 9028] = "CannotPersistPropertyInUnsavedDraftError";
    ApiErrorCode[ApiErrorCode["CallSaveAsyncBeforeToken"] = 9029] = "CallSaveAsyncBeforeToken";
})(ApiErrorCode = exports.ApiErrorCode || (exports.ApiErrorCode = {}));
exports.default = ApiErrorCode;
//# sourceMappingURL=ApiErrorCode.js.map

/***/ }),

/***/ 2112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var emailAddressRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
function isValidEmailAddress(emailAddress) {
    //VSO: 1041: Separate out form field validation to a different package.
    return emailAddressRegex.test(emailAddress);
}
exports.default = isValidEmailAddress;
//# sourceMappingURL=isValidEmailAddress.js.map

/***/ }),

/***/ 2113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.getStore = satcheljs_1.createStore('optionsViewState', {
    isFullOptionsShown: false,
    isSaving: false,
    currentCategoryKey: null,
    currentSubCategoryKey: null,
    currentSubCategoryState: null,
    currentOptionKey: null,
    searchTerm: '',
});
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FindRecipientResultType;
(function (FindRecipientResultType) {
    FindRecipientResultType[FindRecipientResultType["None"] = 0] = "None";
    FindRecipientResultType[FindRecipientResultType["Cache"] = 1] = "Cache";
    FindRecipientResultType[FindRecipientResultType["FindPeople"] = 2] = "FindPeople";
    FindRecipientResultType[FindRecipientResultType["SearchDirectory"] = 3] = "SearchDirectory";
})(FindRecipientResultType = exports.FindRecipientResultType || (exports.FindRecipientResultType = {}));
var ReadWriteRecipientWellSize;
(function (ReadWriteRecipientWellSize) {
    ReadWriteRecipientWellSize[ReadWriteRecipientWellSize["Small"] = 0] = "Small";
    ReadWriteRecipientWellSize[ReadWriteRecipientWellSize["Regular"] = 1] = "Regular";
})(ReadWriteRecipientWellSize = exports.ReadWriteRecipientWellSize || (exports.ReadWriteRecipientWellSize = {}));
//# sourceMappingURL=ReadWriteRecipientWellViewState.js.map

/***/ }),

/***/ 2118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2123), exports);
//# sourceMappingURL=Link.js.map

/***/ }),

/***/ 2119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_NOTIFICATION_MESSAGES_PER_APP = 5;
exports.extensibilityNotifications = {};
// this map is for looking up the hostItemIndex and extensionId
// associated with the messageId
exports.metaLookup = {};
function addOrReplaceExtensibilityNotification(hostItemIndex, extensionId, messageId, notification) {
    if (!getValueAtPath([hostItemIndex, 'data', extensionId])) {
        initializeMaps(hostItemIndex, extensionId);
    }
    if (hasExtensibilityNotification(messageId)) {
        removeFromMap(messageId);
    }
    addToMap(hostItemIndex, extensionId, messageId, notification);
}
exports.addOrReplaceExtensibilityNotification = addOrReplaceExtensibilityNotification;
function removeExtensibilityNotification(messageId) {
    var currentNotification = getExtensibilityNotification(messageId);
    if (!currentNotification) {
        return;
    }
    removeFromMap(messageId);
}
exports.removeExtensibilityNotification = removeExtensibilityNotification;
function getExtensibilityNotification(messageId) {
    if (!hasExtensibilityNotification(messageId)) {
        return null;
    }
    var _a = exports.metaLookup[messageId], hostItemIndex = _a.hostItemIndex, extensionId = _a.extensionId;
    return getValueAtPath([
        hostItemIndex,
        'data',
        extensionId,
        messageId,
    ]);
}
exports.getExtensibilityNotification = getExtensibilityNotification;
function hasExtensibilityNotification(messageId) {
    return !!exports.metaLookup[messageId];
}
exports.hasExtensibilityNotification = hasExtensibilityNotification;
function isExtensibilityNotificationLimitExceeded(hostItemIndex, extensionId) {
    var extNotificationMap = getExtNotificationMap(hostItemIndex, extensionId) || [];
    var numOfNotifications = Object.keys(extNotificationMap).length || 0;
    return numOfNotifications >= exports.MAX_NOTIFICATION_MESSAGES_PER_APP;
}
exports.isExtensibilityNotificationLimitExceeded = isExtensibilityNotificationLimitExceeded;
function getAllPersistentNotifications(hostItemIndex, extensionId) {
    var extNotificationMap = getExtNotificationMap(hostItemIndex, extensionId);
    if (!extNotificationMap) {
        return {};
    }
    return Object.keys(extNotificationMap).reduce(function (result, messageId) {
        var notification = extNotificationMap[messageId];
        if (notification.Persistent) {
            result[messageId] = notification;
        }
        return result;
    }, {});
}
exports.getAllPersistentNotifications = getAllPersistentNotifications;
function getAllMessageIds(hostItemIndex) {
    return exports.extensibilityNotifications[hostItemIndex]
        ? exports.extensibilityNotifications[hostItemIndex].messageIds
        : [];
}
exports.getAllMessageIds = getAllMessageIds;
function destroyExtensibilityNotifications(hostItemIndex) {
    if (!exports.extensibilityNotifications[hostItemIndex]) {
        return;
    }
    var messageIds = exports.extensibilityNotifications[hostItemIndex].messageIds;
    messageIds.forEach(function (messageId) { return delete exports.metaLookup[messageId]; });
    delete exports.extensibilityNotifications[hostItemIndex];
}
exports.destroyExtensibilityNotifications = destroyExtensibilityNotifications;
// currently used for tests only
function clearExtensibilityNotifications() {
    exports.extensibilityNotifications = {};
    exports.metaLookup = {};
}
exports.clearExtensibilityNotifications = clearExtensibilityNotifications;
function initializeMaps(hostItemIndex, extensionId) {
    exports.extensibilityNotifications[hostItemIndex] = exports.extensibilityNotifications[hostItemIndex] || {
        data: {},
        messageIds: [],
    };
    exports.extensibilityNotifications[hostItemIndex].data[extensionId] = {};
}
function addToMap(hostItemIndex, extensionId, messageId, notification) {
    exports.extensibilityNotifications[hostItemIndex].data[extensionId][messageId] = notification;
    exports.extensibilityNotifications[hostItemIndex].messageIds.push(messageId);
    exports.metaLookup[messageId] = { hostItemIndex: hostItemIndex, extensionId: extensionId };
}
function removeFromMap(messageId) {
    var _a = exports.metaLookup[messageId], hostItemIndex = _a.hostItemIndex, extensionId = _a.extensionId;
    var extNotificationMap = getExtNotificationMap(hostItemIndex, extensionId);
    delete extNotificationMap[messageId];
    delete exports.metaLookup[messageId];
    var messageIds = exports.extensibilityNotifications[hostItemIndex].messageIds;
    var index = messageIds.indexOf(messageId);
    if (~index) {
        messageIds.splice(index, 1);
    }
}
function getExtNotificationMap(hostItemIndex, extensionId) {
    return getValueAtPath([hostItemIndex, 'data', extensionId]);
}
function getValueAtPath(keyPath) {
    var obj = exports.extensibilityNotifications;
    for (var i = 0; i < keyPath.length; i++) {
        var key = keyPath[i];
        if (!obj[key]) {
            return null;
        }
        obj = obj[key];
    }
    return obj;
}
//# sourceMappingURL=ExtensibilityNotificationManager.js.map

/***/ }),

/***/ 2120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(1705);
exports.getStore = store_1.getStore;
var oneRecipientSelectedAction_1 = __webpack_require__(2048);
exports.oneRecipientSelectedAction = oneRecipientSelectedAction_1.default;
var onSubjectConversationSelectedAction_1 = __webpack_require__(2049);
exports.onSubjectConversationSelectedAction = onSubjectConversationSelectedAction_1.default;
var conversationsLoadedAction_1 = __webpack_require__(2047);
exports.conversationsLoadedAction = conversationsLoadedAction_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2126), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OwsOptionsFeatureType_1 = __webpack_require__(2045);
var OwsOptionsStore_1 = __webpack_require__(2128);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('owsOptionsStore', {
    options: (_a = {},
        /**
         * Initial values for options in the store should be "fail-safe" values in the
         *  event that the service call to fetch the options has not yet completed or failed.
         *
         * For example, while the default setting for a feature for a user that has made no
         * changes to the options may be to have it enabled, to increase coverage and
         * discoverability, we don't want to aggravate users by potentially having it
         * enabled after they explicitly disabled it.
         */
        _a[OwsOptionsFeatureType_1.OwsOptionsFeatureType.SmartSuggestions] = {
            feature: OwsOptionsFeatureType_1.OwsOptionsFeatureType.SmartSuggestions,
            smartSuggestionsEnabled: false,
            browserLocationEnabled: false,
        },
        _a[OwsOptionsFeatureType_1.OwsOptionsFeatureType.DiverseEmojis] = {
            feature: OwsOptionsFeatureType_1.OwsOptionsFeatureType.DiverseEmojis,
            diverseEmojisSelectedSkinTone: '',
        },
        _a[OwsOptionsFeatureType_1.OwsOptionsFeatureType.SurfaceActions] = {
            feature: OwsOptionsFeatureType_1.OwsOptionsFeatureType.SurfaceActions,
            readSurfaceActions: ['Reply', 'ReplyAll', 'Forward'],
            readSurfaceAddins: [],
            composeSurfaceActions: ['AddAttachment', 'AddInlineImage', 'AddEmoji', 'ToggleRibbon'],
            composeSurfaceAddins: [],
        },
        _a[OwsOptionsFeatureType_1.OwsOptionsFeatureType.SkypeNotifications] = {
            feature: OwsOptionsFeatureType_1.OwsOptionsFeatureType.SkypeNotifications,
            skypeMessageNotification: 1,
            skypeCallingNotification: 1,
        },
        _a),
    loadState: OwsOptionsStore_1.LoadState.OptionsNotLoaded,
})();
var _a;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2124), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(2125);
var styles = stylesImport;
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, children = _a.children, className = _a.className, href = _a.href;
        return (href ? (React.createElement("a", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.anchorProperties), { className: Utilities_1.css('ms-Link', styles.root, className, disabled && ('is-disabled ' + styles.isDisabled), !disabled && styles.isEnabled), onClick: this._onClick, ref: this._resolveRef('_link'), target: this.props.target, "aria-disabled": disabled }), children)) : (React.createElement("button", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.buttonProperties), { className: Utilities_1.css('ms-Link', styles.root, className, disabled && ('is-disabled ' + styles.isDisabled), !disabled && styles.isEnabled), onClick: this._onClick, ref: this._resolveRef('_link'), "aria-disabled": disabled }), children)));
    };
    Link.prototype.focus = function () {
        if (this._link) {
            this._link.focus();
        }
    };
    Link.prototype._onClick = function (ev) {
        var onClick = this.props.onClick;
        if (onClick) {
            onClick(ev);
        }
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Link.prototype, "_onClick", null);
    return Link;
}(Utilities_1.BaseComponent));
exports.Link = Link;
//# sourceMappingURL=Link.js.map

/***/ }),

/***/ 2125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_6f11bd51{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";margin:0;overflow:inherit;padding:0;text-overflow:inherit}.isEnabled_6f11bd51:active,.isEnabled_6f11bd51:hover{color:" }, { "theme": "themeDarker", "defaultValue": "#004578" }, { "rawString": "}.isEnabled_6f11bd51:focus{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.isDisabled_6f11bd51{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";pointer-events:none;cursor:default}button.root_6f11bd51{background:none;border:none;cursor:pointer;display:inline;font-size:inherit}button.root_6f11bd51::-moz-focus-inner{border:0}button.root_6f11bd51{outline:transparent}button.root_6f11bd51{position:relative}.ms-Fabric.is-focusVisible button.root_6f11bd51:focus:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid " }, { "theme": "focusBorder", "defaultValue": "#000000" }, { "rawString": "}html[dir='ltr'] button.root_6f11bd51{text-align:left}html[dir='rtl'] button.root_6f11bd51{text-align:right}@media screen and (-ms-high-contrast: active){button.root_6f11bd51{color:Highlight}}a.root_6f11bd51{text-decoration:none}.ms-Fabric.is-focusVisible a.root_6f11bd51:focus{outline:1px solid " }, { "theme": "focusBorder", "defaultValue": "#000000" }, { "rawString": "}\n" }]);
exports.root = "root_6f11bd51";
exports.isEnabled = "isEnabled_6f11bd51";
exports.isDisabled = "isDisabled_6f11bd51";
//# sourceMappingURL=Link.scss.js.map

/***/ }),

/***/ 2126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var RESIZE_DELAY = 16;
var MIN_SCROLL_UPDATE_DELAY = 100;
var MAX_SCROLL_UPDATE_DELAY = 500;
var IDLE_DEBOUNCE_DELAY = 200;
// The amount of time to wait before declaring that the list isn't scrolling
var DONE_SCROLLING_WAIT = 500;
var DEFAULT_ITEMS_PER_PAGE = 10;
var DEFAULT_PAGE_HEIGHT = 30;
var DEFAULT_RENDERED_WINDOWS_BEHIND = 2;
var DEFAULT_RENDERED_WINDOWS_AHEAD = 2;
var EMPTY_RECT = {
    top: -1,
    bottom: -1,
    left: -1,
    right: -1,
    width: 0,
    height: 0
};
// Naming expensive measures so that they're named in profiles.
var _measurePageRect = function (element) { return element.getBoundingClientRect(); };
var _measureSurfaceRect = _measurePageRect;
var _measureScrollRect = _measurePageRect;
/**
 * The List renders virtualized pages of items. Each page's item count is determined by the getItemCountForPage callback if
 * provided by the caller, or 10 as default. Each page's height is determined by the getPageHeight callback if provided by
 * the caller, or by cached measurements if available, or by a running average, or a default fallback.
 *
 * The algorithm for rendering pages works like this:
 *
 * 1. Predict visible pages based on "current measure data" (page heights, surface position, visible window)
 * 2. If changes are necessary, apply changes (add/remove pages)
 * 3. For pages that are added, measure the page heights if we need to using getBoundingClientRect
 * 4. If measurements don't match predictions, update measure data and goto step 1 asynchronously
 *
 * Measuring too frequently can pull performance down significantly. To compensate, we cache measured values so that
 * we can avoid re-measuring during operations that should not alter heights, like scrolling.
 *
 * To optimize glass rendering performance, onShouldVirtualize can be set. When onShouldVirtualize return false,
 * List will run in fast mode (not virtualized) to render all items without any measurements to improve page load time. And we
 * start doing measurements and rendering in virtualized mode when items grows larger than this threshold.
 *
 * However, certain operations can make measure data stale. For example, resizing the list, or passing in new props,
 * or forcing an update change cause pages to shrink/grow. When these operations occur, we increment a measureVersion
 * number, which we associate with cached measurements and use to determine if a remeasure should occur.
 */
var List = /** @class */ (function (_super) {
    tslib_1.__extends(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pages: [],
            isScrolling: false
        };
        _this._estimatedPageHeight = 0;
        _this._totalEstimates = 0;
        _this._requiredWindowsAhead = 0;
        _this._requiredWindowsBehind = 0;
        // Track the measure version for everything.
        _this._measureVersion = 0;
        // Ensure that scrolls are lazy updated.
        _this._onAsyncScroll = _this._async.debounce(_this._onAsyncScroll, MIN_SCROLL_UPDATE_DELAY, {
            leading: false,
            maxWait: MAX_SCROLL_UPDATE_DELAY
        });
        _this._onAsyncIdle = _this._async.debounce(_this._onAsyncIdle, IDLE_DEBOUNCE_DELAY, {
            leading: false
        });
        _this._onAsyncResize = _this._async.debounce(_this._onAsyncResize, RESIZE_DELAY, {
            leading: false
        });
        _this._onScrollingDone = _this._async.debounce(_this._onScrollingDone, DONE_SCROLLING_WAIT, {
            leading: false
        });
        _this._cachedPageHeights = {};
        _this._estimatedPageHeight = 0;
        _this._focusedIndex = -1;
        _this._scrollingToIndex = -1;
        _this._pageCache = {};
        return _this;
    }
    /**
     * Scroll to the given index. By default will bring the page the specified item is on into the view. If a callback
     * to measure the height of an individual item is specified, will only scroll to bring the specific item into view.
     *
     * Note: with items of variable height and no passed in `getPageHeight` method, the list might jump after scrolling
     * when windows before/ahead are being rendered, and the estimated height is replaced using actual elements.
     *
     * @param index Index of item to scroll to
     * @param measureItem Optional callback to measure the height of an individual item
     */
    List.prototype.scrollToIndex = function (index, measureItem) {
        var startIndex = this.props.startIndex;
        var renderCount = this._getRenderCount();
        var endIndex = startIndex + renderCount;
        var allowedRect = this._allowedRect;
        var scrollTop = 0;
        var itemsPerPage = 1;
        for (var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage) {
            var pageSpecification = this._getPageSpecification(itemIndex, allowedRect);
            var pageHeight = pageSpecification.height;
            itemsPerPage = pageSpecification.itemCount;
            var requestedIndexIsInPage = itemIndex <= index && (itemIndex + itemsPerPage) > index;
            if (requestedIndexIsInPage) {
                // We have found the page. If the user provided a way to measure an individual item, we will try to scroll in just
                // the given item, otherwise we'll only bring the page into view
                if (measureItem) {
                    // Adjust for actual item position within page
                    var itemPositionWithinPage = index - itemIndex;
                    for (var itemIndexInPage = 0; itemIndexInPage < itemPositionWithinPage; ++itemIndexInPage) {
                        scrollTop += measureItem(itemIndex + itemIndexInPage);
                    }
                    var scrollBottom = scrollTop + measureItem(index);
                    var scrollRect = _measureScrollRect(this._scrollElement);
                    var scrollWindow = {
                        top: this._scrollElement.scrollTop,
                        bottom: this._scrollElement.scrollTop + scrollRect.height
                    };
                    var itemIsFullyVisible = scrollTop >= scrollWindow.top && scrollBottom <= scrollWindow.bottom;
                    if (itemIsFullyVisible) {
                        // Item is already visible, do nothing.
                        return;
                    }
                    var itemIsPartiallyAbove = scrollTop < scrollWindow.top;
                    var itemIsPartiallyBelow = scrollBottom > scrollWindow.bottom;
                    if (itemIsPartiallyAbove) {
                        // We will just scroll to 'scrollTop'
                        //  ______
                        // |Item  |   - scrollTop
                        // |  ____|_
                        // |_|____| | - scrollWindow.top
                        //   |      |
                        //   |______|
                    }
                    else if (itemIsPartiallyBelow) {
                        // Adjust scrollTop position to just bring in the element
                        //  ______   - scrollTop
                        // |      |
                        // |  ____|_  - scrollWindow.bottom
                        // |_|____| |
                        //   | Item |
                        //   |______| - scrollBottom
                        scrollTop = this._scrollElement.scrollTop + (scrollBottom - scrollWindow.bottom);
                    }
                }
                this._scrollElement.scrollTop = scrollTop;
                break;
            }
            scrollTop += pageHeight;
        }
    };
    List.prototype.componentDidMount = function () {
        this._updatePages();
        this._measureVersion++;
        this._scrollElement = Utilities_1.findScrollableParent(this.refs.root);
        this._events.on(window, 'resize', this._onAsyncResize);
        this._events.on(this.refs.root, 'focus', this._onFocus, true);
        if (this._scrollElement) {
            this._events.on(this._scrollElement, 'scroll', this._onScroll);
            this._events.on(this._scrollElement, 'scroll', this._onAsyncScroll);
        }
    };
    List.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.items !== this.props.items ||
            newProps.renderCount !== this.props.renderCount ||
            newProps.startIndex !== this.props.startIndex) {
            // We have received new items so we want to make sure that initially we only render a single window to
            // fill the currently visible rect, and then later render additional windows.
            this._resetRequiredWindows();
            this._requiredRect = null;
            this._measureVersion++;
            this._invalidatePageCache();
            this._updatePages(newProps);
        }
    };
    List.prototype.shouldComponentUpdate = function (newProps, newState) {
        var oldPages = this.state.pages;
        var newPages = newState.pages;
        var shouldComponentUpdate = false;
        // Update if the page stops scrolling
        if (!newState.isScrolling && this.state.isScrolling) {
            return true;
        }
        if (newProps.items === this.props.items &&
            oldPages.length === newPages.length) {
            for (var i = 0; i < oldPages.length; i++) {
                var oldPage = oldPages[i];
                var newPage = newPages[i];
                if ((oldPage.key !== newPage.key ||
                    oldPage.itemCount !== newPage.itemCount)) {
                    shouldComponentUpdate = true;
                    break;
                }
            }
        }
        else {
            shouldComponentUpdate = true;
        }
        return shouldComponentUpdate;
    };
    List.prototype.forceUpdate = function () {
        this._invalidatePageCache();
        // Ensure that when the list is force updated we update the pages first before render.
        this._updateRenderRects(this.props, true);
        this._updatePages();
        this._measureVersion++;
        _super.prototype.forceUpdate.call(this);
    };
    List.prototype.render = function () {
        var _a = this.props, className = _a.className, role = _a.role;
        var _b = this.state.pages, pages = _b === void 0 ? [] : _b;
        var pageElements = [];
        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
        for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
            var page = pages_1[_i];
            pageElements.push(this._renderPage(page));
        }
        // console.log(`Page elements ${pageElements.length}`);
        return (React.createElement("div", tslib_1.__assign({ ref: 'root' }, divProps, { role: (role === undefined) ? 'list' : role, className: Utilities_1.css('ms-List', className) }),
            React.createElement("div", { ref: 'surface', className: Utilities_1.css('ms-List-surface'), role: 'presentation' }, pageElements)));
    };
    List.prototype._shouldVirtualize = function (props) {
        if (props === void 0) { props = this.props; }
        var onShouldVirtualize = props.onShouldVirtualize;
        return !onShouldVirtualize || onShouldVirtualize(props);
    };
    /**
     * when props.items change or forceUpdate called, throw away cached pages
     */
    List.prototype._invalidatePageCache = function () {
        this._pageCache = {};
    };
    List.prototype._renderPage = function (page) {
        var usePageCache = this.props.usePageCache;
        var cachedPage;
        // if usePageCache is set and cached page element can be found, just return cached page
        if (usePageCache) {
            cachedPage = this._pageCache[page.key];
            if (cachedPage && cachedPage.pageElement) {
                return cachedPage.pageElement;
            }
        }
        var pageStyle = this._getPageStyle(page);
        var _a = this.props.onRenderPage, onRenderPage = _a === void 0 ? this._onRenderPage : _a;
        var pageElement = onRenderPage({
            page: page,
            className: Utilities_1.css('ms-List-page'),
            key: page.key,
            ref: page.key,
            style: pageStyle,
            role: 'presentation'
        }, this._onRenderPage);
        // cache the first page for now since it is re-rendered a lot times unncessarily.
        // todo: a more aggresive caching mechanism is to cache pages constaining the items not changed.
        // now we re-render pages too frequently, for example, props.items increased from 30 to 60, although the
        // first 30 items did not change, we still re-rendered all of them in this props.items change.
        if (usePageCache && page.startIndex === 0) {
            this._pageCache[page.key] = {
                page: page,
                pageElement: pageElement
            };
        }
        return pageElement;
    };
    /** Generate the style object for the page. */
    List.prototype._getPageStyle = function (page) {
        var getPageStyle = this.props.getPageStyle;
        return tslib_1.__assign({}, (getPageStyle ? getPageStyle(page) : {}), (!page.items ? {
            height: page.height
        } : {}));
    };
    List.prototype._onRenderPage = function (pageProps, defaultRender) {
        var _this = this;
        var _a = this.props, onRenderCell = _a.onRenderCell, role = _a.role;
        var _b = pageProps.page, items = _b.items, startIndex = _b.startIndex, divProps = tslib_1.__rest(pageProps, ["page"]);
        // only assign list item role if no role is assigned
        var cellRole = (role === undefined) ? 'listitem' : 'presentation';
        var cells = (items || []).map(function (item, offset) {
            var index = startIndex + offset;
            var itemKey = _this.props.getKey ?
                _this.props.getKey(item, index) :
                item && item.key;
            if (itemKey === null || itemKey === undefined) {
                itemKey = index;
            }
            return (React.createElement("div", { role: cellRole, className: Utilities_1.css('ms-List-cell'), key: itemKey, "data-list-index": index, "data-automationid": 'ListCell' }, onRenderCell && onRenderCell(item, index, _this.state.isScrolling)));
        });
        return (React.createElement("div", tslib_1.__assign({}, divProps), cells));
    };
    /** Track the last item index focused so that we ensure we keep it rendered. */
    List.prototype._onFocus = function (ev) {
        var target = ev.target;
        while (target !== this.refs.surface) {
            var indexString = target.getAttribute('data-list-index');
            if (indexString) {
                this._focusedIndex = Number(indexString);
                break;
            }
            target = Utilities_1.getParent(target);
        }
    };
    /**
     * Called synchronously to reset the required render range to 0 on scrolling. After async scroll has executed,
     * we will call onAsyncIdle which will reset it back to it's correct value.
     */
    List.prototype._onScroll = function () {
        if (!this.state.isScrolling) {
            this.setState({ isScrolling: true });
        }
        this._resetRequiredWindows();
        this._onScrollingDone();
    };
    List.prototype._resetRequiredWindows = function () {
        this._requiredWindowsAhead = 0;
        this._requiredWindowsBehind = 0;
    };
    /**
     * Debounced method to asynchronously update the visible region on a scroll event.
     */
    List.prototype._onAsyncScroll = function () {
        this._updateRenderRects();
        // Only update pages when the visible rect falls outside of the materialized rect.
        if (!this._materializedRect || !_isContainedWithin(this._requiredRect, this._materializedRect)) {
            this._updatePages();
        }
        else {
            // console.log('requiredRect contained in materialized', this._requiredRect, this._materializedRect);
        }
    };
    /**
     * This is an async debounced method that will try and increment the windows we render. If we can increment
     * either, we increase the amount we render and re-evaluate.
     */
    List.prototype._onAsyncIdle = function () {
        var _a = this.props, renderedWindowsAhead = _a.renderedWindowsAhead, renderedWindowsBehind = _a.renderedWindowsBehind;
        var _b = this, requiredWindowsAhead = _b._requiredWindowsAhead, requiredWindowsBehind = _b._requiredWindowsBehind;
        var windowsAhead = Math.min(renderedWindowsAhead, requiredWindowsAhead + 1);
        var windowsBehind = Math.min(renderedWindowsBehind, requiredWindowsBehind + 1);
        if (windowsAhead !== requiredWindowsAhead || windowsBehind !== requiredWindowsBehind) {
            // console.log('idling', windowsBehind, windowsAhead);
            this._requiredWindowsAhead = windowsAhead;
            this._requiredWindowsBehind = windowsBehind;
            this._updateRenderRects();
            this._updatePages();
        }
        if (renderedWindowsAhead > windowsAhead || renderedWindowsBehind > windowsBehind) {
            // Async increment on next tick.
            this._onAsyncIdle();
        }
    };
    /**
     * Function to call when the list is done scrolling.
     * This function is debounced.
     */
    List.prototype._onScrollingDone = function () {
        this.setState({ isScrolling: false });
    };
    List.prototype._onAsyncResize = function () {
        this.forceUpdate();
    };
    List.prototype._updatePages = function (props) {
        // console.log('updating pages');
        var _this = this;
        if (props === void 0) { props = this.props; }
        if (!this._requiredRect) {
            this._updateRenderRects(props);
        }
        var newListState = this._buildPages(props);
        var oldListPages = this.state.pages;
        this.setState(newListState, function () {
            // If measured version is invalid since we've updated the DOM
            var heightsChanged = _this._updatePageMeasurements(oldListPages, newListState.pages);
            // On first render, we should re-measure so that we don't get a visual glitch.
            if (heightsChanged) {
                _this._materializedRect = null;
                if (!_this._hasCompletedFirstRender) {
                    _this._hasCompletedFirstRender = true;
                    _this._updatePages(props);
                }
                else {
                    _this._onAsyncScroll();
                }
            }
            else {
                // Enqueue an idle bump.
                _this._onAsyncIdle();
            }
        });
    };
    List.prototype._updatePageMeasurements = function (oldPages, newPages) {
        var renderedIndexes = {};
        var heightChanged = false;
        // when not in virtualize mode, we render all the items without page measurement
        if (!this._shouldVirtualize()) {
            return heightChanged;
        }
        for (var i = 0; i < oldPages.length; i++) {
            var page = oldPages[i];
            if (page.items) {
                renderedIndexes[page.startIndex] = page;
            }
        }
        for (var i = 0; i < newPages.length; i++) {
            var page = newPages[i];
            if (page.items) {
                heightChanged = this._measurePage(page) || heightChanged;
                if (!renderedIndexes[page.startIndex]) {
                    this._onPageAdded(page);
                }
                else {
                    delete renderedIndexes[page.startIndex];
                }
            }
        }
        for (var index in renderedIndexes) {
            if (renderedIndexes.hasOwnProperty(index)) {
                this._onPageRemoved(renderedIndexes[index]);
            }
        }
        return heightChanged;
    };
    /**
     * Given a page, measure its dimensions, update cache.
     * @returns True if the height has changed.
     */
    List.prototype._measurePage = function (page) {
        var hasChangedHeight = false;
        var pageElement = this.refs[page.key];
        var cachedHeight = this._cachedPageHeights[page.startIndex];
        // console.log('   * measure attempt', page.startIndex, cachedHeight);
        if (pageElement && this._shouldVirtualize() && (!cachedHeight || cachedHeight.measureVersion !== this._measureVersion)) {
            var newClientRect = {
                width: pageElement.clientWidth,
                height: pageElement.clientHeight
            };
            if (newClientRect.height || newClientRect.width) {
                hasChangedHeight = page.height !== newClientRect.height;
                // console.warn(' *** expensive page measure', page.startIndex, page.height, newClientRect.height);
                page.height = newClientRect.height;
                this._cachedPageHeights[page.startIndex] = {
                    height: newClientRect.height,
                    measureVersion: this._measureVersion
                };
                this._estimatedPageHeight = Math.round(((this._estimatedPageHeight * this._totalEstimates) + newClientRect.height) /
                    (this._totalEstimates + 1));
                this._totalEstimates++;
            }
        }
        return hasChangedHeight;
    };
    /** Called when a page has been added to the DOM. */
    List.prototype._onPageAdded = function (page) {
        var onPageAdded = this.props.onPageAdded;
        // console.log('page added', page.startIndex, this.state.pages.map(page => page.key).join(', '));
        if (onPageAdded) {
            onPageAdded(page);
        }
    };
    /** Called when a page has been removed from the DOM. */
    List.prototype._onPageRemoved = function (page) {
        var onPageRemoved = this.props.onPageRemoved;
        // console.log('  --- page removed', page.startIndex, this.state.pages.map(page => page.key).join(', '));
        if (onPageRemoved) {
            onPageRemoved(page);
        }
    };
    /** Build up the pages that should be rendered. */
    List.prototype._buildPages = function (props) {
        var items = props.items, startIndex = props.startIndex, renderCount = props.renderCount, getPageHeight = props.getPageHeight;
        renderCount = this._getRenderCount(props);
        var materializedRect = tslib_1.__assign({}, EMPTY_RECT);
        var pages = [];
        var itemsPerPage = 1;
        var pageTop = 0;
        var currentSpacer = null;
        var focusedIndex = this._focusedIndex;
        var endIndex = startIndex + renderCount;
        var shouldVirtualize = this._shouldVirtualize(props);
        // First render is very important to track; when we render cells, we have no idea of estimated page height.
        // So we should default to rendering only the first page so that we can get information.
        // However if the user provides a measure function, let's just assume they know the right heights.
        var isFirstRender = this._estimatedPageHeight === 0 && !getPageHeight;
        var allowedRect = this._allowedRect;
        var _loop_1 = function (itemIndex) {
            var pageSpecification = this_1._getPageSpecification(itemIndex, allowedRect);
            var pageHeight = pageSpecification.height;
            var pageData = pageSpecification.data;
            itemsPerPage = pageSpecification.itemCount;
            var pageBottom = pageTop + pageHeight - 1;
            var isPageRendered = Utilities_1.findIndex(this_1.state.pages, function (page) { return !!page.items && page.startIndex === itemIndex; }) > -1;
            var isPageInAllowedRange = !allowedRect || pageBottom >= allowedRect.top && pageTop <= allowedRect.bottom;
            var isPageInRequiredRange = !this_1._requiredRect || pageBottom >= this_1._requiredRect.top && pageTop <= this_1._requiredRect.bottom;
            var isPageVisible = !isFirstRender && (isPageInRequiredRange || (isPageInAllowedRange && isPageRendered)) || !shouldVirtualize;
            var isPageFocused = focusedIndex >= itemIndex && focusedIndex < (itemIndex + itemsPerPage);
            var isFirstPage = itemIndex === startIndex;
            // console.log('building page', itemIndex, 'pageTop: ' + pageTop, 'inAllowed: ' + isPageInAllowedRange, 'inRequired: ' + isPageInRequiredRange);
            // Only render whats visible, focused, or first page,
            // or when running in fast rendering mode (not in virtualized mode), we render all current items in pages
            if (isPageVisible || isPageFocused || isFirstPage) {
                if (currentSpacer) {
                    pages.push(currentSpacer);
                    currentSpacer = null;
                }
                var itemsInPage = Math.min(itemsPerPage, endIndex - itemIndex);
                var newPage = this_1._createPage(undefined, items.slice(itemIndex, itemIndex + itemsInPage), itemIndex, undefined, undefined, pageData);
                newPage.top = pageTop;
                newPage.height = pageHeight;
                pages.push(newPage);
                if (isPageInRequiredRange && this_1._allowedRect) {
                    _mergeRect(materializedRect, {
                        top: pageTop,
                        bottom: pageBottom,
                        height: pageHeight,
                        left: allowedRect.left,
                        right: allowedRect.right,
                        width: allowedRect.width
                    });
                }
            }
            else {
                if (!currentSpacer) {
                    currentSpacer = this_1._createPage('spacer-' + itemIndex, undefined, itemIndex, 0, undefined, pageData);
                }
                currentSpacer.height = (currentSpacer.height || 0) + (pageBottom - pageTop) + 1;
                currentSpacer.itemCount += itemsPerPage;
            }
            pageTop += (pageBottom - pageTop + 1);
            // in virtualized mode, we render need to render first page then break and measure,
            // otherwise, we render all items without measurement to make rendering fast
            if (isFirstRender && shouldVirtualize) {
                return "break";
            }
        };
        var this_1 = this;
        for (var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage) {
            var state_1 = _loop_1(itemIndex);
            if (state_1 === "break")
                break;
        }
        if (currentSpacer) {
            currentSpacer.key = 'spacer-end';
            pages.push(currentSpacer);
        }
        this._materializedRect = materializedRect;
        // console.log('materialized: ', materializedRect);
        return {
            pages: pages,
            measureVersion: this._measureVersion
        };
    };
    List.prototype._getPageSpecification = function (itemIndex, visibleRect) {
        var getPageSpecification = this.props.getPageSpecification;
        if (getPageSpecification) {
            var pageData = getPageSpecification(itemIndex, visibleRect);
            var _a = pageData.itemCount, itemCount = _a === void 0 ? this._getItemCountForPage(itemIndex, visibleRect) : _a;
            var _b = pageData.height, height = _b === void 0 ? this._getPageHeight(itemIndex, itemCount, visibleRect) : _b;
            return {
                itemCount: itemCount,
                height: height,
                data: pageData.data
            };
        }
        else {
            var itemCount = this._getItemCountForPage(itemIndex, visibleRect);
            return {
                itemCount: itemCount,
                height: this._getPageHeight(itemIndex, itemCount, visibleRect)
            };
        }
    };
    /**
     * Get the pixel height of a give page. Will use the props getPageHeight first, and if not provided, fallback to
     * cached height, or estimated page height, or default page height.
     */
    List.prototype._getPageHeight = function (itemIndex, itemsPerPage, visibleRect) {
        if (this.props.getPageHeight) {
            return this.props.getPageHeight(itemIndex, visibleRect);
        }
        else {
            var cachedHeight = (this._cachedPageHeights[itemIndex]);
            return cachedHeight ? cachedHeight.height : (this._estimatedPageHeight || DEFAULT_PAGE_HEIGHT);
        }
    };
    List.prototype._getItemCountForPage = function (itemIndex, visibileRect) {
        var itemsPerPage = this.props.getItemCountForPage ? this.props.getItemCountForPage(itemIndex, visibileRect) : DEFAULT_ITEMS_PER_PAGE;
        return itemsPerPage ? itemsPerPage : DEFAULT_ITEMS_PER_PAGE;
    };
    List.prototype._createPage = function (pageKey, items, startIndex, count, style, data) {
        if (startIndex === void 0) { startIndex = -1; }
        if (count === void 0) { count = items ? items.length : 0; }
        if (style === void 0) { style = {}; }
        if (data === void 0) { data = undefined; }
        pageKey = pageKey || ('page-' + startIndex);
        var cachedPage = this._pageCache[pageKey];
        if (cachedPage && cachedPage.page) {
            return cachedPage.page;
        }
        // Fill undefined cells because array.map will ignore undefined cells.
        if (items) {
            for (var i = 0; i < items.length; i++) {
                items[i] = items[i] || undefined;
            }
        }
        return {
            key: pageKey,
            startIndex: startIndex,
            itemCount: count,
            items: items,
            style: style || {},
            top: 0,
            height: 0,
            data: data
        };
    };
    List.prototype._getRenderCount = function (props) {
        var _a = props || this.props, items = _a.items, startIndex = _a.startIndex, renderCount = _a.renderCount;
        return (renderCount === undefined ? (items ? items.length - startIndex : 0) : renderCount);
    };
    /** Calculate the visible rect within the list where top: 0 and left: 0 is the top/left of the list. */
    List.prototype._updateRenderRects = function (props, forceUpdate) {
        props = props || this.props;
        var renderedWindowsAhead = props.renderedWindowsAhead, renderedWindowsBehind = props.renderedWindowsBehind;
        var pages = this.state.pages;
        // when not in virtualize mode, we render all items without measurement to optimize page rendering perf
        if (!this._shouldVirtualize()) {
            return;
        }
        var surfaceRect = this._surfaceRect;
        var scrollHeight = this._scrollElement && this._scrollElement.scrollHeight;
        var scrollTop = this._scrollElement ? this._scrollElement.scrollTop : 0;
        // WARNING: EXPENSIVE CALL! We need to know the surface top relative to the window.
        // This needs to be called to recalculate when new pages should be loaded.
        // We check to see how far we've scrolled and if it's further than a third of a page we run it again.
        if (forceUpdate ||
            !pages ||
            !this._surfaceRect ||
            !scrollHeight ||
            scrollHeight !== this._scrollHeight ||
            Math.abs(this._scrollTop - scrollTop) > this._estimatedPageHeight / 3) {
            surfaceRect = this._surfaceRect = _measureSurfaceRect(this.refs.surface);
            this._scrollTop = scrollTop;
        }
        // If the scroll height has changed, something in the container likely resized and
        // we should redo the page heights incase their content resized.
        if (forceUpdate ||
            !scrollHeight ||
            scrollHeight !== this._scrollHeight) {
            this._measureVersion++;
        }
        this._scrollHeight = scrollHeight;
        // If the surface is above the container top or below the container bottom, or if this is not the first
        // render return empty rect.
        // The first time the list gets rendered we need to calculate the rectangle. The width of the list is
        // used to calculate the width of the list items.
        var visibleTop = Math.max(0, -surfaceRect.top);
        var visibleRect = {
            top: visibleTop,
            left: surfaceRect.left,
            bottom: visibleTop + window.innerHeight,
            right: surfaceRect.right,
            width: surfaceRect.width,
            height: window.innerHeight
        };
        // The required/allowed rects are adjusted versions of the visible rect.
        this._requiredRect = _expandRect(visibleRect, this._requiredWindowsBehind, this._requiredWindowsAhead);
        this._allowedRect = _expandRect(visibleRect, renderedWindowsBehind, renderedWindowsAhead);
    };
    List.defaultProps = {
        startIndex: 0,
        onRenderCell: function (item, index, containsFocus) { return (React.createElement("div", null, (item && item.name) || '')); },
        renderedWindowsAhead: DEFAULT_RENDERED_WINDOWS_AHEAD,
        renderedWindowsBehind: DEFAULT_RENDERED_WINDOWS_BEHIND
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], List.prototype, "_onRenderPage", null);
    return List;
}(Utilities_1.BaseComponent));
exports.List = List;
function _expandRect(rect, pagesBefore, pagesAfter) {
    var top = rect.top - (pagesBefore * rect.height);
    var height = rect.height + ((pagesBefore + pagesAfter) * rect.height);
    return {
        top: top,
        bottom: top + height,
        height: height,
        left: rect.left,
        right: rect.right,
        width: rect.width
    };
}
function _isContainedWithin(innerRect, outerRect) {
    return (innerRect.top >= outerRect.top &&
        innerRect.left >= outerRect.left &&
        innerRect.bottom <= outerRect.bottom &&
        innerRect.right <= outerRect.right);
}
function _mergeRect(targetRect, newRect) {
    targetRect.top = (newRect.top < targetRect.top || targetRect.top === -1) ? newRect.top : targetRect.top;
    targetRect.left = (newRect.left < targetRect.left || targetRect.left === -1) ? newRect.left : targetRect.left;
    targetRect.bottom = (newRect.bottom > targetRect.bottom || targetRect.bottom === -1) ? newRect.bottom : targetRect.bottom;
    targetRect.right = (newRect.right > targetRect.right || targetRect.right === -1) ? newRect.right : targetRect.right;
    targetRect.width = targetRect.right - targetRect.left + 1;
    targetRect.height = targetRect.bottom - targetRect.top + 1;
    return targetRect;
}
//# sourceMappingURL=List.js.map

/***/ }),

/***/ 2127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getExtensibilityState_1 = __webpack_require__(2043);
var legacy_1 = __webpack_require__(1);
var AdapterManager_1 = __webpack_require__(2109);
var internalAction = function terminateTaskPaneAddinCommandAction(state) {
    var hostItemIndex = state.runningTaskPaneAddinCommand.hostItemIndex;
    state.runningTaskPaneAddinCommand = null;
    var adapter = AdapterManager_1.getAdapter(hostItemIndex);
    adapter.collapsePaneUnderlay();
};
internalAction = legacy_1.action('terminateTaskPaneAddinCommandAction')(internalAction);
function terminateTaskPaneAddinCommand() {
    var state = getExtensibilityState_1.default();
    if (!state.runningTaskPaneAddinCommand) {
        return;
    }
    internalAction(state);
}
exports.default = terminateTaskPaneAddinCommand;
//# sourceMappingURL=terminateTaskPaneAddinCommandAction.js.map

/***/ }),

/***/ 2128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LoadState;
(function (LoadState) {
    LoadState[LoadState["OptionsNotLoaded"] = 0] = "OptionsNotLoaded";
    LoadState[LoadState["OptionsLoading"] = 1] = "OptionsLoading";
    LoadState[LoadState["OptionsLoaded"] = 2] = "OptionsLoaded";
})(LoadState = exports.LoadState || (exports.LoadState = {}));
//# sourceMappingURL=OwsOptionsStore.js.map

/***/ }),

/***/ 2129:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 2130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ApiError = /** @class */ (function () {
    function ApiError(errorCode) {
        this.errorCode = errorCode;
    }
    return ApiError;
}());
exports.default = ApiError;
//# sourceMappingURL=ApiError.js.map

/***/ }),

/***/ 2131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(1740);
/**
 * Gets the host item in an easily mockable way
 * @param {string} hostItemIndex
 * @returns ExtensibilityHostItem
 */
function getHostItem(hostItemIndex) {
    return Store_1.default.HostItems.get(hostItemIndex);
}
exports.default = getHostItem;
//# sourceMappingURL=getHostItem.js.map

/***/ }),

/***/ 2132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2189), exports);
tslib_1.__exportStar(__webpack_require__(2190), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function convertToIContextualMenuItem(hostItemIndex, item) {
    if (item.getClickHandler) {
        item.onClick = item.getClickHandler(hostItemIndex);
    }
    else if (item.sectionProps) {
        var items = item.sectionProps.items;
        items.forEach(function (menuItem) {
            convertToIContextualMenuItem(hostItemIndex, menuItem);
        });
    }
    else if (item.subMenuProps) {
        var items = item.subMenuProps.items;
        items.forEach(function (menuItem) {
            convertToIContextualMenuItem(hostItemIndex, menuItem);
        });
    }
}
exports.convertToIContextualMenuItem = convertToIContextualMenuItem;
//# sourceMappingURL=AddinCommandSurfaceAction.js.map

/***/ }),

/***/ 2134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2122);
function getOptionsForFeature(feature) {
    return store_1.default.options[feature];
}
exports.default = getOptionsForFeature;
//# sourceMappingURL=getOptionsForFeature.js.map

/***/ }),

/***/ 2137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExtensibilityModeEnum_1 = __webpack_require__(2044);
/**
 * The object that keeps track of the enabled addin commands in the store.
 *
 * @export
 * @class EnabledAddinCommands
 */
var EnabledAddinCommands = /** @class */ (function () {
    /**
     * Creates an instance of EnabledAddinCommands.
     */
    function EnabledAddinCommands() {
        this.isInitialized = false;
        this.appointmentAttendeeAddins = [];
        this.appointmentOrganizerAddins = [];
        this.detectedEntityAddins = [];
        this.messageReadAddins = [];
        this.messageComposeAddins = [];
        this.meetingRequestAddins = [];
        this.trapOnSendMessageAddins = [];
    }
    /**
     * Gets the appropriate list given the mode of the item we are on.
     *
     * @param {ExtensibilityModeEnum} mode (The mode of the host item)
     * @returns (The appropriate list for the given mode)
     */
    EnabledAddinCommands.prototype.getExtensionPoint = function (mode) {
        switch (mode) {
            case ExtensibilityModeEnum_1.default.MeetingRequest:
                return this.meetingRequestAddins;
            case ExtensibilityModeEnum_1.default.AppointmentAttendee:
                return this.appointmentAttendeeAddins;
            case ExtensibilityModeEnum_1.default.AppointmentOrganizer:
                return this.appointmentOrganizerAddins;
            case ExtensibilityModeEnum_1.default.DetectedEntity:
                return this.detectedEntityAddins;
            case ExtensibilityModeEnum_1.default.MessageCompose:
                return this.messageReadAddins;
            case ExtensibilityModeEnum_1.default.MessageRead:
                return this.messageComposeAddins;
            case ExtensibilityModeEnum_1.default.TrapOnSendEvent:
                return this.trapOnSendMessageAddins;
            default:
                return null;
        }
    };
    /**
     * Sets the appropriate list given the mode of the item we are on.
     *
     * @param {IAddin[]} value (The new valuye for the array.)
     * @param {ExtensibilityModeEnum} mode (The mode of the host item)
     */
    EnabledAddinCommands.prototype.setExtensionPoint = function (value, mode) {
        switch (mode) {
            case ExtensibilityModeEnum_1.default.MeetingRequest:
                this.meetingRequestAddins = value;
                break;
            case ExtensibilityModeEnum_1.default.AppointmentAttendee:
                this.appointmentAttendeeAddins = value;
                break;
            case ExtensibilityModeEnum_1.default.AppointmentOrganizer:
                this.appointmentOrganizerAddins = value;
                break;
            case ExtensibilityModeEnum_1.default.DetectedEntity:
                this.detectedEntityAddins = value;
                break;
            case ExtensibilityModeEnum_1.default.MessageCompose:
                this.messageReadAddins = value;
                break;
            case ExtensibilityModeEnum_1.default.MessageRead:
                this.messageComposeAddins = value;
                break;
            case ExtensibilityModeEnum_1.default.TrapOnSendEvent:
                this.trapOnSendMessageAddins = value;
                break;
            default:
        }
    };
    return EnabledAddinCommands;
}());
exports.default = EnabledAddinCommands;
//# sourceMappingURL=EnabledAddinCommands.js.map

/***/ }),

/***/ 2138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserType;
(function (UserType) {
    UserType[UserType["consumer"] = 0] = "consumer";
    UserType[UserType["office365"] = 1] = "office365";
    UserType[UserType["enterprise"] = 2] = "enterprise";
})(UserType = exports.UserType || (exports.UserType = {}));
function getUserType(userConfig) {
    if (userConfig.IsConsumerChild) {
        return UserType.consumer;
    }
    else if (userConfig.SessionSettings && userConfig.SessionSettings.IsBposUser) {
        return UserType.office365;
    }
    return UserType.enterprise;
}
exports.getUserType = getUserType;
//# sourceMappingURL=UserType.js.map

/***/ }),

/***/ 2139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(1740);
var terminateTaskPaneAddinCommandAction_1 = __webpack_require__(2127);
var legacy_1 = __webpack_require__(1);
var OnHostItemChangedStatus;
(function (OnHostItemChangedStatus) {
    OnHostItemChangedStatus[OnHostItemChangedStatus["Selected"] = 0] = "Selected";
    OnHostItemChangedStatus[OnHostItemChangedStatus["Deselected"] = 1] = "Deselected";
})(OnHostItemChangedStatus = exports.OnHostItemChangedStatus || (exports.OnHostItemChangedStatus = {}));
exports.default = legacy_1.select({
    hostItem: function (hostItemIndex) { return Store_1.default.HostItems.get(hostItemIndex); },
})(legacy_1.action('onHostItemChanged')(function onHostItemChanged(hostItemIndex, selectionStatus, state) {
    if (selectionStatus == OnHostItemChangedStatus.Deselected) {
        terminateTaskPaneAddinCommandAction_1.default();
    }
}));
//# sourceMappingURL=OnHostItemChanged.js.map

/***/ }),

/***/ 2141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2213), exports);
//# sourceMappingURL=SearchBox.js.map

/***/ }),

/***/ 2145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getHostItem_1 = __webpack_require__(2131);
var mobx_1 = __webpack_require__(15);
function hasHighlightableTerms(index) {
    return !!getHostItem_1.default(index) && getHostItem_1.default(index).contextualTerms != null;
}
exports.hasHighlightableTerms = hasHighlightableTerms;
function getHighlightableTerms(index) {
    if (!hasHighlightableTerms(index)) {
        return null;
    }
    return getHostItem_1.default(index).contextualTerms.keys();
}
exports.getHighlightableTerms = getHighlightableTerms;
function whenItemHasContextualAddinKeywords(hostItemIndex, delegate) {
    return mobx_1.when(function () { return hasHighlightableTerms(hostItemIndex); }, function () { return delegate(getHighlightableTerms(hostItemIndex)); });
}
exports.default = whenItemHasContextualAddinKeywords;
//# sourceMappingURL=HighlightableTermsObserver.js.map

/***/ }),

/***/ 2146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function InitializeContextualCalloutState() {
    return {
        activeContextualAddinCommands: [],
        contextualAnchor: null,
        hostItemIndex: null,
        selectedTerms: [],
    };
}
exports.InitializeContextualCalloutState = InitializeContextualCalloutState;
//# sourceMappingURL=ContextualCalloutState.js.map

/***/ }),

/***/ 2147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getComposeHostItemIndex = function (id) {
    return "extCompose_" + id;
};
exports.getReadHostItemIndex = function (itemId) {
    return "extRead_" + itemId;
};
//# sourceMappingURL=HostItemIndex.js.map

/***/ }),

/***/ 2153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var store_1 = __webpack_require__(1705);
var conversationsLoadedAction_1 = __webpack_require__(2047);
exports.default = satcheljs_1.mutator(conversationsLoadedAction_1.default, function (actionMessage) {
    store_1.default.isLoading = false;
    store_1.default.isError = false;
    if (actionMessage.recipientEmail) {
        store_1.default.emailRecipientConversations.set(actionMessage.recipientEmail, actionMessage.conversations);
    }
});
//# sourceMappingURL=conversationsLoadedMutator.js.map

/***/ }),

/***/ 2154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var store_1 = __webpack_require__(1705);
var oneRecipientSelectedAction_1 = __webpack_require__(2048);
exports.default = satcheljs_1.mutator(oneRecipientSelectedAction_1.default, function (actionMessage) {
    if (actionMessage.persona.EmailAddress && actionMessage.persona.EmailAddress.EmailAddress) {
        store_1.default.isLoading = true;
        store_1.default.isError = false;
    }
});
//# sourceMappingURL=oneRecipientSelectedMutator.js.map

/***/ }),

/***/ 2155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var store_1 = __webpack_require__(1705);
var onSubjectConversationSelectedAction_1 = __webpack_require__(2049);
exports.default = satcheljs_1.mutator(onSubjectConversationSelectedAction_1.default, function (actionMessage) {
    store_1.default.selectedConversationId = actionMessage.conversationId;
});
//# sourceMappingURL=subjectConversationSelectedMutator.js.map

/***/ }),

/***/ 2159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 2564));
});
exports.ReactEditor = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.ReactEditor; });
exports.lazyCreateUndo = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.createUndo; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2160:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","__DEV__":false}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(2191);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(2192);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(640), __webpack_require__(2129)))

/***/ }),

/***/ 2165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RIBBON_BUTTON_FONT_NAME = 'fontname';
exports.RIBBON_BUTTON_FONT_SIZE = 'fontsize';
exports.RIBBON_BUTTON_BOLD = 'bold';
exports.RIBBON_BUTTON_ITALIC = 'italic';
exports.RIBBON_BUTTON_UNDERLINE = 'underline';
exports.RIBBON_BUTTON_BACK_COLOR = 'backcolor';
exports.RIBBON_BUTTON_TEXT_COLOR = 'textcolor';
exports.RIBBON_BUTTON_BULLETS = 'bullets';
exports.RIBBON_BUTTON_NUMBERING = 'numbering';
exports.RIBBON_BUTTON_INDENT = 'indent';
exports.RIBBON_BUTTON_OUTDENT = 'outdent';
exports.RIBBON_BUTTON_ALIGN_LEFT = 'alignleft';
exports.RIBBON_BUTTON_ALIGN_CENTER = 'aligncenter';
exports.RIBBON_BUTTON_ALIGN_RIGHT = 'alignright';
exports.RIBBON_BUTTON_CREATE_LINK = 'createlink';
exports.RIBBON_BUTTON_UNLINK = 'unlink';
exports.RIBBON_BUTTON_SUBSCRIPT = 'subscript';
exports.RIBBON_BUTTON_SUPERSCRIPT = 'superscript';
exports.RIBBON_BUTTON_STRIKETHROUGH = 'strikethrough';
exports.RIBBON_BUTTON_ADDIMAGEALTTEXT = 'alttext';
exports.RIBBON_BUTTON_LEFTTORIGHT = 'ltr';
exports.RIBBON_BUTTON_RIGHTTOLEFT = 'rtl';
exports.RIBBON_BUTTON_UNDO = 'undo';
exports.RIBBON_BUTTON_REDO = 'redo';
exports.RIBBON_BUTTON_REMOVE_FORMAT = 'removeformat';
exports.RIBBON_BUTTON_AFFORDANCE = 'more';
exports.RIBBON_BUTTON_FORMATPAINTER = 'formatPainter';
exports.RIBBON_BUTTON_BLOCKQUOTE = 'blockquote';
/**
 * Complete ribbon button list. This is also the order of buttons as they appear in ribbon and should be maintained as it is.
 * NOTE: this does not include affordance which is handled separately
 */
exports.RIBBON_BUTTON_LIST = [
    exports.RIBBON_BUTTON_FORMATPAINTER,
    exports.RIBBON_BUTTON_FONT_NAME,
    exports.RIBBON_BUTTON_FONT_SIZE,
    exports.RIBBON_BUTTON_BOLD,
    exports.RIBBON_BUTTON_ITALIC,
    exports.RIBBON_BUTTON_UNDERLINE,
    exports.RIBBON_BUTTON_BACK_COLOR,
    exports.RIBBON_BUTTON_TEXT_COLOR,
    exports.RIBBON_BUTTON_BULLETS,
    exports.RIBBON_BUTTON_NUMBERING,
    exports.RIBBON_BUTTON_OUTDENT,
    exports.RIBBON_BUTTON_INDENT,
    exports.RIBBON_BUTTON_BLOCKQUOTE,
    exports.RIBBON_BUTTON_ALIGN_LEFT,
    exports.RIBBON_BUTTON_ALIGN_CENTER,
    exports.RIBBON_BUTTON_ALIGN_RIGHT,
    exports.RIBBON_BUTTON_CREATE_LINK,
    exports.RIBBON_BUTTON_UNLINK,
    exports.RIBBON_BUTTON_SUPERSCRIPT,
    exports.RIBBON_BUTTON_SUBSCRIPT,
    exports.RIBBON_BUTTON_STRIKETHROUGH,
    exports.RIBBON_BUTTON_ADDIMAGEALTTEXT,
    exports.RIBBON_BUTTON_LEFTTORIGHT,
    exports.RIBBON_BUTTON_RIGHTTOLEFT,
    exports.RIBBON_BUTTON_UNDO,
    exports.RIBBON_BUTTON_REDO,
    exports.RIBBON_BUTTON_REMOVE_FORMAT,
];
//# sourceMappingURL=ButtonNames.js.map

/***/ }),

/***/ 2188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getUserConfiguration_1 = __webpack_require__(9);
var owa_format_options_1 = __webpack_require__(2132);
// default composing font family (this should match the Calibri font in the FONT_NAME_LIST in FontName.ts), font size and text color
var DEFAULT_FONT_FAMILY = 'Calibri,Arial,Helvetica,sans-serif';
var DEFAULT_FONT_SIZE = '11pt';
var DEFAULT_TEXT_COLOR = '#000000';
var DEFAULT_FORMAT = {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSize: DEFAULT_FONT_SIZE,
    textColor: DEFAULT_TEXT_COLOR,
    bold: false,
    italic: false,
    underline: false,
};
function getDefaultComposeFormat() {
    var userOption = getUserConfiguration_1.default().UserOptions;
    if (userOption) {
        return getComposeFormat(userOption.ComposeFontName, userOption.ComposeFontSize, userOption.ComposeFontColor, userOption.ComposeFontFlags);
    }
    else {
        return DEFAULT_FORMAT;
    }
}
exports.default = getDefaultComposeFormat;
function getComposeFormat(fontName, fontSize, fontColor, fontFlags) {
    var defaultFormat = tslib_1.__assign({}, DEFAULT_FORMAT);
    var composeFont = fontName ? owa_format_options_1.getFontFamily(fontName) : null;
    if (composeFont) {
        defaultFormat.fontFamily = composeFont;
    }
    var composeSize = fontSize ? owa_format_options_1.getFontSizeInPoints(fontSize) : null;
    if (composeSize) {
        defaultFormat.fontSize = composeSize;
    }
    if (fontColor) {
        defaultFormat.textColor = fontColor;
    }
    if (fontFlags) {
        defaultFormat.bold = (fontFlags & 1 /* Bold */) == 1 /* Bold */;
        defaultFormat.italic = (fontFlags & 2 /* Italic */) == 2 /* Italic */;
        defaultFormat.underline = (fontFlags & 4 /* Underline */) == 4 /* Underline */;
    }
    return defaultFormat;
}
exports.getComposeFormat = getComposeFormat;
//# sourceMappingURL=getDefaultComposeFormat.js.map

/***/ }),

/***/ 2189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// When localized name is missing, use the name
function getLocalizedFontName(fontName) {
    return fontName.localizedName ? fontName.localizedName : fontName.name;
}
exports.getLocalizedFontName = getLocalizedFontName;
exports.FONT_NAME_LIST = [
    { name: 'Arial', family: 'Arial,Helvetica,sans-serif' },
    { name: 'Arial Black', family: "'Arial Black',Arial,sans-serif" },
    { name: 'Calibri', family: 'Calibri,Helvetica,sans-serif' },
    { name: 'Calibri Light', family: "'Calibri Light','Helvetica Light',sans-serif" },
    { name: 'Cambria', family: 'Cambria,Georgia,serif' },
    { name: 'Candara', family: 'Candara,Optima,sans-serif' },
    { name: 'Century Gothic', family: "'Century Gothic',sans-serif" },
    { name: 'Comic Sans MS', family: "'Comic Sans MS',Chalkboard,cursive" },
    { name: 'Consolas', family: 'Consolas,Courier,monospace' },
    { name: 'Constantia', family: "Constantia,'Hoefler Text',serif" },
    { name: 'Corbel', family: 'Corbel,Skia,sans-serif' },
    { name: 'Courier New', family: "'Courier New',monospace" },
    {
        name: 'Franklin Gothic Book',
        family: "'Franklin Gothic Book','Avenir Next Condensed',sans-serif",
    },
    {
        name: 'Franklin Gothic Demi',
        family: "'Franklin Gothic Demi','Avenir Next Condensed Demi Bold',sans-serif",
    },
    {
        name: 'Franklin Gothic Medium',
        family: "'Franklin Gothic Medium','Avenir Next Condensed Medium',sans-serif",
    },
    { name: 'Garamond', family: 'Garamond,Georgia,serif' },
    { name: 'Georgia', family: 'Georgia,serif' },
    { name: 'Impact', family: 'Impact,Charcoal,sans-serif' },
    { name: 'Lucida Console', family: "'Lucida Console',Monaco,monospace" },
    { name: 'Lucida Handwriting', family: "'Lucida Handwriting','Apple Chancery',cursive" },
    { name: 'Lucida Sans Unicode', family: "'Lucida Sans Unicode','Lucida Grande',sans-serif" },
    { name: 'Palatino Linotype', family: "'Palatino Linotype','Book Antiqua',Palatino,serif" },
    { name: 'Segoe UI', family: "'Segoe UI','Helvetica Neue',sans-serif" },
    { name: 'Sitka Heading', family: "'Sitka Heading',Cochin,serif" },
    { name: 'Sitka Text', family: "'Sitka Text',Cochin,serif" },
    { name: 'Tahoma', family: 'Tahoma,Geneva,sans-serif' },
    { name: 'Times', family: "Times,'Times New Roman',serif" },
    { name: 'Times New Roman', family: "'Times New Roman',Times,serif" },
    { name: 'Trebuchet MS', family: "'Trebuchet MS',Trebuchet,sans-serif" },
    { name: 'TW Cen MT', family: "'TW Cen MT','Century Gothic',sans-serif" },
    { name: 'Verdana', family: 'Verdana,Geneva,sans-serif' },
    { name: '-', family: '-' },
    {
        name: 'Microsoft YaHei',
        family: "'Microsoft YaHei','微软雅黑',STHeiti,sans-serif",
        localizedName: '微软雅黑',
    },
    { name: 'SimHei', family: "SimHei,'黑体',STHeiti,sans-serif", localizedName: '黑体' },
    {
        name: 'NSimSun',
        family: "NSimSun,'新宋体',SimSun,'宋体',SimSun-ExtB,'宋体-ExtB',STSong,serif",
        localizedName: '新宋体',
    },
    { name: 'FangSong', family: "FangSong,'仿宋',STFangsong,serif", localizedName: '仿宋' },
    { name: 'SimLi', family: "SimLi,'隶书','Baoli SC',serif", localizedName: '隶书' },
    { name: 'KaiTi', family: "KaiTi,'楷体',STKaiti,serif", localizedName: '楷体' },
    { name: '-', family: '-' },
    {
        name: 'Microsoft JhengHei',
        family: "'Microsoft JhengHei','微軟正黑體','Apple LiGothic',sans-serif",
        localizedName: '微軟正黑體',
    },
    {
        name: 'PMingLiU',
        family: "PMingLiU,'新細明體',PMingLiU-ExtB,'新細明體-ExtB','Apple LiSung',serif",
        localizedName: '新細明體',
    },
    { name: 'DFKai-SB', family: "DFKai-SB,'標楷體','BiauKai',serif", localizedName: '標楷體' },
    { name: '-', family: '-' },
    {
        name: 'Meiryo',
        family: "Meiryo,'メイリオ','Hiragino Sans',sans-serif",
        localizedName: 'メイリオ',
    },
    {
        name: 'MS PGothic',
        family: "'MS PGothic','ＭＳ Ｐゴシック','MS Gothic','ＭＳ ゴシック','Hiragino Kaku Gothic ProN',sans-serif",
        localizedName: 'ＭＳ Ｐゴシック',
    },
    {
        name: 'MS PMincho',
        family: "'MS PMincho','ＭＳ Ｐ明朝','MS Mincho','ＭＳ 明朝','Hiragino Mincho ProN',serif",
        localizedName: 'ＭＳ Ｐ明朝',
    },
    {
        name: 'Yu Gothic',
        family: "'Yu Gothic','游ゴシック','YuGothic',sans-serif",
        localizedName: '游ゴシック',
    },
    { name: 'Yu Mincho', family: "'Yu Mincho','游明朝','YuMincho',serif", localizedName: '游明朝' },
    { name: '-', family: '-' },
    {
        name: 'Malgun Gothic',
        family: "'Malgun Gothic','맑은 고딕',AppleGothic,sans-serif",
        localizedName: '맑은 고딕',
    },
    { name: 'Gulim', family: "Gulim,'굴림','Nanum Gothic',sans-serif", localizedName: '굴림' },
    { name: 'Dotum', family: "Dotum,'돋움',AppleGothic,sans-serif", localizedName: '돋움' },
    { name: 'Batang', family: "Batang,'바탕',AppleMyungjo,serif", localizedName: '바탕' },
    { name: 'BatangChe', family: "BatangChe,'바탕체',AppleMyungjo,serif", localizedName: '바탕체' },
    { name: 'Gungsuh', family: "Gungsuh,'궁서',GungSeo,serif", localizedName: '궁서' },
    { name: '-', family: '-' },
    { name: 'Leelawadee UI', family: "'Leelawadee UI',Thonburi,sans-serif" },
    { name: 'Angsana New', family: "'Angsana New','Leelawadee UI',Sathu,serif" },
    { name: 'Cordia New', family: "'Cordia New','Leelawadee UI',Silom,sans-serif" },
    { name: 'DaunPenh', family: "DaunPenh,'Leelawadee UI','Khmer MN',sans-serif" },
    { name: '-', family: '-' },
    { name: 'Nirmala UI', family: "'Nirmala UI',sans-serif" },
    { name: 'Gautami', family: "Gautami,'Nirmala UI','Telugu MN',sans-serif" },
    { name: 'Iskoola Pota', family: "'Iskoola Pota','Nirmala UI','Sinhala MN',sans-serif" },
    { name: 'Kalinga', family: "Kalinga,'Nirmala UI','Oriya MN',sans-serif" },
    { name: 'Kartika', family: "Kartika,'Nirmala UI','Malayalam MN',sans-serif" },
    { name: 'Latha', family: "Latha,'Nirmala UI','Tamil MN',sans-serif" },
    { name: 'Mangal', family: "Mangal,'Nirmala UI','Devanagari Sangam MN',sans-serif" },
    { name: 'Raavi', family: "Raavi,'Nirmala UI','Gurmukhi MN',sans-serif" },
    { name: 'Shruti', family: "Shruti,'Nirmala UI','Gujarati Sangam MN',sans-serif" },
    { name: 'Tunga', family: "Tunga,'Nirmala UI','Kannada MN',sans-serif" },
    { name: 'Vrinda', family: "Vrinda,'Nirmala UI','Bangla MN',sans-serif" },
    { name: '-', family: '-' },
    { name: 'Nyala', family: 'Nyala,Kefa,sans-serif' },
    { name: 'Sylfaen', family: 'Sylfaen,Mshtakan,Menlo,serif' },
];
// Given a short font string (can be the name or localized name), return font family
function getFontFamily(font) {
    var targetFont = font.toUpperCase();
    for (var i = 0; i < exports.FONT_NAME_LIST.length; i++) {
        var fn = exports.FONT_NAME_LIST[i];
        if (fn.name.toUpperCase() == targetFont ||
            (fn.localizedName && fn.localizedName.toUpperCase() == targetFont)) {
            return fn.family;
        }
    }
    return null;
}
exports.getFontFamily = getFontFamily;
//# sourceMappingURL=FontName.js.map

/***/ }),

/***/ 2190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(2160);
var POINTS = 'pt';
// This is mapping table from browser size (1-7) to PT
exports.FONTSIZE_MAPPING = [
    8 /*1*/,
    10 /*2*/,
    12 /*3*/,
    14 /*4*/,
    18 /*5*/,
    24 /*6*/,
    36 /*7*/,
];
exports.FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
// This list is used to populate font size picker drop down
exports.FONT_SIZE_LIST = exports.FONT_SIZES.map(function (size) { return size.toString(); });
function getFontSizeFromSizeOrIndex(sizeOrIndex) {
    return util_1.isNumber(sizeOrIndex) && sizeOrIndex <= 7
        ? exports.FONTSIZE_MAPPING[sizeOrIndex - 1]
        : sizeOrIndex;
}
exports.getFontSizeFromSizeOrIndex = getFontSizeFromSizeOrIndex;
function getFontSizeInPoints(size) {
    var result = getFontSizeFromSizeOrIndex(size).toString();
    return result ? result + POINTS : result;
}
exports.getFontSizeInPoints = getFontSizeInPoints;
//# sourceMappingURL=FontSize.js.map

/***/ }),

/***/ 2191:
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 2192:
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 2210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_fabric_theme_1 = __webpack_require__(242);
function isDarkTheme() {
    return owa_fabric_theme_1.getIsDarkTheme();
}
exports.default = isDarkTheme;
//# sourceMappingURL=isDarkTheme.js.map

/***/ }),

/***/ 2211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function createFormatState() {
    return {
        fontName: '',
        fontSize: '',
        isBold: false,
        isItalic: false,
        isUnderline: false,
        backgroundColor: '',
        textColor: '',
        isBullet: false,
        isNumbering: false,
        isStrikeThrough: false,
        isSubscript: false,
        isSuperscript: false,
        isBlockQuote: false,
        canUnlink: false,
        canAddImageAltText: false,
        canUndo: false,
        canRedo: false,
    };
}
exports.default = createFormatState;
//# sourceMappingURL=createFormatState.js.map

/***/ }),

/***/ 2213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2214), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Icon_1 = __webpack_require__(43);
var stylesImport = __webpack_require__(2215);
var styles = stylesImport;
var SearchBox = /** @class */ (function (_super) {
    tslib_1.__extends(SearchBox, _super);
    function SearchBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.value || '',
            hasFocus: false,
            id: Utilities_1.getId('SearchBox')
        };
        return _this;
    }
    SearchBox.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.value !== undefined) {
            this._latestValue = newProps.value;
            this.setState({
                value: newProps.value
            });
        }
    };
    SearchBox.prototype.render = function () {
        var _a = this.props, labelText = _a.labelText, className = _a.className, disabled = _a.disabled, underlined = _a.underlined;
        var _b = this.state, value = _b.value, hasFocus = _b.hasFocus, id = _b.id;
        return (React.createElement("div", tslib_1.__assign({ ref: this._resolveRef('_rootElement'), className: Utilities_1.css('ms-SearchBox', className, styles.root, (_c = {},
                _c['is-active ' + styles.rootIsActive] = hasFocus,
                _c['is-disabled ' + styles.rootIsDisabled] = disabled,
                _c['can-clear ' + styles.rootCanClear] = value.length > 0,
                _c['is-underlined ' + styles.rootIsUnderlined] = underlined,
                _c)) }, { onFocusCapture: this._onFocusCapture }),
            React.createElement("div", { className: Utilities_1.css('ms-SearchBox-iconContainer', styles.iconContainer) },
                React.createElement(Icon_1.Icon, { className: Utilities_1.css('ms-SearchBox-icon', styles.icon), iconName: 'Search' })),
            React.createElement("input", { id: id, className: Utilities_1.css('ms-SearchBox-field', styles.field), placeholder: labelText, onChange: this._onInputChange, onInput: this._onInputChange, onKeyDown: this._onKeyDown, value: value, disabled: this.props.disabled, "aria-label": this.props.ariaLabel ? this.props.ariaLabel : this.props.labelText, ref: this._resolveRef('_inputElement') }),
            React.createElement("div", { className: Utilities_1.css('ms-SearchBox-clearButton', styles.clearButton), onClick: this._onClear },
                React.createElement(Icon_1.Icon, { iconName: 'Clear' }))));
        var _c;
    };
    /**
     * Sets focus to the search box input field
     */
    SearchBox.prototype.focus = function () {
        if (this._inputElement) {
            this._inputElement.focus();
        }
    };
    SearchBox.prototype._onClear = function (ev) {
        this.props.onClear && this.props.onClear(ev);
        if (!ev.defaultPrevented) {
            this._latestValue = '';
            this.setState({
                value: ''
            });
            this._callOnChange('');
            ev.stopPropagation();
            ev.preventDefault();
            this._inputElement.focus();
        }
    };
    SearchBox.prototype._onFocusCapture = function (ev) {
        this.setState({
            hasFocus: true
        });
        this._events.on(this._rootElement, 'blur', this._onBlur, true);
        if (this.props.onFocus) {
            this.props.onFocus(ev);
        }
    };
    SearchBox.prototype._onKeyDown = function (ev) {
        switch (ev.which) {
            case 27 /* escape */:
                this.props.onEscape && this.props.onEscape(ev);
                if (!ev.defaultPrevented) {
                    this._onClear(ev);
                }
                break;
            case 13 /* enter */:
                if (this.props.onSearch && this.state.value.length > 0) {
                    this.props.onSearch(this.state.value);
                }
                break;
            default:
                this.props.onKeyDown && this.props.onKeyDown(ev);
                if (!ev.defaultPrevented) {
                    return;
                }
        }
        // We only get here if the keypress has been handled,
        // or preventDefault was called in case of default keyDown handler
        ev.preventDefault();
        ev.stopPropagation();
    };
    SearchBox.prototype._onBlur = function (ev) {
        this._events.off(this._rootElement, 'blur');
        this.setState({
            hasFocus: false
        });
        if (this.props.onBlur) {
            this.props.onBlur(ev);
        }
    };
    SearchBox.prototype._onInputChange = function (ev) {
        var value = this._inputElement.value;
        if (value === this._latestValue) {
            return;
        }
        this._latestValue = value;
        this.setState({ value: value });
        this._callOnChange(value);
    };
    SearchBox.prototype._callOnChange = function (newValue) {
        var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged;
        // Call @deprecated method.
        if (onChanged) {
            onChanged(newValue);
        }
        if (onChange) {
            onChange(newValue);
        }
    };
    SearchBox.defaultProps = {
        labelText: 'Search',
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SearchBox.prototype, "_onClear", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SearchBox.prototype, "_onFocusCapture", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SearchBox.prototype, "_onKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SearchBox.prototype, "_onBlur", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], SearchBox.prototype, "_onInputChange", null);
    return SearchBox;
}(Utilities_1.BaseComponent));
exports.SearchBox = SearchBox;
//# sourceMappingURL=SearchBox.js.map

/***/ }),

/***/ 2215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_01ac5431{font-size:14px;font-weight:400;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:0 0 0 8px;border:1px solid " }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";height:32px}html[dir='rtl'] .root_01ac5431{padding:0 8px 0 0}@media screen and (-ms-high-contrast: active){.root_01ac5431{border:1px solid WindowText}}.iconContainer_01ac5431{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0;font-size:16px;width:32px;text-align:center;-webkit-transition:width .167s;transition:width .167s;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.icon_01ac5431{opacity:1;-webkit-transition:opacity .167s 0s;transition:opacity .167s 0s}.field_01ac5431{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;border:none;outline:none;font-weight:inherit;font-family:inherit;font-size:inherit;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";background-color:transparent;-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0px;overflow:hidden;text-overflow:ellipsis;padding-bottom:.5px}.field_01ac5431::-ms-clear{display:none}.clearButton_01ac5431{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:none;cursor:pointer;text-align:center;font-size:12px;-ms-flex-preferred-size:32px;flex-basis:32px;-ms-flex-negative:0;flex-shrink:0;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.root_01ac5431.rootIsUnderlined_01ac5431{border-width:0px 0px 1px 0px}.root_01ac5431.rootIsUnderlined_01ac5431.rootIsDisabled_01ac5431{background-color:transparent}.root_01ac5431.rootIsActive_01ac5431{border-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.root_01ac5431.rootIsActive_01ac5431:hover{border-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_01ac5431.rootIsActive_01ac5431{border-color:Highlight}}.root_01ac5431.rootIsActive_01ac5431 .iconContainer_01ac5431{width:4px;-webkit-transition:width .167s;transition:width .167s}.root_01ac5431.rootIsActive_01ac5431 .icon_01ac5431{opacity:0;opacity:0 0s .167s}.rootIsDisabled_01ac5431{border-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}.rootIsDisabled_01ac5431 .iconContainer_01ac5431{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.rootIsDisabled_01ac5431 .field_01ac5431{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.rootCanClear_01ac5431 .clearButton_01ac5431{display:-webkit-box;display:-ms-flexbox;display:flex}.root_01ac5431:hover{border-color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.root_01ac5431:hover .label_01ac5431{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": "}.root_01ac5431:hover .label_01ac5431 .iconContainer_01ac5431{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}\n" }]);
exports.root = "root_01ac5431";
exports.iconContainer = "iconContainer_01ac5431";
exports.icon = "icon_01ac5431";
exports.field = "field_01ac5431";
exports.clearButton = "clearButton_01ac5431";
exports.rootIsUnderlined = "rootIsUnderlined_01ac5431";
exports.rootIsDisabled = "rootIsDisabled_01ac5431";
exports.rootIsActive = "rootIsActive_01ac5431";
exports.rootCanClear = "rootCanClear_01ac5431";
exports.label = "label_01ac5431";
//# sourceMappingURL=SearchBox.scss.js.map

/***/ }),

/***/ 2216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var createLazyPlugin_1 = __webpack_require__(1549);
owa_bundling_1.preloadScriptChunk('Editor');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 2566));
});
// Delay loaded plugin
exports.LazyRibbonPluginClass = createLazyPlugin_1.default(lazyModule, function (m) { return m.RibbonPlugin; }, function () { return false; });
// Delay loaded components
exports.Ribbon = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.Ribbon; });
// Delay loaded actions
exports.lazyUpdateRibbonWidth = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.updateRibbonWidth; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2248), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createFormatState_1 = __webpack_require__(2211);
var ButtonNames_1 = __webpack_require__(2165);
function createRibbonViewState() {
    return {
        visibleItemCount: ButtonNames_1.RIBBON_BUTTON_LIST.length,
        formatViewState: createFormatState_1.default(),
        cachedFormatViewState: null,
    };
}
exports.default = createRibbonViewState;
//# sourceMappingURL=createRibbonViewState.js.map

/***/ }),

/***/ 2248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Label_1 = __webpack_require__(1559);
var Utilities_2 = __webpack_require__(7);
var Toggle_classNames_1 = __webpack_require__(2249);
var Toggle = /** @class */ (function (_super) {
    tslib_1.__extends(Toggle, _super);
    function Toggle(props) {
        var _this = _super.call(this) || this;
        _this._warnMutuallyExclusive({
            checked: 'defaultChecked'
        });
        _this.state = {
            isChecked: !!(props.checked || props.defaultChecked)
        };
        _this._id = props.id || Utilities_1.getId('Toggle');
        return _this;
    }
    Object.defineProperty(Toggle.prototype, "checked", {
        /**
         * Gets the current checked state of the toggle.
         */
        get: function () {
            return this.state.isChecked;
        },
        enumerable: true,
        configurable: true
    });
    Toggle.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.checked !== undefined) {
            this.setState({
                isChecked: !!newProps.checked // convert null to false
            });
        }
    };
    Toggle.prototype.render = function () {
        // This control is using an input element for more universal accessibility support.
        // Previously a button and the aria-pressed attribute were used. This technique works well with Narrator + Edge and NVDA + FireFox.
        // However, JAWS and VoiceOver did not announce anything when the toggle was checked or unchecked.
        // In the future when more screenreaders support aria-pressed it would be a good idea to change this control back to using it as it is
        // more semantically correct.
        var _a = this.props, className = _a.className, theme = _a.theme, customStyles = _a.styles, disabled = _a.disabled, label = _a.label, offAriaLabel = _a.offAriaLabel, offText = _a.offText, onAriaLabel = _a.onAriaLabel, onText = _a.onText;
        var isChecked = this.state.isChecked;
        var stateText = isChecked ? onText : offText;
        var ariaLabel = isChecked ? onAriaLabel : offAriaLabel;
        var toggleNativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['defaultChecked']);
        var classNames = Toggle_classNames_1.getClassNames(theme, customStyles, className, disabled, isChecked);
        return (React.createElement("div", { className: classNames.root },
            label && (React.createElement(Label_1.Label, { htmlFor: this._id, className: classNames.label }, label)),
            React.createElement("div", { className: classNames.container },
                React.createElement("button", tslib_1.__assign({}, toggleNativeProps, { className: classNames.pill, disabled: disabled, id: this._id, type: 'button', ref: this._resolveRef('_toggleButton'), "aria-disabled": disabled, "aria-pressed": isChecked, "aria-label": ariaLabel ? ariaLabel : label, "data-is-focusable": true, onChange: this._noop, onClick: this._onClick }),
                    React.createElement("div", { className: classNames.thumb })),
                stateText && (React.createElement(Label_1.Label, { htmlFor: this._id, className: classNames.text }, stateText)))));
    };
    Toggle.prototype.focus = function () {
        if (this._toggleButton) {
            this._toggleButton.focus();
        }
    };
    Toggle.prototype._onClick = function (ev) {
        var _a = this.props, disabled = _a.disabled, checked = _a.checked, onChanged = _a.onChanged, onClick = _a.onClick;
        var isChecked = this.state.isChecked;
        if (!disabled) {
            // Only update the state if the user hasn't provided it.
            if (checked === undefined) {
                this.setState({
                    isChecked: !isChecked
                });
            }
            if (onChanged) {
                onChanged(!isChecked);
            }
            if (onClick) {
                onClick(ev);
            }
        }
    };
    Toggle.prototype._noop = function () {
        /* no-op */
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Toggle.prototype, "_onClick", null);
    Toggle = tslib_1.__decorate([
        Utilities_2.customizable('Toggle', ['theme'])
    ], Toggle);
    return Toggle;
}(Utilities_1.BaseComponent));
exports.Toggle = Toggle;
//# sourceMappingURL=Toggle.js.map

/***/ }),

/***/ 2249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
exports.getClassNames = Utilities_1.memoizeFunction(function (theme, styles, className, disabled, checked) {
    var semanticColors = theme.semanticColors;
    var pillUncheckedBackground = semanticColors.bodyBackground;
    var pillCheckedBackground = semanticColors.inputBackgroundChecked;
    var pillCheckedHoveredBackground = semanticColors.inputBackgroundCheckedHovered;
    var pillCheckedDisabledBackground = semanticColors.disabledText;
    var thumbBackground = semanticColors.inputBorderHovered;
    var thumbCheckedBackground = semanticColors.inputForegroundChecked;
    var thumbDisabledBackground = semanticColors.disabledText;
    var thumbCheckedDisabledBackground = semanticColors.disabledBackground;
    var pillBorderColor = semanticColors.inputBorder;
    var pillBorderHoveredColor = semanticColors.inputBorderHovered;
    var pillBorderDisabledColor = semanticColors.disabledText;
    var textDisabledColor = semanticColors.disabledBodyText;
    styles = styles || {};
    return Styling_1.mergeStyleSets({
        root: [
            'ms-Toggle',
            checked && 'is-checked',
            !disabled && 'is-enabled',
            disabled && 'is-disabled',
            className,
            {
                marginBottom: '8px'
            },
            styles.root
        ],
        label: [
            'ms-Toggle-label',
            styles.label,
            disabled && {
                color: textDisabledColor,
                selectors: (_a = {},
                    _a[Styling_1.HighContrastSelector] = {
                        color: 'GrayText'
                    },
                    _a)
            }
        ],
        container: [
            'ms-Toggle-innerContainer',
            {
                display: 'inline-flex',
                position: 'relative',
            },
            styles.container
        ],
        pill: [
            'ms-Toggle-background',
            Styling_1.getFocusStyle(theme, -3),
            {
                fontSize: '20px',
                lineHeight: '1em',
                boxSizing: 'border-box',
                position: 'relative',
                width: '2.2em',
                height: '1em',
                borderRadius: '1em',
                transition: 'all 0.1s ease',
                borderWidth: '1px',
                borderStyle: 'solid',
                background: pillUncheckedBackground,
                borderColor: pillBorderColor,
                cursor: 'pointer',
            },
            styles.pill,
            !disabled && [
                !checked && {
                    selectors: {
                        ':hover': [
                            {
                                borderColor: pillBorderHoveredColor
                            },
                            styles.pillHovered
                        ],
                        ':hover .ms-Toggle-thumb': styles.thumbHovered
                    }
                },
                checked && [
                    {
                        background: pillCheckedBackground,
                        borderColor: 'transparent'
                    },
                    styles.pillChecked,
                    {
                        selectors: (_b = {
                                ':hover': [
                                    {
                                        backgroundColor: pillCheckedHoveredBackground,
                                        borderColor: 'transparent'
                                    },
                                    styles.pillCheckedHovered
                                ],
                                ':hover .ms-Toggle-thumb': [
                                    styles.thumbCheckedHovered
                                ]
                            },
                            _b[Styling_1.HighContrastSelector] = {
                                backgroundColor: 'WindowText'
                            },
                            _b)
                    }
                ]
            ],
            disabled && [
                {
                    cursor: 'default'
                },
                !checked && [
                    {
                        borderColor: pillBorderDisabledColor
                    },
                    styles.pillDisabled
                ],
                checked && [
                    {
                        backgroundColor: pillCheckedDisabledBackground,
                        borderColor: 'transparent'
                    },
                    styles.pillCheckedDisabled
                ],
            ]
        ],
        thumb: [
            'ms-Toggle-thumb',
            {
                width: '.5em',
                height: '.5em',
                borderRadius: '.5em',
                position: 'absolute',
                top: '.18em',
                transition: 'all 0.1s ease',
                backgroundColor: thumbBackground,
                /* Border is added to handle high contrast mode for Firefox */
                borderColor: 'transparent',
                borderWidth: '.28em',
                borderStyle: 'solid',
                boxSizing: 'border-box',
                left: '.2em'
            },
            styles.thumb,
            !disabled && checked && [
                {
                    backgroundColor: thumbCheckedBackground,
                    left: '1.4em',
                    selectors: (_c = {},
                        _c[Styling_1.HighContrastSelector] = {
                            backgroundColor: 'Window',
                            borderColor: 'Window'
                        },
                        _c)
                },
                styles.thumbChecked,
            ],
            disabled && [
                !checked && [
                    {
                        backgroundColor: thumbDisabledBackground,
                        left: '.2em',
                    },
                    styles.thumbDisabled
                ],
                checked && [
                    {
                        backgroundColor: thumbCheckedDisabledBackground,
                        left: '1.4em'
                    },
                    styles.thumbCheckedDisabled
                ]
            ]
        ],
        text: [
            'ms-Toggle-stateText',
            {
                selectors: {
                    // Workaround: make rules more sepecific than Label rules.
                    '&&': {
                        padding: '0',
                        margin: '0 10px',
                        userSelect: 'none',
                    }
                }
            },
            disabled && {
                selectors: {
                    '&&': {
                        color: textDisabledColor,
                        selectors: (_d = {},
                            _d[Styling_1.HighContrastSelector] = {
                                color: 'GrayText'
                            },
                            _d)
                    }
                }
            },
            styles.text
        ]
    });
    var _a, _b, _c, _d;
});
//# sourceMappingURL=Toggle.classNames.js.map

/***/ }),

/***/ 2302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
// Set Drag state, should be called only from Draggable component
exports.default = legacy_1.action('setDragState')(function (viewState, isBeingDragged) {
    viewState.isBeingDragged = isBeingDragged;
});
//# sourceMappingURL=setDragState.js.map

/***/ }),

/***/ 2303:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(2304);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2304:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".IYeL5SboHRvtFOQ_qcHn0,.IYeL5SboHRvtFOQ_qcHn0 *{cursor:no-drop!important}", ""]);

// exports
exports.locals = {
	"disableDrag": "IYeL5SboHRvtFOQ_qcHn0"
};

/***/ }),

/***/ 2562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var QuickOptions_1 = __webpack_require__(4911);
exports.QuickOptions = QuickOptions_1.default;
var mountAndShowFullOptions_1 = __webpack_require__(3366);
exports.mountAndShowFullOptions = mountAndShowFullOptions_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2599:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "../resources/images/theme_sprite.png";

/***/ }),

/***/ 2603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var initializeInboxRulesEditState_1 = __webpack_require__(3176);
var mobx_1 = __webpack_require__(15);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('inboxRulesOption', {
    inboxRulesListState: {
        inboxRules: mobx_1.map({}),
        inboxRuleIds: [],
        getInboxRuleRequestStatus: 0 /* NotInitiated */,
        getInboxRuleDiagnosticRequestStatus: 0 /* NotInitiated */,
        hasLoggedGetInboxRulesInformation: false,
    },
    inboxRulesEditState: initializeInboxRulesEditState_1.default(),
    findFoldersRequestStatus: 0 /* NotInitiated */,
    dropdownFolders: [],
    junkFolderDisplayName: '',
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_guid_1 = __webpack_require__(585);
exports.isInitialized = false;
exports.clientCorrelationId = undefined;
exports.clientType = undefined;
exports.clientScenario = undefined;
exports.culture = undefined;
exports.isConsumer = false;
exports.useDogfood = false;
exports.isMicrosoftUser = false;
var logger = undefined;
var MicrosoftTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47';
var MicrosoftExoTenantId = '626bd560-f1d8-4cf1-a7fa-91aae03cc409';
function initializeLoki(config) {
    if (exports.isInitialized) {
        throw new Error('initializeLoki can be called only once!');
    }
    if (!config) {
        throw new Error('Loki config object is mandatory!');
    }
    exports.clientType = 'OwaMail';
    exports.clientScenario = config.isConsumer ? 'OwaConsumer' : 'OwaEnterprise';
    exports.culture = config.culture;
    exports.isConsumer = config.isConsumer;
    exports.useDogfood = config.useDogfood;
    logger = config.logger;
    var tenantId = config.tenantId && config.tenantId.toLowerCase();
    exports.isMicrosoftUser = tenantId === MicrosoftTenantId || tenantId === MicrosoftExoTenantId;
    exports.clientCorrelationId = config.clientCorrelationId || owa_guid_1.getGuid();
    exports.isInitialized = true;
}
exports.initializeLoki = initializeLoki;
function log(logType, logResultType, message) {
    logger(logType, [logResultType, message]);
}
exports.log = log;
//# sourceMappingURL=lokiContext.js.map

/***/ }),

/***/ 2613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2761), exports);
//# sourceMappingURL=ChoiceGroup.js.map

/***/ }),

/***/ 2614:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "../resources/images/ribbon_sprite.png";

/***/ }),

/***/ 2615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var resolveAllUnresolvedRecipients_1 = __webpack_require__(2688);
var showHideFindResult_1 = __webpack_require__(2616);
var ReadWriteRecipientWellViewState_1 = __webpack_require__(2114);
var legacy_1 = __webpack_require__(1);
var owa_mail_subject_picker_store_1 = __webpack_require__(2120);
var owa_mail_feature_flags_1 = __webpack_require__(23);
exports.default = legacy_1.action('addReadWriteRecipient')(function addReadWriteRecipient(recipientWell, isValid, newPersona, newEmailAddress, resetFindResult) {
    if (resetFindResult === void 0) { resetFindResult = true; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var newRecipient;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!newPersona) {
                        // construct the email address wrapper if it's not provided.
                        newPersona = {
                            EmailAddress: {
                                MailboxType: 'OneOff',
                                RoutingType: 'SMTP',
                                EmailAddress: newEmailAddress,
                                Name: newEmailAddress,
                            },
                        };
                    }
                    newRecipient = {
                        persona: newPersona,
                        displayText: newPersona.EmailAddress.Name
                            ? newPersona.EmailAddress.Name
                            : newPersona.EmailAddress.EmailAddress,
                        isValid: isValid,
                        isContextMenuOpen: false,
                        isSelected: false,
                        isExpanding: false,
                    };
                    recipientWell.recipients.push(newRecipient);
                    recipientWell.isDirty = true;
                    if (!resetFindResult) return [3 /*break*/, 2];
                    // Clear query string from input field.
                    recipientWell.queryString = '';
                    // Upon resolved, reset the Find Result
                    showHideFindResult_1.default(recipientWell, true /**shouldShowFindResult */, true /* shouldClearFindResult */);
                    // Reset the FindResultType
                    recipientWell.findResultType = ReadWriteRecipientWellViewState_1.FindRecipientResultType.None;
                    if (!recipientWell.inForceResolve) return [3 /*break*/, 2];
                    return [4 /*yield*/, resolveAllUnresolvedRecipients_1.default(recipientWell)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (owa_mail_feature_flags_1.isMailFeatureEnabled('peo-subjectPicker')) {
                        if (recipientWell.recipients.length === 1 && newRecipient.isValid) {
                            owa_mail_subject_picker_store_1.oneRecipientSelectedAction(newRecipient.persona);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=addReadWriteRecipient.js.map

/***/ }),

/***/ 2616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getAndPopulateSuggestedContacts_1 = __webpack_require__(2706);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('showHideFindResult')(function showHideFindResult(recipientWell, shouldShowFindResult, shouldClearFindResult) {
    var findResultCount = recipientWell.findResultSet ? recipientWell.findResultSet.length : 0;
    recipientWell.findResultHightlightIndex = -1;
    if (shouldClearFindResult && findResultCount) {
        // Clear existing find result if are not explicitly preserving the result.
        recipientWell.findResultSet.splice(0, findResultCount);
    }
    if (shouldShowFindResult) {
        if (recipientWell.queryString.length == 0 && !recipientWell.inForceResolve) {
            // With no query string, get our suggested contacts list.
            getAndPopulateSuggestedContacts_1.default(recipientWell.findResultSet, recipientWell.recipients);
        }
        else {
            // If we have (non suggested contacts) results, highlight the first (or the search box if no results).
            recipientWell.findResultHightlightIndex = 0;
        }
    }
    recipientWell.shouldShowFindResult = shouldShowFindResult;
});
//# sourceMappingURL=showHideFindResult.js.map

/***/ }),

/***/ 2620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialRecipientCacheStore = {
    recipientCache: null,
};
var store = satcheljs_1.createStore('recipientcache', initialRecipientCacheStore)();
exports.default = store;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isLokiEndpoint_1 = __webpack_require__(2716);
exports.isLokiEndpoint = isLokiEndpoint_1.isLokiEndpoint;
var Base64 = __webpack_require__(2717);
exports.Base64 = Base64;
var Functional = __webpack_require__(2718);
exports.Functional = Functional;
var StorageUtils = __webpack_require__(2719);
exports.StorageUtils = StorageUtils;
var StringUtils = __webpack_require__(2648);
exports.StringUtils = StringUtils;
var UrlUtils_1 = __webpack_require__(2722);
exports.getUrlParameter = UrlUtils_1.getUrlParameter;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isNullOrWhiteSpace_1 = __webpack_require__(2676);
exports.isNullOrWhiteSpace = isNullOrWhiteSpace_1.isNullOrWhiteSpace;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2620);
var datapoints_1 = __webpack_require__(2677);
var owa_analytics_1 = __webpack_require__(12);
function searchCache(searchQuery, numberOfResults, recipientsToExclude, mailboxTypesToExclude) {
    var resultList = [];
    var i = 0;
    searchQuery = searchQuery.toLowerCase();
    while (resultList.length < numberOfResults &&
        (store_1.default.recipientCache && i < store_1.default.recipientCache.length)) {
        var email = store_1.default.recipientCache[i].EmailAddress;
        if ((email.EmailAddress && email.EmailAddress.toLowerCase().indexOf(searchQuery) == 0) ||
            (email.Name && email.Name.toLowerCase().indexOf(searchQuery) == 0)) {
            var skipRecipient = false;
            // Skip recipient if it's found in recipientsToExclude list
            if (recipientsToExclude && isDuplicated(email, recipientsToExclude)) {
                skipRecipient = true;
            }
            // Skip recipient if its mailbox type is in mailboxTypesToExclude
            if (mailboxTypesToExclude && mailboxTypesToExclude.indexOf(email.MailboxType) >= 0) {
                skipRecipient = true;
            }
            if (!skipRecipient) {
                resultList.push(store_1.default.recipientCache[i]);
            }
        }
        i++;
    }
    owa_analytics_1.logUsage(datapoints_1.default.RecipientCacheHitIndex.datapoint.name, datapoints_1.default.RecipientCacheHitIndex.datapoint.customData(i));
    return resultList;
}
exports.default = searchCache;
function isDuplicated(email, recipientsToCheck) {
    for (var j = 0; j < recipientsToCheck.length; j++) {
        if (email.EmailAddress == recipientsToCheck[j].EmailAddress.EmailAddress) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=searchCache.js.map

/***/ }),

/***/ 2639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2682), exports);
//# sourceMappingURL=Checkbox.js.map

/***/ }),

/***/ 2640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = __webpack_require__(21);
var Utilities_1 = __webpack_require__(7);
var MS_CHECKBOX_LABEL_SIZE = '20px';
var MS_CHECKBOX_TRANSITION_DURATION = '200ms';
var MS_CHECKBOX_TRANSITION_TIMING = 'cubic-bezier(.4, 0, .23, 1)';
exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var checkmarkFontColor = semanticColors.inputForegroundChecked;
    var checkmarkFontColorCheckedDisabled = semanticColors.disabledBackground;
    var checkboxBorderColor = semanticColors.inputBorderHovered;
    var checkboxBorderColorChecked = semanticColors.inputBackgroundChecked;
    var checkboxBorderColorDisabled = semanticColors.disabledText;
    var checkboxBorderHoveredColor = semanticColors.inputBorderHovered;
    var checkboxBackgroundChecked = semanticColors.inputBackgroundChecked;
    var checkboxBackgroundCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
    var checkboxBorderColorCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
    var checkboxBackgroundDisabled = semanticColors.disabledText;
    var checkboxTextColor = semanticColors.bodyText;
    var checkboxTextColorDisabled = semanticColors.disabledText;
    var styles = {
        root: [
            Styling_1.getFocusStyle(theme, -2),
            {
                padding: '0',
                border: 'none',
                background: 'none',
                margin: '0',
                outline: 'none',
                display: 'block',
                cursor: 'pointer',
            }
        ],
        label: {
            display: 'inline-flex',
            margin: '0 -4px',
            alignItems: 'center',
            cursor: 'pointer',
            position: 'relative',
            userSelect: 'none',
            textAlign: 'left'
        },
        labelReversed: {
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end'
        },
        labelDisabled: {
            cursor: 'default'
        },
        checkbox: {
            display: 'flex',
            flexShrink: 0,
            alignItems: 'center',
            justifyContent: 'center',
            height: MS_CHECKBOX_LABEL_SIZE,
            width: MS_CHECKBOX_LABEL_SIZE,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: checkboxBorderColor,
            margin: '0 4px',
            boxSizing: 'border-box',
            transitionProperty: 'background, border, border-color',
            transitionDuration: MS_CHECKBOX_TRANSITION_DURATION,
            transitionTimingFunction: MS_CHECKBOX_TRANSITION_TIMING,
            /* incase the icon is bigger than the box */
            overflow: 'hidden'
        },
        checkboxHovered: {
            borderColor: checkboxBorderHoveredColor,
        },
        checkboxFocused: {
            borderColor: checkboxBorderHoveredColor,
        },
        checkboxChecked: {
            background: checkboxBackgroundChecked,
            borderColor: checkboxBorderColorChecked
        },
        checkboxCheckedHovered: {
            background: checkboxBackgroundCheckedHovered,
            borderColor: checkboxBorderColorCheckedHovered
        },
        checkboxCheckedFocused: {
            background: checkboxBackgroundCheckedHovered,
            borderColor: checkboxBorderColorCheckedHovered
        },
        checkboxDisabled: {
            background: checkboxBackgroundDisabled,
            borderColor: checkboxBorderColorDisabled
        },
        checkboxCheckedDisabled: {
            background: checkboxBackgroundDisabled,
            borderColor: checkboxBorderColorDisabled
        },
        checkmark: {
            opacity: '0',
            color: checkmarkFontColor
        },
        checkmarkChecked: {
            opacity: '1'
        },
        checkmarkDisabled: {},
        checkmarkCheckedDisabled: {
            opacity: '1',
            color: checkmarkFontColorCheckedDisabled,
        },
        text: {
            color: checkboxTextColor,
            margin: '0 4px',
            fontSize: Styling_1.FontSizes.medium
        },
        textHovered: {
            color: palette.black,
        },
        textFocused: {
            color: palette.black,
        },
        textDisabled: {
            color: checkboxTextColorDisabled,
        }
    };
    return Styling_1.concatStyleSets(styles, customStyles);
});
//# sourceMappingURL=Checkbox.styles.js.map

/***/ }),

/***/ 2641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Store
var store_1 = __webpack_require__(2113);
exports.getStore = store_1.getStore;
// Mutators
var setIsFullOptionsShown_1 = __webpack_require__(3722);
exports.setIsFullOptionsShown = setIsFullOptionsShown_1.default;
var setIsSaving_1 = __webpack_require__(4914);
exports.setIsSaving = setIsSaving_1.default;
var setSearchTerm_1 = __webpack_require__(3723);
exports.setSearchTerm = setSearchTerm_1.default;
// Orchestrators
var initializeFullOptions_1 = __webpack_require__(4915);
exports.initializeFullOptions = initializeFullOptions_1.default;
var selectCategory_1 = __webpack_require__(5276);
exports.selectCategory = selectCategory_1.default;
var selectSubcategory_1 = __webpack_require__(5277);
exports.selectSubcategory = selectSubcategory_1.default;
// Selectors
var getAllOptions_1 = __webpack_require__(3771);
exports.getAllOptions = getAllOptions_1.default;
var getCurrentCategory_1 = __webpack_require__(3770);
exports.getCurrentCategory = getCurrentCategory_1.default;
var getCurrentSubcategory_1 = __webpack_require__(3769);
exports.getCurrentSubcategory = getCurrentSubcategory_1.default;
var getQuickOptions_1 = __webpack_require__(5278);
exports.getQuickOptions = getQuickOptions_1.default;
// Config
var collectedOptions_1 = __webpack_require__(3173);
exports.collectedOptions = collectedOptions_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLokiBootstrapperConfig_1 = __webpack_require__(2645);
exports.getLokiBootstrapperConfig = getLokiBootstrapperConfig_1.getLokiBootstrapperConfig;
var userInfoProvider_1 = __webpack_require__(2725);
exports.getUserInfo = userInfoProvider_1.getUserInfo;
var lokiContext_1 = __webpack_require__(2612);
exports.lokiClientCorrelationId = lokiContext_1.clientCorrelationId;
exports.initializeLoki = lokiContext_1.initializeLoki;
var live_persona_card_bootstrapper_1 = __webpack_require__(2650);
exports.initializeLivePersonaCard = live_persona_card_bootstrapper_1.initializeLivePersonaCard;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var requestAuthTokenHandler_1 = __webpack_require__(2646);
var lokiContext = __webpack_require__(2612);
function getLokiBootstrapperConfig() {
    if (!lokiContext.isInitialized) {
        throw new Error('You must call initializeLoki!');
    }
    var config = {
        culture: lokiContext.culture,
        region: getLokiRegion(lokiContext.useDogfood, lokiContext.isMicrosoftUser),
        clientType: lokiContext.clientType,
        clientContextType: lokiContext.clientScenario,
        clientCorrelationId: lokiContext.clientCorrelationId,
        logMessage: function (logType, logResultType, message) {
            lokiContext.log(logType, logResultType, message);
        },
        getAuthToken: requestAuthTokenHandler_1.refreshAuthToken,
        authToken: requestAuthTokenHandler_1.latestAuthToken,
    };
    return config;
}
exports.getLokiBootstrapperConfig = getLokiBootstrapperConfig;
function getLokiRegion(useLokiDogfood, isMicrosoftUser) {
    if (useLokiDogfood) {
        return 'df';
    }
    if (isMicrosoftUser) {
        return 'msit';
    }
    return '';
}
//# sourceMappingURL=getLokiBootstrapperConfig.js.map

/***/ }),

/***/ 2646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var loki_auth_token_1 = __webpack_require__(2715);
var lokiContext_1 = __webpack_require__(2612);
var getLokiAuthTokenAsync_1 = __webpack_require__(2724);
var authTokenProvider = undefined;
exports.latestAuthToken = undefined;
function getAuthToken() {
    if (!authTokenProvider) {
        authTokenProvider = new loki_auth_token_1.AuthTokenProvider(function () { return lokiContext_1.clientCorrelationId; }, getRefreshAuthToken(), null, null);
    }
    return authTokenProvider.getAuthToken();
}
exports.getAuthToken = getAuthToken;
function refreshAuthToken(onSuccess, onFailure) {
    getLokiAuthTokenAsync_1.default().then(function (token) {
        var authTokenRequestCorrelationId = lokiContext_1.clientCorrelationId;
        if (token) {
            setAuthToken(token);
            onSuccess(token, authTokenRequestCorrelationId);
        }
        else {
            onFailure('Failed to get auth token from Loki', authTokenRequestCorrelationId);
        }
    });
}
exports.refreshAuthToken = refreshAuthToken;
function setAuthToken(newAuthToken) {
    exports.latestAuthToken = newAuthToken;
    loki_auth_token_1.setAuthToken(lokiContext_1.clientCorrelationId, newAuthToken);
}
function getRefreshAuthToken() {
    return function (callback) {
        refreshAuthToken(function (authToken, authRequestCorrelationId) {
            callback(authToken, '', authRequestCorrelationId);
        }, function (errorMessage, authRequestCorrelationId) {
            callback('', errorMessage, authRequestCorrelationId);
        });
    };
}
//# sourceMappingURL=requestAuthTokenHandler.js.map

/***/ }),

/***/ 2647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lpc_utils_1 = __webpack_require__(2622);
var lpc_utils_2 = __webpack_require__(2622);
var AUTH_TOKEN_PARSE_ERROR = "AuthTokenParseError";
var DEFAULT_GET_AUTH_TOKEN_TIMEOUT = 10000; /* 10s */
var TOKEN_LIFETIME_BUFFER = 5 * 60 * 1000; /* 5m */
var GET_AUTH_TOKEN_TIMEOUT = "GetAuthTokenTimeout";
var CACHED_TOKEN_EXPIRED = "CachedTokenExpired";
var AUTH_TOKEN_PARTS = 3;
var INVALID_TOKEN_EXPIRATION = "InvalidTokenExpirationValue";
var AuthToken = (function () {
    function AuthToken(value, scopeName, logger) {
        this.value = value;
        this.scopeName = scopeName;
        this.logger = logger;
    }
    AuthToken.prototype.isValid = function () {
        if (!this.value) {
            return false;
        }
        var expiryTime = this.extractAuthTokenExpiration();
        if (expiryTime <= 0) {
            if (this.logger) {
                this.logger.logError(INVALID_TOKEN_EXPIRATION, this.scopeName, { expiryTime: expiryTime.toString() });
            }
            return false;
        }
        // Date.now() returns milliseconds while expiryTime in authToken uses seconds
        if (Date.now() > expiryTime * 1000 - TOKEN_LIFETIME_BUFFER) {
            if (this.logger) {
                this.logger.logEvent(CACHED_TOKEN_EXPIRED, this.scopeName);
            }
            return false;
        }
        return true;
    };
    AuthToken.prototype.getValue = function () {
        return this.value;
    };
    AuthToken.prototype.refresh = function (refreshAuthTokenCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var timeoutId = window.setTimeout(function () {
                // Don't introduce PII as we are logging the rejection scenarios
                reject(GET_AUTH_TOKEN_TIMEOUT);
            }, DEFAULT_GET_AUTH_TOKEN_TIMEOUT);
            refreshAuthTokenCallback(function (token, error, authRequestCorrelationId) {
                window.clearTimeout(timeoutId);
                if (lpc_utils_1.StringUtils.isNullOrEmpty(error)) {
                    _this.value = token;
                    resolve(_this);
                }
                else {
                    // Don't introduce PII as we are logging the rejection scenarios
                    reject("Couldn't retrieve token! authRequestCorrelationId: " + authRequestCorrelationId);
                }
            });
        });
    };
    AuthToken.prototype.getLoggableProps = function () {
        // Expiry time is in seconds in the auth token, so convert to milliseconds:
        var expiryTime = this.extractAuthTokenExpiration() * 1000;
        return { expirationTime: expiryTime, expiresIn: expiryTime - Date.now() };
    };
    AuthToken.prototype.getLoggablePropsAsString = function () {
        return JSON.stringify(this.getLoggableProps());
    };
    AuthToken.prototype.getTokenLifetimeBuffer = function () {
        return TOKEN_LIFETIME_BUFFER;
    };
    // Extract the object id from the auth token
    AuthToken.prototype.extractAuthTokenOid = function () {
        /* tslint:disable:no-any */
        var payload = this.extractPayload();
        /* tslint:enable:no-any */
        if (payload) {
            return payload.oid;
        }
        return "";
    };
    AuthToken.prototype.extractAuthTokenExpiration = function () {
        /* tslint:disable:no-any */
        var payload = this.extractPayload();
        /* tslint:enable:no-any */
        if (payload) {
            return payload.exp;
        }
        return 0;
    };
    /* tslint:disable:no-any */
    AuthToken.prototype.extractPayload = function () {
        /* tslint:enable:no-any */
        if (!this.value) {
            return null;
        }
        var tokenParts = this.value.split(".");
        if (tokenParts.length !== AUTH_TOKEN_PARTS) {
            if (this.logger) {
                this.logger.logError(AUTH_TOKEN_PARSE_ERROR, this.scopeName, { partsCount: tokenParts.length.toString() });
            }
            return null;
        }
        try {
            /* tslint:disable:no-any */
            var payload = JSON.parse(lpc_utils_2.Base64.decode(tokenParts[1]));
            /* tslint:enable:no-any */
            return payload;
        }
        catch (ex) {
            if (this.logger) {
                this.logger.logError(AUTH_TOKEN_PARSE_ERROR, this.scopeName, { error: ex });
            }
            return null;
        }
    };
    return AuthToken;
}());
exports.AuthToken = AuthToken;
//# sourceMappingURL=authToken.js.map

/***/ }),

/***/ 2648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var emptyString = "";
var guidEmpty = "00000000-0000-0000-0000-000000000000";
var guidFormatString = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
function isNullOrEmpty(str) {
    return str === null || str === undefined || str === emptyString;
}
exports.isNullOrEmpty = isNullOrEmpty;
function isNullOrWhitespace(str) {
    return str === null || str === undefined || str.trim() === emptyString;
}
exports.isNullOrWhitespace = isNullOrWhitespace;
function isGuidNullOrEmpty(guid) {
    return isNullOrEmpty(guid) || guid === guidEmpty;
}
exports.isGuidNullOrEmpty = isGuidNullOrEmpty;
// Ranges from isCJK method found numerous places in msasg code.
// This one breaks on Android, and has therefore been replaced by the other one by this tool:
// https://mothereff.in/regexpu
// const cjkRegExp = /[\u{3400}-\u{9fff}\u{f900}-\u{faff}\u{20000}-\u{2a6df}\u{2f800}-\u{2fa1f}]/u;
var cjkRegExp = /(?:[\u3400-\u9FFF\uF900-\uFAFF]|[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]|\uD87E[\uDC00-\uDE1F])/;
function isCJK(text) {
    return cjkRegExp.test(text);
}
exports.isCJK = isCJK;
function generateGuid() {
    /* Equivalent of var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8); */
    return guidFormatString.replace(/[xy]/g, function (c) {
        var r;
        if (window.crypto) {
            var array = new Uint8Array(1);
            window.crypto.getRandomValues(array);
            r = array[0];
        }
        else {
            r = Math.floor(Math.random() * 16);
        }
        var v = c === "x" ? r % 16 : r % 4 + 8;
        return v.toString(16);
    });
}
exports.generateGuid = generateGuid;
/* Ex: { param1: val1, param2: val2 } => "param1=val1,param2=val2" */
function createCommaDelimitedParamStringFromObject(data) {
    // IE does not support data.constructor.name (https://stackoverflow.com/questions/25140723/constructor-name-is-undefined-in-internet-explorer)
    if (Object.prototype.toString.call(data) !== "[object Object]") {
        throw new TypeError("Param data must be a valid object");
    }
    var values = [];
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        values.push(key + "=" + data[key]);
    }
    return values.join(",");
}
exports.createCommaDelimitedParamStringFromObject = createCommaDelimitedParamStringFromObject;
function format(str) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!str) {
        return emptyString;
    }
    if (args != null && args.length > 0) {
        for (var i = 0; i < args.length; i++) {
            var val = args[i];
            var replString = val === null || val === undefined ? emptyString : val.toString();
            var matchPattern = new RegExp("\\{" + i + "\\}", "g");
            str = str.replace(matchPattern, replString);
        }
    }
    return str;
}
exports.format = format;
function toUTF8(s) {
    if (unescape && encodeURIComponent) {
        return unescape(encodeURIComponent(s));
    }
    else {
        return s;
    }
}
exports.toUTF8 = toUTF8;
function fromUTF8(s) {
    if (decodeURIComponent && escape) {
        return decodeURIComponent(escape(s));
    }
    else {
        return s;
    }
}
exports.fromUTF8 = fromUTF8;
//# sourceMappingURL=StringUtils.js.map

/***/ }),

/***/ 2649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lpc_utils_1 = __webpack_require__(2622);
var getItem = lpc_utils_1.StorageUtils.getItem, setItem = lpc_utils_1.StorageUtils.setItem, removeItem = lpc_utils_1.StorageUtils.removeItem;
var AUTH_TOKEN_STORAGE_KEY = "LokiAuthToken";
function setAuthTokenOnUrl(url, authToken) {
    if (authToken && lpc_utils_1.isLokiEndpoint(url)) {
        var queryStringOperator = url.indexOf("?") > -1 ? "&" : "?";
        return "" + url + queryStringOperator + "AuthToken=" + authToken;
    }
    return url;
}
exports.setAuthTokenOnUrl = setAuthTokenOnUrl;
function getAuthToken(appId) {
    return getItem(AUTH_TOKEN_STORAGE_KEY, appId || "") || "";
}
exports.getAuthToken = getAuthToken;
function setAuthToken(appId, authToken) {
    if (authToken) {
        setItem(AUTH_TOKEN_STORAGE_KEY, authToken, appId || "");
    }
}
exports.setAuthToken = setAuthToken;
function clearAuthToken(appId) {
    removeItem(AUTH_TOKEN_STORAGE_KEY, appId || "");
}
exports.clearAuthToken = clearAuthToken;
function removeAuthTokenFromUrl(url) {
    if (url) {
        return url.replace(/AuthToken=[\w-.]*[&$]?/, "");
    }
    return url;
}
exports.removeAuthTokenFromUrl = removeAuthTokenFromUrl;
//# sourceMappingURL=authUtils.js.map

/***/ }),

/***/ 2650:
/***/ (function(module, exports, __webpack_require__) {

/*! Version: 1.3.14; Third Party Notices: https://go.microsoft.com/fwlink/?linkid=855968 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("LivePersonaCardBootstrapper",[],e):"object"==typeof exports?exports.LivePersonaCardBootstrapper=e():t.LivePersonaCardBootstrapper=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=36)}([function(t,e,n){"use strict";n.d(e,"a",function(){return i});var i=function(){function t(t,e,n){this.type=t,this.message=e,this.rootCorrelationId=n}return t}()},function(t,e,n){"use strict";var i=function(){function t(t){this.low=0,this.high=0,this.low=parseInt(t,10),this.low<0&&(this.high=-1)}return t.prototype.Equals=function(e){var n=new t(e);return this.low===n.low&&this.high===n.high},t}();e.Int64=i;var r=function(){function t(t){this.low=0,this.high=0,this.low=parseInt(t,10)}return t.prototype.Equals=function(e){var n=new t(e);return this.low===n.low&&this.high===n.high},t}();e.UInt64=r;var o=function(){function t(){}return t.ToByte=function(t){return this.ToUInt8(t)},t.ToInt16=function(t){return 32767&t|(32768&t)<<16>>16},t.ToInt32=function(t){return 2147483647&t|2147483648&t},t.ToUInt8=function(t){return 255&t},t.ToUInt32=function(t){return 4294967295&t},t}();e.Number=o},function(t,e,n){"use strict";!function(t){t[t.NotSet=0]="NotSet",t[t.DistinguishedName=1]="DistinguishedName",t[t.GenericData=2]="GenericData",t[t.IPV4Address=3]="IPV4Address",t[t.IPv6Address=4]="IPv6Address",t[t.MailSubject=5]="MailSubject",t[t.PhoneNumber=6]="PhoneNumber",t[t.QueryString=7]="QueryString",t[t.SipAddress=8]="SipAddress",t[t.SmtpAddress=9]="SmtpAddress",t[t.Identity=10]="Identity",t[t.Uri=11]="Uri",t[t.Fqdn=12]="Fqdn",t[t.IPV4AddressLegacy=13]="IPV4AddressLegacy"}(e.AWTPiiKind||(e.AWTPiiKind={}))},function(t,e,n){"use strict";var i=n(12),r=n(2),o=n(4),s=function(){function t(){}return t.getPayloadBlob=function(t,e){var n=new i.IO.MemoryStream,r=new i.CompactBinaryProtocolWriter(n);return r.WriteFieldBegin(i.BondDataType.BT_MAP,3),r.WriteMapContainerBegin(e,i.BondDataType.BT_STRING,i.BondDataType.BT_LIST),Object.keys(t).forEach(function(e){r.WriteString(e);var n=t[e];r.WriteContainerBegin(1,i.BondDataType.BT_STRUCT),r.WriteFieldBegin(i.BondDataType.BT_STRING,2),r.WriteString("act_default_source"),r.WriteFieldBegin(i.BondDataType.BT_STRING,5),r.WriteString(o.newGuid()),r.WriteFieldBegin(i.BondDataType.BT_INT64,6),r.WriteInt64(o.numberToBondInt64(Date.now())),r.WriteFieldBegin(i.BondDataType.BT_LIST,8),r.WriteContainerBegin(n.length,i.BondDataType.BT_STRUCT);for(var s=0;s<n.length;++s)r.WriteBlob(n[s]);r.WriteStructEnd(!1)}),r.WriteStructEnd(!1),n.GetBuffer()},t.getEventBlob=function(t){var e=new i.IO.MemoryStream,n=new i.CompactBinaryProtocolWriter(e);n.WriteFieldBegin(i.BondDataType.BT_STRING,1),n.WriteString(t.id),n.WriteFieldBegin(i.BondDataType.BT_INT64,3),n.WriteInt64(o.numberToBondInt64(t.timestamp)),n.WriteFieldBegin(i.BondDataType.BT_STRING,5),n.WriteString(t.type),n.WriteFieldBegin(i.BondDataType.BT_STRING,6),n.WriteString(t.name);var s=[],u=[];return Object.keys(t.properties).forEach(function(e){t.properties[e].pii===r.AWTPiiKind.NotSet?s.push(e):u.push(e)}),s.length&&(n.WriteFieldBegin(i.BondDataType.BT_MAP,13),n.WriteMapContainerBegin(s.length,i.BondDataType.BT_STRING,i.BondDataType.BT_STRING),s.forEach(function(e){n.WriteString(e),n.WriteString(t.properties[e].value)})),u.length&&(n.WriteFieldBegin(i.BondDataType.BT_MAP,30),n.WriteMapContainerBegin(u.length,i.BondDataType.BT_STRING,i.BondDataType.BT_STRUCT),u.forEach(function(e){n.WriteString(e),n.WriteFieldBegin(i.BondDataType.BT_INT32,1),n.WriteInt32(1),n.WriteFieldBegin(i.BondDataType.BT_INT32,2),n.WriteInt32(t.properties[e].pii),n.WriteFieldBegin(i.BondDataType.BT_STRING,3),n.WriteString(t.properties[e].value),n.WriteStructEnd(!1)})),n.WriteStructEnd(!1),e.GetBuffer()},t.base64Encode=function(t){return i.Encoding.Base64.GetString(t)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=s},function(t,e,n){"use strict";function i(t){var e=new s.Int64("0");return e.low=4294967295&t,e.high=Math.floor(t/4294967296),e}function r(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(u,function(t){var e=16*Math.random()|0;return("x"===t?e:3&e|8).toString(16)})}function o(t){return!isNaN(t)&&null!==t&&t>=0&&t<=13}var s=n(1),u=/[xy]/g;e.numberToBondInt64=i,e.newGuid=r,e.isPii=o},function(t,e,n){"use strict";var i=n(2);e.AWTPiiKind=i.AWTPiiKind;var r=n(16);e.AWT=r.default,e.AWT_COLLECTOR_URL_UNITED_STATES="https://us.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_GERMANY="https://de.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_JAPAN="https://jp.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_AUSTRALIA="https://au.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_EUROPE="https://eu.pipe.aria.microsoft.com/Collector/3.0/"},function(t,e,n){"use strict";e.Version="1.2.0",e.FullVersionString="AWT-Web-CJS-"+e.Version},function(t,e,n){"use strict";function i(t){t=t.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");var e=new RegExp("[\\?&]"+t+"=([^&#]*)"),n=e.exec(location.search);return null===n?"":decodeURIComponent(n[1].replace(/\+/g," "))}e.a=i},function(t,e,n){"use strict";function i(t,e,i){return v=v||new Promise(function(r,a){try{var g,v,y=new p.a;o(t),n.i(h.a)(t).then(function(){return n.i(l.a)(t)}).then(function(e){return y.measureFromStart(p.b.getAuthToken),v=n.i(l.b)(e),t.tenantAadObjectId=v.tenantId,t.userAadObjectId=v.userAadId,t.userPuid=v.userPuid,n.i(c.a)(e,t)}).then(function(t){return y.measureFromStart(p.b.getLokiConfig),g=t,_.AWT.setContext("LokiUrl",t.LokiUrl),_.AWT.setContext("tenantAadObjectId",v.tenantId),_.AWT.setContext("userAadObjectId",v.userAadId),_.AWT.setContext("userPuid",v.userPuid),n.i(d.a)(g)}).then(function(){return y.measureFromStart(p.b.getLpcBundles),n.i(f.a)(g,t,y)}).then(function(){var t=s(y.getAllTimings());t.RootCorrelationId=g.RootCorrelationId,_.AWT.logEvent({name:"initializeLivePersonaCard_success",properties:t}),u(),e&&e(),r()}).catch(function(t){var e=s(y.getAllTimings());t.type&&(e.ErrorType=t.type),t.message&&(e.ErrorMessage=t.message),t.rootCorrelationId&&(e.RootCorrelationId=t.rootCorrelationId),navigator&&void 0!==typeof navigator.onLine&&(e.IsClientOnline=navigator.onLine),e.IsCatastrophic=!1,_.AWT.logEvent({name:"initializeLivePersonaCard_failure",properties:e}),u(),i&&i("Failed to initialize Live Persona Card: "+t.type),a("Failed to initialize Live Persona Card: "+t.type)})}catch(t){try{_.AWT.logEvent({name:"initializeLivePersonaCard_failure",properties:{IsCatastrophic:!0,Reason:t.toString()},tenantToken:T}),u()}catch(t){console.error("Couldn't log error through ARIA: "+t.toString())}i&&i("Failed to initialize Live Persona Card: "+t.name+" "+t.message),a("Failed to initialize Live Persona Card: "+t.name+" "+t.message)}})}function r(t){return n.i(l.a)(t).then(function(e){return n.i(c.a)(e,t)})}function o(t){_.AWT.initialize(T),_.AWT.setContext("culture",t.culture),_.AWT.setContext("region",t.region),_.AWT.setContext("clientType",t.clientType),_.AWT.setContext("clientContextType",t.clientContextType),_.AWT.setContext("clientCorrelationId",t.clientCorrelationId),_.AWT.setContext("bootstrapperVersion",g)}function s(t){var e={};return Object.keys(t).forEach(function(n){e["Perf_"+n]=t[n].toString()}),e}function u(){_.AWT.flush(function(){})}Object.defineProperty(e,"__esModule",{value:!0}),e.initializeLivePersonaCard=i,e.fetchLokiConfig=r;var a=n(18),c=(n.n(a),n(24)),l=n(23),f=n(26),d=n(25),h=n(32),p=n(29),_=n(5),g=(n.n(_),n(34));n.i(a.polyfill)();var v,T="e5ad760145754ffc9704e67c800087f2-dc72ff20-3e8a-401a-b9a8-ec72e4dd3e22-7257"},function(t,e,n){"use strict";!function(t){t[t.BT_STOP=0]="BT_STOP",t[t.BT_STOP_BASE=1]="BT_STOP_BASE",t[t.BT_UINT8=3]="BT_UINT8",t[t.BT_UINT32=5]="BT_UINT32",t[t.BT_UINT64=6]="BT_UINT64",t[t.BT_STRING=9]="BT_STRING",t[t.BT_STRUCT=10]="BT_STRUCT",t[t.BT_LIST=11]="BT_LIST",t[t.BT_MAP=13]="BT_MAP",t[t.BT_INT32=16]="BT_INT32",t[t.BT_INT64=17]="BT_INT64",t[t.BT_UNAVAILABLE=127]="BT_UNAVAILABLE"}(e.BondDataType||(e.BondDataType={}))},function(t,e,n){"use strict";var i=n(1),r=function(){function t(){}return t.GetBytes=function(t){for(var e=[],n=0;n<t.length;++n){var i=t.charCodeAt(n);i<128?e.push(i):i<2048?e.push(192|i>>6,128|63&i):i<55296||i>=57344?e.push(224|i>>12,128|i>>6&63,128|63&i):(i=65536+((1023&i)<<10|1023&t.charCodeAt(++n)),e.push(240|i>>18,128|i>>12&63,128|i>>6&63,128|63&i))}return e},t}();e.Utf8=r;var o=function(){function t(){}return t.GetString=function(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",n=[],i=t.length%3,r=0,o=t.length-i;r<o;r+=3){var s=(t[r]<<16)+(t[r+1]<<8)+t[r+2];n.push(function(t){return[e.charAt(t>>18&63),e.charAt(t>>12&63),e.charAt(t>>6&63),e.charAt(63&t)].join("")}(s))}switch(i){case 1:var s=t[t.length-1];n.push(e.charAt(s>>2)),n.push(e.charAt(s<<4&63)),n.push("==");break;case 2:var u=(t[t.length-2]<<8)+t[t.length-1];n.push(e.charAt(u>>10)),n.push(e.charAt(u>>4&63)),n.push(e.charAt(u<<2&63)),n.push("=")}return n.join("")},t}();e.Base64=o;var s=function(){function t(){}return t.GetBytes=function(t){for(var e=[];4294967168&t;)e.push(127&t|128),t>>>=7;return e.push(127&t),e},t}();e.Varint=s;var u=function(){function t(){}return t.GetBytes=function(t){for(var e=t.low,n=t.high,i=[];n||4294967168&e;)i.push(127&e|128),e=(127&n)<<25|e>>>7,n>>>=7;return i.push(127&e),i},t}();e.Varint64=u;var a=function(){function t(){}return t.EncodeZigzag32=function(t){return(t=i.Number.ToInt32(t))<<1^t>>31},t.EncodeZigzag64=function(t){var e=t.low,n=t.high,r=n<<1|e>>>31,o=e<<1;2147483648&n&&(r=~r,o=~o);var s=new i.UInt64("0");return s.low=o,s.high=r,s},t}();e.Zigzag=a},function(t,e,n){"use strict";var i=n(1),r=function(){function t(){this._buffer=[]}return t.prototype.WriteByte=function(t){this._buffer.push(i.Number.ToByte(t))},t.prototype.Write=function(t,e,n){for(;n--;)this.WriteByte(t[e++])},t.prototype.GetBuffer=function(){return this._buffer},t}();e.MemoryStream=r},function(t,e,n){"use strict";var i=n(9);e.BondDataType=i.BondDataType;var r=n(10);e.Encoding=r;var o=n(11);e.IO=o;var s=n(1);e.Int64=s.Int64,e.UInt64=s.UInt64,e.Number=s.Number;var u=function(){function t(t){this._stream=t}return t.prototype.WriteBlob=function(t){this._stream.Write(t,0,t.length)},t.prototype.WriteContainerBegin=function(t,e){this.WriteUInt8(e),this.WriteUInt32(t)},t.prototype.WriteMapContainerBegin=function(t,e,n){this.WriteUInt8(e),this.WriteUInt8(n),this.WriteUInt32(t)},t.prototype.WriteFieldBegin=function(t,e){e<=5?this._stream.WriteByte(t|e<<5):e<=255?(this._stream.WriteByte(192|t),this._stream.WriteByte(e)):(this._stream.WriteByte(224|t),this._stream.WriteByte(e),this._stream.WriteByte(e>>8))},t.prototype.WriteInt32=function(t){t=r.Zigzag.EncodeZigzag32(t),this.WriteUInt32(t)},t.prototype.WriteInt64=function(t){this.WriteUInt64(r.Zigzag.EncodeZigzag64(t))},t.prototype.WriteString=function(t){if(""===t)this.WriteUInt32(0);else{var e=r.Utf8.GetBytes(t);this.WriteUInt32(e.length),this._stream.Write(e,0,e.length)}},t.prototype.WriteStructEnd=function(t){this.WriteUInt8(t?i.BondDataType.BT_STOP_BASE:i.BondDataType.BT_STOP)},t.prototype.WriteUInt32=function(t){var e=r.Varint.GetBytes(s.Number.ToUInt32(t));this._stream.Write(e,0,e.length)},t.prototype.WriteUInt64=function(t){var e=r.Varint64.GetBytes(t);this._stream.Write(e,0,e.length)},t.prototype.WriteUInt8=function(t){this._stream.WriteByte(s.Number.ToUInt8(t))},t}();e.CompactBinaryProtocolWriter=u},function(t,e,n){"use strict";var i=function(){function t(){this._killedTokenDictionary={}}return t.prototype.setKillSwitchTenants=function(t,e){var n=this;if(t&&e)try{var i=t.split(",");if("this-request-only"===e)return i;var r=1e3*parseInt(e,10);i.forEach(function(t){n._killedTokenDictionary[t]=Date.now()+r})}catch(t){return[]}return[]},t.prototype.isTenantKilled=function(t){return void 0!==this._killedTokenDictionary[t]&&this._killedTokenDictionary[t]>Date.now()||(delete this._killedTokenDictionary[t],!1)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=i},function(t,e,n){"use strict";var i=n(3),r=function(){function t(t,e){this._maxRequestSize=t,this._outboundQueue=e,this._currentBatch={},this._currentBatchSize=0}return t.prototype.addEventToBatch=function(t){var e=i.default.getEventBlob(t);e.length>this._maxRequestSize||(this._currentBatchSize+e.length>this._maxRequestSize?this.flushBatch():(void 0===this._currentBatch[t.tenantToken]&&(this._currentBatch[t.tenantToken]=[]),this._currentBatch[t.tenantToken].push(e),this._currentBatchSize+=e.length))},t.prototype.flushBatch=function(){this._currentBatchSize>0&&(this._outboundQueue.push(this._currentBatch),this._currentBatch={},this._currentBatchSize=0)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=r},function(t,e,n){"use strict";var i=function(){function t(){}return t.shouldRetryForStatus=function(t){return!(t>=300&&t<500&&408!==t||501===t||505===t)},t.getMillisToBackoffForRetry=function(t){var e=0,n=Math.floor(1200*Math.random())+2400;return e=Math.pow(4,t)*n,Math.min(e,12e4)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=i},function(t,e,n){"use strict";var i=n(2),r=n(17),o=n(4),s=n(6),u=/^[a-zA-Z0-9]([a-zA-Z0-9]|_){2,98}[a-zA-Z0-9]$/,a=/\./g,c=/^[a-zA-Z0-9](([a-zA-Z0-9|_|\.]){0,98}[a-zA-Z0-9])?$/,l=function(){function t(){}return t.initialize=function(t,e){if(void 0===e&&(e={}),this._isInitialized)throw"Already Initialized";this._defaultTenantToken=t,this._overrideValuesFromConfig(e),r.default.initialize(this._config),this._isInitialized=!0},t.flush=function(t){this._isInitialized&&!this._isDestroyed&&r.default.flush(t)},t.flushAndTeardown=function(){this._isInitialized&&!this._isDestroyed&&(this._isDestroyed=!0,r.default.flushAndTeardown())},t.setContext=function(t,e,n){void 0===n&&(n="allTkns"),null!==(e=this._sanitizeProperty(t,e))&&(this._contextProperties[n]||(this._contextProperties[n]={}),this._contextProperties[n][t]=e)},t.logEvent=function(t){var e=this;if(this._isInitialized){if(!t.name||!t.properties)return;t.name=t.name.toLowerCase(),t.name.replace(a,"_");var n="";if(t.type?(t.type.toLowerCase(),n="custom."):t.type="custom",!u.test(t.name)||!u.test(t.type))return;if(t.type=n+t.type,isNaN(t.timestamp)&&(t.timestamp=(new Date).getTime()),t.tenantToken||(t.tenantToken=this._defaultTenantToken),t.id=o.newGuid(),Object.keys(t.properties).forEach(function(n){t.properties[n]=e._sanitizeProperty(n,t.properties[n]),null===t.properties[n]&&delete t.properties[n]}),this._addContextIfAbsent(t,t.tenantToken),this._addContextIfAbsent(t,"allTkns"),0===Object.keys(t.properties).length)return;this._setDefaultProperty(t,"EventInfo.InitId",this._getInitId(t.tenantToken)),this._setDefaultProperty(t,"EventInfo.Sequence",this._getSequenceId(t.tenantToken)),this._setDefaultProperty(t,"EventInfo.SdkVersion",s.FullVersionString),this._setDefaultProperty(t,"EventInfo.Name",t.name),this._setDefaultProperty(t,"EventInfo.Time",new Date(t.timestamp).toISOString()),r.default.sendEvent(t)}},t._overrideValuesFromConfig=function(t){t.collectorUrl&&(this._config.collectorUrl=t.collectorUrl),t.sendingTimer>1e3&&(this._config.sendingTimer=t.sendingTimer)},t._getInitId=function(t){return void 0===this._initIdMap[t]&&(this._initIdMap[t]=o.newGuid()),this._initIdMap[t]},t._getSequenceId=function(t){return void 0===this._sequenceIdMap[t]&&(this._sequenceIdMap[t]=0),(++this._sequenceIdMap[t]).toString()},t._setDefaultProperty=function(t,e,n){t.properties[e]={value:n,pii:i.AWTPiiKind.NotSet}},t._addContextIfAbsent=function(t,e){if(this._contextProperties[e]){var n=this._contextProperties[e];Object.keys(n).forEach(function(e){t.properties[e]||(t.properties[e]=n[e])})}},t._sanitizeProperty=function(t,e){return"string"!=typeof e&&"number"!=typeof e&&"boolean"!=typeof e||(e={value:e}),c.test(t)&&void 0!==e&&null!==e&&null!==e.value&&void 0!==e.value&&""!==e.value?(void 0===e.pii&&(e.pii=i.AWTPiiKind.NotSet),e.value=e.value.toString(),o.isPii(e.pii)?e:null):null},t}();l._isInitialized=!1,l._isDestroyed=!1,l._contextProperties={},l._sequenceIdMap={},l._initIdMap={},l._config={collectorUrl:"https://browser.pipe.aria.microsoft.com/Collector/3.0/",sendingTimer:1e3},Object.defineProperty(e,"__esModule",{value:!0}),e.default=l},function(t,e,n){"use strict";var i=n(14),r=n(3),o=n(15),s=n(13),u=n(6),a=function(){function t(){}return t.initialize=function(t){this._inboundQueues.push([]),this._recordBatcher=new i.default(2936012,this._outboundQueue),this._newEventsAllowed=!0,"undefined"==typeof Uint8Array&&(this._urlString+="&content-encoding=base64"),this._sendingTimer=t.sendingTimer,this._urlString=t.collectorUrl+this._urlString+"&x-apikey="},t.sendEvent=function(t){var e=this;this._newEventsAllowed&&(this._inboundQueues[this._inboundQueues.length-1].push(t),!this._running&&this._timeout<0&&!this._isCurrentlyFlushing&&(this._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},this._sendingTimer)))},t.flushAndTeardown=function(){this._newEventsAllowed=!1,this._batchAndSendEvents(!0)},t.flush=function(t){this._inboundQueues.push([]),this._isCurrentlyFlushing?this._flushQueue.push(t):(this._isCurrentlyFlushing=!0,this._flush(t))},t._batchAndSendEvents=function(t){for(this._running=!0;this._inboundQueues[0].length>0&&this._outboundQueue.length<1;)this._recordBatcher.addEventToBatch(this._inboundQueues[0].pop());0===this._outboundQueue.length&&this._recordBatcher.flushBatch(),this._sendRequest(this._outboundQueue.pop(),0,t)},t._retryRequestIfNeeded=function(t,e,n,i,r){var s=this,u=!0;if(t&&void 0!==t.status){this._killSwitch.setKillSwitchTenants(t.getResponseHeader("kill-tokens"),t.getResponseHeader("kill-duration-seconds")).forEach(function(t){delete e[t],n--}),(!o.default.shouldRetryForStatus(t.status)||n<=0)&&(u=!1)}u&&r<4?setTimeout(function(){return s._sendRequest(e,r+1,!1)},o.default.getMillisToBackoffForRetry(r)):this._handleRequestFinished(null)},t._sendRequest=function(t,e,n){var i=this,o=new XMLHttpRequest,s=0,u="";if(Object.keys(t).forEach(function(e){i._killSwitch.isTenantKilled(e)?delete t[e]:(u.length>0&&(u+=","),u+=e,s++)}),o.open("POST",this._urlString+u,!n),n||(o.ontimeout=function(){i._retryRequestIfNeeded(o,t,s,u,e)},o.onerror=function(){i._retryRequestIfNeeded(o,t,s,u,e)},o.onload=function(){i._handleRequestFinished(o)}),s>0){var a=r.default.getPayloadBlob(t,s);"undefined"==typeof Uint8Array?o.send(r.default.base64Encode(a)):o.send(new Uint8Array(a))}else n&&this._handleRequestFinished(null)},t._handleRequestFinished=function(t){var e=this;t&&this._killSwitch.setKillSwitchTenants(t.getResponseHeader("kill-tokens"),t.getResponseHeader("kill-duration-seconds")),this._inboundQueues[0].length>0?this._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},this._sendingTimer):(this._timeout=-1,this._running=!1)},t._flush=function(t){var e=this;this._running||(this._timeout>-1&&(clearTimeout(this._timeout),this._timeout=-1),this._inboundQueues[0].length>0&&this._batchAndSendEvents(!1)),this._checkPrimaryInboundQueueEmpty(function(){e._inboundQueues.shift(),null!==t&&void 0!==t&&t(),e._flushQueue.length>0?setTimeout(function(){return e._flush(e._flushQueue.shift())},e._sendingTimer):(e._isCurrentlyFlushing=!1,e._inboundQueues[0].length>0&&(e._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},e._sendingTimer)))})},t._checkPrimaryInboundQueueEmpty=function(t){var e=this;0===this._inboundQueues[0].length?this._checkOutboundQueueEmptyAndSent(t):setTimeout(function(){return e._checkPrimaryInboundQueueEmpty(t)},250)},t._checkOutboundQueueEmptyAndSent=function(t){var e=this;this._running?setTimeout(function(){return e._checkOutboundQueueEmptyAndSent(t)},250):t()},t}();a._outboundQueue=[],a._inboundQueues=[],a._newEventsAllowed=!1,a._killSwitch=new s.default,a._isCurrentlyFlushing=!1,a._flushQueue=[],a._running=!1,a._timeout=-1,a._urlString="?qsp=true&content-type=application%2Fbond-compact-binary&client-id=NO_AUTH&sdk-version="+u.FullVersionString,Object.defineProperty(e,"__esModule",{value:!0}),e.default=a},function(t,e,n){(function(e,i){!function(e,n){t.exports=n()}(0,function(){"use strict";function t(t){return"function"==typeof t||"object"==typeof t&&null!==t}function r(t){return"function"==typeof t}function o(t){Q=t}function s(t){V=t}function u(){return void 0!==G?function(){G(c)}:a()}function a(){var t=setTimeout;return function(){return t(c,1)}}function c(){for(var t=0;t<q;t+=2){(0,Y[t])(Y[t+1]),Y[t]=void 0,Y[t+1]=void 0}q=0}function l(t,e){var n=arguments,i=this,r=new this.constructor(d);void 0===r[tt]&&W(r);var o=i._state;return o?function(){var t=n[o-1];V(function(){return x(o,r,t,i._result)})}():B(i,r,t,e),r}function f(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(d);return m(n,t),n}function d(){}function h(){return new TypeError("You cannot resolve a promise with itself")}function p(){return new TypeError("A promises callback cannot return that same promise.")}function _(t){try{return t.then}catch(t){return rt.error=t,rt}}function g(t,e,n,i){try{t.call(e,n,i)}catch(t){return t}}function v(t,e,n){V(function(t){var i=!1,r=g(n,e,function(n){i||(i=!0,e!==n?m(t,n):I(t,n))},function(e){i||(i=!0,b(t,e))},"Settle: "+(t._label||" unknown promise"));!i&&r&&(i=!0,b(t,r))},t)}function T(t,e){e._state===nt?I(t,e._result):e._state===it?b(t,e._result):B(e,void 0,function(e){return m(t,e)},function(e){return b(t,e)})}function y(t,e,n){e.constructor===t.constructor&&n===l&&e.constructor.resolve===f?T(t,e):n===rt?(b(t,rt.error),rt.error=null):void 0===n?I(t,e):r(n)?v(t,e,n):I(t,e)}function m(e,n){e===n?b(e,h()):t(n)?y(e,n,_(n)):I(e,n)}function w(t){t._onerror&&t._onerror(t._result),A(t)}function I(t,e){t._state===et&&(t._result=e,t._state=nt,0!==t._subscribers.length&&V(A,t))}function b(t,e){t._state===et&&(t._state=it,t._result=e,V(w,t))}function B(t,e,n,i){var r=t._subscribers,o=r.length;t._onerror=null,r[o]=e,r[o+nt]=n,r[o+it]=i,0===o&&t._state&&V(A,t)}function A(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var i=void 0,r=void 0,o=t._result,s=0;s<e.length;s+=3)i=e[s],r=e[s+n],i?x(n,i,r,o):r(o);t._subscribers.length=0}}function S(){this.error=null}function C(t,e){try{return t(e)}catch(t){return ot.error=t,ot}}function x(t,e,n,i){var o=r(n),s=void 0,u=void 0,a=void 0,c=void 0;if(o){if(s=C(n,i),s===ot?(c=!0,u=s.error,s.error=null):a=!0,e===s)return void b(e,p())}else s=i,a=!0;e._state!==et||(o&&a?m(e,s):c?b(e,u):t===nt?I(e,s):t===it&&b(e,s))}function E(t,e){try{e(function(e){m(t,e)},function(e){b(t,e)})}catch(e){b(t,e)}}function k(){return st++}function W(t){t[tt]=st++,t._state=void 0,t._result=void 0,t._subscribers=[]}function P(t,e){this._instanceConstructor=t,this.promise=new t(d),this.promise[tt]||W(this.promise),z(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?I(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&I(this.promise,this._result))):b(this.promise,R())}function R(){return new Error("Array Methods must be provided an Array")}function L(t){return new P(this,t).promise}function O(t){var e=this;return new e(z(t)?function(n,i){for(var r=t.length,o=0;o<r;o++)e.resolve(t[o]).then(n,i)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function D(t){var e=this,n=new e(d);return b(n,t),n}function U(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function M(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function N(t){this[tt]=k(),this._result=this._state=void 0,this._subscribers=[],d!==t&&("function"!=typeof t&&U(),this instanceof N?E(this,t):M())}function F(){var t=void 0;if(void 0!==i)t=i;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var e=t.Promise;if(e){var n=null;try{n=Object.prototype.toString.call(e.resolve())}catch(t){}if("[object Promise]"===n&&!e.cast)return}t.Promise=N}var j=void 0;j=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var z=j,q=0,G=void 0,Q=void 0,V=function(t,e){Y[q]=t,Y[q+1]=e,2===(q+=2)&&(Q?Q(c):$())},H="undefined"!=typeof window?window:void 0,K=H||{},Z=K.MutationObserver||K.WebKitMutationObserver,X="undefined"==typeof self&&void 0!==e&&"[object process]"==={}.toString.call(e),J="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,Y=new Array(1e3),$=void 0;$=X?function(){return function(){return e.nextTick(c)}}():Z?function(){var t=0,e=new Z(c),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}():J?function(){var t=new MessageChannel;return t.port1.onmessage=c,function(){return t.port2.postMessage(0)}}():void 0===H?function(){try{var t=n(35);return G=t.runOnLoop||t.runOnContext,u()}catch(t){return a()}}():a();var tt=Math.random().toString(36).substring(16),et=void 0,nt=1,it=2,rt=new S,ot=new S,st=0;return P.prototype._enumerate=function(){for(var t=this.length,e=this._input,n=0;this._state===et&&n<t;n++)this._eachEntry(e[n],n)},P.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,i=n.resolve;if(i===f){var r=_(t);if(r===l&&t._state!==et)this._settledAt(t._state,e,t._result);else if("function"!=typeof r)this._remaining--,this._result[e]=t;else if(n===N){var o=new n(d);y(o,t,r),this._willSettleAt(o,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(i(t),e)},P.prototype._settledAt=function(t,e,n){var i=this.promise;i._state===et&&(this._remaining--,t===it?b(i,n):this._result[e]=n),0===this._remaining&&I(i,this._result)},P.prototype._willSettleAt=function(t,e){var n=this;B(t,void 0,function(t){return n._settledAt(nt,e,t)},function(t){return n._settledAt(it,e,t)})},N.all=L,N.race=O,N.resolve=f,N.reject=D,N._setScheduler=o,N._setAsap=s,N._asap=V,N.prototype={constructor:N,then:l,catch:function(t){return this.then(null,t)}},N.polyfill=F,N.Promise=N,N})}).call(e,n(22),n(33))},function(t,e){function n(t){this.message=t}function i(t){var e=String(t).replace(/=+$/,"");if(e.length%4==1)throw new n("'atob' failed: The string to be decoded is not correctly encoded.");for(var i,o,s=0,u=0,a="";o=e.charAt(u++);~o&&(i=s%4?64*i+o:o,s++%4)?a+=String.fromCharCode(255&i>>(-2*s&6)):0)o=r.indexOf(o);return a}var r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";n.prototype=new Error,n.prototype.name="InvalidCharacterError",t.exports="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||i},function(t,e,n){function i(t){return decodeURIComponent(r(t).replace(/(.)/g,function(t,e){var n=e.charCodeAt(0).toString(16).toUpperCase();return n.length<2&&(n="0"+n),"%"+n}))}var r=n(19);t.exports=function(t){var e=t.replace(/-/g,"+").replace(/_/g,"/");switch(e.length%4){case 0:break;case 2:e+="==";break;case 3:e+="=";break;default:throw"Illegal base64url string!"}try{return i(e)}catch(t){return r(e)}}},function(t,e,n){"use strict";function i(t){this.message=t}var r=n(20);i.prototype=new Error,i.prototype.name="InvalidTokenError",t.exports=function(t,e){if("string"!=typeof t)throw new i("Invalid token specified");e=e||{};var n=!0===e.header?0:1;try{return JSON.parse(r(t.split(".")[n]))}catch(t){throw new i("Invalid token specified: "+t.message)}},t.exports.InvalidTokenError=i},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function r(t){if(l===setTimeout)return setTimeout(t,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(t,0);try{return l(t,0)}catch(e){try{return l.call(null,t,0)}catch(e){return l.call(this,t,0)}}}function o(t){if(f===clearTimeout)return clearTimeout(t);if((f===i||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function s(){_&&h&&(_=!1,h.length?p=h.concat(p):g=-1,p.length&&u())}function u(){if(!_){var t=r(s);_=!0;for(var e=p.length;e;){for(h=p,p=[];++g<e;)h&&h[g].run();g=-1,e=p.length}h=null,_=!1,o(t)}}function a(t,e){this.fun=t,this.array=e}function c(){}var l,f,d=t.exports={};!function(){try{l="function"==typeof setTimeout?setTimeout:n}catch(t){l=n}try{f="function"==typeof clearTimeout?clearTimeout:i}catch(t){f=i}}();var h,p=[],_=!1,g=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];p.push(new a(t,e)),1!==p.length||_||r(u)},a.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=c,d.addListener=c,d.once=c,d.off=c,d.removeListener=c,d.removeAllListeners=c,d.emit=c,d.prependListener=c,d.prependOnceListener=c,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";function i(t){return o=o||new Promise(function(e,i){t.authToken?(n.i(s.a)(c,t.authToken),e(t.authToken)):t.getAuthToken(function(t,r){t?(n.i(s.a)(c,t),e(t)):i(new u.a("GetAuthTokenError","Auth token is undefined",r))},function(t,e){i(new u.a("GetAuthTokenError",t,e))})})}function r(t){if(!t)throw Error("Empty AuthToken");var e=a(t);return{tenantId:e.tid,userAadId:e.oid,userPuid:e.puid,expirationTimeEpoch:e.exp}}e.a=i,e.b=r;var o,s=n(30),u=n(0),a=n(21),c=(n.n(a),"LokiAuthToken")},function(t,e,n){"use strict";function i(t,e){return o=o||new Promise(function(i,o){var c=new XMLHttpRequest,l=r(e);c.open("GET",l,!0),c.setRequestHeader("authToken",t),c.setRequestHeader("Accept","application/json");var h=n.i(u.a)();c.setRequestHeader("X-RootCorrelationId",h),c.setRequestHeader("X-CorrelationId",h),c.setRequestHeader("X-ClientCorrelationId",e.clientCorrelationId),c.setRequestHeader("X-ClientType",e.clientType);var p=n.i(s.a)(d);p&&c.setRequestHeader(d,p),c.addEventListener("load",function(){if(200===c.status)try{var t=JSON.parse(c.response);t.RootCorrelationId=h,t.LokiVersion=c.getResponseHeader("x-serverversion")||"",i(t)}catch(t){o(new a.a("GetLokiConfigError","Failed to parse initialization config.",h))}else o(new a.a("GetLokiConfigError","Couldn't retrieve initialization config. Status code is "+c.status,h))}),c.addEventListener("error",function(){o(new a.a("GetLokiConfigError","Couldn't retrieve initialization config, request failed to complete.",h))}),c.addEventListener("timeout",function(){o(new a.a("GetLokiConfigError","Loki config request timed out after "+f+" ms.",h))}),c.timeout=f,c.send()})}function r(t){var e=n.i(s.a)(h),i=e||t.culture;return"ppe"===t.region||"df"===t.region||"msit"===t.region?c.replace("{0}",t.region).replace("{1}",t.clientType).replace("{2}",i):l.replace("{0}",t.clientType).replace("{1}",i)}e.a=i;var o,s=n(7),u=n(27),a=n(0),c="https://{0}.loki.delve.office.com/api/v1/configuration/{1}/{2}",l="https://loki.delve.office.com/api/v1/configuration/{0}/{1}",f=6e4,d="LivePersonaCardVersionOverride",h="LivePersonaCardCultureOverride"},function(t,e,n){"use strict";function i(t){if(!o){var e=t.Resources[l],i=void 0;n.i(u.a)("lpcUseLocalBuild")?(e="https://localhost:3333/assets/livepersonacardstrings.js",i="https://localhost:3333/assets/livepersonacard.js"):i=r()?t.Resources[c]:t.Resources[a],o=Promise.all([n.i(s.a)(e),n.i(s.a)(i)])}return o}function r(){return window.React&&window.React.version&&0===window.React.version.indexOf("15.")&&window.ReactDOM&&window.ReactDOM.version&&0===window.ReactDOM.version.indexOf("15.")}e.a=i;var o,s=n(28),u=n(7),a="livepersonacard_full",c="livepersonacard_global",l="livepersonacardstrings"},function(t,e,n){"use strict";function i(t,e,n){return s=s||new Promise(function(i,o){try{var s=r(t,e,n);window.LPC.start(s),i()}catch(t){o(new u.a("StartLivePersonaCardError",t.name+" "+t.message))}})}function r(t,e,n){return{refreshAuthToken:o(e),logToExternalApplication:e.logMessage,logToExternalAria:function(t,e){t.tenantToken=e,a.AWT.logEvent(t)},contextType:e.clientContextType,strings:window.LivePersonaCardStrings.strings,source:e.clientType,consumerCorrelationId:e.clientCorrelationId,activeFlights:t.Flights,performanceTimings:n.getAllTimings(),isDebug:!1,region:e.region,culture:e.culture,dataCallbacks:e.dataCallbacks,actionCallbacks:e.actionCallbacks,privateDataCallbacks:e.privateDataCallbacks,privateActionCallbacks:e.privateActionCallbacks,options:e.options?e.options:{isImmersiveProfileEnabled:!1,isLinkedInIntegrationEnabled:!1,hideDocumentFilter:!1},lokiUrl:t.LokiUrl,lokiVersion:t.LokiVersion,tenantAadObjectId:e.tenantAadObjectId,userAadObjectId:e.userAadObjectId,userPuid:e.userPuid}}function o(t){return function(e){t.getAuthToken(function(t,n){e(t,"",n)},function(t,n){e("",t,n)})}}e.a=i;var s,u=n(0),a=n(5);n.n(a)},function(t,e,n){"use strict";function i(){return r.replace(/[xy]/g,function(t){var e;if(window.crypto){var n=new Uint8Array(1);window.crypto.getRandomValues(n),e=n[0]}else e=Math.floor(16*Math.random());return("x"===t?e%16:e%4+8).toString(16)})}e.a=i;var r="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"},function(t,e,n){"use strict";function i(t){return new Promise(function(e,n){var i=document.createElement("script");i.type="text/javascript",i.crossOrigin="anonymous",i.src=t,i.addEventListener("load",function(){e()}),i.addEventListener("error",function(){n(new r.a("LoadScriptError","Unexpected error while loading script on page."))}),document.body.appendChild(i)})}e.a=i;var r=n(0)},function(t,e,n){"use strict";n.d(e,"b",function(){return i}),n.d(e,"a",function(){return r});var i;!function(t){t.getAuthToken="GetAuthTokenFromStartDuration",t.getLokiConfig="GetLokiConfigFromStartDuration",t.getLpcBundles="GetLpcBundlesFromStartDuration"}(i||(i={}));var r=function(){function t(){this.start=this.getCurrentTime(),this.timings={}}return t.prototype.measureFromStart=function(t){this.timings[t]=Math.round(this.getCurrentTime()-this.start)},t.prototype.getAllTimings=function(){var t=this;if(window.performance&&"function"==typeof window.performance.getEntriesByType){var e=window.performance.getEntriesByType("resource");e&&e.forEach(function(e){if(e&&e.name){var n=e.name.toLowerCase(),i=!1;-1!==n.indexOf("authtoken/loki")?(n="AuthRequestDuration",i=!0):-1!==n.indexOf("/lpc/versionless/livepersonacard_")?(n="LpcBundleRequestDuration",i=!0):-1!==n.indexOf("/lpc/versionless/livepersonacardstrings")?(n="LpcStringsRequestDuration",i=!0):-1!==n.indexOf("/api/v1/configuration/")&&(n="InitConfigRequestDuration",i=!0),i&&(t.timings[n]=Math.round(e.duration))}})}return this.timings},t.prototype.getCurrentTime=function(){return window.performance&&"function"==typeof window.performance.now?performance.now():Date.now()},t}()},function(t,e,n){"use strict";function i(t,e){try{sessionStorage&&sessionStorage.setItem&&sessionStorage.setItem(t,e)}catch(t){}}e.a=i},function(t,e,n){"use strict";function i(t){return void 0===t||"string"!=typeof t||""===t||null===t}function r(t){return void 0===t||"function"!=typeof t}e.a=i,e.b=r},function(t,e,n){"use strict";function i(t){return new Promise(function(e,n){var i=r(t);i?n(new s.a("ValidateBootstrapperConfigError",i)):e()})}function r(t){var e="";if(t){var i=[];n.i(o.a)(t.culture)&&i.push("culture"),n.i(o.a)(t.clientType)&&i.push("clientType"),n.i(o.a)(t.clientContextType)&&i.push("clientContextType"),n.i(o.a)(t.clientCorrelationId)&&i.push("clientCorrelationId"),n.i(o.b)(t.logMessage)&&i.push("logMessage"),n.i(o.b)(t.getAuthToken)&&i.push("getAuthToken"),i.length>0&&(e="Invalid required parameter(s): "+i.join(", ")+". Check the values and types you're passing."),t.region&&-1===u.indexOf(t.region.toLowerCase().trim())&&(e+="Invalid region value. Allowed values are: empty string for production environments, and "+u.join(", ")+" for pre-production environments.")}else e="Config must be defined.";return e}e.a=i;var o=n(31),s=n(0),u=["msit","df","ppe"]},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e){t.exports="1.3.14"},function(t,e){},function(t,e,n){t.exports=n(8)}])});

/***/ }),

/***/ 2651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('generalOptions', {
    supportedCultures: [],
    supportedShortDateFormats: [],
    supportedShortTimeFormats: [],
    supportedTimeZones: [],
    selectedLocale: null,
    shouldRenameDefaultFolders: true,
    selectedDateFormat: null,
    selectedTimeFormat: null,
    selectedTimeZone: null,
    hasUserChangedLanguage: false,
});
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2758), exports);
//# sourceMappingURL=Dropdown.js.map

/***/ }),

/***/ 2654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function contextProperty(data) {
    var result = tslib_1.__assign({ __type: 'ContextProperty:#Exchange' }, data);
    return result;
}
exports.default = contextProperty;


/***/ }),

/***/ 2655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var PersonaCard_1 = __webpack_require__(2710);
var Store_1 = __webpack_require__(327);
var initializeLivePersonaCard_1 = __webpack_require__(2713);
var owa_people_loki_1 = __webpack_require__(2644);
var owa_string_utils_1 = __webpack_require__(2627);
var mobx_react_1 = __webpack_require__(11);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var HOVER_DELAY_MS = 500;
var LivePersonaCardPersonaTypes = {
    NotResolved: 'NotResolved',
    User: 'User',
    Group: 'Group',
    External: 'External',
    DistributionList: 'DistributionList',
    PrivateDistributionList: 'PrivateDistributionList',
    Location: 'Location',
    Room: 'Room',
    Meeting: 'Meeting',
};
var personaCardDiv;
var LegacyPersonaCardBehavior = /** @class */ (function (_super) {
    tslib_1.__extends(LegacyPersonaCardBehavior, _super);
    function LegacyPersonaCardBehavior(props) {
        var _this = _super.call(this, props) || this;
        _this.onElementClicked = function (ev) {
            ev.stopPropagation();
            _this.openPersonaCard();
        };
        _this.openPersonaCard = function () {
            if (!personaCardDiv) {
                personaCardDiv = document.createElement('div');
                personaCardDiv.id = 'personaCard';
                document.body.appendChild(personaCardDiv);
            }
            var _a = _this.props, name = _a.name, emailAddress = _a.emailAddress;
            if (name && emailAddress) {
                ReactDOM.render(React.createElement(PersonaCard_1.default, { emailAddress: emailAddress, name: name, targetElement: _this.wrappedElement, onDismiss: _this.closePersonaCard }), personaCardDiv);
            }
        };
        _this.closePersonaCard = function (ev) {
            ReactDOM.unmountComponentAtNode(personaCardDiv);
        };
        _this.onElementHover = function () {
            _this.openPersonaCard();
        };
        _this.onElementMouseEnter = function (ev) {
            _this.hoverTimerId = setTimeout(_this.onElementHover, HOVER_DELAY_MS);
        };
        _this.onElementMouseLeave = function (ev) {
            if (_this.hoverTimerId) {
                clearTimeout(_this.hoverTimerId);
                _this.hoverTimerId = undefined;
            }
        };
        _this.getElement = function (wrappedElement) {
            _this.wrappedElement = ReactDOM.findDOMNode(wrappedElement);
        };
        return _this;
    }
    LegacyPersonaCardBehavior.prototype.render = function () {
        return (React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props, { onPersonaCardBehaviorClick: this.onElementClicked, onPersonaCardBehaviorMouseEnter: this.onElementMouseEnter, onPersonaCardBehaviorMouseLeave: this.onElementMouseLeave, ref: this.getElement })));
    };
    return LegacyPersonaCardBehavior;
}(React.Component));
var LivePersonaCardBehavior = /** @class */ (function (_super) {
    tslib_1.__extends(LivePersonaCardBehavior, _super);
    function LivePersonaCardBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LivePersonaCardBehavior.prototype.componentDidMount = function () {
        initializeLivePersonaCard_1.default(this.props.composeEmailOverride);
    };
    LivePersonaCardBehavior.prototype.render = function () {
        if (Store_1.default.isLivePersonaCardInitialized) {
            var LivePersonaCardHoverTarget = window.LivePersonaCardHoverTarget;
            return (React.createElement(LivePersonaCardHoverTarget, { upn: this.props.emailAddress, externalAppSessionCorrelationId: owa_people_loki_1.lokiClientCorrelationId, disableHoverAndKeyPress: this.props.disableHoverAndKeyPress, hostAppPersonaInfo: {
                    PersonaType: calculatePersonaType(this.props.mailBoxType, this.props.personaType),
                    PersonaDisplayName: this.props.name,
                    OlsPersonaId: this.props.olsPersonaId,
                } },
                React.createElement("span", { className: this.props.className, "aria-label": this.props.ariaLabel },
                    React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props)))));
        }
        else {
            return React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props));
        }
    };
    LivePersonaCardBehavior = tslib_1.__decorate([
        mobx_react_1.observer
    ], LivePersonaCardBehavior);
    return LivePersonaCardBehavior;
}(React.Component));
function calculatePersonaType(mailBoxType, personaType) {
    if (!owa_string_utils_1.isNullOrWhiteSpace(mailBoxType)) {
        return getLivePersonaCardPersonaTypeFromMailBoxType(mailBoxType);
    }
    if (!owa_string_utils_1.isNullOrWhiteSpace(personaType) &&
        Object.keys(LivePersonaCardPersonaTypes).indexOf(personaType) > -1) {
        return personaType;
    }
    if (owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl')) {
        return 'User';
    }
    return 'NotResolved';
}
function getLivePersonaCardPersonaTypeFromMailBoxType(mailBoxType) {
    switch (mailBoxType) {
        case 'PublicDL':
            return LivePersonaCardPersonaTypes.DistributionList;
        case 'PrivateDL':
            return LivePersonaCardPersonaTypes.PrivateDistributionList;
        case 'GroupMailbox':
            return LivePersonaCardPersonaTypes.Group;
        case 'Mailbox':
        case 'Contact':
        case 'OneOff':
            return LivePersonaCardPersonaTypes.User;
        case 'Unknown':
            return LivePersonaCardPersonaTypes.NotResolved;
        default:
            return LivePersonaCardPersonaTypes.User;
    }
}
function personaCardBehavior(InputTemplate) {
    return mobx_react_1.observer(/** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var ComponentClass = owa_controls_feature_flags_1.isControlFeatureEnabled('rp-livePersonaCard')
                ? LivePersonaCardBehavior
                : LegacyPersonaCardBehavior;
            return React.createElement(ComponentClass, tslib_1.__assign({ InputTemplate: InputTemplate }, this.props));
        };
        return class_1;
    }(React.Component)));
}
exports.personaCardBehavior = personaCardBehavior;
//# sourceMappingURL=PersonaCardBehavior.js.map

/***/ }),

/***/ 2656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SelectableOptionMenuItemType;
(function (SelectableOptionMenuItemType) {
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Normal"] = 0] = "Normal";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Divider"] = 1] = "Divider";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Header"] = 2] = "Header";
})(SelectableOptionMenuItemType = exports.SelectableOptionMenuItemType || (exports.SelectableOptionMenuItemType = {}));
//# sourceMappingURL=SelectableOption.types.js.map

/***/ }),

/***/ 2661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OptionsCheckbox_1 = __webpack_require__(4928);
exports.OptionsCheckbox = OptionsCheckbox_1.default;
var OptionDescription_1 = __webpack_require__(4931);
exports.OptionDescription = OptionDescription_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getPersonasFromReadWriteRecipientList(readWriteRecipientList) {
    var personaList = [];
    if (readWriteRecipientList) {
        personaList = readWriteRecipientList.map(function (obj) { return obj.persona; });
    }
    return personaList;
}
exports.default = getPersonasFromReadWriteRecipientList;
//# sourceMappingURL=getPersonasFromReadWriteRecipientList.js.map

/***/ }),

/***/ 2669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var addReadWriteRecipient_1 = __webpack_require__(2615);
var findReadWriteRecipient_1 = __webpack_require__(2708);
var setHasSearchedDirectory_1 = __webpack_require__(2822);
var setIsSearching_1 = __webpack_require__(2689);
var showHideFindResult_1 = __webpack_require__(2616);
var isValidEmailAddress_1 = __webpack_require__(2112);
var parseSuspectedDisplayNameEmailAddress_1 = __webpack_require__(2754);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('resolveQueryStringToRecipient')(function resolveQueryStringToRecipient(recipientWell, shouldDirectlyResolve, searchDirectory, resolveIfSingle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var inputText, result;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setHasSearchedDirectory_1.default(recipientWell, searchDirectory);
                    inputText = recipientWell.queryString.trim();
                    if (!inputText) return [3 /*break*/, 7];
                    if (!shouldDirectlyResolve) return [3 /*break*/, 2];
                    setIsSearching_1.default(recipientWell, false /* isSearching */);
                    result = parseSuspectedDisplayNameEmailAddress_1.default(inputText);
                    return [4 /*yield*/, addReadWriteRecipient_1.default(recipientWell, isValidEmailAddress_1.default(result.EmailAddress.EmailAddress), result)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 2:
                    if (!(recipientWell.queryString.indexOf('@') >= 0 && recipientWell.inForceResolve)) return [3 /*break*/, 4];
                    setIsSearching_1.default(recipientWell, false /* isSearching */);
                    return [4 /*yield*/, addReadWriteRecipient_1.default(recipientWell, isValidEmailAddress_1.default(inputText), null, inputText)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    setIsSearching_1.default(recipientWell, true /* isSearching */);
                    return [4 /*yield*/, findReadWriteRecipient_1.default(recipientWell, recipientWell.queryString, searchDirectory, resolveIfSingle)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    // If query string is empty, hide find result with existing result cleared.
                    setIsSearching_1.default(recipientWell, false /* isSearching */);
                    showHideFindResult_1.default(recipientWell, true /* shouldShowFindResult */, true /* shouldClearFindResult */);
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=resolveQueryStringToRecipient.js.map

/***/ }),

/***/ 2670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getRegionalConfigurationRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetRegionalConfigurationRequest:#Exchange' }, data);
    return result;
}
exports.default = getRegionalConfigurationRequest;


/***/ }),

/***/ 2671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SelectableOption_types_1 = __webpack_require__(2656);
exports.DropdownMenuItemType = SelectableOption_types_1.SelectableOptionMenuItemType;
//# sourceMappingURL=Dropdown.types.js.map

/***/ }),

/***/ 2672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RecipientType;
(function (RecipientType) {
    RecipientType[RecipientType["None"] = 0] = "None";
    RecipientType[RecipientType["To"] = 1] = "To";
    RecipientType[RecipientType["Cc"] = 2] = "Cc";
    RecipientType[RecipientType["Bcc"] = 3] = "Bcc";
})(RecipientType = exports.RecipientType || (exports.RecipientType = {}));
//# sourceMappingURL=RecipientType.js.map

/***/ }),

/***/ 2676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if a given string is null, empty, or consists only of white-space characters.
 * @param text: the string to check
 */
function isNullOrWhiteSpace(text) {
    return text == null || text.trim().length == 0;
}
exports.isNullOrWhiteSpace = isNullOrWhiteSpace;
//# sourceMappingURL=isNullOrWhiteSpace.js.map

/***/ }),

/***/ 2677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    RecipientCacheHitIndex: {
        datapoint: {
            name: 'RecipientCacheHitIndex',
            customData: function (hitIndex) { return [Math.ceil(hitIndex / 50)]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 2678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getClientAccessTokenJsonRequest_1 = __webpack_require__(2679);
function getClientAccessTokenOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = getClientAccessTokenJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("GetClientAccessToken", req, options);
}
exports.default = getClientAccessTokenOperation;


/***/ }),

/***/ 2679:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getClientAccessTokenJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetClientAccessTokenJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = getClientAccessTokenJsonRequest;


/***/ }),

/***/ 2680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getClientAccessTokenRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetClientAccessTokenRequest:#Exchange' }, data);
    return result;
}
exports.default = getClientAccessTokenRequest;


/***/ }),

/***/ 2682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2683), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2683:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Icon_1 = __webpack_require__(43);
var Utilities_2 = __webpack_require__(7);
var Checkbox_classNames_1 = __webpack_require__(2684);
var Checkbox_styles_1 = __webpack_require__(2640);
var Checkbox = /** @class */ (function (_super) {
    tslib_1.__extends(Checkbox, _super);
    /**
     * Initialize a new instance of the TopHeaderV2
     * @param props Props for the component
     * @param context Context or initial state for the base component.
     */
    function Checkbox(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._warnMutuallyExclusive({
            'checked': 'defaultChecked'
        });
        _this._id = Utilities_1.getId('checkbox-');
        _this.state = {
            isChecked: !!(props.checked !== undefined ? props.checked : props.defaultChecked)
        };
        return _this;
    }
    Checkbox.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.checked !== undefined) {
            this.setState({
                isChecked: !!newProps.checked // convert null to false
            });
        }
    };
    /**
     * Render the Checkbox based on passed props
     */
    Checkbox.prototype.render = function () {
        var _a = this.props, checked = _a.checked, className = _a.className, defaultChecked = _a.defaultChecked, disabled = _a.disabled, inputProps = _a.inputProps, name = _a.name, boxSide = _a.boxSide, theme = _a.theme, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, customStyles = _a.styles, _b = _a.onRenderLabel, onRenderLabel = _b === void 0 ? this._onRenderLabel : _b, checkmarkIconProps = _a.checkmarkIconProps;
        var isChecked = checked === undefined ? this.state.isChecked : checked;
        var isReversed = boxSide !== 'start' ? true : false;
        this._classNames = this.props.getClassNames ?
            this.props.getClassNames(theme, !!disabled, !!isChecked, !!isReversed, className)
            : Checkbox_classNames_1.getClassNames(Checkbox_styles_1.getStyles(theme, customStyles), !!disabled, !!isChecked, !!isReversed, className);
        return (React.createElement("button", tslib_1.__assign({}, inputProps, (checked !== undefined && { checked: checked }), (defaultChecked !== undefined && { defaultChecked: defaultChecked }), { disabled: disabled, ref: this._resolveRef('_checkBox'), name: name, id: this._id, role: 'checkbox', type: 'button', className: this._classNames.root, onClick: this._onClick, onFocus: this._onFocus, onBlur: this._onBlur, "aria-checked": isChecked, "aria-disabled": disabled, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }),
            React.createElement("label", { className: this._classNames.label, htmlFor: this._id },
                React.createElement("div", { className: this._classNames.checkbox },
                    React.createElement(Icon_1.Icon, tslib_1.__assign({ iconName: 'CheckMark' }, checkmarkIconProps, { className: this._classNames.checkmark }))),
                onRenderLabel(this.props, this._onRenderLabel))));
    };
    Object.defineProperty(Checkbox.prototype, "checked", {
        get: function () {
            return this.state.isChecked;
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.focus = function () {
        if (this._checkBox) {
            this._checkBox.focus();
        }
    };
    Checkbox.prototype._onFocus = function (ev) {
        var inputProps = this.props.inputProps;
        if (inputProps && inputProps.onFocus) {
            inputProps.onFocus(ev);
        }
    };
    Checkbox.prototype._onBlur = function (ev) {
        var inputProps = this.props.inputProps;
        if (inputProps && inputProps.onBlur) {
            inputProps.onBlur(ev);
        }
    };
    Checkbox.prototype._onClick = function (ev) {
        var _a = this.props, disabled = _a.disabled, onChange = _a.onChange;
        var isChecked = this.state.isChecked;
        ev.preventDefault();
        ev.stopPropagation();
        if (!disabled) {
            if (onChange) {
                onChange(ev, !isChecked);
            }
            if (this.props.checked === undefined) {
                this.setState({ isChecked: !isChecked });
            }
        }
    };
    Checkbox.prototype._onRenderLabel = function (props) {
        var label = props.label;
        return label ? (React.createElement("span", { className: this._classNames.text }, label)) : (null);
    };
    Checkbox.defaultProps = {
        boxSide: 'start'
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Checkbox.prototype, "_onFocus", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Checkbox.prototype, "_onBlur", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Checkbox.prototype, "_onClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Checkbox.prototype, "_onRenderLabel", null);
    Checkbox = tslib_1.__decorate([
        Utilities_2.customizable('Checkbox', ['theme'])
    ], Checkbox);
    return Checkbox;
}(Utilities_1.BaseComponent));
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map

/***/ }),

/***/ 2684:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
exports.getClassNames = Utilities_1.memoizeFunction(function (styles, disabled, isChecked, isReversed, className) {
    return {
        root: Styling_1.mergeStyles('ms-Checkbox', isReversed && 'reversed', isChecked && 'is-checked', !disabled && 'is-enabled', disabled && 'is-disabled', className, styles.root, !disabled && [
            !isChecked && {
                selectors: {
                    ':hover .ms-Checkbox-checkbox': styles.checkboxHovered,
                    ':focus .ms-Checkbox-checkbox': styles.checkboxFocused
                }
            },
            isChecked && {
                selectors: {
                    ':hover .ms-Checkbox-checkbox': styles.checkboxCheckedHovered,
                    ':focus .ms-Checkbox-checkbox': styles.checkboxCheckedFocused
                }
            },
            {
                selectors: {
                    ':hover .ms-Checkbox-text': styles.textHovered,
                    ':focus .ms-Checkbox-text': styles.textFocused
                }
            }
        ]),
        label: Styling_1.mergeStyles('ms-Checkbox-label', styles.label, isReversed && styles.labelReversed, disabled && styles.labelDisabled),
        checkbox: Styling_1.mergeStyles('ms-Checkbox-checkbox', styles.checkbox, !disabled && isChecked && styles.checkboxChecked, disabled && !isChecked && styles.checkboxDisabled, disabled && isChecked && styles.checkboxCheckedDisabled),
        checkmark: Styling_1.mergeStyles(styles.checkmark, !disabled && isChecked && styles.checkmarkChecked, disabled && !isChecked && styles.checkmarkDisabled, disabled && isChecked && styles.checkmarkCheckedDisabled),
        text: Styling_1.mergeStyles('ms-Checkbox-text', styles.text, disabled && styles.textDisabled),
    };
});
//# sourceMappingURL=Checkbox.classNames.js.map

/***/ }),

/***/ 2685:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('messageFormatOption', {
    showBcc: null,
    showFrom: null,
    composeFormat: null,
    fontFamily: null,
    fontSize: null,
    isFontBold: null,
    isFontItalic: null,
    isFontUnderline: null,
    fontColor: null,
    isColorMenuShown: false,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var findReadWriteRecipient_1 = __webpack_require__(2708);
var resolveQueryStringToRecipient_1 = __webpack_require__(2669);
var setForceResolveState_1 = __webpack_require__(2755);
var showHideFindResult_1 = __webpack_require__(2616);
var owa_analytics_1 = __webpack_require__(12);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('resolveAllUnresolvedRecipients')(function resolveAllUnresolvedRecipients(recipientWell, onBeforeWaitingResove) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var indexToRemove, i, persona, invalidRecipientDisplayText;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setForceResolveState_1.default(recipientWell, true);
                    // Trim the query string prior to resolving in case of just empty spaces in the send scenario.
                    recipientWell.queryString = recipientWell.queryString.trim();
                    if (!recipientWell.queryString) return [3 /*break*/, 2];
                    onBeforeWaitingResove && onBeforeWaitingResove();
                    return [4 /*yield*/, resolveQueryStringToRecipient_1.default(recipientWell, false /* shouldDirectlyResolve */, true /* searchDirectory */, true /* resolveIfSingle */)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 2:
                    indexToRemove = -1;
                    for (i = 0; i < recipientWell.recipients.length; i++) {
                        if (recipientWell.recipients[i].persona &&
                            recipientWell.recipients[i].persona.EmailAddress &&
                            !recipientWell.recipients[i].persona.EmailAddress.EmailAddress) {
                            persona = recipientWell.recipients[i].persona;
                            // Don't log the known single type of mailbox that doesn't have an email address
                            if (persona.EmailAddress.MailboxType != 'PrivateDL') {
                                // There are server errors that report of empty email addresses.
                                // However, we're not sure how users are adding things to the well without email addresses.
                                // This should help us identify what the mailbox type and routing type are for those specific entries
                                // We can then understand what we're handling incorrectly client side for those recipient types
                                // We're logging every instance (bypassing with doNotSample = true) because this is low volume and temporary
                                owa_analytics_1.logUsage('EmptyEmailAddress', [persona.EmailAddress.MailboxType, persona.EmailAddress.RoutingType], null, { doNotSample: true });
                            }
                        }
                        if (!recipientWell.recipients[i].isValid) {
                            indexToRemove = i;
                            break;
                        }
                    }
                    if (!(indexToRemove != -1)) return [3 /*break*/, 4];
                    invalidRecipientDisplayText = recipientWell.recipients[indexToRemove].displayText;
                    // Set the flag so we come back here after we add a recipient to the well
                    recipientWell.queryString = invalidRecipientDisplayText;
                    recipientWell.recipients.splice(indexToRemove, 1);
                    onBeforeWaitingResove && onBeforeWaitingResove();
                    return [4 /*yield*/, findReadWriteRecipient_1.default(recipientWell, invalidRecipientDisplayText, true /* searchDirectory */, true /* resolveIfSingle */)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    // This is the base case for the recursion
                    setForceResolveState_1.default(recipientWell, false);
                    showHideFindResult_1.default(recipientWell, false /* shouldShowFindResult */);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=resolveAllUnresolvedRecipients.js.map

/***/ }),

/***/ 2689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setIsSearching')(function setIsSearching(viewstate, isSearching) {
    viewstate.isSearching = isSearching;
});
//# sourceMappingURL=setIsSearching.js.map

/***/ }),

/***/ 2690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// The reducer limits you to 24 unique entries currently.
var MAX_INDEX = 23;
exports.default = {
    SearchPeopleIndex: {
        datapoint: {
            name: 'SearchPeopleIndex',
            options: { isQos: true },
        },
    },
    FPThresholdHit: {
        datapoint: {
            name: 'FindPeopleThresholdHit',
        },
    },
    AddRecipientFromFindControl: {
        datapoint: {
            name: 'AddRecipientFromFindControl',
            customData: function (index, source) {
                return {
                    index: (index > MAX_INDEX ? MAX_INDEX : index).toString(),
                    source: source.toString(),
                };
            },
        },
    },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 2706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getPersonasFromReadWriteRecipientList_1 = __webpack_require__(2667);
var searchCache_1 = __webpack_require__(2638);
var legacy_1 = __webpack_require__(1);
var NUM_SUGGESTED_CONTACTS = 5;
exports.default = legacy_1.action('getAndPopulateSuggestedContacts')(function getAndPopulateSuggestedContacts(resultsToPopulate, wellContents) {
    var rcTopFive = searchCache_1.default('' /* searchQuery */, NUM_SUGGESTED_CONTACTS, wellContents ? getPersonasFromReadWriteRecipientList_1.default(wellContents) : null);
    var personaTypeSet = rcTopFive.map(function (result) {
        return {
            EmailAddress: result.EmailAddress,
            PersonaId: result.PersonaId,
            ADObjectId: result.ADObjectId,
        };
    });
    resultsToPopulate.splice.apply(resultsToPopulate, [0, resultsToPopulate.length].concat(personaTypeSet));
});
//# sourceMappingURL=getAndPopulateSuggestedContacts.js.map

/***/ }),

/***/ 2707:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var DEFAULT_MAX_RESULTS = 20;
exports.default = legacy_1.action('processFindPeopleResult')(function processFindPeopleResult(resultList, responseMessage, maxResults) {
    if (responseMessage.ResponseClass == 'Success' && responseMessage.ResultSet) {
        maxResults = maxResults ? maxResults : DEFAULT_MAX_RESULTS;
        maxResults =
            responseMessage.ResultSet.length > maxResults
                ? maxResults
                : responseMessage.ResultSet.length;
        var personaTypeSet = [];
        for (var i = 0; i < maxResults; i++) {
            var result = responseMessage.ResultSet[i];
            personaTypeSet.push({
                EmailAddress: result.EmailAddress,
                PersonaId: result.PersonaId,
                ADObjectId: result.ADObjectId,
            });
        }
        resultList.splice.apply(resultList, [0, resultList.length].concat(personaTypeSet));
    }
});
//# sourceMappingURL=processFindPeopleResult.js.map

/***/ }),

/***/ 2708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var addReadWriteRecipient_1 = __webpack_require__(2615);
var setFindResultSet_1 = __webpack_require__(2780);
var setIsSearching_1 = __webpack_require__(2689);
var showHideFindResult_1 = __webpack_require__(2616);
var datapoints_1 = __webpack_require__(2690);
var findPeople_1 = __webpack_require__(2737);
var ReadWriteRecipientWellViewState_1 = __webpack_require__(2114);
var store_1 = __webpack_require__(2821);
var owa_analytics_1 = __webpack_require__(12);
var searchCache_1 = __webpack_require__(2638);
var isCacheEmpty_1 = __webpack_require__(2781);
var processFindPeopleResult_1 = __webpack_require__(2707);
var getPersonasFromReadWriteRecipientList_1 = __webpack_require__(2667);
var legacy_1 = __webpack_require__(1);
var MAX_ENTRIES_TYPEDOWN = 5;
var MAX_ENTRIES_DIRECTORY = 20;
var FIND_PEOPLE_TIMEOUT = 1000;
var FIND_PEOPLE_REQUEST_COUNT_THRESHOLD = 3;
var handleLongDelay = function (recipientWell, queryString, resolveIfSingle, didTimeOut) { return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                didTimeOut.isTimedOut = true;
                return [4 /*yield*/, searchCacheFallback(recipientWell, queryString, resolveIfSingle, didTimeOut)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); }; };
var searchCacheFallback = legacy_1.action('searchCacheFallback')(function searchCacheFallback(recipientWell, queryString, resolveIfSingle, didTimeOut) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rcTopFive, personaTypeSet;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(recipientWell.queryString.trim() == queryString)) return [3 /*break*/, 3];
                    rcTopFive = searchCache_1.default(queryString, 5 /* numberOfResults */, getPersonasFromReadWriteRecipientList_1.default(recipientWell.recipients));
                    if (!(rcTopFive.length > 0)) return [3 /*break*/, 2];
                    personaTypeSet = rcTopFive.map(function (result) {
                        return {
                            EmailAddress: result.EmailAddress,
                            PersonaId: result.PersonaId,
                            ADObjectId: result.ADObjectId,
                        };
                    });
                    setIsSearching_1.default(recipientWell, false);
                    setFindResultSet_1.default(recipientWell, personaTypeSet);
                    return [4 /*yield*/, postProcessFindPeopleResult(recipientWell, ReadWriteRecipientWellViewState_1.FindRecipientResultType.Cache, resolveIfSingle)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (didTimeOut) {
                        didTimeOut.isCacheEmpty = true;
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
exports.default = legacy_1.action('findReadWriteRecipient')(function findReadWriteRecipient(recipientWell, queryString, searchDirectory, resolveIfSingle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var datapoint, didTimeOut, timeout, _a, _b, findPeopleResult, didAutoSearchDirectory, sameQueryString, maxFindResultShown, resultType, error_1, datapoint;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!recipientWell.shouldShowFindResult) {
                        showHideFindResult_1.default(recipientWell, true /* shouldShowFindResult */);
                    }
                    if (!(store_1.default.pendingFindPeopleRequests < FIND_PEOPLE_REQUEST_COUNT_THRESHOLD)) return [3 /*break*/, 12];
                    datapoint = new owa_analytics_1.PerformanceDatapoint(datapoints_1.default.SearchPeopleIndex.datapoint.name);
                    setIsSearching_1.default(recipientWell, true);
                    didTimeOut = { isTimedOut: false, isCacheEmpty: false };
                    if (!(searchDirectory || isCacheEmpty_1.default())) return [3 /*break*/, 1];
                    _a = null;
                    return [3 /*break*/, 3];
                case 1:
                    _b = setTimeout;
                    return [4 /*yield*/, handleLongDelay(recipientWell, queryString, resolveIfSingle, didTimeOut)];
                case 2:
                    _a = _b.apply(void 0, [_c.sent(),
                        FIND_PEOPLE_TIMEOUT]);
                    _c.label = 3;
                case 3:
                    timeout = _a;
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 10, , 11]);
                    store_1.default.pendingFindPeopleRequests++;
                    return [4 /*yield*/, findPeople_1.findPeople(queryString, searchDirectory)];
                case 5:
                    findPeopleResult = _c.sent();
                    store_1.default.pendingFindPeopleRequests--;
                    clearTimeout(timeout);
                    setIsSearching_1.default(recipientWell, false);
                    didAutoSearchDirectory = false;
                    sameQueryString = recipientWell.queryString.trim() == queryString;
                    if (!((!didTimeOut.isTimedOut || didTimeOut.isCacheEmpty) && sameQueryString)) return [3 /*break*/, 9];
                    maxFindResultShown = searchDirectory
                        ? MAX_ENTRIES_DIRECTORY
                        : MAX_ENTRIES_TYPEDOWN;
                    processFindPeopleResult_1.default(recipientWell.findResultSet, findPeopleResult, maxFindResultShown);
                    if (!(recipientWell.findResultSet.length > 0)) return [3 /*break*/, 7];
                    resultType = searchDirectory
                        ? ReadWriteRecipientWellViewState_1.FindRecipientResultType.SearchDirectory
                        : ReadWriteRecipientWellViewState_1.FindRecipientResultType.FindPeople;
                    return [4 /*yield*/, postProcessFindPeopleResult(recipientWell, resultType, resolveIfSingle)];
                case 6:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 7:
                    didAutoSearchDirectory = true;
                    return [4 /*yield*/, autoSearchDirectory(recipientWell, queryString, resolveIfSingle)];
                case 8:
                    _c.sent();
                    _c.label = 9;
                case 9:
                    datapoint.addCustomData([
                        didTimeOut.isTimedOut,
                        sameQueryString,
                        searchDirectory,
                        didTimeOut.isCacheEmpty,
                        didAutoSearchDirectory,
                    ]);
                    datapoint.end();
                    return [3 /*break*/, 11];
                case 10:
                    error_1 = _c.sent();
                    datapoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error_1);
                    return [3 /*break*/, 11];
                case 11: return [3 /*break*/, 14];
                case 12:
                    datapoint = new owa_analytics_1.PerformanceDatapoint(datapoints_1.default.FPThresholdHit.datapoint.name);
                    return [4 /*yield*/, searchCacheFallback(recipientWell, queryString, resolveIfSingle)];
                case 13:
                    _c.sent();
                    datapoint.end();
                    _c.label = 14;
                case 14: return [2 /*return*/];
            }
        });
    });
});
var autoSearchDirectory = legacy_1.action('autoSearchDirectory')(function autoSearchDirectory(recipientWell, queryString, resolveIfSingle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var findPeopleResult, sameQueryString, maxFindResultShown;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, findPeople_1.findPeople(queryString, true /* searchDirectory*/)];
                case 1:
                    findPeopleResult = _a.sent();
                    setIsSearching_1.default(recipientWell, false);
                    sameQueryString = recipientWell.queryString.trim() == queryString;
                    if (!sameQueryString) return [3 /*break*/, 3];
                    maxFindResultShown = MAX_ENTRIES_DIRECTORY;
                    processFindPeopleResult_1.default(recipientWell.findResultSet, findPeopleResult, maxFindResultShown);
                    recipientWell.hasSearchedDirectory = true;
                    return [4 /*yield*/, postProcessFindPeopleResult(recipientWell, ReadWriteRecipientWellViewState_1.FindRecipientResultType.SearchDirectory, resolveIfSingle)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
var postProcessFindPeopleResult = legacy_1.action('postProcessFindPeopleResult')(function postProcessFindPeopleResult(recipientWell, resultType, resolveIfSingle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(recipientWell.findResultSet.length == 1 && resolveIfSingle)) return [3 /*break*/, 2];
                    // Autoresolve if there's only a single result.
                    return [4 /*yield*/, addReadWriteRecipient_1.default(recipientWell, true /* isValid */, recipientWell.findResultSet[0], null /* newEmailAddress */)];
                case 1:
                    // Autoresolve if there's only a single result.
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    recipientWell.findResultType = resultType;
                    showHideFindResult_1.default(recipientWell, true /* shouldShowFindResult */);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=findReadWriteRecipient.js.map

/***/ }),

/***/ 2710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var PersonaControl_1 = __webpack_require__(673);
var Callout_1 = __webpack_require__(157);
var Persona_1 = __webpack_require__(234);
var styles = __webpack_require__(2711);
var PersonaCard = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaCard, _super);
    function PersonaCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseLeave = function (ev) {
            _this.props.onDismiss(ev);
        };
        return _this;
    }
    PersonaCard.prototype.render = function () {
        var _a = this.props, emailAddress = _a.emailAddress, name = _a.name, targetElement = _a.targetElement, onDismiss = _a.onDismiss;
        if (!targetElement) {
            return null;
        }
        return (React.createElement(Callout_1.Callout, { target: targetElement, directionalHint: 4 /* bottomLeftEdge */, isBeakVisible: false, onDismiss: onDismiss },
            React.createElement("div", { onMouseLeave: this.onMouseLeave, className: styles.container },
                React.createElement(PersonaControl_1.default, { name: name, emailAddress: emailAddress, size: Persona_1.PersonaSize.large, showPersonaDetails: true, secondaryText: emailAddress }))));
    };
    PersonaCard = tslib_1.__decorate([
        mobx_react_1.observer
    ], PersonaCard);
    return PersonaCard;
}(React.Component));
exports.default = PersonaCard;
//# sourceMappingURL=PersonaCard.js.map

/***/ }),

/***/ 2711:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(2712);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._2ZbqoLMzvSVTB15DLsl21H{padding:10px}._2ZbqoLMzvSVTB15DLsl21H .ms-Persona-details{-webkit-touch-callout:text;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:auto}", ""]);

// exports
exports.locals = {
	"container": "_2ZbqoLMzvSVTB15DLsl21H"
};

/***/ }),

/***/ 2713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var initializeLivePersonaCardAsync_1 = __webpack_require__(2714);
var Store_1 = __webpack_require__(327);
var owa_trace_1 = __webpack_require__(14);
var owa_bundling_1 = __webpack_require__(6);
var lazyStyles = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 2936));
});
var handleInitializeLivePersonaCard = legacy_1.action('handleInitializeLivePersonaCard')(function () {
    Store_1.default.isLivePersonaCardInitialized = true;
});
var livePersonaCardFailedToInitialize = false;
var initializationPromise = null;
exports.default = legacy_1.action('initializeLivePersonaCard')(function initializeLivePersonaCard(composeEmailOverride) {
    if (!initializationPromise &&
        !Store_1.default.isLivePersonaCardInitialized &&
        !livePersonaCardFailedToInitialize) {
        // TMP: Dynamically load css for card.  LPC will eventually fix this
        // and ship with the required fonts.
        lazyStyles.import();
        initializationPromise = initializeLivePersonaCardAsync_1.default(composeEmailOverride)
            .then(handleInitializeLivePersonaCard)
            .catch(function (reason) {
            initializationPromise = null;
            livePersonaCardFailedToInitialize = true;
            owa_trace_1.trace.error(reason);
        });
    }
});
//# sourceMappingURL=initializeLivePersonaCard.js.map

/***/ }),

/***/ 2714:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_analytics_1 = __webpack_require__(12);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_people_loki_1 = __webpack_require__(2644);
var getPersonaPhotoUrl_1 = __webpack_require__(345);
var getHexConsumerIdForUser_1 = __webpack_require__(1579);
var Persona_1 = __webpack_require__(234);
var getPersonaPhotoUrl_2 = __webpack_require__(345);
var store_1 = __webpack_require__(49);
var personaConfig_1 = __webpack_require__(1777);
var initializeLivePersonaCardPromise;
function initializeLivePersonaCardAsync(composeEmailOverride) {
    var config = personaConfig_1.getConfig();
    initializeLivePersonaCardPromise =
        initializeLivePersonaCardPromise ||
            new Promise(function (resolve, reject) {
                var actionCallbacks = {
                    composeMail: function (recipient, subject, body) {
                        if (composeEmailOverride) {
                            composeEmailOverride(recipient, recipient);
                        }
                        else if (config.actionCallbacks && config.actionCallbacks.composeMail) {
                            config.actionCallbacks.composeMail(recipient, subject, body);
                        }
                        // Compose view is triggered in existing window, therefore dismiss card so it's not left hanging without an anchor
                        window.LPC.dismissCard();
                    },
                };
                var dataCallbacks = {
                    getAndPrefetchPersonaImageUri: function (personaId, callback) {
                        var hexCid = getHexConsumerIdForUser_1.default(personaId.Smtp);
                        callback(hexCid
                            ? getPersonaPhotoUrl_2.getPersonaPhotoUrlFromhexCID(hexCid, Persona_1.PersonaSize.regular)
                            : getPersonaPhotoUrl_1.default(personaId.Smtp));
                    },
                };
                if (config.actionCallbacks && config.actionCallbacks.toggleFavoritePerson) {
                    actionCallbacks.toggleFavoritePerson = config.actionCallbacks.toggleFavoritePerson;
                }
                if (config.dataCallbacks && config.dataCallbacks.getIsPersonFavorited) {
                    dataCallbacks.getIsPersonFavorited = config.dataCallbacks.getIsPersonFavorited;
                }
                var isConsumer = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
                var culture = store_1.default.userConfiguration.SessionSettings.UserCulture;
                var tenantId = store_1.default.userConfiguration.SessionSettings.TenantGuid;
                var useDogfood = owa_controls_feature_flags_1.isControlFeatureEnabled('peo-lokiDogfood');
                var timeFormat = store_1.default.userConfiguration.UserOptions.TimeFormat;
                var is24HourFormat = timeFormat && timeFormat.indexOf('tt') === -1;
                var logger = function (eventName, customData) {
                    owa_analytics_1.logUsage(eventName, customData);
                };
                owa_people_loki_1.initializeLoki({
                    culture: culture,
                    isConsumer: isConsumer,
                    useDogfood: useDogfood,
                    logger: logger,
                    tenantId: tenantId,
                });
                var bootstrapperConfig = owa_people_loki_1.getLokiBootstrapperConfig();
                var lpcBootstrapperConfig = tslib_1.__assign({}, bootstrapperConfig, { actionCallbacks: actionCallbacks, dataCallbacks: dataCallbacks, options: {
                        isLinkedInIntegrationEnabled: false,
                        timeFormat: timeFormat,
                        is24HourFormat: is24HourFormat,
                    } });
                owa_people_loki_1.initializeLivePersonaCard(lpcBootstrapperConfig, function () {
                    resolve();
                }, function (errorMessage) {
                    reject(errorMessage);
                });
            });
    return initializeLivePersonaCardPromise;
}
exports.default = initializeLivePersonaCardAsync;
//# sourceMappingURL=initializeLivePersonaCardAsync.js.map

/***/ }),

/***/ 2715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authToken_1 = __webpack_require__(2647);
exports.AuthToken = authToken_1.AuthToken;
var authTokenProvider_1 = __webpack_require__(2723);
exports.AuthTokenProvider = authTokenProvider_1.AuthTokenProvider;
var authUtils_1 = __webpack_require__(2649);
exports.getAuthToken = authUtils_1.getAuthToken;
exports.setAuthToken = authUtils_1.setAuthToken;
exports.setAuthTokenOnUrl = authUtils_1.setAuthTokenOnUrl;
exports.clearAuthToken = authUtils_1.clearAuthToken;
exports.removeAuthTokenFromUrl = authUtils_1.removeAuthTokenFromUrl;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = __webpack_require__(2648);
function isLokiEndpoint(url) {
    if (StringUtils_1.isNullOrEmpty(url)) {
        return false;
    }
    var regex = new RegExp("^https://.+.loki.delve.office.com/.*", "i");
    return regex.test(url);
}
exports.isLokiEndpoint = isLokiEndpoint;
//# sourceMappingURL=isLokiEndpoint.js.map

/***/ }),

/***/ 2717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copied from Oslo code
// General base64 util based on this repo https://github.com/mathiasbynens/base64
// If you want to modify/change this code, consider this package instead - https://www.npmjs.com/package/atob
Object.defineProperty(exports, "__esModule", { value: true });
// This is just used for browsers <= IE9, for normal browsers use btoa and atob
var TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// From http://whatwg.org/html/common-microsyntaxes.html#space-character
var REGEX_SPACE_CHARACTERS = /<%= spaceCharacters %>/g;
/**
 * `decode` is designed to be fully compatible with `atob` as described in the
 * HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
 */
/* tslint:disable:no-bitwise */
function decode(input) {
    input = String(input).replace(REGEX_SPACE_CHARACTERS, "");
    var length = input.length;
    if (length % 4 === 0) {
        input = input.replace(/==?$/, "");
        length = input.length;
    }
    if (length % 4 === 1 || /[^+a-zA-Z0-9/]/.test(input)) {
        error("Invalid character: the string to be decoded is not correctly encoded.");
    }
    var bitCounter = 0;
    var bitStorage = 0;
    var buffer;
    var output = "";
    var position = -1;
    while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
        // Unless this is the first of a group of 4 characters…
        if (bitCounter++ % 4) {
            // …convert the first 8 bits to a single ASCII character.
            output += String.fromCharCode(0xff & (bitStorage >> ((-2 * bitCounter) & 6)));
        }
    }
    return output;
}
exports.decode = decode;
/** `encode` is designed to be fully compatible with `btoa` as described in the
 *  HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
 */
function encode(input) {
    input = String(input);
    if (/[^\0-\xFF]/.test(input)) {
        // Note: no need to special-case astral symbols here, as surrogates are
        // Matched, and the input is supposed to only contain ASCII anyway.
        error("The string to be encoded contains characters outside of the 'Latin1 range.");
    }
    var padding = input.length % 3;
    var output = "";
    var position = -1;
    var a;
    var b;
    var c;
    var buffer;
    // Make sure any padding is handled outside of the loop.
    var length = input.length - padding;
    while (++position < length) {
        // Read three bytes, i.e. 24 bits.
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c;
        // Turn the 24 bits into four chunks of 6 bits each, and append the
        // Matching character for each of them to the output.
        output +=
            TABLE.charAt((buffer >> 18) & 0x3f) +
                TABLE.charAt((buffer >> 12) & 0x3f) +
                TABLE.charAt((buffer >> 6) & 0x3f) +
                TABLE.charAt(buffer & 0x3f);
    }
    if (padding === 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += TABLE.charAt(buffer >> 10) + TABLE.charAt((buffer >> 4) & 0x3f) + TABLE.charAt((buffer << 2) & 0x3f) + "=";
    }
    else if (padding === 1) {
        buffer = input.charCodeAt(position);
        output += TABLE.charAt(buffer >> 2) + TABLE.charAt((buffer << 4) & 0x3f) + "==";
    }
    return output;
}
exports.encode = encode;
function error(message) {
    var error = new Error(message);
    error.name = "InvalidCharacterError";
    throw new Error(message);
}
//# sourceMappingURL=Base64.js.map

/***/ }),

/***/ 2718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Filters out null and undefined values from an array.
 * @param array The array to filter.
 */
function filterOutNull(array) {
    return array.filter(function (x) { return x !== null && x !== undefined; });
}
exports.filterOutNull = filterOutNull;
/**
 * Returns copy of the given object with all null, undefined, empty string and empty array values removed.
 *
 * The return type isn't totally correct, since it claims that we _can_ return keys with undefined values. It would be neat if we could
 * apply Partial only to the falsyable values, but at least we preserve a defensive version of the incoming type, so that you can't
 * accidentally pass the output to something expecting something completely different.
 */
function omitEmpty(o) {
    return pickBy(o, function (val) { return val !== undefined && val !== null && val !== "" && (!(val instanceof Array) || val.length > 0); });
}
exports.omitEmpty = omitEmpty;
function pickBy(o, pred) {
    if (o === undefined || o === null) {
        return o;
    }
    var ret = {};
    for (var _i = 0, _a = Object.keys(o); _i < _a.length; _i++) {
        var key = _a[_i];
        if (pred(o[key])) {
            ret[key] = o[key];
        }
    }
    return ret;
}
/*
 * Given a "current" and an "update" object, return a new object with the merged properties of current and update, with precedence given to
 * update. The function ensures that update is an exact subset of current. I.e. update cannot (normally) introduce any keys that don't
 * already exist in current.
 *
 * The exception to this rule occurs if update is _not_ a literal object and contains extra properties _in addition_ to all the properties
 * in current. This is an effect of the type checking system, which tends to be more relaxed about object expressions than literal objects.
 *
 * As an example:
 *
 * Given interface I { a: number, b: number},
 * keyof I is "a" | "b"
 * [key in K]: I[K] is an indexer mapping keys to their respective types in I. This will fail for keys that are not in I, since they cannot
 * be mapped.
 *
 * This signature looks very much like Partial<T> and is indeed almost the same thing. However, since Partial marks all its properties as
 * optional, all of them will have undefined as a valid type. We very much don't want the update object to accidentally set non-nullable
 * properties to undefined, so this means we can't use Partial<T>
 */
function updateWith(current, update) {
    return Object.assign({}, current, update);
}
exports.updateWith = updateWith;
//# sourceMappingURL=Functional.js.map

/***/ }),

/***/ 2719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MemoryStorageUtils = __webpack_require__(2720);
var SessionStorageUtils = __webpack_require__(2721);
function clear(appId) {
    MemoryStorageUtils.clear(appId);
    SessionStorageUtils.clear();
}
exports.clear = clear;
function setItem(key, value, appId) {
    MemoryStorageUtils.setItem(key, value, appId);
    SessionStorageUtils.setItem(key, value);
}
exports.setItem = setItem;
function getItem(key, appId) {
    var val = SessionStorageUtils.getItem(key);
    if (val !== undefined) {
        return val;
    }
    return MemoryStorageUtils.getItem(key, appId);
}
exports.getItem = getItem;
function removeItem(key, appId) {
    MemoryStorageUtils.removeItem(key, appId);
    SessionStorageUtils.removeItem(key);
}
exports.removeItem = removeItem;
//# sourceMappingURL=StorageUtils.js.map

/***/ }),

/***/ 2720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var memoryStorage = new Map();
function clear(appId) {
    memoryStorage.delete(appId);
}
exports.clear = clear;
function setItem(key, value, appId) {
    var map = memoryStorage.get(appId) || new Map();
    map.set(key, value);
    memoryStorage.set(appId, map);
}
exports.setItem = setItem;
function getItem(key, appId) {
    var map = memoryStorage.get(appId);
    return map ? map.get(key) : undefined;
}
exports.getItem = getItem;
function removeItem(key, appId) {
    var map = memoryStorage.get(appId);
    if (map) {
        map.delete(key);
    }
}
exports.removeItem = removeItem;
//# sourceMappingURL=MemoryStorageUtils.js.map

/***/ }),

/***/ 2721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function clear() {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.clear();
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.clear = clear;
function setItem(key, value) {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.setItem(key, value);
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.setItem = setItem;
function getItem(key) {
    if (window.sessionStorage) {
        try {
            var val = window.sessionStorage.getItem(key);
            return val === null ? undefined : val;
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
    return undefined;
}
exports.getItem = getItem;
function removeItem(key) {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.removeItem(key);
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.removeItem = removeItem;
//# sourceMappingURL=SessionStorageUtils.js.map

/***/ }),

/***/ 2722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getUrlParameter(name, searchString) {
    if (searchString === void 0) { searchString = window.location.search; }
    var param = searchString
        .substr(1)
        .split("&")
        .map(function (e) { return e.split("=").map(function (f) { return decodeURIComponent(f); }); })
        .filter(function (u) { return u[0] === name; });
    return param[0] && param[0][1];
}
exports.getUrlParameter = getUrlParameter;
//# sourceMappingURL=UrlUtils.js.map

/***/ }),

/***/ 2723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authToken_1 = __webpack_require__(2647);
var authUtils_1 = __webpack_require__(2649);
var GET_AUTH_TOKEN_SCENARIO = "LokiGetAuthToken";
var GET_AUTH_TOKEN_FAILED = "LokiGetAuthTokenFailed";
/**
 * A guy you need to ask to getAuthToken and it will keep your worries away
 */
var AuthTokenProvider = (function () {
    function AuthTokenProvider(getAppId, refreshAuthToken, logger, runWithLogMonitor, authTokenType, loggingFeature) {
        if (authTokenType === void 0) { authTokenType = authToken_1.AuthToken; }
        if (loggingFeature === void 0) { loggingFeature = "RESTAuthToken"; }
        this.getAppId = getAppId;
        this.refreshAuthToken = refreshAuthToken;
        this.logger = logger;
        this.runWithLogMonitor = runWithLogMonitor;
        this.authTokenType = authTokenType;
        this.loggingFeature = loggingFeature;
        this.getAuthToken();
    }
    AuthTokenProvider.prototype.getAuthToken = function () {
        var _this = this;
        // Try getting a valid token we already have
        if (this.authToken && this.authToken.isValid()) {
            return Promise.resolve(this.authToken);
        }
        // Try getting the token from cache
        this.authToken = new this.authTokenType(authUtils_1.getAuthToken(this.getAppId()), this.loggingFeature, this.logger);
        if (this.authToken.isValid()) {
            return Promise.resolve(this.authToken);
        }
        this.authPromise =
            this.authPromise ||
                new Promise(function (resolve, reject) {
                    if (_this.runWithLogMonitor) {
                        _this.runWithLogMonitor({
                            scenarioName: GET_AUTH_TOKEN_SCENARIO,
                            feature: _this.loggingFeature,
                            operation: function () { return _this.authToken.refresh(_this.refreshAuthToken); },
                            successAction: function (token) {
                                _this.onRefreshAuthTokenSuccess(token);
                                resolve(token);
                            },
                            errorAction: function (reason) {
                                _this.onRefreshAuthTokenError(reason);
                                reject(reason);
                            },
                            treatAsExpectedError: function (error) {
                                return !!navigator && !navigator.onLine;
                            }
                        });
                    }
                    else {
                        _this.authToken
                            .refresh(_this.refreshAuthToken)
                            .then(function (token) {
                            _this.onRefreshAuthTokenSuccess(token);
                            resolve(token);
                        })
                            .catch(function (reason) {
                            _this.onRefreshAuthTokenError(reason);
                            reject(reason);
                        });
                    }
                });
        return this.authPromise;
    };
    AuthTokenProvider.prototype.onRefreshAuthTokenSuccess = function (newToken) {
        this.authPromise = undefined;
        authUtils_1.setAuthToken(this.getAppId(), newToken.getValue() || "");
    };
    AuthTokenProvider.prototype.onRefreshAuthTokenError = function (error) {
        this.authPromise = undefined;
        if (this.logger) {
            this.logger.logError(GET_AUTH_TOKEN_FAILED, this.loggingFeature, { message: error });
        }
    };
    return AuthTokenProvider;
}());
exports.AuthTokenProvider = AuthTokenProvider;
//# sourceMappingURL=authTokenProvider.js.map

/***/ }),

/***/ 2724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getClientAccessTokenOperation_1 = __webpack_require__(2678);
var Utils_1 = __webpack_require__(362);
var getClientAccessTokenRequest_1 = __webpack_require__(2680);
var LokiAuthTokenId = '94c63fef-13a3-47bc-8074-75af8c65887a';
function getLokiAuthTokenAsync() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, results, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: Utils_1.getJsonRequestHeader(),
                        Body: getClientAccessTokenRequest_1.default({
                            TokenRequests: [
                                {
                                    __type: 'TokenRequest:#Exchange',
                                    Id: LokiAuthTokenId,
                                    TokenType: 'Loki',
                                },
                            ],
                        }),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getClientAccessTokenOperation_1.default(request)];
                case 2:
                    results = _a.sent();
                    if (results && results.Body.ResponseMessages.Items[0].ResponseClass == 'Success') {
                        return [2 /*return*/, results.Body.ResponseMessages.Items[0].Token.TokenValue];
                    }
                    return [2 /*return*/, null];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.default = getLokiAuthTokenAsync;
//# sourceMappingURL=getLokiAuthTokenAsync.js.map

/***/ }),

/***/ 2725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This endpoint is used to test that Loki is working end to end
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var lokiRequest_1 = __webpack_require__(2726);
function getUserInfo(userSmtp) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var path, queryParameters, response, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    path = 'api/beta/userinfo';
                    queryParameters = {
                        userSmtp: userSmtp,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, lokiRequest_1.lokiRequest('GET', path, queryParameters)];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, response.json()];
                    }
                    return [2 /*return*/, Promise.reject(response.status)];
                case 3:
                    error_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getUserInfo = getUserInfo;
//# sourceMappingURL=userInfoProvider.js.map

/***/ }),

/***/ 2726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var fetchLokiConfigAsync_1 = __webpack_require__(2727);
var lokiContext = __webpack_require__(2612);
var requestAuthTokenHandler_1 = __webpack_require__(2646);
function lokiRequest(method, path, queryParameters, body, headers) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var config, authToken, url, requestInit;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchLokiConfigAsync_1.fetchLokiConfigAsync()];
                case 1:
                    config = _a.sent();
                    return [4 /*yield*/, requestAuthTokenHandler_1.getAuthToken()];
                case 2:
                    authToken = (_a.sent()).getValue();
                    if (!headers) {
                        headers = new Headers();
                    }
                    headers.set('Accept', 'application/json');
                    headers.set('Content-Type', 'application/json');
                    headers.set('authorization', "Bearer " + authToken);
                    headers.set('X-ClientCorrelationId', lokiContext.clientCorrelationId);
                    headers.set('X-ClientType', lokiContext.clientType);
                    headers.set('X-ClientScenario', lokiContext.clientScenario);
                    headers.set('X-RefererUrl', '');
                    url = addQueryParametersToUrl(config.LokiUrl + path, queryParameters);
                    requestInit = {
                        method: method,
                        headers: headers,
                        body: body,
                    };
                    return [2 /*return*/, fetch(url, requestInit)];
            }
        });
    });
}
exports.lokiRequest = lokiRequest;
function addQueryParametersToUrl(url, queryParameters) {
    var parametersKeys = Object.keys(queryParameters);
    if (parametersKeys.length === 0) {
        return url;
    }
    var parameters = [];
    parametersKeys.forEach(function (key) {
        var value = queryParameters[key];
        parameters.push(key + '=' + encodeURIComponent(value || ''));
    });
    return url + '?' + parameters.join('&');
}
//# sourceMappingURL=lokiRequest.js.map

/***/ }),

/***/ 2727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLokiBootstrapperConfig_1 = __webpack_require__(2645);
var live_persona_card_bootstrapper_1 = __webpack_require__(2650);
var lokiConfig = undefined;
function fetchLokiConfigAsync() {
    if (lokiConfig) {
        return Promise.resolve(lokiConfig);
    }
    var bootstrapperConfig = getLokiBootstrapperConfig_1.getLokiBootstrapperConfig();
    return live_persona_card_bootstrapper_1.fetchLokiConfig(bootstrapperConfig).then(function (config) {
        lokiConfig = config;
        return lokiConfig;
    });
}
exports.fetchLokiConfigAsync = fetchLokiConfigAsync;
//# sourceMappingURL=fetchLokiConfigAsync.js.map

/***/ }),

/***/ 2728:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('skypeOption', {
    imNotification: null,
    callNotification: null,
});
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2729:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialSurfaceActionsStore = {
    isAddinObserverLoaded: false,
};
var store = satcheljs_1.createStore('SurfaceActionsStore', initialSurfaceActionsStore)();
exports.default = store;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_delayed_initialization_1 = __webpack_require__(28);
var initCalendarMailboxConfiguration_1 = __webpack_require__(3765);
// Load initial state needed for options
owa_delayed_initialization_1.runAfterBootstrap(function () {
    initCalendarMailboxConfiguration_1.default();
});
var saveCalendarMailboxConfiguration_1 = __webpack_require__(5251);
exports.saveCalendarMailboxConfiguration = saveCalendarMailboxConfiguration_1.default;
var getCalendarConfiguration_1 = __webpack_require__(5254);
exports.getCalendarConfiguration = getCalendarConfiguration_1.default;
var initCalendarMailboxConfiguration_2 = __webpack_require__(3765);
exports.initCalendarMailboxConfiguration = initCalendarMailboxConfiguration_2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = __webpack_require__(23);
var contextProperty_1 = __webpack_require__(2654);
var findPeopleJsonRequest_1 = __webpack_require__(1561);
var findPeopleRequest_1 = __webpack_require__(1748);
var indexedPageView_1 = __webpack_require__(236);
var personaResponseShape_1 = __webpack_require__(1749);
var propertyUri_1 = __webpack_require__(40);
var findPeopleOperation_1 = __webpack_require__(1750);
var ServiceRequestUtils_1 = __webpack_require__(31);
var MAX_ENTRIES_DIRECTORY = 20;
var MAX_ENTRIES_TYPEDOWN = 10;
function configureIndexedPageView(includeDirectory) {
    return indexedPageView_1.default({
        BasePoint: 'Beginning',
        Offset: 0,
        MaxEntriesReturned: includeDirectory ? MAX_ENTRIES_DIRECTORY : MAX_ENTRIES_TYPEDOWN,
    });
}
function configureRequestBody(queryString, includeDirectory) {
    var querySources = ['Mailbox'];
    if (includeDirectory) {
        querySources.push('Directory');
    }
    return findPeopleRequest_1.default({
        IndexedPageItemView: configureIndexedPageView(includeDirectory),
        PersonaShape: configurePersonaShape(),
        QuerySources: querySources,
        QueryString: queryString,
        SearchPeopleSuggestionIndex: true,
        ShouldResolveOneOffEmailAddress: false,
        Context: configureContext(),
    });
}
function configurePersonaShape() {
    return owa_mail_feature_flags_1.isMailFeatureEnabled('rp-requestPersonaResponseShape')
        ? personaResponseShape_1.default({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri_1.default({ FieldURI: 'PersonaEmailAddress' }),
                propertyUri_1.default({ FieldURI: 'EmailAddresses' }),
                propertyUri_1.default({ FieldURI: 'PersonaDisplayName' }),
                propertyUri_1.default({ FieldURI: 'PersonaDisplayNames' }),
                propertyUri_1.default({ FieldURI: 'PersonaId' }),
                propertyUri_1.default({ FieldURI: 'PersonaType' }),
            ],
        })
        : personaResponseShape_1.default({
            BaseShape: 'Default',
        });
}
function configureContext() {
    return [contextProperty_1.default({ Key: 'AppName', Value: 'OWA' })];
}
function findPeople(queryString, includeDirectory) {
    var requestBody = configureRequestBody(queryString, includeDirectory);
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    })).then(function (response) {
        var responseMessage = response.Body;
        return responseMessage;
    });
}
exports.findPeople = findPeople;
//# sourceMappingURL=findPeople.js.map

/***/ }),

/***/ 2753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Icon_1 = __webpack_require__(43);
var Spinner_1 = __webpack_require__(670);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_strings_1 = __webpack_require__(20);
var owa_common_strings_1 = __webpack_require__(37);
var React = __webpack_require__(3);
var styles = __webpack_require__(3013);
var classNames = __webpack_require__(30).bind(styles);
var FindRecipientInfoType;
(function (FindRecipientInfoType) {
    FindRecipientInfoType[FindRecipientInfoType["Default"] = 0] = "Default";
    FindRecipientInfoType[FindRecipientInfoType["Searching"] = 1] = "Searching";
    FindRecipientInfoType[FindRecipientInfoType["TypeToSearch"] = 2] = "TypeToSearch";
    FindRecipientInfoType[FindRecipientInfoType["SearchDirectory"] = 3] = "SearchDirectory";
    FindRecipientInfoType[FindRecipientInfoType["TopNResults"] = 4] = "TopNResults";
    FindRecipientInfoType[FindRecipientInfoType["UseAddress"] = 5] = "UseAddress";
})(FindRecipientInfoType = exports.FindRecipientInfoType || (exports.FindRecipientInfoType = {}));
var FindRecipientInfo = function (props) {
    var isConsumerUser = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
    switch (props.infoType) {
        case FindRecipientInfoType.Searching:
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement(Spinner_1.Spinner, { className: styles.loadingSpinner })),
                React.createElement("div", { className: styles.textContainer }, owa_strings_1.format(owa_common_strings_1.default.findRecipientInfo_Searching, props.queryString))));
        case FindRecipientInfoType.TypeToSearch:
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: classNames(styles.textContainer, styles.centered) }, owa_common_strings_1.default.findRecipientInfo_TypeToSearch)));
        case FindRecipientInfoType.SearchDirectory:
            return (props.searchDirectoryAction && (React.createElement("div", { className: classNames(styles.container, styles.hoverable, {
                    isHighlighted: props.highlighted,
                }), onClick: props.searchDirectoryAction },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement(Icon_1.Icon, { className: styles.searchIcon, iconName: "Search" /* Search */ })),
                React.createElement("div", { className: styles.textContainer }, isConsumerUser
                    ? owa_common_strings_1.default.findRecipientInfo_SearchPeople
                    : owa_common_strings_1.default.findRecipientInfo_SearchDirectory))));
        case FindRecipientInfoType.TopNResults:
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: classNames(styles.textContainer, styles.centered) }, props.numberOfResults
                    ? owa_strings_1.format(owa_common_strings_1.default.findRecipientInfo_TopNResults, props.numberOfResults)
                    : owa_common_strings_1.default.findRecipientInfo_NoResultsFound)));
        case FindRecipientInfoType.UseAddress:
            return (props.useTypedAddressAction && (React.createElement("div", null,
                React.createElement("div", { className: classNames(styles.hoverable, {
                        isHighlighted: props.highlighted,
                    }) },
                    React.createElement("div", { className: classNames(styles.textContainer, styles.useAddressContainer), onClick: props.useTypedAddressAction }, owa_strings_1.format(owa_common_strings_1.default.findRecipientInfo_UseThisAddress, props.queryString))),
                React.createElement(FindRecipientInfo, { infoType: FindRecipientInfoType.TopNResults, highlighted: false, queryString: props.queryString, numberOfResults: props.numberOfResults }))));
        default:
            return null;
    }
};
exports.default = FindRecipientInfo;
//# sourceMappingURL=FindRecipientInfo.js.map

/***/ }),

/***/ 2754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function parseSuspectedDisplayNameEmailAddress(parseString) {
    // Prepare the string
    parseString = parseString.replace(/['"]+/g, '');
    parseString = parseString.trim();
    // Split on various potential opening brackets
    var splits = parseString.split(/([<\[\({])+/g);
    var displayName;
    var emailAddress = parseString;
    if (splits.length == 3) {
        displayName = splits[0].trim();
        emailAddress = splits[2].split(/([>\]\)}])+/g)[0].trim();
    }
    return {
        EmailAddress: {
            MailboxType: 'OneOff',
            RoutingType: 'SMTP',
            EmailAddress: emailAddress,
            Name: displayName ? displayName : emailAddress,
        },
    };
}
exports.default = parseSuspectedDisplayNameEmailAddress;
//# sourceMappingURL=parseSuspectedDisplayNameEmailAddress.js.map

/***/ }),

/***/ 2755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setForceResolveState')(function setForceResolveState(viewstate, inForceResolve) {
    viewstate.inForceResolve = inForceResolve;
});
//# sourceMappingURL=setForceResolveState.js.map

/***/ }),

/***/ 2757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getRegionalConfigurationRequest_1 = __webpack_require__(2670);
function getRegionalConfigurationOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = getRegionalConfigurationRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("GetRegionalConfiguration", req, options);
}
exports.default = getRegionalConfigurationOperation;


/***/ }),

/***/ 2758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2759), exports);
tslib_1.__exportStar(__webpack_require__(2671), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Dropdown_types_1 = __webpack_require__(2671);
var Checkbox_1 = __webpack_require__(2639);
var Callout_1 = __webpack_require__(157);
var Label_1 = __webpack_require__(1559);
var Button_1 = __webpack_require__(62);
var Panel_1 = __webpack_require__(1747);
var Icon_1 = __webpack_require__(43);
var FocusZone_1 = __webpack_require__(78);
var withResponsiveMode_1 = __webpack_require__(325);
var Utilities_1 = __webpack_require__(7);
var SelectableOption_types_1 = __webpack_require__(2656);
var stylesImport = __webpack_require__(2760);
var styles = stylesImport;
var Checkbox_styles_1 = __webpack_require__(2640);
var Styling_1 = __webpack_require__(21);
var Dropdown = /** @class */ (function (_super) {
    tslib_1.__extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this._scrollIdleDelay = 250 /* ms */;
        props.options.forEach(function (option) {
            if (!option.itemType) {
                option.itemType = Dropdown_types_1.DropdownMenuItemType.Normal;
            }
        });
        _this = _super.call(this, props) || this;
        _this._warnDeprecations({
            'isDisabled': 'disabled'
        });
        _this._warnMutuallyExclusive({
            'defaultSelectedKey': 'selectedKey',
            'defaultSelectedKeys': 'selectedKeys',
            'selectedKeys': 'selectedKey',
            'multiSelect': 'defaultSelectedKey',
            'selectedKey': 'multiSelect'
        });
        _this._id = props.id || Utilities_1.getId('Dropdown');
        _this._isScrollIdle = true;
        _this.state = {
            isOpen: false
        };
        if (_this.props.multiSelect) {
            var selectedKeys = props.defaultSelectedKeys !== undefined ? props.defaultSelectedKeys : props.selectedKeys;
            _this.state = {
                selectedIndices: _this._getSelectedIndexes(props.options, selectedKeys)
            };
        }
        else {
            var selectedKey = props.defaultSelectedKey !== undefined ? props.defaultSelectedKey : props.selectedKey;
            _this.state = {
                selectedIndices: _this._getSelectedIndexes(props.options, selectedKey)
            };
        }
        return _this;
    }
    Dropdown_1 = Dropdown;
    Dropdown.prototype.componentWillReceiveProps = function (newProps) {
        // In controlled component usage where selectedKey is provided, update the selectedIndex
        // state if the key or options change.
        var selectedKeyProp = this.props.multiSelect ? 'selectedKeys' : 'selectedKey';
        if (newProps[selectedKeyProp] !== undefined &&
            (newProps[selectedKeyProp] !== this.props[selectedKeyProp] || newProps.options !== this.props.options)) {
            this.setState({
                selectedIndices: this._getSelectedIndexes(newProps.options, newProps[selectedKeyProp])
            });
        }
    };
    Dropdown.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.isOpen === true && this.state.isOpen === false) {
            this._dropDown.focus();
            if (this.props.onDismiss) {
                this.props.onDismiss();
            }
        }
    };
    // Primary Render
    Dropdown.prototype.render = function () {
        var id = this._id;
        var _a = this.props, className = _a.className, label = _a.label, options = _a.options, disabled = _a.disabled, isDisabled = _a.isDisabled, ariaLabel = _a.ariaLabel, required = _a.required, errorMessage = _a.errorMessage, _b = _a.onRenderTitle, onRenderTitle = _b === void 0 ? this._onRenderTitle : _b, _c = _a.onRenderContainer, onRenderContainer = _c === void 0 ? this._onRenderContainer : _c, _d = _a.onRenderPlaceHolder, onRenderPlaceHolder = _d === void 0 ? this._onRenderPlaceHolder : _d, _e = _a.onRenderCaretDown, onRenderCaretDown = _e === void 0 ? this._onRenderCaretDown : _e;
        var _f = this.state, isOpen = _f.isOpen, _g = _f.selectedIndices, selectedIndices = _g === void 0 ? [] : _g;
        var selectedOptions = this._getAllSelectedOptions(options, selectedIndices);
        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
        // Remove this deprecation workaround at 1.0.0
        if (isDisabled !== undefined) {
            disabled = isDisabled;
        }
        return (React.createElement("div", { ref: this._resolveRef('_root'), className: Utilities_1.css('ms-Dropdown-container') },
            label && (React.createElement(Label_1.Label, { className: Utilities_1.css('ms-Dropdown-label'), id: id + '-label', htmlFor: id, ref: this._resolveRef('_dropdownLabel'), required: required }, label)),
            React.createElement("div", tslib_1.__assign({ "data-is-focusable": !disabled, ref: this._resolveRef('_dropDown'), id: id, tabIndex: disabled ? -1 : 0, "aria-expanded": isOpen ? 'true' : 'false', role: 'menu', "aria-live": disabled || isOpen ? 'off' : 'assertive', "aria-label": ariaLabel, "aria-describedby": id + '-option', "aria-activedescendant": isOpen && selectedIndices.length === 1 && selectedIndices[0] >= 0 ? (this._id + '-list' + selectedIndices[0]) : null, "aria-disabled": disabled, "aria-owns": isOpen ? id + '-list' : null }, divProps, { className: Utilities_1.css('ms-Dropdown', styles.root, className, isOpen && 'is-open', disabled && ('is-disabled ' + styles.rootIsDisabled), required && 'is-required'), onBlur: this._onDropdownBlur, onKeyDown: this._onDropdownKeyDown, onKeyUp: this._onDropdownKeyUp, onClick: this._onDropdownClick }),
                React.createElement("span", { id: id + '-option', className: Utilities_1.css('ms-Dropdown-title', styles.title, !selectedOptions.length && 'ms-Dropdown-titleIsPlaceHolder', !selectedOptions.length && styles.titleIsPlaceHolder, (errorMessage && errorMessage.length > 0 ? styles.titleIsError : null)), "aria-atomic": true, role: 'textbox', "aria-readonly": 'true' }, // If option is selected render title, otherwise render the placeholder text
                selectedOptions.length ? (onRenderTitle(selectedOptions, this._onRenderTitle)) :
                    onRenderPlaceHolder(this.props, this._onRenderPlaceHolder)),
                React.createElement("span", { className: Utilities_1.css('ms-Dropdown-caretDownWrapper', styles.caretDownWrapper) }, onRenderCaretDown(this.props, this._onRenderCaretDown))),
            isOpen && (onRenderContainer(this.props, this._onRenderContainer)),
            errorMessage &&
                React.createElement("div", { className: Utilities_1.css(styles.errorMessage) }, errorMessage)));
    };
    Dropdown.prototype.focus = function (shouldOpenOnFocus) {
        if (this._dropDown && this._dropDown.tabIndex !== -1) {
            this._dropDown.focus();
            if (shouldOpenOnFocus) {
                this.setState({
                    isOpen: true
                });
            }
        }
    };
    Dropdown.prototype.setSelectedIndex = function (index) {
        var _a = this.props, onChanged = _a.onChanged, options = _a.options, selectedKey = _a.selectedKey, selectedKeys = _a.selectedKeys, multiSelect = _a.multiSelect;
        var _b = this.state.selectedIndices, selectedIndices = _b === void 0 ? [] : _b;
        var checked = selectedIndices ? selectedIndices.indexOf(index) > -1 : false;
        index = Math.max(0, Math.min(options.length - 1, index));
        if (!multiSelect && index === selectedIndices[0]) {
            return;
        }
        else if (!multiSelect && selectedKey === undefined) {
            // Set the selected option if this is an uncontrolled component
            this.setState({
                selectedIndices: [index]
            });
        }
        else if (multiSelect && selectedKeys === undefined) {
            var newIndexes = selectedIndices ? this._copyArray(selectedIndices) : [];
            if (checked) {
                var position = newIndexes.indexOf(index);
                if (position > -1) {
                    // unchecked the current one
                    newIndexes.splice(position, 1);
                }
            }
            else {
                // add the new selected index into the existing one
                newIndexes.push(index);
            }
            this.setState({
                selectedIndices: newIndexes
            });
        }
        if (onChanged) {
            // for single-select, option passed in will always be selected.
            // for multi-select, flip the checked value
            var changedOpt = multiSelect ? tslib_1.__assign({}, options[index], { selected: !checked }) : options[index];
            onChanged(changedOpt, index);
        }
    };
    Dropdown.prototype._copyArray = function (array) {
        var newArray = [];
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var element = array_1[_i];
            newArray.push(element);
        }
        return newArray;
    };
    /**
     * Finds the next valid Dropdown option and sets the selected index to it.
     * @param stepValue Value of how many items the function should traverse.  Should be -1 or 1.
     * @param index Index of where the search should start
     * @param selectedIndex The selectedIndex Dropdown's state
     * @returns The next valid dropdown option's index
     */
    Dropdown.prototype._moveIndex = function (stepValue, index, selectedIndex) {
        var options = this.props.options;
        // Return selectedIndex if nothing has changed or options is empty
        if (selectedIndex === index || options.length === 0) {
            return selectedIndex;
        }
        // Set starting index to 0 if index is < 0
        if (index < 0) {
            index = 0;
        }
        // Set starting index to last option index if greater than options.length
        if (index >= options.length) {
            index = options.length - 1;
        }
        var stepCounter = 0;
        // If current index is a header or divider, increment by step
        while (options[index].itemType === Dropdown_types_1.DropdownMenuItemType.Header || options[index].itemType === Dropdown_types_1.DropdownMenuItemType.Divider) {
            // If stepCounter exceeds length of options, then return selectedIndex (-1)
            if (stepCounter >= options.length) {
                return selectedIndex;
            }
            // If index + stepValue is out of bounds, wrap around
            if (index + stepValue < 0) {
                index = options.length;
            }
            else if (index + stepValue >= options.length) {
                index = -1;
            }
            index = index + stepValue;
            stepCounter++;
        }
        this.setSelectedIndex(index);
        return index;
    };
    // Render text in dropdown input
    Dropdown.prototype._onRenderTitle = function (item) {
        var _a = this.props.multiSelectDelimiter, multiSelectDelimiter = _a === void 0 ? ', ' : _a;
        var displayTxt = item.map(function (i) { return i.text; }).join(multiSelectDelimiter);
        return React.createElement("span", null, displayTxt);
    };
    // Render placeHolder text in dropdown input
    Dropdown.prototype._onRenderPlaceHolder = function (props) {
        if (!props.placeHolder) {
            return null;
        }
        return React.createElement("span", null, props.placeHolder);
    };
    // Render Callout or Panel container and pass in list
    Dropdown.prototype._onRenderContainer = function (props) {
        var _a = this.props, _b = _a.onRenderList, onRenderList = _b === void 0 ? this._onRenderList : _b, responsiveMode = _a.responsiveMode, calloutProps = _a.calloutProps, dropdownWidth = _a.dropdownWidth;
        var isSmall = responsiveMode <= withResponsiveMode_1.ResponsiveMode.medium;
        return (isSmall ?
            (React.createElement(Panel_1.Panel, { className: Utilities_1.css('ms-Dropdown-panel', styles.panel), isOpen: true, isLightDismiss: true, onDismissed: this._onDismiss, hasCloseButton: false }, onRenderList(props, this._onRenderList)))
            :
                (React.createElement(Callout_1.Callout, tslib_1.__assign({ isBeakVisible: false, gapSpace: 0, doNotLayer: false, directionalHintFixed: true, directionalHint: 4 /* bottomLeftEdge */ }, calloutProps, { className: Utilities_1.css('ms-Dropdown-callout', styles.callout, calloutProps ? calloutProps.className : undefined), target: this._dropDown, onDismiss: this._onDismiss, onScroll: this._onScroll, onPositioned: this._onPositioned, calloutWidth: dropdownWidth || this._dropDown.clientWidth }), onRenderList(props, this._onRenderList))));
    };
    // Render Caret Down Icon
    Dropdown.prototype._onRenderCaretDown = function (props) {
        return (React.createElement(Icon_1.Icon, { className: Utilities_1.css('ms-Dropdown-caretDown', styles.caretDown), iconName: 'ChevronDown' }));
    };
    // Render List of items
    Dropdown.prototype._onRenderList = function (props) {
        var _this = this;
        var _a = this.props.onRenderItem, onRenderItem = _a === void 0 ? this._onRenderItem : _a;
        var id = this._id;
        var _b = this.state.selectedIndices, selectedIndices = _b === void 0 ? [] : _b;
        return (React.createElement("div", { className: styles.listWrapper, onKeyDown: this._onZoneKeyDown, ref: this._resolveRef('_host'), tabIndex: 0 },
            React.createElement(FocusZone_1.FocusZone, { ref: this._resolveRef('_focusZone'), direction: FocusZone_1.FocusZoneDirection.vertical, defaultActiveElement: selectedIndices[0] !== undefined ? "#" + id + "-list" + selectedIndices[0] : undefined, id: id + '-list', className: Utilities_1.css('ms-Dropdown-items', styles.items), "aria-labelledby": id + '-label', role: 'listbox' }, this.props.options.map(function (item, index) { return onRenderItem(tslib_1.__assign({}, item, { index: index }), _this._onRenderItem); }))));
    };
    // Render items
    Dropdown.prototype._onRenderItem = function (item) {
        switch (item.itemType) {
            case SelectableOption_types_1.SelectableOptionMenuItemType.Divider:
                return this._renderSeparator(item);
            case SelectableOption_types_1.SelectableOptionMenuItemType.Header:
                return this._renderHeader(item);
            default:
                return this._renderOption(item);
        }
    };
    // Render separator
    Dropdown.prototype._renderSeparator = function (item) {
        var index = item.index, key = item.key;
        if (index > 0) {
            return (React.createElement("div", { role: 'separator', key: key, className: Utilities_1.css('ms-Dropdown-divider', styles.divider) }));
        }
        return null;
    };
    Dropdown.prototype._renderHeader = function (item) {
        var _a = this.props.onRenderOption, onRenderOption = _a === void 0 ? this._onRenderOption : _a;
        var key = item.key;
        return (React.createElement("div", { key: key, className: Utilities_1.css('ms-Dropdown-header', styles.header) }, onRenderOption(item, this._onRenderOption)));
    };
    // Render menu item
    Dropdown.prototype._renderOption = function (item) {
        var _a = this.props.onRenderOption, onRenderOption = _a === void 0 ? this._onRenderOption : _a;
        var _b = this.state.selectedIndices, selectedIndices = _b === void 0 ? [] : _b;
        var id = this._id;
        var isItemSelected = item.index !== undefined && selectedIndices ? selectedIndices.indexOf(item.index) > -1 : false;
        var checkboxStyles = Checkbox_styles_1.getStyles(Styling_1.getTheme());
        return (!this.props.multiSelect ?
            (React.createElement(Button_1.CommandButton, { id: id + '-list' + item.index, ref: Dropdown_1.Option + item.index, key: item.key, "data-index": item.index, "data-is-focusable": true, className: Utilities_1.css('ms-Dropdown-item', styles.item, (_c = {},
                    _c['is-selected ' + styles.itemIsSelected] = isItemSelected,
                    _c['is-disabled ' + styles.itemIsDisabled] = this.props.disabled === true,
                    _c)), onClick: this._onItemClick(item.index), onMouseEnter: this._onItemMouseEnter.bind(this, item), onMouseLeave: this._onMouseItemLeave.bind(this, item), onMouseMove: this._onItemMouseMove.bind(this, item), role: 'option', "aria-selected": isItemSelected ? 'true' : 'false', ariaLabel: item.ariaLabel || item.text, title: item.text }, onRenderOption(item, this._onRenderOption))) : (React.createElement(Checkbox_1.Checkbox, { id: id + '-list' + item.index, ref: Dropdown_1.Option + item.index, key: item.key, "data-index": item.index, "data-is-focusable": true, onChange: this._onItemClick(item.index), inputProps: {
                onMouseEnter: this._onItemMouseEnter.bind(this, item),
                onMouseLeave: this._onMouseItemLeave.bind(this, item),
                onMouseMove: this._onItemMouseMove.bind(this, item)
            }, label: item.text, className: Utilities_1.css('ms-ColumnManagementPanel-checkbox', 'ms-Dropdown-item', styles.item, (_d = {},
                _d['is-selected ' + styles.itemIsSelected] = isItemSelected,
                _d['is-disabled ' + styles.itemIsDisabled] = isItemSelected,
                _d)), role: 'option', "aria-selected": isItemSelected ? 'true' : 'false', checked: isItemSelected, 
            // Hover is being handled by focus styles
            // so clear out the explicit hover styles
            styles: {
                checkboxHovered: checkboxStyles.checkbox,
                checkboxCheckedHovered: checkboxStyles.checkboxChecked,
                textHovered: checkboxStyles.text
            } }, onRenderOption(item, this._onRenderOption))));
        var _c, _d;
    };
    // Render content of item (i.e. text/icon inside of button)
    Dropdown.prototype._onRenderOption = function (item) {
        return React.createElement("span", { className: Utilities_1.css('ms-Dropdown-optionText', styles.optionText) }, item.text);
    };
    Dropdown.prototype._onPositioned = function () {
        this._focusZone.focus();
    };
    Dropdown.prototype._onItemClick = function (index) {
        var _this = this;
        return function () {
            _this.setSelectedIndex(index);
            if (!_this.props.multiSelect) {
                // only close the callout when it's in single-select mode
                _this.setState({
                    isOpen: false
                });
            }
        };
    };
    /**
     * Scroll handler for the callout to make sure the mouse events
     * for updating focus are not interacting during scroll
     */
    Dropdown.prototype._onScroll = function () {
        var _this = this;
        if (!this._isScrollIdle && this._scrollIdleTimeoutId !== undefined) {
            this._async.clearTimeout(this._scrollIdleTimeoutId);
            this._scrollIdleTimeoutId = undefined;
        }
        else {
            this._isScrollIdle = false;
        }
        this._scrollIdleTimeoutId = this._async.setTimeout(function () { _this._isScrollIdle = true; }, this._scrollIdleDelay);
    };
    Dropdown.prototype._onItemMouseEnter = function (item, ev) {
        if (!this._isScrollIdle) {
            return;
        }
        var targetElement = ev.currentTarget;
        targetElement.focus();
    };
    Dropdown.prototype._onItemMouseMove = function (item, ev) {
        var targetElement = ev.currentTarget;
        if (!this._isScrollIdle || document.activeElement === targetElement) {
            return;
        }
        targetElement.focus();
    };
    Dropdown.prototype._onMouseItemLeave = function (item, ev) {
        if (!this._isScrollIdle) {
            return;
        }
        /**
         * IE11 focus() method forces parents to scroll to top of element.
         * Edge and IE expose a setActive() function for focusable divs that
         * sets the page focus but does not scroll the parent element.
         */
        if (this._host.setActive) {
            this._host.setActive();
        }
        else {
            this._host.focus();
        }
    };
    Dropdown.prototype._onDismiss = function () {
        this.setState({ isOpen: false });
        this._dropDown.focus();
    };
    // Get all selected indexes for multi-select mode
    Dropdown.prototype._getSelectedIndexes = function (options, selectedKey) {
        if (selectedKey === undefined) {
            if (this.props.multiSelect) {
                return this._getAllSelectedIndices(options);
            }
            var selectedIndex = this._getSelectedIndex(options, null);
            return selectedIndex !== -1 ? [selectedIndex] : [];
        }
        else if (!Array.isArray(selectedKey)) {
            return [this._getSelectedIndex(options, selectedKey)];
        }
        var selectedIndices = [];
        for (var _i = 0, selectedKey_1 = selectedKey; _i < selectedKey_1.length; _i++) {
            var key = selectedKey_1[_i];
            selectedIndices.push(this._getSelectedIndex(options, key));
        }
        return selectedIndices;
    };
    // Get all selected options for multi-select mode
    Dropdown.prototype._getAllSelectedOptions = function (options, selectedIndices) {
        var selectedOptions = [];
        for (var _i = 0, selectedIndices_1 = selectedIndices; _i < selectedIndices_1.length; _i++) {
            var index = selectedIndices_1[_i];
            var option = options[index];
            if (option) {
                selectedOptions.push(option);
            }
        }
        return selectedOptions;
    };
    Dropdown.prototype._getAllSelectedIndices = function (options) {
        return options
            .map(function (option, index) { return option.selected ? index : -1; })
            .filter(function (index) { return index !== -1; });
    };
    Dropdown.prototype._getSelectedIndex = function (options, selectedKey) {
        return Utilities_1.findIndex(options, (function (option) {
            // tslint:disable-next-line:triple-equals
            if (selectedKey != null) {
                return option.key === selectedKey;
            }
            else {
                return !!option.isSelected || !!option.selected;
            }
        }));
    };
    Dropdown.prototype._onDropdownBlur = function (ev) {
        if (this.state.isOpen) {
            // Do not onBlur when the callout is opened
            return;
        }
        if (this.props.onBlur) {
            this.props.onBlur(ev);
        }
    };
    Dropdown.prototype._onDropdownKeyDown = function (ev) {
        if (this.props.onKeyDown) {
            this.props.onKeyDown(ev);
            if (ev.preventDefault) {
                return;
            }
        }
        var newIndex;
        var selectedIndex = this.state.selectedIndices.length ? this.state.selectedIndices[0] : -1;
        switch (ev.which) {
            case 13 /* enter */:
                this.setState({
                    isOpen: !this.state.isOpen
                });
                break;
            case 27 /* escape */:
                if (!this.state.isOpen) {
                    return;
                }
                this.setState({
                    isOpen: false
                });
                break;
            case 38 /* up */:
                if (this.props.multiSelect) {
                    this.setState({ isOpen: true });
                }
                else {
                    newIndex = this._moveIndex(-1, selectedIndex - 1, selectedIndex);
                }
                break;
            case 40 /* down */:
                if (ev.altKey || ev.metaKey || this.props.multiSelect) {
                    this.setState({ isOpen: true });
                }
                else {
                    newIndex = this._moveIndex(1, selectedIndex + 1, selectedIndex);
                }
                break;
            case 36 /* home */:
                if (!this.props.multiSelect) {
                    newIndex = this._moveIndex(1, 0, selectedIndex);
                }
                break;
            case 35 /* end */:
                if (!this.props.multiSelect) {
                    newIndex = this._moveIndex(-1, this.props.options.length - 1, selectedIndex);
                }
                break;
            case 32 /* space */:
                // event handled in _onDropdownKeyUp
                break;
            default:
                return;
        }
        if (newIndex !== selectedIndex) {
            ev.stopPropagation();
            ev.preventDefault();
        }
    };
    Dropdown.prototype._onDropdownKeyUp = function (ev) {
        if (this.props.onKeyUp) {
            this.props.onKeyUp(ev);
            if (ev.preventDefault) {
                return;
            }
        }
        switch (ev.which) {
            case 32 /* space */:
                this.setState({
                    isOpen: !this.state.isOpen
                });
                break;
            default:
                return;
        }
        ev.stopPropagation();
        ev.preventDefault();
    };
    Dropdown.prototype._onZoneKeyDown = function (ev) {
        var elementToFocus;
        switch (ev.which) {
            case 38 /* up */:
                if (ev.altKey || ev.metaKey) {
                    this.setState({ isOpen: false });
                }
                else {
                    elementToFocus = Utilities_1.getLastFocusable(this._host, this._host.lastChild, true);
                }
                break;
            // All directional keystrokes should be canceled when the zone is rendered.
            // This avoids the body scroll from reacting and thus dismissing the dropdown.
            case 36 /* home */:
            case 35 /* end */:
            case 33 /* pageUp */:
            case 34 /* pageDown */:
                break;
            case 40 /* down */:
                elementToFocus = Utilities_1.getFirstFocusable(this._host, this._host.firstChild, true);
                break;
            case 27 /* escape */:
                this.setState({ isOpen: false });
                break;
            case 9 /* tab */:
                this.setState({ isOpen: false });
                return;
            default:
                return;
        }
        if (elementToFocus) {
            elementToFocus.focus();
        }
        ev.stopPropagation();
        ev.preventDefault();
    };
    Dropdown.prototype._onDropdownClick = function (ev) {
        if (this.props.onClick) {
            this.props.onClick(ev);
            if (ev.preventDefault) {
                return;
            }
        }
        var _a = this.props, disabled = _a.disabled, isDisabled = _a.isDisabled;
        var isOpen = this.state.isOpen;
        // Remove this deprecation workaround at 1.0.0
        if (isDisabled !== undefined) {
            disabled = isDisabled;
        }
        if (!disabled) {
            this.setState({
                isOpen: !isOpen
            });
        }
    };
    Dropdown.defaultProps = {
        options: []
    };
    Dropdown.Option = 'option';
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onRenderTitle", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onRenderPlaceHolder", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onRenderContainer", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onRenderCaretDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onRenderList", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onRenderItem", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_renderOption", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onRenderOption", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onPositioned", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onItemClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onScroll", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onMouseItemLeave", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onDismiss", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onDropdownBlur", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onDropdownKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onDropdownKeyUp", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onZoneKeyDown", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Dropdown.prototype, "_onDropdownClick", null);
    Dropdown = Dropdown_1 = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], Dropdown);
    return Dropdown;
    var Dropdown_1;
}(Utilities_1.BaseComponent));
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map

/***/ }),

/***/ 2760:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_6424c635{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;font-size:14px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";position:relative;outline:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.root_6424c635:hover .title_6424c635,.root_6424c635:hover .caretDown_6424c635,.root_6424c635:focus .title_6424c635,.root_6424c635:focus .caretDown_6424c635,.root_6424c635:active .title_6424c635,.root_6424c635:active .caretDown_6424c635{color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_6424c635:hover .title_6424c635,.root_6424c635:hover .caretDown_6424c635,.root_6424c635:focus .title_6424c635,.root_6424c635:focus .caretDown_6424c635,.root_6424c635:active .title_6424c635,.root_6424c635:active .caretDown_6424c635{color:Highlight}}.root_6424c635:hover .titleIsPlaceHolder_6424c635,.root_6424c635:focus .titleIsPlaceHolder_6424c635,.root_6424c635:active .titleIsPlaceHolder_6424c635{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.root_6424c635:hover .title_6424c635{border-color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.root_6424c635:active .title_6424c635{border-color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}.root_6424c635:focus .title_6424c635{border-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.root_6424c635 .ms-Label{display:inline-block;margin-bottom:8px}.root_6424c635.rootIsDisabled_6424c635 .title_6424c635{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";border:none;color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";cursor:default}@media screen and (-ms-high-contrast: active){.root_6424c635.rootIsDisabled_6424c635 .title_6424c635{border:1px solid GrayText;color:GrayText}}.root_6424c635.rootIsDisabled_6424c635 .title_6424c635.titleIsError_6424c635{border-color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.root_6424c635.rootIsDisabled_6424c635 .caretDown_6424c635{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_6424c635.rootIsDisabled_6424c635 .caretDown_6424c635{color:GrayText}}.listWrapper_6424c635:focus{outline:0}.caretDownWrapper_6424c635{position:absolute;top:1px;height:32px;line-height:30px}[dir='ltr'] .caretDownWrapper_6424c635{right:12px}[dir='rtl'] .caretDownWrapper_6424c635{left:12px}.caretDown_6424c635{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";font-size:12px;pointer-events:none}.title_6424c635{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;background:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";border:1px solid " }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";cursor:pointer;display:block;height:32px;line-height:30px;padding:0 32px 0 12px;position:relative;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}html[dir='rtl'] .title_6424c635{padding:0 12px 0 32px}.title_6424c635.titleIsError_6424c635{border-color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.title_6424c635.titleIsPlaceHolder_6424c635{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}[dir='ltr'] .panel_6424c635 .ms-Panel-main{-webkit-box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2)}[dir='rtl'] .panel_6424c635 .ms-Panel-main{-webkit-box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2)}.panel_6424c635 .ms-Panel-contentInner{padding:0 0 20px}.callout_6424c635{-webkit-box-shadow:0 0px 2px 0px rgba(0,0,0,0.2);box-shadow:0 0px 2px 0px rgba(0,0,0,0.2);border:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.errorMessage_6424c635{color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.errorMessage_6424c635::before{content:'* '}.items_6424c635{display:block}.item_6424c635{background:transparent;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;display:block;width:100%;height:auto;min-height:32px;line-height:20px;padding:4px 16px;position:relative;border:1px solid transparent;word-wrap:break-word;overflow-wrap:break-word;text-align:left}@media screen and (-ms-high-contrast: active){.item_6424c635{border-color:Window}}.item_6424c635:hover{color:inherit}.item_6424c635:focus{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.item_6424c635:focus{background-color:Highlight;border-color:Highlight;color:HighlightText}}@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: black-on-white){.item_6424c635:focus{-ms-high-contrast-adjust:none}}.item_6424c635:active{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": "}.item_6424c635.itemIsDisabled_6424c635{background:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";cursor:default}.item_6424c635 .ms-Button-flexContainer{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.item_6424c635.itemIsSelected_6424c635{background-color:" }, { "theme": "neutralQuaternaryAlt", "defaultValue": "#dadada" }, { "rawString": ";color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.item_6424c635.itemIsSelected_6424c635{background-color:Highlight;border-color:Highlight;color:HighlightText}}@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: black-on-white){.item_6424c635.itemIsSelected_6424c635{-ms-high-contrast-adjust:none}}.header_6424c635{font-size:14px;font-weight:400;font-weight:600;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";background:none;border:none;height:32px;line-height:32px;cursor:default;padding:0px 16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}html[dir='ltr'] .header_6424c635{text-align:left}html[dir='rtl'] .header_6424c635{text-align:right}.divider_6424c635{height:1px;background-color:" }, { "theme": "bodyDivider", "defaultValue": "#eaeaea" }, { "rawString": "}.optionText_6424c635{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;min-width:0px;max-width:100%;word-wrap:break-word;overflow-wrap:break-word;margin:1px}\n" }]);
exports.root = "root_6424c635";
exports.title = "title_6424c635";
exports.caretDown = "caretDown_6424c635";
exports.titleIsPlaceHolder = "titleIsPlaceHolder_6424c635";
exports.rootIsDisabled = "rootIsDisabled_6424c635";
exports.titleIsError = "titleIsError_6424c635";
exports.listWrapper = "listWrapper_6424c635";
exports.caretDownWrapper = "caretDownWrapper_6424c635";
exports.panel = "panel_6424c635";
exports.callout = "callout_6424c635";
exports.errorMessage = "errorMessage_6424c635";
exports.items = "items_6424c635";
exports.item = "item_6424c635";
exports.itemIsDisabled = "itemIsDisabled_6424c635";
exports.itemIsSelected = "itemIsSelected_6424c635";
exports.header = "header_6424c635";
exports.divider = "divider_6424c635";
exports.optionText = "optionText_6424c635";
//# sourceMappingURL=Dropdown.scss.js.map

/***/ }),

/***/ 2761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2762), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2762:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Image_1 = __webpack_require__(344);
var Label_1 = __webpack_require__(1559);
var Icon_1 = __webpack_require__(43);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(2763);
var styles = stylesImport;
var ChoiceGroup = /** @class */ (function (_super) {
    tslib_1.__extends(ChoiceGroup, _super);
    function ChoiceGroup(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({ 'onChanged': 'onChange' });
        _this._warnMutuallyExclusive({
            selectedKey: 'defaultSelectedKey'
        });
        _this.state = {
            keyChecked: (props.defaultSelectedKey === undefined) ?
                _this._getKeyChecked(props) :
                props.defaultSelectedKey,
            keyFocused: undefined
        };
        _this._id = Utilities_1.getId('ChoiceGroup');
        _this._labelId = Utilities_1.getId('ChoiceGroupLabel');
        return _this;
    }
    ChoiceGroup.prototype.componentWillReceiveProps = function (newProps) {
        var newKeyChecked = this._getKeyChecked(newProps);
        var oldKeyCheched = this._getKeyChecked(this.props);
        if (newKeyChecked !== oldKeyCheched) {
            this.setState({
                keyChecked: newKeyChecked,
            });
        }
    };
    ChoiceGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, options = _a.options, className = _a.className, required = _a.required;
        var _b = this.state, keyChecked = _b.keyChecked, keyFocused = _b.keyFocused;
        return (
        // Need to assign role application on containing div because JAWS doesn't call OnKeyDown without this role
        React.createElement("div", { role: 'application', className: className },
            React.createElement("div", { className: Utilities_1.css('ms-ChoiceFieldGroup', styles.root), role: 'radiogroup', "aria-labelledby": (this.props.label ? this._id + '-label' : '') + " " + (this.props['aria-labelledby'] || '') },
                this.props.label && (React.createElement(Label_1.Label, { className: className, required: required, id: this._id + '-label' }, label)),
                options.map(function (option) {
                    var _a = option.onRenderField, onRenderField = _a === void 0 ? _this._onRenderField : _a, _b = option.onRenderLabel, onRenderLabel = _b === void 0 ? _this._onRenderLabel : _b;
                    // Merge internal props into option
                    Utilities_1.assign(option, {
                        checked: option.key === keyChecked,
                        disabled: option.disabled || _this.props.disabled,
                        id: _this._id + "-" + option.key,
                        labelId: _this._labelId + "-" + option.key,
                        onRenderLabel: onRenderLabel
                    });
                    return (React.createElement("div", { key: option.key, className: Utilities_1.css('ms-ChoiceField', styles.choiceField, (_c = {},
                            _c['ms-ChoiceField--image ' + styles.choiceFieldIsImage] = !!option.imageSrc,
                            _c['ms-ChoiceField--icon ' + styles.choiceFieldIsIcon] = !!option.iconProps,
                            _c['is-inFocus ' + styles.choiceFieldIsInFocus] = option.key === keyFocused,
                            _c)) },
                        React.createElement("div", { className: Utilities_1.css('ms-ChoiceField-wrapper', styles.choiceFieldWrapper) },
                            React.createElement("input", tslib_1.__assign({ ref: _this._resolveRef('_inputElement'), id: option.id, className: Utilities_1.css('ms-ChoiceField-input', styles.input), type: 'radio', name: _this.props.name || _this._id, disabled: option.disabled || _this.props.disabled, checked: option.key === keyChecked, required: required, onChange: _this._onChange.bind(_this, option), onFocus: _this._onFocus.bind(_this, option), onBlur: _this._onBlur.bind(_this, option), "aria-labelledby": option.id }, Utilities_1.getNativeProps(option, Utilities_1.inputProperties))),
                            onRenderField(option, _this._onRenderField))));
                    var _c;
                }))));
    };
    ChoiceGroup.prototype.focus = function () {
        if (this._inputElement) {
            this._inputElement.focus();
        }
    };
    ChoiceGroup.prototype._onFocus = function (option, ev) {
        this.setState({
            keyFocused: option.key,
            keyChecked: this.state.keyChecked
        });
    };
    ChoiceGroup.prototype._onBlur = function (option, ev) {
        this.setState({
            keyFocused: undefined,
            keyChecked: this.state.keyChecked
        });
    };
    ChoiceGroup.prototype._onRenderField = function (option) {
        var onRenderLabel = option.onRenderLabel;
        return (React.createElement("label", { htmlFor: option.id, className: Utilities_1.css('ms-ChoiceField-field', styles.field, (_a = {},
                _a['ms-ChoiceField-field--image ' + styles.fieldIsImage] = !!option.imageSrc,
                _a['ms-ChoiceField--icon ' + styles.fieldIsIcon] = !!option.iconProps,
                _a['is-checked ' + styles.fieldIsChecked] = option.checked,
                _a['is-disabled ' + styles.fieldIsDisabled] = option.disabled,
                _a)) },
            option.imageSrc && (React.createElement("div", { className: Utilities_1.css('ms-ChoiceField-innerField', styles.innerField) },
                React.createElement("div", { className: Utilities_1.css('ms-ChoiceField-imageWrapper', styles.imageWrapper, (_b = {},
                        _b['is-hidden ' + styles.imageWrapperIsHidden] = option.checked,
                        _b)) },
                    React.createElement(Image_1.Image, { src: option.imageSrc, width: option.imageSize ? option.imageSize.width : undefined, height: option.imageSize ? option.imageSize.height : undefined })),
                React.createElement("div", { className: Utilities_1.css('ms-ChoiceField-imageWrapper', styles.imageWrapper, (_c = {},
                        _c['is-hidden ' + styles.imageWrapperIsHidden] = !option.checked,
                        _c)) },
                    React.createElement(Image_1.Image, { src: option.selectedImageSrc, width: option.imageSize ? option.imageSize.width : undefined, height: option.imageSize ? option.imageSize.height : undefined })))),
            option.iconProps
                ? React.createElement("div", { className: Utilities_1.css('ms-ChoiceField-innerField', styles.innerField) },
                    React.createElement("div", { className: Utilities_1.css('ms-ChoiceField-iconWrapper', styles.iconWrapper) },
                        React.createElement(Icon_1.Icon, tslib_1.__assign({}, option.iconProps))))
                : null,
            option.imageSrc || option.iconProps
                ? (React.createElement("div", { className: Utilities_1.css('ms-ChoiceField-labelWrapper', styles.labelWrapper) }, onRenderLabel(option))) : onRenderLabel(option)));
        var _a, _b, _c;
    };
    ChoiceGroup.prototype._onRenderLabel = function (option) {
        return (React.createElement("span", { id: option.labelId, className: 'ms-Label' }, option.text));
    };
    ChoiceGroup.prototype._onChange = function (option, evt) {
        var _a = this.props, onChanged = _a.onChanged, onChange = _a.onChange, selectedKey = _a.selectedKey;
        // Only manage state in uncontrolled scenarios.
        if (selectedKey === undefined) {
            this.setState({
                keyChecked: option.key
            });
        }
        // TODO: onChanged deprecated, remove else if after 07/17/2017 when onChanged has been removed.
        if (onChange) {
            onChange(evt, option);
        }
        else if (onChanged) {
            onChanged(option);
        }
    };
    /**
     * If all the isChecked property of options are falsy values, return undefined;
     * Else return the key of the first option with the truthy isChecked property.
     */
    ChoiceGroup.prototype._getKeyChecked = function (props) {
        if (props.selectedKey !== undefined) {
            return props.selectedKey;
        }
        var optionsChecked = props.options.filter(function (option) {
            return option.checked;
        });
        if (optionsChecked.length === 0) {
            return undefined;
        }
        else {
            return optionsChecked[0].key;
        }
    };
    ChoiceGroup.defaultProps = {
        options: []
    };
    return ChoiceGroup;
}(Utilities_1.BaseComponent));
exports.ChoiceGroup = ChoiceGroup;
//# sourceMappingURL=ChoiceGroup.js.map

/***/ }),

/***/ 2763:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_7b15c7a3{display:block}.choiceField_7b15c7a3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;color:" }, { "theme": "bodyText", "defaultValue": "#333333" }, { "rawString": ";font-size:14px;font-weight:400;min-height:26px;border:none;position:relative;margin-top:8px}.choiceField_7b15c7a3 .ms-Label{font-size:14px;padding:0 0 0 26px;display:inline-block}[dir='rtl'] .choiceField_7b15c7a3 .ms-Label{padding:0 26px 0 0}.input_7b15c7a3{position:absolute;opacity:0;top:8px}.field_7b15c7a3::before{content:'';display:inline-block;background-color:" }, { "theme": "bodyBackground", "defaultValue": "#ffffff" }, { "rawString": ";border:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";width:20px;height:20px;font-weight:normal;position:absolute;top:0;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition-property:border-color;transition-property:border-color;-webkit-transition-duration:200ms;transition-duration:200ms;-webkit-transition-timing-function:cubic-bezier(0.4, 0, 0.23, 1);transition-timing-function:cubic-bezier(0.4, 0, 0.23, 1);border-radius:50%}[dir='ltr'] .field_7b15c7a3::before{left:0}[dir='rtl'] .field_7b15c7a3::before{right:0}.field_7b15c7a3::after{content:'';width:0;height:0;border-radius:50%;position:absolute;-webkit-transition-property:border-width;transition-property:border-width;-webkit-transition-duration:150ms;transition-duration:150ms;-webkit-transition-timing-function:cubic-bezier(0.4, 0, 0.23, 1);transition-timing-function:cubic-bezier(0.4, 0, 0.23, 1);-webkit-box-sizing:border-box;box-sizing:border-box}[dir='ltr'] .field_7b15c7a3::after{left:10px}[dir='rtl'] .field_7b15c7a3::after{right:10px}[dir='ltr'] .field_7b15c7a3::after{right:0}[dir='rtl'] .field_7b15c7a3::after{left:0}.field_7b15c7a3{display:inline-block;cursor:pointer;margin-top:0;position:relative;vertical-align:top;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;min-height:20px}.field_7b15c7a3:hover::before,.field_7b15c7a3:focus::before{border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}.field_7b15c7a3:hover .ms-Label,.field_7b15c7a3:focus .ms-Label{color:" }, { "theme": "bodyTextChecked", "defaultValue": "#000000" }, { "rawString": "}.field_7b15c7a3.fieldIsChecked_7b15c7a3::before{border:1px solid " }, { "theme": "inputBackgroundChecked", "defaultValue": "#0078d7" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.field_7b15c7a3.fieldIsChecked_7b15c7a3::before{border-color:Highlight}}.field_7b15c7a3.fieldIsChecked_7b15c7a3::after{border:5px solid " }, { "theme": "inputBackgroundChecked", "defaultValue": "#0078d7" }, { "rawString": ";top:5px;width:10px;height:10px}[dir='ltr'] .field_7b15c7a3.fieldIsChecked_7b15c7a3::after{left:5px}[dir='rtl'] .field_7b15c7a3.fieldIsChecked_7b15c7a3::after{right:5px}@media screen and (-ms-high-contrast: active){.field_7b15c7a3.fieldIsChecked_7b15c7a3::after{border-color:Highlight}}.field_7b15c7a3.fieldIsChecked_7b15c7a3:hover::before,.field_7b15c7a3.fieldIsChecked_7b15c7a3:focus::before{border-color:" }, { "theme": "inputBackgroundCheckedHovered", "defaultValue": "#106ebe" }, { "rawString": "}.field_7b15c7a3.fieldIsDisabled_7b15c7a3{cursor:default}.field_7b15c7a3.fieldIsDisabled_7b15c7a3::before{background-color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": ";border-color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.field_7b15c7a3.fieldIsDisabled_7b15c7a3::before{border-color:GrayText}}.field_7b15c7a3.fieldIsDisabled_7b15c7a3 .ms-Label{color:" }, { "theme": "disabledText", "defaultValue": "#c8c8c8" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.field_7b15c7a3.fieldIsDisabled_7b15c7a3 .ms-Label{color:GrayText}}.field_7b15c7a3.fieldIsChecked_7b15c7a3.fieldIsDisabled_7b15c7a3::before{background-color:" }, { "theme": "bodyBackground", "defaultValue": "#ffffff" }, { "rawString": ";border-color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_7b15c7a3.fieldIsChecked_7b15c7a3.fieldIsDisabled_7b15c7a3::after{background-color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": ";border-color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.choiceFieldIsImage_7b15c7a3,.choiceFieldIsIcon_7b15c7a3{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:0;margin:0 4px 4px 0;background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": "}[dir='rtl'] .choiceFieldIsImage_7b15c7a3,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3{margin:0 0 4px 4px}[dir='ltr'] .choiceFieldIsImage_7b15c7a3,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3{padding-left:0px}[dir='rtl'] .choiceFieldIsImage_7b15c7a3,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3{padding-right:0px}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3{display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;min-width:96px;cursor:pointer;padding-top:22px;margin:0;text-align:center;-webkit-transition:all 200ms ease;transition:all 200ms ease;border:2px solid transparent}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3.fieldIsDisabled_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3.fieldIsDisabled_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3.fieldIsDisabled_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3.fieldIsDisabled_7b15c7a3{cursor:default}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3.fieldIsDisabled_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3.fieldIsDisabled_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3.fieldIsDisabled_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3.fieldIsDisabled_7b15c7a3 .innerField_7b15c7a3{opacity:0.25}@media screen and (-ms-high-contrast: active){.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3.fieldIsDisabled_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3.fieldIsDisabled_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3.fieldIsDisabled_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3.fieldIsDisabled_7b15c7a3 .innerField_7b15c7a3{color:GrayText;opacity:1}}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3 .innerField_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3 .innerField_7b15c7a3{position:relative;padding:0 28px}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3{padding-bottom:2px;-webkit-transition:opacity 200ms ease;transition:opacity 200ms ease}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3.imageWrapperIsHidden_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3.imageWrapperIsHidden_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3.imageWrapperIsHidden_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3.imageWrapperIsHidden_7b15c7a3{position:absolute;left:0;top:0;width:100%;height:100%;overflow:hidden;opacity:0}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3 .ms-Image,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3 .ms-Image,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3 .ms-Image,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3 .innerField_7b15c7a3 .imageWrapper_7b15c7a3 .ms-Image{display:inline-block}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3 .labelWrapper_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3 .labelWrapper_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3 .labelWrapper_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3 .labelWrapper_7b15c7a3{display:block;position:relative;margin:4px 0 0 0;height:32px;line-height:16px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-size:14px;font-weight:400}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3 .labelWrapper_7b15c7a3 .ms-Label,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3 .labelWrapper_7b15c7a3 .ms-Label,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3 .labelWrapper_7b15c7a3 .ms-Label,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3 .labelWrapper_7b15c7a3 .ms-Label{padding:0}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::before,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::before{top:3px;opacity:0}[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::before,[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::before,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::before,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::before{right:3px}[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::before,[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::before,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::before,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::before{left:3px}[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::before,[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::before,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::before,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::before{left:auto}[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::before,[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::before,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::before,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::before{right:auto}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::after,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::after,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::after,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::after{top:13px}[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::after,[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::after,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::after,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::after{right:13px}[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::after,[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::after,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::after,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::after{left:13px}[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::after,[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::after,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::after,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::after{left:auto}[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3::after,[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3::after,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3::after,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3::after{right:auto}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):hover,.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):focus,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):hover,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):focus,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):hover,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):focus,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):hover,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):focus{border-color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": "}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):hover::before,.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):focus::before,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):hover::before,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):focus::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):hover::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):focus::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):hover::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3):focus::before{opacity:1}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3{border-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::before,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::before{opacity:1}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after{top:8px}[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,[dir='ltr'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,[dir='ltr'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after{right:8px}[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,[dir='rtl'] .choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after,[dir='rtl'] .choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3::after{left:8px}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover,.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus{border-color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover::before,.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus::before,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover::before,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover::before,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus::before{border-color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover::after,.choiceFieldIsImage_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus::after,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover::after,.choiceFieldIsImage_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus::after,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover::after,.choiceFieldIsIcon_7b15c7a3 .fieldIsImage_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus::after,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:hover::after,.choiceFieldIsIcon_7b15c7a3 .fieldIsIcon_7b15c7a3:not(.fieldIsDisabled_7b15c7a3).fieldIsChecked_7b15c7a3:focus::after{background-color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}.choiceFieldIsIcon_7b15c7a3{height:96px;width:96px}.choiceFieldIsIcon_7b15c7a3 .iconWrapper_7b15c7a3{font-size:32px;line-height:32px;height:32px}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3 .choiceFieldWrapper_7b15c7a3::-moz-focus-inner{border:0}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3 .choiceFieldWrapper_7b15c7a3{outline:transparent}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3 .choiceFieldWrapper_7b15c7a3{position:relative}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3 .choiceFieldWrapper_7b15c7a3:after{content:'';position:absolute;top:-2px;right:-2px;bottom:-2px;left:-2px;pointer-events:none;border:1px solid " }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3 .choiceFieldWrapper_7b15c7a3::-moz-focus-inner{border:0}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3 .choiceFieldWrapper_7b15c7a3{outline:transparent}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3 .choiceFieldWrapper_7b15c7a3{position:relative}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3 .choiceFieldWrapper_7b15c7a3:after{content:'';position:absolute;top:-2px;right:-2px;bottom:-2px;left:-2px;pointer-events:none;border:2px solid WindowText}}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsImage_7b15c7a3 .choiceFieldWrapper_7b15c7a3::-moz-focus-inner,.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsIcon_7b15c7a3 .choiceFieldWrapper_7b15c7a3::-moz-focus-inner{border:0}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsImage_7b15c7a3 .choiceFieldWrapper_7b15c7a3,.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsIcon_7b15c7a3 .choiceFieldWrapper_7b15c7a3{outline:transparent}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsImage_7b15c7a3 .choiceFieldWrapper_7b15c7a3,.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsIcon_7b15c7a3 .choiceFieldWrapper_7b15c7a3{position:relative}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsImage_7b15c7a3 .choiceFieldWrapper_7b15c7a3:after,.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsIcon_7b15c7a3 .choiceFieldWrapper_7b15c7a3:after{content:'';position:absolute;top:1px;right:1px;bottom:1px;left:1px;pointer-events:none;border:2px solid " }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsImage_7b15c7a3 .choiceFieldWrapper_7b15c7a3::-moz-focus-inner,.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsIcon_7b15c7a3 .choiceFieldWrapper_7b15c7a3::-moz-focus-inner{border:0}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsImage_7b15c7a3 .choiceFieldWrapper_7b15c7a3,.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsIcon_7b15c7a3 .choiceFieldWrapper_7b15c7a3{outline:transparent}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsImage_7b15c7a3 .choiceFieldWrapper_7b15c7a3,.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsIcon_7b15c7a3 .choiceFieldWrapper_7b15c7a3{position:relative}.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsImage_7b15c7a3 .choiceFieldWrapper_7b15c7a3:after,.ms-Fabric.is-focusVisible .choiceFieldIsInFocus_7b15c7a3.choiceFieldIsIcon_7b15c7a3 .choiceFieldWrapper_7b15c7a3:after{content:'';position:absolute;top:1px;right:1px;bottom:1px;left:1px;pointer-events:none;border:2px solid WindowText}}\n" }]);
exports.root = "root_7b15c7a3";
exports.choiceField = "choiceField_7b15c7a3";
exports.input = "input_7b15c7a3";
exports.field = "field_7b15c7a3";
exports.fieldIsChecked = "fieldIsChecked_7b15c7a3";
exports.fieldIsDisabled = "fieldIsDisabled_7b15c7a3";
exports.choiceFieldIsImage = "choiceFieldIsImage_7b15c7a3";
exports.choiceFieldIsIcon = "choiceFieldIsIcon_7b15c7a3";
exports.fieldIsImage = "fieldIsImage_7b15c7a3";
exports.fieldIsIcon = "fieldIsIcon_7b15c7a3";
exports.innerField = "innerField_7b15c7a3";
exports.imageWrapper = "imageWrapper_7b15c7a3";
exports.imageWrapperIsHidden = "imageWrapperIsHidden_7b15c7a3";
exports.labelWrapper = "labelWrapper_7b15c7a3";
exports.iconWrapper = "iconWrapper_7b15c7a3";
exports.choiceFieldIsInFocus = "choiceFieldIsInFocus_7b15c7a3";
exports.choiceFieldWrapper = "choiceFieldWrapper_7b15c7a3";
//# sourceMappingURL=ChoiceGroup.scss.js.map

/***/ }),

/***/ 2764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setRecipientSelectedState')(function setRecipientSelectedState(viewstate, isSelected) {
    viewstate.isSelected = isSelected;
});
//# sourceMappingURL=setRecipientSelectedState.js.map

/***/ }),

/***/ 2780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setFindResultSet')(function setFindResultSet(viewstate, findResultSet) {
    viewstate.findResultSet = findResultSet;
});
//# sourceMappingURL=setFindResultSet.js.map

/***/ }),

/***/ 2781:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2620);
function isCacheEmpty() {
    return store_1.default.recipientCache === null || store_1.default.recipientCache.length == 0;
}
exports.default = isCacheEmpty;
//# sourceMappingURL=isCacheEmpty.js.map

/***/ }),

/***/ 2793:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MessageBarType;
(function (MessageBarType) {
    /** Info styled MessageBar */
    MessageBarType[MessageBarType["info"] = 0] = "info";
    /** Error styled MessageBar */
    MessageBarType[MessageBarType["error"] = 1] = "error";
    /** Blocked styled MessageBar */
    MessageBarType[MessageBarType["blocked"] = 2] = "blocked";
    /** SevereWarning styled MessageBar */
    MessageBarType[MessageBarType["severeWarning"] = 3] = "severeWarning";
    /** Success styled MessageBar */
    MessageBarType[MessageBarType["success"] = 4] = "success";
    /** Warning styled MessageBar */
    MessageBarType[MessageBarType["warning"] = 5] = "warning";
    /**
     * Deprecated at v0.48.0, to be removed at >= v1.0.0. Use 'blocked' instead.
     * @deprecated
     */
    MessageBarType[MessageBarType["remove"] = 90000] = "remove";
})(MessageBarType = exports.MessageBarType || (exports.MessageBarType = {}));
//# sourceMappingURL=MessageBar.types.js.map

/***/ }),

/***/ 2794:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardOptions_1 = __webpack_require__(4913);
exports.discardOptions = discardOptions_1.discardOptions;
var hideFullOptions_1 = __webpack_require__(5279);
exports.hideFullOptions = hideFullOptions_1.default;
var saveOptions_1 = __webpack_require__(5280);
exports.saveOptions = saveOptions_1.saveOptions;
var showFullOptions_1 = __webpack_require__(3772);
exports.showFullOptions = showFullOptions_1.default;
var navigateToSearchSuggestion_1 = __webpack_require__(5281);
exports.navigateToSearchSuggestion = navigateToSearchSuggestion_1.default;
var selectCategory_1 = __webpack_require__(5282);
exports.selectCategory = selectCategory_1.default;
var selectSubcategory_1 = __webpack_require__(5283);
exports.selectSubcategory = selectSubcategory_1.default;
// Initialize orchestrators listening to external actions
__webpack_require__(5284);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getActionClauseTypeOptions() {
    //******** MUST READ ********//
    // Must keep in order by dropdown section!
    return [
        // Organize
        'moveTo',
        'copyTo',
        'delete',
        'pin',
        // Mark message
        'read',
        'junk',
        'markImportance',
        // Route
        'forwardTo',
        'forwardAsAttachmentTo',
        'redirectTo',
    ];
}
exports.default = getActionClauseTypeOptions;
//# sourceMappingURL=getActionClauseTypeOptions.js.map

/***/ }),

/***/ 2796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getConditionalExceptionClauseTypeOptions() {
    //******** MUST READ ********//
    // Must keep in order by dropdown section!
    return [
        // Addresses
        'from',
        'to',
        // My name is
        'onTheToLine',
        'onTheCcLine',
        'onTheToOrCcLine',
        'notOnTheToLine',
        'theOnlyRecipientListed',
        // Subject
        'subjectIncludes',
        'subjectOrBodyIncludes',
        // Includes these words
        'inTheBody',
        'inTheSenderAddress',
        'inTheRecipientAddress',
        'inTheMessageHeader',
        // Marked with
        'withImportance',
        'sensitivity',
        // Message includes
        // 'classification',
        'flag',
        'type',
        'attachment',
        // Message size
        'atLeast',
        'atMost',
        // Received
        'before',
        'after',
    ];
}
exports.default = getConditionalExceptionClauseTypeOptions;
//# sourceMappingURL=getConditionalExceptionClauseTypeOptions.js.map

/***/ }),

/***/ 2797:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = __webpack_require__(20);
var owa_mail_strings_1 = __webpack_require__(22);
exports.DIVIDER_DISPLAY_NAME = '-';
function getComposeActionDisplayName(key) {
    switch (key) {
        case 'AddAttachment':
            return owa_mail_strings_1.default.attachTooltip;
        case 'AddInlineImage':
            return owa_mail_strings_1.default.insertPicturesInlineTooltip;
        case 'AddEmoji':
            return owa_mail_strings_1.default.emojiTooltip;
        case 'ToggleRibbon':
            return owa_mail_strings_1.default.formattingOptionsTooltip;
        case 'SaveDraft':
            return owa_mail_strings_1.default.saveDraft;
        case 'InsertSignature':
            return owa_mail_strings_1.default.insertSignature;
        case 'ShowFrom':
            return owa_mail_strings_1.default.showFrom;
        case 'SetImportance':
            return owa_mail_strings_1.default.setImportance;
        default:
            return '';
    }
}
exports.getComposeActionDisplayName = getComposeActionDisplayName;
function getReadActionDisplayName(key) {
    switch (key) {
        case 'Reply':
            return owa_mail_strings_1.default.itemHeaderReply;
        case 'ReplyAll':
            return owa_mail_strings_1.default.itemHeaderReplyAll;
        case 'Forward':
            return owa_mail_strings_1.default.itemHeaderForward;
        case 'Delete':
            return owa_mail_strings_1.default.itemHeaderDelete;
        case 'MarkReadUnread':
            return owa_mail_strings_1.default.markAsUnread;
        case 'FlagUnflag':
            return owa_mail_strings_1.default.itemHeaderFlag;
        case 'MarkJunkNotJunk':
            return owa_mail_strings_1.default.itemHeaderMarkAsJunk;
        case 'MarkAsPhishing':
            return owa_mail_strings_1.default.itemHeaderMarkAsPhishing;
        case 'Block':
            return owa_strings_1.format(owa_mail_strings_1.default.itemHeaderBlock, '');
        case 'CreateRule':
            return owa_mail_strings_1.default.createRule;
        case 'Print':
            return owa_mail_strings_1.default.itemHeaderPrint;
        case 'ShowInImmersiveReader':
            return owa_mail_strings_1.default.showInImmersiveReader;
        default:
            return '';
    }
}
exports.getReadActionDisplayName = getReadActionDisplayName;
//# sourceMappingURL=getDisplayNameFromKey.js.map

/***/ }),

/***/ 2798:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setAddinObserverLoaded_1 = __webpack_require__(3092);
var store_1 = __webpack_require__(2729);
var owa_addins_core_1 = __webpack_require__(1738);
var addinCommandSurfaceActionsObserver;
owa_addins_core_1.lazyAddinCommandSurfaceActionsObserver.import().then(function (addinObserver) {
    // Framework team has plans to implement a .isLoaded property for lazy imports.
    // This will allow a component to re-render when the import finishes. Until this is available,
    // we'll use our own boolean in the store. WI: 23555
    addinCommandSurfaceActionsObserver = addinObserver;
    setAddinObserverLoaded_1.default();
});
function getAddinCollection(mode) {
    if (store_1.default.isAddinObserverLoaded && addinCommandSurfaceActionsObserver) {
        return addinCommandSurfaceActionsObserver(mode).get();
    }
    else {
        return null;
    }
}
exports.default = getAddinCollection;
//# sourceMappingURL=getAddinCollection.js.map

/***/ }),

/***/ 2799:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5301);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('readingPaneOption', {
    readingPanePosition: null,
    nextSelection: null,
    loadMessageOnLogOn: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialReadWriteRecipientWellStore = {
    pendingFindPeopleRequests: 0,
};
var store = satcheljs_1.createStore('readwriterecipientwell', initialReadWriteRecipientWellStore)();
exports.default = store;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setHasSearchedDirectory')(function setHasSearchedDirectory(viewstate, hasSearchedDirectory) {
    viewstate.hasSearchedDirectory = hasSearchedDirectory;
});
//# sourceMappingURL=setHasSearchedDirectory.js.map

/***/ }),

/***/ 2893:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createRibbonViewState_1 = __webpack_require__(2229);
var createEditorViewState_1 = __webpack_require__(3735);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('signatureOption', {
    editorViewState: createEditorViewState_1.default(null /*content*/, false /*isDirty*/),
    ribbon: createRibbonViewState_1.default(),
    signNewMails: null,
    signReplies: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2894:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var saveMailboxJunkEmailConfiguration_1 = __webpack_require__(5018);
exports.saveMailboxJunkEmailConfiguration = saveMailboxJunkEmailConfiguration_1.default;
var getMailboxJunkEmailConfiguration_1 = __webpack_require__(5022);
exports.getMailboxJunkEmailConfiguration = getMailboxJunkEmailConfiguration_1.default;
var initMailboxJunkEmailConfiguration_1 = __webpack_require__(5023);
exports.initMailboxJunkEmailConfiguration = initMailboxJunkEmailConfiguration_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('conversationsOption', {
    conversationSortOrder: null,
    hideDeletedItems: null,
    globalListViewType: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    enableDisableInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_EnableDisableInboxRule',
            customData: function (inboxRuleId, shouldBeEnabled) { return [
                inboxRuleId,
                shouldBeEnabled,
            ]; },
        },
    },
    generateInboxRulesDiagnosticReportDatapoint: {
        datapoint: { name: 'TnS_GenerateInboxRulesDiagnosticReport' },
    },
    getInboxRulesDatapoint: { datapoint: { name: 'TnS_GetInboxRules' } },
    numInboxRules: {
        datapoint: {
            name: 'TnS_NumInboxRules',
            customData: function (inboxRuleCollectionLength) { return [inboxRuleCollectionLength]; },
        },
    },
    removeInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_RemoveInboxRule',
            customData: function (inboxRuleId) { return [inboxRuleId]; },
        },
    },
    setInboxRulesDatapoint: { datapoint: { name: 'TnS_SetInboxRules' } },
    inboxRuleInformationDatapoint: {
        datapoint: {
            name: 'TnS_InboxRuleInformation',
            customData: function (inboxRuleInformation, actionSource, numConditionalClauses, numActionClauses, numExceptionClauses) { return [
                inboxRuleInformation,
                actionSource,
                numConditionalClauses,
                numActionClauses,
                numExceptionClauses,
            ]; },
        },
    },
    addPhraseToClauseDatapoint: {
        datapoint: {
            name: 'TnS_AddPhraseToClause',
            customData: function (clauseId, phraseToAdd, actionSource) { return [phraseToAdd.indexOf(' ') !== -1, actionSource]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 2897:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setRecipientSelectedState_1 = __webpack_require__(2764);
var legacy_1 = __webpack_require__(1);
var owa_mail_subject_picker_store_1 = __webpack_require__(2120);
var owa_mail_feature_flags_1 = __webpack_require__(23);
exports.default = legacy_1.action('removeReadWriteRecipient')(function removeReadWriteRecipient(recipientWell, recipientLocatorToRemove, selectToRight) {
    var indexToRemove = -1;
    if (typeof recipientLocatorToRemove === 'number') {
        indexToRemove = recipientLocatorToRemove;
    }
    else {
        indexToRemove = recipientWell.recipients.indexOf(recipientLocatorToRemove);
    }
    if (indexToRemove >= 0) {
        var recipientToRemove = recipientWell.recipients[indexToRemove];
        if (recipientToRemove.blockRecipientRemoval) {
            return;
        }
        var removedRecipient = recipientWell.recipients.splice(indexToRemove, 1);
        if (removedRecipient[0].isSelected && recipientWell.recipients.length > 0) {
            setRecipientSelectedState_1.default(recipientWell.recipients[selectToRight
                ? Math.min(indexToRemove, recipientWell.recipients.length - 1)
                : Math.max(0, indexToRemove - 1)], true);
        }
        recipientWell.isDirty = true;
    }
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('peo-subjectPicker')) {
        if (recipientWell.recipients.length === 1) {
            owa_mail_subject_picker_store_1.oneRecipientSelectedAction(recipientWell.recipients[0].persona);
        }
    }
});
//# sourceMappingURL=removeReadWriteRecipient.js.map

/***/ }),

/***/ 2898:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2899), exports);
//# sourceMappingURL=OverflowSet.js.map

/***/ }),

/***/ 2899:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2900), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
var FocusZone_1 = __webpack_require__(78);
var stylesImport = __webpack_require__(2901);
var styles = stylesImport;
var OverflowSet = /** @class */ (function (_super) {
    tslib_1.__extends(OverflowSet, _super);
    function OverflowSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverflowSet.prototype.render = function () {
        var _a = this.props, items = _a.items, overflowItems = _a.overflowItems, onRenderOverflowButton = _a.onRenderOverflowButton, className = _a.className, focusZoneProps = _a.focusZoneProps, _b = _a.vertical, vertical = _b === void 0 ? false : _b, _c = _a.role, role = _c === void 0 ? 'menubar' : _c;
        return (React.createElement(FocusZone_1.FocusZone, tslib_1.__assign({}, focusZoneProps, { componentRef: this._resolveRef('_focusZone'), className: Styling_1.mergeStyles('ms-OverflowSet', styles.root, vertical && styles.rootVertical, className), direction: vertical ? FocusZone_1.FocusZoneDirection.vertical : FocusZone_1.FocusZoneDirection.horizontal, role: role }),
            items && this._onRenderItems(items),
            overflowItems && overflowItems.length > 0 && this._onRenderOverflowButtonWrapper(overflowItems)));
    };
    OverflowSet.prototype.focus = function () {
        if (this._focusZone) {
            this._focusZone.focus();
        }
    };
    OverflowSet.prototype._onRenderItems = function (items) {
        var _this = this;
        return items.map(function (item, i) {
            var wrapperDivProps = { className: Utilities_1.css('ms-OverflowSet-item', styles.item) };
            if (item.key) {
                wrapperDivProps.key = item.key;
            }
            return (React.createElement("div", tslib_1.__assign({}, wrapperDivProps), _this.props.onRenderItem(item)));
        });
    };
    OverflowSet.prototype._onRenderOverflowButtonWrapper = function (items) {
        var wrapperDivProps = { className: Utilities_1.css('ms-OverflowSet-overflowButton', styles.item) };
        return (React.createElement("div", tslib_1.__assign({}, wrapperDivProps), this.props.onRenderOverflowButton(items)));
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OverflowSet.prototype, "_onRenderItems", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OverflowSet.prototype, "_onRenderOverflowButtonWrapper", null);
    return OverflowSet;
}(Utilities_1.BaseComponent));
exports.OverflowSet = OverflowSet;
//# sourceMappingURL=OverflowSet.js.map

/***/ }),

/***/ 2901:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_f59040df{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.rootVertical_f59040df{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item_f59040df{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n" }]);
exports.root = "root_f59040df";
exports.rootVertical = "rootVertical_f59040df";
exports.item = "item_f59040df";
//# sourceMappingURL=OverflowSet.scss.js.map

/***/ }),

/***/ 2921:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Icon_1 = __webpack_require__(43);
var mobx_react_1 = __webpack_require__(11);
var Persona_1 = __webpack_require__(234);
var PersonaControl_1 = __webpack_require__(673);
var React = __webpack_require__(3);
var styles = __webpack_require__(2922);
var classNames = __webpack_require__(30).bind(styles);
var FindRecipient = /** @class */ (function (_super) {
    tslib_1.__extends(FindRecipient, _super);
    function FindRecipient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addSelectedRecipient = function (evt) {
            evt.preventDefault();
            _this.props.addRecipientAction(_this.props.findRecipient);
        };
        _this.maskRecipient = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (_this.props.maskRecipientAction) {
                _this.props.maskRecipientAction(_this.props.findRecipient);
            }
        };
        return _this;
    }
    FindRecipient.prototype.render = function () {
        var containerClassName = classNames(styles.container, {
            isHighlighted: this.props.isHighlighted,
        });
        var _a = this.props, findRecipient = _a.findRecipient, maskRecipientAction = _a.maskRecipientAction;
        var recipientName = findRecipient.EmailAddress.Name;
        var recipientEmail = findRecipient.EmailAddress.EmailAddress;
        return (React.createElement("div", { className: containerClassName, onClick: this.addSelectedRecipient },
            React.createElement("div", { className: styles.personaContainer },
                React.createElement("div", { className: styles.personaImage },
                    React.createElement(PersonaControl_1.default, { name: recipientName, emailAddress: recipientEmail, size: Persona_1.PersonaSize.size32, showPersonaDetails: false })),
                React.createElement("div", { className: styles.personaText },
                    React.createElement("span", { className: classNames(styles.personaLineOne, styles.personaTextLine) }, recipientName),
                    React.createElement("span", { className: classNames(styles.personaLineTwo, styles.personaTextLine) }, recipientEmail))),
            maskRecipientAction && (React.createElement("div", { className: styles.maskRecipientButton, onClick: this.maskRecipient },
                React.createElement(Icon_1.Icon, { className: styles.cancelIcon, iconName: "Cancel" /* Cancel */ })))));
    };
    FindRecipient = tslib_1.__decorate([
        mobx_react_1.observer
    ], FindRecipient);
    return FindRecipient;
}(React.Component));
exports.default = FindRecipient;
//# sourceMappingURL=FindRecipient.js.map

/***/ }),

/***/ 2922:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3012);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2938:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(3056), exports);
//# sourceMappingURL=MessageBar.js.map

/***/ }),

/***/ 2939:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EditSendersAndDomains_1 = __webpack_require__(5025);
exports.EditSendersAndDomains = EditSendersAndDomains_1.EditSendersAndDomains;
var isEmailAddress_1 = __webpack_require__(5029);
exports.isEmailAddress = isEmailAddress_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var hasUsedAllClauseTypesInSection_1 = __webpack_require__(3174);
var store_1 = __webpack_require__(2603);
var owa_guid_1 = __webpack_require__(585);
var legacy_1 = __webpack_require__(1);
var addNewClause = legacy_1.action('addNewClause')(function addNewClause(sectionType, clauseType, clauseValue) {
    // If user has maxed out on clause types (they have used every possible clause type already), then it's a no-op
    if (hasUsedAllClauseTypesInSection_1.default(sectionType)) {
        return;
    }
    var newClauseId = owa_guid_1.getGuid();
    if (sectionType == 'conditional') {
        store_1.default.inboxRulesEditState.conditionalClauseIds.push(newClauseId);
    }
    else if (sectionType == 'action') {
        store_1.default.inboxRulesEditState.actionClauseIds.push(newClauseId);
    }
    else if (sectionType == 'exception') {
        store_1.default.inboxRulesEditState.exceptionClauseIds.push(newClauseId);
    }
    else {
        throw new Error('Cannot add a clause id to a section that does not exists');
    }
    store_1.default.inboxRulesEditState.clauseMap.set(newClauseId, {
        clauseType: clauseType,
        clauseValue: clauseValue,
    });
});
exports.default = addNewClause;
//# sourceMappingURL=addNewClause.js.map

/***/ }),

/***/ 2941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('showHideContactPicker')(function showHideContactPicker(recipientWell, isShown) {
    recipientWell.shouldShowContactPicker = isShown;
});
//# sourceMappingURL=showHideContactPicker.js.map

/***/ }),

/***/ 2942:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_delayed_initialization_1 = __webpack_require__(28);
var initializeExtensibilityContext_1 = __webpack_require__(3085);
var store_1 = __webpack_require__(2729);
exports.surfaceActionsStore = store_1.default;
// Export synchronous utils and types
var getDisplayNameFromKey_1 = __webpack_require__(2797);
exports.getComposeActionDisplayName = getDisplayNameFromKey_1.getComposeActionDisplayName;
exports.getReadActionDisplayName = getDisplayNameFromKey_1.getReadActionDisplayName;
exports.DIVIDER_DISPLAY_NAME = getDisplayNameFromKey_1.DIVIDER_DISPLAY_NAME;
var getIconNameFromKey_1 = __webpack_require__(3086);
exports.getComposeActionIconName = getIconNameFromKey_1.getComposeActionIconName;
exports.getReadActionIconName = getIconNameFromKey_1.getReadActionIconName;
var getStaticActions_1 = __webpack_require__(3091);
exports.getComposeStaticActions = getStaticActions_1.getComposeStaticActions;
exports.getReadStaticActions = getStaticActions_1.getReadStaticActions;
exports.shouldAddActionToEnd = getStaticActions_1.shouldAddActionToEnd;
var getAddinCollection_1 = __webpack_require__(2798);
exports.getAddinCollection = getAddinCollection_1.default;
var populateCommandBarWithAddins_1 = __webpack_require__(3093);
exports.populateCommandBarWithAddins = populateCommandBarWithAddins_1.default;
owa_delayed_initialization_1.runAfterInitialRender(function () {
    initializeExtensibilityContext_1.default();
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2943:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('weatherOption', {
    weatherEnabled: null,
    weatherUnit: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3012:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1nzI4hxPhiPaF0b8eFo8e_{height:48px;width:300px;max-width:100%;overflow:hidden;position:relative}html[dir] ._1nzI4hxPhiPaF0b8eFo8e_._2qz2G5gywUn_uQwwMgbW75{background-color:\"[theme:themeLighter, default:#DEECF9]\"}html[dir] ._1nzI4hxPhiPaF0b8eFo8e_._2qz2G5gywUn_uQwwMgbW75 ._2UIZzxyu2CKvZbQPd_daYm:hover{background-color:\"[theme:themeTertiary, default:#71AFE5]\"}html[dir] ._1nzI4hxPhiPaF0b8eFo8e_:hover{background-color:\"[theme:neutralLighter, default:#f4f4f4]\"}html[dir] ._1nzI4hxPhiPaF0b8eFo8e_:hover._2qz2G5gywUn_uQwwMgbW75{background-color:\"[theme:themeLight, default:#C7E0F4]\"}._1nzI4hxPhiPaF0b8eFo8e_:hover ._2UIZzxyu2CKvZbQPd_daYm{opacity:1}._1nzI4hxPhiPaF0b8eFo8e_ ._2UIZzxyu2CKvZbQPd_daYm{height:48px;width:32px;position:absolute;top:0;opacity:0}html[dir=ltr] ._1nzI4hxPhiPaF0b8eFo8e_ ._2UIZzxyu2CKvZbQPd_daYm{right:0}html[dir=rtl] ._1nzI4hxPhiPaF0b8eFo8e_ ._2UIZzxyu2CKvZbQPd_daYm{left:0}html[dir] ._1nzI4hxPhiPaF0b8eFo8e_ ._2UIZzxyu2CKvZbQPd_daYm:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}._1VZdzrzgb76lG02l5x0ZHG{width:calc(100% - 12px);display:table;table-layout:fixed}html[dir] ._1VZdzrzgb76lG02l5x0ZHG{margin-top:8px}html[dir=ltr] ._1VZdzrzgb76lG02l5x0ZHG{margin-left:12px}html[dir=rtl] ._1VZdzrzgb76lG02l5x0ZHG{margin-right:12px}._2niab1Kz-ZhtRGbcmGqLDH{position:relative;display:table-cell;vertical-align:middle;width:32px}.g52ZCF23bQfUQw0Ew8OwR{display:table-cell;vertical-align:middle;overflow:hidden}html[dir=ltr] .g52ZCF23bQfUQw0Ew8OwR{padding-left:12px}html[dir=rtl] .g52ZCF23bQfUQw0Ew8OwR{padding-right:12px}._1Rax7GrJXkqVuHjEcIVD1M{width:100%;display:block;line-height:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}html[dir] ._1Rax7GrJXkqVuHjEcIVD1M{padding-bottom:2px}._5EOk0s-x1W97HPcK3_u2l{font-size:14px;color:\"[theme:neutralPrimary, default:#333333]\";font-weight:400}._2WcnX2dLqIYT7uWLRdPXk_{font-size:12px;color:\"[theme:neutralSecondary, default:#666666]\";font-weight:400;position:relative;top:-2px;height:12px;text-overflow:ellipsis}html[dir] ._2WcnX2dLqIYT7uWLRdPXk_{padding-top:4px}._3havBkqpuf2wCrEtAp_-a1{font-size:12px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\";position:relative;top:18px}html[dir=ltr] ._3havBkqpuf2wCrEtAp_-a1{left:10px}html[dir=rtl] ._3havBkqpuf2wCrEtAp_-a1{right:10px}", ""]);

// exports
exports.locals = {
	"container": "_1nzI4hxPhiPaF0b8eFo8e_",
	"isHighlighted": "_2qz2G5gywUn_uQwwMgbW75",
	"maskRecipientButton": "_2UIZzxyu2CKvZbQPd_daYm",
	"personaContainer": "_1VZdzrzgb76lG02l5x0ZHG",
	"personaImage": "_2niab1Kz-ZhtRGbcmGqLDH",
	"personaText": "g52ZCF23bQfUQw0Ew8OwR",
	"personaTextLine": "_1Rax7GrJXkqVuHjEcIVD1M",
	"personaLineOne": "_5EOk0s-x1W97HPcK3_u2l",
	"personaLineTwo": "_2WcnX2dLqIYT7uWLRdPXk_",
	"cancelIcon": "_3havBkqpuf2wCrEtAp_-a1"
};

/***/ }),

/***/ 3013:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3014);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3014:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3sdvn113duLdehvjsAejdE{height:48px;width:300px;overflow:hidden;display:table}html[dir] ._3sdvn113duLdehvjsAejdE{border-top:1px solid \"[theme:neutralLight, default:#eaeaea]\"}._3kJdGuSfmrhk9RlpNDhQmU{font-size:12px;font-weight:400;width:calc(100% - 46px);display:table-cell;vertical-align:middle}html[dir=ltr] ._3kJdGuSfmrhk9RlpNDhQmU{text-align:left;padding-left:12px}html[dir=rtl] ._3kJdGuSfmrhk9RlpNDhQmU{text-align:right;padding-right:12px}._3kJdGuSfmrhk9RlpNDhQmU._2r5l6t1IpZwP0A2wNyEKmd{width:100%}html[dir] ._3kJdGuSfmrhk9RlpNDhQmU._2r5l6t1IpZwP0A2wNyEKmd{text-align:center;padding:0}._35uxSaUhp9YgQQqZsM1Txw{width:32px;display:table-cell}html[dir] ._35uxSaUhp9YgQQqZsM1Txw{padding-top:14px;text-align:center}html[dir=ltr] ._35uxSaUhp9YgQQqZsM1Txw{padding-left:12px}html[dir=rtl] ._35uxSaUhp9YgQQqZsM1Txw{padding-right:12px}html[dir] ._32hQ27yW4QTIr70VnUGQHX:hover{background-color:\"[theme:neutralLighter, default:#f4f4f4]\"}html[dir] ._32hQ27yW4QTIr70VnUGQHX:hover.Pd0mZvU8qp5Zcm60VgBMr{background-color:\"[theme:themeLight, default:#C7E0F4]\"}html[dir] ._32hQ27yW4QTIr70VnUGQHX.Pd0mZvU8qp5Zcm60VgBMr{background-color:\"[theme:themeLighter, default:#DEECF9]\"}.FerIYhOTy0XguAt0EJdtH{font-size:21px;font-weight:100;color:\"[theme:themePrimary, default:#0078D7]\"}._2GE90mHxNOcPMCHX3JGY-u{height:36px}", ""]);

// exports
exports.locals = {
	"container": "_3sdvn113duLdehvjsAejdE",
	"textContainer": "_3kJdGuSfmrhk9RlpNDhQmU",
	"centered": "_2r5l6t1IpZwP0A2wNyEKmd",
	"iconContainer": "_35uxSaUhp9YgQQqZsM1Txw",
	"hoverable": "_32hQ27yW4QTIr70VnUGQHX",
	"isHighlighted": "Pd0mZvU8qp5Zcm60VgBMr",
	"searchIcon": "FerIYhOTy0XguAt0EJdtH",
	"useAddressContainer": "_2GE90mHxNOcPMCHX3JGY-u"
};

/***/ }),

/***/ 3056:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(3057), exports);
tslib_1.__exportStar(__webpack_require__(2793), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3057:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Button_1 = __webpack_require__(62);
var Icon_1 = __webpack_require__(43);
var MessageBar_types_1 = __webpack_require__(2793);
var stylesImport = __webpack_require__(3058);
var styles = stylesImport;
var MessageBar = /** @class */ (function (_super) {
    tslib_1.__extends(MessageBar, _super);
    function MessageBar(props) {
        var _this = _super.call(this, props) || this;
        _this.ICON_MAP = (_a = {},
            _a[MessageBar_types_1.MessageBarType.info] = 'Info',
            _a[MessageBar_types_1.MessageBarType.warning] = 'Info',
            _a[MessageBar_types_1.MessageBarType.error] = 'ErrorBadge',
            _a[MessageBar_types_1.MessageBarType.blocked] = 'Blocked',
            _a[MessageBar_types_1.MessageBarType.remove] = 'Blocked',
            _a[MessageBar_types_1.MessageBarType.severeWarning] = 'Warning',
            _a[MessageBar_types_1.MessageBarType.success] = 'Completed',
            _a);
        _this.state = {
            labelId: Utilities_1.getId('MessageBar'),
            showContent: false
        };
        return _this;
        var _a;
    }
    MessageBar.prototype.render = function () {
        var isMultiline = this.props.isMultiline;
        return isMultiline ? this._renderMultiLine() : this._renderSingleLine();
    };
    MessageBar.prototype._getActionsDiv = function () {
        if (this.props.actions) {
            return (React.createElement("div", { className: this.props.isMultiline ?
                    ('ms-MessageBar-actions ' + styles.actions) :
                    ('ms-MessageBar-actionsOneline ' + styles.actionsOneline) }, this.props.actions));
        }
        return null;
    };
    MessageBar.prototype._getClassName = function () {
        return Utilities_1.css(this.props.className, 'ms-MessageBar', styles.root, (_a = {},
            _a['ms-MessageBar ' + styles.root] = this.props.messageBarType === MessageBar_types_1.MessageBarType.info,
            _a['ms-MessageBar--error ' + styles.rootIsError] = this.props.messageBarType === MessageBar_types_1.MessageBarType.error,
            _a['ms-MessageBar--blocked ' + styles.rootIsBlocked] = (this.props.messageBarType === MessageBar_types_1.MessageBarType.blocked) ||
                (this.props.messageBarType === MessageBar_types_1.MessageBarType.remove),
            _a['ms-MessageBar--severeWarning ' + styles.rootIsSevereWarning] = this.props.messageBarType === MessageBar_types_1.MessageBarType.severeWarning,
            _a['ms-MessageBar--success ' + styles.rootIsSuccess] = this.props.messageBarType === MessageBar_types_1.MessageBarType.success,
            _a['ms-MessageBar--warning ' + styles.rootIsWarning] = this.props.messageBarType === MessageBar_types_1.MessageBarType.warning,
            _a));
        var _a;
    };
    MessageBar.prototype._getDismissDiv = function () {
        if (this.props.onDismiss) {
            return (React.createElement(Button_1.IconButton, { disabled: false, className: Utilities_1.css('ms-MessageBar-dismissal', styles.dismissal), onClick: this.props.onDismiss, iconProps: { iconName: 'Cancel' }, ariaLabel: this.props.dismissButtonAriaLabel }));
        }
        return null;
    };
    MessageBar.prototype._getDismissOneLine = function () {
        if (this.props.onDismiss) {
            return (React.createElement("div", { className: Utilities_1.css('ms-MessageBar-dismissOneline', styles.dismissOneline) }, this._getDismissDiv()));
        }
        return null;
    };
    MessageBar.prototype._getIconSpan = function () {
        return (React.createElement("div", { className: Utilities_1.css('ms-MessageBar-icon', styles.icon) },
            React.createElement(Icon_1.Icon, { iconName: this.ICON_MAP[this.props.messageBarType] })));
    };
    MessageBar.prototype._getInnerTextClassName = function () {
        return this.props.onDismiss || this.props.actions ?
            'ms-MessageBar-innerTextPadding ' + styles.innerTextPadding : 'ms-MessageBar-innerText ' + styles.innerText;
    };
    MessageBar.prototype._renderMultiLine = function () {
        return (React.createElement("div", { className: Utilities_1.css(this._getClassName(), 'ms-MessageBar-multiline', styles.multiline, this.props.onDismiss && styles.dismissalMultiline, this.props.actions && styles.actionableMultiline), role: 'status', "aria-live": this._getAnnouncementPriority() },
            React.createElement("div", { className: Utilities_1.css(styles.content, 'ms-MessageBar-content') },
                this._getIconSpan(),
                this._renderInnerText(),
                this._getDismissDiv()),
            this._getActionsDiv()));
    };
    MessageBar.prototype._renderSingleLine = function () {
        return (React.createElement("div", { className: Utilities_1.css(this._getClassName(), 'ms-MessageBar-singleline', styles.singleline, this.props.onDismiss && 'ms-MessageBar-dismissalOneline ' + styles.rootIsOneline, this.props.actions && styles.actionableOneline) },
            React.createElement("div", { className: Utilities_1.css(styles.content, 'ms-MessageBar-content') },
                this._getIconSpan(),
                this._renderInnerText(),
                this._getDismissOneLine()),
            this._getActionsDiv()));
    };
    MessageBar.prototype._renderInnerText = function () {
        return (React.createElement("div", { className: Utilities_1.css('ms-MessageBar-text', styles.text), id: this.state.labelId },
            React.createElement("span", { className: this._getInnerTextClassName(), role: 'status', "aria-live": this._getAnnouncementPriority() },
                React.createElement(Utilities_1.DelayedRender, null,
                    React.createElement("span", null, this.props.children)))));
    };
    MessageBar.prototype._getAnnouncementPriority = function () {
        switch (this.props.messageBarType) {
            case MessageBar_types_1.MessageBarType.blocked:
            case MessageBar_types_1.MessageBarType.error:
            case MessageBar_types_1.MessageBarType.severeWarning:
                return 'assertive';
        }
        return 'polite';
    };
    MessageBar.defaultProps = {
        messageBarType: MessageBar_types_1.MessageBarType.info,
        onDismiss: undefined,
        isMultiline: true,
    };
    return MessageBar;
}(Utilities_1.BaseComponent));
exports.MessageBar = MessageBar;
//# sourceMappingURL=MessageBar.js.map

/***/ }),

/***/ 3058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_d72e9002{background-color:" }, { "theme": "infoBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";min-height:32px;color:" }, { "theme": "infoText", "defaultValue": "#333333" }, { "rawString": ";width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;word-break:break-word}.root_d72e9002 .icon_d72e9002{color:" }, { "theme": "info", "defaultValue": "#767676" }, { "rawString": ";-ms-flex-negative:0;flex-shrink:0}html[dir='ltr'] .root_d72e9002 .icon_d72e9002{padding-right:8px}html[dir='rtl'] .root_d72e9002 .icon_d72e9002{padding-left:8px}.root_d72e9002 .ms-Link{font-size:12px;color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}html[dir='ltr'] .root_d72e9002 .ms-Button{margin-left:6px}html[dir='rtl'] .root_d72e9002 .ms-Button{margin-right:6px}.icon_d72e9002,.text_d72e9002{display:table-cell;vertical-align:top}.icon_d72e9002{font-size:16px;min-width:16px;min-height:16px;display:-webkit-box;display:-ms-flexbox;display:flex}.text_d72e9002{font-size:12px;font-weight:400;min-width:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.root_d72e9002.rootIsWarning_d72e9002{background-color:" }, { "theme": "warningBackground", "defaultValue": "#fff4ce" }, { "rawString": ";color:" }, { "theme": "warningText", "defaultValue": "#333333" }, { "rawString": "}.root_d72e9002.rootIsSevereWarning_d72e9002{background-color:" }, { "theme": "severeWarningBackground", "defaultValue": "#fed9cc" }, { "rawString": ";color:" }, { "theme": "severeWarningText", "defaultValue": "#333333" }, { "rawString": "}.root_d72e9002.rootIsSevereWarning_d72e9002 .icon_d72e9002{color:" }, { "theme": "severeWarning", "defaultValue": "#d83b01" }, { "rawString": "}.root_d72e9002.rootIsError_d72e9002{background-color:" }, { "theme": "errorBackground", "defaultValue": "#fde7e9" }, { "rawString": ";color:" }, { "theme": "errorText", "defaultValue": "#333333" }, { "rawString": "}.root_d72e9002.rootIsError_d72e9002 .icon_d72e9002{color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.root_d72e9002.rootIsBlocked_d72e9002{background-color:" }, { "theme": "errorBackground", "defaultValue": "#fde7e9" }, { "rawString": ";color:" }, { "theme": "errorText", "defaultValue": "#333333" }, { "rawString": "}.root_d72e9002.rootIsBlocked_d72e9002 .icon_d72e9002{color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.root_d72e9002.rootIsSuccess_d72e9002{background-color:" }, { "theme": "successBackground", "defaultValue": "#dff6dd" }, { "rawString": ";color:" }, { "theme": "successText", "defaultValue": "#333333" }, { "rawString": "}.root_d72e9002.rootIsSuccess_d72e9002 .icon_d72e9002{color:" }, { "theme": "green", "defaultValue": "#107c10" }, { "rawString": "}.content_d72e9002{display:-webkit-box;display:-ms-flexbox;display:flex;line-height:normal;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.content_d72e9002:before{pointer-events:none;position:absolute;right:0;bottom:0;left:0;top:0;margin:0}@media screen and (-ms-high-contrast: active){.content_d72e9002:before{border:1px solid WindowText;content:' '}}.actions_d72e9002{padding-top:12px}html[dir='ltr'] .innerTextPadding_d72e9002 span,html[dir='ltr'] .innerTextPadding_d72e9002 .innerText_d72e9002>span{padding-right:4px}html[dir='rtl'] .innerTextPadding_d72e9002 span,html[dir='rtl'] .innerTextPadding_d72e9002 .innerText_d72e9002>span{padding-left:4px}.singleline_d72e9002{height:32px}.singleline_d72e9002 .content_d72e9002{-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:8px 0px}.singleline_d72e9002 .content_d72e9002 .icon_d72e9002{font-family:'FabricMDL2Icons';padding:0px 8px}.singleline_d72e9002 .content_d72e9002 .text_d72e9002{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.singleline_d72e9002 .content_d72e9002 .text_d72e9002 .innerText_d72e9002,.singleline_d72e9002 .content_d72e9002 .text_d72e9002 .innerTextPadding_d72e9002{max-height:1.3em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}html[dir='ltr'] .singleline_d72e9002 .content_d72e9002 .text_d72e9002 .innerText_d72e9002,html[dir='ltr'] .singleline_d72e9002 .content_d72e9002 .text_d72e9002 .innerTextPadding_d72e9002{padding-right:8px}html[dir='rtl'] .singleline_d72e9002 .content_d72e9002 .text_d72e9002 .innerText_d72e9002,html[dir='rtl'] .singleline_d72e9002 .content_d72e9002 .text_d72e9002 .innerTextPadding_d72e9002{padding-left:8px}.actions_d72e9002,.actionsOneline_d72e9002{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dismissal_d72e9002{max-height:16px;-ms-flex-negative:0;flex-shrink:0}.dismissal_d72e9002::-moz-focus-inner{border:0}.dismissal_d72e9002{outline:transparent}.dismissal_d72e9002{position:relative}.ms-Fabric.is-focusVisible .dismissal_d72e9002:focus:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid " }, { "theme": "focusBorder", "defaultValue": "#000000" }, { "rawString": "}html[dir='ltr'] .dismissal_d72e9002{right:0}html[dir='rtl'] .dismissal_d72e9002{left:0}@media screen and (-ms-high-contrast: active){.dismissal_d72e9002{-ms-high-contrast-adjust:none}}.dismissOneline_d72e9002{display:-webkit-box;display:-ms-flexbox;display:flex}.rootIsOneline_d72e9002{min-width:16px;min-height:16px;padding:8px 12px 8px 12px}html[dir='rtl'] .rootIsOneline_d72e9002{padding:8px 12px 8px 12px}.actionsOneline_d72e9002{position:relative;padding:0px 8px}.actionableOneline_d72e9002{height:48px}.actionableOneline_d72e9002 .content_d72e9002 .icon_d72e9002{padding:0px 16px}html[dir='ltr'] .actionableOneline_d72e9002 .content_d72e9002 .innerText_d72e9002{padding-right:0px}html[dir='rtl'] .actionableOneline_d72e9002 .content_d72e9002 .innerText_d72e9002{padding-left:0px}.multiline_d72e9002{padding:16px 12px 12px 16px}html[dir='rtl'] .multiline_d72e9002{padding:16px 16px 12px 12px}.multiline_d72e9002 .content_d72e9002{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.multiline_d72e9002 .content_d72e9002 .icon_d72e9002{font-family:'FabricMDL2Icons'}html[dir='ltr'] .multiline_d72e9002 .content_d72e9002 .icon_d72e9002{padding-right:8px}html[dir='rtl'] .multiline_d72e9002 .content_d72e9002 .icon_d72e9002{padding-left:8px}.multiline_d72e9002 .content_d72e9002 .innerText_d72e9002{line-height:16px}.multiline_d72e9002 .dismissal_d72e9002{margin:0}.multiline_d72e9002{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}html[dir='ltr'] .actionableMultiline_d72e9002.dismissalMultiline_d72e9002 .innerTextPadding_d72e9002{padding-right:48px}html[dir='rtl'] .actionableMultiline_d72e9002.dismissalMultiline_d72e9002 .innerTextPadding_d72e9002{padding-left:48px}\n" }]);
exports.root = "root_d72e9002";
exports.icon = "icon_d72e9002";
exports.text = "text_d72e9002";
exports.rootIsWarning = "rootIsWarning_d72e9002";
exports.rootIsSevereWarning = "rootIsSevereWarning_d72e9002";
exports.rootIsError = "rootIsError_d72e9002";
exports.rootIsBlocked = "rootIsBlocked_d72e9002";
exports.rootIsSuccess = "rootIsSuccess_d72e9002";
exports.content = "content_d72e9002";
exports.actions = "actions_d72e9002";
exports.innerTextPadding = "innerTextPadding_d72e9002";
exports.innerText = "innerText_d72e9002";
exports.singleline = "singleline_d72e9002";
exports.actionsOneline = "actionsOneline_d72e9002";
exports.dismissal = "dismissal_d72e9002";
exports.dismissOneline = "dismissOneline_d72e9002";
exports.rootIsOneline = "rootIsOneline_d72e9002";
exports.actionableOneline = "actionableOneline_d72e9002";
exports.multiline = "multiline_d72e9002";
exports.actionableMultiline = "actionableMultiline_d72e9002";
exports.dismissalMultiline = "dismissalMultiline_d72e9002";
//# sourceMappingURL=MessageBar.scss.js.map

/***/ }),

/***/ 3059:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('keyboardShortcutsOption', {
    shortcuts: null,
});
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3060:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SkypeNotificationType;
(function (SkypeNotificationType) {
    SkypeNotificationType[SkypeNotificationType["None"] = 0] = "None";
    SkypeNotificationType[SkypeNotificationType["ToastAndSound"] = 1] = "ToastAndSound";
    SkypeNotificationType[SkypeNotificationType["ToastOnly"] = 2] = "ToastOnly";
})(SkypeNotificationType = exports.SkypeNotificationType || (exports.SkypeNotificationType = {}));
exports.default = SkypeNotificationType;
//# sourceMappingURL=SkypeNotificationType.js.map

/***/ }),

/***/ 3061:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('attachmentPreferencesOption', {
    fromComputer: null,
    fromOneDrive: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('blockedDomainsOption', {
    blockedDomains: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3063:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('blockedSendersOption', {
    blockedSenders: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3064:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('markAsReadOption', {
    behavior: null,
    delay: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('replyOption', {
    replyAllByDefault: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3066:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('messageOption', {
    soundNotify: null,
    emailToastNotify: null,
    emptyDeletedItemsOnLogOut: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3067:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('readReceiptOption', {
    readReceiptResponse: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3068:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('dateHeadersOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3069:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('focusedInboxOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3070:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('inlinePreviewOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3071:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('senderImageOption', {
    showSenderImageInListView: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3072:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('messagePreviewOption', {
    showPreviewTextInListView: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3073:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('senderSubjectOption', {
    showSenderOnTopInListView: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3074:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('quickSuggestionsOption', {
    smartSuggestionsEnabled: null,
    browserLocationEnabled: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3075:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('linkPreviewOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3076:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var addNewClause_1 = __webpack_require__(2940);
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(2603);
exports.default = legacy_1.action('initializeInboxRuleEdit')(function initializeInboxRuleEdit(ruleToEditId) {
    if (store_1.default.inboxRulesEditState.conditionalClauseIds.length == 0) {
        addNewClause_1.default('conditional', null, null);
    }
    if (store_1.default.inboxRulesEditState.actionClauseIds.length == 0) {
        addNewClause_1.default('action', null, null);
    }
});
//# sourceMappingURL=initializeInboxRuleEdit.js.map

/***/ }),

/***/ 3077:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getClauseIdsForSectionType_1 = __webpack_require__(3175);
var store_1 = __webpack_require__(2603);
function getExistingClauseTypesInSection(sectionType) {
    var existingClauseTypesMap = new Map();
    var clauseIds = getClauseIdsForSectionType_1.default(sectionType);
    for (var _i = 0, clauseIds_1 = clauseIds; _i < clauseIds_1.length; _i++) {
        var clauseId = clauseIds_1[_i];
        var clause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        existingClauseTypesMap.set(clause.clauseType, clauseId);
    }
    return existingClauseTypesMap;
}
exports.default = getExistingClauseTypesInSection;
//# sourceMappingURL=getExistingClauseTypesInSection.js.map

/***/ }),

/***/ 3078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var getClauseSectionProperties_1 = __webpack_require__(3747);
var getClauseIdsForSectionType_1 = __webpack_require__(3175);
function isValidClause(clauseId) {
    var clause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
    var clauseValue = clause.clauseValue;
    // if clause type hasn't been selected from dropdown or value hasn't been input yet
    if (!clause.clauseType) {
        return false;
    }
    switch (clause.clauseType) {
        case 'from':
        case 'to':
        case 'forwardTo':
        case 'forwardAsAttachmentTo':
        case 'redirectTo':
            // check if recipient well is empty
            var recipientWell = clauseValue;
            return recipientWell.recipients.length != 0;
        case 'subjectIncludes':
        case 'subjectOrBodyIncludes':
        case 'inTheBody':
        case 'inTheSenderAddress':
        case 'inTheRecipientAddress':
        case 'inTheMessageHeader':
            // check if includes words input is empty
            var phrasePills = clauseValue;
            return phrasePills.length != 0;
        case 'moveTo':
        case 'copyTo':
            // check if folder has been selected
            var selectedFolder = clauseValue;
            return selectedFolder != null && selectedFolder.folderId != null;
        case 'atLeast':
        case 'atMost':
            var messageSize = clauseValue;
            return !isNaN(messageSize) && messageSize <= 1000000 && messageSize >= 0;
        case 'category':
        case 'fromTheAccount':
        case 'withImportance':
        case 'markImportance':
        case 'sensitivity':
        case 'classification':
        case 'flag':
        case 'type':
            return clauseValue != null;
        case 'onTheToOrCcLine':
        case 'theOnlyRecipientListed':
        case 'onTheToLine':
        case 'onTheCcLine':
        case 'notOnTheToLine':
        case 'delete':
        case 'pin':
        case 'read':
        case 'junk':
        case 'attachment':
        case 'before':
        case 'after':
            return true;
        default:
            throw new Error('Cannot validate unknown clause type');
    }
}
exports.default = isValidClause;
function isValidSection(sectionType) {
    var sectionProperties = getClauseSectionProperties_1.default(sectionType);
    var clauseIds = getClauseIdsForSectionType_1.default(sectionType);
    var isValidClauseInSection = false;
    // Valid sections:
    // 1: Required sections with an unselected clause with at least one other valid clause in the section
    // 2: Optional sections with an unselected clause type
    // 3: Sections with all valid clauses
    for (var _i = 0, clauseIds_1 = clauseIds; _i < clauseIds_1.length; _i++) {
        var clauseId = clauseIds_1[_i];
        var clause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        if (!clause.clauseType && (isValidClauseInSection || sectionProperties.isOptional)) {
            return true;
        }
        if (!isValidClause(clauseId)) {
            return false;
        }
        isValidClauseInSection = true;
    }
    // we've checked every clause by this point
    return true;
}
exports.isValidSection = isValidSection;
//# sourceMappingURL=isValidClause.js.map

/***/ }),

/***/ 3079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function maskAutoCompleteRecipientRequest(data) {
    var result = tslib_1.__assign({ __type: 'MaskAutoCompleteRecipientRequest:#Exchange' }, data);
    return result;
}
exports.default = maskAutoCompleteRecipientRequest;


/***/ }),

/***/ 3080:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resolveQueryStringToRecipient_1 = __webpack_require__(2669);
function searchDirectory(recipientWell) {
    resolveQueryStringToRecipient_1.default(recipientWell, false /* shouldDirectlyResolve */, true /* searchDirectory */);
}
exports.default = searchDirectory;
//# sourceMappingURL=searchDirectory.js.map

/***/ }),

/***/ 3081:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var addReadWriteRecipient_1 = __webpack_require__(2615);
function useTypedAddress(recipientWell) {
    addReadWriteRecipient_1.default(recipientWell, true /* isValid */, null /* newPersona */, recipientWell.queryString);
}
exports.default = useTypedAddress;
//# sourceMappingURL=useTypedAddress.js.map

/***/ }),

/***/ 3082:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getGroupInfoRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetGroupInfoRequest:#Exchange' }, data);
    return result;
}
exports.default = getGroupInfoRequest;


/***/ }),

/***/ 3083:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function newInboxRuleRequest(data) {
    var result = tslib_1.__assign({ __type: 'NewInboxRuleRequest:#Exchange' }, data);
    return result;
}
exports.default = newInboxRuleRequest;


/***/ }),

/***/ 3084:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('surfaceActionsOption', {
    readSurfaceActions: null,
    readSurfaceAddins: null,
    composeSurfaceActions: null,
    composeSurfaceAddins: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3085:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_mail_feature_flags_1 = __webpack_require__(23);
var legacy_1 = __webpack_require__(1);
var owa_addins_core_1 = __webpack_require__(1738);
exports.default = legacy_1.action('initializeExtensibilityContext')(function initializeExtensibilityContext() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Initializing the EXT context here is only needed for addins under the customSurfaceActions feature.
                    if (!owa_controls_feature_flags_1.isControlFeatureEnabled('rp-customSurfaceActions') ||
                        !owa_mail_feature_flags_1.isMailFeatureEnabled('rp-addins')) {
                        return [2 /*return*/];
                    }
                    // Init EXT context. This method has retry logic and will also resolve immediately if already initialized.
                    return [4 /*yield*/, owa_addins_core_1.initExtensibilityContext.importAndExecute()];
                case 1:
                    // Init EXT context. This method has retry logic and will also resolve immediately if already initialized.
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initializeExtensibilityContext.js.map

/***/ }),

/***/ 3086:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getPackageBaseUrl_1 = __webpack_require__(224);
var url_1 = __webpack_require__(155);
var ATTACH_SVG = __webpack_require__(3087);
var INLINEIMAGE_SVG = __webpack_require__(3088);
var EMOJI_SVG = __webpack_require__(3089);
var SHOWRIBBON_SVG = __webpack_require__(3090);
function getComposeActionIconName(key) {
    var iconName;
    var isImage = false;
    switch (key) {
        case 'AddAttachment':
            iconName = url_1.resolve(getPackageBaseUrl_1.default(), ATTACH_SVG);
            isImage = true;
            break;
        case 'AddInlineImage':
            iconName = url_1.resolve(getPackageBaseUrl_1.default(), INLINEIMAGE_SVG);
            isImage = true;
            break;
        case 'AddEmoji':
            iconName = url_1.resolve(getPackageBaseUrl_1.default(), EMOJI_SVG);
            isImage = true;
            break;
        case 'ToggleRibbon':
            iconName = url_1.resolve(getPackageBaseUrl_1.default(), SHOWRIBBON_SVG);
            isImage = true;
            break;
        case 'SaveDraft':
            iconName = "Save" /* Save */;
            break;
        case 'InsertSignature':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'ShowFrom':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'SetImportance':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        default:
            iconName = '';
            break;
    }
    return [iconName, isImage];
}
exports.getComposeActionIconName = getComposeActionIconName;
function getReadActionIconName(key) {
    var iconName;
    switch (key) {
        case '-':
            iconName = '-';
            break;
        case 'Reply':
            iconName = "Reply" /* Reply */;
            break;
        case 'ReplyAll':
            iconName = "ReplyAll" /* ReplyAll */;
            break;
        case 'Forward':
            iconName = "Forward" /* Forward */;
            break;
        case 'Delete':
            iconName = "Delete" /* Delete */;
            break;
        case 'MarkReadUnread':
            iconName = "Mail" /* Mail */;
            break;
        case 'FlagUnflag':
            iconName = "Flag" /* Flag */;
            break;
        case 'MarkJunkNotJunk':
            iconName = "MailAlert" /* MailAlert */;
            break;
        case 'MarkAsPhishing':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'Block':
            iconName = "BlockContact" /* BlockContact */;
            break;
        case 'CreateRule':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'Print':
            iconName = "Print" /* Print */;
            break;
        case 'ShowInImmersiveReader':
            iconName = "ReadingMode" /* ReadingMode */;
            break;
        default:
            iconName = '';
            break;
    }
    return [iconName, false];
}
exports.getReadActionIconName = getReadActionIconName;
//# sourceMappingURL=getIconNameFromKey.js.map

/***/ }),

/***/ 3087:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3088:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii02MTExIC04NjkyIDMyIDMyIj4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogbm9uZTsNCiAgICAgIH0NCg0KICAgICAgLmNscy0yIHsNCiAgICAgICAgZmlsbDogIzAwNzhkNzsNCiAgICAgICAgc3Ryb2tlOiAjZmZmOw0KICAgICAgICBzdHJva2Utd2lkdGg6IDEuNXB4Ow0KICAgICAgfQ0KDQogICAgICAuY2xzLTMgew0KICAgICAgICBmaWxsOiAjNjY2Ow0KICAgICAgfQ0KICAgIDwvc3R5bGU+DQogIDwvZGVmcz4NCiAgPGcgaWQ9IlRCOl9JbnNlcnQiIGRhdGEtbmFtZT0iVEI6IEluc2VydCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYzNjYgLTkxNjAuOTk5KSI+DQogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yMjkxIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyMjkxIiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgcng9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1NSA0NjguOTk5KSIvPg0KICAgIDxnIGlkPSJHcm91cF8zODgwIiBkYXRhLW5hbWU9Ikdyb3VwIDM4ODAiPg0KICAgICAgPHBhdGggaWQ9IlBhdGhfOTkwIiBkYXRhLW5hbWU9IlBhdGggOTkwIiBjbGFzcz0iY2xzLTIiIGQ9Ik0xLjA2My0zLjE4N0gxMS45OTVMNC43ODEtMTAuNDA5LDEuMDYzLTYuNjgyWm0xNC44NzUsMHYtLjMwN0wxMi4yMTktNy4yMjIsMTAuODQxLTUuODQ0bDIuNjY1LDIuNjU2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjYzIDQ5Mi45OTkpIi8+DQogICAgICA8cGF0aCBpZD0iUGF0aF8xNDUyIiBkYXRhLW5hbWU9IlBhdGggMTQ1MiIgY2xhc3M9ImNscy0zIiBkPSJNMTctMTQuODc1djEyLjc1SDB2LTEyLjc1Wk0xLjA2My0xMy44MTJ2NS42Mkw0Ljc4MS0xMS45bDUuMzEzLDUuMzEzLDIuMTI1LTIuMTI1LDMuNzE5LDMuNzF2LTguODA3Wm0wLDEwLjYyNUgxMS45OTVMNC43ODEtMTAuNDA5LDEuMDYzLTYuNjgyWm0xNC44NzUsMHYtLjMwN0wxMi4yMTktNy4yMjIsMTAuODQxLTUuODQ0bDIuNjY1LDIuNjU2Wm0tMi42NTYtNy40MzdhLjUxMS41MTEsMCwwLDEtLjM3NC0uMTU4LjUxMS41MTEsMCwwLDEtLjE1OC0uMzc0LjUxMS41MTEsMCwwLDEsLjE1OC0uMzc0LjUxMS41MTEsMCwwLDEsLjM3NC0uMTU4LjUxMS41MTEsMCwwLDEsLjM3NC4xNTguNTExLjUxMSwwLDAsMSwuMTU4LjM3NC41MTEuNTExLDAsMCwxLS4xNTguMzc0QS41MTEuNTExLDAsMCwxLDEzLjI4MS0xMC42MjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNjMgNDkyLjk5OSkiLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 3089:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3090:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3091:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = __webpack_require__(23);
var getUserConfiguration_1 = __webpack_require__(9);
function getReadStaticActions() {
    var actions = [
        'Reply',
        'ReplyAll',
        'Forward',
        '-',
        'Delete',
        '-',
        'MarkReadUnread',
        'FlagUnflag',
        '-',
    ];
    if (!getUserConfiguration_1.default().SessionSettings.IsShadowMailbox) {
        actions.push('MarkJunkNotJunk', 'MarkAsPhishing', 'Block', '-');
    }
    actions.push('CreateRule', 'Print');
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('rp-immersiveReader')) {
        actions.push('ShowInImmersiveReader');
    }
    return actions;
}
exports.getReadStaticActions = getReadStaticActions;
function getComposeStaticActions() {
    return [
        'AddAttachment',
        'AddInlineImage',
        'AddEmoji',
        'ToggleRibbon',
        'SaveDraft',
        'InsertSignature',
        'ShowFrom',
        'SetImportance',
    ];
}
exports.getComposeStaticActions = getComposeStaticActions;
function shouldAddActionToEnd(action) {
    // Reply, ReplyAll, and Forward are the first 3 actions in the set of static actions in the reading pane.
    // While all other actions should render from right to left based on their order in the settings,
    // the desire is for these three to render left to right, so they should be inserted at the end of the collection.
    return action == 'Reply' || action == 'ReplyAll' || action == 'Forward';
}
exports.shouldAddActionToEnd = shouldAddActionToEnd;
//# sourceMappingURL=getStaticActions.js.map

/***/ }),

/***/ 3092:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2729);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setAddinObserverLoaded ')(function updateInstalledAddins() {
    // Framework team has plans to implement a .isLoaded property for lazy imports.
    // This will allow a component to re-render when the import finishes. Until this is available,
    // we'll use our own boolean in the store. WI: 23555
    store_1.default.isAddinObserverLoaded = true;
});
//# sourceMappingURL=setAddinObserverLoaded.js.map

/***/ }),

/***/ 3093:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getAddinCollection_1 = __webpack_require__(2798);
var getDisplayNameFromKey_1 = __webpack_require__(2797);
var ContextualMenu_1 = __webpack_require__(329);
var owa_addins_core_1 = __webpack_require__(1738);
function addItemToSurfaceCollection(surfaceItems, item, isEndAligned) {
    if (isEndAligned) {
        surfaceItems.unshift(item);
    }
    else {
        surfaceItems.push(item);
    }
}
function tryAddDivider(overflowItems, dividerKey) {
    var itemLength = overflowItems.length;
    if (itemLength > 0 && overflowItems[itemLength - 1].displayName != getDisplayNameFromKey_1.DIVIDER_DISPLAY_NAME) {
        overflowItems.push({
            key: "addinDivider_" + dividerKey,
            displayName: getDisplayNameFromKey_1.DIVIDER_DISPLAY_NAME,
            itemType: ContextualMenu_1.ContextualMenuItemType.Divider,
            onClick: null,
        });
    }
}
function populateCommandBarWithAddins(extMode, hostId, surfaceAddinKeys, surfaceItems, overflowItems, isEndAligned, shouldPopulateSurface, dividerKey, className) {
    var installedAddins;
    var addinCollection = getAddinCollection_1.default(extMode);
    installedAddins = addinCollection ? addinCollection.sectionProps.items : [];
    var hostItemIndex = extMode == owa_addins_core_1.ExtensibilityModeEnum.MessageRead
        ? owa_addins_core_1.getReadHostItemIndex(hostId)
        : owa_addins_core_1.getComposeHostItemIndex(hostId);
    var shouldAddFirstDivider = true;
    installedAddins.forEach(function (addin) {
        owa_addins_core_1.convertToIContextualMenuItem(hostItemIndex, addin);
        var commandBarItem = addin;
        commandBarItem.iconOnly = true;
        if (className) {
            commandBarItem.className = className;
        }
        // Check if the user has this addin in their surface addins.
        if (surfaceAddinKeys.indexOf(addin.key) >= 0 && shouldPopulateSurface) {
            // If they do, add it to the surface items.
            addItemToSurfaceCollection(surfaceItems, commandBarItem, isEndAligned);
        }
        else {
            // If they don't, push it to the overflow, but first add a divider to separate addins from actions if needed.
            if (shouldAddFirstDivider) {
                tryAddDivider(overflowItems, dividerKey++);
                shouldAddFirstDivider = false;
            }
            overflowItems.push(commandBarItem);
        }
    });
}
exports.default = populateCommandBarWithAddins;
//# sourceMappingURL=populateCommandBarWithAddins.js.map

/***/ }),

/***/ 3094:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('calendarAppearanceOption', {
    weekStartDay: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3095:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('txpOption', {
    CreateEventsFromEmailAsPrivate: null,
    EventsFromEmailEnabled: null,
    Events: {
        DiningEventsFromEmailEnabled: null,
        EntertainmentEventsFromEmailEnabled: null,
        FlightEventsFromEmailEnabled: null,
        HotelEventsFromEmailEnabled: null,
        InvoiceEventsFromEmailEnabled: null,
        PackageDeliveryEventsFromEmailEnabled: null,
        RentalCarEventsFromEmailEnabled: null,
    },
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_general_1 = __webpack_require__(3724);
var owa_options_mail_1 = __webpack_require__(3378);
var owa_options_calendar_1 = __webpack_require__(3764);
__webpack_require__(3378); // Imported to bootstrap several services
var mobx_1 = __webpack_require__(15);
var UNFILTERED_OPTIONS = [owa_options_general_1.GeneralOptions, owa_options_mail_1.MailOptions, owa_options_calendar_1.CalendarOptions];
var collectedOptions = mobx_1.computed(function () {
    return UNFILTERED_OPTIONS.map(function (category) {
        category = tslib_1.__assign({}, category, { subcategories: category.subcategories
                .map(function (subcategory) {
                subcategory = tslib_1.__assign({}, subcategory, { options: subcategory.options.filter(function (option) { return !option.isHidden || !option.isHidden(); }) });
                return subcategory;
            })
                .filter(function (subcategory) { return subcategory.options.length > 0; }) });
        return category;
    }).filter(function (category) { return category.subcategories.length > 0; });
});
exports.default = function () { return collectedOptions.get(); };
//# sourceMappingURL=collectedOptions.js.map

/***/ }),

/***/ 3174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getActionClauseTypeOptions_1 = __webpack_require__(2795);
var getConditionalExceptionClauseTypeOptions_1 = __webpack_require__(2796);
var getExistingClauseTypesInSection_1 = __webpack_require__(3077);
function hasUsedAllClauseTypesInSection(sectionType) {
    var numExistingClauseTypes = getExistingClauseTypesInSection_1.default(sectionType).size;
    if (sectionType == 'conditional' || sectionType == 'exception') {
        return getConditionalExceptionClauseTypeOptions_1.default().length == numExistingClauseTypes;
    }
    else if (sectionType == 'action') {
        return getActionClauseTypeOptions_1.default().length == numExistingClauseTypes;
    }
    else {
        throw new Error('Cannot determine max number of clauses for unknown section type');
    }
}
exports.default = hasUsedAllClauseTypesInSection;
//# sourceMappingURL=hasUsedAllClauseTypesInSection.js.map

/***/ }),

/***/ 3175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
function getClauseIdsForSectionType(sectionType) {
    switch (sectionType) {
        case 'conditional':
            return store_1.default.inboxRulesEditState.conditionalClauseIds;
        case 'action':
            return store_1.default.inboxRulesEditState.actionClauseIds;
        case 'exception':
            return store_1.default.inboxRulesEditState.exceptionClauseIds;
        default:
            throw new Error('Cannot get clause ids for a section type that does not exist');
    }
}
exports.default = getClauseIdsForSectionType;
//# sourceMappingURL=getClauseIdsForSectionType.js.map

/***/ }),

/***/ 3176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(15);
function initializeInboxRulesEditState() {
    return {
        ruleId: '',
        ruleName: '',
        conditionalClauseIds: [],
        actionClauseIds: [],
        exceptionClauseIds: [],
        clauseMap: mobx_1.map({}),
        clauseErrorTextMap: mobx_1.map({}),
        includesWordsInputTextMap: mobx_1.map({}),
        isSectionInfoCalloutVisible: mobx_1.map({}),
        focusedClauseId: '',
        ignoreSubsequentRules: true,
        selectedFolderId: '',
    };
}
exports.default = initializeInboxRulesEditState;
//# sourceMappingURL=initializeInboxRulesEditState.js.map

/***/ }),

/***/ 3177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
function getFolderFromRawId(rawIdentity) {
    // the rawIdendity ends with the path to the folder, formatted **rest of rawIdentity**rootFolder:\pathToFolder
    var rawIdPath = rawIdentity.split(':\\')[1];
    var folders = store_1.default.dropdownFolders;
    for (var _i = 0, folders_1 = folders; _i < folders_1.length; _i++) {
        var folder = folders_1[_i];
        if (rawIdPath === folder.path) {
            return folder;
        }
    }
    return null;
}
exports.getFolderFromRawId = getFolderFromRawId;
function getFolderFromFolderId(folderId) {
    // the rawIdendity ends with the path to the folder, formatted **rest of rawIdentity**rootFolder:\pathToFolder
    var folders = store_1.default.dropdownFolders;
    for (var _i = 0, folders_2 = folders; _i < folders_2.length; _i++) {
        var folder = folders_2[_i];
        if (folderId === folder.folderId) {
            // when we call this function from the create rule dialog the rawIdentity uses the folderId from the mail store
            return folder;
        }
    }
    return null;
}
exports.getFolderFromFolderId = getFolderFromFolderId;
//# sourceMappingURL=folderTypeConversionUtil.js.map

/***/ }),

/***/ 3178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setClauseValue')(function setClauseType(clauseValue, clauseId) {
    store_1.default.inboxRulesEditState.clauseMap.get(clauseId).clauseValue = clauseValue;
});
//# sourceMappingURL=setClauseValue.js.map

/***/ }),

/***/ 3179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var ClauseValueType_1 = __webpack_require__(3748);
var legacy_1 = __webpack_require__(1);
var owa_options_strings_1 = __webpack_require__(1737);
exports.default = legacy_1.action('setClauseErrorText')(function setClauseErrorText(clauseId, isValidClause) {
    var clause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
    var errorText;
    if (isValidClause) {
        store_1.default.inboxRulesEditState.clauseErrorTextMap.set(clauseId, '');
        return;
    }
    if (clauseId == 'name') {
        store_1.default.inboxRulesEditState.clauseErrorTextMap.set(clauseId, owa_options_strings_1.default.options_inboxRules_emptyNameError);
        return;
    }
    switch (clause.clauseType) {
        case 'from':
            errorText = owa_options_strings_1.default.options_inboxRules_emptyFromError;
            break;
        case 'to':
            errorText = owa_options_strings_1.default.options_inboxRules_emptyToError;
            break;
        case 'subjectIncludes':
        case 'subjectOrBodyIncludes':
        case 'inTheBody':
        case 'inTheSenderAddress':
        case 'inTheRecipientAddress':
        case 'inTheMessageHeader':
            errorText = owa_options_strings_1.default.options_inboxRules_emptyPhraseError;
            break;
        case 'atLeast':
        case 'atMost':
            errorText = getMessageSizeErrorText(Number(clause.clauseValue));
            break;
        default:
            errorText = owa_options_strings_1.default.options_inboxRules_emptyDropdownError;
            break;
    }
    store_1.default.inboxRulesEditState.clauseErrorTextMap.set(clauseId, errorText);
});
function getMessageSizeErrorText(num) {
    if (isNaN(num) || num < 1) {
        return owa_options_strings_1.default.options_inboxRules_messageSizeNotANumber;
    }
    else if (num > ClauseValueType_1.MAX_MESSAGE_SIZE / ClauseValueType_1.KB_TO_B) {
        return owa_options_strings_1.default.options_inboxRules_messageSizeTooLarge;
    }
    else {
        return '';
    }
}
//# sourceMappingURL=setClauseErrorText.js.map

/***/ }),

/***/ 3180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var maskAutoCompleteRecipient_1 = __webpack_require__(3390);
var deleteFromCache_1 = __webpack_require__(3392);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('maskRecipientFromFindControl')(function maskRecipientFromFindControl(recipientWell, recipientToMask) {
    // Remove Recipient from Find Control and Cache.
    recipientWell.findResultSet = recipientWell.findResultSet.filter(function (curObj) {
        return curObj !== recipientToMask;
    });
    deleteFromCache_1.default(recipientToMask.EmailAddress);
    // Mask Recipient Well
    maskAutoCompleteRecipient_1.maskAutoCompleteRecipient(recipientToMask.EmailAddress.EmailAddress);
});
//# sourceMappingURL=maskRecipientFromFindControl.js.map

/***/ }),

/***/ 3181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var setContextMenuVisibility_1 = __webpack_require__(3401);
var setRecipientSelectedState_1 = __webpack_require__(2764);
var setShouldBlockSelection_1 = __webpack_require__(3402);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var Persona_1 = __webpack_require__(234);
var Utilities_1 = __webpack_require__(7);
var PersonaControl_1 = __webpack_require__(673);
var owa_common_strings_1 = __webpack_require__(37);
var React = __webpack_require__(3);
var ContextualMenu_1 = __webpack_require__(329);
var KeyboardCharCodes_1 = __webpack_require__(634);
var PersonaCardBehavior_1 = __webpack_require__(2655);
var styles = __webpack_require__(3403);
var classNames = __webpack_require__(30).bind(styles);
var SMTP_ROUTING_TYPE = 'SMTP';
var PRIVATE_DL_ROUTING_TYPE = 'PDL';
var ONE_OFF_MAILBOX_TYPE = 'OneOff';
var RIGHT_CLICK_BUTTONCODE = 2;
var ReadWriteRecipient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadWriteRecipient, _super);
    function ReadWriteRecipient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.removeRecipient = function () {
            setRecipientSelectedState_1.default(_this.props.viewState, false /* isSelected */);
            _this.props.removeOperation(_this.props.viewState);
        };
        _this.expandGroup = function () {
            setRecipientSelectedState_1.default(_this.props.viewState, false /* isSelected */);
            if (!_this.props.viewState.isExpanding) {
                _this.props.expandGroupOperation(_this.props.viewState);
            }
        };
        _this.onContextMenu = function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            setContextMenuVisibility_1.default(_this.props.viewState, true);
            setShouldBlockSelection_1.default(_this.props.viewState, false);
        };
        _this.onDismissContextMenu = function (ev) {
            ev.stopPropagation();
            setContextMenuVisibility_1.default(_this.props.viewState, false);
        };
        _this.onMouseDown = function (ev) {
            ev.stopPropagation();
            if (ev.button == RIGHT_CLICK_BUTTONCODE &&
                _this.props.viewState.isContextMenuOpen == false) {
                setShouldBlockSelection_1.default(_this.props.viewState, true);
            }
        };
        _this.onFocus = function (ev) {
            if (!_this.props.viewState.shouldBlockSelection) {
                setRecipientSelectedState_1.default(_this.props.viewState, true);
            }
        };
        _this.onBlur = function (ev) {
            setRecipientSelectedState_1.default(_this.props.viewState, false);
        };
        _this.onKeyDown = function (ev) {
            switch (ev.keyCode) {
                case KeyboardCharCodes_1.BACKSPACE_CHARCODE:
                    ev.stopPropagation();
                    if (!_this.props.viewState.blockRecipientRemoval) {
                        _this.props.removeOperation(_this.props.viewState);
                    }
                    return;
                case KeyboardCharCodes_1.DELETE_CHARCODE:
                    ev.stopPropagation();
                    if (!_this.props.viewState.blockRecipientRemoval) {
                        _this.props.removeOperation(_this.props.viewState, true /* selectToRight */);
                    }
                    return;
                case KeyboardCharCodes_1.LEFT_ARROW_CHARCODE:
                    ev.stopPropagation();
                    _this.props.focusNextOperation(_this.props.viewState, Utilities_1.getRTL() ? 1 : -1);
                    return;
                case KeyboardCharCodes_1.RIGHT_ARROW_CHARCODE:
                    ev.stopPropagation();
                    _this.props.focusNextOperation(_this.props.viewState, Utilities_1.getRTL() ? -1 : 1);
                    return;
                case KeyboardCharCodes_1.TAB_CHARCODE:
                    if (!ev.shiftKey) {
                        ev.preventDefault();
                        _this.props.focusNextOperation(_this.props.viewState, Utilities_1.getRTL() ? -1 : 1);
                        return;
                    }
            }
        };
        _this.copyAddress = function () {
            var email = _this.props.viewState.persona.EmailAddress;
            var copyText;
            if (email.RoutingType === SMTP_ROUTING_TYPE) {
                if (email.Name) {
                    var nameToUse = email.MailboxType == ONE_OFF_MAILBOX_TYPE
                        ? email.Name
                        : "\"" + email.Name.replace('"', '\\"') + "\"";
                    copyText = nameToUse + " <" + email.EmailAddress + ">";
                }
                else {
                }
            }
            else if (email.RoutingType === PRIVATE_DL_ROUTING_TYPE) {
                copyText = email.Name;
            }
            else {
                copyText = email.Name + " [" + email.RoutingType + ":" + email.EmailAddress + "]";
            }
            var copyInput = document.createElement('input');
            copyInput.className = styles.copyInput;
            document.body.appendChild(copyInput);
            try {
                // Try to copy the text directly to the clipboard
                copyInput.value = copyText;
                copyInput.select();
                if (!document.execCommand('copy')) {
                    // The command failed. Fallback to the method below.
                    throw new Error();
                }
            }
            catch (err) {
                // The above method didn't work. Fallback to a prompt.
                window.prompt(owa_common_strings_1.default.readWriteRecipient_CopyPrompt, copyText);
            }
            finally {
                document.body.removeChild(copyInput);
            }
        };
        return _this;
    }
    ReadWriteRecipient.prototype.setFocusIfSelected = function () {
        if (this.props.viewState.isSelected) {
            this.personaSpan.focus();
        }
    };
    ReadWriteRecipient.prototype.componentDidMount = function () {
        this.setFocusIfSelected();
    };
    ReadWriteRecipient.prototype.componentDidUpdate = function () {
        this.setFocusIfSelected();
    };
    ReadWriteRecipient.prototype.createContextMenuItems = function () {
        var menuItems = [];
        if (!this.props.viewState.blockRecipientRemoval) {
            menuItems.push({
                key: 'remove',
                name: owa_common_strings_1.default.readWriteRecipientMenu_Remove,
                onClick: this.removeRecipient,
            });
        }
        menuItems.push({
            key: 'copyAddress',
            name: owa_common_strings_1.default.readWriteRecipientMenu_Copy,
            onClick: this.copyAddress,
        });
        return menuItems;
    };
    ReadWriteRecipient.prototype.getPersonaSizeFromRecipientWellSize = function (size) {
        switch (size) {
            case 0 /* Small */:
                return Persona_1.PersonaSize.size24;
            case 1 /* Regular */:
                return Persona_1.PersonaSize.size32;
            default:
                throw new Error('Cannot get persona size for unknown recipient well size');
        }
    };
    ReadWriteRecipient.prototype.render = function () {
        var _this = this;
        var viewState = this.props.viewState;
        var email = viewState.persona.EmailAddress;
        var isSmallSize = this.props.size == 0 /* Small */;
        var isRegularSize = this.props.size == 1 /* Regular */;
        var personaSize = this.getPersonaSizeFromRecipientWellSize(this.props.size);
        var isExpandable = (email.MailboxType == 'PrivateDL' ||
            email.MailboxType == 'PublicDL' ||
            email.MailboxType == 'GroupMailbox') &&
            this.props.viewState.persona.PersonaId;
        var personaInfo = (React.createElement("div", { className: styles.personaInfoWrapper },
            React.createElement(PersonaControl_1.default, { className: styles.recipientImg, name: viewState.displayText, emailAddress: email.EmailAddress, size: personaSize }),
            React.createElement("span", { className: classNames(styles.recipientText, { invalid: !viewState.isValid }, { selected: viewState.isSelected }, { smallSize: isSmallSize }, { regularSize: isRegularSize }) }, viewState.displayText)));
        return (React.createElement("div", { className: classNames(styles.recipientBox, {
                boxWithPrivateDl: isExpandable,
                selected: viewState.isSelected,
                smallSize: isSmallSize,
                regularSize: isRegularSize,
            }) },
            React.createElement(Button_1.IconButton, { className: classNames(styles.expandGroupButton, {
                    smallSize: isSmallSize,
                    regularSize: isRegularSize,
                }, styles.actionButton, {
                    visible: isExpandable,
                    noHover: viewState.isExpanding,
                    selected: viewState.isSelected,
                }), onClick: this.expandGroup, iconProps: {
                    iconName: "Add" /* Add */,
                } }),
            React.createElement("span", { className: classNames(styles.recipient), ref: function (ref) { return (_this.personaSpan = ref); }, tabIndex: -1, onMouseDown: this.onMouseDown, onBlur: this.onBlur, onKeyDown: this.onKeyDown, onFocus: this.onFocus, onContextMenu: this.onContextMenu, role: "button", "aria-haspopup": "true" },
                email.EmailAddress ? (React.createElement(LPCComposeRecipientWrapper, { emailAddress: email.EmailAddress, name: viewState.displayText, mailBoxType: email.MailboxType, disableHoverAndKeyPress: true }, personaInfo)) : (personaInfo),
                !this.props.viewState.blockRecipientRemoval && (React.createElement(Button_1.IconButton, { className: classNames(styles.removeRecipient, {
                        smallSize: isSmallSize,
                        regularSize: isRegularSize,
                    }, styles.actionButton, {
                        selected: viewState.isSelected,
                    }), onClick: this.removeRecipient, iconProps: {
                        iconName: "Cancel" /* Cancel */,
                    } })),
                viewState.isContextMenuOpen && (React.createElement(ContextualMenu_1.ContextualMenu, { items: this.createContextMenuItems(), onDismiss: this.onDismissContextMenu, target: this.personaSpan, directionalHint: 4 /* bottomLeftEdge */ })))));
    };
    ReadWriteRecipient = tslib_1.__decorate([
        mobx_react_1.observer
    ], ReadWriteRecipient);
    return ReadWriteRecipient;
}(React.Component));
exports.default = ReadWriteRecipient;
var LPCComposeRecipientWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(LPCComposeRecipientWrapper, _super);
    function LPCComposeRecipientWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LPCComposeRecipientWrapper.prototype.render = function () {
        return React.createElement("span", { onClick: this.props.onPersonaCardBehaviorClick }, this.props.children);
    };
    LPCComposeRecipientWrapper = tslib_1.__decorate([
        PersonaCardBehavior_1.personaCardBehavior
    ], LPCComposeRecipientWrapper);
    return LPCComposeRecipientWrapper;
}(React.Component));
//# sourceMappingURL=ReadWriteRecipient.js.map

/***/ }),

/***/ 3182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('processGetGroupInfoResult')(function processGetGroupInfoResult(personaTypeSet, responseMessage) {
    if (responseMessage.Members) {
        responseMessage.Members.forEach(function (result) {
            personaTypeSet.push({
                EmailAddress: result.EmailAddress,
                PersonaId: result.PersonaId,
                ADObjectId: result.ADObjectId,
            });
        });
    }
});
//# sourceMappingURL=processGetGroupInfoResult.js.map

/***/ }),

/***/ 3183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getGroupInfoRequest_1 = __webpack_require__(3082);
var indexedPageView_1 = __webpack_require__(236);
var getGroupInfoOperation_1 = __webpack_require__(3406);
function configureIndexedPageView() {
    return indexedPageView_1.default({
        BasePoint: 'Beginning',
        Offset: 0,
        MaxEntriesReturned: 100,
    });
}
function configureRequestBody(itemId, adObjectId, emailAddress) {
    return getGroupInfoRequest_1.default({
        ItemId: itemId,
        AdObjectId: adObjectId,
        EmailAddress: emailAddress,
        Paging: configureIndexedPageView(),
        ResultSet: 2 /* Members */,
    });
}
function getGroupInfo(itemId, adObjectId, emailAddress) {
    var requestBody = configureRequestBody(itemId, adObjectId, emailAddress);
    return getGroupInfoOperation_1.default({ getGroupInfoRequest: requestBody }).then(function (response) {
        var responseMessage = response;
        return responseMessage;
    });
}
exports.getGroupInfo = getGroupInfo;
//# sourceMappingURL=getGroupInfo.js.map

/***/ }),

/***/ 3184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RecipientType_1 = __webpack_require__(2672);
var owa_common_strings_1 = __webpack_require__(37);
function getRecipientString(recipientType) {
    switch (recipientType) {
        case RecipientType_1.RecipientType.To:
            return owa_common_strings_1.default.ToRecipientLabel;
        case RecipientType_1.RecipientType.Cc:
            return owa_common_strings_1.default.CcRecipientLabel;
        case RecipientType_1.RecipientType.Bcc:
            return owa_common_strings_1.default.BccRecipientLabel;
        default:
            throw new Error("There is no localized string for RecipientType." + RecipientType_1.RecipientType[recipientType]);
    }
}
exports.default = getRecipientString;
//# sourceMappingURL=getRecipientString.js.map

/***/ }),

/***/ 3185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
owa_bundling_1.preloadScriptChunk('ContactPickerPane');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 3751));
});
// Delayed Loaded Components
exports.ContactPickerPane = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.ContactPickerPane; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var owa_options_store_1 = __webpack_require__(2641);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_orchestration_1 = __webpack_require__(2794);
var executeCallbackAndHide = satcheljs_1.orchestratorAction('executeCallbackAndHide', function executeCallbackAndHide(saveDiscardCallback, continueAfterConfirmCallback) {
    if (saveDiscardCallback) {
        saveDiscardCallback();
    }
    continueAfterConfirmCallback();
});
exports.default = satcheljs_1.orchestratorAction('confirmDirtyOptionsAndPerformAction', function hideFullOptions(continueAfterConfirmCallback) {
    var currentSubcategory = owa_options_store_1.getCurrentSubcategory();
    if (owa_options_core_1.isAnyOptionDirty(currentSubcategory)) {
        owa_options_core_1.confirmOptionNavigation({
            onSave: function () {
                executeCallbackAndHide(owa_options_orchestration_1.saveOptions, continueAfterConfirmCallback);
            },
            onDiscard: function () {
                executeCallbackAndHide(owa_options_orchestration_1.discardOptions, continueAfterConfirmCallback);
            },
            shouldDisableSaveButton: owa_options_core_1.shouldDisableSaveButton(currentSubcategory),
        });
    }
    else {
        continueAfterConfirmCallback();
    }
});
//# sourceMappingURL=confirmDirtyOptionsAndPerformAction.js.map

/***/ }),

/***/ 3282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(2813);
var owa_options_core_2 = __webpack_require__(1736);
var owa_options_core_3 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var ReadingPanePosition_1 = __webpack_require__(52);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var owa_analytics_1 = __webpack_require__(12);
var saveReadingPanePositionOptionStitchName = 'saveReadingPanePositionOptionStitchName';
var saveReadingPaneOption = legacy_1.action('saveReadingPaneOption')(function saveReadingPaneOption(newReadingPanePosition, userOptions, newNextSelection, newLoadFirstMessageOnLogon) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var servicePromises, serverUpdates, showReadingPane, serviceBehavior;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    servicePromises = [];
                    serverUpdates = [];
                    showReadingPane = newReadingPanePosition != ReadingPanePosition_1.default.Off;
                    // Deal with the new ReadingPane position
                    if (newReadingPanePosition !== userOptions.GlobalReadingPanePositionReact) {
                        userOptions.GlobalReadingPanePositionReact = newReadingPanePosition;
                        // Raise stitch so that, if we're running in mail, it'll trigger 3 line view or single line view
                        stitch_1.raiseAction(saveReadingPanePositionOptionStitchName)(newReadingPanePosition);
                        serverUpdates.push({
                            propertyName: 'GlobalReadingPanePositionReact',
                            propertyType: 'Integer32',
                            propertyValue: String(newReadingPanePosition),
                        });
                    }
                    // Deal with ShowReadingPaneOnFirstLoad
                    if (newLoadFirstMessageOnLogon !== undefined &&
                        newLoadFirstMessageOnLogon !== userOptions.ShowReadingPaneOnFirstLoad) {
                        userOptions.ShowReadingPaneOnFirstLoad = newLoadFirstMessageOnLogon;
                        serverUpdates.push({
                            propertyName: 'ShowReadingPaneOnFirstLoad',
                            propertyType: 'Boolean',
                            propertyValue: "" + userOptions.ShowReadingPaneOnFirstLoad,
                        });
                    }
                    // Send request to update RP position and ShowReadingPaneOnFirstLoad
                    if (serverUpdates.length) {
                        servicePromises.push(owa_options_core_3.updateUserConfiguration(serverUpdates));
                    }
                    // Deal with the new 'NextSelection'
                    if (showReadingPane && (newNextSelection || userOptions.NextSelection) == 'ReturnToView') {
                        newNextSelection = 'Next';
                    }
                    if (newNextSelection && newNextSelection !== userOptions.NextSelection) {
                        userOptions.NextSelection = newNextSelection;
                        serviceBehavior = void 0;
                        switch (userOptions.NextSelection) {
                            case 'Previous':
                                serviceBehavior = 0 /* OpenPreviousItem */;
                                break;
                            case 'Next':
                                serviceBehavior = 1 /* OpenNextItem */;
                                break;
                            case 'ReturnToView':
                                serviceBehavior = 2 /* ReturnToView */;
                                break;
                        }
                        servicePromises.push(owa_options_core_1.setMailboxMessageConfiguration({
                            AfterMoveOrDeleteBehavior: serviceBehavior,
                        }));
                    }
                    return [4 /*yield*/, Promise.all(servicePromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
exports.saveReadingPaneOptionFull = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveReadingPaneOptionFull')(function saveReadingPaneOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions, optionState = state.optionState;
                    return [4 /*yield*/, saveReadingPaneOption(owa_options_core_2.getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact), userOptions, optionState.nextSelection || userOptions.NextSelection, owa_options_core_2.getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingReadingPane';
exports.saveReadingPaneOptionQuick = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveReadingPaneOptionQuick')(function saveReadingPaneOptionQuick(newReadingPanePosition, state) {
    var readingPanePositionString;
    switch (newReadingPanePosition) {
        case ReadingPanePosition_1.default.Off:
            readingPanePositionString = 'Off';
            break;
        case ReadingPanePosition_1.default.Right:
            readingPanePositionString = 'Right';
            break;
        case ReadingPanePosition_1.default.Bottom:
            readingPanePositionString = 'Bottom';
            break;
        default:
            readingPanePositionString = 'Unknown';
            break;
    }
    owa_analytics_1.logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [readingPanePositionString]);
    saveReadingPaneOption(newReadingPanePosition, state.userOptions);
}));
//# sourceMappingURL=saveReadingPaneOption.js.map

/***/ }),

/***/ 3312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(3313), exports);
tslib_1.__exportStar(__webpack_require__(3316), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var owa_accessibility_1 = __webpack_require__(79);
var ContextualMenu_1 = __webpack_require__(677);
var Button_1 = __webpack_require__(62);
var FocusZone_1 = __webpack_require__(78);
var styles = __webpack_require__(3314);
var classNames = __webpack_require__(343);
var ColorPicker = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPicker, _super);
    function ColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderColorMenuItem = function (item) {
            var color = item.data;
            var inlineStyles = { backgroundColor: color.code };
            if (color.borderColor) {
                inlineStyles.borderColor = color.borderColor;
            }
            var ariaProps = {
                role: owa_accessibility_1.AriaRoles.menuitem,
                label: color.name,
            };
            return (React.createElement(Button_1.Button, tslib_1.__assign({ buttonType: Button_1.ButtonType.normal, "data-is-focusable": true, title: color.name, onClick: function () { return _this.onSelectColor(color); }, key: item.key }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps)),
                React.createElement("div", { className: styles.colorSquare, style: inlineStyles })));
        };
        _this.onSelectColor = function (color) {
            _this.props.onDismissMenu();
            _this.props.onSelectColor(color);
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, onDismissMenu = _a.onDismissMenu, menuTargetElement = _a.menuTargetElement, shouldFocusOnMount = _a.shouldFocusOnMount;
        var pickerStyle = classNames(styles.colorPickerContainer);
        return (React.createElement(ContextualMenu_1.ContextualMenu, { className: pickerStyle, shouldFocusOnMount: shouldFocusOnMount, target: menuTargetElement, directionalHint: 4 /* bottomLeftEdge */, onDismiss: onDismissMenu, arrowDirection: FocusZone_1.FocusZoneDirection.bidirectional, items: this.props.colors.map(function (color) {
                return {
                    key: color.name,
                    name: color.name,
                    onRender: _this.renderColorMenuItem,
                    data: color,
                    className: styles.colorMenuItem,
                };
            }) }));
    };
    return ColorPicker;
}(React.Component));
exports.ColorPicker = ColorPicker;
//# sourceMappingURL=ColorPicker.js.map

/***/ }),

/***/ 3314:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3315);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3315:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3YS20J8OpBDFhBDeCjdvrX{width:192px;overflow:hidden}html[dir] ._3YS20J8OpBDFhBDeCjdvrX{padding:8px;background:\"[theme:white, default:#ffffff]\"}._3YS20J8OpBDFhBDeCjdvrX ul{width:192px;overflow:hidden}._1-8R5_HZul3CLBXRT0KPiI{display:inline-block;width:32px;height:32px}html[dir] ._1-8R5_HZul3CLBXRT0KPiI{background:\"[theme:white, default:#ffffff]\"}._1-8R5_HZul3CLBXRT0KPiI button{min-width:0}html[dir] ._1-8R5_HZul3CLBXRT0KPiI button{padding:0;background:transparent}._1at9R5Os0T5ZLgYzbCLnqG{width:20px;height:20px}html[dir] ._1at9R5Os0T5ZLgYzbCLnqG{margin:4px;border:2px solid transparent}html[dir] ._1at9R5Os0T5ZLgYzbCLnqG:hover,html[dir] body.addFocusOutline ._1at9R5Os0T5ZLgYzbCLnqG:focus{border-color:#e81123}", ""]);

// exports
exports.locals = {
	"colorPickerContainer": "_3YS20J8OpBDFhBDeCjdvrX",
	"colorMenuItem": "_1-8R5_HZul3CLBXRT0KPiI",
	"colorSquare": "_1at9R5Os0T5ZLgYzbCLnqG"
};

/***/ }),

/***/ 3316:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = __webpack_require__(22);
var mobx_1 = __webpack_require__(15);
var textColors = mobx_1.computed(function () { return [
    { name: owa_mail_strings_1.default.lightBlueColor, code: '#51a7f9' },
    { name: owa_mail_strings_1.default.lightGreenColor, code: '#6fc040' },
    { name: owa_mail_strings_1.default.lightYellowColor, code: '#f5d427' },
    { name: owa_mail_strings_1.default.lightOrangeColor, code: '#f3901d' },
    { name: owa_mail_strings_1.default.lightRedColor, code: '#ed5c57' },
    { name: owa_mail_strings_1.default.lightPurpleColor, code: '#b36ae2' },
    { name: owa_mail_strings_1.default.blueColor, code: '#0c64c0' },
    { name: owa_mail_strings_1.default.greenColor, code: '#0c882a' },
    { name: owa_mail_strings_1.default.yellowColor, code: '#dcbe22' },
    { name: owa_mail_strings_1.default.orangeColor, code: '#de6a19' },
    { name: owa_mail_strings_1.default.redColor, code: '#c82613' },
    { name: owa_mail_strings_1.default.purpleColor, code: '#763e9b' },
    { name: owa_mail_strings_1.default.darkBlueColor, code: '#174e86' },
    { name: owa_mail_strings_1.default.darkGreenColor, code: '#0f5c1a' },
    { name: owa_mail_strings_1.default.darkYellowColor, code: '#c3971d' },
    { name: owa_mail_strings_1.default.darkOrangeColor, code: '#be5b17' },
    { name: owa_mail_strings_1.default.darkRedColor, code: '#861106' },
    { name: owa_mail_strings_1.default.darkPurpleColor, code: '#5e327c' },
    { name: owa_mail_strings_1.default.darkerBlueColor, code: '#002451' },
    { name: owa_mail_strings_1.default.darkerGreenColor, code: '#06400c' },
    { name: owa_mail_strings_1.default.darkerYellowColor, code: '#a37519' },
    { name: owa_mail_strings_1.default.darkerOrangeColor, code: '#934511' },
    { name: owa_mail_strings_1.default.darkerRedColor, code: '#570606' },
    { name: owa_mail_strings_1.default.darkerPurpleColor, code: '#3b204d' },
    { name: owa_mail_strings_1.default.whiteColor, code: '#ffffff', borderColor: '#bebebe' },
    { name: owa_mail_strings_1.default.lightGrayColor, code: '#cccccc' },
    { name: owa_mail_strings_1.default.grayColor, code: '#999999' },
    { name: owa_mail_strings_1.default.darkGrayColor, code: '#666666' },
    { name: owa_mail_strings_1.default.darkerGrayColor, code: '#333333' },
    { name: owa_mail_strings_1.default.blackColor, code: '#000000' },
]; });
exports.textColors = textColors;
var blackColors = mobx_1.computed(function () { return [
    { name: owa_mail_strings_1.default.cyanColor, code: '#00ffff' },
    { name: owa_mail_strings_1.default.greenColor, code: '#00ff00' },
    { name: owa_mail_strings_1.default.yellowColor, code: '#ffff00' },
    { name: owa_mail_strings_1.default.orangeColor, code: '#ff8000' },
    { name: owa_mail_strings_1.default.redColor, code: '#ff0000' },
    { name: owa_mail_strings_1.default.magentaColor, code: '#ff00ff' },
    { name: owa_mail_strings_1.default.lightCyanColor, code: '#80ffff' },
    { name: owa_mail_strings_1.default.lightGreenColor, code: '#80ff80' },
    { name: owa_mail_strings_1.default.lightYellowColor, code: '#ffff80' },
    { name: owa_mail_strings_1.default.lightOrangeColor, code: '#ffc080' },
    { name: owa_mail_strings_1.default.lightRedColor, code: '#ff8080' },
    { name: owa_mail_strings_1.default.lightMagentaColor, code: '#ff80ff' },
    { name: owa_mail_strings_1.default.whiteColor, code: '#ffffff', borderColor: '#bebebe' },
    { name: owa_mail_strings_1.default.lightGrayColor, code: '#cccccc' },
    { name: owa_mail_strings_1.default.grayColor, code: '#999999' },
    { name: owa_mail_strings_1.default.darkGrayColor, code: '#666666' },
    { name: owa_mail_strings_1.default.darkerGrayColor, code: '#333333' },
    { name: owa_mail_strings_1.default.blackColor, code: '#000000' },
]; });
exports.blackColors = blackColors;
//# sourceMappingURL=Colors.js.map

/***/ }),

/***/ 3333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Moves an item in an array located at fromIndex to the position before the toIndex
 * @param arr the array with the element to be moved
 * @param fromIndex item at this index will be moved
 * @param toIndex item will be inserted before this index
 */
function moveDragAndDroppableItem(arr, fromIndex, toIndex) {
    if (fromIndex == toIndex) {
        return;
    }
    // Validate the indices
    if (fromIndex == -1 || toIndex == -1) {
        return;
    }
    // If moving an element down the list, decrement the toIndex since the splice will shift all the elements up
    if (fromIndex < toIndex) {
        toIndex--;
    }
    var itemToMove = arr.splice(fromIndex, 1)[0];
    arr.splice(toIndex, 0, itemToMove);
}
exports.default = moveDragAndDroppableItem;
//# sourceMappingURL=moveDragAndDroppableItem.js.map

/***/ }),

/***/ 3366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_orchestration_1 = __webpack_require__(2794);
var OptionsFull_1 = __webpack_require__(5285);
var owa_options_store_1 = __webpack_require__(2641);
function mountAndShowFullOptions(category, subcategory, option) {
    var wasPreviouslyShown = owa_options_store_1.getStore().isFullOptionsShown;
    owa_options_orchestration_1.showFullOptions(category, subcategory, option);
    if (!wasPreviouslyShown) {
        OptionsFull_1.mountOptionsFullPopup();
    }
}
exports.default = mountAndShowFullOptions;
//# sourceMappingURL=mountAndShowFullOptions.js.map

/***/ }),

/***/ 3367:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4962);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3368:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3369);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3369:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._2RA-icrIYrjMQ9qjz9J7RK{background-position:-45px 0}html[dir] ._2cUkebfx4zNtmoG8SC2Un5,html[dir] ._2RA-icrIYrjMQ9qjz9J7RK{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._2cUkebfx4zNtmoG8SC2Un5{background-position:-225px 0}html[dir] .PWWHOW4cyalBBX20DDeS-{background-position:0 -45px}html[dir] ._1wYRi12tDqpW-njVjXzb-,html[dir] .PWWHOW4cyalBBX20DDeS-{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._1wYRi12tDqpW-njVjXzb-{background-position:-45px -45px}html[dir] ._2JGMYidJnP44XqFMTTpCUT{background-position:-90px 0}html[dir] ._2JGMYidJnP44XqFMTTpCUT,html[dir] .MBYv0mdwONoICEvULJKT7{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] .MBYv0mdwONoICEvULJKT7{background-position:-90px -45px}html[dir] ._1W7VX1oOx0qCr-hSGP5pha{background-position:0 -90px}html[dir] ._1VGXrjYEeCDYqAc7CSNjvs,html[dir] ._1W7VX1oOx0qCr-hSGP5pha{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._1VGXrjYEeCDYqAc7CSNjvs{background-position:-45px -90px}html[dir] ._1_pqPZSNdXvcDWhIkkVEpC{background-position:-90px -90px}html[dir] ._1_pqPZSNdXvcDWhIkkVEpC,html[dir] ._3GURbSkZ2wpisaMvNdZLmI{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._3GURbSkZ2wpisaMvNdZLmI{background-position:-135px 0}html[dir] ._16UdDkDoISEDgz9xhhb45{background-position:-135px -45px}html[dir] ._2f_Hv7fhQMDpaNt_m46y_W,html[dir] ._16UdDkDoISEDgz9xhhb45{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._2f_Hv7fhQMDpaNt_m46y_W{background-position:-135px -90px}html[dir] ._2FtxdEZKlIZcGtt1ihhNTh{background-position:0 -135px}html[dir] ._2FtxdEZKlIZcGtt1ihhNTh,html[dir] ._2IkWz7_sYsLYWfoqd62OKi{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._2IkWz7_sYsLYWfoqd62OKi{background-position:-45px -135px}html[dir] ._1AMgSCKYctvqbYmUkYoraC{background-position:-90px -135px}html[dir] ._1AMgSCKYctvqbYmUkYoraC,html[dir] ._2GXO_UKFgZ_qj0bnUvnxrK{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._2GXO_UKFgZ_qj0bnUvnxrK{background-position:-135px -135px}html[dir] ._2OYZBQI0Hl6IIWoONMHQ_-{background-position:-180px 0}html[dir] ._2OYZBQI0Hl6IIWoONMHQ_-,html[dir] .mXpnmg07AjcewRoHdIM6d{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] .mXpnmg07AjcewRoHdIM6d{background-position:-180px -45px}html[dir] ._3OBpaoBns9aKzNwz0GafjF{background-position:-180px -90px}html[dir] ._1tLMMyStlQX2_f9s7mMLzJ,html[dir] ._3OBpaoBns9aKzNwz0GafjF{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._1tLMMyStlQX2_f9s7mMLzJ{background-position:-180px -135px}html[dir] .vhGDFpLsGrOPbz1BDoSV-{background-position:0 -180px}html[dir] ._2RVksnrEjncIUejZUirf_D,html[dir] .vhGDFpLsGrOPbz1BDoSV-{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._2RVksnrEjncIUejZUirf_D{background-position:-45px -180px}html[dir] ._2_UZm8at48wlKpZbB8rGNW{background-position:-90px -180px}html[dir] ._2_UZm8at48wlKpZbB8rGNW,html[dir] ._24dwzsDqrs7Q5NCGS8fnff{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._24dwzsDqrs7Q5NCGS8fnff{background-position:-135px -180px}html[dir] ._3Q0iAlkkPvmvnTZjmcLk3t{background-position:-180px -180px}html[dir] ._1Go9H1iTf69ydThI2l0E1h,html[dir] ._3Q0iAlkkPvmvnTZjmcLk3t{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._1Go9H1iTf69ydThI2l0E1h{background-position:0 0}html[dir] ._2mkLK8GXu64nQsmDRuCKza{background-position:-225px -45px}html[dir] ._2mkLK8GXu64nQsmDRuCKza,html[dir] ._3cWzfy-NgqeT4d-kuLlYsK{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._3cWzfy-NgqeT4d-kuLlYsK{background-position:-225px -90px}html[dir] ._1AxX4KhmAYThwuxIpz_nVo{background-position:-225px -135px}html[dir] ._1AxX4KhmAYThwuxIpz_nVo,html[dir] ._33kPT133vpgrzn1D8fd1NS{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._33kPT133vpgrzn1D8fd1NS{background-position:-225px -180px}html[dir] ._2jpdmmz5cib9iWJ514q3BJ{background-position:0 -225px}html[dir] ._1Y-Q7TVkRIjKZdDofKPeRl,html[dir] ._2jpdmmz5cib9iWJ514q3BJ{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._1Y-Q7TVkRIjKZdDofKPeRl{background-position:-45px -225px}html[dir] ._1mu_Zj3kmGvuSFgtAn-2Qx{background-position:-90px -225px}html[dir] ._1mu_Zj3kmGvuSFgtAn-2Qx,html[dir] ._3klOkrmTw_-cEF0Z9Po78y{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._3klOkrmTw_-cEF0Z9Po78y{background-position:-135px -225px}html[dir] ._1xX0nbuxr9iNQv0KRlLm0C{background-position:-180px -225px}html[dir] ._1xX0nbuxr9iNQv0KRlLm0C,html[dir] ._3L8GNNcabjU6mQHn8mxNZ7{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._3L8GNNcabjU6mQHn8mxNZ7{background-position:-225px -225px}html[dir] ._1ZRDkudaBL03E684HJhebf{background-position:-270px 0}html[dir] ._1ZRDkudaBL03E684HJhebf,html[dir] ._3ZEpkKeRI6yL1rjsPPSXEJ{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._3ZEpkKeRI6yL1rjsPPSXEJ{background-position:-270px -45px}html[dir] ._2nzajiMDAVK7XtENuu1Kkp{background-position:-270px -90px}html[dir] ._2nzajiMDAVK7XtENuu1Kkp,html[dir] ._2SINVI-urq35YAt29LTphE{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._2SINVI-urq35YAt29LTphE{background-position:-270px -135px}html[dir] ._2exC4iQy3ABTUjVKg6KGGV{background-position:-270px -180px}html[dir] ._2exC4iQy3ABTUjVKg6KGGV,html[dir] ._2HyEPB5zgGrsIQAYV-i2VO{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._2HyEPB5zgGrsIQAYV-i2VO{background-position:-270px -225px}html[dir] .T8nrxYEc5XRGJFYWtN3Vs{background-position:0 -270px}html[dir] ._1kHoNWIGuT2DwLP25mz6ft,html[dir] .T8nrxYEc5XRGJFYWtN3Vs{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._1kHoNWIGuT2DwLP25mz6ft{background-position:-45px -270px}html[dir] ._1QRuK2H-XPoMXQ6vYcKmzB{background-position:-90px -270px}html[dir] ._1-vbeuXuxZG1RTzpeeWWyq,html[dir] ._1QRuK2H-XPoMXQ6vYcKmzB{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._1-vbeuXuxZG1RTzpeeWWyq{background-position:-135px -270px}html[dir] .HeVhoUwJ8K5oLSf4oMLfi{background-position:-180px -270px}html[dir] ._2O-OiWQLbZNkMJbjadOOV3,html[dir] .HeVhoUwJ8K5oLSf4oMLfi{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._2O-OiWQLbZNkMJbjadOOV3{background-position:-225px -270px}html[dir] ._2oCi95pOQs9C9-a2IymuYC{background-position:-270px -270px}html[dir] ._1R9vut3pI2AcDMj332GexH,html[dir] ._2oCi95pOQs9C9-a2IymuYC{background-image:url(" + __webpack_require__(2599) + ");width:44px;height:44px}html[dir] ._1R9vut3pI2AcDMj332GexH{background-position:-315px 0}", ""]);

// exports
exports.locals = {
	"theme-icon-angular": "_2RA-icrIYrjMQ9qjz9J7RK",
	"theme-icon-balloons": "_2cUkebfx4zNtmoG8SC2Un5",
	"theme-icon-base": "PWWHOW4cyalBBX20DDeS-",
	"theme-icon-beach": "_1wYRi12tDqpW-njVjXzb-",
	"theme-icon-black": "_2JGMYidJnP44XqFMTTpCUT",
	"theme-icon-blueberry": "MBYv0mdwONoICEvULJKT7",
	"theme-icon-blueprint": "_1W7VX1oOx0qCr-hSGP5pha",
	"theme-icon-bricks": "_1VGXrjYEeCDYqAc7CSNjvs",
	"theme-icon-cats": "_1_pqPZSNdXvcDWhIkkVEpC",
	"theme-icon-chevron": "_3GURbSkZ2wpisaMvNdZLmI",
	"theme-icon-circuit": "_16UdDkDoISEDgz9xhhb45",
	"theme-icon-comic": "_2f_Hv7fhQMDpaNt_m46y_W",
	"theme-icon-contrast": "_2FtxdEZKlIZcGtt1ihhNTh",
	"theme-icon-cordovan": "_2IkWz7_sYsLYWfoqd62OKi",
	"theme-icon-crayon": "_1AMgSCKYctvqbYmUkYoraC",
	"theme-icon-cubes": "_2GXO_UKFgZ_qj0bnUvnxrK",
	"theme-icon-cubism": "_2OYZBQI0Hl6IIWoONMHQ_-",
	"theme-icon-darkcordovan": "mXpnmg07AjcewRoHdIM6d",
	"theme-icon-darkorange": "_3OBpaoBns9aKzNwz0GafjF",
	"theme-icon-diamonds": "_1tLMMyStlQX2_f9s7mMLzJ",
	"theme-icon-far": "vhGDFpLsGrOPbz1BDoSV-",
	"theme-icon-grape": "_2RVksnrEjncIUejZUirf_D",
	"theme-icon-jelly": "_2_UZm8at48wlKpZbB8rGNW",
	"theme-icon-lightblue": "_24dwzsDqrs7Q5NCGS8fnff",
	"theme-icon-lightgreen": "_3Q0iAlkkPvmvnTZjmcLk3t",
	"theme-icon-lite": "_1Go9H1iTf69ydThI2l0E1h",
	"theme-icon-mediumdarkblue": "_2mkLK8GXu64nQsmDRuCKza",
	"theme-icon-minimal": "_3cWzfy-NgqeT4d-kuLlYsK",
	"theme-icon-modern": "_1AxX4KhmAYThwuxIpz_nVo",
	"theme-icon-mountain": "_33kPT133vpgrzn1D8fd1NS",
	"theme-icon-orange": "_2jpdmmz5cib9iWJ514q3BJ",
	"theme-icon-paint": "_1Y-Q7TVkRIjKZdDofKPeRl",
	"theme-icon-pink": "_1mu_Zj3kmGvuSFgtAn-2Qx",
	"theme-icon-pixel": "_3klOkrmTw_-cEF0Z9Po78y",
	"theme-icon-polka": "_1xX0nbuxr9iNQv0KRlLm0C",
	"theme-icon-pomegranate": "_3L8GNNcabjU6mQHn8mxNZ7",
	"theme-icon-primary": "_1ZRDkudaBL03E684HJhebf",
	"theme-icon-raspberry": "_3ZEpkKeRI6yL1rjsPPSXEJ",
	"theme-icon-robot": "_2nzajiMDAVK7XtENuu1Kkp",
	"theme-icon-simple": "_2SINVI-urq35YAt29LTphE",
	"theme-icon-spectrum": "_2exC4iQy3ABTUjVKg6KGGV",
	"theme-icon-strawberry": "_2HyEPB5zgGrsIQAYV-i2VO",
	"theme-icon-super": "T8nrxYEc5XRGJFYWtN3Vs",
	"theme-icon-teagarden": "_1kHoNWIGuT2DwLP25mz6ft",
	"theme-icon-teal": "_1QRuK2H-XPoMXQ6vYcKmzB",
	"theme-icon-watermelon": "_1-vbeuXuxZG1RTzpeeWWyq",
	"theme-icon-whale": "HeVhoUwJ8K5oLSf4oMLfi",
	"theme-icon-whimsical": "_2O-OiWQLbZNkMJbjadOOV3",
	"theme-icon-wntrlnd": "_2oCi95pOQs9C9-a2IymuYC",
	"theme-icon-wrld": "_1R9vut3pI2AcDMj332GexH"
};

/***/ }),

/***/ 3370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getAllThemeIds_1 = __webpack_require__(4963);
// These won't change dynamically during a session
var availableThemeIds;
exports.ThemeIdsToFilter = [];
function getAvailableThemeIds() {
    return (availableThemeIds ||
        (availableThemeIds = getAllThemeIds_1.default().filter(function (themeId) { return exports.ThemeIdsToFilter.indexOf(themeId) === -1; })));
}
exports.default = getAvailableThemeIds;
//# sourceMappingURL=getAvailableThemeIds.js.map

/***/ }),

/***/ 3371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SkypeNotificationOption_1 = __webpack_require__(3372);
exports.SkypeNotificationOption = SkypeNotificationOption_1.default;
var SkypeNotificationType_1 = __webpack_require__(3060);
exports.SkypeNotificationType = SkypeNotificationType_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardSkypeOptions_1 = __webpack_require__(3373);
var saveSkypeOptions_1 = __webpack_require__(3374);
var isSkypeOptionDirty_1 = __webpack_require__(3375);
var SkypeNotificationFull_1 = __webpack_require__(3376);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var React = __webpack_require__(3);
var SkypeNotificationOption = {
    key: 'skypeNotifications',
    titleStringKey: 'optionSubcategory_notifications',
    searchTermsStringKey: 'optionSubcategory_notifications',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SkypeNotificationFull_1.default, null); },
        isDirty: isSkypeOptionDirty_1.default,
        onSave: saveSkypeOptions_1.default,
        onDiscard: discardSkypeOptions_1.default,
    },
    isHidden: function () { return !owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-skypeConsumer'); },
};
exports.default = SkypeNotificationOption;
//# sourceMappingURL=SkypeNotificationOption.js.map

/***/ }),

/***/ 3373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2728);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('discardSkypeOptions', function discardSkypeOptions() {
    var optionState = store_1.default();
    optionState.imNotification = null;
    optionState.callNotification = null;
});
//# sourceMappingURL=discardSkypeOptions.js.map

/***/ }),

/***/ 3374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(2728);
var owa_options_core_1 = __webpack_require__(1736);
var legacy_1 = __webpack_require__(1);
var owa_outlook_service_options_1 = __webpack_require__(2110);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default(); },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SkypeNotifications);
    },
})(legacy_1.action('saveSkypeOptions')(function saveSkypeOptions(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.skypeMessageNotification = owa_options_core_1.getFallbackValueIfNull(optionState.imNotification, userOptions.skypeMessageNotification);
                    userOptions.skypeCallingNotification = owa_options_core_1.getFallbackValueIfNull(optionState.callNotification, userOptions.skypeCallingNotification);
                    return [4 /*yield*/, owa_outlook_service_options_1.lazyCreateOrUpdateOptionsForFeature.importAndExecute(owa_outlook_service_options_1.OwsOptionsFeatureType.SkypeNotifications, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSkypeOptions.js.map

/***/ }),

/***/ 3375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2728);
var owa_options_core_1 = __webpack_require__(1736);
var legacy_1 = __webpack_require__(1);
var owa_outlook_service_options_1 = __webpack_require__(2110);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default(); },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SkypeNotifications);
    },
})(function isSkypeOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (isOptionDirty(optionState.imNotification, userOptions.skypeMessageNotification) ||
        isOptionDirty(optionState.callNotification, userOptions.skypeCallingNotification));
});
function isOptionDirty(optionState, userOption) {
    return owa_options_core_1.getFallbackValueIfNull(optionState, userOption) !== userOption;
}
//# sourceMappingURL=isSkypeOptionDirty.js.map

/***/ }),

/***/ 3376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectSkypeNotificationOption_1 = __webpack_require__(3377);
var SkypeNotificationType_1 = __webpack_require__(3060);
var store_1 = __webpack_require__(2728);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_outlook_service_options_1 = __webpack_require__(2110);
var SkypeNotificationFull = /** @class */ (function (_super) {
    tslib_1.__extends(SkypeNotificationFull, _super);
    function SkypeNotificationFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (option, isImNotification) {
            selectSkypeNotificationOption_1.default(_this.getNotificationType(option.key), isImNotification);
        };
        return _this;
    }
    SkypeNotificationFull.prototype.render = function () {
        var _this = this;
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var imNotificationType = owa_options_core_1.getFallbackValueIfNull(optionStore.imNotification, userOptions.skypeMessageNotification).toString();
        var callNotificationType = owa_options_core_1.getFallbackValueIfNull(optionStore.callNotification, userOptions.skypeCallingNotification).toString();
        var choices = [
            {
                key: SkypeNotificationType_1.default.ToastAndSound.toString(),
                text: owa_options_strings_1.default.options_skype_NotifyAll,
            },
            {
                key: SkypeNotificationType_1.default.ToastOnly.toString(),
                text: owa_options_strings_1.default.options_skype_NotifyToast,
            },
            {
                key: SkypeNotificationType_1.default.None.toString(),
                text: owa_options_strings_1.default.options_skype_ImNotifyNone,
            },
        ];
        return (React.createElement("div", null,
            React.createElement(ChoiceGroup_1.ChoiceGroup, { label: owa_options_strings_1.default.options_skype_ImNotifityTitle, selectedKey: imNotificationType, options: choices, onChange: function (ev, option) {
                    return _this.onChange(option, true /* isImNotification*/);
                } }),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { label: owa_options_strings_1.default.options_skype_CallNotifityTitle, selectedKey: callNotificationType, options: choices, onChange: function (ev, option) {
                    return _this.onChange(option, false /* isImNotification*/);
                } })));
    };
    SkypeNotificationFull.prototype.getNotificationType = function (num) {
        switch (num) {
            case '1':
                return SkypeNotificationType_1.default.ToastAndSound;
            case '2':
                return SkypeNotificationType_1.default.ToastOnly;
            default:
                return SkypeNotificationType_1.default.None;
        }
    };
    SkypeNotificationFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default(); },
            userOptions: function () {
                return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SkypeNotifications);
            },
        })
    ], SkypeNotificationFull);
    return SkypeNotificationFull;
}(React.Component));
exports.default = SkypeNotificationFull;
//# sourceMappingURL=SkypeNotificationFull.js.map

/***/ }),

/***/ 3377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2728);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('selectSkypeNotificationOption', function selectSkypeNotificationOption(notificationType, isImNotification) {
    var optionState = store_1.default();
    if (isImNotification) {
        optionState.imNotification = notificationType;
    }
    else {
        optionState.callNotification = notificationType;
    }
});
//# sourceMappingURL=selectSkypeNotificationOption.js.map

/***/ }),

/***/ 3378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var category_1 = __webpack_require__(4977);
exports.MailOptions = category_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('calendarConfiguration', {
    mailboxJunkEmailConfiguration: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
function getMailboxJunkEmailConfigurationOperation(options) {
    return ServiceRequest_1.makeServiceRequest("GetMailboxJunkEmailConfiguration", {}, options);
}
exports.default = getMailboxJunkEmailConfigurationOperation;


/***/ }),

/***/ 3381:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3382);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3382:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._1WGiRHsrqJct7isGitJMRO{background-position:-19px 0}html[dir] ._1WGiRHsrqJct7isGitJMRO,html[dir] ._1xpBWgKBCrfSHEeH411ub_{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._1xpBWgKBCrfSHEeH411ub_{background-position:0 -57px}html[dir] ._23eTX942kzuxdkRg6w1_u3{background-position:0 -19px}html[dir] ._2bEvBymFCLxGhYiD-fEw9H,html[dir] ._23eTX942kzuxdkRg6w1_u3{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._2bEvBymFCLxGhYiD-fEw9H{background-position:-19px -19px}html[dir] ._2T-rzFHc4dJkOe78R0GB3b{background-position:-38px 0}html[dir] ._1Ft0K9YS3yDDTfdeROUG5r,html[dir] ._2T-rzFHc4dJkOe78R0GB3b{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._1Ft0K9YS3yDDTfdeROUG5r{background-position:-38px -19px}html[dir] ._3hu58VLCg7OrBz0QYQC3jp{background-position:0 -38px}html[dir] ._2wq0q6_8ZCj4c9mh2ztQl7,html[dir] ._3hu58VLCg7OrBz0QYQC3jp{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._2wq0q6_8ZCj4c9mh2ztQl7{background-position:-19px -38px}html[dir] .T4PRXD7NiohmXvW65ua-F{background-position:-38px -38px}html[dir] .E8bS1O_h4XCWhwlJ94DyE,html[dir] .T4PRXD7NiohmXvW65ua-F{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] .E8bS1O_h4XCWhwlJ94DyE{background-position:-57px 0}html[dir] ._1YMdp49-O0w-LtDaSidfCl{background-position:-57px -19px}html[dir] ._1YMdp49-O0w-LtDaSidfCl,html[dir] .iXMSJv8GBHlDTYV4IXjjg{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] .iXMSJv8GBHlDTYV4IXjjg{background-position:-57px -38px}html[dir] ._3l_u_39JBJZn0yMUZEtfKr{background-position:0 0}html[dir] ._3l_u_39JBJZn0yMUZEtfKr,html[dir] ._3Wb58Yk0YM8D8hhKlH5r_Z{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._3Wb58Yk0YM8D8hhKlH5r_Z{background-position:-19px -57px}html[dir] .xI_v3i1W9mKunUGFpRuOS{background-position:-38px -57px}html[dir] ._1VrX-SPmSJLyjQHwxJfML-,html[dir] .xI_v3i1W9mKunUGFpRuOS{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._1VrX-SPmSJLyjQHwxJfML-{background-position:-57px -57px}html[dir] ._2EGhGef3clbFEVYelAgMfM{background-position:-76px 0}html[dir] ._2EGhGef3clbFEVYelAgMfM,html[dir] ._3C2lfDl_enJg13BCeW7mHi{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._3C2lfDl_enJg13BCeW7mHi{background-position:-76px -19px}html[dir] ._3lnVcJEBq3d0cXYJ7DwEm8{background-position:-76px -38px}html[dir] ._2rDYtLOa9vxj6BCZ58oVWh,html[dir] ._3lnVcJEBq3d0cXYJ7DwEm8{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._2rDYtLOa9vxj6BCZ58oVWh{background-position:-76px -57px}html[dir] ._1BtN7DH2fJDBDJyIup8s6p{background-position:0 -76px}html[dir] ._1BtN7DH2fJDBDJyIup8s6p,html[dir] ._13yYALmbntuqA6JhRht27b{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] ._13yYALmbntuqA6JhRht27b{background-position:-19px -76px}html[dir] ._1l4rgimUFMhzMiNc72gule{background-position:-38px -76px}html[dir] ._1l4rgimUFMhzMiNc72gule,html[dir] .JFGZ7zjri2AsL5cbl8FnG{background-image:url(" + __webpack_require__(2614) + ");width:18px;height:18px}html[dir] .JFGZ7zjri2AsL5cbl8FnG{background-position:-57px -76px}html[dir] ._2pvMFOMAtG7SkLiTvLM2vC{background-image:url(" + __webpack_require__(2614) + ");background-position:-76px -76px;width:18px;height:18px}", ""]);

// exports
exports.locals = {
	"ribbon-icon-aligncenter": "_1WGiRHsrqJct7isGitJMRO",
	"ribbon-icon-alignleft": "_1xpBWgKBCrfSHEeH411ub_",
	"ribbon-icon-alignright": "_23eTX942kzuxdkRg6w1_u3",
	"ribbon-icon-alttext": "_2bEvBymFCLxGhYiD-fEw9H",
	"ribbon-icon-backcolor": "_2T-rzFHc4dJkOe78R0GB3b",
	"ribbon-icon-bold": "_1Ft0K9YS3yDDTfdeROUG5r",
	"ribbon-icon-bullets": "_3hu58VLCg7OrBz0QYQC3jp",
	"ribbon-icon-createlink": "_2wq0q6_8ZCj4c9mh2ztQl7",
	"ribbon-icon-fontname": "T4PRXD7NiohmXvW65ua-F",
	"ribbon-icon-fontsize": "E8bS1O_h4XCWhwlJ94DyE",
	"ribbon-icon-indent": "_1YMdp49-O0w-LtDaSidfCl",
	"ribbon-icon-italic": "iXMSJv8GBHlDTYV4IXjjg",
	"ribbon-icon-ltr": "_3l_u_39JBJZn0yMUZEtfKr",
	"ribbon-icon-numbering": "_3Wb58Yk0YM8D8hhKlH5r_Z",
	"ribbon-icon-outdent": "xI_v3i1W9mKunUGFpRuOS",
	"ribbon-icon-redo": "_1VrX-SPmSJLyjQHwxJfML-",
	"ribbon-icon-removeformat": "_2EGhGef3clbFEVYelAgMfM",
	"ribbon-icon-rtl": "_3C2lfDl_enJg13BCeW7mHi",
	"ribbon-icon-strikethrough": "_3lnVcJEBq3d0cXYJ7DwEm8",
	"ribbon-icon-subscript": "_2rDYtLOa9vxj6BCZ58oVWh",
	"ribbon-icon-superscript": "_1BtN7DH2fJDBDJyIup8s6p",
	"ribbon-icon-textcolor": "_13yYALmbntuqA6JhRht27b",
	"ribbon-icon-underline": "_1l4rgimUFMhzMiNc72gule",
	"ribbon-icon-undo": "JFGZ7zjri2AsL5cbl8FnG",
	"ribbon-icon-unlink": "_2pvMFOMAtG7SkLiTvLM2vC"
};

/***/ }),

/***/ 3383:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5149);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var initializeInboxRuleEdit_1 = __webpack_require__(3076);
var folderTypeConversionUtil_1 = __webpack_require__(3177);
var getActionClauseTypeOptions_1 = __webpack_require__(2795);
var getConditionalExceptionClauseTypeOptions_1 = __webpack_require__(2796);
var mapPeopleIdentityToReadWriteRecipientWellViewState_1 = __webpack_require__(3385);
var setSelectedFolderId_1 = __webpack_require__(3386);
var store_1 = __webpack_require__(2603);
var addNewClause_1 = __webpack_require__(2940);
var legacy_1 = __webpack_require__(1);
var KB_TO_B = 1024;
/**
 * Maps an inbox rule's properties to inbox rule clauses to populated the edit page
 * @param inboxRule the rule whose properties will be added to the edit store
 */
exports.default = legacy_1.action('mapInboxRuleToInboxRuleClauses')(legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesEditState; },
})(function mapInboxRuleToInboxRuleClauses(inboxRule, state) {
    // map conditional clauses
    var optionState = state.optionState;
    var clauseSection;
    var conditionalExceptionClauseTypes = getConditionalExceptionClauseTypeOptions_1.default();
    var actionClauseTypes = getActionClauseTypeOptions_1.default();
    optionState.ruleName = inboxRule.Name;
    optionState.ruleId = inboxRule.Identity ? inboxRule.Identity.RawIdentity : null;
    optionState.ignoreSubsequentRules = inboxRule.StopProcessingRules;
    clauseSection = 'conditional';
    for (var _i = 0, conditionalExceptionClauseTypes_1 = conditionalExceptionClauseTypes; _i < conditionalExceptionClauseTypes_1.length; _i++) {
        var conditionalClause = conditionalExceptionClauseTypes_1[_i];
        var clauseValueToAdd = void 0;
        switch (conditionalClause) {
            case 'from':
                if (inboxRule.From) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.From);
                }
                break;
            case 'to':
                if (inboxRule.SentTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.SentTo);
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.MyNameInToOrCcBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.SentOnlyToMe) {
                    clauseValueToAdd = true;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.MyNameInToBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.MyNameInCcBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.MyNameNotInToBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.SubjectContainsWords) {
                    clauseValueToAdd = inboxRule.SubjectContainsWords.slice(0);
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.SubjectOrBodyContainsWords) {
                    clauseValueToAdd = inboxRule.SubjectOrBodyContainsWords.slice(0);
                }
                break;
            case 'inTheBody':
                if (inboxRule.BodyContainsWords) {
                    clauseValueToAdd = inboxRule.BodyContainsWords.slice(0);
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.FromAddressContainsWords) {
                    clauseValueToAdd = inboxRule.FromAddressContainsWords.slice(0);
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.RecipientAddressContainsWords) {
                    clauseValueToAdd = inboxRule.RecipientAddressContainsWords.slice(0);
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.HeaderContainsWords) {
                    clauseValueToAdd = inboxRule.HeaderContainsWords.slice(0);
                }
                break;
            case 'withImportance':
                if (inboxRule.WithImportance !== 'NullImportance') {
                    clauseValueToAdd = inboxRule.WithImportance;
                }
                break;
            case 'sensitivity':
                if (inboxRule.WithSensitivity !== 'NullSensitivity') {
                    clauseValueToAdd = inboxRule.WithSensitivity;
                }
                break;
            case 'flag':
                if (inboxRule.RequestedAction !== 'NullInboxRuleMessageFlag') {
                    clauseValueToAdd = inboxRule.RequestedAction;
                }
                break;
            case 'type':
                if (inboxRule.MessageTypeMatches != 'NullInboxRuleMessageType') {
                    clauseValueToAdd = inboxRule.MessageTypeMatches;
                }
                break;
            case 'attachment':
                if (inboxRule.HasAttachment) {
                    clauseValueToAdd = inboxRule.HasAttachment;
                }
                break;
            case 'atLeast':
                if (inboxRule.WithinSizeRangeMinimum) {
                    clauseValueToAdd = inboxRule.WithinSizeRangeMinimum / KB_TO_B;
                }
                break;
            case 'atMost':
                if (inboxRule.WithinSizeRangeMaximum) {
                    clauseValueToAdd = inboxRule.WithinSizeRangeMaximum / KB_TO_B;
                }
                else if (inboxRule.WithinSizeRangeMinimum) {
                    // If user has minimum value but didn't input an at most value, set at most value to maximum (999,999 kb)
                    clauseValueToAdd = 999999;
                }
                break;
            case 'before':
                if (inboxRule.ReceivedBeforeDate) {
                    clauseValueToAdd = inboxRule.ReceivedBeforeDate;
                }
                break;
            case 'after':
                if (inboxRule.ReceivedAfterDate) {
                    clauseValueToAdd = inboxRule.ReceivedAfterDate;
                }
                break;
        }
        // only add clauses to the edit page that have corresponding values on the inbox rule
        if (clauseValueToAdd) {
            addNewClause_1.default(clauseSection, conditionalClause, clauseValueToAdd);
        }
    }
    clauseSection = 'action';
    for (var _a = 0, actionClauseTypes_1 = actionClauseTypes; _a < actionClauseTypes_1.length; _a++) {
        var actionClause = actionClauseTypes_1[_a];
        var clauseValueToAdd = void 0;
        switch (actionClause) {
            case 'moveTo':
                if (inboxRule.MoveToFolder) {
                    var ruleFolderId = inboxRule.MoveToFolder.RawIdentity;
                    // check if the inbox rule folder id is a raw identity or folder ID
                    var ruleFolder = ruleFolderId.indexOf(':\\') > -1
                        ? folderTypeConversionUtil_1.getFolderFromRawId(ruleFolderId)
                        : folderTypeConversionUtil_1.getFolderFromFolderId(ruleFolderId);
                    if (ruleFolder) {
                        setSelectedFolderId_1.default(ruleFolder.folderId);
                    }
                    clauseValueToAdd = ruleFolder;
                }
                break;
            case 'copyTo':
                if (inboxRule.CopyToFolder) {
                    var ruleFolderId = inboxRule.CopyToFolder.RawIdentity;
                    // check if the inbox rule folder id is a raw identity or folder ID
                    var ruleFolder = ruleFolderId.indexOf(':\\') > -1
                        ? folderTypeConversionUtil_1.getFolderFromRawId(ruleFolderId)
                        : folderTypeConversionUtil_1.getFolderFromFolderId(ruleFolderId);
                    if (ruleFolder) {
                        setSelectedFolderId_1.default(ruleFolder.folderId);
                    }
                    clauseValueToAdd = ruleFolder;
                }
                break;
            case 'delete':
                if (inboxRule.DeleteMessage) {
                    clauseValueToAdd = inboxRule.DeleteMessage;
                }
                break;
            case 'pin':
                if (inboxRule.PinMessage) {
                    clauseValueToAdd = inboxRule.PinMessage;
                }
                break;
            case 'read':
                if (inboxRule.MarkAsRead) {
                    clauseValueToAdd = inboxRule.MarkAsRead;
                }
                break;
            case 'markImportance':
                if (inboxRule.MarkImportance !== 'NullImportance') {
                    clauseValueToAdd = inboxRule.MarkImportance;
                }
                break;
            case 'forwardTo':
                if (inboxRule.ForwardTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.ForwardTo);
                }
                break;
            case 'forwardAsAttachmentTo':
                if (inboxRule.ForwardAsAttachmentTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.ForwardAsAttachmentTo);
                }
                break;
            case 'redirectTo':
                if (inboxRule.RedirectTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.RedirectTo);
                }
                break;
        }
        // only add clauses to the edit page that have corresponding values on the inbox rule
        if (clauseValueToAdd) {
            addNewClause_1.default(clauseSection, actionClause, clauseValueToAdd);
        }
    }
    clauseSection = 'exception';
    for (var _b = 0, conditionalExceptionClauseTypes_2 = conditionalExceptionClauseTypes; _b < conditionalExceptionClauseTypes_2.length; _b++) {
        var exceptionClause = conditionalExceptionClauseTypes_2[_b];
        var clauseValueToAdd = void 0;
        switch (exceptionClause) {
            case 'from':
                if (inboxRule.ExceptIfFrom) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.ExceptIfFrom);
                }
                break;
            case 'to':
                if (inboxRule.ExceptIfSentTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.ExceptIfSentTo);
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.ExceptIfMyNameInToOrCcBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.ExceptIfSentOnlyToMe) {
                    clauseValueToAdd = true;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.ExceptIfMyNameInToBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.ExceptIfMyNameInCcBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.ExceptIfMyNameNotInToBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.ExceptIfSubjectContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfSubjectContainsWords.slice(0);
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.ExceptIfSubjectOrBodyContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfSubjectOrBodyContainsWords.slice(0);
                }
                break;
            case 'inTheBody':
                if (inboxRule.ExceptIfBodyContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfBodyContainsWords.slice(0);
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.ExceptIfFromAddressContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfFromAddressContainsWords.slice(0);
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.ExceptIfRecipientAddressContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfRecipientAddressContainsWords.slice(0);
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.ExceptIfHeaderContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfHeaderContainsWords.slice(0);
                }
                break;
            case 'withImportance':
                if (inboxRule.ExceptIfWithImportance !== 'NullImportance') {
                    clauseValueToAdd = inboxRule.ExceptIfWithImportance;
                }
                break;
            case 'sensitivity':
                if (inboxRule.ExceptIfWithSensitivity !== 'NullSensitivity') {
                    clauseValueToAdd = inboxRule.ExceptIfWithSensitivity;
                }
                break;
            case 'flag':
                if (inboxRule.ExceptIfFlaggedForAction !== 'NullInboxRuleMessageFlag') {
                    clauseValueToAdd = inboxRule.ExceptIfFlaggedForAction;
                }
                break;
            case 'type':
                if (inboxRule.ExceptIfMessageTypeMatches !== 'NullInboxRuleMessageType') {
                    clauseValueToAdd = inboxRule.ExceptIfMessageTypeMatches;
                }
                break;
            case 'attachment':
                if (inboxRule.ExceptIfHasAttachment) {
                    clauseValueToAdd = inboxRule.ExceptIfHasAttachment;
                }
                break;
            case 'atLeast':
                if (inboxRule.ExceptIfWithinSizeRangeMinimum) {
                    clauseValueToAdd = inboxRule.ExceptIfWithinSizeRangeMinimum;
                }
                break;
            case 'atMost':
                if (inboxRule.ExceptIfWithinSizeRangeMaximum) {
                    clauseValueToAdd = inboxRule.ExceptIfWithinSizeRangeMaximum;
                }
                break;
            case 'before':
                if (inboxRule.ExceptIfReceivedBeforeDate) {
                    clauseValueToAdd = inboxRule.ExceptIfReceivedBeforeDate;
                }
                break;
            case 'after':
                if (inboxRule.ExceptIfReceivedAfterDate) {
                    clauseValueToAdd = inboxRule.ExceptIfReceivedAfterDate;
                }
                break;
        }
        // only add clauses to the edit page that have corresponding values on the inbox rule
        if (clauseValueToAdd) {
            addNewClause_1.default(clauseSection, exceptionClause, clauseValueToAdd);
        }
    }
    initializeInboxRuleEdit_1.default();
    return;
}));
//# sourceMappingURL=mapInboxRuleToInboxRuleClauses.js.map

/***/ }),

/***/ 3385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createRecipientWell_1 = __webpack_require__(2046);
/**
 * Maps people identity objects on an inbox rule to the edit page's recipient well view state, to prepopulate personas
 * @return the ReadWriteRecipientWellViewState populated with the PeopleIdentities as personas
 */
function mapPeopleIdentityToReadWriteRecipientWellViewState(peopleIdentity) {
    // map conditional clauses
    var initialMailboxes = [];
    for (var _i = 0, peopleIdentity_1 = peopleIdentity; _i < peopleIdentity_1.length; _i++) {
        var identity = peopleIdentity_1[_i];
        var mailbox = {
            Name: identity.DisplayName,
            EmailAddress: identity.SmtpAddress,
            RoutingType: identity.RoutingType,
        };
        initialMailboxes.push(mailbox);
    }
    return createRecipientWell_1.default(initialMailboxes);
}
exports.default = mapPeopleIdentityToReadWriteRecipientWellViewState;
//# sourceMappingURL=mapPeopleIdentityToReadWriteRecipientWellViewState.js.map

/***/ }),

/***/ 3386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Set the selectedFolderId in the inbox rules store
 * @param id the folder ID to set
 */
exports.default = legacy_1.action('setSelectedFolderId')(function setSelectedFolderId(id) {
    store_1.default.inboxRulesEditState.selectedFolderId = id;
});
//# sourceMappingURL=setSelectedFolderId.js.map

/***/ }),

/***/ 3387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ReadWriteFindControl_1 = __webpack_require__(3388);
var ReadWriteRecipient_1 = __webpack_require__(3181);
var addReadWriteRecipient_1 = __webpack_require__(2615);
var expandGroup_1 = __webpack_require__(3405);
var focusNextRecipient_1 = __webpack_require__(3407);
var removeReadWriteRecipient_1 = __webpack_require__(2897);
var showHideContactPicker_1 = __webpack_require__(2941);
var getRecipientString_1 = __webpack_require__(3184);
var mobx_react_1 = __webpack_require__(11);
var owa_contact_picker_1 = __webpack_require__(3185);
var RecipientType_1 = __webpack_require__(2672);
var React = __webpack_require__(3);
var styles = __webpack_require__(3408);
var classNames = __webpack_require__(30).bind(styles);
var ReadWriteRecipientWellWithFindControl = /** @class */ (function (_super) {
    tslib_1.__extends(ReadWriteRecipientWellWithFindControl, _super);
    function ReadWriteRecipientWellWithFindControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFindControl = function () {
            return _this.well;
        };
        _this.setContactPickerState = function (recipientWell, isVisible) { return function () {
            showHideContactPicker_1.default(recipientWell, isVisible);
        }; };
        _this.addRecipientFromContactPicker = function (recipientWell) { return function (recipientToAdd) {
            addReadWriteRecipient_1.default(recipientWell, true /* isValid */, recipientToAdd, undefined /* newEmailAddress */, false /* resetFindResult */);
        }; };
        _this.bindWellRef = function (ref) {
            if (ref != null) {
                _this.well = ref;
            }
        };
        _this.removeRecipient = function (recipientWell) { return function (recipientToRemove, selectToRight) {
            removeReadWriteRecipient_1.default(recipientWell, recipientToRemove, selectToRight);
            if (recipientWell.recipients.length == 0) {
                _this.focus();
            }
        }; };
        _this.expandGroup = function (recipientWell) { return function (recipientToExpand) {
            expandGroup_1.default(recipientWell, recipientToExpand);
        }; };
        _this.focusNextRecipient = function (recipientWell) { return function (recipientToBlur, direction) {
            if (recipientWell.recipients.indexOf(recipientToBlur) + direction >=
                recipientWell.recipients.length) {
                _this.findControl.focus();
            }
            else {
                focusNextRecipient_1.default(recipientWell, recipientToBlur, direction);
            }
        }; };
        return _this;
    }
    ReadWriteRecipientWellWithFindControl.prototype.focus = function () {
        this.findControl.focus();
    };
    ReadWriteRecipientWellWithFindControl.prototype.render = function () {
        var _this = this;
        var _a = this.props, recipientWell = _a.recipientWell, recipientType = _a.recipientType, size = _a.size, shouldBlockForcedFocus = _a.shouldBlockForcedFocus;
        if (recipientWell) {
            var wellLabel = recipientType != RecipientType_1.RecipientType.None ? (React.createElement("div", { tabIndex: 0, onClick: this.setContactPickerState(recipientWell, !recipientWell.shouldShowContactPicker), className: styles.label }, getRecipientString_1.default(recipientType))) : null;
            var recipients = recipientWell.recipients;
            return (React.createElement("div", { className: styles.container, ref: this.bindWellRef },
                wellLabel,
                recipientWell.shouldShowContactPicker && (React.createElement(owa_contact_picker_1.ContactPickerPane, { viewState: recipientWell.contactPicker, findControlGetter: this.getFindControl, dismissContactPickerAction: this.setContactPickerState(recipientWell, false /* isVisible */), addRecipientAction: this.addRecipientFromContactPicker(recipientWell) })),
                recipients && recipients.length > 0
                    ? recipients.map(function (recipient, index) {
                        // Using an index as part of the key is sub-optimal, but the recipient array
                        // can contain duplicate data that has no other means of differentiating.
                        return (React.createElement(ReadWriteRecipient_1.default, { key: recipient.persona.EmailAddress.EmailAddress + "_" + index, viewState: recipient, removeOperation: _this.removeRecipient(recipientWell), focusNextOperation: _this.focusNextRecipient(recipientWell), size: size, expandGroupOperation: _this.expandGroup(recipientWell) }));
                    })
                    : null,
                React.createElement(ReadWriteFindControl_1.default, { recipientWell: recipientWell, size: size, className: classNames(styles.findControl, {
                        smallSize: size == 0 /* Small */,
                        regularSize: size == 1 /* Regular */,
                    }), shouldBlockForcedFocus: shouldBlockForcedFocus, ref: function (ref) { return (_this.findControl = ref); } })));
        }
        else {
            return null;
        }
    };
    ReadWriteRecipientWellWithFindControl = tslib_1.__decorate([
        mobx_react_1.observer
    ], ReadWriteRecipientWellWithFindControl);
    return ReadWriteRecipientWellWithFindControl;
}(React.Component));
exports.default = ReadWriteRecipientWellWithFindControl;
//# sourceMappingURL=ReadWriteRecipientWellWithFindControl.js.map

/***/ }),

/***/ 3388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var FindRecipientResult_1 = __webpack_require__(3389);
var addHighlightedFindRecipient_1 = __webpack_require__(3395);
var parsePastedTextForRecipients_1 = __webpack_require__(3396);
var removeReadWriteRecipient_1 = __webpack_require__(2897);
var resolveAllUnresolvedRecipients_1 = __webpack_require__(2688);
var resolveQueryStringToRecipient_1 = __webpack_require__(2669);
var setRecipientSelectedState_1 = __webpack_require__(2764);
var shiftFindResultHighlightIndex_1 = __webpack_require__(3397);
var showHideContactPicker_1 = __webpack_require__(2941);
var showHideFindResult_1 = __webpack_require__(2616);
var updateFindControlQueryString_1 = __webpack_require__(3398);
var isValidEmailAddress_1 = __webpack_require__(2112);
var searchDirectory_1 = __webpack_require__(3080);
var useTypedAddress_1 = __webpack_require__(3081);
var mobx_react_1 = __webpack_require__(11);
var Utilities_1 = __webpack_require__(7);
var FindRecipientInfo_1 = __webpack_require__(2753);
var React = __webpack_require__(3);
var KeyboardCharCodes_1 = __webpack_require__(634);
var styles = __webpack_require__(3399);
var ReadWriteFindControl = /** @class */ (function (_super) {
    tslib_1.__extends(ReadWriteFindControl, _super);
    function ReadWriteFindControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (evt) {
            var inputText = evt.target.value;
            updateFindControlQueryString_1.default(_this.props.recipientWell, inputText);
        };
        _this.onPaste = function (evt) {
            evt.preventDefault();
            var inputText = evt.clipboardData.getData('Text');
            parsePastedTextForRecipients_1.default(_this.props.recipientWell, inputText);
        };
        _this.onFocus = function (evt) {
            if (_this.props.shouldBlockForcedFocus && _this.isForcedFocus) {
                _this.isForcedFocus = false;
            }
            else if (evt.currentTarget == document.activeElement) {
                showHideFindResult_1.default(_this.props.recipientWell, true /**shouldShowFindResult */);
            }
            showHideContactPicker_1.default(_this.props.recipientWell, false /* shouldShowContactPicker */);
        };
        _this.onClick = function (evt) {
            if (!_this.props.recipientWell.shouldShowFindResult) {
                showHideFindResult_1.default(_this.props.recipientWell, true /**shouldShowFindResult */);
            }
        };
        _this.getQueryInputElement = function () {
            return _this.queryInputElement;
        };
        _this.onKeyDown = function (target) {
            switch (target.keyCode) {
                case KeyboardCharCodes_1.DOWN_ARROW_CHARCODE:
                    target.preventDefault();
                    shiftFindResultHighlightIndex_1.default(_this.props.recipientWell, true /* isIncrement */, _this.infoElementType);
                    return;
                case KeyboardCharCodes_1.UP_ARROW_CHARCODE:
                    if (_this.props.recipientWell.findResultHightlightIndex > -1) {
                        target.preventDefault();
                        shiftFindResultHighlightIndex_1.default(_this.props.recipientWell, false /* isIncrement */, _this.infoElementType);
                    }
                    return;
                case KeyboardCharCodes_1.LEFT_ARROW_CHARCODE:
                case KeyboardCharCodes_1.RIGHT_ARROW_CHARCODE:
                    if (((target.keyCode == KeyboardCharCodes_1.LEFT_ARROW_CHARCODE && !Utilities_1.getRTL()) ||
                        (target.keyCode == KeyboardCharCodes_1.RIGHT_ARROW_CHARCODE && Utilities_1.getRTL())) &&
                        _this.inputControl.selectionStart == 0 &&
                        _this.inputControl.selectionEnd == 0 &&
                        _this.props.recipientWell.recipients.length > 0) {
                        target.preventDefault();
                        setRecipientSelectedState_1.default(_this.props.recipientWell.recipients[_this.props.recipientWell.recipients.length - 1], true);
                    }
                    return;
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                case KeyboardCharCodes_1.TAB_CHARCODE:
                    if (!target.shiftKey) {
                        if (_this.props.recipientWell.findResultHightlightIndex > -1) {
                            target.preventDefault();
                            var resultsLength = _this.props.recipientWell.findResultSet.length;
                            if (_this.props.recipientWell.findResultHightlightIndex == resultsLength) {
                                if (_this.infoElementType === FindRecipientInfo_1.FindRecipientInfoType.TopNResults &&
                                    resultsLength == 0) {
                                    target.preventDefault();
                                    resolveQueryStringToRecipient_1.default(_this.props.recipientWell, true /* shouldDirectlyResolve */);
                                }
                                if (_this.infoElementType === FindRecipientInfo_1.FindRecipientInfoType.SearchDirectory) {
                                    searchDirectory_1.default(_this.props.recipientWell);
                                }
                                else if (_this.infoElementType === FindRecipientInfo_1.FindRecipientInfoType.UseAddress) {
                                    useTypedAddress_1.default(_this.props.recipientWell);
                                }
                            }
                            else {
                                addHighlightedFindRecipient_1.default(_this.props.recipientWell);
                            }
                        }
                        else if (_this.props.recipientWell.queryString.length > 0) {
                            // When there are no results, just add the text as a recipient.
                            target.preventDefault();
                            resolveQueryStringToRecipient_1.default(_this.props.recipientWell, true /* shouldDirectlyResolve */);
                        }
                        else {
                            showHideFindResult_1.default(_this.props.recipientWell, false /* shouldShowFindResult */);
                        }
                    }
                    else {
                        showHideFindResult_1.default(_this.props.recipientWell, false /**shouldShowFindResult */);
                    }
                    return;
                case KeyboardCharCodes_1.K_CHARCODE:
                    if (target.ctrlKey) {
                        target.preventDefault();
                        resolveAllUnresolvedRecipients_1.default(_this.props.recipientWell);
                    }
                    return;
                case KeyboardCharCodes_1.BACKSPACE_CHARCODE:
                    if (_this.inputControl.selectionStart == 0 && _this.inputControl.selectionEnd == 0) {
                        removeReadWriteRecipient_1.default(_this.props.recipientWell, _this.props.recipientWell.recipients.length - 1);
                        showHideFindResult_1.default(_this.props.recipientWell, true /**shouldShowFindResult */);
                    }
                    return;
            }
        };
        _this.bindQueryInputRef = function (ref) {
            if (ref) {
                _this.queryInputElement = ref;
            }
        };
        _this.getFindRecipientInfoType = function () {
            var recipientWell = _this.props.recipientWell;
            var hasQueryString = !!recipientWell.queryString;
            if (recipientWell.isSearching) {
                _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.Searching;
            }
            else if (!hasQueryString && recipientWell.findResultSet.length == 0) {
                _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.TypeToSearch;
            }
            else if (hasQueryString) {
                if (recipientWell.findResultSet.length == 0 &&
                    recipientWell.queryString.indexOf('@') >= 0 &&
                    isValidEmailAddress_1.default(recipientWell.queryString)) {
                    _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.UseAddress;
                }
                else if (!recipientWell.hasSearchedDirectory) {
                    _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.SearchDirectory;
                }
                else {
                    _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.TopNResults;
                }
            }
            else {
                _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.Default;
            }
            return _this.infoElementType;
        };
        return _this;
    }
    ReadWriteFindControl.prototype.focus = function () {
        this.isForcedFocus = true;
        this.inputControl.focus();
        this.inputControl.selectionStart = this.props.recipientWell.queryString.length;
    };
    ReadWriteFindControl.prototype.render = function () {
        var _this = this;
        var size = this.props.size;
        var inputClassName = size == 0 /* Small */
            ? styles.findControlInputSmall
            : styles.findControlInputRegular;
        return (React.createElement("span", { ref: this.bindQueryInputRef, className: this.props.className },
            React.createElement("input", { className: inputClassName, ref: function (ref) { return (_this.inputControl = ref); }, type: "text", value: this.props.recipientWell.queryString, onClick: this.onClick, onFocus: this.onFocus, onChange: this.onChange, onPaste: this.onPaste, onKeyDown: this.onKeyDown }),
            React.createElement(FindRecipientResult_1.default, { recipientWell: this.props.recipientWell, queryInputGetter: this.getQueryInputElement, findRecipientInfoType: this.getFindRecipientInfoType() })));
    };
    ReadWriteFindControl = tslib_1.__decorate([
        mobx_react_1.observer
    ], ReadWriteFindControl);
    return ReadWriteFindControl;
}(React.Component));
exports.default = ReadWriteFindControl;
//# sourceMappingURL=ReadWriteFindControl.js.map

/***/ }),

/***/ 3389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var addReadWriteRecipient_1 = __webpack_require__(2615);
var maskRecipientFromFindControl_1 = __webpack_require__(3180);
var showHideFindResult_1 = __webpack_require__(2616);
var datapoints_1 = __webpack_require__(2690);
var searchDirectory_1 = __webpack_require__(3080);
var useTypedAddress_1 = __webpack_require__(3081);
var mobx_react_1 = __webpack_require__(11);
var Callout_1 = __webpack_require__(157);
var Utilities_1 = __webpack_require__(7);
var owa_analytics_1 = __webpack_require__(12);
var FindRecipient_1 = __webpack_require__(2921);
var owa_common_strings_1 = __webpack_require__(37);
var userAgent_1 = __webpack_require__(148);
var React = __webpack_require__(3);
var FindRecipientInfo_1 = __webpack_require__(2753);
var styles = __webpack_require__(3393);
var classNames = __webpack_require__(30).bind(styles);
var FindRecipientResult = /** @class */ (function (_super) {
    tslib_1.__extends(FindRecipientResult, _super);
    function FindRecipientResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dismissFindResult = function () {
            showHideFindResult_1.default(_this.props.recipientWell, false /**shouldShowFindResult */);
        };
        _this.addRecipientAction = function (recipientWell, position) { return function (recipientToAdd) {
            var _a = datapoints_1.default.AddRecipientFromFindControl.datapoint, eventName = _a.name, customData = _a.customData;
            owa_analytics_1.logUsage(eventName, customData(position, recipientWell.findResultType));
            addReadWriteRecipient_1.default(recipientWell, true /* isValid */, recipientToAdd);
        }; };
        _this.maskRecipientAction = function (recipientWell) { return function (recipientToMask) {
            maskRecipientFromFindControl_1.default(recipientWell, recipientToMask);
        }; };
        return _this;
    }
    FindRecipientResult.prototype.render = function () {
        var _this = this;
        var _a = this.props, recipientWell = _a.recipientWell, queryInputGetter = _a.queryInputGetter, findRecipientInfoType = _a.findRecipientInfoType;
        var hasQueryString = !!recipientWell.queryString;
        return recipientWell.shouldShowFindResult ? (React.createElement(Callout_1.Callout, { className: classNames(styles.callout, {
                animationStop: userAgent_1.isBrowserEdge() /* see VSO:13872 Remove on release of RS3 */,
            }), onDismiss: this.dismissFindResult, gapSpace: 10, target: queryInputGetter(), isBeakVisible: false, setInitialFocus: false, directionalHint: Utilities_1.getRTL() ? 6 /* bottomRightEdge */ : 4 /* bottomLeftEdge */ },
            !hasQueryString &&
                recipientWell.findResultSet.length > 0 && (React.createElement("div", { className: styles.suggestedContactsHeaderBox },
                React.createElement("span", { className: styles.suggestedContactsText }, owa_common_strings_1.default.findRecipientResult_SuggestedContactsHeader))),
            recipientWell.findResultSet.length != 0 && (React.createElement("div", { className: classNames(styles.scrollContainer, 'customScrollBar') },
                React.createElement("div", { className: styles.recipientCollection }, recipientWell.findResultSet.map(function (result, index) { return (React.createElement(FindRecipient_1.default, { key: result.EmailAddress.EmailAddress, findRecipient: result, isHighlighted: index == recipientWell.findResultHightlightIndex, addRecipientAction: _this.addRecipientAction(recipientWell, index), maskRecipientAction: _this.maskRecipientAction(recipientWell) })); })))),
            React.createElement(FindRecipientInfo_1.default, { infoType: findRecipientInfoType, highlighted: recipientWell.findResultSet.length ==
                    recipientWell.findResultHightlightIndex, numberOfResults: recipientWell.findResultSet.length, searchDirectoryAction: function () { return searchDirectory_1.default(_this.props.recipientWell); }, useTypedAddressAction: function () { return useTypedAddress_1.default(_this.props.recipientWell); }, queryString: recipientWell.queryString }))) : null;
    };
    FindRecipientResult = tslib_1.__decorate([
        mobx_react_1.observer
    ], FindRecipientResult);
    return FindRecipientResult;
}(React.Component));
exports.default = FindRecipientResult;
//# sourceMappingURL=FindRecipientResult.js.map

/***/ }),

/***/ 3390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var maskAutoCompleteRecipientOperation_1 = __webpack_require__(3391);
var maskAutoCompleteRecipientRequest_1 = __webpack_require__(3079);
function configureRequestBody(emailAddress) {
    return maskAutoCompleteRecipientRequest_1.default({
        EmailAddress: emailAddress,
    });
}
function maskAutoCompleteRecipient(emailAddress) {
    var requestBody = configureRequestBody(emailAddress);
    return maskAutoCompleteRecipientOperation_1.default(requestBody).then(function (response) {
        var responseMessage = response;
        return responseMessage;
    });
}
exports.maskAutoCompleteRecipient = maskAutoCompleteRecipient;
//# sourceMappingURL=maskAutoCompleteRecipient.js.map

/***/ }),

/***/ 3391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var maskAutoCompleteRecipientRequest_1 = __webpack_require__(3079);
function maskAutoCompleteRecipientOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = maskAutoCompleteRecipientRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("MaskAutoCompleteRecipient", req, options);
}
exports.default = maskAutoCompleteRecipientOperation;


/***/ }),

/***/ 3392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2620);
function deleteFromCache(emailToDelete) {
    var i = 0;
    var match = false;
    if (store_1.default.recipientCache) {
        while (!match && i < store_1.default.recipientCache.length) {
            var email = store_1.default.recipientCache[i].EmailAddress;
            if ((email.EmailAddress && email.EmailAddress == emailToDelete.EmailAddress) ||
                (email.Name && email.Name == emailToDelete.Name)) {
                match = true;
                store_1.default.recipientCache.splice(i, 1);
            }
            else {
                i++;
            }
        }
    }
    return match;
}
exports.default = deleteFromCache;
//# sourceMappingURL=deleteFromCache.js.map

/***/ }),

/***/ 3393:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3394);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3394:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1W4-SWaDoHR4AHifnFVokw{width:300px}html[dir] ._1W4-SWaDoHR4AHifnFVokw{background-color:\"[theme:white, default:#ffffff]\"}._32BxM1FO0jXY3xTW5lD3cr{-webkit-animation:none!important;animation:none!important}._1Yyx3wIEF7Ar8m3nTigMHF{max-height:470px;overflow-x:hidden}.bc9ijHYux-j6qNoG72WFd{overflow:hidden}._2q0n_nmrjXEqaJvNl5uf63{height:28px}html[dir=ltr] ._2q0n_nmrjXEqaJvNl5uf63{padding-left:14px}html[dir=rtl] ._2q0n_nmrjXEqaJvNl5uf63{padding-right:14px}._2pTYsSnXy019FsgSeuTpC0{font-size:12px;font-weight:400;color:\"[theme:themePrimary, default:#0078D7]\";line-height:1;display:inline-block}html[dir] ._2pTYsSnXy019FsgSeuTpC0{padding-top:8px}", ""]);

// exports
exports.locals = {
	"callout": "_1W4-SWaDoHR4AHifnFVokw",
	"animationStop": "_32BxM1FO0jXY3xTW5lD3cr",
	"scrollContainer": "_1Yyx3wIEF7Ar8m3nTigMHF",
	"recipientCollection": "bc9ijHYux-j6qNoG72WFd",
	"suggestedContactsHeaderBox": "_2q0n_nmrjXEqaJvNl5uf63",
	"suggestedContactsText": "_2pTYsSnXy019FsgSeuTpC0"
};

/***/ }),

/***/ 3395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var addReadWriteRecipient_1 = __webpack_require__(2615);
var datapoints_1 = __webpack_require__(2690);
var owa_analytics_1 = __webpack_require__(12);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('addHighlightedFindRecipient')(function addHighlightedFindRecipient(recipientWell) {
    // Only add highlighted recipient when find result is visible
    if (recipientWell.shouldShowFindResult) {
        var _a = datapoints_1.default.AddRecipientFromFindControl.datapoint, eventName = _a.name, customData = _a.customData;
        owa_analytics_1.logUsage(eventName, customData(recipientWell.findResultHightlightIndex, recipientWell.findResultType));
        var highlightedFindRecipient = recipientWell.findResultSet[recipientWell.findResultHightlightIndex];
        addReadWriteRecipient_1.default(recipientWell, true /* isValid */, highlightedFindRecipient, null /* newEmailAddress */);
    }
});
//# sourceMappingURL=addHighlightedFindRecipient.js.map

/***/ }),

/***/ 3396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var addReadWriteRecipient_1 = __webpack_require__(2615);
var resolveAllUnresolvedRecipients_1 = __webpack_require__(2688);
var isValidEmailAddress_1 = __webpack_require__(2112);
var parseSuspectedDisplayNameEmailAddress_1 = __webpack_require__(2754);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('parsePastedTextForRecipients')(function parsePastedTextForRecipients(recipientWell, inputText) {
    var recipientList = inputText.split(';');
    recipientList.forEach(function (element) {
        var trimmedElement = element.trim();
        if (trimmedElement.length > 0) {
            // try to parse out a suspected name + email address combo
            var result = parseSuspectedDisplayNameEmailAddress_1.default(trimmedElement);
            addReadWriteRecipient_1.default(recipientWell, isValidEmailAddress_1.default(result.EmailAddress.EmailAddress), result);
        }
    });
    resolveAllUnresolvedRecipients_1.default(recipientWell);
});
//# sourceMappingURL=parsePastedTextForRecipients.js.map

/***/ }),

/***/ 3397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FindRecipientInfo_1 = __webpack_require__(2753);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('shiftFindResultHighlightIndex')(function shiftFindResultHighlightIndex(recipientWell, isIncrement, infoType) {
    // Only shift highlight index when find result is visible
    if (recipientWell.shouldShowFindResult) {
        var findResultCount = recipientWell.findResultSet.length;
        if (isIncrement) {
            recipientWell.findResultHightlightIndex++;
        }
        else {
            recipientWell.findResultHightlightIndex--;
        }
        // Incrementing on last item loops back to the first item.
        // Decrementing on first item loops back to the last item.
        var totalOptions = findResultCount +
            (infoType === FindRecipientInfo_1.FindRecipientInfoType.SearchDirectory ||
                infoType === FindRecipientInfo_1.FindRecipientInfoType.UseAddress
                ? 1
                : 0);
        recipientWell.findResultHightlightIndex =
            (recipientWell.findResultHightlightIndex + totalOptions) % totalOptions;
    }
});
//# sourceMappingURL=shiftFindResultHighlightIndex.js.map

/***/ }),

/***/ 3398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resolveQueryStringToRecipient_1 = __webpack_require__(2669);
var setForceResolveState_1 = __webpack_require__(2755);
var legacy_1 = __webpack_require__(1);
// Using a "global" timer for this case since we want to kill any search within the timeout scope.
var currentTimeout = null;
var DEBOUNCE_TIMEOUT = 150;
var resolveQueryStringDebounce = function (recipientWell, isLastCharSemiColon) { return function () {
    currentTimeout = null;
    resolveQueryStringToRecipient_1.default(recipientWell, isLastCharSemiColon /**shouldDirectlyResolve */);
}; };
exports.default = legacy_1.action('updateFindControlQueryString')(function updateFindControlQueryString(recipientWell, inputText) {
    if (currentTimeout) {
        clearTimeout(currentTimeout);
    }
    // If the user is typing, we should reset forceResolve state, just in case.
    setForceResolveState_1.default(recipientWell, false /* inForceResolve */);
    // Set the first result to highlighted, if nothing else is.
    if (recipientWell.findResultHightlightIndex == -1) {
        recipientWell.findResultHightlightIndex = 0;
    }
    // Check if last char is semi-colon and if so, remove it from query string.
    var lastCharIndex = inputText.length - 1;
    var lastChar = inputText[lastCharIndex];
    var isLastCharAKnownDelimiter = lastChar == ';' || lastChar == ',';
    if (isLastCharAKnownDelimiter) {
        inputText = inputText.substring(0, lastCharIndex);
    }
    recipientWell.queryString = inputText;
    // Directly resolve if user explicitly typed semi-colon at the end.
    currentTimeout = setTimeout(resolveQueryStringDebounce(recipientWell, isLastCharAKnownDelimiter /**shouldDirectlyResolve */), DEBOUNCE_TIMEOUT);
});
//# sourceMappingURL=updateFindControlQueryString.js.map

/***/ }),

/***/ 3399:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3400);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3400:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._2Lw2fldsMfxaEjAoXWsSXy,._2sDvvyXFEfTUFIcboDcbn3,._20rUCNZ41fZpRRptsqiZxf{color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._2Lw2fldsMfxaEjAoXWsSXy,html[dir] ._2sDvvyXFEfTUFIcboDcbn3,html[dir] ._20rUCNZ41fZpRRptsqiZxf{background:\"[theme:composeNeutralBackground, default:#FFFFFF]\"}._2Lw2fldsMfxaEjAoXWsSXy::-ms-clear,._2sDvvyXFEfTUFIcboDcbn3::-ms-clear,._20rUCNZ41fZpRRptsqiZxf::-ms-clear{display:none}._20rUCNZ41fZpRRptsqiZxf{height:28px}._2sDvvyXFEfTUFIcboDcbn3{height:32px}", ""]);

// exports
exports.locals = {
	"findControlInput": "_2Lw2fldsMfxaEjAoXWsSXy",
	"findControlInputSmall": "_20rUCNZ41fZpRRptsqiZxf",
	"findControlInputRegular": "_2sDvvyXFEfTUFIcboDcbn3"
};

/***/ }),

/***/ 3401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setContextMenuVisibility')(function setContextMenuVisibility(viewstate, isContextMenuShown) {
    viewstate.isContextMenuOpen = isContextMenuShown;
});
//# sourceMappingURL=setContextMenuVisibility.js.map

/***/ }),

/***/ 3402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setShouldBlockSelection')(function setShouldBlockSelection(viewstate, shouldBlockSelection) {
    viewstate.shouldBlockSelection = shouldBlockSelection;
});
//# sourceMappingURL=setShouldBlockSelection.js.map

/***/ }),

/***/ 3403:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3404);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3404:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3pinW1c-FX0QagRaL8qMoE{cursor:pointer;display:inline-block;white-space:nowrap}._134yvRNY4mdfzbLmYh4jqe{display:inline-block}html[dir] ._134yvRNY4mdfzbLmYh4jqe{border-radius:50%}._134yvRNY4mdfzbLmYh4jqe._1L9dKA8GSC8yYQuZoRCMfo{height:24px;width:24px}._134yvRNY4mdfzbLmYh4jqe._3CxO5pafGElAeJhjR87Yoh{height:32px;line-height:32px}._2rksLEmAdUU_0AtNbbammA,._3pinW1c-FX0QagRaL8qMoE ._2rksLEmAdUU_0AtNbbammA{display:inline-block;vertical-align:top}._3Xv6NHNW3vB1JF8RFdEu-2{color:\"[theme:themeDark, default:#0D62AA]\";font-size:14px;font-weight:400}html[dir] ._3Xv6NHNW3vB1JF8RFdEu-2{margin:0 8px}._3Xv6NHNW3vB1JF8RFdEu-2._2XGhBjwjNZCRF0AhUnBuQU{color:#e81123}._3Xv6NHNW3vB1JF8RFdEu-2.RmwGWnYx6QKs98kQwtqbs{color:\"[theme:white, default:#ffffff]\"}._3Xv6NHNW3vB1JF8RFdEu-2._1L9dKA8GSC8yYQuZoRCMfo{line-height:24px}._3Xv6NHNW3vB1JF8RFdEu-2._3CxO5pafGElAeJhjR87Yoh{line-height:32px}._3muM-f0gLUjFQxf7936JDk{position:fixed;top:0;width:2em;height:2em;outline:none}html[dir] ._3muM-f0gLUjFQxf7936JDk{padding:0;border:none;-webkit-box-shadow:none;box-shadow:none;background:transparent}html[dir=ltr] ._3muM-f0gLUjFQxf7936JDk{left:0}html[dir=rtl] ._3muM-f0gLUjFQxf7936JDk{right:0}.jI7KJmsPKr5bpREo6llfO{width:48px;display:none;position:absolute}html[dir] .jI7KJmsPKr5bpREo6llfO{text-align:center}html[dir=ltr] .jI7KJmsPKr5bpREo6llfO{border-radius:15px 0 0 15px;left:0}html[dir=rtl] .jI7KJmsPKr5bpREo6llfO{border-radius:0 15px 15px 0;right:0}.jI7KJmsPKr5bpREo6llfO._1L9dKA8GSC8yYQuZoRCMfo{height:24px;line-height:24px}html[dir=ltr] .jI7KJmsPKr5bpREo6llfO._1L9dKA8GSC8yYQuZoRCMfo{padding-right:12px}html[dir=rtl] .jI7KJmsPKr5bpREo6llfO._1L9dKA8GSC8yYQuZoRCMfo{padding-left:12px}.jI7KJmsPKr5bpREo6llfO._3CxO5pafGElAeJhjR87Yoh{height:32px;line-height:32px}html[dir=ltr] .jI7KJmsPKr5bpREo6llfO._3CxO5pafGElAeJhjR87Yoh{padding-right:16px}html[dir=rtl] .jI7KJmsPKr5bpREo6llfO._3CxO5pafGElAeJhjR87Yoh{padding-left:16px}._1myVJbAP0VaAjgOHmqiCS7{color:\"[theme:themeDark, default:#0D62AA]\"}._1myVJbAP0VaAjgOHmqiCS7 .ms-Button-icon{font-size:14px;font-weight:400}html[dir] ._1myVJbAP0VaAjgOHmqiCS7:hover{background-color:\"[theme:themeLight, default:#C7E0F4]\"}._1myVJbAP0VaAjgOHmqiCS7.RmwGWnYx6QKs98kQwtqbs{color:\"[theme:white, default:#ffffff]\"}html[dir] ._1myVJbAP0VaAjgOHmqiCS7.RmwGWnYx6QKs98kQwtqbs:hover{background-color:\"[theme:themeDark, default:#0D62AA]\"}html[dir] ._3krMa995_4maVS_wzrRQ0T:hover{background-color:transparent}.jI7KJmsPKr5bpREo6llfO._1alUyI4Oksj-bxNxriT-oR{display:inline-block}._2ToCh9ORlZTLsK9SmcffYJ{position:relative;display:inline-block}html[dir] ._2ToCh9ORlZTLsK9SmcffYJ{background-color:\"[theme:themeLighterAlt, default:#EFF6FC]\";border-radius:15px}html[dir] ._2ToCh9ORlZTLsK9SmcffYJ:hover{background-color:\"[theme:themeLighter, default:#DEECF9]\"}html[dir] ._2ToCh9ORlZTLsK9SmcffYJ.RmwGWnYx6QKs98kQwtqbs{background-color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._2ToCh9ORlZTLsK9SmcffYJ._1L9dKA8GSC8yYQuZoRCMfo{margin:2px}html[dir=ltr] ._2ToCh9ORlZTLsK9SmcffYJ._3CxO5pafGElAeJhjR87Yoh{margin:10px 0 0 10px}html[dir=rtl] ._2ToCh9ORlZTLsK9SmcffYJ._3CxO5pafGElAeJhjR87Yoh{margin:10px 10px 0 0}html[dir=ltr] ._2ToCh9ORlZTLsK9SmcffYJ._1fCnbmWe5Xs9BLYTxhziTl{padding-left:30px}html[dir=rtl] ._2ToCh9ORlZTLsK9SmcffYJ._1fCnbmWe5Xs9BLYTxhziTl{padding-right:30px}._3cX3Lfm7VTrpuaHvACkAaV{display:inline}", ""]);

// exports
exports.locals = {
	"recipient": "_3pinW1c-FX0QagRaL8qMoE",
	"removeRecipient": "_134yvRNY4mdfzbLmYh4jqe",
	"smallSize": "_1L9dKA8GSC8yYQuZoRCMfo",
	"regularSize": "_3CxO5pafGElAeJhjR87Yoh",
	"recipientImg": "_2rksLEmAdUU_0AtNbbammA",
	"recipientText": "_3Xv6NHNW3vB1JF8RFdEu-2",
	"invalid": "_2XGhBjwjNZCRF0AhUnBuQU",
	"selected": "RmwGWnYx6QKs98kQwtqbs",
	"copyInput": "_3muM-f0gLUjFQxf7936JDk",
	"expandGroupButton": "jI7KJmsPKr5bpREo6llfO",
	"actionButton": "_1myVJbAP0VaAjgOHmqiCS7",
	"noHover": "_3krMa995_4maVS_wzrRQ0T",
	"visible": "_1alUyI4Oksj-bxNxriT-oR",
	"recipientBox": "_2ToCh9ORlZTLsK9SmcffYJ",
	"boxWithPrivateDl": "_1fCnbmWe5Xs9BLYTxhziTl",
	"personaInfoWrapper": "_3cX3Lfm7VTrpuaHvACkAaV"
};

/***/ }),

/***/ 3405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var addReadWriteRecipient_1 = __webpack_require__(2615);
var processGetGroupInfoResult_1 = __webpack_require__(3182);
var removeReadWriteRecipient_1 = __webpack_require__(2897);
var getGroupInfo_1 = __webpack_require__(3183);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('expandGroup')(function expandGroup(recipientWell, recipientToExpand) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var groupResponse, expandedEmails;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    recipientToExpand.isExpanding = true;
                    return [4 /*yield*/, getGroupInfo_1.getGroupInfo(recipientToExpand.persona.PersonaId, recipientToExpand.persona.ADObjectId, recipientToExpand.persona.EmailAddress)];
                case 1:
                    groupResponse = _a.sent();
                    recipientToExpand.isExpanding = false;
                    expandedEmails = [];
                    processGetGroupInfoResult_1.default(expandedEmails, groupResponse);
                    removeReadWriteRecipient_1.default(recipientWell, recipientToExpand);
                    expandedEmails.forEach(function (member) {
                        addReadWriteRecipient_1.default(recipientWell, true /* isValid */, member, null /* newEmailAddress */);
                    });
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=expandGroup.js.map

/***/ }),

/***/ 3406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getGroupInfoRequest_1 = __webpack_require__(3082);
function getGroupInfoOperation(req, options) {
    if (req.getGroupInfoRequest !== undefined && !req.getGroupInfoRequest["__type"]) {
        req.getGroupInfoRequest = getGroupInfoRequest_1.default(req.getGroupInfoRequest);
    }
    return ServiceRequest_1.makeServiceRequest("GetGroupInfo", req, options);
}
exports.default = getGroupInfoOperation;


/***/ }),

/***/ 3407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setRecipientSelectedState_1 = __webpack_require__(2764);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('focusNextRecipient')(function focusNextRecipient(recipientWell, recipientToBlur, direction) {
    var indexToBlur;
    if (typeof recipientToBlur === 'number') {
        indexToBlur = recipientToBlur;
    }
    else {
        indexToBlur = recipientWell.recipients.indexOf(recipientToBlur);
    }
    if (indexToBlur >= 0) {
        var indexToFocus = Math.max(0, indexToBlur + direction);
        if (indexToFocus < recipientWell.recipients.length) {
            setRecipientSelectedState_1.default(recipientWell.recipients[indexToFocus], true);
        }
    }
});
//# sourceMappingURL=focusNextRecipient.js.map

/***/ }),

/***/ 3408:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3409);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3409:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3IY8AiXwzXLNGfCdJdfZR5{width:100%;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}._1XEWbbmhC56udCj6xhAw8N{display:inline-block;height:32px;line-height:32px;min-width:52px;font-weight:600;color:\"[theme:themeDark, default:#0D62AA]\";cursor:pointer}html[dir] ._1XEWbbmhC56udCj6xhAw8N{margin-top:11px;padding:0 4px;text-align:center;background-color:\"[theme:themeLighterAlt, default:#EFF6FC]\";border-radius:2px}html[dir] ._1XEWbbmhC56udCj6xhAw8N:hover{background-color:\"[theme:themeLighter, default:#DEECF9]\"}html[dir] ._1XEWbbmhC56udCj6xhAw8N:active{background-color:\"[theme:themeLight, default:#C7E0F4]\"}._2W1FbxMQwSz-nSwTqjiIRc{-webkit-box-flex:1;-ms-flex:1 0;flex:1 0;min-width:50px}._2W1FbxMQwSz-nSwTqjiIRc input{outline:none;width:100%;font-size:12px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._2W1FbxMQwSz-nSwTqjiIRc input{border:none}html[dir=ltr] ._2W1FbxMQwSz-nSwTqjiIRc._6xuk4_0N5GeAh8C9FRwRV{margin-left:10px}html[dir=rtl] ._2W1FbxMQwSz-nSwTqjiIRc._6xuk4_0N5GeAh8C9FRwRV{margin-right:10px}html[dir=ltr] ._2W1FbxMQwSz-nSwTqjiIRc._1SAqhiyhD3-eWVVkOn8yd_{margin:10px 0 0 10px}html[dir=rtl] ._2W1FbxMQwSz-nSwTqjiIRc._1SAqhiyhD3-eWVVkOn8yd_{margin:10px 10px 0 0}", ""]);

// exports
exports.locals = {
	"container": "_3IY8AiXwzXLNGfCdJdfZR5",
	"label": "_1XEWbbmhC56udCj6xhAw8N",
	"findControl": "_2W1FbxMQwSz-nSwTqjiIRc",
	"smallSize": "_6xuk4_0N5GeAh8C9FRwRV",
	"regularSize": "_1SAqhiyhD3-eWVVkOn8yd_"
};

/***/ }),

/***/ 3410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var initializeInboxRulesEditState_1 = __webpack_require__(3176);
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('resetInboxRuleEdit')(function resetInboxRuleEdit(state) {
    var optionState = state.optionState;
    optionState.inboxRulesEditState = initializeInboxRulesEditState_1.default();
}));
//# sourceMappingURL=resetInboxRuleEdit.js.map

/***/ }),

/***/ 3411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function peopleIdentity(data) {
    var result = tslib_1.__assign({ __type: 'PeopleIdentity:#Exchange' }, data);
    return result;
}
exports.default = peopleIdentity;


/***/ }),

/***/ 3412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var newInboxRuleRequest_1 = __webpack_require__(3083);
function newInboxRuleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = newInboxRuleRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("NewInboxRule", req, options);
}
exports.default = newInboxRuleOperation;


/***/ }),

/***/ 3413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('calendarConfiguration', {
    calendarConfiguration: null,
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var setCategory_1 = __webpack_require__(5273);
var setSubCategoryState_1 = __webpack_require__(5274);
var getCurrentSubcategory_1 = __webpack_require__(3769);
var store_1 = __webpack_require__(2113);
function updateCategory(categoryKey, subcategoryKey, currentOptionKey) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        function areCategoryAndSubCategoryUnchanged() {
            var store = store_1.getStore();
            return (store.currentCategoryKey === categoryKey &&
                store.currentSubCategoryKey === subcategoryKey);
        }
        var subCategory, success, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCategory_1.default(categoryKey, subcategoryKey, currentOptionKey);
                    subCategory = getCurrentSubcategory_1.default();
                    if (!subCategory.onSelected) return [3 /*break*/, 5];
                    setSubCategoryState_1.default(0 /* Loading */);
                    success = void 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, subCategory.onSelected()];
                case 2:
                    success = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    success = false;
                    return [3 /*break*/, 4];
                case 4:
                    if (areCategoryAndSubCategoryUnchanged()) {
                        setSubCategoryState_1.default(success ? 1 /* Loaded */ : 2 /* Error */);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setSubCategoryState_1.default(1 /* Loaded */);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.default = updateCategory;
//# sourceMappingURL=updateCategory.js.map

/***/ }),

/***/ 3415:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(5291);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 3416:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5312);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2217), exports);
//# sourceMappingURL=Toggle.js.map

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Drag and Drop apis need identifiers to be strings.
exports.DraggableItemTypes = {
    FavoriteNode: 'favoriteNode',
    InboxRule: 'inboxRule',
    LocalFile: 'localFile',
    MailFolderNode: 'mailFolderNode',
    MailListRow: 'mailListRow',
};
//# sourceMappingURL=DraggableItemTypes.js.map

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECTION_CHANGE = 'change';
var SelectionMode;
(function (SelectionMode) {
    SelectionMode[SelectionMode["none"] = 0] = "none";
    SelectionMode[SelectionMode["single"] = 1] = "single";
    SelectionMode[SelectionMode["multiple"] = 2] = "multiple";
})(SelectionMode = exports.SelectionMode || (exports.SelectionMode = {}));
var SelectionDirection;
(function (SelectionDirection) {
    SelectionDirection[SelectionDirection["horizontal"] = 0] = "horizontal";
    SelectionDirection[SelectionDirection["vertical"] = 1] = "vertical";
})(SelectionDirection = exports.SelectionDirection || (exports.SelectionDirection = {}));
//# sourceMappingURL=interfaces.js.map

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The days of the week
 */
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
/**
 * The months
 */
var MonthOfYear;
(function (MonthOfYear) {
    MonthOfYear[MonthOfYear["January"] = 0] = "January";
    MonthOfYear[MonthOfYear["February"] = 1] = "February";
    MonthOfYear[MonthOfYear["March"] = 2] = "March";
    MonthOfYear[MonthOfYear["April"] = 3] = "April";
    MonthOfYear[MonthOfYear["May"] = 4] = "May";
    MonthOfYear[MonthOfYear["June"] = 5] = "June";
    MonthOfYear[MonthOfYear["July"] = 6] = "July";
    MonthOfYear[MonthOfYear["August"] = 7] = "August";
    MonthOfYear[MonthOfYear["September"] = 8] = "September";
    MonthOfYear[MonthOfYear["October"] = 9] = "October";
    MonthOfYear[MonthOfYear["November"] = 10] = "November";
    MonthOfYear[MonthOfYear["December"] = 11] = "December";
})(MonthOfYear = exports.MonthOfYear || (exports.MonthOfYear = {}));
/**
 * First week of the year settings types
 */
var FirstWeekOfYear;
(function (FirstWeekOfYear) {
    FirstWeekOfYear[FirstWeekOfYear["FirstDay"] = 0] = "FirstDay";
    FirstWeekOfYear[FirstWeekOfYear["FirstFullWeek"] = 1] = "FirstFullWeek";
    FirstWeekOfYear[FirstWeekOfYear["FirstFourDayWeek"] = 2] = "FirstFourDayWeek";
})(FirstWeekOfYear = exports.FirstWeekOfYear || (exports.FirstWeekOfYear = {}));
/**
 * The supported date range types
 */
var DateRangeType;
(function (DateRangeType) {
    DateRangeType[DateRangeType["Day"] = 0] = "Day";
    DateRangeType[DateRangeType["Week"] = 1] = "Week";
    DateRangeType[DateRangeType["Month"] = 2] = "Month";
})(DateRangeType = exports.DateRangeType || (exports.DateRangeType = {}));
//# sourceMappingURL=DateValues.js.map

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialHeaderViewState = {
    activeCharm: null,
};
exports.store = satcheljs_1.createStore('headerViewState', initialHeaderViewState)();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mountAndShowFullOptions_1 = __webpack_require__(3366);
var mobx_react_1 = __webpack_require__(11);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var Button_1 = __webpack_require__(62);
var styles = __webpack_require__(3416);
var classNames = __webpack_require__(30).bind(styles);
var QuickOptionSearchEntry = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptionSearchEntry, _super);
    function QuickOptionSearchEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHeaderClick = function () {
            mountAndShowFullOptions_1.default(_this.props.option.categoryKey, _this.props.option.subcategoryKey, _this.props.option.key);
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        return _this;
    }
    QuickOptionSearchEntry.prototype.render = function () {
        var option = this.props.option;
        return (React.createElement("div", { className: styles.quickSetting },
            React.createElement(Button_1.CommandButton, { text: owa_options_strings_1.default[option.titleStringKey], className: classNames(styles.quickSettingHeader, styles.isSearch), onClick: this.onHeaderClick })));
    };
    QuickOptionSearchEntry = tslib_1.__decorate([
        mobx_react_1.observer
    ], QuickOptionSearchEntry);
    return QuickOptionSearchEntry;
}(React.Component));
exports.default = QuickOptionSearchEntry;
//# sourceMappingURL=QuickOptionSearchEntry.js.map

/***/ }),

/***/ 3721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_store_1 = __webpack_require__(2641);
var owa_analytics_1 = __webpack_require__(12);
var SAVE_DATAPOINT_NAME = 'OptionOnSave';
var DISCARD_DATAPOINT_NAME = 'OptionOnDiscard';
function saveOrDiscardOptions(isSave) {
    var _this = this;
    return Promise.all(owa_options_store_1.getCurrentSubcategory().options.map(function (option) {
        return (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var settings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        settings = option.fullOptionFormSettings;
                        if (!settings.isDirty()) return [3 /*break*/, 3];
                        owa_analytics_1.logUsage(isSave ? SAVE_DATAPOINT_NAME : DISCARD_DATAPOINT_NAME, [option.key]);
                        if (!isSave) return [3 /*break*/, 2];
                        return [4 /*yield*/, settings.onSave()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // We want to "discard" after saving as well, to clean up the view state so it's not stale
                        // if the option is changed outside the full options pane.
                        settings.onDiscard();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }));
}
exports.default = saveOrDiscardOptions;
//# sourceMappingURL=saveOrDiscardOptions.js.map

/***/ }),

/***/ 3722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2113);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('setIsFullOptionsShown', function setIsFullOptionsShown(newValue) {
    store_1.getStore().isFullOptionsShown = newValue;
});
//# sourceMappingURL=setIsFullOptionsShown.js.map

/***/ }),

/***/ 3723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var store_1 = __webpack_require__(2113);
exports.default = satcheljs_1.mutatorAction('setSearchTerm', function setSearchTerm(searchTerm) {
    store_1.getStore().searchTerm = searchTerm;
});
//# sourceMappingURL=setSearchTerm.js.map

/***/ }),

/***/ 3724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Export category
var category_1 = __webpack_require__(4916);
exports.GeneralOptions = category_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getTimeZone_1 = __webpack_require__(4922);
var setSupportedTimeZones_1 = __webpack_require__(4924);
function loadTimeZoneOptions() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTimeZone_1.default().then(function (timeZones) {
                        setSupportedTimeZones_1.default(timeZones);
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = loadTimeZoneOptions;
//# sourceMappingURL=loadTimeZoneOptions.js.map

/***/ }),

/***/ 3726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    savedLocale: function () { return owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture; },
    selectedLocale: function () { return store_1.default().selectedLocale; },
    supportedCultures: function () { return store_1.default().supportedCultures; },
    supportedShortDateFormats: function () { return store_1.default().supportedShortDateFormats; },
})(function getFilteredDateFormatOptions(state) {
    var selectedLocaleName = state.selectedLocale || state.savedLocale;
    var selectedLocale = state.supportedCultures.filter(function (culture) { return culture.Name === selectedLocaleName; })[0];
    if (selectedLocale) {
        return state.supportedShortDateFormats.filter(function (shortDateFormat, index) { return selectedLocale.ShortDateFormatsIndexes.indexOf(index) >= 0; });
    }
    else {
        return [];
    }
});
//# sourceMappingURL=getFilteredDateFormatOptions.js.map

/***/ }),

/***/ 3727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    savedLocale: function () { return owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture; },
    selectedLocale: function () { return store_1.default().selectedLocale; },
    supportedCultures: function () { return store_1.default().supportedCultures; },
    supportedShortTimeFormats: function () { return store_1.default().supportedShortTimeFormats; },
})(function getFilteredTimeFormatOptions(state) {
    var selectedLocaleName = state.selectedLocale || state.savedLocale;
    var selectedLocale = state.supportedCultures.filter(function (culture) { return culture.Name === selectedLocaleName; })[0];
    if (selectedLocale) {
        return state.supportedShortTimeFormats.filter(function (shortDateFormat, index) { return selectedLocale.ShortTimeFormatsIndexes.indexOf(index) >= 0; });
    }
    else {
        return [];
    }
});
//# sourceMappingURL=getFilteredTimeFormatOptions.js.map

/***/ }),

/***/ 3728:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var setUserTheme_1 = __webpack_require__(4957);
var getTheme_1 = __webpack_require__(1629);
var loadTheme_1 = __webpack_require__(698);
var owa_options_core_1 = __webpack_require__(1736);
var owa_analytics_1 = __webpack_require__(12);
var onCommitThemeChange_1 = __webpack_require__(4959);
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingTheme';
function commitThemeChange(themeId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var newTheme;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (themeId) {
                        loadTheme_1.default(themeId);
                    }
                    newTheme = getTheme_1.default();
                    onCommitThemeChange_1.default(newTheme);
                    owa_options_core_1.updateUserOptions({ ThemeStorageId: newTheme });
                    return [4 /*yield*/, setUserTheme_1.default(newTheme)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = commitThemeChange;
function commitQuickThemeChange(themeId) {
    owa_analytics_1.logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [
        themeId /* What theme the user chose */,
        getTheme_1.default() /* What theme the user is switching away from */,
    ]);
    commitThemeChange(themeId);
}
exports.commitQuickThemeChange = commitQuickThemeChange;
//# sourceMappingURL=commitThemeChange.js.map

/***/ }),

/***/ 3729:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setUserThemeRequest(data) {
    var result = tslib_1.__assign({ __type: 'SetUserThemeRequest:#Exchange' }, data);
    return result;
}
exports.default = setUserThemeRequest;


/***/ }),

/***/ 3730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var owa_options_strings_1 = __webpack_require__(1737);
var store_1 = __webpack_require__(590);
var React = __webpack_require__(3);
var styles = __webpack_require__(3367);
var classNames = __webpack_require__(30).bind(styles);
var spriteStyles = __webpack_require__(3368);
var ThemeSwatch = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeSwatch, _super);
    function ThemeSwatch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (ev) {
            ev.stopPropagation();
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.themeId);
            }
        };
        return _this;
    }
    ThemeSwatch.prototype.render = function () {
        var themeId = this.props.themeId;
        var isChecked = themeId === store_1.store.theme;
        return (React.createElement("div", { className: classNames(styles.swatch, {
                selected: isChecked,
            }), onClick: this.onClick, "data-is-focusable": "true", role: "option", "aria-checked": isChecked, "aria-label": owa_options_strings_1.default["themeDisplayName_" + themeId], title: owa_options_strings_1.default["themeDisplayName_" + themeId] },
            React.createElement("i", { className: classNames(spriteStyles["theme-icon-" + themeId], styles.image) })));
    };
    ThemeSwatch = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThemeSwatch);
    return ThemeSwatch;
}(React.Component));
exports.default = ThemeSwatch;
//# sourceMappingURL=ThemeSwatch.js.map

/***/ }),

/***/ 3731:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.createStore('themeOption', {
    isQuickOptionExpanded: false,
});
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3732:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var styles = __webpack_require__(4988);
var HeaderContainer = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderContainer, _super);
    function HeaderContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderContainer.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className },
            React.createElement("div", { className: styles.header }, this.props.header),
            this.props.children));
    };
    HeaderContainer = tslib_1.__decorate([
        mobx_react_1.observer
    ], HeaderContainer);
    return HeaderContainer;
}(React.Component));
exports.default = HeaderContainer;
//# sourceMappingURL=HeaderContainer.js.map

/***/ }),

/***/ 3733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 4991));
});
// Delay loaded components
exports.FileProviderView = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.FileProviderView; });
exports.FileProvidersToAddListView = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.FileProvidersToAddListView; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(2893);
var legacy_1 = __webpack_require__(1);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_message_options_1 = __webpack_require__(788);
exports.default = legacy_1.select({
    editorViewState: function () { return store_1.default.editorViewState; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('initializeSignatureContent')(function initializeSignatureContent(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var editorViewState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    editorViewState = state.editorViewState, userOptions = state.userOptions;
                    return [4 /*yield*/, owa_options_message_options_1.lazyLoadSignatureInUserOptions.importAndExecute()];
                case 1:
                    _a.sent();
                    editorViewState.content = userOptions.SignatureHtml;
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=initializeSignatureContent.js.map

/***/ }),

/***/ 3735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function createEditorViewState(content, isDirty, cursorStyle) {
    if (cursorStyle === void 0) { cursorStyle = ''; }
    return {
        content: content,
        isDirty: isDirty,
        cursorStyle: cursorStyle,
    };
}
exports.default = createEditorViewState;
//# sourceMappingURL=createEditorViewState.js.map

/***/ }),

/***/ 3736:
/***/ (function(module, exports) {


module.exports = function equal(arr1, arr2) {
  var length = arr1.length
  if (length !== arr2.length) return false
  for (var i = 0; i < length; i++)
    if (arr1[i] !== arr2[i])
      return false
  return true
}


/***/ }),

/***/ 3737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ChoiceGroupWithImages_1 = __webpack_require__(5070);
exports.ChoiceGroupWithImages = ChoiceGroupWithImages_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(2895);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var owa_analytics_1 = __webpack_require__(12);
var onListViewTypeOptionSaved_1 = __webpack_require__(800);
var saveConversationsOptionStitchName = 'saveConversationsOptionStitchName';
var saveConversationsOption = legacy_1.action('saveConversationsOption')(function saveConversationsOption(newListViewType, conversationSortOrder, hideDeletedItems, userOptions) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var serviceUpdates, sortOrderValue;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    serviceUpdates = [];
                    if (newListViewType !== null && newListViewType !== userOptions.GlobalListViewTypeReact) {
                        userOptions.GlobalListViewTypeReact = newListViewType;
                        onListViewTypeOptionSaved_1.onListViewTypeOptionSaved(newListViewType);
                        serviceUpdates.push({
                            propertyName: 'GlobalListViewTypeReact',
                            propertyType: 'Integer32',
                            propertyValue: "" + newListViewType,
                        });
                    }
                    if (conversationSortOrder) {
                        userOptions.ConversationSortOrderReact = conversationSortOrder;
                        sortOrderValue = void 0;
                        switch (userOptions.ConversationSortOrderReact) {
                            case 'Chronological':
                                sortOrderValue = 0x1;
                                break;
                            case 'Tree':
                                sortOrderValue = 0x2;
                                break;
                            case 'NewestOnTop':
                                sortOrderValue = 0x4;
                                break;
                            case 'NewestOnBottom':
                                sortOrderValue = 0x8;
                                break;
                            case 'ChronologicalNewestOnTop':
                                sortOrderValue = 0x5;
                                break;
                            case 'ChronologicalNewestOnBottom':
                                sortOrderValue = 0x9;
                                break;
                            case 'TreeNewestOnBottom':
                                sortOrderValue = 0xa;
                                break;
                        }
                        serviceUpdates.push({
                            propertyName: 'ConversationSortOrderReact',
                            propertyType: 'Integer32',
                            propertyValue: "" + sortOrderValue,
                        });
                    }
                    if (hideDeletedItems !== null) {
                        userOptions.HideDeletedItems = hideDeletedItems;
                        serviceUpdates.push({
                            propertyName: 'HideDeletedItems',
                            propertyType: 'Boolean',
                            propertyValue: "" + userOptions.HideDeletedItems,
                        });
                    }
                    // Raise stitch so that, if we're running in mail, the conversation cache will be cleaned
                    stitch_1.raiseAction(saveConversationsOptionStitchName)();
                    if (!serviceUpdates.length) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration(serviceUpdates)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
});
exports.saveConversationsOptionFull = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveConversationsOptionFull')(function saveConversationsOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions, optionState = state.optionState;
                    return [4 /*yield*/, saveConversationsOption(optionState.globalListViewType, optionState.conversationSortOrder, optionState.hideDeletedItems, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingConversations';
exports.saveConversationsOptionQuick = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveConversationsOptionQuick')(function saveConversationsOptionQuick(isConversationViewEnabled, newSortOrder, state) {
    owa_analytics_1.logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [newSortOrder]);
    saveConversationsOption(isConversationViewEnabled ? 0 /* Conversation */ : 1 /* Message */, newSortOrder, null, state.userOptions);
}));
//# sourceMappingURL=saveConversationsOption.js.map

/***/ }),

/***/ 3739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var listViewBitFlagsUtil_1 = __webpack_require__(243);
function isDateHeaderEnabled() {
    return !listViewBitFlagsUtil_1.getIsBitSet(2 /* DateHeadersDisabled */);
}
exports.default = isDateHeaderEnabled;
//# sourceMappingURL=isDateHeaderEnabled.js.map

/***/ }),

/***/ 3740:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Button_1 = __webpack_require__(62);
var owa_common_strings_1 = __webpack_require__(37);
var spriteStyles = __webpack_require__(3381);
var styles = __webpack_require__(3383);
var classNames = __webpack_require__(30).bind(styles);
var FormatButton = /** @class */ (function (_super) {
    tslib_1.__extends(FormatButton, _super);
    function FormatButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            if (_this.props.onClick) {
                _this.props.onClick(!_this.props.isSelected);
            }
        };
        return _this;
    }
    FormatButton.prototype.render = function () {
        return (React.createElement(Button_1.Button, { buttonType: Button_1.ButtonType.icon, type: this.props.type, className: classNames(styles.formatButton, {
                isSelected: this.props.isSelected,
            }), "data-is-focusable": true, title: owa_common_strings_1.default[this.props.type], onClick: this.onClick },
            React.createElement("span", { className: spriteStyles["ribbon-icon-" + this.props.type] })));
    };
    return FormatButton;
}(React.Component));
exports.default = FormatButton;
//# sourceMappingURL=FormatButton.js.map

/***/ }),

/***/ 3741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function disableInboxRuleRequest(data) {
    var result = tslib_1.__assign({ __type: 'DisableInboxRuleRequest:#Exchange' }, data);
    return result;
}
exports.default = disableInboxRuleRequest;


/***/ }),

/***/ 3742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function enableInboxRuleRequest(data) {
    var result = tslib_1.__assign({ __type: 'EnableInboxRuleRequest:#Exchange' }, data);
    return result;
}
exports.default = enableInboxRuleRequest;


/***/ }),

/***/ 3743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function removeInboxRuleRequest(data) {
    var result = tslib_1.__assign({ __type: 'RemoveInboxRuleRequest:#Exchange' }, data);
    return result;
}
exports.default = removeInboxRuleRequest;


/***/ }),

/***/ 3744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setInboxAndSweepRulesRequest(data) {
    var result = tslib_1.__assign({ __type: 'SetInboxAndSweepRulesRequest:#Exchange' }, data);
    return result;
}
exports.default = setInboxAndSweepRulesRequest;


/***/ }),

/***/ 3745:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5188);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3746:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var setClauseValue_1 = __webpack_require__(3178);
var legacy_1 = __webpack_require__(1);
/**
 * Removes the phrase pill from the input box of the 'includes' type of clauses
 * @param clauseId the id of the clause to remove the phrase from
 * @param phraseToRemove the phrase to remove from the clause
 */
exports.default = legacy_1.action('removePhraseFromClause')(function removePhraseFromClause(clauseId, phraseToRemove) {
    var existingPhrases = store_1.default.inboxRulesEditState.clauseMap.get(clauseId).clauseValue;
    var indexToRemove = existingPhrases.indexOf(phraseToRemove);
    if (indexToRemove == -1) {
        throw new Error('Phrase not found in existing phrases');
    }
    existingPhrases.splice(indexToRemove, 1);
    setClauseValue_1.default(existingPhrases, clauseId);
});
//# sourceMappingURL=removePhraseFromClause.js.map

/***/ }),

/***/ 3747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = __webpack_require__(1737);
function getClauseSectionProperties(sectionType) {
    switch (sectionType) {
        case 'conditional':
            return {
                addClauseText: owa_options_strings_1.default.options_inboxRules_addCondition,
                headerText: owa_options_strings_1.default.options_inboxRules_conditionsHeader,
                calloutText: owa_options_strings_1.default.options_inboxRules_conditionsInfo,
                isOptional: false,
            };
        case 'action':
            return {
                addClauseText: owa_options_strings_1.default.options_inboxRules_addAction,
                headerText: owa_options_strings_1.default.options_inboxRules_actionsHeader,
                calloutText: owa_options_strings_1.default.options_inboxRules_actionsInfo,
                isOptional: false,
            };
        case 'exception':
            return {
                addClauseText: owa_options_strings_1.default.options_inboxRules_addException,
                headerText: owa_options_strings_1.default.options_inboxRules_exceptionsHeader,
                calloutText: owa_options_strings_1.default.options_inboxRules_exceptionsInfo,
                isOptional: true,
            };
        case 'name':
            return null;
        default:
            throw new Error('Cannot get section properties for section that does not exist');
    }
}
exports.default = getClauseSectionProperties;
//# sourceMappingURL=getClauseSectionProperties.js.map

/***/ }),

/***/ 3748:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MESSAGE_SIZE = 2147483.647; // 2GB
exports.KB_TO_B = 1024;
//# sourceMappingURL=ClauseValueType.js.map

/***/ }),

/***/ 3749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Sets the input text of the IncludesWordsInput text field
 * @param clauseId the id of the clause that corresponds to the input
 * @param inputText the current text in the input field
 */
exports.default = legacy_1.action('setIncludesWordsInputText')(function setIncludesWordsInputText(clauseId, inputText) {
    store_1.default.inboxRulesEditState.includesWordsInputTextMap.set(clauseId, inputText);
});
//# sourceMappingURL=setIncludesWordsInputText.js.map

/***/ }),

/***/ 3750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Sets the input text of the IncludesWordsInput text field
 * @param clauseId the id of the clause that corresponds to the input
 * @param inputText the current text in the input field
 */
exports.default = legacy_1.action('setFocusedClauseId')(function setFocusedClauseId(clauseId, shouldSetAsFocused) {
    store_1.default.inboxRulesEditState.focusedClauseId = shouldSetAsFocused ? clauseId : '';
});
//# sourceMappingURL=setFocusedClauseId.js.map

/***/ }),

/***/ 3752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Set the InboxRuleDiagnosticRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules diagnostic request status to set
 */
exports.default = legacy_1.action('setInboxRuleDiagnosticRequestStatus')(function setInboxRuleDiagnosticRequestStatus(requestStatus) {
    store_1.default.inboxRulesListState.getInboxRuleDiagnosticRequestStatus = requestStatus;
});
//# sourceMappingURL=setInboxRuleDiagnosticRequestStatus.js.map

/***/ }),

/***/ 3753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getOutlookMigrationDiagnosticsRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetOutlookMigrationDiagnosticsRequest:#Exchange' }, data);
    return result;
}
exports.default = getOutlookMigrationDiagnosticsRequest;


/***/ }),

/***/ 3754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var datapoints_1 = __webpack_require__(2896);
var setGetInboxRuleRequestStatus_1 = __webpack_require__(5219);
var getInboxRulesService_1 = __webpack_require__(5220);
var store_1 = __webpack_require__(2603);
var mobx_1 = __webpack_require__(15);
var owa_analytics_1 = __webpack_require__(12);
var owa_analytics_2 = __webpack_require__(12);
var DraggableItemTypes_1 = __webpack_require__(349);
var legacy_1 = __webpack_require__(1);
var logInboxRuleInformation_1 = __webpack_require__(3756);
/**
 * Gets inbox rules and stores them in the inboxRules options store
 */
// Task 20143: Full error handling / success notification support
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(legacy_1.action('getInboxRules', datapoints_1.default.getInboxRulesDatapoint)(function getInboxRules(state) {
    var optionState = state.optionState;
    setGetInboxRuleRequestStatus_1.default(1 /* Pending */);
    optionState.inboxRuleIds = [];
    optionState.inboxRules = mobx_1.map({});
    var dataPoint = owa_analytics_2.returnTopExecutingActionDatapoint();
    return getInboxRulesService_1.default()
        .then(function (response) {
        if (response.WasSuccessful) {
            setGetInboxRuleRequestStatus_1.default(2 /* Complete */);
            var inboxRuleCollection = response.InboxRuleCollection.InboxRules;
            var _a = datapoints_1.default.numInboxRules.datapoint, eventName = _a.name, customData = _a.customData;
            owa_analytics_1.logUsage(eventName, customData(inboxRuleCollection.length));
            for (var i = 0; i < inboxRuleCollection.length; i++) {
                addInboxRuleToStore(inboxRuleCollection[i], optionState);
                if (!optionState.hasLoggedGetInboxRulesInformation) {
                    logInboxRuleInformation_1.default(inboxRuleCollection[i], 'GetInboxRules');
                }
            }
            optionState.hasLoggedGetInboxRulesInformation = true;
        }
        else {
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            setGetInboxRuleRequestStatus_1.default(3 /* Error */);
            dataPoint.endWithError(owa_analytics_2.DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        setGetInboxRuleRequestStatus_1.default(3 /* Error */);
        dataPoint.endWithError(owa_analytics_2.DatapointStatus.ServerError, error.message);
    });
}));
var addInboxRuleToStore = legacy_1.action('addInboxRuleToStore')(function addInboxRuleToStore(inboxRule, optionState) {
    optionState.inboxRuleIds.push(inboxRule.Identity.RawIdentity);
    // transform inbox rule to InboxRuleRowType and add to map
    optionState.inboxRules.set(inboxRule.Identity.RawIdentity, tslib_1.__assign({}, inboxRule, { drop: {
            isDragOver: false,
            draggableItemType: DraggableItemTypes_1.DraggableItemTypes.InboxRule,
        } }));
});
//# sourceMappingURL=getInboxRules.js.map

/***/ }),

/***/ 3755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getInboxRuleRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetInboxRuleRequest:#Exchange' }, data);
    return result;
}
exports.default = getInboxRuleRequest;


/***/ }),

/***/ 3756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getActionClauseTypeOptions_1 = __webpack_require__(2795);
var getConditionalExceptionClauseTypeOptions_1 = __webpack_require__(2796);
var datapoints_1 = __webpack_require__(2896);
var folderIdToName_1 = __webpack_require__(48);
var owa_analytics_1 = __webpack_require__(12);
function logInboxRuleInformation(inboxRule, actionSource) {
    var ruleToLog = {};
    var numActionClauses = 0;
    var numConditionalClauses = 0;
    var numExceptionClauses = 0;
    var _a = datapoints_1.default.inboxRuleInformationDatapoint.datapoint, eventName = _a.name, customData = _a.customData;
    // map conditional clauses
    var conditionalExceptionClauseOptions = getConditionalExceptionClauseTypeOptions_1.default();
    var actionClauseOptions = getActionClauseTypeOptions_1.default();
    for (var _i = 0, conditionalExceptionClauseOptions_1 = conditionalExceptionClauseOptions; _i < conditionalExceptionClauseOptions_1.length; _i++) {
        var conditionalClause = conditionalExceptionClauseOptions_1[_i];
        switch (conditionalClause) {
            case 'from':
                if (inboxRule.From) {
                    ruleToLog.NumFrom = inboxRule.From.length;
                    numConditionalClauses++;
                }
                break;
            case 'to':
                if (inboxRule.SentTo) {
                    ruleToLog.NumSentTo = inboxRule.SentTo.length;
                    numConditionalClauses++;
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.MyNameInToOrCcBox) {
                    ruleToLog.MyNameInToOrCcBox = inboxRule.MyNameInToOrCcBox;
                    numConditionalClauses++;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.SentOnlyToMe) {
                    ruleToLog.SentOnlyToMe = inboxRule.SentOnlyToMe;
                    numConditionalClauses++;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.MyNameInToBox) {
                    ruleToLog.MyNameInToBox = inboxRule.MyNameInToBox;
                    numConditionalClauses++;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.MyNameInCcBox) {
                    ruleToLog.MyNameInCcBox = inboxRule.MyNameInCcBox;
                    numConditionalClauses++;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.MyNameNotInToBox) {
                    ruleToLog.MyNameNotInToBox = inboxRule.MyNameNotInToBox;
                    numConditionalClauses++;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.SubjectContainsWords) {
                    ruleToLog.NumSubjectContainsWordsPills = inboxRule.SubjectContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.SubjectOrBodyContainsWords) {
                    ruleToLog.NumSubjectOrBodyContainsWordsPills =
                        inboxRule.SubjectOrBodyContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheBody':
                if (inboxRule.BodyContainsWords) {
                    ruleToLog.NumBodyContainsWordsPills = inboxRule.BodyContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.FromAddressContainsWords) {
                    ruleToLog.NumFromAddressContainsWordsPills =
                        inboxRule.FromAddressContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.RecipientAddressContainsWords) {
                    ruleToLog.NumRecipientAddressContainsWordsPills =
                        inboxRule.RecipientAddressContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.HeaderContainsWords) {
                    ruleToLog.NumHeaderContainsWordsPills = inboxRule.HeaderContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'withImportance':
                if (inboxRule.WithImportance && inboxRule.WithImportance != 'NullImportance') {
                    ruleToLog.WithImportance = inboxRule.WithImportance;
                    numConditionalClauses++;
                }
                break;
            case 'sensitivity':
                if (inboxRule.WithSensitivity && inboxRule.WithSensitivity != 'NullSensitivity') {
                    ruleToLog.WithSensitivity = inboxRule.WithSensitivity;
                    numConditionalClauses++;
                }
                break;
            case 'flag':
                if (inboxRule.FlaggedForAction &&
                    inboxRule.FlaggedForAction != 'NullInboxRuleMessageFlag') {
                    ruleToLog.FlaggedForAction = inboxRule.FlaggedForAction;
                    numConditionalClauses++;
                }
                break;
            case 'type':
                if (inboxRule.MessageTypeMatches &&
                    inboxRule.MessageTypeMatches != 'NullInboxRuleMessageType') {
                    ruleToLog.MessageTypeMatches = inboxRule.MessageTypeMatches;
                    numConditionalClauses++;
                }
                break;
            case 'attachment':
                if (inboxRule.HasAttachment) {
                    ruleToLog.HasAttachment = inboxRule.HasAttachment;
                    numConditionalClauses++;
                }
                break;
        }
    }
    for (var _b = 0, actionClauseOptions_1 = actionClauseOptions; _b < actionClauseOptions_1.length; _b++) {
        var actionClause = actionClauseOptions_1[_b];
        switch (actionClause) {
            case 'moveTo':
                if (inboxRule.MoveToFolder) {
                    // We are only given RawIdentity from the server on the inbox rule, which can't be used to get the folder name
                    if (actionSource == 'GetInboxRules' || actionSource == 'EditInboxRule') {
                        ruleToLog.MoveToFolder = 'unknown';
                    }
                    else {
                        ruleToLog.MoveToFolder ==
                            folderIdToName_1.default(inboxRule.MoveToFolder.RawIdentity);
                    }
                    numActionClauses++;
                }
                break;
            case 'copyTo':
                if (inboxRule.CopyToFolder) {
                    // We are only given RawIdentity from the server on the inbox rule, which can't be used to get the folder name
                    if (actionSource == 'GetInboxRules' || actionSource == 'EditInboxRule') {
                        ruleToLog.MoveToFolder = 'unknown';
                    }
                    else {
                        ruleToLog.CopyToFolder = folderIdToName_1.default(inboxRule.MoveToFolder.RawIdentity);
                    }
                    numActionClauses++;
                }
                break;
            case 'delete':
                if (inboxRule.DeleteMessage) {
                    ruleToLog.DeleteMessage = inboxRule.DeleteMessage;
                    numActionClauses++;
                }
                break;
            case 'pin':
                if (inboxRule.PinMessage) {
                    ruleToLog.PinMessage = inboxRule.PinMessage;
                    numActionClauses++;
                }
                break;
            case 'read':
                if (inboxRule.MarkAsRead) {
                    ruleToLog.MarkAsRead = inboxRule.MarkAsRead;
                    numActionClauses++;
                }
                break;
            case 'markImportance':
                if (inboxRule.MarkImportance && inboxRule.MarkImportance != 'NullImportance') {
                    ruleToLog.MarkImportance = inboxRule.MarkImportance;
                    numActionClauses++;
                }
                break;
            case 'forwardTo':
                if (inboxRule.ForwardTo) {
                    ruleToLog.NumForwardTo = inboxRule.ForwardTo.length;
                    numActionClauses++;
                }
                break;
            case 'forwardAsAttachmentTo':
                if (inboxRule.ForwardAsAttachmentTo) {
                    ruleToLog.NumForwardAsAttachmentTo = inboxRule.ForwardAsAttachmentTo.length;
                    numActionClauses++;
                }
                break;
            case 'redirectTo':
                if (inboxRule.RedirectTo) {
                    ruleToLog.NumRedirectTo = inboxRule.RedirectTo.length;
                    numActionClauses++;
                }
                break;
        }
    }
    for (var _c = 0, conditionalExceptionClauseOptions_2 = conditionalExceptionClauseOptions; _c < conditionalExceptionClauseOptions_2.length; _c++) {
        var exceptionClause = conditionalExceptionClauseOptions_2[_c];
        switch (exceptionClause) {
            case 'from':
                if (inboxRule.ExceptIfFrom) {
                    ruleToLog.NumExceptIfFrom = inboxRule.ExceptIfFrom.length;
                    numExceptionClauses++;
                }
                break;
            case 'to':
                if (inboxRule.ExceptIfSentTo) {
                    ruleToLog.NumExceptIfSentTo = inboxRule.ExceptIfSentTo.length;
                    numExceptionClauses++;
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.ExceptIfMyNameInToOrCcBox) {
                    ruleToLog.ExceptIfMyNameInToOrCcBox = inboxRule.ExceptIfMyNameInToOrCcBox;
                    numExceptionClauses++;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.ExceptIfSentOnlyToMe) {
                    ruleToLog.ExceptIfSentOnlyToMe = inboxRule.ExceptIfSentOnlyToMe;
                    numExceptionClauses++;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.ExceptIfMyNameInToBox) {
                    ruleToLog.ExceptIfMyNameInToBox = inboxRule.ExceptIfMyNameInToBox;
                    numExceptionClauses++;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.ExceptIfMyNameInCcBox) {
                    ruleToLog.ExceptIfMyNameInCcBox = inboxRule.ExceptIfMyNameInCcBox;
                    numExceptionClauses++;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.ExceptIfMyNameNotInToBox) {
                    ruleToLog.ExceptIfMyNameNotInToBox = inboxRule.ExceptIfMyNameNotInToBox;
                    numExceptionClauses++;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.ExceptIfSubjectContainsWords) {
                    ruleToLog.NumExceptIfSubjectContainsWordsPills =
                        inboxRule.ExceptIfSubjectContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.ExceptIfSubjectOrBodyContainsWords) {
                    ruleToLog.NumExceptIfSubjectOrBodyContainsWordsPills =
                        inboxRule.ExceptIfSubjectOrBodyContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheBody':
                if (inboxRule.ExceptIfBodyContainsWords) {
                    ruleToLog.NumExceptIfBodyContainsWordsPills =
                        inboxRule.ExceptIfBodyContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.ExceptIfFromAddressContainsWords) {
                    ruleToLog.NumExceptIfFromAddressContainsWordsPills =
                        inboxRule.ExceptIfFromAddressContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.ExceptIfRecipientAddressContainsWords) {
                    ruleToLog.NumExceptIfRecipientAddressContainsWordsPills =
                        inboxRule.ExceptIfRecipientAddressContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.ExceptIfHeaderContainsWords) {
                    ruleToLog.NumExceptIfHeaderContainsWordsPills =
                        inboxRule.ExceptIfHeaderContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'withImportance':
                if (inboxRule.ExceptIfWithImportance &&
                    inboxRule.ExceptIfWithImportance != 'NullImportance') {
                    ruleToLog.ExceptIfWithImportance = inboxRule.ExceptIfWithImportance;
                    numExceptionClauses++;
                }
                break;
            case 'sensitivity':
                if (inboxRule.ExceptIfWithSensitivity &&
                    inboxRule.ExceptIfWithSensitivity != 'NullSensitivity') {
                    ruleToLog.ExceptIfWithSensitivity = inboxRule.ExceptIfWithSensitivity;
                    numExceptionClauses++;
                }
                break;
            case 'flag':
                if (inboxRule.ExceptIfFlaggedForAction &&
                    inboxRule.ExceptIfFlaggedForAction != 'NullInboxRuleMessageFlag') {
                    ruleToLog.ExceptIfFlaggedForAction = inboxRule.ExceptIfFlaggedForAction;
                    numExceptionClauses++;
                }
                break;
            case 'type':
                if (inboxRule.ExceptIfMessageTypeMatches &&
                    inboxRule.ExceptIfMessageTypeMatches != 'NullInboxRuleMessageType') {
                    ruleToLog.ExceptIfMessageTypeMatches = inboxRule.ExceptIfMessageTypeMatches;
                    numExceptionClauses++;
                }
                break;
            case 'attachment':
                if (inboxRule.ExceptIfHasAttachment) {
                    ruleToLog.ExceptIfHasAttachment = inboxRule.ExceptIfHasAttachment;
                    numExceptionClauses++;
                }
                break;
        }
    }
    ruleToLog.StopProcessingRules = inboxRule.StopProcessingRules;
    owa_analytics_1.logUsage(eventName, customData(ruleToLog, actionSource, numConditionalClauses, numActionClauses, numExceptionClauses));
}
exports.default = logInboxRuleInformation;
//# sourceMappingURL=logInboxRuleInformation.js.map

/***/ }),

/***/ 3757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
function isInboxRuleOptionEditState() {
    return store_1.default.inboxRulesEditState.clauseMap.size > 0;
}
exports.default = isInboxRuleOptionEditState;
//# sourceMappingURL=isInboxRuleOptionEditState.js.map

/***/ }),

/***/ 3758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setInboxRuleRequest(data) {
    var result = tslib_1.__assign({ __type: 'SetInboxRuleRequest:#Exchange' }, data);
    return result;
}
exports.default = setInboxRuleRequest;


/***/ }),

/***/ 3759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3084);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardSurfaceActionsOption')(function discardSurfaceActionsOption(state) {
    var optionState = state.optionState;
    optionState.readSurfaceActions = null;
    optionState.readSurfaceAddins = null;
    optionState.composeSurfaceActions = null;
    optionState.composeSurfaceAddins = null;
}));
//# sourceMappingURL=discardSurfaceActionsOption.js.map

/***/ }),

/***/ 3760:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3084);
var owa_options_core_1 = __webpack_require__(1736);
var legacy_1 = __webpack_require__(1);
var owa_outlook_service_options_1 = __webpack_require__(2110);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SurfaceActions);
    },
})(legacy_1.action('saveSurfaceActionsOption')(function saveSurfaceActionsOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.readSurfaceActions = owa_options_core_1.getFallbackValueIfNull(optionState.readSurfaceActions, userOptions.readSurfaceActions);
                    userOptions.readSurfaceAddins = owa_options_core_1.getFallbackValueIfNull(optionState.readSurfaceAddins, userOptions.readSurfaceAddins);
                    userOptions.composeSurfaceActions = owa_options_core_1.getFallbackValueIfNull(optionState.composeSurfaceActions, userOptions.composeSurfaceActions);
                    userOptions.composeSurfaceAddins = owa_options_core_1.getFallbackValueIfNull(optionState.composeSurfaceAddins, userOptions.composeSurfaceAddins);
                    return [4 /*yield*/, owa_outlook_service_options_1.lazyCreateOrUpdateOptionsForFeature.importAndExecute(owa_outlook_service_options_1.OwsOptionsFeatureType.SurfaceActions, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSurfaceActionsOption.js.map

/***/ }),

/***/ 3761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var SurfaceActionsShared_1 = __webpack_require__(5238);
var store_1 = __webpack_require__(3084);
var owa_addins_core_1 = __webpack_require__(1738);
var owa_mail_feature_flags_1 = __webpack_require__(23);
var owa_options_core_1 = __webpack_require__(1736);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_outlook_service_options_1 = __webpack_require__(2110);
var owa_surface_actions_1 = __webpack_require__(2942);
var ABSTRACT_COMPOSE_SVG = __webpack_require__(5241);
var ABSTRACT_ITEM_PART_SVG = __webpack_require__(5242);
var styles = __webpack_require__(3762);
var SurfaceActionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(SurfaceActionsFull, _super);
    function SurfaceActionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurfaceActionsFull.prototype.render = function () {
        var _a = this.props, isCompose = _a.isCompose, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var actions = [];
        var addins = [];
        var selectedActions = [];
        var selectedAddins = [];
        var actionsOptionName;
        var addinsOptionName;
        var actionDisplayNameGetter;
        var actionIconNameGetter;
        var previewImageUri;
        var previewClassName;
        var extMode;
        if (isCompose) {
            actions = owa_surface_actions_1.getComposeStaticActions();
            extMode = owa_addins_core_1.ExtensibilityModeEnum.MessageCompose;
            // Get action/addin arrays and slice them to create a copy so we don't modify the real data.
            selectedActions = owa_options_core_1.getFallbackValueIfNull(optionStore.composeSurfaceActions, userOptions.composeSurfaceActions).slice();
            selectedAddins = owa_options_core_1.getFallbackValueIfNull(optionStore.composeSurfaceAddins, userOptions.composeSurfaceAddins).slice();
            actionsOptionName = 'composeSurfaceActions';
            addinsOptionName = 'composeSurfaceAddins';
            actionDisplayNameGetter = owa_surface_actions_1.getComposeActionDisplayName;
            actionIconNameGetter = owa_surface_actions_1.getComposeActionIconName;
            previewImageUri = ABSTRACT_COMPOSE_SVG;
            previewClassName = styles.composePreview;
        }
        else {
            actions = owa_surface_actions_1.getReadStaticActions();
            extMode = owa_addins_core_1.ExtensibilityModeEnum.MessageRead;
            // Get action/addin arrays and slice them to create a copy so we don't modify the real data.
            selectedActions = owa_options_core_1.getFallbackValueIfNull(optionStore.readSurfaceActions, userOptions.readSurfaceActions).slice();
            selectedAddins = owa_options_core_1.getFallbackValueIfNull(optionStore.readSurfaceAddins, userOptions.readSurfaceAddins).slice();
            actionsOptionName = 'readSurfaceActions';
            addinsOptionName = 'readSurfaceAddins';
            actionDisplayNameGetter = owa_surface_actions_1.getReadActionDisplayName;
            actionIconNameGetter = owa_surface_actions_1.getReadActionIconName;
            previewImageUri = ABSTRACT_ITEM_PART_SVG;
            previewClassName = styles.readingPanePreview;
        }
        if (owa_mail_feature_flags_1.isMailFeatureEnabled('rp-addins')) {
            var addinCollection = owa_surface_actions_1.getAddinCollection(extMode);
            addins = addinCollection ? addinCollection.sectionProps.items : [];
        }
        return (React.createElement("div", null,
            React.createElement(SurfaceActionsShared_1.default, { actions: actions, addins: addins, selectedActions: selectedActions, selectedAddins: selectedAddins, actionsOptionName: actionsOptionName, addinsOptionName: addinsOptionName, getDisplayNameFromAction: actionDisplayNameGetter, getIconNameFromAction: actionIconNameGetter, isLeftToRight: isCompose, previewImageUri: previewImageUri, previewClassName: previewClassName })));
    };
    SurfaceActionsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () {
                return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SurfaceActions);
            },
        })
    ], SurfaceActionsFull);
    return SurfaceActionsFull;
}(React.Component));
exports.default = SurfaceActionsFull;
//# sourceMappingURL=SurfaceActionsFull.js.map

/***/ }),

/***/ 3762:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5240);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3763:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3084);
var owa_options_core_1 = __webpack_require__(1736);
var legacy_1 = __webpack_require__(1);
var owa_outlook_service_options_1 = __webpack_require__(2110);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SurfaceActions);
    },
})(function isSurfaceActionsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (isOptionDirty(owa_options_core_1.getFallbackValueIfNull(optionState.readSurfaceActions, userOptions.readSurfaceActions), userOptions.readSurfaceActions) ||
        isOptionDirty(owa_options_core_1.getFallbackValueIfNull(optionState.readSurfaceAddins, userOptions.readSurfaceAddins), userOptions.readSurfaceAddins) ||
        isOptionDirty(owa_options_core_1.getFallbackValueIfNull(optionState.composeSurfaceActions, userOptions.composeSurfaceActions), userOptions.composeSurfaceActions) ||
        isOptionDirty(owa_options_core_1.getFallbackValueIfNull(optionState.composeSurfaceAddins, userOptions.composeSurfaceAddins), userOptions.composeSurfaceAddins));
});
function isOptionDirty(optionState, userOption) {
    // For easy array comparison:
    // First, slice each array to create a copy so we don't modify the real data.
    // Second, sort them since order isn't important for this feature.
    // Third, join them to create a single string of all the actions/addins.
    // Finally, compare the strings.
    return (optionState
        .slice()
        .sort()
        .join() !==
        userOption
            .slice()
            .sort()
            .join());
}
//# sourceMappingURL=isSurfaceActionsOptionDirty.js.map

/***/ }),

/***/ 3764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var category_1 = __webpack_require__(5244);
exports.CalendarOptions = category_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3765:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(3413);
var getMailboxCalendarConfiguration_1 = __webpack_require__(5249);
exports.default = legacy_1.action('initCalendarMailboxConfiguration')(function initCalendarMailboxConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (store_1.default.calendarConfiguration) {
                        // If we already have the mailbox configuration, we won't get it again
                        return [2 /*return*/];
                    }
                    _a = store_1.default;
                    return [4 /*yield*/, getMailboxCalendarConfiguration_1.default()];
                case 1:
                    _a.calendarConfiguration = _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initCalendarMailboxConfiguration.js.map

/***/ }),

/***/ 3766:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setMailboxCalendarConfigurationRequest(data) {
    var result = tslib_1.__assign({ __type: 'SetMailboxCalendarConfigurationRequest:#Exchange' }, data);
    return result;
}
exports.default = setMailboxCalendarConfigurationRequest;


/***/ }),

/***/ 3767:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var owa_trace_1 = __webpack_require__(14);
function loadCalendarMailboxConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, owa_calendar_configuration_1.initCalendarMailboxConfiguration()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    owa_trace_1.trace.warn(e_1.message || 'loadCalendarMailboxConfiguration failed');
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.default = loadCalendarMailboxConfiguration;
//# sourceMappingURL=loadCalendarMailboxConfiguration.js.map

/***/ }),

/***/ 3768:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3095);
var legacy_1 = __webpack_require__(1);
/**
 * The action to update the flags behind the checkboxes in the txp options UI
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('updateTxpFlag')(function updateTxpFlag(flagName, enabled, state) {
    var optionState = state.optionState;
    if (flagName == 'EventsFromEmailEnabled' || flagName == 'CreateEventsFromEmailAsPrivate') {
        optionState[flagName] = enabled;
    }
    else {
        optionState.Events[flagName] = enabled;
    }
}));
//# sourceMappingURL=updateTxpFlag.js.map

/***/ }),

/***/ 3769:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getCurrentCategory_1 = __webpack_require__(3770);
var store_1 = __webpack_require__(2113);
var mobx_1 = __webpack_require__(15);
var currentSubcategory = mobx_1.computed(function () {
    var currentCategory = getCurrentCategory_1.default();
    for (var subcategoryIndex = 0; currentCategory && subcategoryIndex < currentCategory.subcategories.length; subcategoryIndex++) {
        var currentSubcategory_1 = currentCategory.subcategories[subcategoryIndex];
        if (currentSubcategory_1.key === store_1.getStore().currentSubCategoryKey) {
            return currentSubcategory_1;
        }
    }
    return {};
});
exports.default = function () { return currentSubcategory.get(); };
//# sourceMappingURL=getCurrentSubcategory.js.map

/***/ }),

/***/ 3770:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var collectedOptions_1 = __webpack_require__(3173);
var store_1 = __webpack_require__(2113);
var mobx_1 = __webpack_require__(15);
var currentCategory = mobx_1.computed(function () {
    for (var categoryIndex = 0; categoryIndex < collectedOptions_1.default().length; categoryIndex++) {
        var currentCategory_1 = collectedOptions_1.default()[categoryIndex];
        if (currentCategory_1.key == store_1.getStore().currentCategoryKey) {
            return currentCategory_1;
        }
    }
    return null;
});
exports.default = function () { return currentCategory.get(); };
//# sourceMappingURL=getCurrentCategory.js.map

/***/ }),

/***/ 3771:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var collectedOptions_1 = __webpack_require__(3173);
var mobx_1 = __webpack_require__(15);
var allOptions = mobx_1.computed(function () {
    var allOptions = [];
    collectedOptions_1.default().forEach(function (category) {
        category.subcategories.forEach(function (subcategory) {
            allOptions = allOptions.concat(subcategory.options.map(function (option) { return (tslib_1.__assign({}, option, { categoryKey: category.key, subcategoryKey: subcategory.key })); }));
        });
    });
    return allOptions;
});
exports.default = function () { return allOptions.get(); };
//# sourceMappingURL=getAllOptions.js.map

/***/ }),

/***/ 3772:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var owa_options_store_1 = __webpack_require__(2641);
var owa_analytics_1 = __webpack_require__(12);
var owa_options_store_2 = __webpack_require__(2641);
var OPTION_NAVIGATION_KEY = 'OptionDirectNavigation';
exports.default = satcheljs_1.orchestratorAction('showFullOptions', function showFullOptions(category, subcategory, option) {
    if (option) {
        // The option value is only set if the user navigated to a specific option,
        // rather than just opening the full options from the link at the bottom of the flex pane.
        // We should log the option chosen, as well as the current search term
        owa_analytics_1.logUsage(OPTION_NAVIGATION_KEY, [option, owa_options_store_1.getStore().searchTerm]);
    }
    owa_options_store_2.initializeFullOptions(category, subcategory, option);
});
//# sourceMappingURL=showFullOptions.js.map

/***/ }),

/***/ 3773:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.action('ON_QUICK_OPTION_TOGGLE', function (isToggledOn, option) { return ({
    isToggledOn: isToggledOn,
    option: option,
}); });
//# sourceMappingURL=onQuickOptionToggle.js.map

/***/ }),

/***/ 3774:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_store_1 = __webpack_require__(2641);
var owa_options_strings_1 = __webpack_require__(1737);
var legacy_1 = __webpack_require__(1);
var escapeRegExp = __webpack_require__(5288);
exports.default = legacy_1.select({
    options: function () { return owa_options_store_1.getAllOptions(); },
})(function filterOptions(searchTerm, state) {
    if (!searchTerm) {
        return null;
    }
    var searchRegex = RegExp(escapeRegExp(searchTerm.trim()), 'i');
    return state.options.filter(function (option) {
        return owa_options_strings_1.default[option.searchTermsStringKey].match(searchRegex);
    });
});
//# sourceMappingURL=filterOptions.js.map

/***/ }),

/***/ 4911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var QuickOptionEntry_1 = __webpack_require__(4912);
var QuickOptionSearchEntry_1 = __webpack_require__(3720);
var mountAndShowFullOptions_1 = __webpack_require__(3366);
var owa_options_store_1 = __webpack_require__(2641);
var filterOptions_1 = __webpack_require__(3774);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var SearchBox_1 = __webpack_require__(2141);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var Icon_1 = __webpack_require__(43);
var SettingPanelFirstRunCallout_1 = __webpack_require__(5313);
var ReactDOM = __webpack_require__(71);
var owa_lightning_1 = __webpack_require__(638);
var styles = __webpack_require__(3416);
var classNames = __webpack_require__(30).bind(styles);
var QuickOptions = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptions, _super);
    function QuickOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function () {
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        _this.goToFullOptions = function () {
            mountAndShowFullOptions_1.default();
            _this.onDismiss();
        };
        return _this;
    }
    QuickOptions.prototype.render = function () {
        var _this = this;
        var store = owa_options_store_1.getStore();
        var displayedOptions = filterOptions_1.default(store.searchTerm) || owa_options_store_1.getQuickOptions();
        var isSearch = !!store.searchTerm;
        var target;
        return (React.createElement("div", { className: styles.container },
            React.createElement(SearchBox_1.SearchBox, { labelText: owa_options_strings_1.default.optionsFlex_searchPlaceholder, value: store.searchTerm, onChange: owa_options_store_1.setSearchTerm }),
            React.createElement("div", { className: styles.quickSettingsPanel },
                displayedOptions.map(function (option, index) {
                    return isSearch ? (React.createElement(QuickOptionSearchEntry_1.default, { onDismiss: _this.props.onDismiss, option: option, key: option.key })) : (React.createElement(QuickOptionEntry_1.default, { ref: function (ref) {
                            if (index == 0) {
                                target = ReactDOM.findDOMNode(ref);
                            }
                        }, onDismiss: _this.props.onDismiss, option: option, key: option.key }));
                }),
                React.createElement(SettingPanelFirstRunCallout_1.SettingPanelFirstRunCallout, { lid: owa_lightning_1.LightningId.SettingPanelFirstRunCallout, when: function (lightup) { return lightup(); }, series: [
                        owa_lightning_1.LightningId.AnimatedConsumerRefreshFRE2,
                        owa_lightning_1.LightningId.SettingPanelFirstRunCallout,
                        owa_lightning_1.LightningId.SettingIconFirstRunCallout,
                    ], target: function () { return target; } })),
            React.createElement(Button_1.CommandButton, { className: styles.viewFullSettings, onClick: this.goToFullOptions },
                React.createElement("span", null, owa_options_strings_1.default.optionsFlex_goToFullOptions),
                React.createElement(Icon_1.Icon, { iconName: "ChevronRight" /* ChevronRight */, className: classNames(styles.icon, 'flipForRtl') }))));
    };
    QuickOptions.prototype.componentWillUnmount = function () {
        this.onDismiss();
    };
    QuickOptions = tslib_1.__decorate([
        mobx_react_1.observer
    ], QuickOptions);
    return QuickOptions;
}(React.Component));
exports.default = QuickOptions;
//# sourceMappingURL=QuickOptions.js.map

/***/ }),

/***/ 4912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var owa_common_strings_1 = __webpack_require__(37);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var QuickOptionSearchEntry_1 = __webpack_require__(3720);
var Toggle_1 = __webpack_require__(3417);
var Icon_1 = __webpack_require__(43);
var Tooltip_1 = __webpack_require__(350);
var onQuickOptionToggle_1 = __webpack_require__(3773);
var styles = __webpack_require__(3416);
var QuickOptionEntry = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptionEntry, _super);
    function QuickOptionEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onToggle = function (isToggledOn) {
            onQuickOptionToggle_1.default(isToggledOn, _this.props.option);
        };
        return _this;
    }
    QuickOptionEntry.prototype.render = function () {
        var option = this.props.option;
        var quickOptionSettings = option.quickOptionSettings, key = option.key;
        if (!quickOptionSettings) {
            // No render was provided. Instead, render as link to full options
            return React.createElement(QuickOptionSearchEntry_1.default, tslib_1.__assign({}, this.props));
        }
        var optionAriaId = "options-quick-" + key;
        var optionTooltipId = optionAriaId + "-tooltip";
        var rendering = quickOptionSettings.rendering, tooltip = quickOptionSettings.tooltip, customTitle = quickOptionSettings.customTitle;
        var _a = tooltip || {}, tooltipStringKey = _a.tooltipStringKey, shouldHideTooltip = _a.shouldHideTooltip;
        var render = rendering.render;
        var _b = rendering, isToggleOn = _b.isToggleOn, onToggle = _b.onToggle, hideToggle = _b.hideToggle;
        return (React.createElement("div", { className: styles.quickSetting },
            React.createElement("div", { id: optionAriaId, className: styles.quickSettingHeader, role: "heading", "aria-level": 3 },
                React.createElement("div", { className: styles.title },
                    React.createElement("span", null, owa_options_strings_1.default[customTitle || option.titleStringKey]),
                    tooltip &&
                        (!shouldHideTooltip || !shouldHideTooltip()) && (React.createElement(Tooltip_1.TooltipHost, { content: owa_options_strings_1.default[tooltipStringKey], id: optionTooltipId },
                        React.createElement(Icon_1.Icon, { iconName: "Info" /* Info */, className: styles.infoIcon })))),
                isToggleOn &&
                    onToggle &&
                    (!hideToggle || !hideToggle()) && (React.createElement(Toggle_1.Toggle, { checked: isToggleOn(), onChanged: this.onToggle, className: styles.toggle, onAriaLabel: owa_common_strings_1.default.toggle_on, offAriaLabel: owa_common_strings_1.default.toggle_off }))),
            render &&
                render({
                    headerAriaId: optionAriaId,
                })));
    };
    QuickOptionEntry = tslib_1.__decorate([
        mobx_react_1.observer
    ], QuickOptionEntry);
    return QuickOptionEntry;
}(React.Component));
exports.default = QuickOptionEntry;
//# sourceMappingURL=QuickOptionEntry.js.map

/***/ }),

/***/ 4913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var saveOrDiscardOptions_1 = __webpack_require__(3721);
exports.discardOptions = satcheljs_1.orchestratorAction('discardOptions', function discardOptions() {
    saveOrDiscardOptions_1.default(false);
});
//# sourceMappingURL=discardOptions.js.map

/***/ }),

/***/ 4914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2113);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('setIsSaving', function setIsSaving(newValue) {
    store_1.getStore().isSaving = newValue;
});
//# sourceMappingURL=setIsSaving.js.map

/***/ }),

/***/ 4915:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var setIsFullOptionsShown_1 = __webpack_require__(3722);
var setSearchTerm_1 = __webpack_require__(3723);
var collectedOptions_1 = __webpack_require__(3173);
var updateCategory_1 = __webpack_require__(3414);
var satcheljs_1 = __webpack_require__(2);
var getDefaultCategory_1 = __webpack_require__(5275);
var initializeFullOptionsAction = satcheljs_1.action('initializeFullOptions', function (category, subcategory, option) { return ({
    category: category,
    subcategory: subcategory,
    option: option,
}); });
exports.default = initializeFullOptionsAction;
exports.initializeFullOptionsInternal = satcheljs_1.orchestrator(initializeFullOptionsAction, function (optionsPath) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var category, subcategory, option, categories, categoryKey, subcategoryKey;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                category = optionsPath.category, subcategory = optionsPath.subcategory, option = optionsPath.option;
                setSearchTerm_1.default('');
                setIsFullOptionsShown_1.default(true);
                categories = collectedOptions_1.default();
                categoryKey = category || getDefaultCategory_1.default();
                subcategoryKey = subcategory || getFirstSubCategoryForCategory(categoryKey, categories);
                return [4 /*yield*/, updateCategory_1.default(categoryKey, subcategoryKey, option)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
function getFirstSubCategoryForCategory(categoryKey, categories) {
    var selectedCategory = categories.filter(function (category) { return category.key === categoryKey; })[0];
    return (selectedCategory &&
        selectedCategory.subcategories &&
        selectedCategory.subcategories[0] &&
        selectedCategory.subcategories[0].key);
}
//# sourceMappingURL=initializeFullOptions.js.map

/***/ }),

/***/ 4916:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var accountSubCategory_1 = __webpack_require__(4917);
var appearanceSubCategory_1 = __webpack_require__(4954);
var configurationSubCategory_1 = __webpack_require__(4968);
var skypeSubCategory_1 = __webpack_require__(4976);
var generalCategory = {
    key: 'general',
    titleStringKey: 'optionCategory_General',
    icon: "Settings" /* Settings */,
    subcategories: [
        accountSubCategory_1.default,
        appearanceSubCategory_1.default,
        configurationSubCategory_1.default,
        skypeSubCategory_1.default,
    ],
};
exports.default = generalCategory;
//# sourceMappingURL=category.js.map

/***/ }),

/***/ 4917:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_regional_option_1 = __webpack_require__(4918);
var accountSubCategory = {
    key: 'account',
    titleStringKey: 'optionSubcategory_account',
    options: [owa_regional_option_1.RegionalOption],
};
exports.default = accountSubCategory;
//# sourceMappingURL=accountSubCategory.js.map

/***/ }),

/***/ 4918:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_delayed_initialization_1 = __webpack_require__(28);
var loadRegionalOptions_1 = __webpack_require__(4919);
// Load initial state needed for options
owa_delayed_initialization_1.runAfterBootstrap(function () {
    loadRegionalOptions_1.default();
});
// Export option itself
var RegionalOption_1 = __webpack_require__(4925);
exports.RegionalOption = RegionalOption_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4919:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getMailboxRegionalConfiguration_1 = __webpack_require__(4920);
var setRegionalConfiguration_1 = __webpack_require__(4921);
var loadTimeZoneOptions_1 = __webpack_require__(3725);
function loadRegionalOptions() {
    return Promise.all([
        getMailboxRegionalConfiguration_1.default().then(function (options) {
            setRegionalConfiguration_1.default(options.SupportedCultures, options.SupportedShortDateFormats, options.SupportedShortTimeFormats);
        }),
        loadTimeZoneOptions_1.default(),
    ]);
}
exports.default = loadRegionalOptions;
//# sourceMappingURL=loadRegionalOptions.js.map

/***/ }),

/***/ 4920:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getRegionalConfigurationRequest_1 = __webpack_require__(2670);
var getRegionalConfigurationOperation_1 = __webpack_require__(2757);
function getRegionalConfiguration() {
    return getRegionalConfigurationOperation_1.default(getRegionalConfigurationRequest_1.default({}));
}
exports.default = getRegionalConfiguration;
//# sourceMappingURL=getMailboxRegionalConfiguration.js.map

/***/ }),

/***/ 4921:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var store_1 = __webpack_require__(2651);
exports.default = satcheljs_1.mutatorAction('setRegionalConfiguration', function setRegionalConfiguration(supportedCultures, supportedShortDateFormats, supportedShortTimeFormats) {
    var regionalOptions = store_1.default();
    regionalOptions.supportedCultures = supportedCultures;
    regionalOptions.supportedShortDateFormats = supportedShortDateFormats;
    regionalOptions.supportedShortTimeFormats = supportedShortTimeFormats;
});
//# sourceMappingURL=setRegionalConfiguration.js.map

/***/ }),

/***/ 4922:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getTimeZoneOperation_1 = __webpack_require__(4923);
function getTimeZone() {
    return getTimeZoneOperation_1.default({
        needTimeZoneList: true,
    }).then(function (response) { return response.TimeZoneList; });
}
exports.default = getTimeZone;
//# sourceMappingURL=getTimeZone.js.map

/***/ }),

/***/ 4923:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
function getTimeZoneOperation(req, options) {
    return ServiceRequest_1.makeServiceRequest("GetTimeZone", req, options);
}
exports.default = getTimeZoneOperation;


/***/ }),

/***/ 4924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var store_1 = __webpack_require__(2651);
exports.default = satcheljs_1.mutatorAction('setSupportedTimeZones', function setSupportedTimeZones(supportedTimeZones) {
    var regionalOptions = store_1.default();
    regionalOptions.supportedTimeZones = supportedTimeZones;
});
//# sourceMappingURL=setSupportedTimeZones.js.map

/***/ }),

/***/ 4925:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RegionalFull_1 = __webpack_require__(4926);
var isRegionalOptionDirty_1 = __webpack_require__(4944);
var React = __webpack_require__(3);
var discardRegionalOption_1 = __webpack_require__(4945);
var saveRegionalOption_1 = __webpack_require__(4946);
var RegionalOption = {
    key: 'regional',
    titleStringKey: 'optionTitle_regional',
    searchTermsStringKey: 'optionTitle_regional',
    fullOptionFormSettings: {
        render: function () { return React.createElement(RegionalFull_1.default, null); },
        isDirty: isRegionalOptionDirty_1.default,
        onSave: saveRegionalOption_1.default,
        onDiscard: discardRegionalOption_1.default,
    },
};
exports.default = RegionalOption;
//# sourceMappingURL=RegionalOption.js.map

/***/ }),

/***/ 4926:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var CultureSelection_1 = __webpack_require__(4927);
var DateFormatSelection_1 = __webpack_require__(4938);
var TimeFormatSelection_1 = __webpack_require__(4940);
var TimeZoneSelection_1 = __webpack_require__(4942);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var RegionalFull = /** @class */ (function (_super) {
    tslib_1.__extends(RegionalFull, _super);
    function RegionalFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegionalFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(CultureSelection_1.default, null),
            React.createElement(DateFormatSelection_1.default, null),
            React.createElement(TimeFormatSelection_1.default, null),
            React.createElement(TimeZoneSelection_1.default, null)));
    };
    RegionalFull = tslib_1.__decorate([
        mobx_react_1.observer
    ], RegionalFull);
    return RegionalFull;
}(React.Component));
exports.default = RegionalFull;
//# sourceMappingURL=RegionalFull.js.map

/***/ }),

/***/ 4927:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var Dropdown_1 = __webpack_require__(2652);
var owa_options_controls_1 = __webpack_require__(2661);
var Button_1 = __webpack_require__(62);
var React = __webpack_require__(3);
var store_1 = __webpack_require__(2651);
var owa_session_store_1 = __webpack_require__(151);
var selectLocaleOption_1 = __webpack_require__(4934);
var setRenameFoldersOption_1 = __webpack_require__(4935);
var owa_options_strings_1 = __webpack_require__(1737);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var styles = __webpack_require__(4936);
var CultureSelection = /** @class */ (function (_super) {
    tslib_1.__extends(CultureSelection, _super);
    function CultureSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CultureSelection.prototype.render = function () {
        var store = store_1.default();
        return (React.createElement("div", null,
            React.createElement(Dropdown_1.Dropdown, { label: owa_options_strings_1.default.option_regional_language, options: store.supportedCultures.map(function (culture) { return ({
                    text: culture.NativeName,
                    key: culture.Name,
                }); }), selectedKey: store.selectedLocale || owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture, onChanged: this.onSelectLocale }),
            store.selectedLocale !== null &&
                store.selectedLocale !== owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture && (React.createElement(owa_options_controls_1.OptionsCheckbox, { className: styles.renameFolders, onChange: this.toggleRenameFolders, label: owa_options_strings_1.default.option_regional_renameDefaultFolders, checked: store.shouldRenameDefaultFolders })),
            store.hasUserChangedLanguage && (React.createElement(Button_1.CommandButton, { text: owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-localeHotReload')
                    ? owa_options_strings_1.default.option_regional_languageHotReload
                    : owa_options_strings_1.default.option_regional_languageReload, onClick: this.reloadPage, className: styles.reloadButton }))));
    };
    CultureSelection.prototype.toggleRenameFolders = function (ev, checked) {
        setRenameFoldersOption_1.default(checked);
    };
    CultureSelection.prototype.reloadPage = function () {
        location.reload();
    };
    CultureSelection.prototype.onSelectLocale = function (item) {
        selectLocaleOption_1.default(item.key);
    };
    CultureSelection = tslib_1.__decorate([
        mobx_react_1.observer
    ], CultureSelection);
    return CultureSelection;
}(React.Component));
exports.default = CultureSelection;
//# sourceMappingURL=CultureSelection.js.map

/***/ }),

/***/ 4928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Checkbox_1 = __webpack_require__(2639);
var styles = __webpack_require__(4929);
var classNames = __webpack_require__(30).bind(styles);
function OptionsCheckbox(props) {
    return (React.createElement(Checkbox_1.Checkbox, tslib_1.__assign({}, props, { styles: {
            root: classNames(styles.root, (props.styles || {}).root),
        } })));
}
exports.default = OptionsCheckbox;
//# sourceMappingURL=OptionsCheckbox.js.map

/***/ }),

/***/ 4929:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4930);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4930:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._2VXkhFCvBZqqIELnyCG3FQ{margin:8px 0}html[dir] ._2VXkhFCvBZqqIELnyCG3FQ:last-child{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "_2VXkhFCvBZqqIELnyCG3FQ"
};

/***/ }),

/***/ 4931:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var classNames = __webpack_require__(343);
var styles = __webpack_require__(4932);
function OptionDescription(props) {
    return (React.createElement("p", tslib_1.__assign({}, props, { className: classNames(props.className, styles.description) }), props.children));
}
exports.default = OptionDescription;
//# sourceMappingURL=OptionDescription.js.map

/***/ }),

/***/ 4932:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4933);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4933:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._37f2GxKDsLSyr_j6Cet-xZ{font-size:14px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._37f2GxKDsLSyr_j6Cet-xZ{margin-top:0}", ""]);

// exports
exports.locals = {
	"description": "_37f2GxKDsLSyr_j6Cet-xZ"
};

/***/ }),

/***/ 4934:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('selectLocaleOption', function selectLocaleOption(locale) {
    var optionState = store_1.default();
    optionState.selectedLocale = locale;
});
//# sourceMappingURL=selectLocaleOption.js.map

/***/ }),

/***/ 4935:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var store_1 = __webpack_require__(2651);
exports.default = satcheljs_1.mutatorAction('setRenameFoldersOption', function setRenameFoldersOption(shouldRenameFolders) {
    store_1.default().shouldRenameDefaultFolders = shouldRenameFolders;
});
//# sourceMappingURL=setRenameFoldersOption.js.map

/***/ }),

/***/ 4936:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4937);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4937:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._3pp1Qufz2t7toh0C6btOdR{margin-bottom:20px}._1ebMuzYXLa7vqjY032dKYy{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._1ebMuzYXLa7vqjY032dKYy{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"renameFolders": "_3pp1Qufz2t7toh0C6btOdR",
	"reloadButton": "_1ebMuzYXLa7vqjY032dKYy"
};

/***/ }),

/***/ 4938:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var Dropdown_1 = __webpack_require__(2652);
var React = __webpack_require__(3);
var store_1 = __webpack_require__(2651);
var owa_session_store_1 = __webpack_require__(151);
var mobx_1 = __webpack_require__(15);
var getFilteredDateFormatOptions_1 = __webpack_require__(3726);
var selectDateFormatOption_1 = __webpack_require__(4939);
var owa_options_strings_1 = __webpack_require__(1737);
var owa_datetime_format_1 = __webpack_require__(600);
var EXAMPLE_DATE = new Date(2017, 8, 1);
var DateFormatSelection = /** @class */ (function (_super) {
    tslib_1.__extends(DateFormatSelection, _super);
    function DateFormatSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFormatSelection.prototype.render = function () {
        var savedDateFormat = owa_session_store_1.getUserConfiguration().UserOptions.DateFormat;
        var selectedKey = store_1.default().selectedDateFormat || savedDateFormat;
        if (getFilteredDateFormatOptions_1.default().indexOf(selectedKey) === -1) {
            selectedKey =
                getFilteredDateFormatOptions_1.default().indexOf(savedDateFormat) === -1
                    ? getFilteredDateFormatOptions_1.default()[0]
                    : savedDateFormat;
        }
        return (React.createElement(Dropdown_1.Dropdown, { label: owa_options_strings_1.default.option_regional_dateFormat, options: this.dateFormatOptions, selectedKey: selectedKey, onChanged: this.onSelectDateFormat }));
    };
    DateFormatSelection.prototype.onSelectDateFormat = function (item) {
        selectDateFormatOption_1.default(item.key);
    };
    Object.defineProperty(DateFormatSelection.prototype, "dateFormatOptions", {
        get: function () {
            return getFilteredDateFormatOptions_1.default().map(function (shortDateFormat) {
                return {
                    text: owa_datetime_format_1.formatDate(EXAMPLE_DATE, shortDateFormat, false),
                    key: shortDateFormat,
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], DateFormatSelection.prototype, "dateFormatOptions", null);
    DateFormatSelection = tslib_1.__decorate([
        mobx_react_1.observer
    ], DateFormatSelection);
    return DateFormatSelection;
}(React.Component));
exports.default = DateFormatSelection;
//# sourceMappingURL=DateFormatSelection.js.map

/***/ }),

/***/ 4939:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('selectDateFormatOption', function selectDateFormatOption(dateFormat) {
    var optionState = store_1.default();
    optionState.selectedDateFormat = dateFormat;
});
//# sourceMappingURL=selectDateFormatOption.js.map

/***/ }),

/***/ 4940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var Dropdown_1 = __webpack_require__(2652);
var React = __webpack_require__(3);
var store_1 = __webpack_require__(2651);
var owa_session_store_1 = __webpack_require__(151);
var mobx_1 = __webpack_require__(15);
var getFilteredTimeFormatOptions_1 = __webpack_require__(3727);
var selectTimeFormatOption_1 = __webpack_require__(4941);
var owa_options_strings_1 = __webpack_require__(1737);
var owa_datetime_format_1 = __webpack_require__(600);
var EXAMPLE_START_RANGE = new Date(2017, 8, 1, 1, 1);
var EXAMPLE_END_RANGE = new Date(2017, 8, 1, 23, 59);
var TimeFormatSelection = /** @class */ (function (_super) {
    tslib_1.__extends(TimeFormatSelection, _super);
    function TimeFormatSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeFormatSelection.prototype.render = function () {
        var savedTimeFormat = owa_session_store_1.getUserConfiguration().UserOptions.TimeFormat;
        var selectedKey = store_1.default().selectedTimeFormat || savedTimeFormat;
        if (getFilteredTimeFormatOptions_1.default().indexOf(selectedKey) === -1) {
            selectedKey =
                getFilteredTimeFormatOptions_1.default().indexOf(savedTimeFormat) === -1
                    ? getFilteredTimeFormatOptions_1.default()[0]
                    : savedTimeFormat;
        }
        return (React.createElement(Dropdown_1.Dropdown, { label: owa_options_strings_1.default.option_regional_timeFormat, options: this.timeFormatOptions, selectedKey: selectedKey, onChanged: this.onSelectDateFormat }));
    };
    TimeFormatSelection.prototype.onSelectDateFormat = function (item) {
        selectTimeFormatOption_1.default(item.key);
    };
    Object.defineProperty(TimeFormatSelection.prototype, "timeFormatOptions", {
        get: function () {
            return getFilteredTimeFormatOptions_1.default().map(function (shortTimeFormat) {
                return {
                    text: owa_datetime_format_1.formatDate(EXAMPLE_START_RANGE, shortTimeFormat, false) + " - " + owa_datetime_format_1.formatDate(EXAMPLE_END_RANGE, shortTimeFormat, false),
                    key: shortTimeFormat,
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], TimeFormatSelection.prototype, "timeFormatOptions", null);
    TimeFormatSelection = tslib_1.__decorate([
        mobx_react_1.observer
    ], TimeFormatSelection);
    return TimeFormatSelection;
}(React.Component));
exports.default = TimeFormatSelection;
//# sourceMappingURL=TimeFormatSelection.js.map

/***/ }),

/***/ 4941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('selectTimeFormatOption', function selectTimeFormatOption(timeFormat) {
    var optionState = store_1.default();
    optionState.selectedTimeFormat = timeFormat;
});
//# sourceMappingURL=selectTimeFormatOption.js.map

/***/ }),

/***/ 4942:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var Dropdown_1 = __webpack_require__(2652);
var React = __webpack_require__(3);
var store_1 = __webpack_require__(2651);
var owa_session_store_1 = __webpack_require__(151);
var selectTimeZoneOption_1 = __webpack_require__(4943);
var owa_options_strings_1 = __webpack_require__(1737);
// const styles = require('./Regional.scss');
var TimeZoneSelection = /** @class */ (function (_super) {
    tslib_1.__extends(TimeZoneSelection, _super);
    function TimeZoneSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeZoneSelection.prototype.render = function () {
        var store = store_1.default();
        return (React.createElement(Dropdown_1.Dropdown, { label: owa_options_strings_1.default.option_regional_timeZone, options: store.supportedTimeZones.map(function (timeZone) { return ({
                text: timeZone.Name,
                key: timeZone.Value,
            }); }), selectedKey: store.selectedTimeZone || owa_session_store_1.getUserConfiguration().UserOptions.TimeZone, onChanged: this.onSelectDateFormat }));
    };
    TimeZoneSelection.prototype.onSelectDateFormat = function (item) {
        selectTimeZoneOption_1.default(item.key);
    };
    TimeZoneSelection = tslib_1.__decorate([
        mobx_react_1.observer
    ], TimeZoneSelection);
    return TimeZoneSelection;
}(React.Component));
exports.default = TimeZoneSelection;
//# sourceMappingURL=TimeZoneSelection.js.map

/***/ }),

/***/ 4943:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('selectTimeZoneOption', function selectTimeZoneOption(timeZone) {
    var optionState = store_1.default();
    optionState.selectedTimeZone = timeZone;
});
//# sourceMappingURL=selectTimeZoneOption.js.map

/***/ }),

/***/ 4944:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    selectedLocale: function () { return store_1.default().selectedLocale; },
    selectedDateFormat: function () { return store_1.default().selectedDateFormat; },
    selectedTimeFormat: function () { return store_1.default().selectedTimeFormat; },
    selectedTimeZone: function () { return store_1.default().selectedTimeZone; },
    savedLocale: function () { return owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture; },
    savedDateFormat: function () { return owa_session_store_1.getUserConfiguration().UserOptions.DateFormat; },
    savedTimeFormat: function () { return owa_session_store_1.getUserConfiguration().UserOptions.TimeFormat; },
    savedTimeZone: function () { return owa_session_store_1.getUserConfiguration().UserOptions.TimeZone; },
})(function isRegionalOptionDirty(state) {
    var selectedLocale = state.selectedLocale, selectedDateFormat = state.selectedDateFormat, selectedTimeFormat = state.selectedTimeFormat, selectedTimeZone = state.selectedTimeZone, savedLocale = state.savedLocale, savedDateFormat = state.savedDateFormat, savedTimeFormat = state.savedTimeFormat, savedTimeZone = state.savedTimeZone;
    return ((selectedLocale !== null && selectedLocale !== savedLocale) ||
        (selectedDateFormat !== null && selectedDateFormat !== savedDateFormat) ||
        (selectedTimeFormat !== null && selectedTimeFormat !== savedTimeFormat) ||
        (selectedTimeZone !== null && selectedTimeZone !== savedTimeZone));
});
//# sourceMappingURL=isRegionalOptionDirty.js.map

/***/ }),

/***/ 4945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('discardRegionalOption', function discardRegionalOption() {
    var optionState = store_1.default();
    optionState.selectedLocale = null;
    optionState.shouldRenameDefaultFolders = true;
    optionState.selectedDateFormat = null;
    optionState.selectedTimeFormat = null;
    optionState.selectedTimeZone = null;
});
//# sourceMappingURL=discardRegionalOption.js.map

/***/ }),

/***/ 4946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(2651);
var setHasUserChangedLanguage_1 = __webpack_require__(4947);
var owa_session_store_1 = __webpack_require__(151);
var getFilteredDateFormatOptions_1 = __webpack_require__(3726);
var getFilteredTimeFormatOptions_1 = __webpack_require__(3727);
var config_1 = __webpack_require__(61);
var setMailboxRegionalConfiguration_1 = __webpack_require__(4948);
var owa_datetime_store_1 = __webpack_require__(722);
var owa_options_core_1 = __webpack_require__(1736);
var owa_strings_1 = __webpack_require__(20);
var utilities_1 = __webpack_require__(774);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var getNewTimeZoneOffsets_1 = __webpack_require__(4952);
var loadTimeZoneOptions_1 = __webpack_require__(3725);
function saveRegionalOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _this = this;
        var optionState, _a, SessionSettings, UserOptions, languageHasChanged, newDateFormat, newTimeFormat, timeZoneHasChanged, newTimeZone, setMailboxRegionalConfigurationPromise, promises, language_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    optionState = store_1.default();
                    _a = owa_session_store_1.getUserConfiguration(), SessionSettings = _a.SessionSettings, UserOptions = _a.UserOptions;
                    languageHasChanged = optionState.selectedLocale !== null &&
                        optionState.selectedLocale !== SessionSettings.UserCulture;
                    owa_options_core_1.updateSessionSettings({
                        UserCulture: optionState.selectedLocale || SessionSettings.UserCulture,
                    });
                    newDateFormat = optionState.selectedDateFormat || UserOptions.DateFormat;
                    if (getFilteredDateFormatOptions_1.default().indexOf(newDateFormat) === -1) {
                        // The user changed locales to one that didn't support their previous date format, and didn't update the selection
                        // Default to the first option compatible with their locale
                        newDateFormat = getFilteredDateFormatOptions_1.default()[0];
                    }
                    owa_datetime_store_1.setDateFormat(newDateFormat);
                    newTimeFormat = optionState.selectedTimeFormat || UserOptions.TimeFormat;
                    if (getFilteredTimeFormatOptions_1.default().indexOf(newTimeFormat) === -1) {
                        // The user changed locales to one that didn't support their previous time format, and didn't update the selection
                        // Default to the first option compatible with their locale
                        newTimeFormat = getFilteredTimeFormatOptions_1.default()[0];
                    }
                    owa_datetime_store_1.setTimeFormat(newTimeFormat);
                    timeZoneHasChanged = !!optionState.selectedTimeZone && optionState.selectedTimeZone != UserOptions.TimeZone;
                    newTimeZone = optionState.selectedTimeZone || UserOptions.TimeZone;
                    config_1.setTimezone(newTimeZone);
                    // Save the new values to UserOptions
                    owa_options_core_1.updateUserOptions({
                        DateFormat: newDateFormat,
                        TimeFormat: newTimeFormat,
                        TimeZone: newTimeZone,
                    });
                    setMailboxRegionalConfigurationPromise = setMailboxRegionalConfiguration_1.default(SessionSettings.UserCulture, optionState.shouldRenameDefaultFolders, UserOptions.DateFormat, UserOptions.TimeFormat, UserOptions.TimeZone);
                    promises = [setMailboxRegionalConfigurationPromise];
                    // VSO:14100 - Rename the default folders, without pulling in mail code.
                    if (languageHasChanged) {
                        promises.push(setMailboxRegionalConfigurationPromise.then(loadTimeZoneOptions_1.default));
                        if (owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-localeHotReload')) {
                            language_1 = owa_strings_1.getSupportedFallbackForLocale(optionState.selectedLocale);
                            promises.push(owa_strings_1.setLocale(language_1.locale).then(function () { return utilities_1.setRTL(language_1.dir === 'rtl'); }));
                        }
                    }
                    if (timeZoneHasChanged) {
                        promises.push(setMailboxRegionalConfigurationPromise.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var newTimeZoneOffsetType;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, getNewTimeZoneOffsets_1.default()];
                                    case 1:
                                        newTimeZoneOffsetType = _a.sent();
                                        owa_datetime_store_1.updateTimeZoneOffsets(newTimeZoneOffsetType);
                                        return [2 /*return*/];
                                }
                            });
                        }); }));
                    }
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    _b.sent();
                    if (languageHasChanged &&
                        (!owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-localeHotReload') || optionState.shouldRenameDefaultFolders)) {
                        setHasUserChangedLanguage_1.default(true);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = saveRegionalOption;
//# sourceMappingURL=saveRegionalOption.js.map

/***/ }),

/***/ 4947:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2651);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('setHasUserChangedLanguage', function setHasUserChangedLanguage(value) {
    store_1.default().hasUserChangedLanguage = value;
});
//# sourceMappingURL=setHasUserChangedLanguage.js.map

/***/ }),

/***/ 4948:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setMailboxRegionalConfigurationOperation_1 = __webpack_require__(4949);
var setMailboxRegionalConfigurationData_1 = __webpack_require__(4951);
var ServiceRequestUtils_1 = __webpack_require__(31);
function setMailboxRegionalConfiguration(locale, renameDefaultFolders, dateFormat, timeFormat, timeZone) {
    return setMailboxRegionalConfigurationOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Options: setMailboxRegionalConfigurationData_1.default({
            Language: locale,
            LocalizeDefaultFolderName: renameDefaultFolders,
            DateFormat: dateFormat,
            TimeFormat: timeFormat,
            TimeZone: timeZone,
        }),
        SkipUserCultureCookies: false,
    });
}
exports.default = setMailboxRegionalConfiguration;
//# sourceMappingURL=setMailboxRegionalConfiguration.js.map

/***/ }),

/***/ 4949:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var setMailboxRegionalConfigurationRequest_1 = __webpack_require__(4950);
function setMailboxRegionalConfigurationOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = setMailboxRegionalConfigurationRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("SetMailboxRegionalConfiguration", req, options);
}
exports.default = setMailboxRegionalConfigurationOperation;


/***/ }),

/***/ 4950:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setMailboxRegionalConfigurationRequest(data) {
    var result = tslib_1.__assign({ __type: 'SetMailboxRegionalConfigurationRequest:#Exchange' }, data);
    return result;
}
exports.default = setMailboxRegionalConfigurationRequest;


/***/ }),

/***/ 4951:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setMailboxRegionalConfigurationData(data) {
    var result = tslib_1.__assign({ __type: 'SetMailboxRegionalConfigurationData:#Exchange' }, data);
    return result;
}
exports.default = setMailboxRegionalConfigurationData;


/***/ }),

/***/ 4952:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getOwaUserConfigurationOperation_1 = __webpack_require__(4953);
/**
 * Gets the new time zone offsets by getting the user configuration
 */
function getNewTimeZoneOffsets() {
    return getOwaUserConfigurationOperation_1.default().then(function (userConfiguration) {
        return userConfiguration.UserOptions.MailboxTimeZoneOffset;
    });
}
exports.default = getNewTimeZoneOffsets;
//# sourceMappingURL=getNewTimeZoneOffsets.js.map

/***/ }),

/***/ 4953:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
function getOwaUserConfigurationOperation(options) {
    return ServiceRequest_1.makeServiceRequest("GetOwaUserConfiguration", {}, options);
}
exports.default = getOwaUserConfigurationOperation;


/***/ }),

/***/ 4954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_theme_option_1 = __webpack_require__(4955);
var appearanceSubCategory = {
    key: 'appearance',
    titleStringKey: 'optionSubcategory_appearance',
    options: [owa_theme_option_1.ThemeOption],
};
exports.default = appearanceSubCategory;
//# sourceMappingURL=appearanceSubCategory.js.map

/***/ }),

/***/ 4955:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ThemeOption_1 = __webpack_require__(4956);
exports.ThemeOption = ThemeOption_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4956:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var commitThemeChange_1 = __webpack_require__(3728);
var discardThemeChange_1 = __webpack_require__(4960);
var ThemeFull_1 = __webpack_require__(4961);
var ThemeQuick_1 = __webpack_require__(4965);
var isThemePreviewDirty_1 = __webpack_require__(4967);
var React = __webpack_require__(3);
var ThemeOption = {
    key: 'theme',
    titleStringKey: 'optionTitle_Theme',
    searchTermsStringKey: 'optionSearch_Theme',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ThemeFull_1.default, null); },
        isDirty: isThemePreviewDirty_1.default,
        onSave: commitThemeChange_1.default,
        onDiscard: discardThemeChange_1.default,
    },
    quickOptionSettings: {
        rendering: {
            render: function () { return React.createElement(ThemeQuick_1.default, null); },
        },
        order: 0 /* Theme */,
        workloads: 2415919103 /* All */,
    },
};
exports.default = ThemeOption;
//# sourceMappingURL=ThemeOption.js.map

/***/ }),

/***/ 4957:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setUserThemeRequest_1 = __webpack_require__(3729);
var setUserThemeOperation_1 = __webpack_require__(4958);
function setUserTheme(themeId) {
    return setUserThemeOperation_1.default({
        request: setUserThemeRequest_1.default({
            ThemeId: themeId,
        }),
    });
}
exports.default = setUserTheme;
//# sourceMappingURL=setUserTheme.js.map

/***/ }),

/***/ 4958:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var setUserThemeRequest_1 = __webpack_require__(3729);
function setUserThemeOperation(req, options) {
    if (req.request !== undefined && !req.request["__type"]) {
        req.request = setUserThemeRequest_1.default(req.request);
    }
    return ServiceRequest_1.makeServiceRequest("SetUserTheme", req, options);
}
exports.default = setUserThemeOperation;


/***/ }),

/***/ 4959:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.action('ON_COMMIT_THEME_CHANGE', function (themeId) {
    return {
        themeId: themeId,
    };
});
//# sourceMappingURL=onCommitThemeChange.js.map

/***/ }),

/***/ 4960:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_session_store_1 = __webpack_require__(151);
var loadTheme_1 = __webpack_require__(698);
function discardThemeChange() {
    loadTheme_1.default(owa_session_store_1.getUserConfiguration().UserOptions.ThemeStorageId);
}
exports.default = discardThemeChange;
//# sourceMappingURL=discardThemeChange.js.map

/***/ }),

/***/ 4961:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ThemeSwatch_1 = __webpack_require__(3730);
var loadTheme_1 = __webpack_require__(698);
var mobx_react_1 = __webpack_require__(11);
var FocusZone_1 = __webpack_require__(78);
var getAvailableThemeIds_1 = __webpack_require__(3370);
var React = __webpack_require__(3);
var styles = __webpack_require__(3367);
var ThemeFull = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeFull, _super);
    function ThemeFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThemeFull.prototype.render = function () {
        var _this = this;
        return (React.createElement(FocusZone_1.FocusZone, { className: styles.fullSwatchContainer, direction: FocusZone_1.FocusZoneDirection.bidirectional, role: "listbox" }, getAvailableThemeIds_1.default().map(function (id) { return (React.createElement(ThemeSwatch_1.default, { themeId: id, key: id, onClick: _this.onThemeClick })); })));
    };
    ThemeFull.prototype.onThemeClick = function (themeId) {
        loadTheme_1.default(themeId);
    };
    ThemeFull = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThemeFull);
    return ThemeFull;
}(React.Component));
exports.default = ThemeFull;
//# sourceMappingURL=ThemeFull.js.map

/***/ }),

/***/ 4962:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] .a0umIVu-fW5BPpMsX8iGs{margin-bottom:2px}.a0umIVu-fW5BPpMsX8iGs ._2uGe-yN9pb11Ak6HUY6XRK{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}html[dir=ltr] .a0umIVu-fW5BPpMsX8iGs ._2uGe-yN9pb11Ak6HUY6XRK{margin-left:-5px}html[dir=rtl] .a0umIVu-fW5BPpMsX8iGs ._2uGe-yN9pb11Ak6HUY6XRK{margin-right:-5px}.a0umIVu-fW5BPpMsX8iGs ._39rapMrOZ_5w6t6XY0i_K5{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] .a0umIVu-fW5BPpMsX8iGs ._39rapMrOZ_5w6t6XY0i_K5{margin-left:-8px}html[dir=rtl] .a0umIVu-fW5BPpMsX8iGs ._39rapMrOZ_5w6t6XY0i_K5{margin-right:-8px}._3U5-u58YjUZoS77nmE3OPE{width:50px;height:50px;cursor:pointer;overflow:hidden}html[dir] ._3U5-u58YjUZoS77nmE3OPE{padding:1px;border-radius:50%;border:1px solid transparent}html[dir] ._3U5-u58YjUZoS77nmE3OPE._2PeD6fhcbycvjNSVAutGKu{border-color:\"[theme:themePrimary, default:#0078D7]\"}._3U5-u58YjUZoS77nmE3OPE ._1QGvKqLfRPQMKj8P-jIvVy{height:44px;width:44px;display:block}html[dir] ._3U5-u58YjUZoS77nmE3OPE ._1QGvKqLfRPQMKj8P-jIvVy{margin:3px;border-radius:50%}.TmOrjN2tTWRbrZgUQ5BS0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}", ""]);

// exports
exports.locals = {
	"quickContainer": "a0umIVu-fW5BPpMsX8iGs",
	"swatchContainer": "_2uGe-yN9pb11Ak6HUY6XRK",
	"expandButton": "_39rapMrOZ_5w6t6XY0i_K5",
	"swatch": "_3U5-u58YjUZoS77nmE3OPE",
	"selected": "_2PeD6fhcbycvjNSVAutGKu",
	"image": "_1QGvKqLfRPQMKj8P-jIvVy",
	"fullSwatchContainer": "TmOrjN2tTWRbrZgUQ5BS0"
};

/***/ }),

/***/ 4963:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getAllThemeIds() {
    // This require context is calculated at webpack-time
    var req = __webpack_require__(4964);
    return req.keys().map(function (key) { return /.*\/fabric\.color\.variables\.theme\.(\w+)\.json/.exec(key)[1]; });
}
exports.default = getAllThemeIds;
//# sourceMappingURL=getAllThemeIds.js.map

/***/ }),

/***/ 4964:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./fabric.color.variables.theme.angular.json": 724,
	"./fabric.color.variables.theme.balloons.json": 725,
	"./fabric.color.variables.theme.base.json": 726,
	"./fabric.color.variables.theme.beach.json": 727,
	"./fabric.color.variables.theme.black.json": 728,
	"./fabric.color.variables.theme.blueberry.json": 729,
	"./fabric.color.variables.theme.blueprint.json": 730,
	"./fabric.color.variables.theme.bricks.json": 731,
	"./fabric.color.variables.theme.cats.json": 732,
	"./fabric.color.variables.theme.chevron.json": 733,
	"./fabric.color.variables.theme.circuit.json": 734,
	"./fabric.color.variables.theme.comic.json": 735,
	"./fabric.color.variables.theme.contrast.json": 736,
	"./fabric.color.variables.theme.cordovan.json": 737,
	"./fabric.color.variables.theme.crayon.json": 738,
	"./fabric.color.variables.theme.cubes.json": 739,
	"./fabric.color.variables.theme.cubism.json": 740,
	"./fabric.color.variables.theme.darkcordovan.json": 741,
	"./fabric.color.variables.theme.darkorange.json": 742,
	"./fabric.color.variables.theme.diamonds.json": 743,
	"./fabric.color.variables.theme.far.json": 744,
	"./fabric.color.variables.theme.grape.json": 745,
	"./fabric.color.variables.theme.jelly.json": 746,
	"./fabric.color.variables.theme.lightblue.json": 747,
	"./fabric.color.variables.theme.lightgreen.json": 748,
	"./fabric.color.variables.theme.lite.json": 749,
	"./fabric.color.variables.theme.mediumdarkblue.json": 750,
	"./fabric.color.variables.theme.minimal.json": 751,
	"./fabric.color.variables.theme.modern.json": 752,
	"./fabric.color.variables.theme.mountain.json": 753,
	"./fabric.color.variables.theme.orange.json": 754,
	"./fabric.color.variables.theme.paint.json": 755,
	"./fabric.color.variables.theme.pink.json": 756,
	"./fabric.color.variables.theme.pixel.json": 757,
	"./fabric.color.variables.theme.polka.json": 758,
	"./fabric.color.variables.theme.pomegranate.json": 759,
	"./fabric.color.variables.theme.primary.json": 760,
	"./fabric.color.variables.theme.raspberry.json": 761,
	"./fabric.color.variables.theme.robot.json": 762,
	"./fabric.color.variables.theme.simple.json": 763,
	"./fabric.color.variables.theme.spectrum.json": 764,
	"./fabric.color.variables.theme.strawberry.json": 765,
	"./fabric.color.variables.theme.super.json": 766,
	"./fabric.color.variables.theme.teagarden.json": 767,
	"./fabric.color.variables.theme.teal.json": 768,
	"./fabric.color.variables.theme.watermelon.json": 769,
	"./fabric.color.variables.theme.whale.json": 770,
	"./fabric.color.variables.theme.whimsical.json": 771,
	"./fabric.color.variables.theme.wntrlnd.json": 772,
	"./fabric.color.variables.theme.wrld.json": 773
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4964;

/***/ }),

/***/ 4965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ThemeSwatch_1 = __webpack_require__(3730);
var commitThemeChange_1 = __webpack_require__(3728);
var toggleThemeQuickOptionExpansion_1 = __webpack_require__(4966);
var store_1 = __webpack_require__(3731);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var FocusZone_1 = __webpack_require__(78);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var getAvailableThemeIds_1 = __webpack_require__(3370);
var normalizeThemeId_1 = __webpack_require__(702);
var React = __webpack_require__(3);
var styles = __webpack_require__(3367);
var COLLAPSED_SIZE = 5;
var ThemeQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeQuick, _super);
    function ThemeQuick() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThemeQuick.prototype.componentWillMount = function () {
        // Pin the initially selected theme to the front of the list for as long as this control is mounted
        this.pinnedTheme = normalizeThemeId_1.default(owa_session_store_1.getUserConfiguration().UserOptions.ThemeStorageId);
    };
    ThemeQuick.prototype.componentDidMount = function () {
        toggleThemeQuickOptionExpansion_1.default(false);
    };
    ThemeQuick.prototype.render = function () {
        var _this = this;
        var isExpanded = store_1.default().isQuickOptionExpanded;
        var themeIds = getAvailableThemeIds_1.default();
        // Push the initially saved theme to the front of the list
        var pinnedThemeIndex = themeIds.indexOf(this.pinnedTheme);
        themeIds.splice(pinnedThemeIndex, 1);
        themeIds.unshift(this.pinnedTheme);
        if (!isExpanded) {
            themeIds = themeIds.slice(0, COLLAPSED_SIZE);
        }
        return (React.createElement("div", { className: styles.quickContainer },
            React.createElement(FocusZone_1.FocusZone, { className: styles.swatchContainer, role: "listbox" }, themeIds.map(function (id) { return (React.createElement(ThemeSwatch_1.default, { themeId: id, onClick: _this.onThemeClick, key: id })); })),
            React.createElement(Button_1.CommandButton, { text: isExpanded ? owa_options_strings_1.default.themeCollapseLabel : owa_options_strings_1.default.themeExpandLabel, onClick: this.toggleExpand, className: styles.expandButton })));
    };
    ThemeQuick.prototype.toggleExpand = function () {
        toggleThemeQuickOptionExpansion_1.default();
    };
    ThemeQuick.prototype.onThemeClick = function (themeId) {
        commitThemeChange_1.commitQuickThemeChange(themeId);
    };
    ThemeQuick = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThemeQuick);
    return ThemeQuick;
}(React.Component));
exports.default = ThemeQuick;
//# sourceMappingURL=ThemeQuick.js.map

/***/ }),

/***/ 4966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3731);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('toggleThemeQuickOptionExpansion', function toggleThemeQuickOptionExpansion(overrideValue) {
    var themeOptions = store_1.default();
    themeOptions.isQuickOptionExpanded =
        overrideValue === void 0 ? !themeOptions.isQuickOptionExpanded : overrideValue;
});
//# sourceMappingURL=toggleThemeQuickOptionExpansion.js.map

/***/ }),

/***/ 4967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_session_store_1 = __webpack_require__(151);
var getTheme_1 = __webpack_require__(1629);
var normalizeThemeId_1 = __webpack_require__(702);
var getAvailableThemeIds_1 = __webpack_require__(3370);
function isThemePreviewDirty() {
    var savedTheme = normalizeThemeId_1.default(owa_session_store_1.getUserConfiguration().UserOptions.ThemeStorageId);
    var loadedTheme = getTheme_1.default();
    return (savedTheme !== loadedTheme &&
        // We check against available theme ids, so that the form is not immediately dirty
        // just because you have a theme not available through the form
        getAvailableThemeIds_1.default().indexOf(loadedTheme) !== -1);
}
exports.default = isThemePreviewDirty;
//# sourceMappingURL=isThemePreviewDirty.js.map

/***/ }),

/***/ 4968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_shortcut_option_1 = __webpack_require__(4969);
var configurationSubCategory = {
    key: 'configuration',
    titleStringKey: 'optionSubcategory_configuration',
    options: [owa_shortcut_option_1.KeyboardShortcutsOption],
};
exports.default = configurationSubCategory;
//# sourceMappingURL=configurationSubCategory.js.map

/***/ }),

/***/ 4969:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var KeyboardShortcutsOption_1 = __webpack_require__(4970);
exports.KeyboardShortcutsOption = KeyboardShortcutsOption_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var KeyboardShortcutsFull_1 = __webpack_require__(4971);
var isKeyboardShortcutsOptionDirty_1 = __webpack_require__(4973);
var discardKeyboardShortcutsOption_1 = __webpack_require__(4974);
var saveKeyboardShortcutsOption_1 = __webpack_require__(4975);
var KeyboardShortcutsOption = {
    key: 'shortcuts',
    titleStringKey: 'optionTitle_shortcuts',
    searchTermsStringKey: 'optionTitle_shortcuts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(KeyboardShortcutsFull_1.default, null); },
        isDirty: isKeyboardShortcutsOptionDirty_1.default,
        onSave: saveKeyboardShortcutsOption_1.default,
        onDiscard: discardKeyboardShortcutsOption_1.default,
    },
};
exports.default = KeyboardShortcutsOption;
//# sourceMappingURL=KeyboardShortcutsOption.js.map

/***/ }),

/***/ 4971:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3059);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var ChoiceGroup_1 = __webpack_require__(2613);
var selectShortcutsOption_1 = __webpack_require__(4972);
var owa_options_controls_1 = __webpack_require__(2661);
var KeyboardShortcutsFull = /** @class */ (function (_super) {
    tslib_1.__extends(KeyboardShortcutsFull, _super);
    function KeyboardShortcutsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyboardShortcutsFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var selectedKey = "" + owa_options_core_1.getFallbackValueIfNull(optionState.shortcuts, userOptions.KeyboardShortcutsMode);
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_shortcuts_description),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { label: owa_options_strings_1.default.options_shortcuts_label, selectedKey: selectedKey, options: [
                    {
                        key: "" + 0 /* Hotmail */,
                        text: owa_options_strings_1.default.options_shortcut_choice_hotmail,
                    },
                    {
                        key: "" + 2 /* Yahoo */,
                        text: owa_options_strings_1.default.options_shortcut_choice_yahoo,
                    },
                    {
                        key: "" + 3 /* Gmail */,
                        text: owa_options_strings_1.default.options_shortcut_choice_gmail,
                    },
                    {
                        key: "" + 4 /* Owa */,
                        text: owa_options_strings_1.default.options_shortcut_choice_outlook,
                    },
                    {
                        key: "" + 1 /* Off */,
                        text: owa_options_strings_1.default.options_shortcut_choice_off,
                    },
                ], onChange: this.onChange })));
    };
    KeyboardShortcutsFull.prototype.onChange = function (ev, option) {
        selectShortcutsOption_1.default(parseInt(option.key, 10));
    };
    KeyboardShortcutsFull = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
            optionState: function () { return store_1.default(); },
        })
    ], KeyboardShortcutsFull);
    return KeyboardShortcutsFull;
}(React.Component));
exports.default = KeyboardShortcutsFull;
//# sourceMappingURL=KeyboardShortcutsFull.js.map

/***/ }),

/***/ 4972:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3059);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('selectShortcutsOption', function selectShortcutsOption(shortcutSet) {
    var optionState = store_1.default();
    optionState.shortcuts = shortcutSet;
});
//# sourceMappingURL=selectShortcutsOption.js.map

/***/ }),

/***/ 4973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3059);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default(); },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isKeyboardShortcutsOptionDirty(state) {
    var userOptions = state.userOptions, optionState = state.optionState;
    return (owa_options_core_1.getFallbackValueIfNull(optionState.shortcuts, userOptions.KeyboardShortcutsMode) !==
        userOptions.KeyboardShortcutsMode);
});
//# sourceMappingURL=isKeyboardShortcutsOptionDirty.js.map

/***/ }),

/***/ 4974:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3059);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('discardKeyboardShortcutsOption', function discardKeyboardShortcutsOption() {
    var optionState = store_1.default();
    optionState.shortcuts = null;
});
//# sourceMappingURL=discardKeyboardShortcutsOption.js.map

/***/ }),

/***/ 4975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_core_2 = __webpack_require__(1736);
var store_1 = __webpack_require__(3059);
function saveKeyboardShortcutsOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = store_1.default();
                    owa_options_core_1.updateUserOptions({
                        KeyboardShortcutsMode: optionState.shortcuts,
                    });
                    return [4 /*yield*/, owa_options_core_2.updateUserConfiguration([
                            {
                                propertyName: 'KeyboardShortcutsMode',
                                propertyType: 'Integer32',
                                propertyValue: "" + optionState.shortcuts,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = saveKeyboardShortcutsOption;
//# sourceMappingURL=saveKeyboardShortcutsOption.js.map

/***/ }),

/***/ 4976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_skype_option_1 = __webpack_require__(3371);
var skypeSubCategory = {
    key: 'skype',
    titleStringKey: 'optionSubcategory_skype',
    options: [owa_skype_option_1.SkypeNotificationOption],
};
exports.default = skypeSubCategory;
//# sourceMappingURL=skypeSubCategory.js.map

/***/ }),

/***/ 4977:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attachmentsSubCategory_1 = __webpack_require__(4978);
var automationSubCategory_1 = __webpack_require__(5004);
var blockAllowSubCategory_1 = __webpack_require__(5014);
var handlingSubCategory_1 = __webpack_require__(5039);
var layoutSubCategory_1 = __webpack_require__(5064);
var messageContentSubcategory_1 = __webpack_require__(5130);
var rulesSubCategory_1 = __webpack_require__(5161);
var surfaceActionsSubcategory_1 = __webpack_require__(5236);
var mailCategory = {
    key: 'mail',
    titleStringKey: 'optionCategory_Mail',
    icon: "Mail" /* Mail */,
    subcategories: [
        layoutSubCategory_1.default,
        automationSubCategory_1.default,
        handlingSubCategory_1.default,
        attachmentsSubCategory_1.default,
        messageContentSubcategory_1.default,
        blockAllowSubCategory_1.default,
        rulesSubCategory_1.default,
        surfaceActionsSubcategory_1.default,
    ],
};
exports.default = mailCategory;
//# sourceMappingURL=category.js.map

/***/ }),

/***/ 4978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AttachmentPreferencesOption_1 = __webpack_require__(4979);
var StorageAccountsOption_1 = __webpack_require__(4986);
var attachmentsSubCategory = {
    key: 'attachments',
    titleStringKey: 'optionSubcategory_attachments',
    options: [AttachmentPreferencesOption_1.default, StorageAccountsOption_1.default],
};
exports.default = attachmentsSubCategory;
//# sourceMappingURL=attachmentsSubCategory.js.map

/***/ }),

/***/ 4979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var AttachmentPreferencesFull_1 = __webpack_require__(4980);
var isAttachmentPreferencesOptionDirty_1 = __webpack_require__(4983);
var discardAttachmentPreferencesOption_1 = __webpack_require__(4984);
var saveAttachmentPreferencesOption_1 = __webpack_require__(4985);
var AttachmentPreferencesOption = {
    key: 'attachmentPreferences',
    titleStringKey: 'optionTitle_attachmentPreferences',
    searchTermsStringKey: 'optionTitle_attachmentPreferences',
    fullOptionFormSettings: {
        render: function () { return React.createElement(AttachmentPreferencesFull_1.default, null); },
        isDirty: isAttachmentPreferencesOptionDirty_1.default,
        onSave: saveAttachmentPreferencesOption_1.default,
        onDiscard: discardAttachmentPreferencesOption_1.default,
    },
};
exports.default = AttachmentPreferencesOption;
//# sourceMappingURL=AttachmentPreferencesOption.js.map

/***/ }),

/***/ 4980:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3061);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var AttachmentPreferencesChoiceGroup_1 = __webpack_require__(4981);
var AttachmentPreferencesFull = /** @class */ (function (_super) {
    tslib_1.__extends(AttachmentPreferencesFull, _super);
    function AttachmentPreferencesFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttachmentPreferencesFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var fromComputerSelectedKey = owa_options_core_1.getFallbackValueIfNull(optionStore.fromComputer, userOptions.AttachOrShareLocalFiles);
        var fromOneDriveSelectedKey = owa_options_core_1.getFallbackValueIfNull(optionStore.fromOneDrive, userOptions.AttachOrShareCloudFiles);
        return (React.createElement("div", null,
            React.createElement(AttachmentPreferencesChoiceGroup_1.default, { selectedKey: fromComputerSelectedKey, label: owa_options_strings_1.default.options_attachmentPreferences_localLabel, optionKey: "fromComputer" }),
            React.createElement(AttachmentPreferencesChoiceGroup_1.default, { selectedKey: fromOneDriveSelectedKey, label: owa_options_strings_1.default.options_attachmentPreferences_cloudLabel, optionKey: "fromOneDrive" })));
    };
    AttachmentPreferencesFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
        })
    ], AttachmentPreferencesFull);
    return AttachmentPreferencesFull;
}(React.Component));
exports.default = AttachmentPreferencesFull;
//# sourceMappingURL=AttachmentPreferencesFull.js.map

/***/ }),

/***/ 4981:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectAttachmentPreferencesOption_1 = __webpack_require__(4982);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var AttachmentPreferencesChoiceGroup = /** @class */ (function (_super) {
    tslib_1.__extends(AttachmentPreferencesChoiceGroup, _super);
    function AttachmentPreferencesChoiceGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectAttachmentPreferencesOption_1.default(_this.props.optionKey, parseInt(option.key, 10));
        };
        return _this;
    }
    AttachmentPreferencesChoiceGroup.prototype.render = function () {
        var _a = this.props, selectedKey = _a.selectedKey, label = _a.label;
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + selectedKey, label: label, options: [
                {
                    key: "" + 0 /* None */,
                    text: owa_options_strings_1.default.options_attachmentPreferences_askOption,
                },
                {
                    key: "" + 2 /* Share */,
                    text: owa_options_strings_1.default.options_attachmentPreferences_shareOption,
                },
                {
                    key: "" + 1 /* Attach */,
                    text: owa_options_strings_1.default.options_attachmentPreferences_attachOption,
                },
            ], onChange: this.onChange }));
    };
    AttachmentPreferencesChoiceGroup = tslib_1.__decorate([
        mobx_react_1.observer
    ], AttachmentPreferencesChoiceGroup);
    return AttachmentPreferencesChoiceGroup;
}(React.Component));
exports.default = AttachmentPreferencesChoiceGroup;
//# sourceMappingURL=AttachmentPreferencesChoiceGroup.js.map

/***/ }),

/***/ 4982:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3061);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectAttachmentPreferencesOption')(function selectAttachmentPreferencesOption(optionKey, preference, state) {
    var optionState = state.optionState;
    optionState[optionKey] = preference;
}));
//# sourceMappingURL=selectAttachmentPreferencesOption.js.map

/***/ }),

/***/ 4983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3061);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(function isAttachmentPreferencesOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var fromComputer = owa_options_core_1.getFallbackValueIfNull(optionState.fromComputer, userOptions.AttachOrShareLocalFiles);
    var fromOneDrive = owa_options_core_1.getFallbackValueIfNull(optionState.fromOneDrive, userOptions.AttachOrShareCloudFiles);
    return (fromComputer !== userOptions.AttachOrShareLocalFiles ||
        fromOneDrive !== userOptions.AttachOrShareCloudFiles);
});
//# sourceMappingURL=isAttachmentPreferencesOptionDirty.js.map

/***/ }),

/***/ 4984:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3061);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardAttachmentPreferencesOption')(function discardAttachmentPreferencesOption(state) {
    var optionState = state.optionState;
    optionState.fromComputer = null;
    optionState.fromOneDrive = null;
}));
//# sourceMappingURL=discardAttachmentPreferencesOption.js.map

/***/ }),

/***/ 4985:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3061);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_core_2 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(legacy_1.action('saveAttachmentPreferencesOption')(function saveAttachmentPreferencesOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.AttachOrShareLocalFiles = owa_options_core_1.getFallbackValueIfNull(optionState.fromComputer, userOptions.AttachOrShareLocalFiles);
                    userOptions.AttachOrShareCloudFiles = owa_options_core_1.getFallbackValueIfNull(optionState.fromOneDrive, userOptions.AttachOrShareCloudFiles);
                    return [4 /*yield*/, owa_options_core_2.updateUserConfiguration([
                            {
                                propertyName: 'AttachOrShareLocalFiles',
                                propertyType: 'Integer32',
                                propertyValue: "" + userOptions.AttachOrShareLocalFiles,
                            },
                            {
                                propertyName: 'AttachOrShareCloudFiles',
                                propertyType: 'Integer32',
                                propertyValue: "" + userOptions.AttachOrShareCloudFiles,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveAttachmentPreferencesOption.js.map

/***/ }),

/***/ 4986:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var StorageAccountsFull_1 = __webpack_require__(4987);
var StorageAccountsOption = {
    key: 'storageAccounts',
    titleStringKey: 'optionTitle_storageAccounts',
    searchTermsStringKey: 'optionTitle_storageAccounts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(StorageAccountsFull_1.default, null); },
        isDirty: function () { return false; },
        onSave: function () { return Promise.resolve(); },
        onDiscard: function () { },
    },
};
exports.default = StorageAccountsOption;
//# sourceMappingURL=StorageAccountsOption.js.map

/***/ }),

/***/ 4987:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var HeaderContainer_1 = __webpack_require__(3732);
var StorageAccountsListView_1 = __webpack_require__(4990);
var initializeStorageAccountsOption_1 = __webpack_require__(5000);
var Spinner_1 = __webpack_require__(670);
var owa_filepicker_options_view_1 = __webpack_require__(3733);
var owa_filepicker_store_1 = __webpack_require__(1590);
var owa_fileprovider_store_1 = __webpack_require__(597);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var ReactDOM = __webpack_require__(71);
var AddStorageAccountCallout_1 = __webpack_require__(5001);
var owa_lightning_1 = __webpack_require__(638);
var styles = __webpack_require__(5002);
var StorageAccountsFull = /** @class */ (function (_super) {
    tslib_1.__extends(StorageAccountsFull, _super);
    function StorageAccountsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addAndSelectFileProviderAction = null;
        // Keeps track of whether there is already an account removal action going on
        _this.isAccountBeingRemoved = {};
        _this.getAddStorageAccountFunc = function (account) {
            return function () {
                // If we already have the action loaded then just execute it
                // otherwise make an asynchronous call to load it and then call it
                // which will trigger the popup blocker but its the fallback logic.
                if (_this.addAndSelectFileProviderAction) {
                    _this.addAndSelectFileProviderAction(account.type);
                }
                else {
                    owa_filepicker_store_1.lazyAddAndSelectFileProvider.import().then(function (addAndSelectFileProvider) {
                        addAndSelectFileProvider(account.type);
                    });
                }
            };
        };
        _this.removeAccount = function (viewState) {
            var id = viewState.model.Id;
            if (!_this.isAccountBeingRemoved[id]) {
                // If there was no ongoing account removal action for the
                // corresponding account then initiate it. The reason we only
                // allow one removal action to be called at a time as otherwise
                // any other requests after the successful removal of account will fail
                // which might cause the removal failure dialog to open giving the impression
                // to user that removing the account failed.
                _this.isAccountBeingRemoved[id] = true;
                owa_filepicker_store_1.lazyRemoveFileProvider
                    .importAndExecute(viewState.model.Id)
                    .then(function () {
                    // Set the state back to false as the operation completed
                    _this.isAccountBeingRemoved[id] = false;
                })
                    .catch(function () {
                    /* Ignore any error */
                    // Set the state back to false as the operation completed
                    _this.isAccountBeingRemoved[id] = false;
                });
            }
        };
        return _this;
    }
    StorageAccountsFull.prototype.componentDidMount = function () {
        var _this = this;
        // Initialize the addAndSelectFileProvider so that by the time user clicks it
        // we don't have to import it asynchornously and execute as that can cause
        // popup blocker to trigger
        owa_filepicker_store_1.lazyAddAndSelectFileProvider.import().then(function (addAndSelectFileProvider) {
            _this.addAndSelectFileProviderAction = addAndSelectFileProvider;
        });
        initializeStorageAccountsOption_1.default();
    };
    StorageAccountsFull.prototype.render = function () {
        var target;
        var _a = this.props, addableFileProvidersViewState = _a.addableFileProvidersViewState, fileProvidersViewState = _a.fileProvidersViewState, areFileProvidersLoaded = _a.areFileProvidersLoaded;
        var _b = this.getStorageAccountCategories(fileProvidersViewState), primaryAccounts = _b.primaryAccounts, secondaryAccounts = _b.secondaryAccounts;
        var providersToAddInfo = this.getStorageAccountToAdd(addableFileProvidersViewState);
        return areFileProvidersLoaded ? (React.createElement("div", { className: styles.container },
            React.createElement("div", null,
                providersToAddInfo.length !== 0 && (React.createElement("div", null,
                    React.createElement(HeaderContainer_1.default, { className: styles.fileProvidersToAddContainer, ref: function (ref) { return (target = ReactDOM.findDOMNode(ref)); }, header: owa_options_strings_1.default.options_storageAccounts_addAccountHeader },
                        React.createElement(owa_filepicker_options_view_1.FileProvidersToAddListView, { providersToAddInfo: providersToAddInfo })),
                    React.createElement(AddStorageAccountCallout_1.AddStorageAccountCallout, { lid: owa_lightning_1.LightningId.AddStorageAccountCallout, when: function (lightup) { return setTimeout(lightup, 500); }, target: function () { return target; } }))),
                React.createElement(StorageAccountsListView_1.default, { header: owa_options_strings_1.default.options_storageAccounts_primaryAccount, storageAccounts: primaryAccounts }),
                React.createElement(StorageAccountsListView_1.default, { header: owa_options_strings_1.default.options_storageAccounts_otherAccounts, storageAccounts: secondaryAccounts, onRemoveHandler: this.removeAccount })))) : (React.createElement(Spinner_1.Spinner, null));
    };
    StorageAccountsFull.prototype.getStorageAccountToAdd = function (accountsToAdd) {
        var _this = this;
        return accountsToAdd.map(function (account) {
            return {
                providerType: account.type,
                onClick: _this.getAddStorageAccountFunc(account),
            };
        });
    };
    StorageAccountsFull.prototype.getStorageAccountCategories = function (providers) {
        var _a = providers.filter(function (p) { return p.type !== 4 /* Mailbox */; }), primaryProvider = _a[0], secondaryProviders = _a.slice(1);
        return {
            primaryAccounts: primaryProvider ? [primaryProvider] : [],
            secondaryAccounts: secondaryProviders,
        };
    };
    StorageAccountsFull = tslib_1.__decorate([
        react_1.reactive({
            fileProvidersViewState: function () { return owa_fileprovider_store_1.store.fileProvidersViewState; },
            addableFileProvidersViewState: function () { return owa_fileprovider_store_1.store.addableFileProvidersViewState; },
            areFileProvidersLoaded: function () { return owa_fileprovider_store_1.store.areFileProvidersLoaded; },
        })
    ], StorageAccountsFull);
    return StorageAccountsFull;
}(React.Component));
exports.default = StorageAccountsFull;
//# sourceMappingURL=StorageAccountsFull.js.map

/***/ }),

/***/ 4988:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4989);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4989:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._29nyZ4KidIJk11t-3Gg_-c{font-weight:300;font-size:14px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._29nyZ4KidIJk11t-3Gg_-c{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"header": "_29nyZ4KidIJk11t-3Gg_-c"
};

/***/ }),

/***/ 4990:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var HeaderContainer_1 = __webpack_require__(3732);
var mobx_react_1 = __webpack_require__(11);
var owa_filepicker_options_view_1 = __webpack_require__(3733);
var React = __webpack_require__(3);
var styles = __webpack_require__(4998);
var StorageAccountsListView = /** @class */ (function (_super) {
    tslib_1.__extends(StorageAccountsListView, _super);
    function StorageAccountsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StorageAccountsListView.prototype.render = function () {
        var _this = this;
        return (React.createElement(HeaderContainer_1.default, { className: styles.container, header: this.props.header },
            React.createElement("div", null, this.props.storageAccounts.map(function (storageAccount) {
                var removeHandler = _this.props.onRemoveHandler &&
                    (function () { return _this.props.onRemoveHandler(storageAccount); });
                return (React.createElement("div", { key: storageAccount.model.Id, className: styles.storageAccount },
                    React.createElement(owa_filepicker_options_view_1.FileProviderView, { providerType: storageAccount.type, providerName: storageAccount.name, displayText: storageAccount.model.AssociatedDataProviderAccountId, onRemoveClicked: removeHandler })));
            }))));
    };
    StorageAccountsListView = tslib_1.__decorate([
        mobx_react_1.observer
    ], StorageAccountsListView);
    return StorageAccountsListView;
}(React.Component));
exports.default = StorageAccountsListView;
//# sourceMappingURL=StorageAccountsListView.js.map

/***/ }),

/***/ 4998:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4999);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4999:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1pdINh6c4O0RBawz8YAln5{width:100%}html[dir] ._1pdINh6c4O0RBawz8YAln5 .ocG6IWfJpV-L4TtLekVoS{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"container": "_1pdINh6c4O0RBawz8YAln5",
	"storageAccount": "ocG6IWfJpV-L4TtLekVoS"
};

/***/ }),

/***/ 5000:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_fileprovider_store_1 = __webpack_require__(597);
var legacy_1 = __webpack_require__(1);
var isInitialized = false;
exports.default = legacy_1.action('initializeStorageAccountsOption')(function initializeStorageAccountsOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!isInitialized) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_fileprovider_store_1.lazyGetAllFileProviders.import()];
                case 1:
                    // Get the all file providers
                    (_a.sent())();
                    isInitialized = true;
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initializeStorageAccountsOption.js.map

/***/ }),

/***/ 5001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var TeachingBubble_1 = __webpack_require__(1627);
var Button_1 = __webpack_require__(62);
var owa_lightning_1 = __webpack_require__(638);
var owa_options_strings_1 = __webpack_require__(1737);
var AddStorageAccountCallout = /** @class */ (function (_super) {
    tslib_1.__extends(AddStorageAccountCallout, _super);
    function AddStorageAccountCallout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            owa_lightning_1.lighted(_this.props.lid);
        };
        return _this;
    }
    AddStorageAccountCallout.prototype.render = function () {
        var gotItButtonProps = {
            buttonType: Button_1.ButtonType.primary,
            children: owa_options_strings_1.default.options_callout_addStorageAccount_button,
            onClick: this.onClose,
        };
        return (React.createElement(TeachingBubble_1.TeachingBubble, { calloutProps: {
                beakWidth: 15,
                directionalHint: 12 /* rightCenter */,
                minPagePadding: 50,
                gapSpace: 20,
            }, targetElement: this.props.target(), hasCloseIcon: true, onDismiss: this.onClose, hasSmallHeadline: true, headline: owa_options_strings_1.default.options_callout_addStorageAccount_title, primaryButtonProps: gotItButtonProps }, owa_options_strings_1.default.options_callout_addStorageAccount_body));
    };
    AddStorageAccountCallout = tslib_1.__decorate([
        mobx_react_1.observer,
        owa_lightning_1.lightable
    ], AddStorageAccountCallout);
    return AddStorageAccountCallout;
}(React.Component));
exports.AddStorageAccountCallout = AddStorageAccountCallout;
//# sourceMappingURL=AddStorageAccountCallout.js.map

/***/ }),

/***/ 5002:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5003);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5003:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1HSowMwvzLkqhKBEwxa2y8{width:300px}html[dir] ._2ngqnsmMTZS5v3sbKWRBFf{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"container": "_1HSowMwvzLkqhKBEwxa2y8",
	"fileProvidersToAddContainer": "_2ngqnsmMTZS5v3sbKWRBFf"
};

/***/ }),

/***/ 5004:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// import JunkOption from './options/JunkOption';
var SignatureOption_1 = __webpack_require__(5005);
var automationSubCategory = {
    key: 'automation',
    titleStringKey: 'optionSubcategory_automation',
    options: [
        // JunkOption,
        SignatureOption_1.default,
    ],
};
exports.default = automationSubCategory;
//# sourceMappingURL=automationSubCategory.js.map

/***/ }),

/***/ 5005:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SignatureFull_1 = __webpack_require__(5006);
var React = __webpack_require__(3);
var isSignatureOptionDirty_1 = __webpack_require__(5011);
var discardSignatureOption_1 = __webpack_require__(5012);
var saveSignatureOption_1 = __webpack_require__(5013);
var SignatureOption = {
    key: 'signature',
    titleStringKey: 'optionTitle_signature',
    searchTermsStringKey: 'optionTitle_signature',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SignatureFull_1.default, null); },
        isDirty: isSignatureOptionDirty_1.default,
        onSave: saveSignatureOption_1.default,
        onDiscard: discardSignatureOption_1.default,
    },
};
exports.default = SignatureOption;
//# sourceMappingURL=SignatureOption.js.map

/***/ }),

/***/ 5006:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var initializeSignatureContent_1 = __webpack_require__(3734);
var store_1 = __webpack_require__(2893);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_controls_1 = __webpack_require__(2661);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var SignatureEditor_1 = __webpack_require__(5007);
var toggleSignatureSetting_1 = __webpack_require__(5010);
var SignatureFull = /** @class */ (function (_super) {
    tslib_1.__extends(SignatureFull, _super);
    function SignatureFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SignatureFull.prototype.componentDidMount = function () {
        initializeSignatureContent_1.default();
    };
    SignatureFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_signature_title),
            React.createElement(SignatureEditor_1.default, null),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { label: owa_options_strings_1.default.options_signature_signNewMails, checked: owa_options_core_1.getFallbackValueIfNull(optionStore.signNewMails, userOptions.AutoAddSignature), onChange: this.onSignNewEmailsClicked }),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { label: owa_options_strings_1.default.options_signature_signReplies, checked: owa_options_core_1.getFallbackValueIfNull(optionStore.signReplies, userOptions.AutoAddSignatureOnReply), onChange: this.onSignRepliesClicked })));
    };
    SignatureFull.prototype.onSignNewEmailsClicked = function (ev, checked) {
        toggleSignatureSetting_1.default('signNewMails', checked);
    };
    SignatureFull.prototype.onSignRepliesClicked = function (ev, checked) {
        toggleSignatureSetting_1.default('signReplies', checked);
    };
    SignatureFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], SignatureFull);
    return SignatureFull;
}(React.Component));
exports.default = SignatureFull;
//# sourceMappingURL=SignatureFull.js.map

/***/ }),

/***/ 5007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var initializeSignatureContent_1 = __webpack_require__(3734);
var store_1 = __webpack_require__(2893);
var owa_session_store_1 = __webpack_require__(151);
// import strings from 'owa-strings/owa-options-strings';
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_editor_1 = __webpack_require__(2159);
var mobx_1 = __webpack_require__(15);
var owa_editor_ribbonplugin_1 = __webpack_require__(2216);
var Spinner_1 = __webpack_require__(670);
var styles = __webpack_require__(5008);
var SignatureEditor = /** @class */ (function (_super) {
    tslib_1.__extends(SignatureEditor, _super);
    function SignatureEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.ribbonPlugin = new owa_editor_ribbonplugin_1.LazyRibbonPluginClass(_this.props.optionStore.ribbon, _this.props.optionStore.editorViewState);
        return _this;
    }
    SignatureEditor.prototype.componentDidMount = function () {
        initializeSignatureContent_1.default();
    };
    SignatureEditor.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, isRtl = _a.isRtl;
        return (React.createElement("div", { className: styles.editorContainer }, this.isMessageOptionsFetchComplete ? ([
            React.createElement(owa_editor_ribbonplugin_1.Ribbon, { key: "ribbon", ribbonPlugin: this.ribbonPlugin, viewState: optionStore.ribbon, className: styles.ribbon }),
            React.createElement(owa_editor_1.ReactEditor, { key: "editor", isRtl: isRtl, viewState: optionStore.editorViewState, plugins: this.plugins, classNames: styles.editor, updateOnKeyPress: true }),
        ]) : (React.createElement("div", { className: styles.loading },
            React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.medium })))));
    };
    Object.defineProperty(SignatureEditor.prototype, "plugins", {
        get: function () {
            // VSO 14829 - Use a common collection of plugins
            return [this.ribbonPlugin];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignatureEditor.prototype, "isMessageOptionsFetchComplete", {
        get: function () {
            var optionStore = this.props.optionStore;
            return optionStore.editorViewState.content !== null;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], SignatureEditor.prototype, "isMessageOptionsFetchComplete", null);
    SignatureEditor = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
            isRtl: function () { return owa_session_store_1.getUserConfiguration().SessionSettings.IsUserCultureRightToLeft; },
        })
    ], SignatureEditor);
    return SignatureEditor;
}(React.Component));
exports.default = SignatureEditor;
//# sourceMappingURL=SignatureEditor.js.map

/***/ }),

/***/ 5008:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5009);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5009:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1qVDrz-2ttmt4X8g2O_6Bw{width:100%;max-width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;height:250px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap}html[dir] ._1qVDrz-2ttmt4X8g2O_6Bw{border:solid 1px \"[theme:neutralTertiaryAlt, default:#c8c8c8]\";margin:12px 0}._1qVDrz-2ttmt4X8g2O_6Bw ._2jMR__uQZbxuuzqgQBf3cW{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir] ._1qVDrz-2ttmt4X8g2O_6Bw ._2jMR__uQZbxuuzqgQBf3cW{background-color:\"[theme:composeNeutralBackground, default:#FFFFFF]\";padding:0 10px;margin-top:1px}._1qVDrz-2ttmt4X8g2O_6Bw ._3tCQHXP4fKWXElJjf2iwLr{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;font-size:12pt;resize:none;outline:none;overflow:auto;cursor:auto}html[dir] ._1qVDrz-2ttmt4X8g2O_6Bw ._3tCQHXP4fKWXElJjf2iwLr{background-color:#fff;border:none;padding:10px}._1qVDrz-2ttmt4X8g2O_6Bw ._3tCQHXP4fKWXElJjf2iwLr #divtagdefaultwrapper{color:#666}html[dir] ._1qVDrz-2ttmt4X8g2O_6Bw ._3tCQHXP4fKWXElJjf2iwLr #divtagdefaultwrapper{margin-top:0;margin-bottom:0}._1qVDrz-2ttmt4X8g2O_6Bw ._1JGYN61gkh2MQmTsbkJ3Hz{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}html[dir] ._1qVDrz-2ttmt4X8g2O_6Bw ._1JGYN61gkh2MQmTsbkJ3Hz{background:\"[theme:neutralLight, default:#eaeaea]\"}", ""]);

// exports
exports.locals = {
	"editorContainer": "_1qVDrz-2ttmt4X8g2O_6Bw",
	"ribbon": "_2jMR__uQZbxuuzqgQBf3cW",
	"editor": "_3tCQHXP4fKWXElJjf2iwLr",
	"loading": "_1JGYN61gkh2MQmTsbkJ3Hz"
};

/***/ }),

/***/ 5010:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2893);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('toggleSignatureSetting')(function toggleSignatureSetting(field, checked, state) {
    var optionState = state.optionState;
    optionState[field] = checked;
}));
//# sourceMappingURL=toggleSignatureSetting.js.map

/***/ }),

/***/ 5011:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2893);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var owa_options_core_1 = __webpack_require__(1736);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isSignatureOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (optionState.editorViewState.isDirty ||
        owa_options_core_1.getFallbackValueIfNull(optionState.signNewMails, userOptions.AutoAddSignature) !==
            userOptions.AutoAddSignature ||
        owa_options_core_1.getFallbackValueIfNull(optionState.signReplies, userOptions.AutoAddSignatureOnReply) !==
            userOptions.AutoAddSignatureOnReply);
});
//# sourceMappingURL=isSignatureOptionDirty.js.map

/***/ }),

/***/ 5012:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2893);
var createEditorViewState_1 = __webpack_require__(3735);
var legacy_1 = __webpack_require__(1);
var owa_session_store_1 = __webpack_require__(151);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('discardSignatureOption')(function discardSignatureOption(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    optionState.editorViewState = createEditorViewState_1.default(userOptions.SignatureHtml /*content*/, false /*isDirty*/);
    optionState.signNewMails = null;
    optionState.signReplies = null;
}));
//# sourceMappingURL=discardSignatureOption.js.map

/***/ }),

/***/ 5013:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(2893);
var legacy_1 = __webpack_require__(1);
var owa_session_store_1 = __webpack_require__(151);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveSignatureOption')(function saveSignatureOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceOptions = {};
                    if (optionState.editorViewState.isDirty) {
                        userOptions.SignatureHtml = optionState.editorViewState.content;
                        serviceOptions.SignatureHtml = optionState.editorViewState.content;
                        // Reset isDirty so the save/discard buttons reset
                        optionState.editorViewState.isDirty = false;
                    }
                    if (optionState.signNewMails !== null) {
                        userOptions.AutoAddSignature = optionState.signNewMails;
                        serviceOptions.AutoAddSignature = optionState.signNewMails;
                    }
                    if (optionState.signReplies !== null) {
                        userOptions.AutoAddSignatureOnReply = optionState.signReplies;
                        serviceOptions.AutoAddSignatureOnReply = optionState.signReplies;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration(serviceOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSignatureOption.js.map

/***/ }),

/***/ 5014:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var BlockedDomainsOption_1 = __webpack_require__(5015);
var BlockedSendersOption_1 = __webpack_require__(5033);
var owa_junkmail_configuration_1 = __webpack_require__(2894);
var owa_trace_1 = __webpack_require__(14);
var blockAllowSubCategory = {
    key: 'blockAllow',
    titleStringKey: 'optionSubcategory_junkEmail',
    options: [BlockedSendersOption_1.default, BlockedDomainsOption_1.default],
    onSelected: function () {
        return loadMailboxJunkEmailConfiguration();
    },
};
exports.default = blockAllowSubCategory;
function loadMailboxJunkEmailConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, owa_junkmail_configuration_1.initMailboxJunkEmailConfiguration()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    owa_trace_1.trace.warn(e_1.message || 'loadMailboxJunkEmailConfiguration failed');
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=blockAllowSubCategory.js.map

/***/ }),

/***/ 5015:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardBlockedDomainsOption_1 = __webpack_require__(5016);
var saveBlockedDomainsOption_1 = __webpack_require__(5017);
var BlockedDomainsFull_1 = __webpack_require__(5030);
var isBlockedDomainsOptionDirty_1 = __webpack_require__(5032);
var React = __webpack_require__(3);
var BlockedDomainsOption = {
    key: 'blockedDomains',
    titleStringKey: 'optionTitle_blockedDomains',
    searchTermsStringKey: 'optionSearchTerms_blockedDomains',
    fullOptionFormSettings: {
        render: function () { return React.createElement(BlockedDomainsFull_1.default, null); },
        isDirty: isBlockedDomainsOptionDirty_1.default,
        onSave: saveBlockedDomainsOption_1.default,
        onDiscard: discardBlockedDomainsOption_1.default,
    },
};
exports.default = BlockedDomainsOption;
//# sourceMappingURL=BlockedDomainsOption.js.map

/***/ }),

/***/ 5016:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3062);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardBlockedDomainsOption')(function discardBlockedDomainsOption(state) {
    var optionState = state.optionState;
    optionState.blockedDomains = null;
}));
//# sourceMappingURL=discardBlockedDomainsOption.js.map

/***/ }),

/***/ 5017:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3062);
var owa_options_core_1 = __webpack_require__(1736);
var legacy_1 = __webpack_require__(1);
var owa_junkmail_configuration_1 = __webpack_require__(2894);
var owa_mail_option_common_1 = __webpack_require__(2939);
exports.default = legacy_1.select({
    mailboxJunkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveBlockedDomainsOption')(function saveBlockedDomainsOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, mailboxJunkEmailConfiguration, optionState, blockedDomains, blockedSenders, blockedSenderAndDomains;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = state, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration, optionState = _a.optionState;
                    blockedDomains = owa_options_core_1.getFallbackValueIfNull(optionState.blockedDomains, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !owa_mail_option_common_1.isEmailAddress(item); }));
                    blockedSenders = mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) {
                        return owa_mail_option_common_1.isEmailAddress(item);
                    });
                    blockedSenderAndDomains = blockedSenders.concat(blockedDomains.slice());
                    mailboxJunkEmailConfiguration.BlockedSendersAndDomains = blockedSenderAndDomains;
                    return [4 /*yield*/, owa_junkmail_configuration_1.saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveBlockedDomainsOption.js.map

/***/ }),

/***/ 5018:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(3379);
var setMailboxJunkEmailConfiguration_1 = __webpack_require__(5019);
exports.default = legacy_1.action('saveMailboxJunkMailConfiguration')(function saveMailboxJunkMailConfiguration(mailboxJunkEmailConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store_1.default.mailboxJunkEmailConfiguration = mailboxJunkEmailConfiguration;
                    return [4 /*yield*/, setMailboxJunkEmailConfiguration_1.default(mailboxJunkEmailConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveMailboxJunkEmailConfiguration.js.map

/***/ }),

/***/ 5019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setMailboxJunkEmailConfigurationOperation_1 = __webpack_require__(5020);
var ServiceRequestUtils_1 = __webpack_require__(31);
function saveMailboxJunkEmailConfiguration(options) {
    return setMailboxJunkEmailConfigurationOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Options: options,
    });
}
exports.default = saveMailboxJunkEmailConfiguration;
//# sourceMappingURL=setMailboxJunkEmailConfiguration.js.map

/***/ }),

/***/ 5020:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var setMailboxJunkEmailConfigurationRequest_1 = __webpack_require__(5021);
function setMailboxJunkEmailConfigurationOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = setMailboxJunkEmailConfigurationRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("SetMailboxJunkEmailConfiguration", req, options);
}
exports.default = setMailboxJunkEmailConfigurationOperation;


/***/ }),

/***/ 5021:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function setMailboxJunkEmailConfigurationRequest(data) {
    var result = tslib_1.__assign({ __type: 'SetMailboxJunkEmailConfigurationRequest:#Exchange' }, data);
    return result;
}
exports.default = setMailboxJunkEmailConfigurationRequest;


/***/ }),

/***/ 5022:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3379);
/**
 * Returns the mailbox junk email configuration object which is observable
 */
function getMailboxJunkEmailConfiguration() {
    return store_1.default.mailboxJunkEmailConfiguration;
}
exports.default = getMailboxJunkEmailConfiguration;
//# sourceMappingURL=getMailboxJunkEmailConfiguration.js.map

/***/ }),

/***/ 5023:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(3379);
var getMailboxJunkEmailConfiguration_1 = __webpack_require__(5024);
exports.default = legacy_1.action('initMailboxJunkEmailConfiguration')(function initMailboxJunkEmailConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Always reload the junk email configuration because the user may change
                    // the configuration at any time by blocking senders of individual emails
                    _a = store_1.default;
                    return [4 /*yield*/, getMailboxJunkEmailConfiguration_1.default()];
                case 1:
                    // Always reload the junk email configuration because the user may change
                    // the configuration at any time by blocking senders of individual emails
                    _a.mailboxJunkEmailConfiguration = _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initMailboxJunkEmailConfiguration.js.map

/***/ }),

/***/ 5024:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getMailboxJunkEmailConfigurationOperation_1 = __webpack_require__(3380);
function loadMailboxJunkEmailConfiguration() {
    return getMailboxJunkEmailConfigurationOperation_1.default().then(function (responseMessage) {
        if (responseMessage.WasSuccessful) {
            return responseMessage.Options;
        }
        else {
            throw new Error("getMailboxJunkEmailConfigurationOperation " + responseMessage.ErrorCode + " " + responseMessage.ErrorMessage);
        }
    });
}
exports.default = loadMailboxJunkEmailConfiguration;
//# sourceMappingURL=getMailboxJunkEmailConfiguration.js.map

/***/ }),

/***/ 5025:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var smtpAddress_1 = __webpack_require__(5026);
var mobx_1 = __webpack_require__(15);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var FocusZone_1 = __webpack_require__(78);
var List_1 = __webpack_require__(1746);
var MessageBar_1 = __webpack_require__(2938);
var TextField_1 = __webpack_require__(1741);
var owa_assert_1 = __webpack_require__(123);
var getUserConfiguration_1 = __webpack_require__(9);
var owa_options_strings_1 = __webpack_require__(1737);
var owa_trace_1 = __webpack_require__(14);
var React = __webpack_require__(3);
var Selection_1 = __webpack_require__(1714);
var KeyboardCharCodes_1 = __webpack_require__(634);
var styles = __webpack_require__(5027);
var classNames = __webpack_require__(30);
var EditSendersAndDomainsMode;
(function (EditSendersAndDomainsMode) {
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["EmailAddressOnly"] = 0] = "EmailAddressOnly";
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["DomainOnly"] = 1] = "DomainOnly";
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["EmailAddressAndDomain"] = 2] = "EmailAddressAndDomain";
})(EditSendersAndDomainsMode = exports.EditSendersAndDomainsMode || (exports.EditSendersAndDomainsMode = {}));
var ValidationResult;
(function (ValidationResult) {
    ValidationResult[ValidationResult["OK"] = 0] = "OK";
    ValidationResult[ValidationResult["InvalidAddress"] = 1] = "InvalidAddress";
    ValidationResult[ValidationResult["InvalidAddressOrDomain"] = 2] = "InvalidAddressOrDomain";
    ValidationResult[ValidationResult["InvalidDomain"] = 3] = "InvalidDomain";
    ValidationResult[ValidationResult["IsSelf"] = 4] = "IsSelf";
})(ValidationResult || (ValidationResult = {}));
var EditSendersAndDomains = /** @class */ (function (_super) {
    tslib_1.__extends(EditSendersAndDomains, _super);
    function EditSendersAndDomains() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editItemState = null;
        _this.newItemState = { errorMessage: null, value: null };
        _this.selection = null;
        _this.renderListItem = function (item, index) {
            var isEdit = _this.editItemState && _this.editItemState.index === index;
            var isSelected = _this.selection.isIndexSelected(index);
            return (React.createElement("div", { "data-selection-index": index, key: index, "data-is-focusable": !isEdit, "data-selection-disabled": isEdit }, isEdit
                ? _this.renderEditListItem(item, index)
                : _this.renderViewListItem(item, index, isSelected)));
        };
        _this.renderViewListItem = function (item, index, isSelected) {
            var itemClassName = classNames(styles.viewListItemCell, isSelected && styles.viewListItemCellSelected);
            return (React.createElement("div", { className: itemClassName, "data-is-focusable": true, key: index, onKeyDown: _this.onViewListItemTextFieldKeyDown }, item.key));
        };
        _this.renderEditListItem = function (item, index) {
            _this.selection.setChangeEvents(false);
            return (React.createElement("div", { key: index, "data-is-focusable": false },
                React.createElement(TextField_1.TextField, { "data-is-focusable": false, className: styles.textField, onBlur: function () { return _this.onEditItemTextFieldBlur(index); }, onChanged: _this.onEditItemTextFieldChanged, onFocus: _this.moveEditItemTextFieldCaretToEnd, onKeyDown: function (event) { return _this.onEditItemTextFieldKeyDown(event, index); }, ref: function (input) {
                        input && _this.shouldSetFocusInEditListItemTextField() && input.focus();
                    }, value: _this.editItemState.value }),
                _this.editItemState.errorMessage && (React.createElement(MessageBar_1.MessageBar, { isMultiline: false, messageBarType: MessageBar_1.MessageBarType.error }, _this.editItemState.errorMessage))));
        };
        _this.onAddNewItemButtonClicked = function () {
            if (_this.isDuplicate(_this.newItemState.value)) {
                _this.newItemState.value = '';
                return;
            }
            var result = _this.validateSenderOrDomain(_this.newItemState.value);
            if (result == 0 /* OK */) {
                var sendersAndDomains = _this.props.items.slice(0);
                sendersAndDomains.unshift(_this.newItemState.value.trim());
                _this.props.onItemsChanged(sendersAndDomains);
                _this.newItemState.value = '';
            }
            else {
                _this.setNewItemTextFieldErrorMessage(_this.validationErrorMessage(result));
            }
        };
        _this.onEditItemTextFieldBlur = function (index) {
            var result = _this.validateSenderOrDomain(_this.editItemState.value);
            if (result == 0 /* OK */) {
                var sendersAndDomains = _this.props.items.slice(0);
                sendersAndDomains.splice(index, 1, _this.editItemState.value.trim());
                _this.props.onItemsChanged(sendersAndDomains);
                _this.editItemState = null;
                _this.selection = null;
            }
            else {
                _this.setEditItemTextFieldErrorMessage(_this.validationErrorMessage(result));
            }
        };
        _this.resetSelectionOnNextRender = function () {
            _this.selection = null;
        };
        _this.resetSelection = function (items) {
            _this.selection = new Selection_1.Selection({
                onSelectionChanged: function () {
                    if (_this.hasMounted) {
                        _this.forceUpdate();
                    }
                },
                getKey: function (item, index) { return index.toString(); },
            });
            var itemsWithKey = items.map(function (item) {
                return { key: item };
            });
            _this.selection.setItems(itemsWithKey, false);
        };
        _this.onEditItemTextFieldChanged = function (newValue) {
            _this.clearEditItemTextFieldErrorMessage();
            _this.editItemState.value = newValue;
        };
        _this.onEditItemTextFieldKeyDown = function (event, index) {
            switch (event.keyCode) {
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                    var result = _this.validateSenderOrDomain(_this.editItemState.value);
                    if (result == 0 /* OK */) {
                        var sendersAndDomains = _this.props.items.slice(0);
                        sendersAndDomains.splice(index, 1, _this.editItemState.value.trim());
                        _this.props.onItemsChanged(sendersAndDomains);
                        _this.editItemState = null;
                        _this.resetSelectionOnNextRender();
                    }
                    else {
                        _this.setEditItemTextFieldErrorMessage(_this.validationErrorMessage(result));
                    }
                    break;
                case KeyboardCharCodes_1.ESC_CHARCODE:
                    event.stopPropagation();
                    _this.editItemState = null;
                    _this.resetSelectionOnNextRender();
                    break;
                default:
                    break;
            }
        };
        _this.onEditListItemButtonClicked = function () {
            if (_this.selection.count != 1) {
                throw new Error('onEditListItemButtonClicked with selected items count != 1');
            }
            var item = _this.selection.getItems()[0];
            var index = _this.props.items.indexOf(item.key);
            _this.editItemState = {
                value: item.key,
                index: index,
                errorMessage: null,
            };
        };
        _this.onDeleteListItemButtonClicked = function () {
            var sendersAndDomains = _this.props.items.slice(0);
            _this.selection.getSelection().forEach(function (item) {
                var index = sendersAndDomains.indexOf(item.key);
                if (index !== -1) {
                    sendersAndDomains.splice(index, 1);
                }
            });
            _this.props.onItemsChanged(sendersAndDomains);
            _this.resetSelectionOnNextRender();
        };
        _this.onItemInvoked = function (invokedItem) {
            if ((_this.editItemState && _this.editItemState.errorMessage) ||
                _this.newItemState.errorMessage) {
                return;
            }
            var index = _this.props.items.indexOf(invokedItem.key);
            if (index !== -1) {
                _this.selection.setAllSelected(false);
                _this.editItemState = {
                    value: invokedItem.key,
                    index: index,
                    errorMessage: null,
                };
            }
        };
        _this.onNewItemTextFieldChanged = function (text) {
            _this.clearNewItemTextFieldErrorMessage();
            _this.newItemState.value = text;
        };
        _this.onNewItemTextFieldFocus = function () {
            _this.selection.setAllSelected(false);
        };
        _this.onNewItemTextFieldKeyDown = function (event) {
            switch (event.keyCode) {
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                    if (_this.newItemState.value && _this.newItemState.value.length > 0) {
                        var result = _this.validateSenderOrDomain(_this.newItemState.value);
                        if (result == 0 /* OK */) {
                            _this.onAddNewItemButtonClicked();
                        }
                        else {
                            _this.setNewItemTextFieldErrorMessage(_this.validationErrorMessage(result));
                        }
                    }
                    break;
                case KeyboardCharCodes_1.ESC_CHARCODE:
                    event.stopPropagation();
                    break;
                default:
                    break;
            }
        };
        _this.onViewListItemTextFieldKeyDown = function (event) {
            switch (event.keyCode) {
                case KeyboardCharCodes_1.BACKSPACE_CHARCODE:
                case KeyboardCharCodes_1.DELETE_CHARCODE:
                    _this.onDeleteListItemButtonClicked();
                    break;
                default:
                    break;
            }
        };
        _this.moveEditItemTextFieldCaretToEnd = function (event) {
            var tempValue = event.target.value;
            event.target.value = '';
            event.target.value = tempValue;
        };
        _this.newItemTextFieldPlaceHolderText = function () {
            switch (_this.props.mode) {
                case 1 /* DomainOnly */:
                    return owa_options_strings_1.default.options_common_addDomainPlaceholder;
                case 2 /* EmailAddressAndDomain */:
                    return owa_options_strings_1.default.options_common_addSenderOrDomainPlaceholder;
                case 0 /* EmailAddressOnly */:
                    return owa_options_strings_1.default.options_common_addSenderPlaceholder;
                default:
                    return owa_assert_1.assertNever(_this.props.mode);
            }
        };
        _this.isSelf = function (smtpAddress) {
            var sessionSettings = getUserConfiguration_1.default().SessionSettings;
            var userEmailAddress = sessionSettings.UserEmailAddress;
            var lowerCaseSmtpAddress = smtpAddress.toLowerCase();
            if (!userEmailAddress) {
                owa_trace_1.trace.error('User email address from session data is null.');
            }
            return (userEmailAddress.toLowerCase() === lowerCaseSmtpAddress ||
                (sessionSettings.UserProxyAddresses &&
                    sessionSettings.UserProxyAddresses.some(function (address) { return address.toLowerCase() === lowerCaseSmtpAddress; })));
        };
        _this.setEditItemTextFieldErrorMessage = function (message) {
            _this.editItemState.errorMessage = message;
            _this.forceUpdate();
        };
        _this.setNewItemTextFieldErrorMessage = function (message) {
            _this.newItemState.errorMessage = message;
        };
        _this.clearEditItemTextFieldErrorMessage = function () {
            _this.editItemState.errorMessage = null;
            _this.forceUpdate();
        };
        _this.clearNewItemTextFieldErrorMessage = function () {
            _this.newItemState.errorMessage = null;
        };
        _this.validateSenderOrDomain = function (text) {
            var trimmedText = text.trim();
            switch (_this.props.mode) {
                case 1 /* DomainOnly */:
                    return _this.validateDomain(trimmedText);
                case 0 /* EmailAddressOnly */:
                    return _this.validateEmailAddress(trimmedText);
                case 2 /* EmailAddressAndDomain */:
                    if (_this.validateEmailAddress(trimmedText) == 0 /* OK */ ||
                        _this.validateDomain(trimmedText) == 0 /* OK */) {
                        return 0 /* OK */;
                    }
                    else {
                        return 2 /* InvalidAddressOrDomain */;
                    }
                default:
                    return owa_assert_1.assertNever(_this.props.mode);
            }
        };
        _this.validateEmailAddress = function (text) {
            if (_this.isSelf(text)) {
                return 4 /* IsSelf */;
            }
            return smtpAddress_1.isValidAddress(text) ? 0 /* OK */ : 1 /* InvalidAddress */;
        };
        _this.validateDomain = function (text) {
            return smtpAddress_1.isValidAddressDomain(text) ? 0 /* OK */ : 3 /* InvalidDomain */;
        };
        _this.validationErrorMessage = function (result) {
            switch (result) {
                case 0 /* OK */:
                    throw new Error('validationErrorMessage called for OK');
                case 1 /* InvalidAddress */:
                    return owa_options_strings_1.default.options_common_invalidAddressError;
                case 2 /* InvalidAddressOrDomain */:
                    return owa_options_strings_1.default.options_common_invalidAddressOrDomainError;
                case 3 /* InvalidDomain */:
                    return owa_options_strings_1.default.options_common_invalidDomainError;
                case 4 /* IsSelf */:
                    return owa_options_strings_1.default.options_common_invalidIsSelfError;
                default:
                    return owa_assert_1.assertNever(result);
            }
        };
        return _this;
    }
    EditSendersAndDomains.prototype.componentWillMount = function () {
        this.resetSelection(this.props.items);
    };
    EditSendersAndDomains.prototype.componentDidMount = function () {
        this.hasMounted = true;
    };
    EditSendersAndDomains.prototype.componentWillUpdate = function (nextProps, nextState) {
        if (!this.selection) {
            this.resetSelection(nextProps.items);
        }
    };
    EditSendersAndDomains.prototype.render = function () {
        var itemsWithKey = this.props.items.map(function (item) {
            return { key: item };
        });
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(Button_1.IconButton, { className: styles.editListItemButton, "data-is-focusable": true, disabled: this.selection.count !== 1, iconProps: { iconName: "Edit" /* Edit */ }, onClick: this.onEditListItemButtonClicked, styles: {
                        rootDisabled: styles.disabledButton,
                    }, title: owa_options_strings_1.default.options_common_editEmailAddressOrDomainButtonTitle }),
                React.createElement(Button_1.IconButton, { className: styles.iconButton, "data-is-focusable": true, disabled: !this.selection.count || this.selection.count === 0, iconProps: { iconName: "Delete" /* Delete */ }, onClick: this.onDeleteListItemButtonClicked, styles: {
                        rootDisabled: styles.disabledButton,
                    }, title: owa_options_strings_1.default.options_common_removeEmailAddressOrDomainButtonTitle })),
            React.createElement("div", { className: styles.outerContainer },
                React.createElement("div", { className: styles.textFieldAndListContainer },
                    React.createElement("div", null,
                        React.createElement(TextField_1.TextField, { className: styles.textField, onChanged: this.onNewItemTextFieldChanged, onFocus: this.onNewItemTextFieldFocus, onKeyDown: this.onNewItemTextFieldKeyDown, placeholder: this.newItemTextFieldPlaceHolderText(), value: this.newItemState.value || '' })),
                    this.newItemState.errorMessage && (React.createElement(MessageBar_1.MessageBar, { isMultiline: false, messageBarType: MessageBar_1.MessageBarType.error, onDismiss: this.clearNewItemTextFieldErrorMessage }, this.newItemState.errorMessage)),
                    React.createElement(FocusZone_1.FocusZone, null,
                        React.createElement(Selection_1.SelectionZone, { onItemInvoked: this.onItemInvoked, selection: this.selection, selectionMode: Selection_1.SelectionMode.multiple },
                            React.createElement("div", { className: styles.listItemContainer, "data-is-scrollable": true },
                                React.createElement(List_1.List, { items: itemsWithKey, onRenderCell: this.renderListItem }))))),
                React.createElement(Button_1.PrimaryButton, { text: owa_options_strings_1.default.options_common_addButtonLabel, "data-is-focusable": true, disabled: !this.newItemState.value || this.newItemState.value.length === 0, onClick: this.onAddNewItemButtonClicked, className: styles.addNewItemButton }))));
    };
    EditSendersAndDomains.prototype.shouldSetFocusInEditListItemTextField = function () {
        // only set focus when initially displaying the text field and not
        // when there is an error message displayed - otherwise focus is trapped
        // in the text field when there is an error message
        return !this.editItemState.errorMessage;
    };
    EditSendersAndDomains.prototype.isDuplicate = function (text) {
        // Assume both local part and domain are case-insensitive
        var lowerCaseText = text.toLowerCase();
        return this.props.items.some(function (sender) { return sender.toLowerCase() === lowerCaseText; });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], EditSendersAndDomains.prototype, "editItemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], EditSendersAndDomains.prototype, "newItemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], EditSendersAndDomains.prototype, "selection", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onAddNewItemButtonClicked", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldBlur", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "resetSelectionOnNextRender", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "resetSelection", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldChanged", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldKeyDown", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onEditListItemButtonClicked", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onDeleteListItemButtonClicked", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onItemInvoked", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onNewItemTextFieldChanged", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "setEditItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "setNewItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "clearEditItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "clearNewItemTextFieldErrorMessage", void 0);
    EditSendersAndDomains = tslib_1.__decorate([
        mobx_react_1.observer
    ], EditSendersAndDomains);
    return EditSendersAndDomains;
}(React.Component));
exports.EditSendersAndDomains = EditSendersAndDomains;
//# sourceMappingURL=EditSendersAndDomains.js.map

/***/ }),

/***/ 5026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = __webpack_require__(20);
/**
 * Code here is based on JSMVVM transpiled JavaScript
 */
/**
 * Parses and validates a given address per the rules specified in RFC821
 * @param address
 * @returns whether valid
 */
function isValidAddress(address) {
    var isValid = IsValidSmtpAddress(address, true, true)[0];
    return isValid;
}
exports.isValidAddress = isValidAddress;
/**
 * Parses and validates a given address per the rules specified in RFC821
 * @param address
 * @returns whether valid
 */
function isValidAddressDomain(address) {
    return IsValidDomain(address, 0, true, true);
}
exports.isValidAddressDomain = isValidAddressDomain;
var Token;
(function (Token) {
    /// <summary>MIME control character.</summary>
    Token[Token["Ctl"] = 1] = "Ctl";
    /// <summary>MIME SPEC character.</summary>
    Token[Token["Spec"] = 2] = "Spec";
    /// <summary>MIME TSPEC character.</summary>
    Token[Token["TSpec"] = 4] = "TSpec";
    /// <summary>MIME token character.</summary>
    Token[Token["Token"] = 8] = "Token";
    /// <summary>MIME atom character.</summary>
    Token[Token["Atom"] = 16] = "Atom";
    /// <summary>Digit character.</summary>
    Token[Token["Digit"] = 32] = "Digit";
    /// <summary>Hexadecimal character.</summary>
    Token[Token["Hex"] = 64] = "Hex";
    /// <summary>Linear white space character.</summary>
    Token[Token["Lwsp"] = 128] = "Lwsp";
    /// <summary>Binary character.</summary>
    Token[Token["BChar"] = 256] = "BChar";
    /// <summary>Field character.</summary>
    Token[Token["Field"] = 512] = "Field";
    /// <summary>Field character.</summary>
    Token[Token["Alpha"] = 1024] = "Alpha";
    /// <summary>Folding white space character.</summary>
    Token[Token["Fwsp"] = 2048] = "Fwsp";
})(Token || (Token = {}));
var ValidationStage;
(function (ValidationStage) {
    /// <summary>BEGIN</summary>
    ValidationStage[ValidationStage["BEGIN"] = 0] = "BEGIN";
    /// <summary>ELOCALND</summary>
    ValidationStage[ValidationStage["LOCAL"] = 1] = "LOCAL";
    /// <summary>LOCAL_DOT</summary>
    ValidationStage[ValidationStage["LOCAL_DOT"] = 2] = "LOCAL_DOT";
    /// <summary>LOCAL_DQS</summary>
    ValidationStage[ValidationStage["LOCAL_DQS"] = 3] = "LOCAL_DQS";
    /// <summary>LOCAL_ESC</summary>
    ValidationStage[ValidationStage["LOCAL_ESC"] = 4] = "LOCAL_ESC";
    /// <summary>LOCAL_DQS_ESC</summary>
    ValidationStage[ValidationStage["LOCAL_DQS_ESC"] = 5] = "LOCAL_DQS_ESC";
    /// <summary>LOCAL_DQS_END</summary>
    ValidationStage[ValidationStage["LOCAL_DQS_END"] = 6] = "LOCAL_DQS_END";
    /// <summary>DOMAIN</summary>
    ValidationStage[ValidationStage["DOMAIN"] = 7] = "DOMAIN";
    /// <summary>DOMAIN_SUB</summary>
    ValidationStage[ValidationStage["DOMAIN_SUB"] = 8] = "DOMAIN_SUB";
    /// <summary>DOMAIN_DOT</summary>
    ValidationStage[ValidationStage["DOMAIN_DOT"] = 9] = "DOMAIN_DOT";
    /// <summary>DOMAIN_LITERAL</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL"] = 10] = "DOMAIN_LITERAL";
    /// <summary>DOMAIN_LITERAL_IPV4</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV4"] = 11] = "DOMAIN_LITERAL_IPV4";
    /// <summary>DOMAIN_LITERAL_IPV4_DOT</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV4_DOT"] = 12] = "DOMAIN_LITERAL_IPV4_DOT";
    /// <summary>DOMAIN_LITERAL_I</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_I"] = 13] = "DOMAIN_LITERAL_I";
    /// <summary>DOMAIN_LITERAL_IP</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IP"] = 14] = "DOMAIN_LITERAL_IP";
    /// <summary>DOMAIN_LITERAL_IPV</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV"] = 15] = "DOMAIN_LITERAL_IPV";
    /// <summary>DOMAIN_LITERAL_IPV6</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6"] = 16] = "DOMAIN_LITERAL_IPV6";
    /// <summary>DOMAIN_LITERAL_IPV6_</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_"] = 17] = "DOMAIN_LITERAL_IPV6_";
    /// <summary>DOMAIN_LITERAL_IPV6_STARTCOLON</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_STARTCOLON"] = 18] = "DOMAIN_LITERAL_IPV6_STARTCOLON";
    /// <summary>DOMAIN_LITERAL_IPV6_GRP</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_GRP"] = 19] = "DOMAIN_LITERAL_IPV6_GRP";
    /// <summary>DOMAIN_LITERAL_IPV6_V4GRP</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_V4GRP"] = 20] = "DOMAIN_LITERAL_IPV6_V4GRP";
    /// <summary>DOMAIN_LITERAL_IPV6_COLON</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_COLON"] = 21] = "DOMAIN_LITERAL_IPV6_COLON";
    /// <summary>DOMAIN_LITERAL_IPV6_COMP</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_COMP"] = 22] = "DOMAIN_LITERAL_IPV6_COMP";
    /// <summary>DOMAIN_LITERAL_END</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_END"] = 23] = "DOMAIN_LITERAL_END";
    /// <summary>ERROR</summary>
    ValidationStage[ValidationStage["ERROR"] = 24] = "ERROR";
})(ValidationStage || (ValidationStage = {}));
var Dictionary = [
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */ | 128 /* Lwsp */ | 2048 /* Fwsp */ /* 09 (HT) */,
    1 /* Ctl */ | 128 /* Lwsp */ /* 0A (LF)*/,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */ | 128 /* Lwsp */ /* 0D (CR) */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    128 /* Lwsp */ | 2048 /* Fwsp */ | 256 /* BChar */ /* 20 SPACE */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 21 ! */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 22 " */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 23 # */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 24 $ */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 25 % */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 26 & */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ /* 27 ' */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ | 256 /* BChar */ /* 28 ( */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ | 256 /* BChar */ /* 29 ) */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 2A * */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ /* 2B | */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ | 256 /* BChar */ /* 2C , */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ /* 2D - */,
    512 /* Field */ | 8 /* Token */ | 2 /* Spec */ | 256 /* BChar */ /* 2E . */,
    512 /* Field */ | 16 /* Atom */ | 4 /* TSpec */ | 256 /* BChar */ /* 2F / */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 30 0 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 31 1 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 32 2 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 33 3 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 34 4 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 35 5 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 36 6 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 37 7 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 38 8 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 39 9 */,
    2 /* Spec */ | 4 /* TSpec */ | 256 /* BChar */ /* 3A : */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 3B ; */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 3C < */,
    512 /* Field */ | 16 /* Atom */ | 4 /* TSpec */ | 256 /* BChar */ /* 3D = */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 3E > */,
    512 /* Field */ | 16 /* Atom */ | 4 /* TSpec */ | 256 /* BChar */ /* 3F ? */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 40 @ */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 41 A */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 42 B */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 43 C */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 44 D */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 45 E */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 46 F */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 47 G */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 48 H */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 49 I */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4A J */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4B K */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4C L */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4D M */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4E N */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4F O */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 50 P */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 51 Q */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 52 R */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 53 S */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 54 T */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 55 U */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 56 V */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 57 W */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 58 X */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 59 Y */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 5A Z */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 5B [ */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 5C \ */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 5D ] */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 5E ^ */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ /* 5F _ */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 60 ` */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 61 a */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 62 b */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 63 c */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 64 d */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 65 e */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 66 f */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 67 g */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 68 h */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 69 i */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6A j */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6B k */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6C l */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6D m */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6E n */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6F o */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 70 p */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 71 q */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 72 r */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 73 s */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 74 t */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 75 u */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 76 v */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 77 w */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 78 x */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 79 y */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 7A z */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 7B { */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 7C | */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 7D } */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 7E ~ */,
    1 /* Ctl */,
    /* and the rest are zero's */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
];
/**
 * Maximum length for an email name
 */
var MaxEmailName = 315; // for compatibility with TI, which accepts local part up to 315 chars, see PS:Exchange12:7056
/**
 * Maximum length for an email name for IMCEA-encapsulated X400 addresses.
 * Coupled with '@' and MaxDomainName, this results in max full address.
 * Coupled with '@' and MaxDomainName, this results in max full address.
 */
var MaxX400EmailName = 1604;
/**
 * Maximum length for a domain name
 */
var MaxDomainName = 255;
/**
 * Maximum length for a subdomain name
 * Labels must be 63 characters or less.
 */
var MaxSubDomainName = 63;
/**
 * Maximum length for an internet name
 */
var MaxInternetName = MaxEmailName + MaxDomainName + 1;
/**
 * Maximum length for an internet name for IMCEA-encapsulated X400 addresses.
 */
var MaxX400InternetName = MaxX400EmailName + MaxDomainName + 1;
/**
 * Parses and validates a given address per the rules specified in the RFC821
 * @param address Address to validate
 * @param checkLength If true, this method validates the length of smtp address and its individual parts
 * @param allowUTF8 If true, allow UTF8 characters in the email address.
 * @returns tuple containing boolean indicating whether address valid and number indicating start of domain part
 */
function IsValidSmtpAddress(address, checkLength, allowUTF8) {
    if (owa_strings_1.isStringNullOrWhiteSpace(address)) {
        // null address...
        return [false, -1];
    }
    if (checkLength && address.length > MaxInternetName) {
        if (address.length > MaxX400InternetName || !IsEncapsulatedX400Address(address)) {
            // exceeds SMTP limits...
            return [false, -1];
        }
    }
    var offset = 0;
    var state = 0 /* BEGIN */;
    while (offset < address.length && state != 24 /* ERROR */) {
        var ch = address.charAt(offset);
        var charCode = address.charCodeAt(offset);
        offset++;
        switch (state) {
            case 0 /* BEGIN */:
                if ((ch < '\x80' && IsAtom(charCode)) || (ch >= '\x80' && allowUTF8)) {
                    state = 1 /* LOCAL */;
                    continue;
                }
                if (ch == '\\') {
                    state = 4 /* LOCAL_ESC */;
                    continue;
                }
                if (ch == '"') {
                    state = 3 /* LOCAL_DQS */;
                    continue;
                }
                // error...
                break;
            case 1 /* LOCAL */:
                if (ch == '@') {
                    state = 7 /* DOMAIN */;
                    offset--;
                    continue;
                }
                if (ch == '.') {
                    state = 2 /* LOCAL_DOT */;
                    continue;
                }
                // fall through...
                state = 2 /* LOCAL_DOT */;
                offset--;
                continue;
            case 2 /* LOCAL_DOT */:
                if ((ch < '\x80' && IsAtom(charCode)) || (ch >= '\x80' && allowUTF8)) {
                    state = 1 /* LOCAL */;
                    continue;
                }
                if (ch == '\\') {
                    state = 4 /* LOCAL_ESC */;
                    continue;
                }
                // error...
                break;
            case 4 /* LOCAL_ESC */:
                // RFC 821:
                // <local-part> ::= <dot-string> | <quoted-string>
                // <dot-string> ::= <string> | <string> "." <dot-string>
                // <string> ::= <char> | <char> <string>
                // <char> ::= <c> | "\" <x>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                if (ch < '\x80' || (ch >= '\x80' && allowUTF8)) {
                    state = 1 /* LOCAL */;
                    continue;
                }
                // error...
                break;
            case 3 /* LOCAL_DQS */:
                if (ch == '"') {
                    state = 6 /* LOCAL_DQS_END */;
                    continue;
                }
                if (ch == '\\') {
                    state = 5 /* LOCAL_DQS_ESC */;
                    continue;
                }
                // RFC 821:
                // <local-part> ::= <dot-string> | <quoted-string>
                // <quoted-string> ::=  """ <qtext> """
                // <qtext> ::=  "\" <x> | "\" <x> <qtext> | <q> | <q> <qtext>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                // <q> ::= any one of the 128 ASCII characters except <CR>,
                //           <LF>, quote ("), or backslash (\)
                // RFC 2821 is more restrictive on this, but we need to support old RFC821
                // With RFC 6530 adding support of UTF8 characters in the value
                if ((ch < '\x80' && '\r' != ch && '\n' != ch && '\\' != ch && '"' != ch) ||
                    (ch >= '\x80' && allowUTF8)) {
                    state = 3 /* LOCAL_DQS */;
                    continue;
                }
                // error...
                break;
            case 5 /* LOCAL_DQS_ESC */:
                // RFC 821:
                // <local-part> ::= <dot-string> | <quoted-string>
                // <quoted-string> ::=  """ <qtext> """
                // <qtext> ::=  "\" <x> | "\" <x> <qtext> | <q> | <q> <qtext>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                // <q> ::= any one of the 128 ASCII characters except <CR>,
                //           <LF>, quote ("), or backslash (\)
                if (ch < '\x80' || (ch >= '\x80' && allowUTF8)) {
                    state = 3 /* LOCAL_DQS */;
                    continue;
                }
                // error...
                break;
            case 6 /* LOCAL_DQS_END */:
                if (ch == '@') {
                    state = 7 /* DOMAIN */;
                    offset--;
                    continue;
                }
                // error...
                break;
            case 7 /* DOMAIN */:
                // nameLength includes the count of the '@' character
                if (checkLength && offset - 1 > MaxEmailName) {
                    if (offset - 1 > MaxX400EmailName || !IsEncapsulatedX400Address(address)) {
                        // exceeds SMTP limits...
                        return [false, -1];
                    }
                }
                if (IsValidDomain(address, offset, checkLength, allowUTF8)) {
                    return [true, offset];
                }
                // error...
                break;
            default:
                //Debug.Assert(false, 'unexpected');
                break;
        }
        state = 24 /* ERROR */;
    }
    return [false, -1];
}
/**
 * Validates a given domain per the rules specified in the RFC821
 * @param address the domain
 * @param offset domain start offset in array
 * @param checkLength If true, this method validates the length of smtp address and its individual parts
 * @param allowUTF8 Whether the address should be parsed as an international (non-ASCII) address.
 * @returns whether domain is valid
 */
function IsValidDomain(address, offset, checkLength, allowUTF8) {
    if (owa_strings_1.isStringNullOrWhiteSpace(address) ||
        (checkLength && address.length - offset > MaxDomainName)) {
        // empty or exceeds SMTP limits...
        return false;
    }
    var state = 7 /* DOMAIN */;
    // domain literal validation variables
    // ... Group is a sequence of digits or hex digits . Groups are composed into address literal with
    //   appropriate delimiters.
    var group = 0; // number of groups found
    var groupChars = 0; // number of characters in the current group
    var currentGroup = 0; // value of the current group, used to check the group in ipv4 address <= 255
    var compressedIpv6 = false; // compressed form of IPv6 address found
    var subDomainStart = 0;
    var isSingleLabelDomain = true;
    while (offset < address.length && state != 24 /* ERROR */) {
        var ch = address.charAt(offset);
        var charCode = address.charCodeAt(offset);
        offset++;
        switch (state) {
            case 7 /* DOMAIN */:
                if (ch == '[') {
                    state = 10 /* DOMAIN_LITERAL */;
                    continue;
                }
                // NOTE: per RFC 2821 underscore is not allowed in a sub-domain name and
                // sub-domain name cannot start with hyphen. But... Exchange transport
                // allows underscore and hyphen anywhere in sub-domain name.
                // So we will do what transport does and allow these characters.
                // See RAID 227719 for reference.
                if ((ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_') {
                    subDomainStart = offset;
                    state = 8 /* DOMAIN_SUB */;
                    continue;
                }
                // error...
                break;
            case 8 /* DOMAIN_SUB */:
                if (ch == '.') {
                    if (checkLength && offset - subDomainStart > MaxSubDomainName) {
                        // exceeds SMTP limits...
                        return false;
                    }
                    isSingleLabelDomain = false;
                    state = 9 /* DOMAIN_DOT */;
                    continue;
                }
                if ((ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_') {
                    state = 8 /* DOMAIN_SUB */;
                    continue;
                }
                // error...
                break;
            case 9 /* DOMAIN_DOT */:
                if ((ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_') {
                    subDomainStart = offset;
                    state = 8 /* DOMAIN_SUB */;
                    continue;
                }
                // error...
                break;
            case 10 /* DOMAIN_LITERAL */:
                if (ch < '\x80' && IsDigit(charCode)) {
                    state = 11 /* DOMAIN_LITERAL_IPV4 */;
                    group = 1;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    continue;
                }
                if (ch == 'I' || ch == 'i') {
                    state = 13 /* DOMAIN_LITERAL_I */;
                    continue;
                }
                // error...
                break;
            case 11 /* DOMAIN_LITERAL_IPV4 */:
                if (ch < '\x80' && IsDigit(charCode) && groupChars < 3) {
                    groupChars++;
                    currentGroup = currentGroup * 10 + parseInt('' + ch);
                    if (currentGroup > 255) {
                        // error...
                        break;
                    }
                    state = 11 /* DOMAIN_LITERAL_IPV4 */;
                    continue;
                }
                if (ch == '.') {
                    state = 12 /* DOMAIN_LITERAL_IPV4_DOT */;
                    continue;
                }
                if (ch == ']' && group == 4) {
                    state = 23 /* DOMAIN_LITERAL_END */;
                    continue;
                }
                // error...
                break;
            case 12 /* DOMAIN_LITERAL_IPV4_DOT */:
                if (ch < '\x80' && IsDigit(charCode) && group < 4) {
                    group++;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    state = 11 /* DOMAIN_LITERAL_IPV4 */;
                    continue;
                }
                // error...
                break;
            case 13 /* DOMAIN_LITERAL_I */:
                if (ch == 'P' || ch == 'p') {
                    state = 14 /* DOMAIN_LITERAL_IP */;
                    continue;
                }
                // error...
                break;
            case 14 /* DOMAIN_LITERAL_IP */:
                if (ch == 'v' || ch == 'V') {
                    state = 15 /* DOMAIN_LITERAL_IPV */;
                    continue;
                }
                // error...
                break;
            case 15 /* DOMAIN_LITERAL_IPV */:
                if (ch == '6') {
                    state = 16 /* DOMAIN_LITERAL_IPV6 */;
                    continue;
                }
                // error...
                break;
            case 16 /* DOMAIN_LITERAL_IPV6 */:
                if (ch == ':') {
                    state = 17 /* DOMAIN_LITERAL_IPV6_ */;
                    continue;
                }
                // error...
                break;
            case 17 /* DOMAIN_LITERAL_IPV6_ */:
                if (ch < '\x80' && IsHex(charCode)) {
                    compressedIpv6 = false;
                    group = 1;
                    groupChars = 1;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ':') {
                    group = 0;
                    state = 18 /* DOMAIN_LITERAL_IPV6_STARTCOLON */;
                    continue;
                }
                // error...
                break;
            case 18 /* DOMAIN_LITERAL_IPV6_STARTCOLON */:
                if (ch == ':') {
                    compressedIpv6 = true;
                    state = 22 /* DOMAIN_LITERAL_IPV6_COMP */;
                    continue;
                }
                // error...
                break;
            case 19 /* DOMAIN_LITERAL_IPV6_GRP */:
                if (ch < '\x80' && IsHex(charCode) && groupChars < 4) {
                    groupChars++;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ':') {
                    state = 21 /* DOMAIN_LITERAL_IPV6_COLON */;
                    continue;
                }
                if (ch == ']' &&
                    ((!compressedIpv6 && group == 8) || (compressedIpv6 && group <= 6))) {
                    state = 23 /* DOMAIN_LITERAL_END */;
                    continue;
                }
                // error...
                break;
            case 20 /* DOMAIN_LITERAL_IPV6_V4GRP */:
                if (ch < '\x80' && IsDigit(charCode) && groupChars < 3) {
                    groupChars++;
                    currentGroup = currentGroup * 10 + parseInt('' + ch);
                    state =
                        currentGroup <= 255
                            ? 20 /* DOMAIN_LITERAL_IPV6_V4GRP */
                            : 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch < '\x80' && IsHex(charCode) && groupChars < 4) {
                    groupChars++;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ':') {
                    state = 21 /* DOMAIN_LITERAL_IPV6_COLON */;
                    continue;
                }
                if (ch == '.') {
                    group = 1; // we saw one IPv4 group
                    state = 12 /* DOMAIN_LITERAL_IPV4_DOT */;
                    continue;
                }
                if (ch == ']' && compressedIpv6 && group <= 6) {
                    state = 23 /* DOMAIN_LITERAL_END */;
                    continue;
                }
                // error...
                break;
            case 21 /* DOMAIN_LITERAL_IPV6_COLON */:
                // check: parentheses...
                if ((ch < '\x80' && IsDigit(charCode) && (!compressedIpv6 && group == 6)) ||
                    (compressedIpv6 && group <= 4)) {
                    // can have ipv4 addr at the end
                    group++;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    state = 20 /* DOMAIN_LITERAL_IPV6_V4GRP */;
                    continue;
                }
                // check: parentheses...
                if ((ch < '\x80' && IsHex(charCode) && (!compressedIpv6 && group < 8)) ||
                    (compressedIpv6 && group < 6)) {
                    group++;
                    groupChars = 1;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ':' && !compressedIpv6 && group <= 6) {
                    compressedIpv6 = true;
                    state = 22 /* DOMAIN_LITERAL_IPV6_COMP */;
                    continue;
                }
                // error...
                break;
            case 22 /* DOMAIN_LITERAL_IPV6_COMP */:
                if (ch < '\x80' && IsHex(charCode) && group < 6) {
                    group++;
                    groupChars = 1;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ']') {
                    state = 23 /* DOMAIN_LITERAL_END */;
                    continue;
                }
                // error...
                break;
            case 23 /* DOMAIN_LITERAL_END */:
                // any input in ValidationStage.DOMAIN_LITERAL_END state is an error
                break;
            default:
                //Debug.Assert(false, 'unexpected');
                break;
        }
        state = 24 /* ERROR */;
    }
    // domain is good if we are in one of valid end states
    return (state == 23 /* DOMAIN_LITERAL_END */ ||
        (state == 8 /* DOMAIN_SUB */ &&
            (!checkLength || offset - subDomainStart < MaxSubDomainName) &&
            !isSingleLabelDomain));
}
function IsEncapsulatedX400Address(address) {
    return address.toUpperCase().lastIndexOf('IMCEAX400-', 0) === 0;
}
function IsAtom(ch) {
    return 0 != (Dictionary[ch] & 16 /* Atom */);
}
function IsHex(ch) {
    return 0 != (Dictionary[ch] & 64 /* Hex */);
}
function IsDigit(ch) {
    return 0 != (Dictionary[ch] & 32 /* Digit */);
}
function IsAlphaOrDigit(ch) {
    return 0 != (Dictionary[ch] & (32 /* Digit */ | 1024 /* Alpha */));
}
//# sourceMappingURL=smtpAddress.js.map

/***/ }),

/***/ 5027:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5028);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5028:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1VQlcdsGzPdlKhWdrnWiBy{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._3zXwgAW1PjLbspI3Xb8XLm{margin-top:4px}html[dir=ltr] ._3zXwgAW1PjLbspI3Xb8XLm{margin-left:10px}html[dir=rtl] ._3zXwgAW1PjLbspI3Xb8XLm{margin-right:10px}html[dir=ltr] ._1y4D8E3uH8uy2_gjRn_rlu{margin-right:4px}html[dir=rtl] ._1y4D8E3uH8uy2_gjRn_rlu{margin-left:4px}._1D_k7ffL0cjGyeiFBehccS{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}html[dir] ._1D_k7ffL0cjGyeiFBehccS{margin-top:4px}.xvTpDR9j28ToZJTnkbtrQ .ms-TextField-fieldGroup{height:32px}._1xqNnEbZ8vCYkk7fNRu08A{height:32px;line-height:32px;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex}html[dir=ltr] ._1xqNnEbZ8vCYkk7fNRu08A{padding-left:13px}html[dir=rtl] ._1xqNnEbZ8vCYkk7fNRu08A{padding-right:13px}html[dir] ._1xqNnEbZ8vCYkk7fNRu08A:focus,html[dir] ._1xqNnEbZ8vCYkk7fNRu08A:hover{background-color:\"[theme:neutralLighter, default:#f4f4f4]\"}html[dir] ._1XRUJgC3Q64WGWliuPhhH7,html[dir] ._1XRUJgC3Q64WGWliuPhhH7:focus,html[dir] ._1XRUJgC3Q64WGWliuPhhH7:hover{background:\"[theme:neutralLight, default:#eaeaea]\"}.BoQYgl1hfk55p4O5VaOCq{height:160px;overflow:auto}html[dir] .BoQYgl1hfk55p4O5VaOCq{border:solid 1px \"[theme:neutralTertiary, default:#a6a6a6]\";margin-top:10px}html[dir] ._2do4Eqalx4YJXJ8mn2zp4H{background-color:transparent}", ""]);

// exports
exports.locals = {
	"outerContainer": "_1VQlcdsGzPdlKhWdrnWiBy",
	"addNewItemButton": "_3zXwgAW1PjLbspI3Xb8XLm",
	"editListItemButton": "_1y4D8E3uH8uy2_gjRn_rlu",
	"textFieldAndListContainer": "_1D_k7ffL0cjGyeiFBehccS",
	"textField": "xvTpDR9j28ToZJTnkbtrQ",
	"viewListItemCell": "_1xqNnEbZ8vCYkk7fNRu08A",
	"viewListItemCellSelected": "_1XRUJgC3Q64WGWliuPhhH7",
	"listItemContainer": "BoQYgl1hfk55p4O5VaOCq",
	"disabledButton": "_2do4Eqalx4YJXJ8mn2zp4H"
};

/***/ }),

/***/ 5029:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determines if a string is an email address as opposed to an address domain
 * @param text - contains either a valid email address or a valid address domain
 */
function isEmailAddress(text) {
    return text.indexOf('@') !== -1;
}
exports.default = isEmailAddress;
//# sourceMappingURL=isEmailAddress.js.map

/***/ }),

/***/ 5030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var setBlockedDomainsOption_1 = __webpack_require__(5031);
var store_1 = __webpack_require__(3062);
var owa_junkmail_configuration_1 = __webpack_require__(2894);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_mail_option_common_1 = __webpack_require__(2939);
var owa_options_controls_1 = __webpack_require__(2661);
var BlockedDomainsFull = /** @class */ (function (_super) {
    tslib_1.__extends(BlockedDomainsFull, _super);
    function BlockedDomainsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeBlockedDomains = function (blockedDomains) {
            setBlockedDomainsOption_1.default(blockedDomains);
        };
        return _this;
    }
    BlockedDomainsFull.prototype.render = function () {
        var domains = owa_options_core_1.getFallbackValueIfNull(this.props.optionState.blockedDomains, this.props.junkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !owa_mail_option_common_1.isEmailAddress(item); }));
        return (React.createElement("div", null, domains && (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_junkEmail_blockedDomains),
            React.createElement(owa_mail_option_common_1.EditSendersAndDomains, { items: domains, onItemsChanged: this.onChangeBlockedDomains, mode: 1 /* DomainOnly */ })))));
    };
    BlockedDomainsFull = tslib_1.__decorate([
        react_1.reactive({
            optionState: function () { return store_1.default; },
            junkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
        })
    ], BlockedDomainsFull);
    return BlockedDomainsFull;
}(React.Component));
exports.default = BlockedDomainsFull;
//# sourceMappingURL=BlockedDomainsFull.js.map

/***/ }),

/***/ 5031:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3062);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('setBlockedDomainsOption')(function setBlockedDomainsOption(blockedSenders, state) {
    var optionState = state.optionState;
    optionState.blockedDomains = blockedSenders;
}));
//# sourceMappingURL=setBlockedDomainsOption.js.map

/***/ }),

/***/ 5032:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3062);
var owa_junkmail_configuration_1 = __webpack_require__(2894);
var owa_mail_option_common_1 = __webpack_require__(2939);
var legacy_1 = __webpack_require__(1);
var arrayEquals = __webpack_require__(3736);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    mailboxJunkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
})(function isBlockedDomainsOptionDirty(state) {
    var _a = state, optionState = _a.optionState, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration;
    if (!mailboxJunkEmailConfiguration || !optionState.blockedDomains) {
        return false;
    }
    return !arrayEquals(optionState.blockedDomains, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !owa_mail_option_common_1.isEmailAddress(item); }));
});
//# sourceMappingURL=isBlockedDomainsOptionDirty.js.map

/***/ }),

/***/ 5033:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardBlockedSendersOption_1 = __webpack_require__(5034);
var saveBlockedSendersOption_1 = __webpack_require__(5035);
var BlockedSendersFull_1 = __webpack_require__(5036);
var isBlockedSendersOptionDirty_1 = __webpack_require__(5038);
var React = __webpack_require__(3);
var BlockedSendersOption = {
    key: 'blockedSenders',
    titleStringKey: 'optionTitle_blockedSenders',
    searchTermsStringKey: 'optionSearchTerms_blockedSenders',
    fullOptionFormSettings: {
        render: function () { return React.createElement(BlockedSendersFull_1.default, null); },
        isDirty: isBlockedSendersOptionDirty_1.default,
        onSave: saveBlockedSendersOption_1.default,
        onDiscard: discardBlockedSendersOption_1.default,
    },
};
exports.default = BlockedSendersOption;
//# sourceMappingURL=BlockedSendersOption.js.map

/***/ }),

/***/ 5034:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3063);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardBlockedSendersOption')(function discardBlockedSendersOption(state) {
    var optionState = state.optionState;
    optionState.blockedSenders = null;
}));
//# sourceMappingURL=discardBlockedSendersOption.js.map

/***/ }),

/***/ 5035:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3063);
var owa_options_core_1 = __webpack_require__(1736);
var legacy_1 = __webpack_require__(1);
var owa_junkmail_configuration_1 = __webpack_require__(2894);
var owa_mail_option_common_1 = __webpack_require__(2939);
exports.default = legacy_1.select({
    mailboxJunkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveBlockedSendersOption')(function saveBlockedSendersOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, mailboxJunkEmailConfiguration, optionState, blockedSenders, blockedDomains, blockedSenderAndDomains;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = state, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration, optionState = _a.optionState;
                    blockedSenders = owa_options_core_1.getFallbackValueIfNull(optionState.blockedSenders, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) {
                        return owa_mail_option_common_1.isEmailAddress(item);
                    }));
                    blockedDomains = mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !owa_mail_option_common_1.isEmailAddress(item); });
                    blockedSenderAndDomains = blockedSenders.slice(0).concat(blockedDomains);
                    mailboxJunkEmailConfiguration.BlockedSendersAndDomains = blockedSenderAndDomains;
                    return [4 /*yield*/, owa_junkmail_configuration_1.saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveBlockedSendersOption.js.map

/***/ }),

/***/ 5036:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var setBlockedSendersOption_1 = __webpack_require__(5037);
var store_1 = __webpack_require__(3063);
var owa_junkmail_configuration_1 = __webpack_require__(2894);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_mail_option_common_1 = __webpack_require__(2939);
var owa_options_controls_1 = __webpack_require__(2661);
var BlockedSendersFull = /** @class */ (function (_super) {
    tslib_1.__extends(BlockedSendersFull, _super);
    function BlockedSendersFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeBlockedSenders = function (blockedSenders) {
            setBlockedSendersOption_1.default(blockedSenders);
        };
        return _this;
    }
    BlockedSendersFull.prototype.render = function () {
        var senders = owa_options_core_1.getFallbackValueIfNull(this.props.optionState.blockedSenders, this.props.junkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) {
            return owa_mail_option_common_1.isEmailAddress(item);
        }));
        return (React.createElement("div", null, senders && (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_junkEmail_blockedSenders),
            React.createElement(owa_mail_option_common_1.EditSendersAndDomains, { items: senders, onItemsChanged: this.onChangeBlockedSenders, mode: 0 /* EmailAddressOnly */ })))));
    };
    BlockedSendersFull = tslib_1.__decorate([
        react_1.reactive({
            optionState: function () { return store_1.default; },
            junkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
        })
    ], BlockedSendersFull);
    return BlockedSendersFull;
}(React.Component));
exports.default = BlockedSendersFull;
//# sourceMappingURL=BlockedSendersFull.js.map

/***/ }),

/***/ 5037:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3063);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('setBlockedSendersOption')(function setBlockedSendersOption(blockedSenders, state) {
    var optionState = state.optionState;
    optionState.blockedSenders = blockedSenders;
}));
//# sourceMappingURL=setBlockedSendersOption.js.map

/***/ }),

/***/ 5038:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3063);
var owa_junkmail_configuration_1 = __webpack_require__(2894);
var owa_mail_option_common_1 = __webpack_require__(2939);
var legacy_1 = __webpack_require__(1);
var arrayEquals = __webpack_require__(3736);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    mailboxJunkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
})(function isBlockedSendersOptionDirty(state) {
    var _a = state, optionState = _a.optionState, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration;
    if (!mailboxJunkEmailConfiguration || !optionState.blockedSenders) {
        return false;
    }
    return !arrayEquals(optionState.blockedSenders, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return owa_mail_option_common_1.isEmailAddress(item); }));
});
//# sourceMappingURL=isBlockedSendersOptionDirty.js.map

/***/ }),

/***/ 5039:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MarkAsReadOption_1 = __webpack_require__(5040);
var ReplyOption_1 = __webpack_require__(5046);
var MessageOption_1 = __webpack_require__(5052);
var ReadReceiptsOption_1 = __webpack_require__(5058);
var handlingSubCategory = {
    key: 'handling',
    titleStringKey: 'optionSubcategory_handling',
    options: [MarkAsReadOption_1.default, ReplyOption_1.default, MessageOption_1.default, ReadReceiptsOption_1.default],
};
exports.default = handlingSubCategory;
//# sourceMappingURL=handlingSubCategory.js.map

/***/ }),

/***/ 5040:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardMarkAsReadOption_1 = __webpack_require__(5041);
var saveMarkAsReadOption_1 = __webpack_require__(5042);
var MarkAsReadFull_1 = __webpack_require__(5043);
var isMarkAsReadOptionDirty_1 = __webpack_require__(5045);
var React = __webpack_require__(3);
var MarkAsReadOption = {
    key: 'markAsRead',
    titleStringKey: 'optionTitle_markAsRead',
    searchTermsStringKey: 'optionTitle_markAsRead',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MarkAsReadFull_1.default, null); },
        isDirty: isMarkAsReadOptionDirty_1.default,
        onSave: saveMarkAsReadOption_1.default,
        onDiscard: discardMarkAsReadOption_1.default,
    },
};
exports.default = MarkAsReadOption;
//# sourceMappingURL=MarkAsReadOption.js.map

/***/ }),

/***/ 5041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3064);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardMarkAsReadOption')(function discardMarkAsReadOption(state) {
    var optionState = state.optionState;
    optionState.behavior = null;
    optionState.delay = null;
}));
//# sourceMappingURL=discardMarkAsReadOption.js.map

/***/ }),

/***/ 5042:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3064);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveMarkAsReadOption')(function saveMarkAsReadOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceObject;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceObject = {};
                    if (optionState.behavior !== null) {
                        userOptions.PreviewMarkAsRead = optionState.behavior;
                        // This conversion is required because UserOptions deal with string literals (MarkAsRead type),
                        // whereas MailboxMessageConfigurationOptions deals with numbers (PreviewMarkAsReadBehavior const enum type)
                        switch (state.optionState.behavior) {
                            case 'Delayed':
                                serviceObject.PreviewMarkAsReadBehavior = 0 /* Delayed */;
                                break;
                            case 'OnSelectionChange':
                                serviceObject.PreviewMarkAsReadBehavior =
                                    1 /* OnSelectionChange */;
                                break;
                            case 'Never':
                                serviceObject.PreviewMarkAsReadBehavior = 2 /* Never */;
                                break;
                        }
                    }
                    if (optionState.delay !== null) {
                        userOptions.MarkAsReadDelaytime = optionState.delay;
                        serviceObject.PreviewMarkAsReadDelaytime = optionState.delay;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration(serviceObject)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveMarkAsReadOption.js.map

/***/ }),

/***/ 5043:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectMarkAsReadOption_1 = __webpack_require__(5044);
var store_1 = __webpack_require__(3064);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var MarkAsReadFull = /** @class */ (function (_super) {
    tslib_1.__extends(MarkAsReadFull, _super);
    function MarkAsReadFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectMarkAsReadOption_1.default(option.key);
        };
        return _this;
    }
    MarkAsReadFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var behavior = owa_options_core_1.getFallbackValueIfNull(optionStore.behavior, userOptions.PreviewMarkAsRead);
        var delay = owa_options_core_1.getFallbackValueIfNull(optionStore.delay, userOptions.MarkAsReadDelaytime);
        var selectedKey = behavior === 'Delayed' && delay === 0 ? 'Instant' : behavior;
        var choices = [
            {
                key: 'Instant',
                text: owa_options_strings_1.default.options_mail_markAsReadInstant,
            },
            {
                key: 'Delayed',
                // TODO: VSO:13206 -Need to make a change to Fabric to allow for a dropdown inline as part of a choice
                // https://github.com/OfficeDev/office-ui-fabric-react/issues/1765
                text: owa_options_strings_1.default.options_mail_markAsReadDelayed,
            },
            {
                key: 'OnSelectionChange',
                text: owa_options_strings_1.default.options_mail_markAsReadSelectionChange,
            },
            {
                key: 'Never',
                text: owa_options_strings_1.default.options_mail_markAsReadNever,
            },
        ];
        return React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange });
    };
    MarkAsReadFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MarkAsReadFull);
    return MarkAsReadFull;
}(React.Component));
exports.default = MarkAsReadFull;
//# sourceMappingURL=MarkAsReadFull.js.map

/***/ }),

/***/ 5044:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3064);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectMarkAsReadOption')(function selectMarkAsReadOption(choice, state) {
    var optionState = state.optionState;
    optionState.behavior = choice === 'Instant' ? 'Delayed' : choice;
    // TODO: VSO:13206 - Implement a customizable delay
    optionState.delay = choice === 'Instant' ? 0 : 5;
}));
//# sourceMappingURL=selectMarkAsReadOption.js.map

/***/ }),

/***/ 5045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3064);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMarkAsReadOptionDirty(state) {
    var savedOptions = state.userOptions;
    var behavior = owa_options_core_1.getFallbackValueIfNull(state.optionState.behavior, savedOptions.PreviewMarkAsRead);
    var delay = owa_options_core_1.getFallbackValueIfNull(state.optionState.delay, savedOptions.MarkAsReadDelaytime);
    return (behavior !== savedOptions.PreviewMarkAsRead ||
        (behavior === 'Delayed' && delay !== savedOptions.MarkAsReadDelaytime));
});
//# sourceMappingURL=isMarkAsReadOptionDirty.js.map

/***/ }),

/***/ 5046:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardReplyOption_1 = __webpack_require__(5047);
var saveReplyOption_1 = __webpack_require__(5048);
var ReplyFull_1 = __webpack_require__(5049);
var isReplyOptionDirty_1 = __webpack_require__(5051);
var React = __webpack_require__(3);
var ReplyOption = {
    key: 'reply',
    titleStringKey: 'optionTitle_reply',
    searchTermsStringKey: 'optionTitle_reply',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReplyFull_1.default, null); },
        isDirty: isReplyOptionDirty_1.default,
        onSave: saveReplyOption_1.default,
        onDiscard: discardReplyOption_1.default,
    },
};
exports.default = ReplyOption;
//# sourceMappingURL=ReplyOption.js.map

/***/ }),

/***/ 5047:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3065);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardReplyOption')(function discardReplyOption(state) {
    var optionState = state.optionState;
    optionState.replyAllByDefault = null;
}));
//# sourceMappingURL=discardReplyOption.js.map

/***/ }),

/***/ 5048:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3065);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveReplyOption')(function saveReplyOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.IsReplyAllTheDefaultResponse = optionState.replyAllByDefault;
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'IsReplyAllTheDefaultResponse',
                                propertyType: 'Boolean',
                                propertyValue: "" + optionState.replyAllByDefault,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveReplyOption.js.map

/***/ }),

/***/ 5049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectReplyOption_1 = __webpack_require__(5050);
var store_1 = __webpack_require__(3065);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var REPLY_KEY = 'Reply';
var REPLY_ALL_KEY = 'ReplyAll';
var ReplyFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReplyFull, _super);
    function ReplyFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectReplyOption_1.default(option.key === REPLY_ALL_KEY);
        };
        return _this;
    }
    ReplyFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isReplyAllDefault = owa_options_core_1.getFallbackValueIfNull(optionStore.replyAllByDefault, userOptions.IsReplyAllTheDefaultResponse);
        var selectedKey = isReplyAllDefault ? REPLY_ALL_KEY : REPLY_KEY;
        var choices = [
            {
                key: REPLY_KEY,
                text: owa_options_strings_1.default.options_mail_Reply,
            },
            {
                key: REPLY_ALL_KEY,
                text: owa_options_strings_1.default.options_mail_ReplyAll,
            },
        ];
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange, label: owa_options_strings_1.default.options_mail_ReplyOptionLabel }));
    };
    ReplyFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ReplyFull);
    return ReplyFull;
}(React.Component));
exports.default = ReplyFull;
//# sourceMappingURL=ReplyFull.js.map

/***/ }),

/***/ 5050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3065);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectReplyOption')(function selectReplyOption(replyAllByDefault, state) {
    var optionState = state.optionState;
    optionState.replyAllByDefault = replyAllByDefault;
}));
//# sourceMappingURL=selectReplyOption.js.map

/***/ }),

/***/ 5051:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3065);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isReplyOptionDirty(state) {
    var savedOptions = state.userOptions;
    var replyAllByDefault = owa_options_core_1.getFallbackValueIfNull(state.optionState.replyAllByDefault, savedOptions.IsReplyAllTheDefaultResponse);
    return replyAllByDefault !== savedOptions.IsReplyAllTheDefaultResponse;
});
//# sourceMappingURL=isReplyOptionDirty.js.map

/***/ }),

/***/ 5052:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardMessageOption_1 = __webpack_require__(5053);
var saveMessageOption_1 = __webpack_require__(5054);
var MessageOptionsFull_1 = __webpack_require__(5055);
var isMessageOptionDirty_1 = __webpack_require__(5057);
var React = __webpack_require__(3);
var MessageOption = {
    key: 'message',
    titleStringKey: 'optionTitle_message',
    searchTermsStringKey: 'optionTitle_message',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessageOptionsFull_1.default, null); },
        isDirty: isMessageOptionDirty_1.default,
        onSave: saveMessageOption_1.default,
        onDiscard: discardMessageOption_1.default,
    },
};
exports.default = MessageOption;
//# sourceMappingURL=MessageOption.js.map

/***/ }),

/***/ 5053:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3066);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardMessageOption')(function discardMessageOption(state) {
    var optionState = state.optionState;
    optionState.soundNotify = null;
    optionState.emailToastNotify = null;
    optionState.emptyDeletedItemsOnLogOut = null;
}));
//# sourceMappingURL=discardMessageOption.js.map

/***/ }),

/***/ 5054:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3066);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
// We don't expose the option to change voicemail or fax toast, and we don't want to change the legacy settings, either.
// This mask is used in preserving these settings
var NOTIFICATION_MASK = 4 /* VoiceMailToast */ | 8 /* FaxToast */;
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveMessageOption')(function saveMessageOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceObject, newNotifySetting;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceObject = {};
                    if (optionState.soundNotify !== null || optionState.emailToastNotify !== null) {
                        newNotifySetting = userOptions.NewItemNotify & NOTIFICATION_MASK;
                        newNotifySetting |=
                            optionState.soundNotify === null
                                ? userOptions.NewItemNotify & 1 /* Sound */
                                : optionState.soundNotify ? 1 /* Sound */ : 0 /* None */;
                        newNotifySetting |=
                            optionState.emailToastNotify === null
                                ? userOptions.NewItemNotify & 2 /* EMailToast */
                                : optionState.emailToastNotify
                                    ? 2 /* EMailToast */
                                    : 0 /* None */;
                        userOptions.NewItemNotify = newNotifySetting;
                        serviceObject.NewItemNotification = newNotifySetting;
                    }
                    if (optionState.emptyDeletedItemsOnLogOut !== null) {
                        userOptions.EmptyDeletedItemsOnLogoff = optionState.emptyDeletedItemsOnLogOut;
                        serviceObject.EmptyDeletedItemsOnLogoff = optionState.emptyDeletedItemsOnLogOut;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration(serviceObject)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveMessageOption.js.map

/***/ }),

/***/ 5055:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var toggleMessageOptionCheckbox_1 = __webpack_require__(5056);
var store_1 = __webpack_require__(3066);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_controls_1 = __webpack_require__(2661);
var Label_1 = __webpack_require__(1559);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var MessageOptionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageOptionsFull, _super);
    function MessageOptionsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSoundNotifyChange = function (ev, checked) {
            toggleMessageOptionCheckbox_1.default('soundNotify', checked);
        };
        _this.onEmailToastNotifyChange = function (ev, checked) {
            toggleMessageOptionCheckbox_1.default('emailToastNotify', checked);
        };
        _this.onEmptyDeletedItemsOnLogOutChange = function (ev, checked) {
            toggleMessageOptionCheckbox_1.default('emptyDeletedItemsOnLogOut', checked);
        };
        return _this;
    }
    MessageOptionsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var soundNotify = owa_options_core_1.getFallbackValueIfNull(optionStore.soundNotify, !!(userOptions.NewItemNotify & 1 /* Sound */));
        var emailToastNotify = owa_options_core_1.getFallbackValueIfNull(optionStore.emailToastNotify, !!(userOptions.NewItemNotify & 2 /* EMailToast */));
        var emptyDeletedItemsOnLogOut = owa_options_core_1.getFallbackValueIfNull(optionStore.emptyDeletedItemsOnLogOut, userOptions.EmptyDeletedItemsOnLogoff);
        return (React.createElement("div", null,
            React.createElement(Label_1.Label, null, owa_options_strings_1.default.option_mail_NotifyTitle),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: soundNotify, label: owa_options_strings_1.default.option_mail_NotifySound, onChange: this.onSoundNotifyChange }),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: emailToastNotify, label: owa_options_strings_1.default.option_mail_NotifyToast, onChange: this.onEmailToastNotifyChange }),
            React.createElement(Label_1.Label, null, owa_options_strings_1.default.option_mail_LogOutTitle),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: emptyDeletedItemsOnLogOut, label: owa_options_strings_1.default.option_mail_EmptyDeletedOnLogOut, onChange: this.onEmptyDeletedItemsOnLogOutChange })));
    };
    MessageOptionsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MessageOptionsFull);
    return MessageOptionsFull;
}(React.Component));
exports.default = MessageOptionsFull;
//# sourceMappingURL=MessageOptionsFull.js.map

/***/ }),

/***/ 5056:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3066);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('toggleMessageOptionCheckbox')(function toggleMessageOptionCheckbox(field, checked, state) {
    var optionState = state.optionState;
    optionState[field] = checked;
}));
//# sourceMappingURL=toggleMessageOptionCheckbox.js.map

/***/ }),

/***/ 5057:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3066);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMessageOptionDirty(state) {
    var savedOptions = state.userOptions;
    var soundNotify = owa_options_core_1.getFallbackValueIfNull(state.optionState.soundNotify, !!(savedOptions.NewItemNotify & 1 /* Sound */));
    var emailToastNotify = owa_options_core_1.getFallbackValueIfNull(state.optionState.emailToastNotify, !!(savedOptions.NewItemNotify & 2 /* EMailToast */));
    var emptyDeletedItemsOnLogOut = owa_options_core_1.getFallbackValueIfNull(state.optionState.emptyDeletedItemsOnLogOut, savedOptions.EmptyDeletedItemsOnLogoff);
    return (emptyDeletedItemsOnLogOut !== savedOptions.EmptyDeletedItemsOnLogoff ||
        !!(savedOptions.NewItemNotify & 1 /* Sound */) !== soundNotify ||
        !!(savedOptions.NewItemNotify & 2 /* EMailToast */) !== emailToastNotify);
});
//# sourceMappingURL=isMessageOptionDirty.js.map

/***/ }),

/***/ 5058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardReadReceiptOption_1 = __webpack_require__(5059);
var saveReadReceiptOption_1 = __webpack_require__(5060);
var ReadReceiptsFull_1 = __webpack_require__(5061);
var isReadReceiptOptionDirty_1 = __webpack_require__(5063);
var React = __webpack_require__(3);
var ReadReceiptsOption = {
    key: 'readReceipts',
    titleStringKey: 'optionTitle_readReceipts',
    searchTermsStringKey: 'optionTitle_readReceipts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReadReceiptsFull_1.default, null); },
        isDirty: isReadReceiptOptionDirty_1.default,
        onSave: saveReadReceiptOption_1.default,
        onDiscard: discardReadReceiptOption_1.default,
    },
};
exports.default = ReadReceiptsOption;
//# sourceMappingURL=ReadReceiptsOption.js.map

/***/ }),

/***/ 5059:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3067);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardReadReceiptOption')(function discardReadReceiptOption(state) {
    var optionState = state.optionState;
    optionState.readReceiptResponse = null;
}));
//# sourceMappingURL=discardReadReceiptOption.js.map

/***/ }),

/***/ 5060:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3067);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveReadReceiptOption')(function saveReadReceiptOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, optionId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.ReadReceipt = optionState.readReceiptResponse;
                    switch (optionState.readReceiptResponse) {
                        case 'DoNotAutomaticallySend':
                            optionId = 0;
                            break;
                        case 'AlwaysSend':
                            optionId = 1;
                            break;
                        case 'NeverSend':
                            optionId = 2;
                            break;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration({
                            ReadReceiptResponse: optionId,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveReadReceiptOption.js.map

/***/ }),

/***/ 5061:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectReadReceiptOption_1 = __webpack_require__(5062);
var store_1 = __webpack_require__(3067);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var ReadReceiptsFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReadReceiptsFull, _super);
    function ReadReceiptsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectReadReceiptOption_1.default(option.key);
        };
        return _this;
    }
    ReadReceiptsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var selectedKey = owa_options_core_1.getFallbackValueIfNull(optionStore.readReceiptResponse, userOptions.ReadReceipt);
        var choices = [
            {
                key: 'DoNotAutomaticallySend',
                text: owa_options_strings_1.default.options_mail_ReadReceiptPrompt,
            },
            {
                key: 'AlwaysSend',
                text: owa_options_strings_1.default.options_mail_ReadReceiptAlways,
            },
            {
                key: 'NeverSend',
                text: owa_options_strings_1.default.options_mail_ReadReceiptNever,
            },
        ];
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange, label: owa_options_strings_1.default.options_mail_ReadReceiptTitle }));
    };
    ReadReceiptsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ReadReceiptsFull);
    return ReadReceiptsFull;
}(React.Component));
exports.default = ReadReceiptsFull;
//# sourceMappingURL=ReadReceiptsFull.js.map

/***/ }),

/***/ 5062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3067);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectReadReceiptOption')(function selectReadReceiptOption(choice, state) {
    var optionState = state.optionState;
    optionState.readReceiptResponse = choice;
}));
//# sourceMappingURL=selectReadReceiptOption.js.map

/***/ }),

/***/ 5063:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3067);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isReadReceiptOptionDirty(state) {
    var savedOptions = state.userOptions;
    var readReceiptResponse = owa_options_core_1.getFallbackValueIfNull(state.optionState.readReceiptResponse, savedOptions.ReadReceipt);
    return readReceiptResponse !== savedOptions.ReadReceipt;
});
//# sourceMappingURL=isReadReceiptOptionDirty.js.map

/***/ }),

/***/ 5064:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ConversationsOption_1 = __webpack_require__(5065);
var DateHeadersOption_1 = __webpack_require__(5080);
var FocusedInboxOption_1 = __webpack_require__(5086);
var InlinePreviewsOption_1 = __webpack_require__(5093);
var SenderImageOption_1 = __webpack_require__(5099);
var MessagePreviewOption_1 = __webpack_require__(5106);
var ReadingPaneOption_1 = __webpack_require__(5113);
var SenderSubjectOption_1 = __webpack_require__(5124);
var layoutSubCategory = {
    key: 'layout',
    titleStringKey: 'optionSubcategory_layout',
    options: [
        ConversationsOption_1.default,
        FocusedInboxOption_1.default,
        SenderSubjectOption_1.default,
        MessagePreviewOption_1.default,
        SenderImageOption_1.default,
        ReadingPaneOption_1.default,
        InlinePreviewsOption_1.default,
        DateHeadersOption_1.default,
    ],
};
exports.default = layoutSubCategory;
//# sourceMappingURL=layoutSubCategory.js.map

/***/ }),

/***/ 5065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var ConversationsFull_1 = __webpack_require__(5066);
var ConversationsQuick_1 = __webpack_require__(5077);
var isConversationsOptionDirty_1 = __webpack_require__(5078);
var discardConversationsOption_1 = __webpack_require__(5079);
var saveConversationsOption_1 = __webpack_require__(3738);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var ConversationsOption = {
    key: 'conversations',
    titleStringKey: 'optionTitle_conversations',
    searchTermsStringKey: 'optionTitle_conversations',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ConversationsFull_1.default, null); },
        isDirty: isConversationsOptionDirty_1.default,
        onSave: saveConversationsOption_1.saveConversationsOptionFull,
        onDiscard: discardConversationsOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            render: function (props) { return (React.createElement(ConversationsQuick_1.default, tslib_1.__assign({}, props))); },
        },
        order: 1 /* Conversations */,
        workloads: 1 /* Mail */,
        customTitle: 'options_conversations_quick_label',
        tooltip: {
            tooltipStringKey: 'options_conversations_quick_tooltip',
            shouldHideTooltip: function () { return !owa_controls_feature_flags_1.isControlFeatureEnabled('tri-messageListView'); },
        },
    },
};
exports.default = ConversationsOption;
//# sourceMappingURL=ConversationsOption.js.map

/***/ }),

/***/ 5066:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectConversationSortOrderOption_1 = __webpack_require__(5067);
var selectHideDeletedItemsOption_1 = __webpack_require__(5068);
var selectGlobalListViewTypeOption_1 = __webpack_require__(5069);
var store_1 = __webpack_require__(2895);
var owa_choice_group_with_images_1 = __webpack_require__(3737);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var NEWEST_ON_TOP_SVG = __webpack_require__(5073);
var NEWEST_ON_BOTTOM_SVG = __webpack_require__(5074);
var HIDE_DELETED_ITEMS_SVG = __webpack_require__(5075);
var SHOW_DELETED_ITEMS_SVG = __webpack_require__(5076);
var ConversationsFull = /** @class */ (function (_super) {
    tslib_1.__extends(ConversationsFull, _super);
    function ConversationsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onListViewTypeChange = function (ev, option) {
            selectGlobalListViewTypeOption_1.default(+option.key);
        };
        _this.onHideDeletedItemsChanged = function (ev, option) {
            selectHideDeletedItemsOption_1.default(option.key === 'true');
        };
        _this.onChangeSortOrder = function (ev, option) {
            selectConversationSortOrderOption_1.default(option.key);
        };
        return _this;
    }
    ConversationsFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var listViewTypeSelectedKey = owa_options_core_1.getFallbackValueIfNull(optionState.globalListViewType, userOptions.GlobalListViewTypeReact);
        var conversationSortOrderKey = optionState.conversationSortOrder || userOptions.ConversationSortOrderReact;
        var hideDeletedItemsKey = "" + owa_options_core_1.getFallbackValueIfNull(optionState.hideDeletedItems, userOptions.HideDeletedItems);
        return (React.createElement("div", null,
            owa_controls_feature_flags_1.isControlFeatureEnabled('tri-messageListView') && (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + listViewTypeSelectedKey, label: owa_options_strings_1.default.options_messageOrganization_positionLabel, options: [
                    {
                        key: "" + 0 /* Conversation */,
                        text: owa_options_strings_1.default.options_messageOrganization_showAsConversation,
                    },
                    {
                        key: "" + 1 /* Message */,
                        text: owa_options_strings_1.default.options_messageOrganization_showAsMessage,
                    },
                ], onChange: this.onListViewTypeChange })),
            listViewTypeSelectedKey === 0 /* Conversation */ && [
                React.createElement(owa_choice_group_with_images_1.ChoiceGroupWithImages, { key: "sortOrder", selectedKey: conversationSortOrderKey, label: owa_options_strings_1.default.options_conversations_sortOrderLabel, options: [
                        {
                            key: 'ChronologicalNewestOnTop',
                            text: owa_options_strings_1.default.options_conversations_sortOrderTop,
                            imageUri: NEWEST_ON_TOP_SVG,
                            width: 280,
                        },
                        {
                            key: 'ChronologicalNewestOnBottom',
                            text: owa_options_strings_1.default.options_conversations_sortOrderBottom,
                            imageUri: NEWEST_ON_BOTTOM_SVG,
                            width: 280,
                        },
                    ], onChange: this.onChangeSortOrder }),
                React.createElement(owa_choice_group_with_images_1.ChoiceGroupWithImages, { key: "deletedItems", selectedKey: hideDeletedItemsKey, label: owa_options_strings_1.default.options_conversations_deletedItemsLabel, options: [
                        {
                            key: 'false',
                            text: owa_options_strings_1.default.options_conversations_deletedItemsShow,
                            imageUri: SHOW_DELETED_ITEMS_SVG,
                            width: 280,
                        },
                        {
                            key: 'true',
                            text: owa_options_strings_1.default.options_conversations_deletedItemsHide,
                            imageUri: HIDE_DELETED_ITEMS_SVG,
                            width: 280,
                        },
                    ], onChange: this.onHideDeletedItemsChanged }),
            ]));
    };
    ConversationsFull = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
            optionState: function () { return store_1.default; },
        })
    ], ConversationsFull);
    return ConversationsFull;
}(React.Component));
exports.default = ConversationsFull;
//# sourceMappingURL=ConversationsFull.js.map

/***/ }),

/***/ 5067:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2895);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectConversationSortOrderOption')(function selectConversationSortOrderOption(sortOrder, state) {
    var optionState = state.optionState;
    optionState.conversationSortOrder = sortOrder;
}));
//# sourceMappingURL=selectConversationSortOrderOption.js.map

/***/ }),

/***/ 5068:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2895);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectHideDeletedItemsOption')(function selectHideDeletedItemsOption(hideDeletedItems, state) {
    var optionState = state.optionState;
    optionState.hideDeletedItems = hideDeletedItems;
}));
//# sourceMappingURL=selectHideDeletedItemsOption.js.map

/***/ }),

/***/ 5069:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2895);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectGlobalListViewTypeOption')(function selectGlobalListViewTypeOption(selection, state) {
    var optionState = state.optionState;
    optionState.globalListViewType = selection;
}));
//# sourceMappingURL=selectGlobalListViewTypeOption.js.map

/***/ }),

/***/ 5070:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ChoiceGroup_1 = __webpack_require__(2613);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var Image_1 = __webpack_require__(344);
var url_1 = __webpack_require__(155);
var getPackageBaseUrl_1 = __webpack_require__(224);
var isDarkTheme_1 = __webpack_require__(2210);
var classnames = __webpack_require__(343);
var styles = __webpack_require__(5071);
var ChoiceItemWithImages = mobx_react_1.observer(function (props) {
    var option = props;
    return (React.createElement("div", { className: styles.option, style: { width: option.width + 4 + "px" } },
        React.createElement("span", { id: props.labelId, className: "ms-Label" }, props.text),
        React.createElement("div", { className: classnames(styles.imageContainer, 'flipForRtl', option.checked && styles.selected) },
            React.createElement(Image_1.Image, { src: url_1.resolve(getPackageBaseUrl_1.default(), option.imageUri), className: styles.image, alt: "", role: "presentation", style: 
                /* We need to invert the black SVG for dark themes. Does not work in IE11, but these SVGs will be going away with an option refactor soon anyway */
                isDarkTheme_1.default() ? { filter: 'invert(100%)' } : undefined }))));
});
var ChoiceGroupWithImages = /** @class */ (function (_super) {
    tslib_1.__extends(ChoiceGroupWithImages, _super);
    function ChoiceGroupWithImages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRenderChoice = function (props) { return React.createElement(ChoiceItemWithImages, tslib_1.__assign({}, props)); };
        return _this;
    }
    ChoiceGroupWithImages.prototype.render = function () {
        var _this = this;
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, tslib_1.__assign({}, this.props, { className: classnames(this.props.className, styles.choiceGroup), options: this.props.options &&
                this.props.options.map(function (option) {
                    return (tslib_1.__assign({}, option, { onRenderLabel: _this.onRenderChoice }));
                }) })));
    };
    ChoiceGroupWithImages = tslib_1.__decorate([
        mobx_react_1.observer
    ], ChoiceGroupWithImages);
    return ChoiceGroupWithImages;
}(React.Component));
exports.default = ChoiceGroupWithImages;
//# sourceMappingURL=ChoiceGroupWithImages.js.map

/***/ }),

/***/ 5071:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5072);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5072:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] div._3pLccNutbzGEieDfpWkWVJ{margin-bottom:16px}html[dir] div._3pLccNutbzGEieDfpWkWVJ:last-child{margin-bottom:0}div._3pLccNutbzGEieDfpWkWVJ .ms-ChoiceFieldGroup{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}div._3pLccNutbzGEieDfpWkWVJ .ms-ChoiceFieldGroup>.ms-Label{width:100%}div._3pLccNutbzGEieDfpWkWVJ .ms-ChoiceField{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}html[dir=ltr] div._3pLccNutbzGEieDfpWkWVJ .ms-ChoiceField{margin-right:10px}html[dir=rtl] div._3pLccNutbzGEieDfpWkWVJ .ms-ChoiceField{margin-left:10px}html[dir=ltr] div._3pLccNutbzGEieDfpWkWVJ .ms-ChoiceField:last-child{margin-right:0}html[dir=rtl] div._3pLccNutbzGEieDfpWkWVJ .ms-ChoiceField:last-child{margin-left:0}._1LvunhT7w9VYFDMwOiAz3h{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._1LvunhT7w9VYFDMwOiAz3h ._3FhXcGpVt_nQWlwPBsfqwa{width:154px;height:100px}html[dir] ._1LvunhT7w9VYFDMwOiAz3h ._3FhXcGpVt_nQWlwPBsfqwa{margin-top:10px;border:2px solid transparent}html[dir=ltr] ._1LvunhT7w9VYFDMwOiAz3h ._3FhXcGpVt_nQWlwPBsfqwa{margin-left:24px}html[dir=rtl] ._1LvunhT7w9VYFDMwOiAz3h ._3FhXcGpVt_nQWlwPBsfqwa{margin-right:24px}html[dir] ._1LvunhT7w9VYFDMwOiAz3h ._3FhXcGpVt_nQWlwPBsfqwa._3yNCm7Tp1S0x6GQmM1rs5j{border-color:\"[theme:themePrimary, default:#0078D7]\"}", ""]);

// exports
exports.locals = {
	"choiceGroup": "_3pLccNutbzGEieDfpWkWVJ",
	"option": "_1LvunhT7w9VYFDMwOiAz3h",
	"imageContainer": "_3FhXcGpVt_nQWlwPBsfqwa",
	"selected": "_3yNCm7Tp1S0x6GQmM1rs5j"
};

/***/ }),

/***/ 5073:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxOTIgMTI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxOTIgMTI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMDAwMDAwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30NCgkuc3Qxe2ZpbGw6I0M4QzhDODt9DQoJLnN0MntmaWxsOm5vbmU7c3Ryb2tlOiMwMTAxMDE7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KCS5zdDN7ZmlsbDojMDEwMTAxO30NCgkuc3Q0e2ZpbGw6I0ZGRkZGRjt9DQoJLnN0NXtjbGlwLXBhdGg6dXJsKCNTVkdJRF8yXyk7fQ0KCS5zdDZ7Y2xpcC1wYXRoOnVybCgjU1ZHSURfNF8pO30NCgkuc3Q3e2NsaXAtcGF0aDp1cmwoI1NWR0lEXzZfKTt9DQoJLnN0OHtjbGlwLXBhdGg6dXJsKCNTVkdJRF84Xyk7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGQ9Ik0xOTAsMnYxMjBIMlYySDE5MCBNMTkwLDBIMkMwLjksMCwwLDAuOSwwLDJ2MTIwYzAsMS4xLDAuOSwyLDIsMmgxODhjMS4xLDAsMi0wLjksMi0yVjJDMTkyLDAuOSwxOTEuMSwwLDE5MCwwTDE5MCwweiIvPg0KPC9nPg0KPHBhdGggY2xhc3M9InN0MCIgZD0iTTk1LDMxLjIiLz4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik05NSwxMDguMiIvPg0KPHBhdGggY2xhc3M9InN0MCIgZD0iTTk0LDQwIi8+DQo8cmVjdCB4PSI3IiB5PSIyMCIgY2xhc3M9InN0MSIgd2lkdGg9IjI3IiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjciIHk9IjMwIiBjbGFzcz0ic3QxIiB3aWR0aD0iMjciIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iNyIgeT0iNDAiIGNsYXNzPSJzdDEiIHdpZHRoPSIyNyIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSI3IiB5PSI1MCIgY2xhc3M9InN0MSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjQwIiB5PSI1MC41IiB3aWR0aD0iNTIuMSIgaGVpZ2h0PSIxOS41Ii8+DQo8cmVjdCB4PSI5MSIgeT0iMTMiIHdpZHRoPSIyIiBoZWlnaHQ9IjExMCIvPg0KPHJlY3QgeD0iMzkiIHk9IjEzIiB3aWR0aD0iMiIgaGVpZ2h0PSIxMTAiLz4NCjxyZWN0IHg9IjQwIiB5PSI4OCIgd2lkdGg9IjUyIiBoZWlnaHQ9IjIiLz4NCjxyZWN0IHg9IjQwIiB5PSIxMDciIHdpZHRoPSI1MiIgaGVpZ2h0PSIyIi8+DQo8cmVjdCB4PSI0MCIgeT0iMzAiIHdpZHRoPSI1MiIgaGVpZ2h0PSIyIi8+DQo8cmVjdCB4PSIxIiB5PSIxMSIgd2lkdGg9IjE5MCIgaGVpZ2h0PSIyIi8+DQo8cmVjdCB4PSI3IiB5PSI2OCIgY2xhc3M9InN0MSIgd2lkdGg9IjI3IiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjciIHk9Ijc4IiBjbGFzcz0ic3QxIiB3aWR0aD0iMjciIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iNyIgeT0iODgiIGNsYXNzPSJzdDEiIHdpZHRoPSIyNyIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSI3IiB5PSI5OCIgY2xhc3M9InN0MSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjMiLz4NCjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik0xOTEsNDAiLz4NCjxyZWN0IHg9IjEyMCIgeT0iNDgiIGNsYXNzPSJzdDMiIHdpZHRoPSI1NiIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSIxMjAiIHk9IjU3IiBjbGFzcz0ic3QzIiB3aWR0aD0iNDIiIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iMTIwIiB5PSI3NiIgY2xhc3M9InN0MyIgd2lkdGg9IjU2IiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjEyMCIgeT0iODUiIGNsYXNzPSJzdDMiIHdpZHRoPSI0MiIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSIxMjAiIHk9IjEwMyIgY2xhc3M9InN0MyIgd2lkdGg9IjU2IiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjEyMCIgeT0iMTEyIiBjbGFzcz0ic3QzIiB3aWR0aD0iNDIiIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iOTIiIHk9IjY4IiBjbGFzcz0ic3QzIiB3aWR0aD0iOTkiIGhlaWdodD0iMiIvPg0KPHJlY3QgeD0iOTIiIHk9Ijk2IiBjbGFzcz0ic3QzIiB3aWR0aD0iOTkiIGhlaWdodD0iMiIvPg0KPGc+DQoJPHBhdGggY2xhc3M9InN0NCIgZD0iTTEwNywzNEwxMDcsMzRjLTMuOSwwLTctMy4xLTctN2wwLDBjMC0zLjksMy4xLTcsNy03bDAsMGMzLjksMCw3LDMuMSw3LDdsMCwwQzExNCwzMC45LDExMC45LDM0LDEwNywzNHoiLz4NCgk8Zz4NCgkJPGc+DQoJCQk8Zz4NCgkJCQk8Zz4NCgkJCQkJPGRlZnM+DQoJCQkJCQk8cGF0aCBpZD0iU1ZHSURfMV8iIGQ9Ik0xMDcsMzRMMTA3LDM0Yy0zLjksMC03LTMuMS03LTdsMCwwYzAtMy45LDMuMS03LDctN2wwLDBjMy45LDAsNywzLjEsNyw3bDAsMA0KCQkJCQkJCUMxMTQsMzAuOSwxMTAuOSwzNCwxMDcsMzR6Ii8+DQoJCQkJCTwvZGVmcz4NCgkJCQkJPGNsaXBQYXRoIGlkPSJTVkdJRF8yXyI+DQoJCQkJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF8xXyIgIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPg0KCQkJCQk8L2NsaXBQYXRoPg0KCQkJCQk8ZyBjbGFzcz0ic3Q1Ij4NCgkJCQkJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0xMDcsMjcuOUwxMDcsMjcuOWMtMS40LDAtMi42LTEuMi0yLjYtMi42bDAsMGMwLTEuNCwxLjItMi42LDIuNi0yLjZsMCwwYzEuNCwwLDIuNiwxLjIsMi42LDIuNmwwLDANCgkJCQkJCQlDMTA5LjYsMjYuNywxMDguNCwyNy45LDEwNywyNy45eiIvPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEwNy42LDM2LjZoLTEuMmMtMi4xLDAtMy44LTEuNy0zLjgtMy43di0xLjNjMC0yLjEsMS43LTMuNywzLjgtMy43aDEuMmMyLjEsMCwzLjgsMS43LDMuOCwzLjd2MS4zDQoJCQkJCQkJQzExMS40LDM0LjksMTA5LjcsMzYuNiwxMDcuNiwzNi42eiIvPg0KCQkJCQk8L2c+DQoJCQkJPC9nPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPGc+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTEwNyw2MkwxMDcsNjJjLTMuOSwwLTctMy4xLTctN2wwLDBjMC0zLjksMy4xLTcsNy03bDAsMGMzLjksMCw3LDMuMSw3LDdsMCwwQzExNCw1OC45LDExMC45LDYyLDEwNyw2MnoiLz4NCgk8Zz4NCgkJPGc+DQoJCQk8Zz4NCgkJCQk8Zz4NCgkJCQkJPGRlZnM+DQoJCQkJCQk8cGF0aCBpZD0iU1ZHSURfM18iIGQ9Ik0xMDcsNjJMMTA3LDYyYy0zLjksMC03LTMuMS03LTdsMCwwYzAtMy45LDMuMS03LDctN2wwLDBjMy45LDAsNywzLjEsNyw3bDAsMA0KCQkJCQkJCUMxMTQsNTguOSwxMTAuOSw2MiwxMDcsNjJ6Ii8+DQoJCQkJCTwvZGVmcz4NCgkJCQkJPGNsaXBQYXRoIGlkPSJTVkdJRF80XyI+DQoJCQkJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF8zXyIgIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPg0KCQkJCQk8L2NsaXBQYXRoPg0KCQkJCQk8ZyBjbGFzcz0ic3Q2Ij4NCgkJCQkJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0xMDcsNTUuOUwxMDcsNTUuOWMtMS40LDAtMi42LTEuMi0yLjYtMi42bDAsMGMwLTEuNCwxLjItMi42LDIuNi0yLjZsMCwwYzEuNCwwLDIuNiwxLjIsMi42LDIuNmwwLDANCgkJCQkJCQlDMTA5LjYsNTQuNywxMDguNCw1NS45LDEwNyw1NS45eiIvPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEwNy42LDY0LjZoLTEuMmMtMi4xLDAtMy44LTEuNy0zLjgtMy43di0xLjNjMC0yLjEsMS43LTMuNywzLjgtMy43aDEuMmMyLjEsMCwzLjgsMS43LDMuOCwzLjd2MS4zDQoJCQkJCQkJQzExMS40LDYyLjksMTA5LjcsNjQuNiwxMDcuNiw2NC42eiIvPg0KCQkJCQk8L2c+DQoJCQkJPC9nPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPGc+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTEwNyw5MEwxMDcsOTBjLTMuOSwwLTctMy4xLTctN2wwLDBjMC0zLjksMy4xLTcsNy03bDAsMGMzLjksMCw3LDMuMSw3LDdsMCwwQzExNCw4Ni45LDExMC45LDkwLDEwNyw5MHoiLz4NCgk8Zz4NCgkJPGc+DQoJCQk8Zz4NCgkJCQk8Zz4NCgkJCQkJPGRlZnM+DQoJCQkJCQk8cGF0aCBpZD0iU1ZHSURfNV8iIGQ9Ik0xMDcsOTBMMTA3LDkwYy0zLjksMC03LTMuMS03LTdsMCwwYzAtMy45LDMuMS03LDctN2wwLDBjMy45LDAsNywzLjEsNyw3bDAsMA0KCQkJCQkJCUMxMTQsODYuOSwxMTAuOSw5MCwxMDcsOTB6Ii8+DQoJCQkJCTwvZGVmcz4NCgkJCQkJPGNsaXBQYXRoIGlkPSJTVkdJRF82XyI+DQoJCQkJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF81XyIgIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPg0KCQkJCQk8L2NsaXBQYXRoPg0KCQkJCQk8ZyBjbGFzcz0ic3Q3Ij4NCgkJCQkJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0xMDcsODMuOUwxMDcsODMuOWMtMS40LDAtMi42LTEuMi0yLjYtMi42bDAsMGMwLTEuNCwxLjItMi42LDIuNi0yLjZsMCwwYzEuNCwwLDIuNiwxLjIsMi42LDIuNmwwLDANCgkJCQkJCQlDMTA5LjYsODIuNywxMDguNCw4My45LDEwNyw4My45eiIvPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEwNy42LDkyLjZoLTEuMmMtMi4xLDAtMy44LTEuNy0zLjgtMy44di0xLjJjMC0yLjEsMS43LTMuOCwzLjgtMy44aDEuMmMyLjEsMCwzLjgsMS43LDMuOCwzLjh2MS4yDQoJCQkJCQkJQzExMS40LDkwLjksMTA5LjcsOTIuNiwxMDcuNiw5Mi42eiIvPg0KCQkJCQk8L2c+DQoJCQkJPC9nPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPGc+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTEwNywxMTdMMTA3LDExN2MtMy45LDAtNy0zLjEtNy03bDAsMGMwLTMuOSwzLjEtNyw3LTdsMCwwYzMuOSwwLDcsMy4xLDcsN2wwLDBDMTE0LDExMy45LDExMC45LDExNywxMDcsMTE3eg0KCQkiLz4NCgk8Zz4NCgkJPGc+DQoJCQk8Zz4NCgkJCQk8Zz4NCgkJCQkJPGRlZnM+DQoJCQkJCQk8cGF0aCBpZD0iU1ZHSURfN18iIGQ9Ik0xMDcsMTE3TDEwNywxMTdjLTMuOSwwLTctMy4xLTctN2wwLDBjMC0zLjksMy4xLTcsNy03bDAsMGMzLjksMCw3LDMuMSw3LDdsMCwwDQoJCQkJCQkJQzExNCwxMTMuOSwxMTAuOSwxMTcsMTA3LDExN3oiLz4NCgkJCQkJPC9kZWZzPg0KCQkJCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzhfIj4NCgkJCQkJCTx1c2UgeGxpbms6aHJlZj0iI1NWR0lEXzdfIiAgc3R5bGU9Im92ZXJmbG93OnZpc2libGU7Ii8+DQoJCQkJCTwvY2xpcFBhdGg+DQoJCQkJCTxnIGNsYXNzPSJzdDgiPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEwNywxMTAuOUwxMDcsMTEwLjljLTEuNCwwLTIuNi0xLjItMi42LTIuNmwwLDBjMC0xLjQsMS4yLTIuNiwyLjYtMi42bDAsMGMxLjQsMCwyLjYsMS4yLDIuNiwyLjZsMCwwDQoJCQkJCQkJQzEwOS42LDEwOS43LDEwOC40LDExMC45LDEwNywxMTAuOXoiLz4NCgkJCQkJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0xMDcuNiwxMTkuNmgtMS4yYy0yLjEsMC0zLjgtMS43LTMuOC0zLjh2LTEuMmMwLTIuMSwxLjctMy44LDMuOC0zLjhoMS4yYzIuMSwwLDMuOCwxLjcsMy44LDMuOHYxLjINCgkJCQkJCQlDMTExLjQsMTE3LjksMTA5LjcsMTE5LjYsMTA3LjYsMTE5LjZ6Ii8+DQoJCQkJCTwvZz4NCgkJCQk8L2c+DQoJCQk8L2c+DQoJCTwvZz4NCgk8L2c+DQo8L2c+DQo8cGF0aCBjbGFzcz0ic3QzIiBkPSJNOTIsMTJ2MzBoOTlWMTJIOTJ6IE0xMDcsMzRMMTA3LDM0Yy0zLjksMC03LTMuMS03LTdsMCwwYzAtMy45LDMuMS03LDctN2wwLDBjMy45LDAsNywzLjEsNyw3bDAsMA0KCUMxMTQsMzAuOSwxMTAuOSwzNCwxMDcsMzR6IE0xNjIsMzJoLTQydi0zaDQyVjMyeiBNMTc2LDIzaC01NnYtM2g1NlYyM3oiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 5074:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 5075:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 5076:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 5077:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var saveConversationsOption_1 = __webpack_require__(3738);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var CONVERSATION_VIEW_OFF_KEY = 'Off';
var ConversationsQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ConversationsQuick, _super);
    function ConversationsQuick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            if (option.key === CONVERSATION_VIEW_OFF_KEY) {
                saveConversationsOption_1.saveConversationsOptionQuick(false);
            }
            else {
                saveConversationsOption_1.saveConversationsOptionQuick(true, option.key);
            }
        };
        return _this;
    }
    ConversationsQuick.prototype.render = function () {
        var userOptions = this.props.userOptions;
        var selectedKey = userOptions.GlobalListViewTypeReact === 1 /* Message */
            ? CONVERSATION_VIEW_OFF_KEY
            : userOptions.ConversationSortOrderReact;
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { "aria-labelledby": this.props.headerAriaId, selectedKey: selectedKey, options: [
                {
                    key: 'ChronologicalNewestOnTop',
                    text: owa_options_strings_1.default.options_conversations_quick_sortOrderTop,
                },
                {
                    key: 'ChronologicalNewestOnBottom',
                    text: owa_options_strings_1.default.options_conversations_quick_sortOrderBottom,
                },
                {
                    key: CONVERSATION_VIEW_OFF_KEY,
                    text: owa_options_strings_1.default.options_conversations_quick_messageView,
                },
            ], onChange: this.onChange }));
    };
    ConversationsQuick = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ConversationsQuick);
    return ConversationsQuick;
}(React.Component));
exports.default = ConversationsQuick;
//# sourceMappingURL=ConversationsQuick.js.map

/***/ }),

/***/ 5078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2895);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var owa_options_core_1 = __webpack_require__(1736);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isConversationsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var listViewTypeSelected = owa_options_core_1.getFallbackValueIfNull(optionState.globalListViewType, userOptions.GlobalListViewTypeReact);
    var conversationSortOrder = owa_options_core_1.getFallbackValueIfNull(optionState.conversationSortOrder, userOptions.ConversationSortOrderReact);
    var hideDeletedItems = owa_options_core_1.getFallbackValueIfNull(optionState.hideDeletedItems, userOptions.HideDeletedItems);
    return (listViewTypeSelected !== userOptions.GlobalListViewTypeReact ||
        conversationSortOrder !== userOptions.ConversationSortOrderReact ||
        hideDeletedItems !== userOptions.HideDeletedItems);
});
//# sourceMappingURL=isConversationsOptionDirty.js.map

/***/ }),

/***/ 5079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2895);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardConversationsOption')(function discardConversationsOption(state) {
    var optionState = state.optionState;
    optionState.globalListViewType = null;
    optionState.conversationSortOrder = null;
    optionState.hideDeletedItems = null;
}));
//# sourceMappingURL=discardConversationsOption.js.map

/***/ }),

/***/ 5080:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DateHeadersFull_1 = __webpack_require__(5081);
var React = __webpack_require__(3);
var isDateHeadersOptionDirty_1 = __webpack_require__(5083);
var saveDateHeadersOption_1 = __webpack_require__(5084);
var discardDateHeadersOption_1 = __webpack_require__(5085);
var isDateHeaderEnabled_1 = __webpack_require__(3739);
var DateHeadersOption = {
    key: 'dateHeaders',
    titleStringKey: 'optionTitle_dateHeaders',
    searchTermsStringKey: 'optionTitle_dateHeaders',
    fullOptionFormSettings: {
        render: function () { return React.createElement(DateHeadersFull_1.default, null); },
        isDirty: isDateHeadersOptionDirty_1.default,
        onSave: saveDateHeadersOption_1.default,
        onDiscard: discardDateHeadersOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isDateHeaderEnabled_1.default,
            onToggle: saveDateHeadersOption_1.default,
        },
        order: 5 /* DateHeaders */,
        workloads: 1 /* Mail */,
        customTitle: 'options_dateHeaders_quick_label',
    },
};
exports.default = DateHeadersOption;
//# sourceMappingURL=DateHeadersOption.js.map

/***/ }),

/***/ 5081:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectDateHeadersOption_1 = __webpack_require__(5082);
var store_1 = __webpack_require__(3068);
var ChoiceGroup_1 = __webpack_require__(2613);
var isDateHeaderEnabled_1 = __webpack_require__(3739);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var DateHeadersFull = /** @class */ (function (_super) {
    tslib_1.__extends(DateHeadersFull, _super);
    function DateHeadersFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectDateHeadersOption_1.default(option.key === 'true');
        };
        return _this;
    }
    DateHeadersFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var isDateHeadersEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.isEnabled, isDateHeaderEnabled_1.default());
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + isDateHeadersEnabled, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_dateHeaders_enabled,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_dateHeaders_disabled,
                },
            ], onChange: this.onChange }));
    };
    DateHeadersFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
        })
    ], DateHeadersFull);
    return DateHeadersFull;
}(React.Component));
exports.default = DateHeadersFull;
//# sourceMappingURL=DateHeadersFull.js.map

/***/ }),

/***/ 5082:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3068);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectDateHeadersOption')(function selectDateHeadersOption(isDateHeadersEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isDateHeadersEnabled;
}));
//# sourceMappingURL=selectDateHeadersOption.js.map

/***/ }),

/***/ 5083:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var listViewBitFlagsUtil_1 = __webpack_require__(243);
var store_1 = __webpack_require__(3068);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    viewStateConfiguration: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(function IsDateHeadersDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled == listViewBitFlagsUtil_1.getIsBitSet(2 /* DateHeadersDisabled */));
});
//# sourceMappingURL=isDateHeadersOptionDirty.js.map

/***/ }),

/***/ 5084:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3068);
var listViewBitFlagsUtil_1 = __webpack_require__(243);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    viewStateConfiguration: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(legacy_1.action('saveDateHeadersOption')(function saveDateHeadersOption(isEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, viewStateConfiguration, isDateHeadersEnabled;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, viewStateConfiguration = state.viewStateConfiguration;
                    isDateHeadersEnabled = isEnabled === void 0 ? optionState.isEnabled : isEnabled;
                    listViewBitFlagsUtil_1.setBit(!isDateHeadersEnabled, 2 /* DateHeadersDisabled */);
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'ListViewBitFlags',
                                propertyType: 'Integer32',
                                propertyValue: "" + viewStateConfiguration.ListViewBitFlags,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveDateHeadersOption.js.map

/***/ }),

/***/ 5085:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3068);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardDateHeadersOption')(function discardDateHeadersOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardDateHeadersOption.js.map

/***/ }),

/***/ 5086:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardFocusedInboxOption_1 = __webpack_require__(5087);
var saveFocusedInboxOption_1 = __webpack_require__(5088);
var FocusedFull_1 = __webpack_require__(5090);
var isFocusedInboxOptionDirty_1 = __webpack_require__(5092);
var React = __webpack_require__(3);
var owa_session_store_1 = __webpack_require__(151);
var FocusedInboxOption = {
    key: 'focused',
    titleStringKey: 'optionTitle_focusedInbox',
    searchTermsStringKey: 'optionTitle_focusedInbox',
    fullOptionFormSettings: {
        render: function () { return React.createElement(FocusedFull_1.default, null); },
        isDirty: isFocusedInboxOptionDirty_1.default,
        onSave: saveFocusedInboxOption_1.default,
        onDiscard: discardFocusedInboxOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: function () { return owa_session_store_1.getUserConfiguration().UserOptions.IsFocusedInboxEnabled; },
            onToggle: saveFocusedInboxOption_1.saveFocusedInboxQuickOption,
        },
        order: 3 /* Focused */,
        workloads: 1 /* Mail */,
        tooltip: {
            tooltipStringKey: 'options_focused_enabled',
        },
    },
};
exports.default = FocusedInboxOption;
//# sourceMappingURL=FocusedInboxOption.js.map

/***/ }),

/***/ 5087:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3069);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardFocusedInboxOption')(function discardFocusedInboxOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardFocusedInboxOption.js.map

/***/ }),

/***/ 5088:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3069);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var setIsFocusedCapableService_1 = __webpack_require__(5089);
var owa_analytics_1 = __webpack_require__(12);
var saveFocusInboxOptionStitchName = 'saveFocusInboxOptionStitchName';
var saveFocusedInboxOption = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveFocusedInboxOption')(function saveFocusedInboxOption(isEnabledOverride, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, servicePromises;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    if (isEnabledOverride !== undefined) {
                        optionState.isEnabled = isEnabledOverride;
                    }
                    userOptions.IsFocusedInboxEnabled = optionState.isEnabled;
                    // Raise stitch so that, if we're running in mail, the focused inbox will toggle on and off
                    stitch_1.raiseAction(saveFocusInboxOptionStitchName)(userOptions.IsFocusedInboxEnabled);
                    servicePromises = [];
                    servicePromises.push(owa_options_core_1.updateUserConfiguration([
                        {
                            propertyName: 'IsFocusedInboxEnabled',
                            propertyType: 'Boolean',
                            propertyValue: "" + optionState.isEnabled,
                        },
                    ]));
                    // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
                    if (userOptions.IsFocusedInboxEnabled) {
                        servicePromises.push(setIsFocusedCapableService_1.default());
                    }
                    return [4 /*yield*/, Promise.all(servicePromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
exports.default = saveFocusedInboxOption;
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingFocusedInbox';
function saveFocusedInboxQuickOption(isEnabled) {
    owa_analytics_1.logUsage(OPTION_QUICK_SETTING_USAGE_KEY, ["" + isEnabled]);
    saveFocusedInboxOption(isEnabled);
}
exports.saveFocusedInboxQuickOption = saveFocusedInboxQuickOption;
//# sourceMappingURL=saveFocusedInboxOption.js.map

/***/ }),

/***/ 5089:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setFocusedInboxConfigurationOperation_1 = __webpack_require__(1865);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Sets IsFocusedInboxCapable flag on server to indicate enable mailbox for focused inbox
 * @return the SetFocusedInboxConfigurationResponse
 */
function setIsFocusedInboxCapableService() {
    var request = {
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        IsFocusedInboxCapable: true,
    };
    return setFocusedInboxConfigurationOperation_1.default({
        request: request,
    }).then(function (response) {
        return response;
    });
}
exports.default = setIsFocusedInboxCapableService;
//# sourceMappingURL=setIsFocusedCapableService.js.map

/***/ }),

/***/ 5090:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectFocusedInboxOption_1 = __webpack_require__(5091);
var store_1 = __webpack_require__(3069);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var FocusedFull = /** @class */ (function (_super) {
    tslib_1.__extends(FocusedFull, _super);
    function FocusedFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectFocusedInboxOption_1.default(option.key === 'true');
        };
        return _this;
    }
    FocusedFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isFocusedEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.isEnabled, userOptions.IsFocusedInboxEnabled);
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + isFocusedEnabled, label: owa_options_strings_1.default.options_focused_label, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_focused_enabled,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_focused_disabled,
                },
            ], onChange: this.onChange }));
    };
    FocusedFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], FocusedFull);
    return FocusedFull;
}(React.Component));
exports.default = FocusedFull;
//# sourceMappingURL=FocusedFull.js.map

/***/ }),

/***/ 5091:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3069);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectFocusedInboxOption')(function selectFocusedInboxOption(isFocusedInboxEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isFocusedInboxEnabled;
}));
//# sourceMappingURL=selectFocusedInboxOption.js.map

/***/ }),

/***/ 5092:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3069);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isFocusedInboxOptionDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled !== state.userOptions.IsFocusedInboxEnabled);
});
//# sourceMappingURL=isFocusedInboxOptionDirty.js.map

/***/ }),

/***/ 5093:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InlinePreviewsFull_1 = __webpack_require__(5094);
var React = __webpack_require__(3);
var isInlinePreviewsOptionDirty_1 = __webpack_require__(5096);
var saveInlinePreviewsOption_1 = __webpack_require__(5097);
var discardInlinePreviewsOption_1 = __webpack_require__(5098);
var owa_session_store_1 = __webpack_require__(151);
var InlinePreviewsOption = {
    key: 'inlinePreviews',
    titleStringKey: 'optionTitle_inlinePreviews',
    searchTermsStringKey: 'optionTitle_inlinePreviews',
    fullOptionFormSettings: {
        render: function () { return React.createElement(InlinePreviewsFull_1.default, null); },
        isDirty: isInlinePreviewsOptionDirty_1.default,
        onSave: saveInlinePreviewsOption_1.default,
        onDiscard: discardInlinePreviewsOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: function () { return owa_session_store_1.getUserConfiguration().UserOptions.ShowInlinePreviews; },
            onToggle: saveInlinePreviewsOption_1.default,
        },
        order: 6 /* InlinePreview */,
        workloads: 1 /* Mail */,
        customTitle: 'options_inlinePreviews_quick_setting_label',
    },
};
exports.default = InlinePreviewsOption;
//# sourceMappingURL=InlinePreviewsOption.js.map

/***/ }),

/***/ 5094:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectInlinePreviewsOption_1 = __webpack_require__(5095);
var store_1 = __webpack_require__(3070);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var InlinePreviewsFull = /** @class */ (function (_super) {
    tslib_1.__extends(InlinePreviewsFull, _super);
    function InlinePreviewsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectInlinePreviewsOption_1.default(option.key === 'true');
        };
        return _this;
    }
    InlinePreviewsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isPreviewsInlineEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.isEnabled, userOptions.ShowInlinePreviews);
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + isPreviewsInlineEnabled, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_inlinePreviews_enabled,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_inlinePreviews_disabled,
                },
            ], onChange: this.onChange }));
    };
    InlinePreviewsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], InlinePreviewsFull);
    return InlinePreviewsFull;
}(React.Component));
exports.default = InlinePreviewsFull;
//# sourceMappingURL=InlinePreviewsFull.js.map

/***/ }),

/***/ 5095:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3070);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectInlinePreviewsOption')(function selectInlinePreviewsOption(isInlinePreviewsEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isInlinePreviewsEnabled;
}));
//# sourceMappingURL=selectInlinePreviewsOption.js.map

/***/ }),

/***/ 5096:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3070);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function IsInlinePreviewsDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled !== state.userOptions.ShowInlinePreviews);
});
//# sourceMappingURL=isInlinePreviewsOptionDirty.js.map

/***/ }),

/***/ 5097:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3070);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var owa_options_core_1 = __webpack_require__(1736);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveInlinePreviewsOption')(function saveInlinePreviewsOption(isEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, isFeatureEnabled;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    isFeatureEnabled = isEnabled === void 0 ? optionState.isEnabled : isEnabled;
                    userOptions.ShowInlinePreviews = isFeatureEnabled;
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'ShowInlinePreviews',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.ShowInlinePreviews,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveInlinePreviewsOption.js.map

/***/ }),

/***/ 5098:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3070);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardInlinePreviewsOption')(function discardInlinePreviewsOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardInlinePreviewsOption.js.map

/***/ }),

/***/ 5099:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var SenderImageFull_1 = __webpack_require__(5100);
var discardSenderImageOption_1 = __webpack_require__(5102);
var saveSenderImageOption_1 = __webpack_require__(5103);
var isSenderImageOptionDirty_1 = __webpack_require__(5104);
var isSenderImageEnabled_1 = __webpack_require__(5105);
var SenderImageOption = {
    key: 'senderImage',
    titleStringKey: 'optionTitle_senderImage',
    searchTermsStringKey: 'optionTitle_senderImage',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SenderImageFull_1.default, null); },
        isDirty: isSenderImageOptionDirty_1.default,
        onSave: saveSenderImageOption_1.default,
        onDiscard: discardSenderImageOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isSenderImageEnabled_1.default,
            onToggle: saveSenderImageOption_1.onSenderImageToggle,
        },
        order: 4 /* SenderImage */,
        workloads: 1 /* Mail */,
    },
};
exports.default = SenderImageOption;
//# sourceMappingURL=SenderImageOption.js.map

/***/ }),

/***/ 5100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectHideSenderImageOption_1 = __webpack_require__(5101);
var store_1 = __webpack_require__(3071);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
// import ReadReceiptResponse from 'owa-service/lib/contract/ReadReceiptResponse';
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var listViewBitFlagsUtil_1 = __webpack_require__(243);
var SenderImageFull = /** @class */ (function (_super) {
    tslib_1.__extends(SenderImageFull, _super);
    function SenderImageFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHideSenderImageChange = function (ev, option) {
            selectHideSenderImageOption_1.default(option.key === 'true');
        };
        return _this;
    }
    SenderImageFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var showSenderImageInListView = owa_options_core_1.getFallbackValueIfNull(optionStore.showSenderImageInListView, !listViewBitFlagsUtil_1.getIsBitSet(8 /* HideSenderImage */));
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + showSenderImageInListView, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_messageList_showSenderImage,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_messageList_hideSenderImage,
                },
            ], onChange: this.onHideSenderImageChange, label: owa_options_strings_1.default.options_messageList_senderImageLabel }));
    };
    SenderImageFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
        })
    ], SenderImageFull);
    return SenderImageFull;
}(React.Component));
exports.default = SenderImageFull;
//# sourceMappingURL=SenderImageFull.js.map

/***/ }),

/***/ 5101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3071);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectHideSenderImageOption')(function selectShowPreviewTextOption(hideSenderImage, state) {
    var optionState = state.optionState;
    optionState.showSenderImageInListView = hideSenderImage;
}));
//# sourceMappingURL=selectHideSenderImageOption.js.map

/***/ }),

/***/ 5102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3071);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardSenderImageOption')(function discardSenderImageOption(state) {
    var optionState = state.optionState;
    optionState.showSenderImageInListView = null;
}));
//# sourceMappingURL=discardSenderImageOption.js.map

/***/ }),

/***/ 5103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3071);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var listViewBitFlagsUtil_1 = __webpack_require__(243);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    viewStateConfiguration: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(function saveSenderImageOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, viewStateConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, viewStateConfiguration = state.viewStateConfiguration;
                    return [4 /*yield*/, saveSenderImageOption(optionState.showSenderImageInListView, viewStateConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
var saveSenderImageOption = legacy_1.action('saveSenderImageOption')(function saveSenderImageOption(isEnabled, viewStateConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    listViewBitFlagsUtil_1.setBit(!isEnabled, 8 /* HideSenderImage */);
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'ListViewBitFlags',
                                propertyType: 'Integer32',
                                propertyValue: "" + viewStateConfiguration.ListViewBitFlags,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
exports.onSenderImageToggle = legacy_1.select({
    viewStateConfiguration: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(function (isEnabled, state) {
    saveSenderImageOption(isEnabled, state.viewStateConfiguration);
});
//# sourceMappingURL=saveSenderImageOption.js.map

/***/ }),

/***/ 5104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3071);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var listViewBitFlagsUtil_1 = __webpack_require__(243);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isSenderImageOptionDirty(state) {
    var hideSenderImageViewStateOption = !listViewBitFlagsUtil_1.getIsBitSet(8 /* HideSenderImage */);
    var showSenderImageInListView = owa_options_core_1.getFallbackValueIfNull(state.optionState.showSenderImageInListView, hideSenderImageViewStateOption);
    return showSenderImageInListView !== hideSenderImageViewStateOption;
});
//# sourceMappingURL=isSenderImageOptionDirty.js.map

/***/ }),

/***/ 5105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var listViewBitFlagsUtil_1 = __webpack_require__(243);
function isSenderImageEnabled() {
    return !listViewBitFlagsUtil_1.getIsBitSet(8 /* HideSenderImage */);
}
exports.default = isSenderImageEnabled;
//# sourceMappingURL=isSenderImageEnabled.js.map

/***/ }),

/***/ 5106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var MessagePreviewFull_1 = __webpack_require__(5107);
var discardMessagePreviewOption_1 = __webpack_require__(5109);
var saveMessagePreviewOption_1 = __webpack_require__(5110);
var isMessagePreviewOptionDirty_1 = __webpack_require__(5111);
var isMessagePreviewEnabled_1 = __webpack_require__(5112);
var MessagePreviewOption = {
    key: 'messagePreview',
    titleStringKey: 'optionTitle_messagePreview',
    searchTermsStringKey: 'optionTitle_messagePreview',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessagePreviewFull_1.default, null); },
        isDirty: isMessagePreviewOptionDirty_1.default,
        onSave: saveMessagePreviewOption_1.default,
        onDiscard: discardMessagePreviewOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isMessagePreviewEnabled_1.default,
            onToggle: saveMessagePreviewOption_1.onMessagePreviewToggle,
        },
        order: 7 /* PreviewText */,
        workloads: 1 /* Mail */,
    },
};
exports.default = MessagePreviewOption;
//# sourceMappingURL=MessagePreviewOption.js.map

/***/ }),

/***/ 5107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectShowPreviewTextOption_1 = __webpack_require__(5108);
var store_1 = __webpack_require__(3072);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var MessagePreviewFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessagePreviewFull, _super);
    function MessagePreviewFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onShowPreviewTextChange = function (ev, option) {
            selectShowPreviewTextOption_1.default(option.key === 'true');
        };
        return _this;
    }
    MessagePreviewFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var showPreviewText = owa_options_core_1.getFallbackValueIfNull(optionStore.showPreviewTextInListView, userOptions.ShowPreviewTextInListView);
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + showPreviewText, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_messageList_previewShow,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_messageList_previewHide,
                },
            ], onChange: this.onShowPreviewTextChange, label: owa_options_strings_1.default.options_messageList_previewLabel }));
    };
    MessagePreviewFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MessagePreviewFull);
    return MessagePreviewFull;
}(React.Component));
exports.default = MessagePreviewFull;
//# sourceMappingURL=MessagePreviewFull.js.map

/***/ }),

/***/ 5108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3072);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectShowPreviewTextOption')(function selectShowPreviewTextOption(showPreviewText, state) {
    var optionState = state.optionState;
    optionState.showPreviewTextInListView = showPreviewText;
}));
//# sourceMappingURL=selectShowPreviewTextOption.js.map

/***/ }),

/***/ 5109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3072);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardMessagePreviewOption')(function discardMessagePreviewOption(state) {
    var optionState = state.optionState;
    optionState.showPreviewTextInListView = null;
}));
//# sourceMappingURL=discardMessagePreviewOption.js.map

/***/ }),

/***/ 5110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3072);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_core_2 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function saveMessagePreviewOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    return [4 /*yield*/, saveMessagePreviewOption(optionState.showPreviewTextInListView, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
exports.onMessagePreviewToggle = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function saveMessagePreviewOptionFull(isToggleEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions;
                    return [4 /*yield*/, saveMessagePreviewOption(isToggleEnabled, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
var saveMessagePreviewOption = legacy_1.action('saveMessagePreviewOption')(function saveMessagePreviewOption(isEnabled, userOptions) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions.ShowPreviewTextInListView = owa_options_core_1.getFallbackValueIfNull(isEnabled, userOptions.ShowPreviewTextInListView);
                    return [4 /*yield*/, owa_options_core_2.updateUserConfiguration([
                            {
                                propertyName: 'ShowPreviewTextInListView',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.ShowPreviewTextInListView,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveMessagePreviewOption.js.map

/***/ }),

/***/ 5111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3072);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMessagePreviewOptionDirty(state) {
    var savedOptions = state.userOptions;
    var showPreviewTextInListView = owa_options_core_1.getFallbackValueIfNull(state.optionState.showPreviewTextInListView, savedOptions.ShowPreviewTextInListView);
    return showPreviewTextInListView !== savedOptions.ShowPreviewTextInListView;
});
//# sourceMappingURL=isMessagePreviewOptionDirty.js.map

/***/ }),

/***/ 5112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_session_store_1 = __webpack_require__(151);
function isMessagePreviewEnabled() {
    return owa_session_store_1.getUserConfiguration().UserOptions.ShowPreviewTextInListView;
}
exports.default = isMessagePreviewEnabled;
//# sourceMappingURL=isMessagePreviewEnabled.js.map

/***/ }),

/***/ 5113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var ReadingPaneQuick_1 = __webpack_require__(5114);
var ReadingPaneFull_1 = __webpack_require__(5115);
var discardReadingPaneOption_1 = __webpack_require__(5122);
var saveReadingPaneOption_1 = __webpack_require__(3282);
var isReadingPaneOptionDirty_1 = __webpack_require__(5123);
var ReadingPaneOption = {
    key: 'readingPane',
    titleStringKey: 'optionTitle_readingPane',
    searchTermsStringKey: 'optionTitle_readingPane',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReadingPaneFull_1.default, null); },
        isDirty: isReadingPaneOptionDirty_1.default,
        onSave: saveReadingPaneOption_1.saveReadingPaneOptionFull,
        onDiscard: discardReadingPaneOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            render: function (props) { return (React.createElement(ReadingPaneQuick_1.default, tslib_1.__assign({}, props))); },
        },
        order: 2 /* ReadingPane */,
        workloads: 1 /* Mail */,
        customTitle: 'options_readingPane_quickSetting_label',
    },
};
exports.default = ReadingPaneOption;
//# sourceMappingURL=ReadingPaneOption.js.map

/***/ }),

/***/ 5114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var saveReadingPaneOption_1 = __webpack_require__(3282);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var ReadingPanePosition_1 = __webpack_require__(52);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var ReadingPaneQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ReadingPaneQuick, _super);
    function ReadingPaneQuick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            var newReadingPanePosition = parseInt(option.key, 10);
            saveReadingPaneOption_1.saveReadingPaneOptionQuick(newReadingPanePosition);
        };
        return _this;
    }
    ReadingPaneQuick.prototype.render = function () {
        var userOptions = this.props.userOptions;
        var options = [
            {
                key: "" + ReadingPanePosition_1.default.Right,
                text: owa_options_strings_1.default.options_readingPane_quickSetting_right,
            },
            {
                key: "" + ReadingPanePosition_1.default.Bottom,
                text: owa_options_strings_1.default.options_readingPane_quickSetting_bottom,
            },
            {
                key: "" + ReadingPanePosition_1.default.Off,
                text: owa_options_strings_1.default.options_readingPane_quickSetting_classic,
            },
        ];
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { "aria-labelledby": this.props.headerAriaId, selectedKey: "" + userOptions.GlobalReadingPanePositionReact, options: options, onChange: this.onChange }));
    };
    ReadingPaneQuick = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ReadingPaneQuick);
    return ReadingPaneQuick;
}(React.Component));
exports.default = ReadingPaneQuick;
//# sourceMappingURL=ReadingPaneQuick.js.map

/***/ }),

/***/ 5115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectAfterMoveActionOption_1 = __webpack_require__(5116);
var selectLoadMessageOnSignOnOption_1 = __webpack_require__(5117);
var selectReadingPanePositionOption_1 = __webpack_require__(5118);
var store_1 = __webpack_require__(2813);
var owa_choice_group_with_images_1 = __webpack_require__(3737);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var ReadingPanePosition_1 = __webpack_require__(52);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var READING_PANE_RIGHT_SVG = __webpack_require__(5119);
var READING_PANE_OFF_SVG = __webpack_require__(5120);
var READING_PANE_BOTTOM_SVG = __webpack_require__(5121);
var ReadingPaneFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReadingPaneFull, _super);
    function ReadingPaneFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onAfterMoveActionChange = function (ev, option) {
            selectAfterMoveActionOption_1.default(option.key);
        };
        _this.onChangeReadingPane = function (ev, option) {
            selectReadingPanePositionOption_1.default(parseInt(option.key, 10));
        };
        _this.onChangeLoadMessage = function (ev, option) {
            selectLoadMessageOnSignOnOption_1.default(option.key === 'true');
        };
        return _this;
    }
    ReadingPaneFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var readingPanePositionSelectedKey = "" + owa_options_core_1.getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact);
        var actionAfterMoveKey = optionState.nextSelection || userOptions.NextSelection;
        var showReadingPaneOnFirstLoadSelectedKey = "" + owa_options_core_1.getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad);
        // Account for the case where RP is not 'Off', but we should 'ReturnToView' after move/delete
        // This is done in the view to preserve the underlying selection if a users switches RP position back and forth
        if (readingPanePositionSelectedKey !== "" + ReadingPanePosition_1.default.Off &&
            actionAfterMoveKey === 'ReturnToView') {
            actionAfterMoveKey = 'Next';
        }
        var options = [
            {
                key: "" + ReadingPanePosition_1.default.Right,
                text: owa_options_strings_1.default.options_readingPane_positionRight,
                imageUri: READING_PANE_RIGHT_SVG,
                width: 280,
            },
            {
                key: "" + ReadingPanePosition_1.default.Bottom,
                text: owa_options_strings_1.default.options_readingPane_positionBottom,
                imageUri: READING_PANE_BOTTOM_SVG,
                width: 280,
            },
            {
                key: "" + ReadingPanePosition_1.default.Off,
                text: owa_options_strings_1.default.options_readingPane_positionHide,
                imageUri: READING_PANE_OFF_SVG,
                width: 280,
            },
        ];
        return (React.createElement("div", null,
            React.createElement(owa_choice_group_with_images_1.ChoiceGroupWithImages, { selectedKey: readingPanePositionSelectedKey, label: owa_options_strings_1.default.options_readingPane_positionLabel, options: options, onChange: this.onChangeReadingPane }),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: actionAfterMoveKey, label: owa_options_strings_1.default.options_readingPane_afterMove_title, options: [
                    {
                        key: 'Next',
                        text: owa_options_strings_1.default.options_readingPane_afterMove_next,
                    },
                    {
                        key: 'Previous',
                        text: owa_options_strings_1.default.options_readingPane_afterMove_previous,
                    },
                    {
                        key: 'ReturnToView',
                        text: owa_options_strings_1.default.options_readingPane_afterMove_returnToView,
                        disabled: readingPanePositionSelectedKey !== "" + ReadingPanePosition_1.default.Off,
                    },
                ], onChange: this.onAfterMoveActionChange }),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: showReadingPaneOnFirstLoadSelectedKey, label: owa_options_strings_1.default.options_readingPane_actionOnLoadLabel, options: [
                    {
                        key: 'true',
                        text: owa_options_strings_1.default.options_readingPane_actionOnLoadFirstItem,
                    },
                    {
                        key: 'false',
                        text: owa_options_strings_1.default.options_readingPane_actionOnLoadNoAction,
                    },
                ], onChange: this.onChangeLoadMessage })));
    };
    ReadingPaneFull = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
            optionState: function () { return store_1.default; },
        })
    ], ReadingPaneFull);
    return ReadingPaneFull;
}(React.Component));
exports.default = ReadingPaneFull;
//# sourceMappingURL=ReadingPaneFull.js.map

/***/ }),

/***/ 5116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2813);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectAfterMoveActionOption')(function selectAfterMoveActionOption(selection, state) {
    var optionState = state.optionState;
    optionState.nextSelection = selection;
}));
//# sourceMappingURL=selectAfterMoveActionOption.js.map

/***/ }),

/***/ 5117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2813);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectLoadMessageOnSignOnOption')(function selectLoadMessageOnSignOnOption(loadMessage, state) {
    var optionState = state.optionState;
    optionState.loadMessageOnLogOn = loadMessage;
}));
//# sourceMappingURL=selectLoadMessageOnSignOnOption.js.map

/***/ }),

/***/ 5118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2813);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectReadingPanePositionOption')(function selectReadingPanePositionOption(selection, state) {
    var optionState = state.optionState;
    optionState.readingPanePosition = selection;
}));
//# sourceMappingURL=selectReadingPanePositionOption.js.map

/***/ }),

/***/ 5119:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxOTIgMTI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxOTIgMTI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMDAwMDAwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30NCgkuc3Qxe2ZpbGw6I0M4QzhDODt9DQoJLnN0MntmaWxsOm5vbmU7c3Ryb2tlOiMwMTAxMDE7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KCS5zdDN7ZmlsbDojMDEwMTAxO30NCgkuc3Q0e2NsaXAtcGF0aDp1cmwoI1NWR0lEXzJfKTt9DQoJLnN0NXtjbGlwLXBhdGg6dXJsKCNTVkdJRF80Xyk7fQ0KCS5zdDZ7Y2xpcC1wYXRoOnVybCgjU1ZHSURfNl8pO30NCgkuc3Q3e2NsaXAtcGF0aDp1cmwoI1NWR0lEXzhfKTt9DQo8L3N0eWxlPg0KPGc+DQoJPHBhdGggZD0iTTE5MCwydjEyMEgyVjJIMTkwIE0xOTAsMEgyQzAuOSwwLDAsMC45LDAsMnYxMjBjMCwxLjEsMC45LDIsMiwyaDE4OGMxLjEsMCwyLTAuOSwyLTJWMkMxOTIsMC45LDE5MS4xLDAsMTkwLDBMMTkwLDB6Ii8+DQo8L2c+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNOTUsMzEuMiIvPg0KPHBhdGggY2xhc3M9InN0MCIgZD0iTTk1LDEwOC4yIi8+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNOTQsNDAiLz4NCjxyZWN0IHg9IjciIHk9IjIwIiBjbGFzcz0ic3QxIiB3aWR0aD0iMjciIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iNyIgeT0iMzAiIGNsYXNzPSJzdDEiIHdpZHRoPSIyNyIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSI3IiB5PSI0MCIgY2xhc3M9InN0MSIgd2lkdGg9IjI3IiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjciIHk9IjUwIiBjbGFzcz0ic3QxIiB3aWR0aD0iMjAiIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iNDAiIHk9IjUwLjUiIHdpZHRoPSI1Mi4xIiBoZWlnaHQ9IjE5LjUiLz4NCjxyZWN0IHg9IjkxIiB5PSIxMyIgd2lkdGg9IjIiIGhlaWdodD0iMTEwIi8+DQo8cmVjdCB4PSIzOSIgeT0iMTMiIHdpZHRoPSIyIiBoZWlnaHQ9IjExMCIvPg0KPHJlY3QgeD0iNDAiIHk9Ijg4IiB3aWR0aD0iNTIiIGhlaWdodD0iMiIvPg0KPHJlY3QgeD0iNDAiIHk9IjEwNyIgd2lkdGg9IjUyIiBoZWlnaHQ9IjIiLz4NCjxyZWN0IHg9IjQwIiB5PSIzMCIgd2lkdGg9IjUyIiBoZWlnaHQ9IjIiLz4NCjxyZWN0IHg9IjEiIHk9IjExIiB3aWR0aD0iMTkwIiBoZWlnaHQ9IjIiLz4NCjxyZWN0IHg9IjciIHk9IjY4IiBjbGFzcz0ic3QxIiB3aWR0aD0iMjciIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iNyIgeT0iNzgiIGNsYXNzPSJzdDEiIHdpZHRoPSIyNyIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSI3IiB5PSI4OCIgY2xhc3M9InN0MSIgd2lkdGg9IjI3IiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjciIHk9Ijk4IiBjbGFzcz0ic3QxIiB3aWR0aD0iMjAiIGhlaWdodD0iMyIvPg0KPHBhdGggY2xhc3M9InN0MiIgZD0iTTE5MSw0MCIvPg0KPHJlY3QgeD0iMTIwIiB5PSI0OCIgY2xhc3M9InN0MyIgd2lkdGg9IjU2IiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjEyMCIgeT0iNTciIGNsYXNzPSJzdDMiIHdpZHRoPSI0MiIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSIxMjAiIHk9Ijc2IiBjbGFzcz0ic3QzIiB3aWR0aD0iNTYiIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iMTIwIiB5PSI4NSIgY2xhc3M9InN0MyIgd2lkdGg9IjQyIiBoZWlnaHQ9IjMiLz4NCjxyZWN0IHg9IjEyMCIgeT0iMTAzIiBjbGFzcz0ic3QzIiB3aWR0aD0iNTYiIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iMTIwIiB5PSIxMTIiIGNsYXNzPSJzdDMiIHdpZHRoPSI0MiIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSI5MiIgeT0iNjgiIGNsYXNzPSJzdDMiIHdpZHRoPSI5OSIgaGVpZ2h0PSIyIi8+DQo8cmVjdCB4PSI5MiIgeT0iOTYiIGNsYXNzPSJzdDMiIHdpZHRoPSI5OSIgaGVpZ2h0PSIyIi8+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTA3LDYyTDEwNyw2MmMtMy45LDAtNy0zLjEtNy03bDAsMGMwLTMuOSwzLjEtNyw3LTdsMCwwYzMuOSwwLDcsMy4xLDcsN2wwLDBDMTE0LDU4LjksMTEwLjksNjIsMTA3LDYyeiIvPg0KCTxnPg0KCQk8Zz4NCgkJCTxnPg0KCQkJCTxnPg0KCQkJCQk8ZGVmcz4NCgkJCQkJCTxwYXRoIGlkPSJTVkdJRF8xXyIgZD0iTTEwNyw2MkwxMDcsNjJjLTMuOSwwLTctMy4xLTctN2wwLDBjMC0zLjksMy4xLTcsNy03bDAsMGMzLjksMCw3LDMuMSw3LDdsMCwwDQoJCQkJCQkJQzExNCw1OC45LDExMC45LDYyLDEwNyw2MnoiLz4NCgkJCQkJPC9kZWZzPg0KCQkJCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzJfIj4NCgkJCQkJCTx1c2UgeGxpbms6aHJlZj0iI1NWR0lEXzFfIiAgc3R5bGU9Im92ZXJmbG93OnZpc2libGU7Ii8+DQoJCQkJCTwvY2xpcFBhdGg+DQoJCQkJCTxnIGNsYXNzPSJzdDQiPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEwNyw1NS45TDEwNyw1NS45Yy0xLjQsMC0yLjYtMS4yLTIuNi0yLjZsMCwwYzAtMS40LDEuMi0yLjYsMi42LTIuNmwwLDBjMS40LDAsMi42LDEuMiwyLjYsMi42bDAsMA0KCQkJCQkJCUMxMDkuNiw1NC43LDEwOC40LDU1LjksMTA3LDU1Ljl6Ii8+DQoJCQkJCQk8cGF0aCBjbGFzcz0ic3QzIiBkPSJNMTA3LjYsNjQuNmgtMS4yYy0yLjEsMC0zLjgtMS43LTMuOC0zLjd2LTEuM2MwLTIuMSwxLjctMy43LDMuOC0zLjdoMS4yYzIuMSwwLDMuOCwxLjcsMy44LDMuN3YxLjMNCgkJCQkJCQlDMTExLjQsNjIuOSwxMDkuNyw2NC42LDEwNy42LDY0LjZ6Ii8+DQoJCQkJCTwvZz4NCgkJCQk8L2c+DQoJCQk8L2c+DQoJCTwvZz4NCgk8L2c+DQo8L2c+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTA3LDkwTDEwNyw5MGMtMy45LDAtNy0zLjEtNy03bDAsMGMwLTMuOSwzLjEtNyw3LTdsMCwwYzMuOSwwLDcsMy4xLDcsN2wwLDBDMTE0LDg2LjksMTEwLjksOTAsMTA3LDkweiIvPg0KCTxnPg0KCQk8Zz4NCgkJCTxnPg0KCQkJCTxnPg0KCQkJCQk8ZGVmcz4NCgkJCQkJCTxwYXRoIGlkPSJTVkdJRF8zXyIgZD0iTTEwNyw5MEwxMDcsOTBjLTMuOSwwLTctMy4xLTctN2wwLDBjMC0zLjksMy4xLTcsNy03bDAsMGMzLjksMCw3LDMuMSw3LDdsMCwwDQoJCQkJCQkJQzExNCw4Ni45LDExMC45LDkwLDEwNyw5MHoiLz4NCgkJCQkJPC9kZWZzPg0KCQkJCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzRfIj4NCgkJCQkJCTx1c2UgeGxpbms6aHJlZj0iI1NWR0lEXzNfIiAgc3R5bGU9Im92ZXJmbG93OnZpc2libGU7Ii8+DQoJCQkJCTwvY2xpcFBhdGg+DQoJCQkJCTxnIGNsYXNzPSJzdDUiPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEwNyw4My45TDEwNyw4My45Yy0xLjQsMC0yLjYtMS4yLTIuNi0yLjZsMCwwYzAtMS40LDEuMi0yLjYsMi42LTIuNmwwLDBjMS40LDAsMi42LDEuMiwyLjYsMi42bDAsMA0KCQkJCQkJCUMxMDkuNiw4Mi43LDEwOC40LDgzLjksMTA3LDgzLjl6Ii8+DQoJCQkJCQk8cGF0aCBjbGFzcz0ic3QzIiBkPSJNMTA3LjYsOTIuNmgtMS4yYy0yLjEsMC0zLjgtMS43LTMuOC0zLjh2LTEuMmMwLTIuMSwxLjctMy44LDMuOC0zLjhoMS4yYzIuMSwwLDMuOCwxLjcsMy44LDMuOHYxLjINCgkJCQkJCQlDMTExLjQsOTAuOSwxMDkuNyw5Mi42LDEwNy42LDkyLjZ6Ii8+DQoJCQkJCTwvZz4NCgkJCQk8L2c+DQoJCQk8L2c+DQoJCTwvZz4NCgk8L2c+DQo8L2c+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTA3LDExN0wxMDcsMTE3Yy0zLjksMC03LTMuMS03LTdsMCwwYzAtMy45LDMuMS03LDctN2wwLDBjMy45LDAsNywzLjEsNyw3bDAsMEMxMTQsMTEzLjksMTEwLjksMTE3LDEwNywxMTd6DQoJCSIvPg0KCTxnPg0KCQk8Zz4NCgkJCTxnPg0KCQkJCTxnPg0KCQkJCQk8ZGVmcz4NCgkJCQkJCTxwYXRoIGlkPSJTVkdJRF81XyIgZD0iTTEwNywxMTdMMTA3LDExN2MtMy45LDAtNy0zLjEtNy03bDAsMGMwLTMuOSwzLjEtNyw3LTdsMCwwYzMuOSwwLDcsMy4xLDcsN2wwLDANCgkJCQkJCQlDMTE0LDExMy45LDExMC45LDExNywxMDcsMTE3eiIvPg0KCQkJCQk8L2RlZnM+DQoJCQkJCTxjbGlwUGF0aCBpZD0iU1ZHSURfNl8iPg0KCQkJCQkJPHVzZSB4bGluazpocmVmPSIjU1ZHSURfNV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4NCgkJCQkJPC9jbGlwUGF0aD4NCgkJCQkJPGcgY2xhc3M9InN0NiI+DQoJCQkJCQk8cGF0aCBjbGFzcz0ic3QzIiBkPSJNMTA3LDExMC45TDEwNywxMTAuOWMtMS40LDAtMi42LTEuMi0yLjYtMi42bDAsMGMwLTEuNCwxLjItMi42LDIuNi0yLjZsMCwwYzEuNCwwLDIuNiwxLjIsMi42LDIuNmwwLDANCgkJCQkJCQlDMTA5LjYsMTA5LjcsMTA4LjQsMTEwLjksMTA3LDExMC45eiIvPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEwNy42LDExOS42aC0xLjJjLTIuMSwwLTMuOC0xLjctMy44LTMuOHYtMS4yYzAtMi4xLDEuNy0zLjgsMy44LTMuOGgxLjJjMi4xLDAsMy44LDEuNywzLjgsMy44djEuMg0KCQkJCQkJCUMxMTEuNCwxMTcuOSwxMDkuNywxMTkuNiwxMDcuNiwxMTkuNnoiLz4NCgkJCQkJPC9nPg0KCQkJCTwvZz4NCgkJCTwvZz4NCgkJPC9nPg0KCTwvZz4NCjwvZz4NCjxyZWN0IHg9IjEyMCIgeT0iMjAiIGNsYXNzPSJzdDMiIHdpZHRoPSI1NiIgaGVpZ2h0PSIzIi8+DQo8cmVjdCB4PSIxMjAiIHk9IjI5IiBjbGFzcz0ic3QzIiB3aWR0aD0iNDIiIGhlaWdodD0iMyIvPg0KPHJlY3QgeD0iOTIiIHk9IjQwIiBjbGFzcz0ic3QzIiB3aWR0aD0iOTkiIGhlaWdodD0iMiIvPg0KPGc+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTEwNywzNEwxMDcsMzRjLTMuOSwwLTctMy4xLTctN2wwLDBjMC0zLjksMy4xLTcsNy03bDAsMGMzLjksMCw3LDMuMSw3LDdsMCwwQzExNCwzMC45LDExMC45LDM0LDEwNywzNHoiLz4NCgk8Zz4NCgkJPGc+DQoJCQk8Zz4NCgkJCQk8Zz4NCgkJCQkJPGRlZnM+DQoJCQkJCQk8cGF0aCBpZD0iU1ZHSURfN18iIGQ9Ik0xMDcsMzRMMTA3LDM0Yy0zLjksMC03LTMuMS03LTdsMCwwYzAtMy45LDMuMS03LDctN2wwLDBjMy45LDAsNywzLjEsNyw3bDAsMA0KCQkJCQkJCUMxMTQsMzAuOSwxMTAuOSwzNCwxMDcsMzR6Ii8+DQoJCQkJCTwvZGVmcz4NCgkJCQkJPGNsaXBQYXRoIGlkPSJTVkdJRF84XyI+DQoJCQkJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF83XyIgIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPg0KCQkJCQk8L2NsaXBQYXRoPg0KCQkJCQk8ZyBjbGFzcz0ic3Q3Ij4NCgkJCQkJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0xMDcsMjcuOUwxMDcsMjcuOWMtMS40LDAtMi42LTEuMi0yLjYtMi42bDAsMGMwLTEuNCwxLjItMi42LDIuNi0yLjZsMCwwYzEuNCwwLDIuNiwxLjIsMi42LDIuNmwwLDANCgkJCQkJCQlDMTA5LjYsMjYuNywxMDguNCwyNy45LDEwNywyNy45eiIvPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEwNy42LDM2LjZoLTEuMmMtMi4xLDAtMy44LTEuNy0zLjgtMy43di0xLjNjMC0yLjEsMS43LTMuNywzLjgtMy43aDEuMmMyLjEsMCwzLjgsMS43LDMuOCwzLjd2MS4zDQoJCQkJCQkJQzExMS40LDM0LjksMTA5LjcsMzYuNiwxMDcuNiwzNi42eiIvPg0KCQkJCQk8L2c+DQoJCQkJPC9nPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 5120:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 5121:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 5122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2813);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardReadingPaneOption')(function discardReadingPaneOption(state) {
    var optionState = state.optionState;
    optionState.readingPanePosition = null;
    optionState.nextSelection = null;
    optionState.loadMessageOnLogOn = null;
}));
//# sourceMappingURL=discardReadingPaneOption.js.map

/***/ }),

/***/ 5123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(2813);
var legacy_1 = __webpack_require__(1);
var owa_session_store_1 = __webpack_require__(151);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isReadingPaneOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var readingPanePositionSelected = owa_options_core_1.getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact);
    var actionAfterMoveKey = optionState.nextSelection || userOptions.NextSelection;
    var showReadingPaneOnFirstLoadSelected = owa_options_core_1.getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad);
    return (readingPanePositionSelected !== userOptions.GlobalReadingPanePositionReact ||
        actionAfterMoveKey !== userOptions.NextSelection ||
        showReadingPaneOnFirstLoadSelected !== userOptions.ShowReadingPaneOnFirstLoad);
});
//# sourceMappingURL=isReadingPaneOptionDirty.js.map

/***/ }),

/***/ 5124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var SenderSubjectFull_1 = __webpack_require__(5125);
var discardSenderSubjectOption_1 = __webpack_require__(5127);
var saveSenderSubjectOption_1 = __webpack_require__(5128);
var isSenderSubjectOptionDirty_1 = __webpack_require__(5129);
var SenderSubjectOption = {
    key: 'senderSubject',
    titleStringKey: 'optionTitle_senderSubjectOrder',
    searchTermsStringKey: 'optionTitle_senderSubjectOrder',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SenderSubjectFull_1.default, null); },
        isDirty: isSenderSubjectOptionDirty_1.default,
        onSave: saveSenderSubjectOption_1.default,
        onDiscard: discardSenderSubjectOption_1.default,
    },
};
exports.default = SenderSubjectOption;
//# sourceMappingURL=SenderSubjectOption.js.map

/***/ }),

/***/ 5125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectSenderOnTopOption_1 = __webpack_require__(5126);
var store_1 = __webpack_require__(3073);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var MessageListFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageListFull, _super);
    function MessageListFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSenderOnTopChange = function (ev, option) {
            selectSenderOnTopOption_1.default(option.key === 'true');
        };
        return _this;
    }
    MessageListFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var senderOnTop = owa_options_core_1.getFallbackValueIfNull(optionStore.showSenderOnTopInListView, userOptions.ShowSenderOnTopInListView);
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + senderOnTop, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_messageList_firstLineSender,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_messageList_firstLineSubject,
                },
            ], onChange: this.onSenderOnTopChange, label: owa_options_strings_1.default.options_messageList_firstLineLabel }));
    };
    MessageListFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MessageListFull);
    return MessageListFull;
}(React.Component));
exports.default = MessageListFull;
//# sourceMappingURL=SenderSubjectFull.js.map

/***/ }),

/***/ 5126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3073);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectSenderOnTopOption')(function selectSenderOnTopOption(senderOnTop, state) {
    var optionState = state.optionState;
    optionState.showSenderOnTopInListView = senderOnTop;
}));
//# sourceMappingURL=selectSenderOnTopOption.js.map

/***/ }),

/***/ 5127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3073);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardSenderSubjectOption')(function discardSenderSubjectOption(state) {
    var optionState = state.optionState;
    optionState.showSenderOnTopInListView = null;
}));
//# sourceMappingURL=discardSenderSubjectOption.js.map

/***/ }),

/***/ 5128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3073);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_core_2 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveSenderSubjectOption')(function saveSenderSubjectOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.ShowSenderOnTopInListView = owa_options_core_1.getFallbackValueIfNull(optionState.showSenderOnTopInListView, userOptions.ShowSenderOnTopInListView);
                    return [4 /*yield*/, owa_options_core_2.updateUserConfiguration([
                            {
                                propertyName: 'ShowSenderOnTopInListView',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.ShowSenderOnTopInListView,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSenderSubjectOption.js.map

/***/ }),

/***/ 5129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3073);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMessageListOptionDirty(state) {
    var savedOptions = state.userOptions;
    var showSenderOnTopInListView = owa_options_core_1.getFallbackValueIfNull(state.optionState.showSenderOnTopInListView, savedOptions.ShowSenderOnTopInListView);
    return showSenderOnTopInListView !== savedOptions.ShowSenderOnTopInListView;
});
//# sourceMappingURL=isSenderSubjectOptionDirty.js.map

/***/ }),

/***/ 5130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var QuickSuggestionsOption_1 = __webpack_require__(5131);
var LinkPreviewOption_1 = __webpack_require__(5137);
var MessageFormatOption_1 = __webpack_require__(5146);
var messageContentSubcategory = {
    key: 'messageContent',
    titleStringKey: 'optionSubcategory_messageContent',
    options: [MessageFormatOption_1.default, LinkPreviewOption_1.default, QuickSuggestionsOption_1.default],
};
exports.default = messageContentSubcategory;
//# sourceMappingURL=messageContentSubcategory.js.map

/***/ }),

/***/ 5131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var QuickSuggestionsFull_1 = __webpack_require__(5132);
var isQuickSuggestionsOptionDirty_1 = __webpack_require__(5134);
var discardQuickSuggestionOption_1 = __webpack_require__(5135);
var saveQuickSuggestionOption_1 = __webpack_require__(5136);
var QuickSuggestionsOption = {
    key: 'quickSuggestions',
    titleStringKey: 'optionTitle_quickSuggestions',
    searchTermsStringKey: 'optionTitle_quickSuggestions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(QuickSuggestionsFull_1.default, null); },
        isDirty: isQuickSuggestionsOptionDirty_1.default,
        onSave: saveQuickSuggestionOption_1.default,
        onDiscard: discardQuickSuggestionOption_1.default,
    },
};
exports.default = QuickSuggestionsOption;
//# sourceMappingURL=QuickSuggestionsOption.js.map

/***/ }),

/***/ 5132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3074);
var owa_options_controls_1 = __webpack_require__(2661);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_outlook_service_options_1 = __webpack_require__(2110);
var selectQuickSuggestionOption_1 = __webpack_require__(5133);
var owa_options_core_1 = __webpack_require__(1736);
var QuickSuggestionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(QuickSuggestionsFull, _super);
    function QuickSuggestionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuickSuggestionsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
        var useLocation = owa_options_core_1.getFallbackValueIfNull(optionStore.browserLocationEnabled, userOptions.browserLocationEnabled);
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_mail_quickSuggestionsDescription),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: isEnabled, label: owa_options_strings_1.default.options_mail_quickSuggestionsEnable, onChange: this.toggleEnable }),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { disabled: !isEnabled, checked: useLocation, label: owa_options_strings_1.default.options_mail_quickSuggestionsLocation, onChange: this.toggleLocation })));
    };
    QuickSuggestionsFull.prototype.toggleEnable = function (ev, checked) {
        selectQuickSuggestionOption_1.default('smartSuggestionsEnabled', checked);
    };
    QuickSuggestionsFull.prototype.toggleLocation = function (ev, checked) {
        selectQuickSuggestionOption_1.default('browserLocationEnabled', checked);
    };
    QuickSuggestionsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () {
                return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SmartSuggestions);
            },
        })
    ], QuickSuggestionsFull);
    return QuickSuggestionsFull;
}(React.Component));
exports.default = QuickSuggestionsFull;
//# sourceMappingURL=QuickSuggestionsFull.js.map

/***/ }),

/***/ 5133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3074);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectQuickSuggestionOption')(function selectQuickSuggestionOption(option, choice, state) {
    var optionState = state.optionState;
    optionState[option] = choice;
}));
//# sourceMappingURL=selectQuickSuggestionOption.js.map

/***/ }),

/***/ 5134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3074);
var legacy_1 = __webpack_require__(1);
var owa_outlook_service_options_1 = __webpack_require__(2110);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SmartSuggestions);
    },
})(function isQuickSuggestionsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var smartSuggestionsEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
    var browserLocationEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.browserLocationEnabled, userOptions.browserLocationEnabled);
    return (smartSuggestionsEnabled !== userOptions.smartSuggestionsEnabled ||
        browserLocationEnabled !== userOptions.browserLocationEnabled);
});
//# sourceMappingURL=isQuickSuggestionsOptionDirty.js.map

/***/ }),

/***/ 5135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3074);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardQuickSuggestionOption')(function discardQuickSuggestionOption(state) {
    var optionState = state.optionState;
    optionState.smartSuggestionsEnabled = null;
    optionState.browserLocationEnabled = null;
}));
//# sourceMappingURL=discardQuickSuggestionOption.js.map

/***/ }),

/***/ 5136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3074);
var owa_options_core_1 = __webpack_require__(1736);
var owa_outlook_service_options_1 = __webpack_require__(2110);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SmartSuggestions);
    },
})(legacy_1.action('saveQuickSuggestionOption')(function saveQuickSuggestionOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.smartSuggestionsEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
                    userOptions.browserLocationEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.browserLocationEnabled, userOptions.browserLocationEnabled);
                    return [4 /*yield*/, owa_outlook_service_options_1.lazyCreateOrUpdateOptionsForFeature.importAndExecute(owa_outlook_service_options_1.OwsOptionsFeatureType.SmartSuggestions, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveQuickSuggestionOption.js.map

/***/ }),

/***/ 5137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var LinkPreviewFull_1 = __webpack_require__(5138);
var isLinkPreviewOptionDirty_1 = __webpack_require__(5143);
var discardLinkPreviewOption_1 = __webpack_require__(5144);
var saveLinkPreviewOption_1 = __webpack_require__(5145);
var LinkPreviewOption = {
    key: 'linkPreview',
    titleStringKey: 'optionTitle_linkPreview',
    searchTermsStringKey: 'optionTitle_linkPreview',
    fullOptionFormSettings: {
        render: function () { return React.createElement(LinkPreviewFull_1.default, null); },
        isDirty: isLinkPreviewOptionDirty_1.default,
        onSave: saveLinkPreviewOption_1.default,
        onDiscard: discardLinkPreviewOption_1.default,
    },
};
exports.default = LinkPreviewOption;
//# sourceMappingURL=LinkPreviewOption.js.map

/***/ }),

/***/ 5138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3075);
var owa_options_controls_1 = __webpack_require__(2661);
var HelpLink_1 = __webpack_require__(5139);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_core_1 = __webpack_require__(1736);
var selectLinkPreviewIsEnabledOption_1 = __webpack_require__(5142);
var LinkPreviewFull = /** @class */ (function (_super) {
    tslib_1.__extends(LinkPreviewFull, _super);
    function LinkPreviewFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinkPreviewFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.isEnabled, userOptions.LinkPreviewEnabled);
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null,
                owa_options_strings_1.default.options_mail_linkPreviewDescription,
                "\u00A0",
                React.createElement(HelpLink_1.default, { helpId: "LinkPreview" })),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: isEnabled, label: owa_options_strings_1.default.options_mail_linkPreviewCheckboxLabel, onChange: this.toggleEnable })));
    };
    LinkPreviewFull.prototype.toggleEnable = function (ev, checked) {
        selectLinkPreviewIsEnabledOption_1.default(checked);
    };
    LinkPreviewFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], LinkPreviewFull);
    return LinkPreviewFull;
}(React.Component));
exports.default = LinkPreviewFull;
//# sourceMappingURL=LinkPreviewFull.js.map

/***/ }),

/***/ 5139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var Link_1 = __webpack_require__(2118);
var owa_help_1 = __webpack_require__(5140);
var owa_options_strings_1 = __webpack_require__(1737);
var HELP_WINDOW_NAME = 'o365Help';
var HELP_WINDOW_OPTIONS = 'width=400,height=500,menubar=no,status=no,scrollbars=no,titlebar=no,toolbar=no,resizable=yes';
var HelpLink = /** @class */ (function (_super) {
    tslib_1.__extends(HelpLink, _super);
    function HelpLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHelpLink = function (ev) {
            ev.preventDefault();
            window.open(owa_help_1.getHelpUrl(_this.props.helpId), HELP_WINDOW_NAME, HELP_WINDOW_OPTIONS);
        };
        return _this;
    }
    HelpLink.prototype.render = function () {
        return (React.createElement(Link_1.Link, { href: owa_help_1.getHelpUrl(this.props.helpId), target: HELP_WINDOW_NAME, onClick: this.onHelpLink }, owa_options_strings_1.default.options_mail_linkPreviewHelpLink));
    };
    HelpLink = tslib_1.__decorate([
        mobx_react_1.observer
    ], HelpLink);
    return HelpLink;
}(React.Component));
exports.default = HelpLink;
//# sourceMappingURL=HelpLink.js.map

/***/ }),

/***/ 5140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getHelpUrl_1 = __webpack_require__(5141);
exports.getHelpUrl = getHelpUrl_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_session_store_1 = __webpack_require__(151);
var owa_strings_1 = __webpack_require__(20);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    helpUrlFormatString: function () { return owa_session_store_1.getUserConfiguration().SessionSettings.HelpUrl; },
})(function getHelpUrl(helpId, state) {
    return owa_strings_1.format(state.helpUrlFormatString, helpId);
});
//# sourceMappingURL=getHelpUrl.js.map

/***/ }),

/***/ 5142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3075);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectLinkPreviewIsEnabledOption')(function selectLinkPreviewIsEnabledOption(isLinkPreviewEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isLinkPreviewEnabled;
}));
//# sourceMappingURL=selectLinkPreviewIsEnabledOption.js.map

/***/ }),

/***/ 5143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3075);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isLinkPreviewOptionDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled !== state.userOptions.LinkPreviewEnabled);
});
//# sourceMappingURL=isLinkPreviewOptionDirty.js.map

/***/ }),

/***/ 5144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3075);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardLinkPreviewOption')(function discardLinkPreviewOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardLinkPreviewOption.js.map

/***/ }),

/***/ 5145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3075);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveLinkPreviewOption')(function saveLinkPreviewOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.LinkPreviewEnabled = optionState.isEnabled;
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'LinkPreviewEnabled',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.LinkPreviewEnabled,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveLinkPreviewOption.js.map

/***/ }),

/***/ 5146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var MessageFormatFull_1 = __webpack_require__(5147);
var isMessageFormatOptionDirty_1 = __webpack_require__(5158);
var discardMessageFormatOption_1 = __webpack_require__(5159);
var saveMessageFormatOption_1 = __webpack_require__(5160);
var MessageFormatOption = {
    key: 'messageFormat',
    titleStringKey: 'optionTitle_messageFormat',
    searchTermsStringKey: 'optionTitle_messageFormat',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessageFormatFull_1.default, null); },
        isDirty: isMessageFormatOptionDirty_1.default,
        onSave: saveMessageFormatOption_1.default,
        onDiscard: discardMessageFormatOption_1.default,
    },
};
exports.default = MessageFormatOption;
//# sourceMappingURL=MessageFormatOption.js.map

/***/ }),

/***/ 5147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ComposeStyles_1 = __webpack_require__(5148);
var selectComposeFormatOption_1 = __webpack_require__(5156);
var selectShowRecipientWellOption_1 = __webpack_require__(5157);
var store_1 = __webpack_require__(2685);
var owa_options_controls_1 = __webpack_require__(2661);
var Dropdown_1 = __webpack_require__(2652);
var owa_options_core_1 = __webpack_require__(1736);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var styles = __webpack_require__(3383);
var MessageFormatFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageFormatFull, _super);
    function MessageFormatFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageFormatFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var showBcc = owa_options_core_1.getFallbackValueIfNull(optionStore.showBcc, userOptions.AlwaysShowBcc);
        var showFrom = owa_options_core_1.getFallbackValueIfNull(optionStore.showFrom, userOptions.AlwaysShowFrom);
        var messageFormat = owa_options_core_1.getFallbackValueIfNull(optionStore.composeFormat, userOptions.ComposeMarkup);
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.showRecipientWellOptions },
                React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: showBcc, label: owa_options_strings_1.default.options_format_showBcc, onChange: this.onShowBccChanged }),
                React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: showFrom, label: owa_options_strings_1.default.options_format_showFrom, onChange: this.onShowFromChanged })),
            React.createElement("div", { className: styles.formatDropDownDiv },
                React.createElement("span", null, owa_options_strings_1.default.options_format_formatLabel_front),
                React.createElement(Dropdown_1.Dropdown, { selectedKey: messageFormat, options: [
                        {
                            key: 'Html',
                            text: owa_options_strings_1.default.options_format_dropdown_html,
                        },
                        {
                            key: 'PlainText',
                            text: owa_options_strings_1.default.options_format_dropdown_plaintext,
                        },
                    ], onChanged: this.onComposeFormatChanged }),
                React.createElement("span", null, owa_options_strings_1.default.options_format_formatLabel_back)),
            React.createElement(ComposeStyles_1.default, null)));
    };
    MessageFormatFull.prototype.onShowBccChanged = function (ev, checked) {
        selectShowRecipientWellOption_1.default('showBcc', checked);
    };
    MessageFormatFull.prototype.onShowFromChanged = function (ev, checked) {
        selectShowRecipientWellOption_1.default('showFrom', checked);
    };
    MessageFormatFull.prototype.onComposeFormatChanged = function (option, index) {
        selectComposeFormatOption_1.default(option.key);
    };
    MessageFormatFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MessageFormatFull);
    return MessageFormatFull;
}(React.Component));
exports.default = MessageFormatFull;
//# sourceMappingURL=MessageFormatFull.js.map

/***/ }),

/***/ 5148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(2685);
var owa_options_core_1 = __webpack_require__(1736);
var Dropdown_1 = __webpack_require__(2652);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_format_options_1 = __webpack_require__(2132);
var getDefaultComposeFormat_1 = __webpack_require__(2188);
var FormatButton_1 = __webpack_require__(3740);
var ColorPickerButton_1 = __webpack_require__(5150);
var selectFontFamilyOption_1 = __webpack_require__(5152);
var selectFontSizeOption_1 = __webpack_require__(5153);
var selectFormattingOption_1 = __webpack_require__(5154);
var selectTextColorOption_1 = __webpack_require__(5155);
var owa_options_controls_1 = __webpack_require__(2661);
var styles = __webpack_require__(3383);
var ComposeStyles = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeStyles, _super);
    function ComposeStyles(props) {
        var _this = _super.call(this, props) || this;
        var dividerIndex = 0;
        _this.fontNameItems = owa_format_options_1.FONT_NAME_LIST.map(function (font) {
            if (font.name === '-') {
                return {
                    key: "divider_" + dividerIndex++,
                    itemType: Dropdown_1.DropdownMenuItemType.Divider,
                    text: '-',
                };
            }
            else {
                return {
                    key: font.name,
                    text: font.name,
                };
            }
        });
        _this.fontSizeItems = owa_format_options_1.FONT_SIZES.map(function (size, index) { return ({
            key: owa_format_options_1.getFontSizeFromSizeOrIndex(size),
            text: owa_format_options_1.getFontSizeInPoints(size),
        }); });
        return _this;
    }
    ComposeStyles.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var defaultFontFamily = owa_options_core_1.getFallbackValueIfNull(optionStore.fontFamily, userOptions.ComposeFontName);
        var defaultFontSize = owa_options_core_1.getFallbackValueIfNull(owa_format_options_1.getFontSizeFromSizeOrIndex(optionStore.fontSize), owa_format_options_1.getFontSizeFromSizeOrIndex(userOptions.ComposeFontSize));
        var isBold = owa_options_core_1.getFallbackValueIfNull(optionStore.isFontBold, (userOptions.ComposeFontFlags & 1 /* Bold */) === 1 /* Bold */);
        var isItalic = owa_options_core_1.getFallbackValueIfNull(optionStore.isFontItalic, (userOptions.ComposeFontFlags & 2 /* Italic */) === 2 /* Italic */);
        var isUnderline = owa_options_core_1.getFallbackValueIfNull(optionStore.isFontUnderline, (userOptions.ComposeFontFlags & 4 /* Underline */) === 4 /* Underline */);
        var textStyles = this.getFormatStyles(defaultFontFamily, defaultFontSize, owa_options_core_1.getFallbackValueIfNull(optionStore.fontColor, userOptions.ComposeFontColor), isBold, isItalic, isUnderline);
        return (React.createElement("div", { className: styles.textFormat },
            React.createElement("div", { className: styles.formatBar },
                React.createElement(Dropdown_1.Dropdown, { selectedKey: defaultFontFamily, options: this.fontNameItems, className: styles.fontDropDown, onChanged: this.onFontFamilyChanged }),
                React.createElement(Dropdown_1.Dropdown, { selectedKey: defaultFontSize, options: this.fontSizeItems, className: styles.sizeDropDown, onChanged: this.onFontSizeChanged }),
                React.createElement(FormatButton_1.default, { type: "bold", isSelected: isBold, onClick: this.onBoldClicked }),
                React.createElement(FormatButton_1.default, { type: "italic", isSelected: isItalic, onClick: this.onItalicClicked }),
                React.createElement(FormatButton_1.default, { type: "underline", isSelected: isUnderline, onClick: this.onUnderlineClicked }),
                React.createElement(ColorPickerButton_1.default, { onSelectColor: selectTextColorOption_1.default })),
            React.createElement("div", { className: styles.sampleText, style: textStyles },
                React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_format_sampleText_1),
                React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_format_sampleText_2))));
    };
    ComposeStyles.prototype.onFontFamilyChanged = function (option, index) {
        selectFontFamilyOption_1.default(option.key);
    };
    ComposeStyles.prototype.onFontSizeChanged = function (option, index) {
        selectFontSizeOption_1.default(option.key);
    };
    ComposeStyles.prototype.onBoldClicked = function (isSelected) {
        selectFormattingOption_1.default('isFontBold', isSelected);
    };
    ComposeStyles.prototype.onItalicClicked = function (isSelected) {
        selectFormattingOption_1.default('isFontItalic', isSelected);
    };
    ComposeStyles.prototype.onUnderlineClicked = function (isSelected) {
        selectFormattingOption_1.default('isFontUnderline', isSelected);
    };
    ComposeStyles.prototype.getFormatStyles = function (fontFamily, fontSize, fontColor, isBold, isItalic, isUnderline) {
        var composeFormat = getDefaultComposeFormat_1.getComposeFormat(fontFamily, fontSize, fontColor, 0);
        return {
            fontFamily: composeFormat.fontFamily,
            fontSize: composeFormat.fontSize,
            color: composeFormat.textColor,
            fontWeight: isBold ? 'bold' : undefined,
            fontStyle: isItalic ? 'italic' : undefined,
            textDecoration: isUnderline ? 'underline' : undefined,
        };
    };
    ComposeStyles = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ComposeStyles);
    return ComposeStyles;
}(React.Component));
exports.default = ComposeStyles;
//# sourceMappingURL=ComposeStyles.js.map

/***/ }),

/***/ 5149:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] .YOWLQEquenYckbiXL1eyj{margin-top:-6px;margin-bottom:16px}._3ktM8BB3Ksz28jHVrmCB2q{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3ktM8BB3Ksz28jHVrmCB2q .ms-Dropdown-container{display:inline-block}html[dir] ._3ktM8BB3Ksz28jHVrmCB2q .ms-Dropdown-container{margin:0 8px}html[dir] ._3ktM8BB3Ksz28jHVrmCB2q .ms-Dropdown-container .ms-Dropdown{margin:0}._1sME0J6-gjN_rNv5AbRPIe{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}html[dir] ._1sME0J6-gjN_rNv5AbRPIe{margin-top:20px;background-color:\"[theme:white, default:#ffffff]\"}._1sME0J6-gjN_rNv5AbRPIe ._2OPI_INCUmMEuNa11XCABL{min-width:300px;color:\"[theme:black, default:#000000]\"}html[dir=ltr] ._1sME0J6-gjN_rNv5AbRPIe ._2OPI_INCUmMEuNa11XCABL{margin-right:8px}html[dir=rtl] ._1sME0J6-gjN_rNv5AbRPIe ._2OPI_INCUmMEuNa11XCABL{margin-left:8px}._1sME0J6-gjN_rNv5AbRPIe .J0gpVmJKQw7j1vse9fM1G{min-width:100px;color:\"[theme:black, default:#000000]\"}html[dir=ltr] ._1sME0J6-gjN_rNv5AbRPIe .J0gpVmJKQw7j1vse9fM1G{margin-right:10px}html[dir=rtl] ._1sME0J6-gjN_rNv5AbRPIe .J0gpVmJKQw7j1vse9fM1G{margin-left:10px}html[dir] ._8avB61l1fNrFQUJUjL1hj{margin-top:10px;background-color:#fff}html[dir=ltr] ._8avB61l1fNrFQUJUjL1hj{padding:1px 0 1px 19px;border-left:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir=rtl] ._8avB61l1fNrFQUJUjL1hj{padding:1px 19px 1px 0;border-right:1px solid \"[theme:neutralLight, default:#eaeaea]\"}._8avB61l1fNrFQUJUjL1hj p{font-family:inherit!important;font-weight:inherit!important;font-size:inherit!important;color:inherit!important}html[dir] ._8avB61l1fNrFQUJUjL1hj p:last-child{margin-bottom:0}._2y22VP-1-AgmiXa3k4324i{font-size:22px;width:30px;height:30px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir] ._2y22VP-1-AgmiXa3k4324i{background-color:#fff}html[dir=ltr] ._2y22VP-1-AgmiXa3k4324i{margin-right:5px}html[dir=rtl] ._2y22VP-1-AgmiXa3k4324i{margin-left:5px}html[dir] ._2y22VP-1-AgmiXa3k4324i:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}html[dir] ._2y22VP-1-AgmiXa3k4324i.tdvd_BoEPYl4aVCz_hl6s{background-color:\"[theme:themeLight, default:#C7E0F4]\"}", ""]);

// exports
exports.locals = {
	"showRecipientWellOptions": "YOWLQEquenYckbiXL1eyj",
	"formatDropDownDiv": "_3ktM8BB3Ksz28jHVrmCB2q",
	"formatBar": "_1sME0J6-gjN_rNv5AbRPIe",
	"fontDropDown": "_2OPI_INCUmMEuNa11XCABL",
	"sizeDropDown": "J0gpVmJKQw7j1vse9fM1G",
	"sampleText": "_8avB61l1fNrFQUJUjL1hj",
	"formatButton": "_2y22VP-1-AgmiXa3k4324i",
	"isSelected": "tdvd_BoEPYl4aVCz_hl6s"
};

/***/ }),

/***/ 5150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var FormatButton_1 = __webpack_require__(3740);
var toggleColorMenuIsShown_1 = __webpack_require__(5151);
var store_1 = __webpack_require__(2685);
var owa_color_picker_1 = __webpack_require__(3312);
var owa_session_store_1 = __webpack_require__(151);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var react_1 = __webpack_require__(1546);
var ColorPickerButton = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPickerButton, _super);
    function ColorPickerButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectColor = function (value) {
            _this.props.onSelectColor(value.code);
        };
        return _this;
    }
    ColorPickerButton.prototype.render = function () {
        var _this = this;
        var isShown = this.props.optionStore.isColorMenuShown;
        return (React.createElement("div", null,
            React.createElement(FormatButton_1.default, { type: "textcolor", isSelected: false, ref: function (ref) { return (_this.anchorButton = ReactDOM.findDOMNode(ref)); }, onClick: isShown ? this.onDismissMenu : this.onShowMenu }),
            isShown && (React.createElement(owa_color_picker_1.ColorPicker, { menuTargetElement: this.anchorButton, colors: owa_color_picker_1.textColors.get(), onDismissMenu: this.onDismissMenu, onSelectColor: this.onSelectColor, shouldFocusOnMount: true }))));
    };
    ColorPickerButton.prototype.onShowMenu = function () {
        toggleColorMenuIsShown_1.default(true);
    };
    ColorPickerButton.prototype.onDismissMenu = function () {
        toggleColorMenuIsShown_1.default(false);
    };
    ColorPickerButton = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ColorPickerButton);
    return ColorPickerButton;
}(React.Component));
exports.default = ColorPickerButton;
//# sourceMappingURL=ColorPickerButton.js.map

/***/ }),

/***/ 5151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('toggleColorMenuIsShown')(function toggleColorMenuIsShown(isShown, state) {
    var optionState = state.optionState;
    optionState.isColorMenuShown = isShown;
}));
//# sourceMappingURL=toggleColorMenuIsShown.js.map

/***/ }),

/***/ 5152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectFontFamilyOption')(function selectFontFamilyOption(fontFamily, state) {
    var optionState = state.optionState;
    optionState.fontFamily = fontFamily;
}));
//# sourceMappingURL=selectFontFamilyOption.js.map

/***/ }),

/***/ 5153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectFontSizeOption')(function selectFontSizeOption(fontSize, state) {
    var optionState = state.optionState;
    optionState.fontSize = fontSize;
}));
//# sourceMappingURL=selectFontSizeOption.js.map

/***/ }),

/***/ 5154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectFormattingOption')(function selectFormattingOption(formatOption, isSet, state) {
    var optionState = state.optionState;
    optionState[formatOption] = isSet;
}));
//# sourceMappingURL=selectFormattingOption.js.map

/***/ }),

/***/ 5155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectTextColorOption')(function selectTextColorOption(color, state) {
    var optionState = state.optionState;
    optionState.fontColor = color;
}));
//# sourceMappingURL=selectTextColorOption.js.map

/***/ }),

/***/ 5156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectComposeFormatOption')(function selectComposeFormatOption(value, state) {
    var optionState = state.optionState;
    optionState.composeFormat = value;
}));
//# sourceMappingURL=selectComposeFormatOption.js.map

/***/ }),

/***/ 5157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectShowRecipientWellOption')(function selectShowRecipientWellOption(field, isChecked, state) {
    var optionState = state.optionState;
    optionState[field] = isChecked;
}));
//# sourceMappingURL=selectShowRecipientWellOption.js.map

/***/ }),

/***/ 5158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(2685);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMessageFormatOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (owa_options_core_1.getFallbackValueIfNull(optionState.showBcc, userOptions.AlwaysShowBcc) !==
        userOptions.AlwaysShowBcc ||
        owa_options_core_1.getFallbackValueIfNull(optionState.showFrom, userOptions.AlwaysShowFrom) !==
            userOptions.AlwaysShowFrom ||
        owa_options_core_1.getFallbackValueIfNull(optionState.composeFormat, userOptions.ComposeMarkup) !==
            userOptions.ComposeMarkup ||
        owa_options_core_1.getFallbackValueIfNull(optionState.fontFamily, userOptions.ComposeFontName) !==
            userOptions.ComposeFontName ||
        owa_options_core_1.getFallbackValueIfNull(optionState.fontSize, userOptions.ComposeFontSize) !==
            userOptions.ComposeFontSize ||
        owa_options_core_1.getFallbackValueIfNull(optionState.fontColor, userOptions.ComposeFontColor) !==
            userOptions.ComposeFontColor ||
        (optionState.isFontBold !== null &&
            !!(userOptions.ComposeFontFlags & 1 /* Bold */) !== optionState.isFontBold) ||
        (optionState.isFontItalic !== null &&
            !!(userOptions.ComposeFontFlags & 2 /* Italic */) !== optionState.isFontItalic) ||
        (optionState.isFontUnderline !== null &&
            !!(userOptions.ComposeFontFlags & 4 /* Underline */) !== optionState.isFontUnderline));
});
//# sourceMappingURL=isMessageFormatOptionDirty.js.map

/***/ }),

/***/ 5159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardMessageFormatOption')(function discardMessageFormatOption(state) {
    var optionState = state.optionState;
    optionState.showBcc = null;
    optionState.showFrom = null;
    optionState.composeFormat = null;
    optionState.fontFamily = null;
    optionState.fontSize = null;
    optionState.isFontBold = null;
    optionState.isFontItalic = null;
    optionState.isFontUnderline = null;
    optionState.fontColor = null;
    optionState.isColorMenuShown = false;
}));
//# sourceMappingURL=discardMessageFormatOption.js.map

/***/ }),

/***/ 5160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(2685);
var legacy_1 = __webpack_require__(1);
var owa_session_store_1 = __webpack_require__(151);
var owa_options_core_1 = __webpack_require__(1736);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveMessageFormatOption')(function saveMessageFormatOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceObject;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceObject = {};
                    if (optionState.showBcc !== null) {
                        userOptions.AlwaysShowBcc = optionState.showBcc;
                        serviceObject.AlwaysShowBcc = optionState.showBcc;
                    }
                    if (optionState.showFrom !== null) {
                        userOptions.AlwaysShowFrom = optionState.showFrom;
                        serviceObject.AlwaysShowFrom = optionState.showFrom;
                    }
                    if (optionState.composeFormat !== null) {
                        userOptions.ComposeMarkup = optionState.composeFormat;
                        switch (optionState.composeFormat) {
                            case 'Html':
                                serviceObject.DefaultFormat = 0 /* Html */;
                                break;
                            case 'PlainText':
                                serviceObject.DefaultFormat = 1 /* PlainText */;
                                break;
                        }
                    }
                    if (optionState.fontFamily !== null) {
                        userOptions.ComposeFontName = optionState.fontFamily;
                        serviceObject.DefaultFontName = optionState.fontFamily;
                    }
                    if (optionState.fontSize !== null) {
                        userOptions.ComposeFontSize = optionState.fontSize;
                        serviceObject.DefaultFontSize = optionState.fontSize;
                    }
                    if (optionState.isFontBold !== null ||
                        optionState.isFontItalic !== null ||
                        optionState.isFontUnderline !== null) {
                        userOptions.ComposeFontFlags = applyFontFlagIfNonNull(optionState.isFontBold, 1 /* Bold */, userOptions.ComposeFontFlags);
                        userOptions.ComposeFontFlags = applyFontFlagIfNonNull(optionState.isFontItalic, 2 /* Italic */, userOptions.ComposeFontFlags);
                        userOptions.ComposeFontFlags = applyFontFlagIfNonNull(optionState.isFontUnderline, 4 /* Underline */, userOptions.ComposeFontFlags);
                        // For some reason, owa-service has two identical enums, FontFlags and FontFlags2.
                        // Cast one to the other for typechecking
                        serviceObject.DefaultFontFlags = userOptions.ComposeFontFlags;
                    }
                    if (optionState.fontColor !== null) {
                        userOptions.ComposeFontColor = optionState.fontColor;
                        serviceObject.DefaultFontColor = optionState.fontColor;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration(serviceObject)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
function applyFontFlagIfNonNull(isFlagSet, flagToSet, collectedFlags) {
    if (isFlagSet === null) {
        return collectedFlags;
    }
    else if (isFlagSet) {
        return collectedFlags | flagToSet;
    }
    else {
        return collectedFlags ^ flagToSet;
    }
}
//# sourceMappingURL=saveMessageFormatOption.js.map

/***/ }),

/***/ 5161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InboxRulesOption_1 = __webpack_require__(5162);
var rulesSubCategory = {
    key: 'rules',
    titleStringKey: 'optionSubcategory_rules',
    options: [InboxRulesOption_1.default],
};
exports.default = rulesSubCategory;
//# sourceMappingURL=rulesSubCategory.js.map

/***/ }),

/***/ 5162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InboxRulesFull_1 = __webpack_require__(5163);
var React = __webpack_require__(3);
var isInboxRuleEditDirty_1 = __webpack_require__(5228);
var isInboxRuleOptionEditState_1 = __webpack_require__(3757);
var saveInboxRuleEdit_1 = __webpack_require__(5229);
var resetInboxRuleEdit_1 = __webpack_require__(3410);
var InboxRulesOption = {
    key: 'inboxRules',
    titleStringKey: 'optionTitle_inboxRules',
    searchTermsStringKey: 'optionTitle_inboxRules',
    fullOptionFormSettings: {
        render: function () { return React.createElement(InboxRulesFull_1.default, null); },
        isDirty: function () { return isInboxRuleOptionEditState_1.default(); },
        onSave: function () { return saveInboxRuleEdit_1.default(); },
        onDiscard: function () { return resetInboxRuleEdit_1.default(); },
        disableSave: function () { return !isInboxRuleEditDirty_1.default(); },
        hideSaveDiscard: function () {
            return !isInboxRuleOptionEditState_1.default();
        },
    },
};
exports.default = InboxRulesOption;
//# sourceMappingURL=InboxRulesOption.js.map

/***/ }),

/***/ 5163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var InboxRuleRow_1 = __webpack_require__(5164);
var InboxRulesEdit_1 = __webpack_require__(5183);
var generateInboxRulesDiagnosticReport_1 = __webpack_require__(5216);
var getInboxRules_1 = __webpack_require__(3754);
var initializeInboxRulesFolders_1 = __webpack_require__(5222);
var setInboxRuleDiagnosticRequestStatus_1 = __webpack_require__(3752);
var initializeInboxRuleEdit_1 = __webpack_require__(3076);
var isInboxRuleOptionEditState_1 = __webpack_require__(3757);
var store_1 = __webpack_require__(2603);
var Button_1 = __webpack_require__(62);
var Button_2 = __webpack_require__(62);
var MessageBar_1 = __webpack_require__(2938);
var Spinner_1 = __webpack_require__(670);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_options_controls_1 = __webpack_require__(2661);
var styles = __webpack_require__(5226);
var className = __webpack_require__(30).bind(styles);
var InboxRulesFull = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesFull, _super);
    function InboxRulesFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InboxRulesFull.prototype.componentWillMount = function () {
        setInboxRuleDiagnosticRequestStatus_1.default(0 /* NotInitiated */);
        initializeInboxRulesFolders_1.default();
    };
    InboxRulesFull.prototype.componentDidMount = function () {
        getInboxRules_1.default();
    };
    InboxRulesFull.prototype.render = function () {
        return isInboxRuleOptionEditState_1.default()
            ? this.renderInboxRulesEditPage()
            : this.renderRuleList();
    };
    /**
     * Gives back the list of rows depending on the status of getting inbox rules
     * @return inbox rule list
     */
    InboxRulesFull.prototype.renderRuleList = function () {
        var getInboxRuleRequestStatus = this.props.inboxRulesListState.getInboxRuleRequestStatus;
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_inboxRules_description),
            owa_controls_feature_flags_1.isControlFeatureEnabled('tri-rules-advanced') && (React.createElement(Button_2.ActionButton, { className: styles.ruleCommandButton, onClick: function () { return initializeInboxRuleEdit_1.default(); }, text: owa_options_strings_1.default.options_inboxRules_addNewRule, iconProps: {
                    iconName: "Add" /* Add */,
                    styles: {
                        root: className(styles.icon, 'flipForRtl'),
                    },
                } })),
            this.getInboxRulesListContent(getInboxRuleRequestStatus)));
    };
    InboxRulesFull.prototype.getInboxRulesListContent = function (getInboxRuleRequestStatus) {
        switch (getInboxRuleRequestStatus) {
            case 2 /* Complete */:
                return this.renderRuleRows();
            case 3 /* Error */:
                return this.getInboxRuleError();
            case 1 /* Pending */:
            default:
                return React.createElement(Spinner_1.Spinner, { className: styles.loadingSpinner, type: Spinner_1.SpinnerType.large });
        }
    };
    /**
     * Creates error message div on get inbox rules error
     * @return error message div
     */
    InboxRulesFull.prototype.getInboxRuleError = function () {
        return (React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.error, isMultiline: false, actions: 
            // Localize button text VSTS: 19216
            React.createElement(Button_1.DefaultButton, { onClick: function () {
                    getInboxRules_1.default();
                } }, owa_options_strings_1.default.options_inboxRules_tryAgain) }, owa_options_strings_1.default.options_inboxRules_loadingRulesError));
    };
    /**
     * Creates the rule rows in inbox rules settings page
     * @return inbox rule rows
     */
    InboxRulesFull.prototype.renderRuleRows = function () {
        var rows = [];
        var inboxRuleCollection = this.props.inboxRulesListState.inboxRuleIds;
        if (inboxRuleCollection) {
            inboxRuleCollection.forEach(function (inboxRuleId) {
                rows.push(React.createElement(InboxRuleRow_1.default, { key: inboxRuleId, inboxRuleId: inboxRuleId }));
            });
        }
        return (React.createElement("div", { className: styles.inboxRuleRowsContainer },
            rows.length > 0 ? (rows) : (React.createElement(owa_options_controls_1.OptionDescription, { className: styles.emptyRules }, owa_options_strings_1.default.options_inboxRules_noRules)),
            owa_controls_feature_flags_1.isControlFeatureEnabled('tri-rules-advanced') && this.renderDiagnosticButton()));
    };
    InboxRulesFull.prototype.renderDiagnosticButton = function () {
        switch (this.props.inboxRulesListState.getInboxRuleDiagnosticRequestStatus) {
            case 1 /* Pending */:
                return (React.createElement("div", { className: styles.diagnosticLoadingContainer },
                    React.createElement(Spinner_1.Spinner, { className: styles.diagnosticSpinner, type: Spinner_1.SpinnerType.normal }),
                    React.createElement("span", { className: styles.diagnosticLoadingText }, owa_options_strings_1.default.options_inboxRules_generateReportPending)));
            case 3 /* Error */:
                return (React.createElement("span", { className: styles.diagnosticText }, owa_options_strings_1.default.options_inboxRules_generateReportFail));
            case 2 /* Complete */:
                return (React.createElement("span", { className: styles.diagnosticText }, owa_options_strings_1.default.options_inboxRules_generateReportSuccess));
            default:
                return (React.createElement("div", { className: styles.generateReportText },
                    React.createElement(Button_2.ActionButton, { className: styles.ruleCommandButton, onClick: function () { return generateInboxRulesDiagnosticReport_1.default(); }, text: owa_options_strings_1.default.options_inboxRules_generateReport })));
        }
    };
    InboxRulesFull.prototype.renderInboxRulesEditPage = function () {
        return React.createElement(InboxRulesEdit_1.default, null);
    };
    InboxRulesFull = tslib_1.__decorate([
        react_1.reactive({
            inboxRulesListState: function () { return store_1.default.inboxRulesListState; },
        })
    ], InboxRulesFull);
    return InboxRulesFull;
}(React.Component));
exports.default = InboxRulesFull;
//# sourceMappingURL=InboxRulesFull.js.map

/***/ }),

/***/ 5164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var editInboxRule_1 = __webpack_require__(5165);
var enableDisableInboxRule_1 = __webpack_require__(5166);
var removeInboxRule_1 = __webpack_require__(5171);
var store_1 = __webpack_require__(2603);
var index_1 = __webpack_require__(91);
var mobx_react_1 = __webpack_require__(11);
var Toggle_1 = __webpack_require__(2217);
var DragAndDroppable_1 = __webpack_require__(1634);
var DraggableItemTypes_1 = __webpack_require__(349);
var owa_inbox_rules_option_1 = __webpack_require__(5174);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var styles = __webpack_require__(5181);
var classNames = __webpack_require__(30).bind(styles);
var InboxRuleRow = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRuleRow, _super);
    function InboxRuleRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Helper method that handles user click on toggle
         * @param event user click event
         * @param shouldBeEnabled whether rule should be enabled
         */
        _this.onEnableDisableInboxRule = function (event, shouldBeEnabled) {
            event.stopPropagation();
            enableDisableInboxRule_1.default(_this.props.inboxRuleId, shouldBeEnabled);
        };
        /**
         * Helper method that handles user click on delete
         * @param event user click event
         */
        _this.onRemoveInboxRule = function (event) {
            event.stopPropagation();
            removeInboxRule_1.default(_this.props.inboxRuleId);
        };
        /**
         * Helper method that handles user click on edit
         * @param event user click event
         */
        _this.onEditInboxRule = function (event) {
            event.stopPropagation();
            editInboxRule_1.default(_this.props.inboxRuleId);
        };
        _this.getDragData = function () {
            var inboxRuleId = _this.props.inboxRuleId;
            var ruleRowDragData = {
                itemType: DraggableItemTypes_1.DraggableItemTypes.InboxRule,
                ruleId: inboxRuleId,
                ruleName: store_1.default.inboxRulesListState.inboxRules.get(inboxRuleId).Name,
            };
            return ruleRowDragData;
        };
        _this.getDragPreview = function (ruleDragData) {
            var elem = document.createElement('div');
            elem.className = styles.dragHelperStyle;
            elem.innerText = ruleDragData.ruleName;
            return elem;
        };
        _this.canDrop = function (dragData) {
            return dragData.itemType === DraggableItemTypes_1.DraggableItemTypes.InboxRule;
        };
        _this.onDrop = function (dragData) {
            var draggedRule = dragData;
            var draggedRuleId = draggedRule.ruleId;
            var dragTargetRuleId = _this.props.inboxRuleId;
            // Moves rule to new position
            owa_inbox_rules_option_1.lazyMoveInboxRule.importAndExecute(draggedRuleId /* idToUpdate */, dragTargetRuleId /* destinationRuleId */);
        };
        return _this;
    }
    InboxRuleRow.prototype.shouldShowEditButton = function (inboxRuleRow) {
        // Do not show edit button if the rule is not supported by OWA OR
        // rule has a clause type we don't support just yet
        // VSTS: 23316 and 23317 Add remaining conditions, actions, and exceptions
        // Check that the rule user wants to edit does not have any clauses that have
        // not been implemented yet.
        return (inboxRuleRow.SupportedByTask &&
            !inboxRuleRow.ApplyCategory &&
            !inboxRuleRow.ApplySystemCategory &&
            !inboxRuleRow.HasClassification &&
            !inboxRuleRow.ExceptIfHasClassification &&
            !inboxRuleRow.FromSubscription &&
            !inboxRuleRow.ExceptIfFromSubscription &&
            !inboxRuleRow.SendTextMessageNotificationTo);
    };
    InboxRuleRow.prototype.render = function () {
        var _this = this;
        var inboxRuleRow = store_1.default.inboxRulesListState.inboxRules.get(this.props.inboxRuleId);
        var descriptionText = this.getDescriptionText(inboxRuleRow.Description);
        var isRuleSupported = inboxRuleRow.SupportedByTask;
        var warningMessages = inboxRuleRow.WarningMessages;
        var shouldShowAlert = !(isRuleSupported && !warningMessages);
        var inboxRuleRowClassName = classNames(styles.inboxRuleContainer, inboxRuleRow.drop.isDragOver && styles.showBorderOnDroppedOver);
        return (React.createElement(DragAndDroppable_1.default, { getDragData: this.getDragData, getDragPreview: this.getDragPreview, dropViewState: inboxRuleRow.drop, onDrop: this.onDrop, canDrop: this.canDrop },
            React.createElement("div", { className: inboxRuleRowClassName, tabIndex: -1 },
                React.createElement("div", { className: styles.inboxRuleLeft },
                    React.createElement(Toggle_1.Toggle, { className: styles.inboxRuleToggle, styles: {
                            pillChecked: styles.themeDarkBackground,
                            pillHovered: styles.themeDarkerBackground,
                        }, checked: !shouldShowAlert ? inboxRuleRow.Enabled : false, disabled: shouldShowAlert, offAriaLabel: owa_options_strings_1.default.options_inboxRules_ruleDisabledAriaText, onAriaLabel: owa_options_strings_1.default.options_inboxRules_ruleEnabledAriaText, onClick: function (evt) {
                            _this.onEnableDisableInboxRule(evt, !inboxRuleRow.Enabled);
                        } }),
                    React.createElement("div", { className: styles.inboxRuleText },
                        React.createElement("div", { className: styles.inboxRuleName }, inboxRuleRow.Name),
                        React.createElement("div", { className: styles.inboxRuleHelperText }, descriptionText),
                        shouldShowAlert && (React.createElement("div", { className: styles.inboxRuleAlert },
                            React.createElement("div", { className: classNames(index_1.getIconClassName("Warning" /* Warning */), styles.icon) }),
                            React.createElement("span", null, this.getAlertString(isRuleSupported, warningMessages)))))),
                React.createElement("div", { className: styles.hoverIcons },
                    this.shouldShowEditButton(inboxRuleRow) && (React.createElement("div", { className: classNames(index_1.getIconClassName("Edit" /* Edit */), styles.icon), onClick: this.onEditInboxRule, "aria-label": 'Edit rule' })),
                    React.createElement("div", { className: classNames(index_1.getIconClassName("Delete" /* Delete */)), onClick: this.onRemoveInboxRule, "aria-label": owa_options_strings_1.default.options_inboxRules_deleteRuleAriaText })))));
    };
    /**
     * Gets the description text for the given inbox rule
     * @param inboxRuleDescriptions the inbox rule clause descriptions
     * @return inbox rule description
     */
    InboxRuleRow.prototype.getDescriptionText = function (inboxRuleDescriptions) {
        var andDelimeter = ' ' + owa_options_strings_1.default.options_inboxRules_and + ' ';
        var orDelimeter = ' ' + owa_options_strings_1.default.options_inboxRules_or + ' ';
        var commaDelimeter = ', ';
        var period = '.';
        // Create the description string from all the clauses
        // For example: If <conditional clause 1>, <conditional clause 2> and <conditional clause 3>,
        // <action clause 1>, <action clause 2> and <action clause 3>,
        // except when <exception clause 1>, <exception clause 2> or <exception clause 3>
        var descriptionText = owa_options_strings_1.default.options_inboxRules_if + ' ';
        descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ConditionDescriptions, commaDelimeter, andDelimeter);
        descriptionText += commaDelimeter;
        descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ActionDescriptions, commaDelimeter, andDelimeter);
        var exceptionDescriptions = inboxRuleDescriptions.ExceptionDescriptions;
        if (exceptionDescriptions.length > 0) {
            descriptionText += commaDelimeter + owa_options_strings_1.default.options_inboxRules_exceptWhen + ' ';
            descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ExceptionDescriptions, commaDelimeter, orDelimeter);
        }
        descriptionText += period;
        return descriptionText;
    };
    /**
     * Gets the description text for a clause for the given inbox rule (conditional, action, exception)
     * @param descriptions the descriptions for an inbox rule's clause
     * @param midDelimeter the delimeter for between clauses except between the second to last and last clauses
     * @param lastDelimeter the delimeter for between the second to last and last clauses
     * @return the concatenated, user-ready description for an inbox rule's clause
     */
    InboxRuleRow.prototype.getDescriptionTextHelper = function (descriptions, midDelimeter, lastDelimeter) {
        var descriptionText = '';
        for (var i = 0; i < descriptions.length; i++) {
            descriptionText += descriptions[i];
            // Clauses should be separated by ',' except for between the second to last and last clauses,
            // which should be separated by 'and'
            if (i < descriptions.length - 2) {
                descriptionText += midDelimeter;
            }
            else if (i === descriptions.length - 2) {
                descriptionText += lastDelimeter;
            }
        }
        return descriptionText;
    };
    /**
     * Helper method that gets alert strings for rules
     * @param isRuleSupported whether rule is supported in OWA
     * @param warningMessages warning messages if the rule is broken
     * @return Alert string
     */
    InboxRuleRow.prototype.getAlertString = function (isRuleSupported, warningMessages) {
        var alertString = '';
        var spaceDelimeter = ' ';
        if (!isRuleSupported) {
            // TODO: VSTS Localize 19216
            alertString += 'This rule does not work in OWA.' + spaceDelimeter;
        }
        if (warningMessages) {
            for (var _i = 0, warningMessages_1 = warningMessages; _i < warningMessages_1.length; _i++) {
                var warningMessage = warningMessages_1[_i];
                alertString += warningMessage + spaceDelimeter;
            }
        }
        return alertString;
    };
    InboxRuleRow = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRuleRow);
    return InboxRuleRow;
}(React.Component));
exports.default = InboxRuleRow;
//# sourceMappingURL=InboxRuleRow.js.map

/***/ }),

/***/ 5165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mapInboxRuleToInboxRuleClauses_1 = __webpack_require__(3384);
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Sets the given rule to edit mode
 * @param inboxRuleId the inbox rule id
 */
exports.default = legacy_1.select({
    listOptionState: function () { return store_1.default.inboxRulesListState; },
    editOptionState: function () { return store_1.default.inboxRulesEditState; },
})(legacy_1.action('editInboxRule')(function editInboxRule(inboxRuleId, state) {
    var listOptionState = state.listOptionState;
    var inboxRule = listOptionState.inboxRules.get(inboxRuleId);
    mapInboxRuleToInboxRuleClauses_1.default(inboxRule);
}));
//# sourceMappingURL=editInboxRule.js.map

/***/ }),

/***/ 5166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2896);
var disableInboxRuleService_1 = __webpack_require__(5167);
var enableInboxRuleService_1 = __webpack_require__(5169);
var store_1 = __webpack_require__(2603);
var owa_analytics_1 = __webpack_require__(12);
var legacy_1 = __webpack_require__(1);
/**
 * Enables / disables the given rule
 * @param inboxRuleId the inbox rule id
 * @param shouldBeEnabled whether the inbox rule should be enabled
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(legacy_1.action('enableDisableInboxRule', datapoints_1.default.enableDisableInboxRuleDatapoint)(function enableDisableInboxRule(inboxRuleId, shouldBeEnabled, state) {
    var optionState = state.optionState;
    var dataPoint = owa_analytics_1.returnTopExecutingActionDatapoint();
    var inboxRule = optionState.inboxRules.get(inboxRuleId);
    setEnableDisableInboxRuleState(shouldBeEnabled, inboxRule);
    var enableDisableInboxRulePromise;
    if (inboxRule.Enabled) {
        enableDisableInboxRulePromise = enableInboxRuleService_1.default(inboxRule);
    }
    else {
        enableDisableInboxRulePromise = disableInboxRuleService_1.default(inboxRule);
    }
    // TODO: Proper error handling / success notification
    // Task 20143: Full error handling / success notification support
    return enableDisableInboxRulePromise
        .then(function (response) {
        if (!response.WasSuccessful) {
            setEnableDisableInboxRuleState(!shouldBeEnabled, inboxRule);
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error.message);
    });
}));
var setEnableDisableInboxRuleState = legacy_1.action('setEnableDisableInboxRuleState')(function setEnableDisableInboxRuleState(shouldBeEnabled, inboxRule) {
    inboxRule.Enabled = shouldBeEnabled;
});
//# sourceMappingURL=enableDisableInboxRule.js.map

/***/ }),

/***/ 5167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var disableInboxRuleRequest_1 = __webpack_require__(3741);
var disableInboxRuleOperation_1 = __webpack_require__(5168);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Helper method that creates the DisableInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return DisableInboxRuleRequest
 */
function createRequestBody(inboxRule) {
    return disableInboxRuleRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Identity: inboxRule.Identity,
    });
}
/**
 * Disable inbox rule service
 * @param inboxRule the inbox rule
 * @return DisableInboxRuleResponse
 */
function disableInboxRuleService(inboxRule) {
    var requestBody = createRequestBody(inboxRule);
    return disableInboxRuleOperation_1.default(requestBody);
}
exports.default = disableInboxRuleService;
//# sourceMappingURL=disableInboxRuleService.js.map

/***/ }),

/***/ 5168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var disableInboxRuleRequest_1 = __webpack_require__(3741);
function disableInboxRuleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = disableInboxRuleRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("DisableInboxRule", req, options);
}
exports.default = disableInboxRuleOperation;


/***/ }),

/***/ 5169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var enableInboxRuleRequest_1 = __webpack_require__(3742);
var enableInboxRuleOperation_1 = __webpack_require__(5170);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Helper method that creates the EnableInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleRequest
 */
function createRequestBody(inboxRule) {
    return enableInboxRuleRequest_1.default({ Header: ServiceRequestUtils_1.getJsonRequestHeader(), Identity: inboxRule.Identity });
}
/**
 * Enable inbox rule service
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleResponse
 */
function enableInboxRuleService(inboxRule) {
    var requestBody = createRequestBody(inboxRule);
    return enableInboxRuleOperation_1.default(requestBody);
}
exports.default = enableInboxRuleService;
//# sourceMappingURL=enableInboxRuleService.js.map

/***/ }),

/***/ 5170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var enableInboxRuleRequest_1 = __webpack_require__(3742);
function enableInboxRuleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = enableInboxRuleRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("EnableInboxRule", req, options);
}
exports.default = enableInboxRuleOperation;


/***/ }),

/***/ 5171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2896);
var removeInboxRuleService_1 = __webpack_require__(5172);
var store_1 = __webpack_require__(2603);
var owa_analytics_1 = __webpack_require__(12);
var legacy_1 = __webpack_require__(1);
/**
 * Removes the given rule
 * @param inboxRuleId the inbox rule id
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(legacy_1.action('removeInboxRule', datapoints_1.default.removeInboxRuleDatapoint)(function removeInboxRule(inboxRuleId, state) {
    var dataPoint = owa_analytics_1.returnTopExecutingActionDatapoint();
    var optionState = state.optionState;
    var inboxRule = optionState.inboxRules.get(inboxRuleId);
    optionState.inboxRules.delete(inboxRuleId);
    optionState.inboxRuleIds.splice(optionState.inboxRuleIds.indexOf(inboxRuleId), 1);
    // TODO: Task 20143: Full error handling / success notification support
    return removeInboxRuleService_1.default(inboxRule)
        .then(function (response) {
        if (!response.WasSuccessful) {
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error.message);
    });
}));
//# sourceMappingURL=removeInboxRule.js.map

/***/ }),

/***/ 5172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var removeInboxRuleRequest_1 = __webpack_require__(3743);
var removeInboxRuleOperation_1 = __webpack_require__(5173);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Helper method that creates the RemoveInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return RemoveInboxRuleRequest
 */
function createRequestBody(inboxRule) {
    return removeInboxRuleRequest_1.default({ Header: ServiceRequestUtils_1.getJsonRequestHeader(), Identity: inboxRule.Identity });
}
/**
 * Remove inbox rule service
 * @param inboxRule the inbox rule
 * @return RemoveInboxRuleResponse
 */
function removeInboxRuleService(inboxRule) {
    var requestBody = createRequestBody(inboxRule);
    return removeInboxRuleOperation_1.default(requestBody);
}
exports.default = removeInboxRuleService;
//# sourceMappingURL=removeInboxRuleService.js.map

/***/ }),

/***/ 5173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var removeInboxRuleRequest_1 = __webpack_require__(3743);
function removeInboxRuleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = removeInboxRuleRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("RemoveInboxRule", req, options);
}
exports.default = removeInboxRuleOperation;


/***/ }),

/***/ 5174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 5175));
});
exports.lazyMoveInboxRule = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.moveInboxRule; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moveInboxRule_1 = __webpack_require__(5176);
exports.moveInboxRule = moveInboxRule_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 5176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setInboxRules_1 = __webpack_require__(5177);
var store_1 = __webpack_require__(2603);
var owa_analytics_1 = __webpack_require__(12);
var moveDragAndDroppableItem_1 = __webpack_require__(3333);
var legacy_1 = __webpack_require__(1);
/**
 * Move the inbox rule above the specified node
 * @param ruleIdToMove the rule to be moved
 * @param destinationRuleId the rule to be inserted before
 */
exports.default = legacy_1.action('moveInboxRule')(legacy_1.select({
    orderedInboxRuleIds: function () { return store_1.default.inboxRulesListState.inboxRuleIds; },
})(function moveInboxRule(ruleIdToMove, destinationRuleId, state) {
    var orderedInboxRuleIds = state.orderedInboxRuleIds;
    var fromIndex = orderedInboxRuleIds.indexOf(ruleIdToMove);
    var toIndex = orderedInboxRuleIds.indexOf(destinationRuleId);
    // Move the element from the old position to the new position in the array
    moveDragAndDroppableItem_1.default(orderedInboxRuleIds, fromIndex, toIndex);
    owa_analytics_1.logUsage('TnS_MoveInboxRule', [orderedInboxRuleIds.length, fromIndex, toIndex]);
    setInboxRules_1.default();
}));
//# sourceMappingURL=moveInboxRule.js.map

/***/ }),

/***/ 5177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setInboxAndSweepRulesService_1 = __webpack_require__(5178);
var store_1 = __webpack_require__(2603);
var owa_analytics_1 = __webpack_require__(12);
var legacy_1 = __webpack_require__(1);
var datapoints_1 = __webpack_require__(2896);
/**
 * Saves the current inbox rule configuration
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(legacy_1.action('setInboxRules', datapoints_1.default.setInboxRulesDatapoint)(function setInboxRules(state) {
    var datapoint = owa_analytics_1.returnTopExecutingActionDatapoint();
    var optionState = state.optionState;
    var inboxRuleIds = optionState.inboxRuleIds;
    var inboxRuleMap = optionState.inboxRules;
    return setInboxAndSweepRulesService_1.default(inboxRuleIds, inboxRuleMap)
        .then(function (response) {
        if (!response.WasSuccessful) {
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            datapoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        datapoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error.message);
    });
}));
//# sourceMappingURL=setInboxRules.js.map

/***/ }),

/***/ 5178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var enableDisableInboxRuleRequest_1 = __webpack_require__(5179);
var setInboxAndSweepRulesRequest_1 = __webpack_require__(3744);
var setInboxAndSweepRulesOperation_1 = __webpack_require__(5180);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Helper method that creates the SetInboxAndSweepRulesRequest body
 * @param inboxRuleIds the list of inbox ruleIds in order
 * @param inboxRules the map that contains the inbox rule objects
 * @return EnableInboxRuleRequest
 */
function createRequestBody(inboxRuleIds, inboxRules) {
    var enableDisableRequests = [];
    inboxRuleIds.forEach(function (inboxRuleId) {
        var request = enableDisableInboxRuleRequest_1.default({
            Header: ServiceRequestUtils_1.getJsonRequestHeader(),
            Identity: inboxRules.get(inboxRuleId).Identity,
            IsEnabled: inboxRules.get(inboxRuleId).Enabled,
        });
        enableDisableRequests.push(request);
    });
    return setInboxAndSweepRulesRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        EnableDisableInboxRules: enableDisableRequests,
    });
}
/**
 * Enable inbox rule service
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleResponse
 */
function setInboxAndSweepRulesService(inboxRuleIds, inboxRules) {
    var requestBody = createRequestBody(inboxRuleIds, inboxRules);
    return setInboxAndSweepRulesOperation_1.default(requestBody);
}
exports.default = setInboxAndSweepRulesService;
//# sourceMappingURL=setInboxAndSweepRulesService.js.map

/***/ }),

/***/ 5179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function enableDisableInboxRuleRequest(data) {
    var result = tslib_1.__assign({ __type: 'EnableDisableInboxRuleRequest:#Exchange' }, data);
    return result;
}
exports.default = enableDisableInboxRuleRequest;


/***/ }),

/***/ 5180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var setInboxAndSweepRulesRequest_1 = __webpack_require__(3744);
function setInboxAndSweepRulesOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = setInboxAndSweepRulesRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("SetInboxAndSweepRules", req, options);
}
exports.default = setInboxAndSweepRulesOperation;


/***/ }),

/***/ 5181:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5182);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5182:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._2Z6sixlEWfQdq0UDZtXa2u{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._2Z6sixlEWfQdq0UDZtXa2u{padding:16px 0;border-bottom:1px solid \"[theme:neutralLighter, default:#f4f4f4]\"}._2Z6sixlEWfQdq0UDZtXa2u:hover ._1Tx5HjZk2H7xBE_3wYDn-1{visibility:visible}html[dir] ._2Z6sixlEWfQdq0UDZtXa2u._3tgMgfAsBJoUAWDQAmFPgF{-webkit-box-shadow:0 -1px 1px -1px \"[theme:neutralDark, default:#212121]\";box-shadow:0 -1px 1px -1px \"[theme:neutralDark, default:#212121]\"}._1kvno7VyDqvoxqO_NFzhrP{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden}.lROclrUaE4eIcy4o2zmUv{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir=ltr] .lROclrUaE4eIcy4o2zmUv{padding-right:16px}html[dir=rtl] .lROclrUaE4eIcy4o2zmUv{padding-left:16px}._1OY_V0jxIt_hQeD6oyBgWp{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;overflow:hidden}._2p6XmU5DXh4_jK22AQ_Jc6{font-weight:600}._1z048wCdks3XhEkmDuff5d,._2jPTFvHqrtNW6uB_Pxcl6L,._2p6XmU5DXh4_jK22AQ_Jc6{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir] ._1z048wCdks3XhEkmDuff5d,html[dir] ._2jPTFvHqrtNW6uB_Pxcl6L{margin-top:8px}._2jPTFvHqrtNW6uB_Pxcl6L{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1Tx5HjZk2H7xBE_3wYDn-1{visibility:hidden;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:16px;cursor:pointer}html[dir] ._1Tx5HjZk2H7xBE_3wYDn-1{padding:12px 4px}html[dir=ltr] ._1Tx5HjZk2H7xBE_3wYDn-1{margin-left:20px}html[dir=rtl] ._1Tx5HjZk2H7xBE_3wYDn-1{margin-right:20px}html[dir=ltr] ._1RWeXjtK6li6X5ENXdV5Uw{margin-right:8px}html[dir=rtl] ._1RWeXjtK6li6X5ENXdV5Uw{margin-left:8px}", ""]);

// exports
exports.locals = {
	"inboxRuleContainer": "_2Z6sixlEWfQdq0UDZtXa2u",
	"hoverIcons": "_1Tx5HjZk2H7xBE_3wYDn-1",
	"showBorderOnDroppedOver": "_3tgMgfAsBJoUAWDQAmFPgF",
	"inboxRuleLeft": "_1kvno7VyDqvoxqO_NFzhrP",
	"inboxRuleToggle": "lROclrUaE4eIcy4o2zmUv",
	"inboxRuleText": "_1OY_V0jxIt_hQeD6oyBgWp",
	"inboxRuleName": "_2p6XmU5DXh4_jK22AQ_Jc6",
	"inboxRuleHelperText": "_1z048wCdks3XhEkmDuff5d",
	"inboxRuleAlert": "_2jPTFvHqrtNW6uB_Pxcl6L",
	"icon": "_1RWeXjtK6li6X5ENXdV5Uw"
};

/***/ }),

/***/ 5183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var InboxRulesSection_1 = __webpack_require__(5184);
var getActionClauseTypeOptions_1 = __webpack_require__(2795);
var getConditionalExceptionClauseTypeOptions_1 = __webpack_require__(2796);
var resetInboxRuleEdit_1 = __webpack_require__(3410);
var setIgnoreSubsequentRules_1 = __webpack_require__(5213);
var store_1 = __webpack_require__(2603);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var React = __webpack_require__(3);
var owa_options_controls_1 = __webpack_require__(2661);
var owa_options_strings_1 = __webpack_require__(1737);
var styles = __webpack_require__(5214);
var stopProcessingRulesLearnMoreUrl = 'https://support.office.com/en-US/client/results?Shownav=true&lcid=1033&ns=OLWAO365B&version=15&omkt=en-US&ver=15&v=15.20.298.0&mode=Desktop&helpid=ms.exch.owab.InboxRulesStopProcessing';
var InboxRulesEdit = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesEdit, _super);
    function InboxRulesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InboxRulesEdit.prototype.componentWillUnmount = function () {
        resetInboxRuleEdit_1.default();
    };
    InboxRulesEdit.prototype.render = function () {
        var showExceptions = store_1.default.inboxRulesEditState.exceptionClauseIds.length > 0;
        return (React.createElement("div", null,
            this.getInboxRulesSection('name'),
            this.getInboxRulesSection('conditional'),
            this.getInboxRulesSection('action'),
            showExceptions && this.getInboxRulesSection('exception'),
            this.renderIgnoreSubsequentRulesCheckbox()));
    };
    InboxRulesEdit.prototype.getInboxRulesSection = function (sectionType) {
        var editState = store_1.default.inboxRulesEditState;
        switch (sectionType) {
            case 'name':
                return React.createElement(InboxRulesSection_1.default, { sectionType: sectionType, numStep: 1 });
            case 'conditional':
                return (React.createElement(InboxRulesSection_1.default, { sectionType: sectionType, numStep: 2, clauseIds: editState.conditionalClauseIds, clauseTypeOptions: getConditionalExceptionClauseTypeOptions_1.default() }));
            case 'action':
                return (React.createElement(InboxRulesSection_1.default, { sectionType: sectionType, numStep: 3, clauseIds: editState.actionClauseIds, clauseTypeOptions: getActionClauseTypeOptions_1.default() }));
            case 'exception':
                return (React.createElement(InboxRulesSection_1.default, { sectionType: sectionType, numStep: 4, clauseIds: editState.exceptionClauseIds, clauseTypeOptions: getConditionalExceptionClauseTypeOptions_1.default() }));
            default:
                throw new Error('Cannot get inbox rule section component for a section type that does not exist');
        }
    };
    InboxRulesEdit.prototype.renderIgnoreSubsequentRulesCheckbox = function () {
        return (React.createElement("div", { className: styles.ignoreSubsequentRulesCheckbox },
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: store_1.default.inboxRulesEditState.ignoreSubsequentRules, label: owa_options_strings_1.default.options_inboxRules_stopProcessingRules, onChange: function (ev, checked) { return setIgnoreSubsequentRules_1.default(checked); } }),
            React.createElement(Button_1.ActionButton, { className: styles.ignoreSubsequentRulesLearnMore, text: owa_options_strings_1.default.options_inboxRules_learnMore, onClick: function () { return window.open(stopProcessingRulesLearnMoreUrl, '_blank'); } })));
    };
    InboxRulesEdit = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRulesEdit);
    return InboxRulesEdit;
}(React.Component));
exports.default = InboxRulesEdit;
//# sourceMappingURL=InboxRulesEdit.js.map

/***/ }),

/***/ 5184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var InboxRuleClause_1 = __webpack_require__(5185);
var addNewClause_1 = __webpack_require__(2940);
var getClauseSectionProperties_1 = __webpack_require__(3747);
var getSectionCompletionStatus_1 = __webpack_require__(5209);
var hasUsedAllClauseTypesInSection_1 = __webpack_require__(3174);
var setClauseErrorText_1 = __webpack_require__(3179);
var setFocusedClauseId_1 = __webpack_require__(3750);
var setRuleName_1 = __webpack_require__(5210);
var store_1 = __webpack_require__(2603);
var isValidClause_1 = __webpack_require__(3078);
var mobx_1 = __webpack_require__(15);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var Icon_1 = __webpack_require__(43);
var TextField_1 = __webpack_require__(1741);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var styles = __webpack_require__(5211);
var classNames = __webpack_require__(30).bind(styles);
var InboxRulesSectionComputedState = /** @class */ (function () {
    function InboxRulesSectionComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(InboxRulesSectionComputedState.prototype, "sectionCompletionStatus", {
        get: function () {
            return getSectionCompletionStatus_1.default(this.props.sectionType, this.props.clauseIds);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], InboxRulesSectionComputedState.prototype, "sectionCompletionStatus", null);
    return InboxRulesSectionComputedState;
}());
var InboxRulesSection = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesSection, _super);
    function InboxRulesSection(props) {
        var _this = _super.call(this, props) || this;
        _this.setFocusOnNameField = function (shouldSetFocus) {
            setFocusedClauseId_1.default('name', shouldSetFocus);
        };
        _this.validateName = function () {
            setClauseErrorText_1.default('name', store_1.default.inboxRulesEditState.ruleName.trim().length > 0);
            setFocusedClauseId_1.default('name', false);
        };
        _this.computedState = new InboxRulesSectionComputedState(_this.props);
        return _this;
    }
    InboxRulesSection.prototype.render = function () {
        var _this = this;
        var sectionProperties = getClauseSectionProperties_1.default(this.props.sectionType);
        var sectionStatus = this.computedState.sectionCompletionStatus;
        var sectionNumberClassName = classNames(styles.sectionNumber, sectionStatus == 2 /* InProgress */ &&
            styles.inProgressSection, sectionStatus == 0 /* Incomplete */ &&
            styles.incompleteSection, sectionStatus == 1 /* Complete */ && styles.completeSection);
        var showAddException = this.props.sectionType == 'action' &&
            store_1.default.inboxRulesEditState.exceptionClauseIds.length == 0;
        return (React.createElement("div", { className: styles.sectionContainer },
            React.createElement("div", { className: sectionNumberClassName }, sectionStatus == 1 /* Complete */ ? (React.createElement(Icon_1.Icon, { iconName: "CheckMark" /* CheckMark */, className: styles.sectionCompleteCheckmark })) : (this.props.numStep)),
            React.createElement("div", { className: styles.sectionDetails }, this.props.sectionType === 'name' ? (React.createElement("div", { className: styles.ruleNameContainer },
                React.createElement(TextField_1.TextField, { onFocus: function () { return _this.setFocusOnNameField(true); }, onBlur: this.validateName, value: store_1.default.inboxRulesEditState.ruleName, placeholder: 'Name your rule', onChanged: this.onRuleNameInputChanged, errorMessage: store_1.default.inboxRulesEditState.clauseErrorTextMap.get('name') }))) : (React.createElement("div", null,
                this.renderSectionHeader(sectionProperties),
                this.getInboxRuleSectionClauses(sectionProperties),
                showAddException && (React.createElement(Button_1.ActionButton, { className: styles.addAnExceptionButton, onClick: function (evt) {
                        addNewClause_1.default('exception', null, null);
                    }, text: owa_options_strings_1.default.options_inboxRules_addExceptionSection })))))));
    };
    InboxRulesSection.prototype.getInboxRuleSectionClauses = function (sectionProperties) {
        var clauseIds = this.props.clauseIds;
        var clauseTypeOptions = this.props.clauseTypeOptions;
        var sectionType = this.props.sectionType;
        var inboxRuleClauses = [];
        var lastClauseInSection = clauseIds[clauseIds.length - 1];
        for (var i = 0; i < clauseIds.length; i++) {
            var clauseId = clauseIds[i];
            inboxRuleClauses.push(React.createElement(InboxRuleClause_1.default, { key: clauseId, clauseId: clauseId, clauseTypeOptions: clauseTypeOptions, sectionType: sectionType, sectionClauseIds: clauseIds }));
        }
        return (React.createElement("div", { className: styles.inboxRuleClausesContainer },
            inboxRuleClauses,
            this.shouldShowAddNewClause() && (React.createElement(Button_1.ActionButton, { className: styles.addClause, onClick: function (evt) {
                    // validate the previous clause in the section
                    setClauseErrorText_1.default(lastClauseInSection, isValidClause_1.default(lastClauseInSection));
                    addNewClause_1.default(sectionType, null, null);
                }, text: sectionProperties.addClauseText }))));
    };
    InboxRulesSection.prototype.onRuleNameInputChanged = function (inputText) {
        setRuleName_1.default(inputText);
    };
    InboxRulesSection.prototype.shouldShowAddNewClause = function () {
        var clauseIds = this.props.clauseIds;
        var lastClauseInSection = store_1.default.inboxRulesEditState.clauseMap.get(clauseIds[clauseIds.length - 1]);
        // only show add clause button if
        // 1) the last clause in the section has a type
        // 2) user hasn't used all possible clause types yet
        return (lastClauseInSection &&
            lastClauseInSection.clauseType &&
            !hasUsedAllClauseTypesInSection_1.default(this.props.sectionType));
    };
    InboxRulesSection.prototype.renderSectionHeader = function (sectionProperties) {
        return (React.createElement("div", { className: styles.sectionLabel },
            React.createElement("span", null, sectionProperties.headerText)));
    };
    InboxRulesSection = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRulesSection);
    return InboxRulesSection;
}(React.Component));
exports.default = InboxRulesSection;
//# sourceMappingURL=InboxRulesSection.js.map

/***/ }),

/***/ 5185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var InboxRulesFolderDropdown_1 = __webpack_require__(5186);
var IncludesWordsInput_1 = __webpack_require__(5189);
var getClauseTypeProperties_1 = __webpack_require__(5196);
var getExistingClauseTypesInSection_1 = __webpack_require__(3077);
var getHeaderTextFromHeaderType_1 = __webpack_require__(5197);
var getImportanceOptions_1 = __webpack_require__(5198);
var getInboxRuleMessageFlagOptions_1 = __webpack_require__(5199);
var getInboxRuleMessageTypeOptions_1 = __webpack_require__(5200);
var getSensitivityOptions_1 = __webpack_require__(5201);
var setClauseErrorText_1 = __webpack_require__(3179);
var setFocusedClauseId_1 = __webpack_require__(3750);
var setIncludesWordsInputText_1 = __webpack_require__(3749);
var removeClause_1 = __webpack_require__(5202);
var setClauseType_1 = __webpack_require__(5203);
var setClauseValue_1 = __webpack_require__(3178);
var store_1 = __webpack_require__(2603);
var isValidClause_1 = __webpack_require__(3078);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var Dropdown_1 = __webpack_require__(2652);
var TextField_1 = __webpack_require__(1741);
var owa_datepicker_1 = __webpack_require__(1869);
var owa_datetime_1 = __webpack_require__(207);
var ReadWriteRecipientWellWithFindControl_1 = __webpack_require__(3387);
var RecipientType_1 = __webpack_require__(2672);
var getUserConfiguration_1 = __webpack_require__(9);
var React = __webpack_require__(3);
var owa_options_strings_1 = __webpack_require__(1737);
var styles = __webpack_require__(3745);
var classNames = __webpack_require__(30).bind(styles);
var InboxRuleClause = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRuleClause, _super);
    function InboxRuleClause() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getClauseValueInput = function () {
            var clauseId = _this.props.clauseId;
            var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(_this.props.clauseId);
            switch (selectedClause.clauseType) {
                case 'from':
                case 'to':
                case 'forwardTo':
                case 'forwardAsAttachmentTo':
                case 'redirectTo':
                    return _this.renderRecipientWell(selectedClause);
                case 'subjectIncludes':
                case 'subjectOrBodyIncludes':
                case 'inTheBody':
                case 'inTheSenderAddress':
                case 'inTheRecipientAddress':
                case 'inTheMessageHeader':
                    setIncludesWordsInputText_1.default(clauseId, '');
                    return _this.renderIncludesWordsInput(clauseId);
                case 'withImportance':
                case 'markImportance':
                    return _this.renderClauseValueDropdown(getImportanceOptions_1.default());
                case 'sensitivity':
                    return _this.renderClauseValueDropdown(getSensitivityOptions_1.default());
                case 'flag':
                    return _this.renderClauseValueDropdown(getInboxRuleMessageFlagOptions_1.default());
                case 'type':
                    return _this.renderClauseValueDropdown(getInboxRuleMessageTypeOptions_1.default());
                case 'atLeast':
                case 'atMost':
                    return _this.renderNumberTextField(selectedClause);
                case 'moveTo':
                case 'copyTo':
                    return _this.renderFolderDropdown(clauseId);
                case 'onTheToOrCcLine':
                case 'theOnlyRecipientListed':
                case 'onTheToLine':
                case 'onTheCcLine':
                case 'notOnTheToLine':
                case 'attachment':
                case 'delete':
                case 'pin':
                case 'read':
                case 'junk':
                case null:// no clause selected from the clause type dropdown ('select a clause')
                    return null; // No second input
                case 'before':
                case 'after':
                    return _this.renderDatePicker(selectedClause);
                // Other cases return null, default throw error
                default:
                    throw new Error('Cannot get clause value input for a clause type that does not exist');
            }
        };
        _this.onTextFieldChanged = function (value) {
            var num = Number(value);
            if (!isNaN(num)) {
                setClauseValue_1.default(num, _this.props.clauseId);
            }
        };
        _this.onDateSelected = function (date) {
            setClauseValue_1.default(date, _this.props.clauseId);
        };
        _this.removeFocusAndValidate = function () {
            var clauseId = _this.props.clauseId;
            setClauseErrorText_1.default(clauseId, isValidClause_1.default(clauseId));
            setFocusedClauseId_1.default(clauseId, false /* shouldSetAsFocused */);
        };
        return _this;
    }
    InboxRuleClause.prototype.render = function () {
        var _this = this;
        var clauseId = this.props.clauseId;
        var sectionType = this.props.sectionType;
        var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        return (React.createElement("div", { className: styles.clauseContainer, key: clauseId },
            React.createElement(Dropdown_1.Dropdown, { onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return setFocusedClauseId_1.default(clauseId, false /* shouldSetAsFocused */); }, id: 'dropdown' + clauseId, placeHolder: owa_options_strings_1.default.options_inboxRules_clauseTypeDropdownPlaceholder, options: this.getClauseDropdownOptions(), selectedKey: this.getDropdownKey(selectedClause.clauseType), className: styles.clauseTypesDropdown, onChanged: function (option) { return _this.onClauseTypeChanged(option); } }),
            this.getClauseValueInput(),
            this.shouldShowRemoveClauseButton() && (React.createElement(Button_1.IconButton, { className: styles.removeClauseButton, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: styles.cancelIcon,
                    },
                }, onClick: function () { return removeClause_1.default(clauseId, sectionType); } }))));
    };
    InboxRuleClause.prototype.getClauseDropdownOptions = function () {
        var items = [];
        var clauseId = this.props.clauseId;
        var sectionType = this.props.sectionType;
        var clauseTypeOptions = this.props.clauseTypeOptions;
        var existingClauseTypes = getExistingClauseTypesInSection_1.default(this.props.sectionType);
        var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        var previousHeaderType = null;
        for (var i = 0; i < clauseTypeOptions.length; i++) {
            var clauseType = clauseTypeOptions[i];
            var isSelectedClauseType = selectedClause.clauseType == clauseType;
            var hasClauseType = existingClauseTypes.has(clauseType);
            // Do not add the clause type to the dropdown options if the clause type...
            // 1) is not the current clause's type AND
            // 2) has been used already
            if (!isSelectedClauseType && hasClauseType) {
                continue;
            }
            var clauseTypeProperties = getClauseTypeProperties_1.default(clauseType);
            var clauseHeaderType = clauseTypeProperties.headerType;
            // Only push a header if we are first element or if the next clause type's header is different than the previous's
            if (!previousHeaderType || clauseHeaderType != previousHeaderType) {
                items.push({
                    key: sectionType + clauseHeaderType,
                    text: getHeaderTextFromHeaderType_1.default(clauseHeaderType),
                    itemType: Dropdown_1.DropdownMenuItemType.Header,
                });
            }
            // If clause type is junk, need to make sure the segmentation settings have junk turned on before adding to dropdown
            if (clauseType !== 'junk' || getUserConfiguration_1.default().SegmentationSettings.JunkEMail) {
                items.push({
                    key: this.getDropdownKey(clauseType),
                    text: clauseTypeProperties.dropdownOptionText,
                    data: clauseTypeProperties,
                });
            }
            previousHeaderType = clauseHeaderType;
        }
        return items;
    };
    InboxRuleClause.prototype.getDropdownKey = function (clauseType) {
        return this.props.sectionType + clauseType;
    };
    InboxRuleClause.prototype.onClauseTypeChanged = function (clauseTypeDropdownOption) {
        var clauseId = this.props.clauseId;
        setClauseType_1.default(clauseTypeDropdownOption.data.clauseType, clauseId);
        setClauseValue_1.default(clauseTypeDropdownOption.data.initialValue, clauseId);
        // clear the error text if the previous clause had invalid input
        setClauseErrorText_1.default(clauseId, true /* isValidClause */);
    };
    InboxRuleClause.prototype.onClauseValueChanged = function (clauseValueDropdownOption) {
        var clauseId = this.props.clauseId;
        setClauseValue_1.default(clauseValueDropdownOption.data, clauseId);
        // clear the error text if the previous value was invalid
        setClauseErrorText_1.default(clauseId, true /* isValidClause */);
    };
    InboxRuleClause.prototype.renderIncludesWordsInput = function (clauseId) {
        var _this = this;
        var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        return (React.createElement(IncludesWordsInput_1.default, { clauseId: clauseId, placeHolderText: this.getIncludesWordsPlaceholderText(selectedClause.clauseType), onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); } }));
    };
    InboxRuleClause.prototype.renderClauseValueDropdown = function (dropdownOptionsData) {
        var _this = this;
        var dropdownOptions = [];
        var currentSelectedValue = store_1.default.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var selectedKey = currentSelectedValue ? currentSelectedValue.toString() : null;
        var clauseId = this.props.clauseId;
        dropdownOptionsData.forEach(function (option) {
            dropdownOptions.push({
                key: option.value.toString(),
                text: option.text,
                data: option.value,
            });
        });
        return (React.createElement("div", { className: styles.clauseValueContainer },
            React.createElement(Dropdown_1.Dropdown, { onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); }, options: dropdownOptions, onChanged: function (option) { return _this.onClauseValueChanged(option); }, errorMessage: store_1.default.inboxRulesEditState.clauseErrorTextMap.get(clauseId), placeHolder: owa_options_strings_1.default.options_inboxRules_clauseValueDropdownPlaceholder, selectedKey: selectedKey })));
    };
    InboxRuleClause.prototype.renderFolderDropdown = function (clauseId) {
        var _this = this;
        return (React.createElement(InboxRulesFolderDropdown_1.default, { clauseId: clauseId, dropdownFolderList: store_1.default.dropdownFolders, onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); } }));
    };
    InboxRuleClause.prototype.renderRecipientWell = function (selectedClause) {
        var _this = this;
        var clauseId = this.props.clauseId;
        var errorText = store_1.default.inboxRulesEditState.clauseErrorTextMap.get(this.props.clauseId);
        var value = store_1.default.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var numPeople;
        if (value && value.recipients.length) {
            numPeople = value.recipients.length;
        }
        else {
            numPeople = 0;
        }
        return (React.createElement("div", { className: styles.recipientWellContainer },
            React.createElement("div", { className: classNames(styles.recipientWell, errorText && numPeople == 0 && styles.hasError), tabIndex: -1, onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); } },
                React.createElement(ReadWriteRecipientWellWithFindControl_1.default, { recipientWell: selectedClause.clauseValue, recipientType: RecipientType_1.RecipientType.None, size: 0 /* Small */ })),
            numPeople == 0 && React.createElement("span", { className: styles.recipientWellError },
                " ",
                errorText,
                " ")));
    };
    InboxRuleClause.prototype.renderNumberTextField = function (selectedClause) {
        var _this = this;
        var clauseId = this.props.clauseId;
        return (React.createElement(TextField_1.TextField, { className: styles.clauseDateSizeValueContainer, onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); }, value: selectedClause.clauseValue.toString(), onChanged: this.onTextFieldChanged, errorMessage: store_1.default.inboxRulesEditState.clauseErrorTextMap.get(clauseId), suffix: owa_options_strings_1.default.options_inboxRules_kb }));
    };
    InboxRuleClause.prototype.renderDatePicker = function (selectedClause) {
        var _this = this;
        var selectedClauseValue = selectedClause.clauseValue;
        var todayDate = new Date(owa_datetime_1.now());
        var defaultDate = selectedClauseValue ? new Date(selectedClauseValue) : todayDate;
        return (React.createElement(owa_datepicker_1.default, { ref: function (ref) { return (_this.owaDatePickerControl = ref); }, className: styles.clauseDateSizeValueContainer, isMonthPickerVisible: false, value: defaultDate, onSelectDate: this.onDateSelected, minDate: todayDate }));
    };
    InboxRuleClause.prototype.getIncludesWordsPlaceholderText = function (clauseType) {
        return clauseType == 'inTheSenderAddress' || clauseType == 'inTheRecipientAddress'
            ? owa_options_strings_1.default.options_inboxRules_addressIncludesOptionPlaceholder
            : owa_options_strings_1.default.options_inboxRules_containsOptionPlaceholder;
    };
    // show remove clause button if there is more than one clause in conditional/action sections or for
    // any clause in the exception section
    InboxRuleClause.prototype.shouldShowRemoveClauseButton = function () {
        // always show for exceptions since it's an optional field
        return (this.props.sectionType == 'exception' ||
            // otherwise, show if there is more than one clause in conditional/action sections
            this.props.sectionClauseIds.length > 1);
    };
    InboxRuleClause = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRuleClause);
    return InboxRuleClause;
}(React.Component));
exports.default = InboxRuleClause;
//# sourceMappingURL=InboxRuleClause.js.map

/***/ }),

/***/ 5186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var setClauseValue_1 = __webpack_require__(3178);
var getCustomIcon_1 = __webpack_require__(5187);
var mobx_react_1 = __webpack_require__(11);
var Icon_1 = __webpack_require__(703);
var Dropdown_1 = __webpack_require__(2652);
var owa_mail_strings_1 = __webpack_require__(22);
var React = __webpack_require__(3);
var store_1 = __webpack_require__(2603);
var styles = __webpack_require__(3745);
var InboxRulesFolderDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesFolderDropdown, _super);
    function InboxRulesFolderDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InboxRulesFolderDropdown.prototype.render = function () {
        var _this = this;
        var currentSelectedFolder = store_1.default.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var selectedKey = currentSelectedFolder ? currentSelectedFolder.folderId : null;
        return (React.createElement(Dropdown_1.Dropdown, { onFocus: this.props.onFocus, onBlur: this.props.onBlur, className: styles.moveToDropdown, options: this.getDropdownOptions(), onRenderOption: this.onRenderOption, onRenderTitle: function (options) { return _this.onRenderOption(options[0]); }, onChanged: function (item) { return setClauseValue_1.default(item.data.folder, _this.props.clauseId); }, placeHolder: owa_mail_strings_1.default.ruleSelectFolder, selectedKey: selectedKey }));
    };
    InboxRulesFolderDropdown.prototype.getDropdownOptions = function () {
        var dropdownOptions = [];
        this.props.dropdownFolderList.forEach(function (folder) {
            dropdownOptions.push({
                key: folder.folderId,
                text: folder.displayName,
                data: {
                    folder: folder,
                    icon: getCustomIcon_1.default(folder.folderId, true),
                },
            });
        });
        return dropdownOptions;
    };
    // Render dropdown items and current selection, which consist of icon and foldername
    InboxRulesFolderDropdown.prototype.onRenderOption = function (option) {
        return (React.createElement("div", { className: styles.dropdownItem },
            option.data &&
                option.data.icon && (React.createElement(Icon_1.Icon, { className: styles.customIcon, iconName: option.data.icon })),
            React.createElement("span", null, option.text)));
    };
    InboxRulesFolderDropdown = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRulesFolderDropdown);
    return InboxRulesFolderDropdown;
}(React.Component));
exports.default = InboxRulesFolderDropdown;
//# sourceMappingURL=InboxRulesFolderDropdown.js.map

/***/ }),

/***/ 5187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var folderNameToId_1 = __webpack_require__(35);
/**
 * Get custom icon for special folders like inbox, drafts, sent, deleted, etc.
 * @param showNonSpecialFolderIcon Whether to show generic folder icon
 */
function getCustomIcon(folderId, showNonSpecialFolderIcon) {
    switch (folderId) {
        case folderNameToId_1.default('inbox'):
            return "Inbox" /* Inbox */;
        case folderNameToId_1.default('sentitems'):
            return "Send" /* Send */;
        case folderNameToId_1.default('drafts'):
            return "Edit" /* Edit */;
        case folderNameToId_1.default('deleteditems'):
            return "Delete" /* Delete */;
        case folderNameToId_1.default('archive'):
            return "Archive" /* Archive */;
        case folderNameToId_1.default('junkemail'):
            return "Blocked" /* Blocked */;
        default:
            break;
    }
    if (showNonSpecialFolderIcon) {
        return "FabricFolder" /* FabricFolder */;
    }
    else {
        return null;
    }
}
exports.default = getCustomIcon;
//# sourceMappingURL=getCustomIcon.js.map

/***/ }),

/***/ 5188:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1wcNNN39CRy0xAYO-xTWQQ{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._1wcNNN39CRy0xAYO-xTWQQ{margin-top:8px}._1wcNNN39CRy0xAYO-xTWQQ .ms-TextField-errorMessage{color:#a80000!important}._3zN5bmP8YIJ13j2NoTAzB9{width:240px}._3HU9moRgEpqBBSTotkE7YI,._3ZUk7gk_BC-2eUBlfkrVgj{display:-webkit-box;display:-ms-flexbox;display:flex}.ZABkfKX41DKsaC5P_FGsX{width:280px;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir=ltr] .ZABkfKX41DKsaC5P_FGsX{margin-left:8px}html[dir=rtl] .ZABkfKX41DKsaC5P_FGsX{margin-right:8px}.bUGY3HgtnJgtssaEuh8c5{width:280px}html[dir=ltr] .bUGY3HgtnJgtssaEuh8c5{margin-left:8px}html[dir=rtl] .bUGY3HgtnJgtssaEuh8c5{margin-right:8px}.bUGY3HgtnJgtssaEuh8c5 .ms-TextField-errorMessage{color:#a80000!important}._1Xs0X7ZRaT_Pr1W8tIXEOy{width:240px}html[dir=ltr] ._1Xs0X7ZRaT_Pr1W8tIXEOy{margin-left:8px}html[dir=rtl] ._1Xs0X7ZRaT_Pr1W8tIXEOy{margin-right:8px}._1Xs0X7ZRaT_Pr1W8tIXEOy .ms-TextField-errorMessage{color:#a80000!important}.bvAanIwV90-nn-M6S2_ch{width:25px;height:100%;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir=ltr] .O3aBx21ZR8hXvev9HA6fi{margin-left:8px}html[dir=rtl] .O3aBx21ZR8hXvev9HA6fi{margin-right:8px}._3AFXr35aswvIjh_uBr8ICB{width:340px;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir] ._3AFXr35aswvIjh_uBr8ICB{border:solid 1px \"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir] ._3AFXr35aswvIjh_uBr8ICB.VX2g8JqVVDP_DDhcY6IK_{border-color:#a80000}._6YgnZAZ1reSq21jsVkdEq{color:#a80000!important}", ""]);

// exports
exports.locals = {
	"clauseContainer": "_1wcNNN39CRy0xAYO-xTWQQ",
	"clauseTypesDropdown": "_3zN5bmP8YIJ13j2NoTAzB9",
	"dropdownItem": "_3HU9moRgEpqBBSTotkE7YI",
	"inboxRuleClauseContainer": "_3ZUk7gk_BC-2eUBlfkrVgj",
	"moveToDropdown": "ZABkfKX41DKsaC5P_FGsX",
	"clauseValueContainer": "bUGY3HgtnJgtssaEuh8c5",
	"clauseDateSizeValueContainer": "_1Xs0X7ZRaT_Pr1W8tIXEOy",
	"customIcon": "bvAanIwV90-nn-M6S2_ch",
	"recipientWellContainer": "O3aBx21ZR8hXvev9HA6fi",
	"recipientWell": "_3AFXr35aswvIjh_uBr8ICB",
	"hasError": "VX2g8JqVVDP_DDhcY6IK_",
	"recipientWellError": "_6YgnZAZ1reSq21jsVkdEq"
};

/***/ }),

/***/ 5189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var PhrasePill_1 = __webpack_require__(5190);
var addPhraseToClause_1 = __webpack_require__(5193);
var removePhraseFromClause_1 = __webpack_require__(3746);
var setClauseErrorText_1 = __webpack_require__(3179);
var setIncludesWordsInputText_1 = __webpack_require__(3749);
var store_1 = __webpack_require__(2603);
var mobx_1 = __webpack_require__(15);
var mobx_react_1 = __webpack_require__(11);
var KeyboardCharCodes_1 = __webpack_require__(634);
var React = __webpack_require__(3);
var styles = __webpack_require__(5194);
var classNames = __webpack_require__(30).bind(styles);
var IncludesWordsInputComputedState = /** @class */ (function () {
    function IncludesWordsInputComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(IncludesWordsInputComputedState.prototype, "isFocused", {
        get: function () {
            return store_1.default.inboxRulesEditState.focusedClauseId == this.props.clauseId;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], IncludesWordsInputComputedState.prototype, "isFocused", null);
    return IncludesWordsInputComputedState;
}());
var IncludesWordsInput = /** @class */ (function (_super) {
    tslib_1.__extends(IncludesWordsInput, _super);
    function IncludesWordsInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onInputChange = function () {
            setIncludesWordsInputText_1.default(_this.props.clauseId, _this.inputRef.value);
        };
        _this.onKeyDown = function (evt) {
            var clauseId = _this.props.clauseId;
            var inputText = store_1.default.inboxRulesEditState.includesWordsInputTextMap.get(clauseId);
            switch (evt.keyCode) {
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                    evt.stopPropagation();
                    if (_this.isValidInput(inputText)) {
                        // clear the error text in case the user is creating their first pill while the error state is shown
                        setClauseErrorText_1.default(clauseId, true /*isValidClause*/);
                        addPhraseToClause_1.default(clauseId, inputText, 'Keyboard');
                    }
                    break;
                case KeyboardCharCodes_1.BACKSPACE_CHARCODE:
                    evt.stopPropagation();
                    if (!inputText) {
                        _this.removeLastPhraseFromClause(clauseId, inputText);
                    }
                    break;
            }
        };
        _this.onBlur = function () {
            var inputText = store_1.default.inboxRulesEditState.includesWordsInputTextMap.get(_this.props.clauseId);
            if (_this.isValidInput(inputText)) {
                addPhraseToClause_1.default(_this.props.clauseId, inputText, 'Blur');
            }
            _this.props.onBlur();
        };
        _this.computedState = new IncludesWordsInputComputedState(_this.props);
        return _this;
    }
    IncludesWordsInput.prototype.render = function () {
        var _this = this;
        var clauseId = this.props.clauseId;
        var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        var errorText = store_1.default.inboxRulesEditState.clauseErrorTextMap.get(clauseId);
        var committedPhrases = selectedClause.clauseValue;
        var inputContainerClassName = classNames(styles.includesWordsInputContainer, this.computedState.isFocused && styles.inputFocused, errorText && styles.hasError);
        return (React.createElement("div", { className: styles.includesWordsContainer },
            React.createElement("div", { className: inputContainerClassName },
                this.renderCommittedPhrases(committedPhrases),
                React.createElement("input", { ref: function (ref) { return (_this.inputRef = ref); }, onFocus: this.props.onFocus, onBlur: this.onBlur, className: styles.phraseInput, value: store_1.default.inboxRulesEditState.includesWordsInputTextMap.get(clauseId), placeholder: committedPhrases.length > 0 ? '' : this.props.placeHolderText, onChange: this.onInputChange, onKeyDown: this.onKeyDown })),
            store_1.default.inboxRulesEditState.clauseErrorTextMap.get(clauseId) && (React.createElement("span", { className: styles.invalidInput }, errorText))));
    };
    IncludesWordsInput.prototype.renderCommittedPhrases = function (committedPhrases) {
        var _this = this;
        var phrasePills = [];
        if (committedPhrases.length > 0) {
            committedPhrases.forEach(function (phrase) {
                phrasePills.push(React.createElement(PhrasePill_1.default, { key: phrase, clauseId: _this.props.clauseId, phrase: phrase }));
            });
        }
        return phrasePills;
    };
    IncludesWordsInput.prototype.isValidInput = function (inputText) {
        // if user presses enter with empty input or only whitespace, input is invalid
        return inputText && inputText.trim().length > 0;
    };
    IncludesWordsInput.prototype.removeLastPhraseFromClause = function (clauseId, phrase) {
        var existingPhrases = store_1.default.inboxRulesEditState.clauseMap.get(clauseId)
            .clauseValue;
        // if there are no phrases to delete (if a user presses backspace on an empty input), do nothing
        if (!existingPhrases || existingPhrases.length == 0) {
            return;
        }
        removePhraseFromClause_1.default(this.props.clauseId, existingPhrases[existingPhrases.length - 1]);
    };
    IncludesWordsInput = tslib_1.__decorate([
        mobx_react_1.observer
    ], IncludesWordsInput);
    return IncludesWordsInput;
}(React.Component));
exports.default = IncludesWordsInput;
//# sourceMappingURL=IncludesWordsInput.js.map

/***/ }),

/***/ 5190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var removePhraseFromClause_1 = __webpack_require__(3746);
var Button_1 = __webpack_require__(62);
var isValidClause_1 = __webpack_require__(3078);
var setClauseErrorText_1 = __webpack_require__(3179);
var styles = __webpack_require__(5191);
/*
Phrase pills are used in the 'includes these words' clauses for inbox rules.
A user enters text in the input and presses enter to commit the phrase and
create a phrase pill
*/
var PhrasePill = /** @class */ (function (_super) {
    tslib_1.__extends(PhrasePill, _super);
    function PhrasePill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PhrasePill.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: styles.phrasePill },
            React.createElement("span", { className: styles.phrasePillText }, this.props.phrase),
            React.createElement(Button_1.IconButton, { className: styles.phrasePillClose, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: styles.cancelIcon,
                    },
                }, onClick: function () {
                    removePhraseFromClause_1.default(_this.props.clauseId, _this.props.phrase);
                    setClauseErrorText_1.default(_this.props.clauseId, isValidClause_1.default(_this.props.clauseId));
                } })));
    };
    PhrasePill = tslib_1.__decorate([
        mobx_react_1.observer
    ], PhrasePill);
    return PhrasePill;
}(React.Component));
exports.default = PhrasePill;
//# sourceMappingURL=PhrasePill.js.map

/***/ }),

/***/ 5191:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5192);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5192:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3eIcQa2E4W2ipSB_tlwMEm{-ms-flex-negative:1;flex-shrink:1;height:24px;line-height:24px;display:-webkit-box;display:-ms-flexbox;display:flex;max-width:250px}html[dir] ._3eIcQa2E4W2ipSB_tlwMEm{background:\"[theme:neutralLighter, default:#f4f4f4]\";margin:3px;border-radius:15px}html[dir] ._3eIcQa2E4W2ipSB_tlwMEm:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}._1-Lvz53isftWuYtqYAsLC_{line-height:24px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}html[dir] ._1-Lvz53isftWuYtqYAsLC_{margin:0 8px}html[dir=ltr] ._1-Lvz53isftWuYtqYAsLC_{margin:0 5px 0 8px}html[dir=rtl] ._1-Lvz53isftWuYtqYAsLC_{margin:0 8px 0 5px}.iKsjJlne08gbcHqeEMq1h{width:24px;height:24px}html[dir] .iKsjJlne08gbcHqeEMq1h{border-radius:50%;padding:0}.iKsjJlne08gbcHqeEMq1h .WuNwTvRuQbyedp1bxQrb1{font-size:12px;font-weight:400;color:\"[theme:black, default:#000000]\"}html[dir] ._3eIcQa2E4W2ipSB_tlwMEm:hover .iKsjJlne08gbcHqeEMq1h{background-color:\"[theme:neutralTertiaryAlt, default:#c8c8c8]\"}._17XDBd62aBJA23GKR7GLbx{overflow:hidden;text-overflow:ellipsis;max-width:60vw}", ""]);

// exports
exports.locals = {
	"phrasePill": "_3eIcQa2E4W2ipSB_tlwMEm",
	"phrasePillText": "_1-Lvz53isftWuYtqYAsLC_",
	"phrasePillClose": "iKsjJlne08gbcHqeEMq1h",
	"cancelIcon": "WuNwTvRuQbyedp1bxQrb1",
	"phrasePillTextOverflow": "_17XDBd62aBJA23GKR7GLbx"
};

/***/ }),

/***/ 5193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var setClauseValue_1 = __webpack_require__(3178);
var legacy_1 = __webpack_require__(1);
var datapoints_1 = __webpack_require__(2896);
/**
 * Adds a phrase to a 'contains words' clause value
 * @param clauseId the id of the clause to add the phrase to
 * @param phraseToAdd the phrase to add the the clause value
 * @param actionSource the source of the action (onBlur, keyboard)
 */
exports.default = legacy_1.action('addPhraseToClause', datapoints_1.default.addPhraseToClauseDatapoint)(function addPhraseToClause(clauseId, phraseToAdd, actionSource) {
    var existingPhrases = store_1.default.inboxRulesEditState.clauseMap.get(clauseId)
        .clauseValue;
    if (!existingPhrases) {
        existingPhrases = [];
    }
    // only add unique, non-empty phrases
    if (existingPhrases.indexOf(phraseToAdd) == -1) {
        existingPhrases.push(phraseToAdd);
        setClauseValue_1.default(existingPhrases, clauseId);
        // clear the input field if the phrase was added
        store_1.default.inboxRulesEditState.includesWordsInputTextMap.set(clauseId, '');
    }
});
//# sourceMappingURL=addPhraseToClause.js.map

/***/ }),

/***/ 5194:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5195);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5195:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1_8srNGysNwkF4nsN8uuMb{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:inherit;flex-wrap:inherit}._2ud82diZn0MUkHnBnWZs9Y{width:280px}html[dir=ltr] ._2ud82diZn0MUkHnBnWZs9Y{margin-right:16px}html[dir=rtl] ._2ud82diZn0MUkHnBnWZs9Y{margin-left:16px}._2kXEO9ayoZydD1J4gReaH6{width:25px;height:100%;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir=ltr] ._1OcrrwDviYOsEyiwiVQGQ{margin-left:8px}html[dir=rtl] ._1OcrrwDviYOsEyiwiVQGQ{margin-right:8px}._30nrVu7k772h_rTkTTlRnm{width:340px;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:30px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:wrap row;flex-flow:wrap row}html[dir] ._30nrVu7k772h_rTkTTlRnm{border:1px solid \"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir] ._30nrVu7k772h_rTkTTlRnm:hover{border-color:\"[theme:themeDarker, default:#004578]\"}html[dir] ._30nrVu7k772h_rTkTTlRnm._3l3LtytLY3tkpExNYKaJu2{border-color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._30nrVu7k772h_rTkTTlRnm._324Y-SxYWw8sNtAW07LcRH{border-color:#a80000}._2U-wCtqPw4zAS3vhQzMA-h{color:#a80000}._1o3gVWuW9zzjTybLnxjIe9{min-width:30px;line-height:22px;-webkit-box-flex:1;-ms-flex:1;flex:1}html[dir] ._1o3gVWuW9zzjTybLnxjIe9{border:0}html[dir=ltr] ._1o3gVWuW9zzjTybLnxjIe9{margin-left:12px}html[dir=rtl] ._1o3gVWuW9zzjTybLnxjIe9{margin-right:12px}", ""]);

// exports
exports.locals = {
	"clausePhrasesContainer": "_1_8srNGysNwkF4nsN8uuMb",
	"clauseValueInputContainer": "_2ud82diZn0MUkHnBnWZs9Y",
	"customIcon": "_2kXEO9ayoZydD1J4gReaH6",
	"includesWordsContainer": "_1OcrrwDviYOsEyiwiVQGQ",
	"includesWordsInputContainer": "_30nrVu7k772h_rTkTTlRnm",
	"inputFocused": "_3l3LtytLY3tkpExNYKaJu2",
	"hasError": "_324Y-SxYWw8sNtAW07LcRH",
	"invalidInput": "_2U-wCtqPw4zAS3vhQzMA-h",
	"phraseInput": "_1o3gVWuW9zzjTybLnxjIe9"
};

/***/ }),

/***/ 5196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_datetime_1 = __webpack_require__(207);
var createRecipientWell_1 = __webpack_require__(2046);
var owa_options_strings_1 = __webpack_require__(1737);
function getClauseTypeProperties(clauseType) {
    switch (clauseType) {
        case 'moveTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_moveTo,
                headerType: 'organize',
                initialValue: null,
            };
        case 'copyTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_copyTo,
                headerType: 'organize',
                initialValue: null,
            };
        case 'delete':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_delete,
                headerType: 'organize',
                initialValue: null,
            };
        case 'pin':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_pinToTop,
                headerType: 'organize',
                initialValue: null,
            };
        case 'read':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_read,
                headerType: 'markMessage',
                initialValue: null,
            };
        case 'junk':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_junk,
                headerType: 'markMessage',
                initialValue: null,
            };
        case 'markImportance':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_importance,
                headerType: 'markMessage',
                initialValue: null,
            };
        case 'forwardTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_forwardTo,
                headerType: 'route',
                initialValue: createRecipientWell_1.default(),
            };
        case 'forwardAsAttachmentTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_forwardAsAttachmentTo,
                headerType: 'route',
                initialValue: createRecipientWell_1.default(),
            };
        case 'redirectTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_redirectTo,
                headerType: 'route',
                initialValue: createRecipientWell_1.default(),
            };
        case 'from':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_from,
                headerType: 'addresses',
                initialValue: createRecipientWell_1.default(),
            };
        case 'to':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_to,
                headerType: 'addresses',
                initialValue: createRecipientWell_1.default(),
            };
        case 'onTheToOrCcLine':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_toOrCcLine,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'theOnlyRecipientListed':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_onlyRecipient,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'onTheToLine':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_toLine,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'onTheCcLine':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_ccLine,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'notOnTheToLine':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_notToLine,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'subjectIncludes':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_subjectIncludes,
                headerType: 'subject',
                initialValue: [],
            };
        case 'subjectOrBodyIncludes':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_subjectOrBodyIncludes,
                headerType: 'subject',
                initialValue: [],
            };
        case 'inTheBody':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_inBody,
                headerType: 'includesTheseWords',
                initialValue: [],
            };
        case 'inTheSenderAddress':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_inSenderAddress,
                headerType: 'includesTheseWords',
                initialValue: [],
            };
        case 'inTheRecipientAddress':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_inRecipientAddress,
                headerType: 'includesTheseWords',
                initialValue: [],
            };
        case 'inTheMessageHeader':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_inMessageHeader,
                headerType: 'includesTheseWords',
                initialValue: [],
            };
        case 'withImportance':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_importance,
                headerType: 'markedWith',
                initialValue: null,
            };
        case 'sensitivity':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_sensitivity,
                headerType: 'markedWith',
                initialValue: null,
            };
        case 'flag':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_flag,
                headerType: 'messageIncludes',
                initialValue: null,
            };
        case 'type':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_type,
                headerType: 'messageIncludes',
                initialValue: null,
            };
        case 'attachment':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_attachment,
                headerType: 'messageIncludes',
                initialValue: null,
            };
        case 'atLeast':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_atLeast,
                headerType: 'messageSize',
                initialValue: 0,
            };
        case 'atMost':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_atMost,
                headerType: 'messageSize',
                initialValue: 0,
            };
        case 'before':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_before,
                headerType: 'received',
                initialValue: new Date(owa_datetime_1.now()),
            };
        case 'after':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_after,
                headerType: 'received',
                initialValue: new Date(owa_datetime_1.now()),
            };
        default:
            throw new Error('Cannot get clause type properties for a clause type that does not exist');
    }
}
exports.default = getClauseTypeProperties;
//# sourceMappingURL=getClauseTypeProperties.js.map

/***/ }),

/***/ 5197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = __webpack_require__(1737);
function getHeaderTextFromHeaderType(headerType) {
    switch (headerType) {
        case 'organize':
            return owa_options_strings_1.default.options_inboxRules_organize;
        case 'markMessage':
            return owa_options_strings_1.default.options_inboxRules_markMessage;
        case 'route':
            return owa_options_strings_1.default.options_inboxRules_route;
        case 'addresses':
            return owa_options_strings_1.default.options_inboxRules_people;
        case 'myNameIs':
            return owa_options_strings_1.default.options_inboxRules_myNameIs;
        case 'subject':
            return owa_options_strings_1.default.options_inboxRules_subject;
        case 'includesTheseWords':
            return owa_options_strings_1.default.options_inboxRules_includesWords;
        case 'markedWith':
            return owa_options_strings_1.default.options_inboxRules_markedWith;
        case 'messageIncludes':
            return owa_options_strings_1.default.options_inboxRules_messageIncludes;
        case 'messageSize':
            return owa_options_strings_1.default.options_inboxRules_messageSize;
        case 'received':
            return owa_options_strings_1.default.options_inboxRules_received;
        default:
            throw new Error('Cannot get header text for a header type that does not exist');
    }
}
exports.default = getHeaderTextFromHeaderType;
//# sourceMappingURL=getHeaderTextFromHeaderType.js.map

/***/ }),

/***/ 5198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = __webpack_require__(1737);
function getImportanceOptions() {
    return [
        { value: 'High', text: owa_options_strings_1.default.options_inboxRules_high },
        { value: 'Normal', text: owa_options_strings_1.default.options_inboxRules_normal },
        { value: 'Low', text: owa_options_strings_1.default.options_inboxRules_low },
    ];
}
exports.default = getImportanceOptions;
//# sourceMappingURL=getImportanceOptions.js.map

/***/ }),

/***/ 5199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = __webpack_require__(1737);
function getInboxRuleMessageFlagOptions() {
    return [
        { value: 'Any', text: owa_options_strings_1.default.options_inboxRules_any },
        { value: 'Call', text: owa_options_strings_1.default.options_inboxRules_call },
        { value: 'DoNotForward', text: owa_options_strings_1.default.options_inboxRules_doNotForward },
        { value: 'FollowUp', text: owa_options_strings_1.default.options_inboxRules_followUp },
        { value: 'Forward', text: owa_options_strings_1.default.options_inboxRules_forward },
        { value: 'ForYourInformation', text: owa_options_strings_1.default.options_inboxRules_forYourInformation },
        { value: 'NoResponseNecessary', text: owa_options_strings_1.default.options_inboxRules_noResponseNecessary },
        { value: 'Read', text: owa_options_strings_1.default.options_inboxRules_read },
        { value: 'Reply', text: owa_options_strings_1.default.options_inboxRules_reply },
        { value: 'ReplyToAll', text: owa_options_strings_1.default.options_inboxRules_replyToAll },
        { value: 'Review', text: owa_options_strings_1.default.options_inboxRules_review },
    ];
}
exports.default = getInboxRuleMessageFlagOptions;
//# sourceMappingURL=getInboxRuleMessageFlagOptions.js.map

/***/ }),

/***/ 5200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = __webpack_require__(1737);
function getInboxRuleMessageTypeOptions() {
    return [
        { value: 'ApprovalRequest', text: owa_options_strings_1.default.options_inboxRules_requestForApproval },
        { value: 'AutomaticForward', text: owa_options_strings_1.default.options_inboxRules_automaticallyForwarded },
        { value: 'AutomaticReply', text: owa_options_strings_1.default.options_inboxRules_automaticReply },
        { value: 'Calendaring', text: owa_options_strings_1.default.options_inboxRules_invitation },
        { value: 'CalendaringResponse', text: owa_options_strings_1.default.options_inboxRules_eventResponse },
        { value: 'Encrypted', text: owa_options_strings_1.default.options_inboxRules_encrypted },
        { value: 'NonDeliveryReport', text: owa_options_strings_1.default.options_inboxRules_nonDeliveryReport },
        { value: 'PermissionControlled', text: owa_options_strings_1.default.options_inboxRules_permissionControlled },
        { value: 'ReadReceipt', text: owa_options_strings_1.default.options_inboxRules_readReceipt },
        { value: 'Signed', text: owa_options_strings_1.default.options_inboxRules_signed },
        { value: 'Voicemail', text: owa_options_strings_1.default.options_inboxRules_voiceMail },
    ];
}
exports.default = getInboxRuleMessageTypeOptions;
//# sourceMappingURL=getInboxRuleMessageTypeOptions.js.map

/***/ }),

/***/ 5201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = __webpack_require__(1737);
function getSensitivityOptions() {
    return [
        { value: 'CompanyConfidential', text: owa_options_strings_1.default.options_inboxRules_companyConfidential },
        { value: 'Normal', text: owa_options_strings_1.default.options_inboxRules_normal },
        { value: 'Personal', text: owa_options_strings_1.default.options_inboxRules_personal },
        { value: 'Private', text: owa_options_strings_1.default.options_inboxRules_private },
    ];
}
exports.default = getSensitivityOptions;
//# sourceMappingURL=getSensitivityOptions.js.map

/***/ }),

/***/ 5202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Removes a clause from the rules edit page
 * @param clauseId the id of the clause to remove
 * @param sectionType the section that the clause belongs to (action, conditional, exception)
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesEditState; },
})(legacy_1.action('removeClause')(function removeClause(clauseId, sectionType, state) {
    var optionState = state.optionState;
    optionState.clauseMap.delete(clauseId);
    if (sectionType == 'conditional') {
        var indexToDelete = optionState.conditionalClauseIds.indexOf(clauseId);
        optionState.conditionalClauseIds.splice(indexToDelete, 1);
    }
    else if (sectionType == 'action') {
        var indexToDelete = optionState.actionClauseIds.indexOf(clauseId);
        optionState.actionClauseIds.splice(indexToDelete, 1);
    }
    else if (sectionType == 'exception') {
        var indexToDelete = optionState.exceptionClauseIds.indexOf(clauseId);
        optionState.exceptionClauseIds.splice(indexToDelete, 1);
    }
    else {
        throw new Error('Cannot remove clause in section type that does not exist');
    }
}));
//# sourceMappingURL=removeClause.js.map

/***/ }),

/***/ 5203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setClauseType')(function setClauseType(clauseType, clauseId) {
    store_1.default.inboxRulesEditState.clauseMap.get(clauseId).clauseType = clauseType;
});
//# sourceMappingURL=setClauseType.js.map

/***/ }),

/***/ 5209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var isValidClause_1 = __webpack_require__(3078);
function getSectionCompletionStatus(sectionType, sectionClauseIds) {
    var focusedClauseId = store_1.default.inboxRulesEditState.focusedClauseId;
    // name section is a special case -- no clause Id
    if (sectionType == 'name') {
        if (focusedClauseId == 'name') {
            return 2 /* InProgress */;
        }
        else if (store_1.default.inboxRulesEditState.ruleName &&
            store_1.default.inboxRulesEditState.ruleName.trim().length > 0) {
            return 1 /* Complete */;
        }
        else {
            return 0 /* Incomplete */;
        }
    }
    if (sectionClauseIds.indexOf(focusedClauseId) > -1) {
        return 2 /* InProgress */;
    }
    else if (isValidClause_1.isValidSection(sectionType)) {
        return 1 /* Complete */;
    }
    else {
        return 0 /* Incomplete */;
    }
}
exports.default = getSectionCompletionStatus;
//# sourceMappingURL=getSectionCompletionStatus.js.map

/***/ }),

/***/ 5210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setRuleName')(function setRuleName(newRuleName) {
    store_1.default.inboxRulesEditState.ruleName = newRuleName;
});
//# sourceMappingURL=setRuleName.js.map

/***/ }),

/***/ 5211:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5212);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5212:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._2anBe95rpkEc1VhokgtNY8{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._2anBe95rpkEc1VhokgtNY8{padding-left:0}html[dir=rtl] ._2anBe95rpkEc1VhokgtNY8{padding-right:0}._1Xnz9ROVMa1uua_ox-iyqR{color:#a80000;font-size:12px}._1fmsOPADl3gRzWrV72Jr4H{width:590px}._1fmsOPADl3gRzWrV72Jr4H .ms-TextField-errorMessage{color:#a80000!important}._2rCtGjrtUi0oWCulRJbs_o{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}html[dir] ._2rCtGjrtUi0oWCulRJbs_o{padding:14px 0}._3XhLKfthx8LaOEQKYlFd7M{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;width:32px;height:32px;font-size:16px;color:#fff}html[dir] ._3XhLKfthx8LaOEQKYlFd7M{border-radius:50%;background-color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._3XhLKfthx8LaOEQKYlFd7M{margin-right:16px}html[dir=rtl] ._3XhLKfthx8LaOEQKYlFd7M{margin-left:16px}._2oRrGZda1ppOZ8BTqIZgMD{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;width:32px;height:32px;font-size:16px;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._2oRrGZda1ppOZ8BTqIZgMD{border-radius:50%;background-color:\"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] ._2oRrGZda1ppOZ8BTqIZgMD{margin-right:16px}html[dir=rtl] ._2oRrGZda1ppOZ8BTqIZgMD{margin-left:16px}._3357dbGgQ7fCRPenoOsBrW{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;width:32px;height:32px;font-size:16px}html[dir] ._3357dbGgQ7fCRPenoOsBrW{border-radius:50%;background-color:\"[theme:themeLighter, default:#DEECF9]\"}html[dir=ltr] ._3357dbGgQ7fCRPenoOsBrW{margin-right:16px}html[dir=rtl] ._3357dbGgQ7fCRPenoOsBrW{margin-left:16px}._2pKM1Z-R2Rcw23BUy9R1If{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap}._2pKM1Z-R2Rcw23BUy9R1If,._26Q7Fo-ciwszxKpr0IipWB{display:-webkit-box;display:-ms-flexbox;display:flex}._26Q7Fo-ciwszxKpr0IipWB{height:32px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:16px}html[dir] ._26Q7Fo-ciwszxKpr0IipWB{margin-bottom:8px}.bfyh9kRnWKxBIWiehFMOd{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] .bfyh9kRnWKxBIWiehFMOd{padding-left:0}html[dir=rtl] .bfyh9kRnWKxBIWiehFMOd{padding-right:0}._2_Xgc54wVr_nEbkI9_Ea6E{color:\"[theme:themePrimary, default:#0078D7]\"}", ""]);

// exports
exports.locals = {
	"addAnExceptionButton": "_2anBe95rpkEc1VhokgtNY8",
	"invalidInput": "_1Xnz9ROVMa1uua_ox-iyqR",
	"ruleNameContainer": "_1fmsOPADl3gRzWrV72Jr4H",
	"sectionContainer": "_2rCtGjrtUi0oWCulRJbs_o",
	"inProgressSection": "_3XhLKfthx8LaOEQKYlFd7M",
	"incompleteSection": "_2oRrGZda1ppOZ8BTqIZgMD",
	"completeSection": "_3357dbGgQ7fCRPenoOsBrW",
	"sectionDetails": "_2pKM1Z-R2Rcw23BUy9R1If",
	"sectionLabel": "_26Q7Fo-ciwszxKpr0IipWB",
	"addClause": "bfyh9kRnWKxBIWiehFMOd",
	"sectionCompleteCheckmark": "_2_Xgc54wVr_nEbkI9_Ea6E"
};

/***/ }),

/***/ 5213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Changes the ignoreSubsequentRules value in the inbox rule edit store
 * @param shouldIgnoreSubsequentRules value to set, sets the corresponding value for the inbox rule
 */
exports.default = legacy_1.action('setIgnoreSubsequentRules')(function setIgnoreSubsequentRules(shouldIgnoreSubsequentRules) {
    store_1.default.inboxRulesEditState.ignoreSubsequentRules = shouldIgnoreSubsequentRules;
});
//# sourceMappingURL=setIgnoreSubsequentRules.js.map

/***/ }),

/***/ 5214:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5215);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5215:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3XnU1DZiD6daIApAOrCdwM{display:-webkit-box;display:-ms-flexbox;display:flex}._2DR1SRhuUBy8y-7DO1KD5p{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._2DR1SRhuUBy8y-7DO1KD5p{margin-top:2px}html[dir=ltr] ._2DR1SRhuUBy8y-7DO1KD5p{padding-left:0}html[dir=rtl] ._2DR1SRhuUBy8y-7DO1KD5p{padding-right:0}._1z4cMAA6XzOY3uTga1DJDv{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._1z4cMAA6XzOY3uTga1DJDv{padding-left:0}html[dir=rtl] ._1z4cMAA6XzOY3uTga1DJDv{padding-right:0}._1z4cMAA6XzOY3uTga1DJDv ._2bbbxifO4lVoIDavAP3u3j{font-size:12px}html[dir] ._1z4cMAA6XzOY3uTga1DJDv ._2bbbxifO4lVoIDavAP3u3j{margin-top:2px}html[dir=ltr] ._1z4cMAA6XzOY3uTga1DJDv ._2bbbxifO4lVoIDavAP3u3j{margin-left:0}html[dir=rtl] ._1z4cMAA6XzOY3uTga1DJDv ._2bbbxifO4lVoIDavAP3u3j{margin-right:0}", ""]);

// exports
exports.locals = {
	"ignoreSubsequentRulesCheckbox": "_3XnU1DZiD6daIApAOrCdwM",
	"ignoreSubsequentRulesLearnMore": "_2DR1SRhuUBy8y-7DO1KD5p",
	"ruleCommandButton": "_1z4cMAA6XzOY3uTga1DJDv",
	"icon": "_2bbbxifO4lVoIDavAP3u3j"
};

/***/ }),

/***/ 5216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2896);
var setInboxRuleDiagnosticRequestStatus_1 = __webpack_require__(3752);
var getOutlookMigrationDiagnosticsService_1 = __webpack_require__(5217);
var owa_analytics_1 = __webpack_require__(12);
var legacy_1 = __webpack_require__(1);
/**
 * Generates an inbox rule diagnostic report
 */
exports.default = legacy_1.action('generateInboxRulesDiagnosticReport', datapoints_1.default.generateInboxRulesDiagnosticReportDatapoint)(function removeInboxRule(state) {
    setInboxRuleDiagnosticRequestStatus_1.default(1 /* Pending */);
    var dataPoint = owa_analytics_1.returnTopExecutingActionDatapoint();
    // TODO: Task 20143: Full error handling / success notification support
    return getOutlookMigrationDiagnosticsService_1.default()
        .then(function (response) {
        if (response) {
            setInboxRuleDiagnosticRequestStatus_1.default(2 /* Complete */);
        }
        else {
            dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, new Error('GetOutlookMigrationDiagnostics service request failed'));
            setInboxRuleDiagnosticRequestStatus_1.default(3 /* Error */);
        }
    })
        .catch(function (error) {
        dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error.message);
        setInboxRuleDiagnosticRequestStatus_1.default(3 /* Error */);
    });
});
//# sourceMappingURL=generateInboxRulesDiagnosticReport.js.map

/***/ }),

/***/ 5217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getOutlookMigrationDiagnosticsRequest_1 = __webpack_require__(3753);
var getOutlookDotComMigrationDiagnosticsOperation_1 = __webpack_require__(5218);
var getUserConfiguration_1 = __webpack_require__(9);
/**
 * Helper method that creates the GetOutlookMigrationDiagnosticsRequest body
 * @return GetOutlookMigrationDiagnosticsRequest
 */
function createRequestBody() {
    var sessionSettings = getUserConfiguration_1.default().SessionSettings;
    var emailAddresses = [
        {
            EmailAddress: sessionSettings.UserEmailAddress,
            Name: sessionSettings.UserDisplayName,
            RoutingType: 'SMTP',
        },
    ];
    return getOutlookMigrationDiagnosticsRequest_1.default({ SendReportToAddresses: emailAddresses });
}
/**
 * Get rules diagnostics report
 * @return GetOutlookMigrationDiagnosticsRequest
 */
function getOutlookMigrationDiagnosticsService() {
    var requestBody = createRequestBody();
    return getOutlookDotComMigrationDiagnosticsOperation_1.default(requestBody);
}
exports.default = getOutlookMigrationDiagnosticsService;
//# sourceMappingURL=getOutlookMigrationDiagnosticsService.js.map

/***/ }),

/***/ 5218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getOutlookMigrationDiagnosticsRequest_1 = __webpack_require__(3753);
function getOutlookDotComMigrationDiagnosticsOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = getOutlookMigrationDiagnosticsRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("GetOutlookDotComMigrationDiagnostics", req, options);
}
exports.default = getOutlookDotComMigrationDiagnosticsOperation;


/***/ }),

/***/ 5219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Set the getInboxRuleRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules request status to set
 * @param state the state which contains the store
 */
exports.default = legacy_1.action('setGetInboxRuleRequestStatus')(legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(function setGetInboxRuleRequestStatus(requestStatus, state) {
    var optionState = state.optionState;
    optionState.getInboxRuleRequestStatus = requestStatus;
}));
//# sourceMappingURL=setGetInboxRuleRequestStatus.js.map

/***/ }),

/***/ 5220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getInboxRuleRequest_1 = __webpack_require__(3755);
var getInboxRuleOperation_1 = __webpack_require__(5221);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Helper method that creates the GetInboxRuleRequest body
 * @return GetInboxRuleRequest
 */
function createRequestBody() {
    return getInboxRuleRequest_1.default({ Header: ServiceRequestUtils_1.getJsonRequestHeader() });
}
/**
 * Get inbox rules service
 * @return the GetInboxRuleResponse
 */
function getInboxRulesService() {
    var requestBody = createRequestBody();
    return getInboxRuleOperation_1.default(requestBody);
}
exports.default = getInboxRulesService;
//# sourceMappingURL=getInboxRulesService.js.map

/***/ }),

/***/ 5221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getInboxRuleRequest_1 = __webpack_require__(3755);
function getInboxRuleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = getInboxRuleRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("GetInboxRule", req, options);
}
exports.default = getInboxRuleOperation;


/***/ }),

/***/ 5222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var findFoldersService_1 = __webpack_require__(5223);
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
var folderNameToId_1 = __webpack_require__(35);
var getMoveToDropdownFolders_1 = __webpack_require__(5224);
var setFindFoldersRequestStatus_1 = __webpack_require__(5225);
var HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG = '0x10f4';
/**
 * Makes the find folder service call and adds the folders to the create/edit inbox rule store
 */
exports.default = legacy_1.action('initializeInboxRulesFolders')(legacy_1.select({
    optionState: function () { return store_1.default; },
})(function initializeInboxRulesFolders(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rootFolderId, optionState;
        return tslib_1.__generator(this, function (_a) {
            rootFolderId = folderNameToId_1.default('msgfolderroot');
            optionState = state.optionState;
            setFindFoldersRequestStatus_1.default(1 /* Pending */);
            return [2 /*return*/, findFoldersService_1.default(rootFolderId)
                    .then(function (response) {
                    if (response.ResponseClass == 'Success') {
                        addFoldersFromFindFolder(optionState, response);
                        setFindFoldersRequestStatus_1.default(2 /* Complete */);
                    }
                })
                    .catch(function (error) {
                    setFindFoldersRequestStatus_1.default(3 /* Error */);
                    return;
                })];
        });
    });
}));
// VSTS 23155: Refactor load folders to not have pass by reference pattern
var addFoldersFromFindFolder = legacy_1.action('addFoldersFromFindFolder')(function addFoldersFromFindFolder(state, responseMessage) {
    var folderIds = [];
    var folders = new Map();
    var junkFolderId = folderNameToId_1.default('junkemail');
    // process all of the folders in the response
    responseMessage.RootFolder.Folders.forEach(function (item) {
        var folderId = item.FolderId.Id;
        addFolderToMap(item, folders);
        folderIds.push(folderId);
        if (folderId === junkFolderId) {
            state.junkFolderDisplayName = item.DisplayName;
        }
    });
    // process the ParentFolder from the response, and set it as the root
    addFolderToMap(responseMessage.RootFolder.ParentFolder, folders);
    var rootFolder = folders.get(responseMessage.RootFolder.ParentFolder.FolderId.Id);
    // set up all of the parent-child folder relations
    folderIds.forEach(function (folderId) {
        var folder = folders.get(folderId);
        var parentFolder = folders.get(folder.parentFolderId);
        if (parentFolder && !folder.isHidden) {
            parentFolder.childFolderIds.push(folderId);
        }
    });
    //create move to dropdown folder list
    state.dropdownFolders = getMoveToDropdownFolders_1.default(folders, rootFolder);
});
function addFolderToMap(item, folderMap) {
    var folder = {
        childFolderIds: [],
        displayName: item.DisplayName,
        folderId: item.FolderId.Id,
        folderType: item.__type,
        isHidden: getIsFolderHidden(item),
        parentFolderId: item.ParentFolderId.Id,
    };
    folderMap.set(folder.folderId, folder);
}
function getIsFolderHidden(item) {
    if (item.ExtendedProperty) {
        for (var i = 0; i < item.ExtendedProperty.length; i++) {
            var extendedProperty = item.ExtendedProperty[i];
            if (extendedProperty.ExtendedFieldURI.PropertyTag ===
                HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG ||
                extendedProperty.ExtendedFieldURI.PropertyName ===
                    HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG) {
                return JSON.parse(extendedProperty.Value);
            }
        }
    }
    return undefined;
}
//# sourceMappingURL=initializeInboxRulesFolders.js.map

/***/ }),

/***/ 5223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var findFolderOperation_1 = __webpack_require__(232);
var findFolderRequest_1 = __webpack_require__(231);
var folderId_1 = __webpack_require__(47);
var folderResponseShape_1 = __webpack_require__(340);
var propertyUri_1 = __webpack_require__(40);
var ServiceRequestUtils_1 = __webpack_require__(31);
function configureRequestBody(rootFolderId) {
    return findFolderRequest_1.default({
        FolderShape: folderResponseShape_1.default({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri_1.default({ FieldURI: 'DistinguishedFolderId' }),
                propertyUri_1.default({ FieldURI: 'FolderClass' }),
                propertyUri_1.default({ FieldURI: 'FolderDisplayName' }),
                propertyUri_1.default({ FieldURI: 'ParentFolderId' }),
            ],
        }),
        Paging: null,
        ParentFolderIds: [folderId_1.default({ Id: rootFolderId })],
        ReturnParentFolder: true,
        ShapeName: 'Folder',
        Traversal: 'Deep',
    });
}
function findFolders(rootFolderId) {
    var requestBody = configureRequestBody(rootFolderId);
    return findFolderOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = findFolders;
//# sourceMappingURL=findFoldersService.js.map

/***/ }),

/***/ 5224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = __webpack_require__(23);
var getUserConfiguration_1 = __webpack_require__(9);
var folderIdToName_1 = __webpack_require__(48);
var folderNameToId_1 = __webpack_require__(35);
// Same order as in OWA:MailFolderTreeNodeViewModel.cs
var FOLDERS_TO_SHOW_FIRST = [
    'inbox',
    'junkemail',
    'drafts',
    'sentitems',
    'deleteditems',
];
var GEEK_FOLDERS_TO_HIDE = ['journal', 'outbox', 'syncissues'];
var FOLDER_DELIMITER = '\\';
// returns the flat folder tree to be used in the move to dropdown
function getMoveToDropdownFolders(folderMap, root) {
    // Get flat folder tree
    var dropdownFolderList = [];
    // First get the first level of the tree in order, with special folders first
    var childFolderIds = getFirstLevelFoldersInOrder(root, folderMap);
    // recursively add all of the child folders of the root
    addAllChildFolders(dropdownFolderList, childFolderIds, folderMap, '');
    return dropdownFolderList;
}
exports.default = getMoveToDropdownFolders;
function getFirstLevelFoldersInOrder(root, folderMap) {
    var childFolderIds = [];
    // First add all the special folders.
    FOLDERS_TO_SHOW_FIRST.forEach(function (distinguishedFolderId) {
        var folder = folderMap.get(folderNameToId_1.default(distinguishedFolderId));
        if (folder && shouldDisplayFolderInFolderTree(folder)) {
            childFolderIds.push(folder.folderId);
        }
    });
    // Add all the remaining folders that are not part of the special list above.
    if (root && root.childFolderIds) {
        root.childFolderIds.map(function (childId) {
            var folder = folderMap.get(childId);
            if (folder &&
                FOLDERS_TO_SHOW_FIRST.indexOf(folderIdToName_1.default(folder.folderId)) == -1 &&
                shouldDisplayFolderInFolderTree(folder)) {
                childFolderIds.push(folder.folderId);
            }
        });
    }
    return childFolderIds;
}
// Recursive function to add all child folders in tree for dropdown list
function addAllChildFolders(dropdownFolderList, childFolders, folderMap, currentPath) {
    for (var _i = 0, childFolders_1 = childFolders; _i < childFolders_1.length; _i++) {
        var childFolderId = childFolders_1[_i];
        var childFolder = folderMap.get(childFolderId);
        // Don't add hidden folders or special folders(they are already added) to list
        if (shouldDisplayFolderInFolderTree(childFolder)) {
            var childFolderPath = currentPath + childFolder.displayName;
            childFolder.path = childFolderPath;
            dropdownFolderList.push(childFolder);
            if (childFolder.childFolderIds) {
                addAllChildFolders(dropdownFolderList, childFolder.childFolderIds, folderMap, childFolderPath + FOLDER_DELIMITER);
            }
        }
    }
}
function isOfTypeMailFolder(folder) {
    return folder && folder.folderType == 'Folder:#Exchange';
}
function shouldDisplayFolderInFolderTree(folder) {
    // Do not show the folder if it's not a mail folder.
    if (!isOfTypeMailFolder(folder)) {
        return false;
    }
    // Suppress hidden and 'geek' folders (outbox, journal, etc).
    if (folder.isHidden || GEEK_FOLDERS_TO_HIDE.indexOf(folderIdToName_1.default(folder.folderId)) >= 0) {
        return false;
    }
    // Only show the Notes folder if that feature is enabled.
    var userConfiguration = getUserConfiguration_1.default();
    if (folderIdToName_1.default(folder.folderId) == 'notes') {
        return (userConfiguration.SegmentationSettings.StickyNotes &&
            owa_mail_feature_flags_1.isMailFeatureEnabled('cal-stickyNotesFolder'));
    }
    // Only show the Junk Email folder if that feature is enabled.
    if (folderIdToName_1.default(folder.folderId) == 'junkemail' &&
        !userConfiguration.SegmentationSettings.JunkEMail) {
        return false;
    }
    // Good folder!
    return true;
}
//# sourceMappingURL=getMoveToDropdownFolders.js.map

/***/ }),

/***/ 5225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2603);
var legacy_1 = __webpack_require__(1);
/**
 * Set the FindFoldersRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules request status to set
 */
exports.default = legacy_1.action('setGetInboxRuleRequestStatus')(function setGetInboxRuleRequestStatus(requestStatus) {
    store_1.default.findFoldersRequestStatus = requestStatus;
});
//# sourceMappingURL=setFindFoldersRequestStatus.js.map

/***/ }),

/***/ 5226:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5227);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5227:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".EHxxZDjp4ux4GvDZJKNMN{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}html[dir] .EHxxZDjp4ux4GvDZJKNMN{margin-top:12px}html[dir=ltr] ._1brxZjEULYtdyJUqMWbkY3{padding-left:8px}html[dir=rtl] ._1brxZjEULYtdyJUqMWbkY3{padding-right:8px}._2qhC3fRF6f40LSH8EQfkWN{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._2qhC3fRF6f40LSH8EQfkWN{margin-top:12px}._3BoJr6iUDUWhSk0MK9RUC4{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] .RuN5fEh_ZHZ6dmsFl9NcR{margin-top:48px}html[dir] ._17FabqP1YAKZzpOfICk1r-{border-top:1px solid \"[theme:neutralLighter, default:#f4f4f4]\"}html[dir] ._23zMn8tO2q19-WgkfT2hya{padding:12px 0}.XneGIzICAy4i8_MZdNcPE{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] .XneGIzICAy4i8_MZdNcPE{border-width:1px;border-style:solid;padding:0 4px;background-color:#fff}html[dir=ltr] .XneGIzICAy4i8_MZdNcPE{left:0}html[dir=rtl] .XneGIzICAy4i8_MZdNcPE{right:0}._3XFnx9Slfxm6YFgIBhv8ad{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._3XFnx9Slfxm6YFgIBhv8ad{padding-left:0}html[dir=rtl] ._3XFnx9Slfxm6YFgIBhv8ad{padding-right:0}._3XFnx9Slfxm6YFgIBhv8ad .HVDwA-bpVVvnq-qCflmpR{font-size:12px}html[dir] ._3XFnx9Slfxm6YFgIBhv8ad .HVDwA-bpVVvnq-qCflmpR{margin-top:2px}html[dir=ltr] ._3XFnx9Slfxm6YFgIBhv8ad .HVDwA-bpVVvnq-qCflmpR{margin-left:0}html[dir=rtl] ._3XFnx9Slfxm6YFgIBhv8ad .HVDwA-bpVVvnq-qCflmpR{margin-right:0}", ""]);

// exports
exports.locals = {
	"diagnosticLoadingContainer": "EHxxZDjp4ux4GvDZJKNMN",
	"diagnosticLoadingText": "_1brxZjEULYtdyJUqMWbkY3",
	"diagnosticText": "_2qhC3fRF6f40LSH8EQfkWN",
	"generateReportText": "_3BoJr6iUDUWhSk0MK9RUC4",
	"loadingSpinner": "RuN5fEh_ZHZ6dmsFl9NcR",
	"inboxRuleRowsContainer": "_17FabqP1YAKZzpOfICk1r-",
	"emptyRules": "_23zMn8tO2q19-WgkfT2hya",
	"dragHelperStyle": "XneGIzICAy4i8_MZdNcPE",
	"ruleCommandButton": "_3XFnx9Slfxm6YFgIBhv8ad",
	"icon": "HVDwA-bpVVvnq-qCflmpR"
};

/***/ }),

/***/ 5228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(2603);
var isValidClause_1 = __webpack_require__(3078);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(function isInboxRuleEditDirty(state) {
    return (state.optionState.inboxRulesEditState.clauseMap.size > 0 &&
        state.optionState.inboxRulesEditState.ruleName.trim().length > 0 &&
        isValidClause_1.isValidSection('conditional') &&
        isValidClause_1.isValidSection('action') &&
        isValidClause_1.isValidSection('exception'));
});
//# sourceMappingURL=isInboxRuleEditDirty.js.map

/***/ }),

/***/ 5229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getInboxRules_1 = __webpack_require__(3754);
var createInboxRuleFromStoreEditState_1 = __webpack_require__(5230);
var newInboxRuleService_1 = __webpack_require__(5233);
var setInboxRuleService_1 = __webpack_require__(5234);
var resetInboxRuleEdit_1 = __webpack_require__(3410);
var store_1 = __webpack_require__(2603);
var logInboxRuleInformation_1 = __webpack_require__(3756);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('saveInboxRuleEdit')(legacy_1.select({
    optionState: function () { return store_1.default; },
})(function saveInboxRuleEdit(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var inboxRuleId, inboxRule;
        return tslib_1.__generator(this, function (_a) {
            inboxRuleId = state.optionState.inboxRulesEditState.ruleId;
            inboxRule = createInboxRuleFromStoreEditState_1.default(inboxRuleId);
            // If the rule already has an id, that means it is an edited rule
            if (inboxRuleId) {
                return [2 /*return*/, setInboxRuleService_1.default(inboxRule)
                        .then(function (response) {
                        onSuccessfulRuleSave(response, 'SetInboxRule', inboxRule);
                    })
                        .catch(function (error) {
                        return;
                    })];
            }
            // Otherwise it is a new rule
            return [2 /*return*/, newInboxRuleService_1.default(inboxRule)
                    .then(function (response) {
                    onSuccessfulRuleSave(response, 'NewInboxRule', inboxRule);
                })
                    .catch(function (error) {
                    return;
                })];
        });
    });
}));
function onSuccessfulRuleSave(response, ruleActionSource, inboxRule) {
    if (response.WasSuccessful) {
        resetInboxRuleEdit_1.default();
        // re-fetch the rules list if successful
        getInboxRules_1.default();
        logInboxRuleInformation_1.default(inboxRule, ruleActionSource);
    }
}
//# sourceMappingURL=saveInboxRuleEdit.js.map

/***/ }),

/***/ 5230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var folderTypeConversionUtil_1 = __webpack_require__(3177);
var getActionClauseTypeOptions_1 = __webpack_require__(2795);
var getConditionalExceptionClauseTypeOptions_1 = __webpack_require__(2796);
var getExistingClauseTypesInSection_1 = __webpack_require__(3077);
var mapReadWriteRecipientWellViewStateToPeopleIdentity_1 = __webpack_require__(5231);
var ClauseValueType_1 = __webpack_require__(3748);
var store_1 = __webpack_require__(2603);
var getDefaultInboxRuleClauseValue_1 = __webpack_require__(5232);
var folderNameToId_1 = __webpack_require__(35);
/**
 * Maps the rule clauses from the advanced rules option page to an inbox rule
 * @return the InboxRule with the corresponding clauses as properties
 */
function createInboxRuleFromStoreEditState(inboxRuleId) {
    var inboxRule = {};
    var editState = store_1.default.inboxRulesEditState;
    var clauseMap = editState.clauseMap;
    inboxRule.Name = editState.ruleName;
    var conditionalExistingClauseTypesMap = getExistingClauseTypesInSection_1.default('conditional');
    var actionExistingClauseTypesMap = getExistingClauseTypesInSection_1.default('action');
    var exceptionExistingClauseTypesMap = getExistingClauseTypesInSection_1.default('exception');
    var originalRule = inboxRuleId ? store_1.default.inboxRulesListState.inboxRules.get(inboxRuleId) : null;
    // map conditional and exception clauses
    for (var _i = 0, _a = getConditionalExceptionClauseTypeOptions_1.default(); _i < _a.length; _i++) {
        var conditionalExceptionClauseType = _a[_i];
        var conditionalClauseId = conditionalExistingClauseTypesMap.get(conditionalExceptionClauseType);
        var exceptionClauseId = exceptionExistingClauseTypesMap.get(conditionalExceptionClauseType);
        var conditionalClauseValue = conditionalClauseId
            ? clauseMap.get(conditionalClauseId).clauseValue
            : null;
        var exceptionClauseValue = exceptionClauseId
            ? clauseMap.get(exceptionClauseId).clauseValue
            : null;
        var defaultValue = getDefaultInboxRuleClauseValue_1.default(conditionalExceptionClauseType);
        var originalConditionalValue = void 0;
        var originalExceptionValue = void 0;
        var newConditionalValue = void 0;
        var newExceptionValue = void 0;
        // In this switch statement, we decide whether to set the value of the clause type to be sent to server by the following ways:
        // 1) If there is no new value and there is no old value, do nothing (means user never has this clause type in the rule)
        // 2) Otherwise, get clause value
        // Otherwise do not set because the value has not changed
        switch (conditionalExceptionClauseType) {
            case 'from':
                originalConditionalValue = originalRule ? originalRule.From : defaultValue;
                originalExceptionValue = originalRule ? originalRule.ExceptIfFrom : defaultValue;
                newConditionalValue = getClauseValueWithFallback(conditionalClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity_1.default, defaultValue);
                newExceptionValue = getClauseValueWithFallback(exceptionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity_1.default, defaultValue);
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.From = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfFrom = value;
                });
                break;
            case 'to':
                originalConditionalValue = originalRule ? originalRule.SentTo : defaultValue;
                originalExceptionValue = originalRule ? originalRule.ExceptIfSentTo : defaultValue;
                newConditionalValue = getClauseValueWithFallback(conditionalClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity_1.default, defaultValue);
                newExceptionValue = getClauseValueWithFallback(exceptionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity_1.default, defaultValue);
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.SentTo = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfSentTo = value;
                });
                break;
            case 'onTheToOrCcLine':
                originalConditionalValue = originalRule
                    ? originalRule.MyNameInToOrCcBox
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMyNameInToOrCcBox
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MyNameInToOrCcBox = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMyNameInToOrCcBox = value;
                });
                break;
            case 'theOnlyRecipientListed':
                originalConditionalValue = originalRule ? originalRule.SentOnlyToMe : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfSentOnlyToMe
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.SentOnlyToMe = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfSentOnlyToMe = value;
                });
                break;
            case 'onTheToLine':
                originalConditionalValue = originalRule ? originalRule.MyNameInToBox : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMyNameInToBox
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MyNameInToBox = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMyNameInToBox = value;
                });
                break;
            case 'onTheCcLine':
                originalConditionalValue = originalRule ? originalRule.MyNameInCcBox : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMyNameInCcBox
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MyNameInCcBox = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMyNameInCcBox = value;
                });
                break;
            case 'notOnTheToLine':
                originalConditionalValue = originalRule
                    ? originalRule.MyNameNotInToBox
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMyNameNotInToBox
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MyNameNotInToBox = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMyNameNotInToBox = value;
                });
                break;
            case 'subjectIncludes':
                originalConditionalValue = originalRule
                    ? originalRule.SubjectContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfSubjectContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.SubjectContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfSubjectContainsWords = value;
                });
                break;
            case 'subjectOrBodyIncludes':
                originalConditionalValue = originalRule
                    ? originalRule.SubjectOrBodyContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfSubjectOrBodyContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.SubjectOrBodyContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfSubjectOrBodyContainsWords = value;
                });
                break;
            case 'inTheBody':
                originalConditionalValue = originalRule
                    ? originalRule.BodyContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfBodyContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.BodyContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfBodyContainsWords = value;
                });
                break;
            case 'inTheSenderAddress':
                originalConditionalValue = originalRule
                    ? originalRule.FromAddressContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfFromAddressContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.FromAddressContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfFromAddressContainsWords = value;
                });
                break;
            case 'inTheRecipientAddress':
                originalConditionalValue = originalRule
                    ? originalRule.RecipientAddressContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfRecipientAddressContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.RecipientAddressContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfRecipientAddressContainsWords = value;
                });
                break;
            case 'inTheMessageHeader':
                originalConditionalValue = originalRule
                    ? originalRule.HeaderContainsWords
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfHeaderContainsWords
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.HeaderContainsWords = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfHeaderContainsWords = value;
                });
                break;
            case 'withImportance':
                originalConditionalValue = originalRule
                    ? originalRule.WithImportance
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfWithImportance
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.WithImportance = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfWithImportance = value;
                });
                break;
            case 'sensitivity':
                originalConditionalValue = originalRule
                    ? originalRule.WithSensitivity
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfWithSensitivity
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.WithSensitivity = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfWithSensitivity = value;
                });
                break;
            case 'attachment':
                originalConditionalValue = originalRule ? originalRule.HasAttachment : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfHasAttachment
                    : defaultValue;
                newConditionalValue = conditionalClauseId ? true : defaultValue;
                newExceptionValue = exceptionClauseId ? true : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.HasAttachment = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfHasAttachment = value;
                });
                break;
            case 'flag':
                originalConditionalValue = originalRule
                    ? originalRule.RequestedAction
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfRequestedAction
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.RequestedAction = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfRequestedAction = value;
                });
                break;
            case 'type':
                originalConditionalValue = originalRule
                    ? originalRule.MessageTypeMatches
                    : defaultValue;
                originalExceptionValue = originalRule
                    ? originalRule.ExceptIfMessageTypeMatches
                    : defaultValue;
                newConditionalValue = conditionalClauseId
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseId
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.MessageTypeMatches = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfMessageTypeMatches = value;
                });
                break;
            case 'atLeast':
                originalConditionalValue =
                    originalRule && originalRule.WithinSizeRangeMinimum
                        ? originalRule.WithinSizeRangeMinimum
                        : defaultValue;
                originalExceptionValue =
                    originalRule && originalRule.ExceptIfWithinSizeRangeMinimum
                        ? originalRule.ExceptIfWithinSizeRangeMinimum
                        : defaultValue;
                newConditionalValue = getClauseValueWithFallback(conditionalClauseValue, mapKilobytesToBytes, defaultValue);
                newExceptionValue = getClauseValueWithFallback(exceptionClauseValue, mapKilobytesToBytes, defaultValue);
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.WithinSizeRangeMinimum = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfWithinSizeRangeMinimum = value;
                });
                break;
            case 'atMost':
                originalConditionalValue =
                    originalRule && originalRule.WithinSizeRangeMaximum
                        ? originalRule.WithinSizeRangeMaximum
                        : defaultValue;
                originalExceptionValue =
                    originalRule && originalRule.ExceptIfWithinSizeRangeMaximum
                        ? originalRule.ExceptIfWithinSizeRangeMaximum
                        : defaultValue;
                newConditionalValue = getClauseValueWithFallback(conditionalClauseValue, mapKilobytesToBytes, defaultValue);
                newExceptionValue = getClauseValueWithFallback(exceptionClauseValue, mapKilobytesToBytes, defaultValue);
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.WithinSizeRangeMaximum = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfWithinSizeRangeMaximum = value;
                });
                break;
            case 'before':
                originalConditionalValue =
                    originalRule && originalRule.ReceivedBeforeDate
                        ? originalRule.ReceivedBeforeDate
                        : defaultValue;
                originalExceptionValue =
                    originalRule && originalRule.ExceptIfReceivedBeforeDate
                        ? originalRule.ExceptIfReceivedBeforeDate
                        : defaultValue;
                newConditionalValue = conditionalClauseValue
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseValue
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.ReceivedBeforeDate = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalExceptionValue, newExceptionValue), function (value) {
                    inboxRule.ExceptIfReceivedBeforeDate = value;
                });
                break;
            case 'after':
                originalConditionalValue =
                    originalRule && originalRule.ReceivedAfterDate
                        ? originalRule.ReceivedAfterDate
                        : defaultValue;
                originalExceptionValue =
                    originalRule && originalRule.ExceptIfReceivedAfterDate
                        ? originalRule.ExceptIfReceivedAfterDate
                        : defaultValue;
                newConditionalValue = conditionalClauseValue
                    ? conditionalClauseValue
                    : defaultValue;
                newExceptionValue = exceptionClauseValue
                    ? exceptionClauseValue
                    : defaultValue;
                // Set conditional value
                setClauseValueWithFallback(newConditionalValue, originalConditionalValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.ReceivedAfterDate = value;
                });
                // Set exception value
                setClauseValueWithFallback(newExceptionValue, originalExceptionValue, defaultValue, areClauseValuesEqual(originalConditionalValue, newConditionalValue), function (value) {
                    inboxRule.ExceptIfReceivedAfterDate = value;
                });
                break;
            default:
                throw new Error('Cannot map an exception inbox rule clause to an inbox rule property for a clause type that does not exist');
        }
    }
    // map action clauses
    for (var _b = 0, _c = getActionClauseTypeOptions_1.default(); _b < _c.length; _b++) {
        var actionClauseType = _c[_b];
        var actionClauseId = actionExistingClauseTypesMap.get(actionClauseType);
        var actionClauseValue = actionClauseId ? clauseMap.get(actionClauseId).clauseValue : null;
        var defaultValue = getDefaultInboxRuleClauseValue_1.default(actionClauseType);
        var originalValue = void 0;
        var newValue = void 0;
        switch (actionClauseType) {
            case 'moveTo':
                newValue = defaultValue;
                originalValue = originalRule ? originalRule.MoveToFolder : defaultValue;
                var newMoveToFolderId = defaultValue;
                var moveToFolder = actionClauseValue;
                if (moveToFolder) {
                    newMoveToFolderId = moveToFolder.folderId;
                    newValue = {
                        DisplayName: moveToFolder.displayName,
                        RawIdentity: newMoveToFolderId,
                    };
                }
                var originalRuleMoveToFolderId = originalValue
                    ? folderTypeConversionUtil_1.getFolderFromRawId(originalRule.MoveToFolder.RawIdentity).folderId
                    : null;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalRuleMoveToFolderId, newMoveToFolderId), function (value) {
                    inboxRule.MoveToFolder = value;
                });
                break;
            case 'copyTo':
                newValue = defaultValue;
                originalValue = originalRule ? originalRule.CopyToFolder : defaultValue;
                var newCopyToFolderId = defaultValue;
                var copyToFolder = actionClauseValue;
                if (copyToFolder) {
                    newCopyToFolderId = copyToFolder.folderId;
                    newValue = {
                        DisplayName: copyToFolder.displayName,
                        RawIdentity: newCopyToFolderId,
                    };
                }
                var originalRuleCopyToFolderId = originalValue
                    ? folderTypeConversionUtil_1.getFolderFromRawId(originalRule.CopyToFolder.RawIdentity).folderId
                    : null;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalRuleCopyToFolderId, newCopyToFolderId), function (value) {
                    inboxRule.CopyToFolder = value;
                });
                break;
            case 'delete':
                originalValue = originalRule ? originalRule.DeleteMessage : defaultValue;
                newValue = actionClauseId ? true : defaultValue;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.DeleteMessage = value;
                });
                break;
            case 'pin':
                originalValue = originalRule ? originalRule.PinMessage : defaultValue;
                newValue = actionClauseId ? true : defaultValue;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.PinMessage = value;
                });
                break;
            case 'read':
                originalValue = originalRule ? originalRule.MarkAsRead : defaultValue;
                newValue = actionClauseId ? true : defaultValue;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.MarkAsRead = value;
                });
                break;
            case 'junk':
                // Mark as junk is a special case because there is no server property for it. We give the user the option and do a
                // Move to folder 'Junk Email' under the covers.
                var junkFolderId = folderNameToId_1.default('junkemail');
                var newJunkClauseValue = actionClauseId
                    ? {
                        DisplayName: store_1.default.junkFolderDisplayName,
                        RawIdentity: junkFolderId,
                    }
                    : defaultValue;
                var originalMoveToFolderId = originalRule && originalRule.MoveToFolder
                    ? folderTypeConversionUtil_1.getFolderFromRawId(originalRule.MoveToFolder.RawIdentity).folderId
                    : defaultValue;
                var areMoveToAndJunkFoldersEquivalent = originalMoveToFolderId
                    ? newJunkClauseValue && originalMoveToFolderId === junkFolderId
                    : false;
                // Since junk is special, we have to do an additional check if the move to folder on the original rule was a junk folder
                if (newJunkClauseValue && (!originalRule || !areMoveToAndJunkFoldersEquivalent)) {
                    inboxRule.MoveToFolder = newJunkClauseValue;
                }
                else if (!newJunkClauseValue &&
                    (areMoveToAndJunkFoldersEquivalent &&
                        originalRule.MoveToFolder !== defaultValue)) {
                    inboxRule.MoveToFolder = defaultValue;
                }
                break;
            case 'markImportance':
                originalValue = originalRule ? originalRule.MarkImportance : defaultValue;
                newValue = actionClauseId ? actionClauseValue : null;
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.MarkImportance = value;
                });
                break;
            case 'forwardTo':
                originalValue = originalRule ? originalRule.ForwardTo : defaultValue;
                newValue = getClauseValueWithFallback(actionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity_1.default, defaultValue);
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.ForwardTo = value;
                });
                break;
            case 'forwardAsAttachmentTo':
                originalValue = originalRule ? originalRule.ForwardAsAttachmentTo : defaultValue;
                newValue = getClauseValueWithFallback(actionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity_1.default, defaultValue);
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.ForwardAsAttachmentTo = value;
                });
                break;
            case 'redirectTo':
                originalValue = originalRule ? originalRule.RedirectTo : defaultValue;
                newValue = getClauseValueWithFallback(actionClauseValue, mapReadWriteRecipientWellViewStateToPeopleIdentity_1.default, defaultValue);
                setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual(originalValue, newValue), function (value) {
                    inboxRule.RedirectTo = value;
                });
                break;
            default:
                throw new Error('Cannot map an exception inbox rule clause to an inbox rule property for a clause type that does not exist');
        }
    }
    // Once all the clause values are set, set at most value size if there is an at least value but not an at most value on either the new rule or the original rule
    if (inboxRule.WithinSizeRangeMinimum &&
        (!inboxRule.WithinSizeRangeMaximum && originalRule && !originalRule.WithinSizeRangeMaximum)) {
        inboxRule.WithinSizeRangeMaximum = ClauseValueType_1.MAX_MESSAGE_SIZE;
    }
    if (inboxRule.ExceptIfWithinSizeRangeMinimum &&
        (!inboxRule.ExceptIfWithinSizeRangeMaximum &&
            originalRule &&
            !originalRule.ExceptIfWithinSizeRangeMaximum)) {
        inboxRule.ExceptIfWithinSizeRangeMaximum = ClauseValueType_1.MAX_MESSAGE_SIZE;
    }
    inboxRule.StopProcessingRules = store_1.default.inboxRulesEditState.ignoreSubsequentRules;
    if (store_1.default.inboxRulesEditState.ruleId) {
        inboxRule.Identity = {
            DisplayName: store_1.default.inboxRulesEditState.ruleName,
            RawIdentity: store_1.default.inboxRulesEditState.ruleId,
        };
    }
    return inboxRule;
}
exports.default = createInboxRuleFromStoreEditState;
// Set inbox rule value to the edit state value if:
// 1) There is an edit state value (user added that clause type) AND
// 2) It is a new rule (no original rule) OR the value of the new rule is different than value of the original rule
// Else if:
// Set inbox rule value to the default inbox rule value if user removes the clause while editing:
// 1) There is no edit state value AND
// 2) There is an original rule (in edit mode) AND the value of the original rule was not the default value
function setClauseValueWithFallback(newValue, originalValue, defaultValue, areClauseValuesEqual, valueSetter) {
    if (!areClauseValuesEqual) {
        var valueToSet = void 0;
        if (newValue && newValue != originalValue) {
            valueToSet = newValue;
        }
        else if (!newValue && originalValue != defaultValue) {
            valueToSet = defaultValue;
        }
        valueSetter(valueToSet);
    }
}
function areClauseValuesEqual(originalValue, newValue) {
    return originalValue === newValue;
}
function getClauseValueWithFallback(existingValue, mapFunction, defaultValue) {
    return existingValue ? mapFunction(existingValue) : defaultValue;
}
function mapKilobytesToBytes(clauseValue) {
    return clauseValue * ClauseValueType_1.KB_TO_B;
}
//# sourceMappingURL=createInboxRuleFromStoreEditState.js.map

/***/ }),

/***/ 5231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var peopleIdentity_1 = __webpack_require__(3411);
/**
 * Maps the recipient well from the rule edit page to PeopleIdentity type
 * @return the PeopleIdentity list with the corresponding recipients as items
 */
function mapReadWriteRecipientWellViewStateToPeopleIdentity(recipientWell) {
    // map conditional clauses
    var peopleIdentities = [];
    for (var _i = 0, _a = recipientWell.recipients; _i < _a.length; _i++) {
        var recipient = _a[_i];
        var mailbox = recipient.persona.EmailAddress;
        var identity = peopleIdentity_1.default({
            DisplayName: mailbox.Name,
            SmtpAddress: mailbox.EmailAddress,
            RoutingType: mailbox.RoutingType,
        });
        peopleIdentities.push(identity);
    }
    return peopleIdentities.length > 0 ? peopleIdentities : null;
}
exports.default = mapReadWriteRecipientWellViewStateToPeopleIdentity;
//# sourceMappingURL=mapReadWriteRecipientWellViewStateToPeopleIdentity.js.map

/***/ }),

/***/ 5232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getDefaultInboxRuleClauseValue(clauseType) {
    switch (clauseType) {
        case 'markImportance':
        case 'withImportance':
            return 'NullImportance';
        case 'sensitivity':
            return 'NullSensitivity';
        case 'type':
            return 'NullInboxRuleMessageType';
        case 'flag':
            return 'NullInboxRuleMessageFlag';
        case 'moveTo':
        case 'copyTo':
        case 'junk':
        case 'forwardTo':
        case 'forwardAsAttachmentTo':
        case 'redirectTo':
        case 'from':
        case 'to':
        case 'subjectIncludes':
        case 'subjectOrBodyIncludes':
        case 'inTheBody':
        case 'inTheSenderAddress':
        case 'inTheRecipientAddress':
        case 'inTheMessageHeader':
        case 'atLeast':
        case 'atMost':
        case 'before':
        case 'after':
            return null;
        case 'read':
        case 'pin':
        case 'delete':
        case 'attachment':
        case 'onTheToOrCcLine':
        case 'theOnlyRecipientListed':
        case 'onTheToLine':
        case 'onTheCcLine':
        case 'notOnTheToLine':
            return false;
        default:
            throw new Error('Cannot get an initial inbox rule clause value for a clause type that does not exist');
    }
}
exports.default = getDefaultInboxRuleClauseValue;
//# sourceMappingURL=getDefaultInboxRuleClauseValue.js.map

/***/ }),

/***/ 5233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var newInboxRuleOperation_1 = __webpack_require__(3412);
var newInboxRuleRequest_1 = __webpack_require__(3083);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Sends out the service request to update an inbox rule
 * @param newInboxRuleData the object that contains the new rule data
 * @return a promise that contains NewInboxRuleResponse
 */
function newInboxRuleService(newInboxRule) {
    var requestBody = newInboxRuleRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        InboxRule: newInboxRule,
    });
    return newInboxRuleOperation_1.default(requestBody);
}
exports.default = newInboxRuleService;
//# sourceMappingURL=newInboxRuleService.js.map

/***/ }),

/***/ 5234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setInboxRuleRequest_1 = __webpack_require__(3758);
var setInboxRuleOperation_1 = __webpack_require__(5235);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Set inbox rule service
 * @param inboxRule the rule to update
 * @return SetInboxRuleResponse
 */
function setInboxRuleService(inboxRule) {
    var requestBody = setInboxRuleRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        InboxRule: inboxRule,
    });
    return setInboxRuleOperation_1.default(requestBody);
}
exports.default = setInboxRuleService;
//# sourceMappingURL=setInboxRuleService.js.map

/***/ }),

/***/ 5235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var setInboxRuleRequest_1 = __webpack_require__(3758);
function setInboxRuleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = setInboxRuleRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("SetInboxRule", req, options);
}
exports.default = setInboxRuleOperation;


/***/ }),

/***/ 5236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComposeSurfaceActionsOption_1 = __webpack_require__(5237);
var ReadSurfaceActionsOption_1 = __webpack_require__(5243);
var surfaceActionsSubCategory = {
    key: 'surfaceActions',
    titleStringKey: 'optionSubcategory_surfaceActions',
    options: [ReadSurfaceActionsOption_1.default, ComposeSurfaceActionsOption_1.default],
};
exports.default = surfaceActionsSubCategory;
//# sourceMappingURL=surfaceActionsSubcategory.js.map

/***/ }),

/***/ 5237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardSurfaceActionsOption_1 = __webpack_require__(3759);
var saveSurfaceActionsOption_1 = __webpack_require__(3760);
var SurfaceActionsFull_1 = __webpack_require__(3761);
var isSurfaceActionsOptionDirty_1 = __webpack_require__(3763);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var React = __webpack_require__(3);
var ComposeSurfaceActionsOption = {
    key: 'composeSurfaceActions',
    titleStringKey: 'optionTitle_composeSurfaceActions',
    searchTermsStringKey: 'optionTitle_composeSurfaceActions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SurfaceActionsFull_1.default, { isCompose: true }); },
        isDirty: isSurfaceActionsOptionDirty_1.default,
        onSave: saveSurfaceActionsOption_1.default,
        onDiscard: discardSurfaceActionsOption_1.default,
    },
    isHidden: function () { return !owa_controls_feature_flags_1.isControlFeatureEnabled('rp-customSurfaceActions'); },
};
exports.default = ComposeSurfaceActionsOption;
//# sourceMappingURL=ComposeSurfaceActionsOption.js.map

/***/ }),

/***/ 5238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectSurfaceActionsOption_1 = __webpack_require__(5239);
var Button_1 = __webpack_require__(62);
var owa_options_controls_1 = __webpack_require__(2661);
var ContextualMenu_1 = __webpack_require__(329);
var Icon_1 = __webpack_require__(43);
var Image_1 = __webpack_require__(344);
var Label_1 = __webpack_require__(1559);
var OverflowSet_1 = __webpack_require__(2898);
var owa_surface_actions_1 = __webpack_require__(2942);
var React = __webpack_require__(3);
var DIVIDER_MENU_ITEM_NAME = '-';
var MAX_PINNED_ITEMS = 8;
var styles = __webpack_require__(3762);
var classNames = __webpack_require__(30).bind(styles);
var SurfaceActionsShared = /** @class */ (function (_super) {
    tslib_1.__extends(SurfaceActionsShared, _super);
    function SurfaceActionsShared() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRenderActionCheckboxLabel = function (props, key) {
            var label = _this.props.getDisplayNameFromAction(key);
            var _a = _this.props.getIconNameFromAction(key), icon = _a[0], isImage = _a[1];
            var className = isImage ? styles.imageWrapper : '';
            return (React.createElement("div", { className: className },
                isImage ? (React.createElement(Image_1.Image, { className: styles.actionImage, shouldFadeIn: false, src: icon })) : (React.createElement(Icon_1.Icon, { iconName: icon, className: styles.actionIcon })),
                React.createElement(Label_1.Label, { className: styles.actionLabel },
                    " ",
                    label,
                    " ")));
        };
        _this.onRenderAddinCheckboxLabel = function (props, iconProps, name) {
            return (React.createElement("div", null,
                React.createElement(Icon_1.Icon, { iconType: iconProps.iconType, className: styles.addinImage, imageProps: iconProps.imageProps }),
                React.createElement(Label_1.Label, { className: styles.actionLabel },
                    " ",
                    name,
                    " ")));
        };
        _this.onRenderPreviewItem = function (item) {
            var className = classNames(styles.previewButton, { isAddin: item.isAddin });
            return (React.createElement(Button_1.CommandBarButton, { onClick: null, iconProps: item.iconProps, styles: { root: className } }));
        };
        _this.onRenderPreviewOverflow = function (overflowItems) {
            overflowItems.forEach(function (item) {
                if (!item.isAddin) {
                    item.iconProps = null; // Hide static action icons in the overflow
                }
            });
            return (React.createElement(Button_1.CommandBarButton, { menuIconProps: { iconName: 'ChevronDown' }, menuProps: { items: overflowItems }, styles: { root: styles.previewButton } }));
        };
        return _this;
    }
    SurfaceActionsShared.prototype.render = function () {
        var _a = this.props, previewImageUri = _a.previewImageUri, previewClassName = _a.previewClassName;
        var actionCheckboxes = [];
        var addinCheckboxes = [];
        var previewPinnedItems = [];
        var previewOverflowItems = [];
        this.prepareActionsContent(actionCheckboxes, previewPinnedItems, previewOverflowItems);
        this.prepareAddinsContent(addinCheckboxes, previewPinnedItems, previewOverflowItems);
        return (React.createElement("div", { className: styles.sharedWrapper },
            React.createElement("div", { className: styles.sharedListSection },
                actionCheckboxes,
                addinCheckboxes),
            React.createElement("div", { className: styles.sharedPreviewSection },
                React.createElement(Image_1.Image, { src: previewImageUri, className: 'flipForRtl' }),
                React.createElement(OverflowSet_1.OverflowSet, { className: previewClassName, items: previewPinnedItems, overflowItems: previewOverflowItems, onRenderItem: this.onRenderPreviewItem, onRenderOverflowButton: this.onRenderPreviewOverflow }))));
    };
    SurfaceActionsShared.prototype.prepareActionsContent = function (actionCheckboxes, previewPinnedItems, previewOverflowItems) {
        var _this = this;
        var _a = this.props, actions = _a.actions, selectedActions = _a.selectedActions, actionsOptionName = _a.actionsOptionName;
        actions.forEach(function (action) {
            var isPinned = selectedActions.indexOf(action) >= 0;
            if (action != DIVIDER_MENU_ITEM_NAME) {
                // If the action isn't a divider, create a OptionsCheckbox for it.
                actionCheckboxes.push(React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: isPinned, onChange: function (event, checked) {
                        selectSurfaceActionsOption_1.default(actionsOptionName, selectedActions, action, checked);
                    }, key: action, onRenderLabel: function (props) {
                        return _this.onRenderActionCheckboxLabel(props, action);
                    }, styles: { label: styles.checkBoxLabel } }));
                // If the action is pinned, push a preview of it to the proper collection
                if (isPinned) {
                    var _a = _this.props.getIconNameFromAction(action), iconName = _a[0], isImage = _a[1];
                    var previewAction = {
                        key: action,
                        isAddin: false,
                        iconProps: {
                            iconName: iconName,
                            iconType: isImage ? Icon_1.IconType.Image : Icon_1.IconType.default,
                            imageProps: isImage ? { shouldFadeIn: false, src: iconName } : null,
                        },
                        name: _this.props.getDisplayNameFromAction(action),
                    };
                    _this.addPreviewItem(previewAction, previewPinnedItems, previewOverflowItems);
                }
            }
        });
    };
    SurfaceActionsShared.prototype.prepareAddinsContent = function (addinCheckboxes, previewPinnedItems, previewOverflowItems) {
        var _this = this;
        var _a = this.props, addins = _a.addins, selectedAddins = _a.selectedAddins, addinsOptionName = _a.addinsOptionName;
        addins.forEach(function (addin) {
            var isPinned = selectedAddins.indexOf(addin.key) >= 0;
            if (addin.itemType == ContextualMenu_1.ContextualMenuItemType.Normal) {
                addinCheckboxes.push(React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: isPinned, onChange: function (event, checked) {
                        selectSurfaceActionsOption_1.default(addinsOptionName, selectedAddins, addin.key, checked);
                    }, key: addin.key, onRenderLabel: function (props) {
                        return _this.onRenderAddinCheckboxLabel(props, addin.iconProps, addin.name);
                    }, styles: { label: styles.checkBoxLabel } }));
                // If the addin is pinned, push a preview of it to the proper collection
                if (isPinned) {
                    var previewAddin = {
                        key: addin.key,
                        isAddin: true,
                        iconProps: addin.iconProps,
                        name: addin.name,
                    };
                    _this.addPreviewItem(previewAddin, previewPinnedItems, previewOverflowItems);
                }
            }
        });
    };
    SurfaceActionsShared.prototype.addPreviewItem = function (item, pinnedItems, overflowItems) {
        var isLeftToRight = this.props.isLeftToRight;
        // If we have fewer than the max pinned items and no overflow items, push to the pinned collection.
        if (pinnedItems.length < MAX_PINNED_ITEMS && overflowItems.length == 0) {
            if (isLeftToRight || owa_surface_actions_1.shouldAddActionToEnd(item.key)) {
                pinnedItems.push(item);
            }
            else {
                pinnedItems.unshift(item);
            }
        }
        else if (pinnedItems.length == MAX_PINNED_ITEMS) {
            // Otherwise, if we have exactly the max amount of pinned items, remove one and add it to the overflow along with the new item.
            overflowItems.push(isLeftToRight ? pinnedItems.pop() : pinnedItems.shift());
            overflowItems.push(item);
        }
        else {
            // Otherwise push to the overflow.
            overflowItems.push(item);
        }
    };
    return SurfaceActionsShared;
}(React.Component));
exports.default = SurfaceActionsShared;
//# sourceMappingURL=SurfaceActionsShared.js.map

/***/ }),

/***/ 5239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3084);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectSurfaceActionsOption')(function selectSurfaceActionsOption(option, actionCollection, actionKey, checked, state) {
    var optionState = state.optionState;
    if (checked) {
        if (actionCollection.indexOf(actionKey) == -1) {
            actionCollection.push(actionKey);
        }
    }
    else {
        var index = actionCollection.indexOf(actionKey);
        if (index >= 0) {
            actionCollection.splice(index, 1);
        }
    }
    optionState[option] = actionCollection;
}));
//# sourceMappingURL=selectSurfaceActionsOption.js.map

/***/ }),

/***/ 5240:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir=ltr] ._2zERWTI4EQV7lH6DtRzdyv{margin-right:0}html[dir=rtl] ._2zERWTI4EQV7lH6DtRzdyv{margin-left:0}._3R8xXubPa71znaL7ALnQCk{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir=ltr] ._3R8xXubPa71znaL7ALnQCk{margin:-6px 0 -6px -4px}html[dir=rtl] ._3R8xXubPa71znaL7ALnQCk{margin:-6px -4px -6px 0}html[dir] ._3R8xXubPa71znaL7ALnQCk ._2O1o4HZba-nmssXlZodjpP{padding-top:8px}html[dir=ltr] ._3R8xXubPa71znaL7ALnQCk ._2O1o4HZba-nmssXlZodjpP{margin-left:-4px!important}html[dir=rtl] ._3R8xXubPa71znaL7ALnQCk ._2O1o4HZba-nmssXlZodjpP{margin-right:-4px!important}._37cxEI2k3zrs9gQ-4IyM67{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._37cxEI2k3zrs9gQ-4IyM67{padding:0 5px}._28AYDrX4tyOm7_rFNXYkfb{width:32px}html[dir=ltr] ._28AYDrX4tyOm7_rFNXYkfb{padding-right:4px}html[dir=rtl] ._28AYDrX4tyOm7_rFNXYkfb{padding-left:4px}html[dir] ._1pe9gW8Tdhasq0p5PXAotN{padding:0 4px}._2O1o4HZba-nmssXlZodjpP{display:inline}html[dir] ._2O1o4HZba-nmssXlZodjpP{margin:0!important}._147ZjIi5FRkzyHSAPEgHqA{min-width:480px}html[dir=ltr] ._285aSm296P2m_irimqG1kq{float:left}html[dir=rtl] ._285aSm296P2m_irimqG1kq{float:right}._1RhGD00IRLLjx3R4l340XE{height:200px;width:480px}html[dir=ltr] ._1RhGD00IRLLjx3R4l340XE{float:right}html[dir=rtl] ._1RhGD00IRLLjx3R4l340XE{float:left}._2E7bpWciyhLfVI0Vftj_Sp{min-height:34px;top:-200px}html[dir=ltr] ._2E7bpWciyhLfVI0Vftj_Sp{float:right}html[dir=rtl] ._2E7bpWciyhLfVI0Vftj_Sp{float:left}._1TnnnraBqIAnQuNcS25a6_{top:-40px;min-height:34px}html[dir=ltr] ._1TnnnraBqIAnQuNcS25a6_{float:left;left:145px}html[dir=rtl] ._1TnnnraBqIAnQuNcS25a6_{float:right;right:145px}html[dir] ._2TZceDfHAS107tqKerg6k6{background-color:transparent}._2TZceDfHAS107tqKerg6k6 .ms-Icon-imageContainer{width:32px;height:32px}html[dir] ._2TZceDfHAS107tqKerg6k6 .ms-Icon-imageContainer{margin:0}._2TZceDfHAS107tqKerg6k6._2YnZKjrp4W9hDhGMyZvK-4{top:8px}html[dir=ltr] ._2TZceDfHAS107tqKerg6k6._2YnZKjrp4W9hDhGMyZvK-4{margin-right:-8px}html[dir=rtl] ._2TZceDfHAS107tqKerg6k6._2YnZKjrp4W9hDhGMyZvK-4{margin-left:-8px}", ""]);

// exports
exports.locals = {
	"checkBoxLabel": "_2zERWTI4EQV7lH6DtRzdyv",
	"imageWrapper": "_3R8xXubPa71znaL7ALnQCk",
	"actionLabel": "_2O1o4HZba-nmssXlZodjpP",
	"actionIcon": "_37cxEI2k3zrs9gQ-4IyM67",
	"actionImage": "_28AYDrX4tyOm7_rFNXYkfb",
	"addinImage": "_1pe9gW8Tdhasq0p5PXAotN",
	"sharedWrapper": "_147ZjIi5FRkzyHSAPEgHqA",
	"sharedListSection": "_285aSm296P2m_irimqG1kq",
	"sharedPreviewSection": "_1RhGD00IRLLjx3R4l340XE",
	"readingPanePreview": "_2E7bpWciyhLfVI0Vftj_Sp",
	"composePreview": "_1TnnnraBqIAnQuNcS25a6_",
	"previewButton": "_2TZceDfHAS107tqKerg6k6",
	"isAddin": "_2YnZKjrp4W9hDhGMyZvK-4"
};

/***/ }),

/***/ 5241:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 5242:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 5243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardSurfaceActionsOption_1 = __webpack_require__(3759);
var saveSurfaceActionsOption_1 = __webpack_require__(3760);
var SurfaceActionsFull_1 = __webpack_require__(3761);
var isSurfaceActionsOptionDirty_1 = __webpack_require__(3763);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var React = __webpack_require__(3);
var ReadSurfaceActionsOption = {
    key: 'readSurfaceActions',
    titleStringKey: 'optionTitle_readSurfaceActions',
    searchTermsStringKey: 'optionTitle_readSurfaceActions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SurfaceActionsFull_1.default, { isCompose: false }); },
        isDirty: isSurfaceActionsOptionDirty_1.default,
        onSave: saveSurfaceActionsOption_1.default,
        onDiscard: discardSurfaceActionsOption_1.default,
    },
    isHidden: function () { return !owa_controls_feature_flags_1.isControlFeatureEnabled('rp-customSurfaceActions'); },
};
exports.default = ReadSurfaceActionsOption;
//# sourceMappingURL=ReadSurfaceActionsOption.js.map

/***/ }),

/***/ 5244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var personalizationSubCategory_1 = __webpack_require__(5245);
var automaticProcessingSubCategory_1 = __webpack_require__(5265);
var calendarCategory = {
    key: 'calendar',
    titleStringKey: 'optionCategory_Calendar',
    icon: "Calendar" /* Calendar */,
    subcategories: [personalizationSubCategory_1.default, automaticProcessingSubCategory_1.default],
};
exports.default = calendarCategory;
//# sourceMappingURL=category.js.map

/***/ }),

/***/ 5245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WeatherOption_1 = __webpack_require__(5246);
var AppearanceOption_1 = __webpack_require__(5259);
var loadCalendarMailboxConfiguration_1 = __webpack_require__(3767);
var personalizationSubCategory = {
    key: 'personalization',
    titleStringKey: 'optionSubcategory_personalization',
    options: [AppearanceOption_1.default, WeatherOption_1.default],
    onSelected: loadCalendarMailboxConfiguration_1.default,
};
exports.default = personalizationSubCategory;
//# sourceMappingURL=personalizationSubCategory.js.map

/***/ }),

/***/ 5246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardWeatherOption_1 = __webpack_require__(5247);
var saveWeatherOption_1 = __webpack_require__(5248);
var WeatherFull_1 = __webpack_require__(5255);
var isWeatherOptionDirty_1 = __webpack_require__(5258);
var React = __webpack_require__(3);
var WeatherOption = {
    key: 'weather',
    titleStringKey: 'optionTitle_weather',
    searchTermsStringKey: 'optionTitle_weather',
    fullOptionFormSettings: {
        render: function () { return React.createElement(WeatherFull_1.default, null); },
        isDirty: isWeatherOptionDirty_1.default,
        onSave: saveWeatherOption_1.default,
        onDiscard: discardWeatherOption_1.default,
    },
};
exports.default = WeatherOption;
//# sourceMappingURL=WeatherOption.js.map

/***/ }),

/***/ 5247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(2943);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardWeatherOption')(function discardWeatherOption(state) {
    var optionState = state.optionState;
    optionState.weatherEnabled = null;
    optionState.weatherUnit = null;
}));
//# sourceMappingURL=discardWeatherOption.js.map

/***/ }),

/***/ 5248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(2943);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var saveWeatherOption = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
    calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
})(legacy_1.action('saveWeatherOption')(function saveWeatherOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, calendarConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions, calendarConfiguration = state.calendarConfiguration;
                    // update the UserOptions so that changes reflect in current session
                    userOptions.WeatherEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.weatherEnabled, calendarConfiguration.WeatherEnabled);
                    userOptions.WeatherUnit = owa_options_core_1.getFallbackValueIfNull(optionState.weatherUnit, calendarConfiguration.WeatherUnit);
                    calendarConfiguration.WeatherEnabled = userOptions.WeatherEnabled;
                    calendarConfiguration.WeatherUnit = userOptions.WeatherUnit;
                    // save the new calendar configuration at server
                    return [4 /*yield*/, owa_calendar_configuration_1.saveCalendarMailboxConfiguration(calendarConfiguration)];
                case 1:
                    // save the new calendar configuration at server
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
exports.default = saveWeatherOption;
//# sourceMappingURL=saveWeatherOption.js.map

/***/ }),

/***/ 5249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getMailboxCalendarConfigurationOperation_1 = __webpack_require__(5250);
function getMailboxCalendarConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getMailboxCalendarConfigurationOperation_1.default()];
                case 1:
                    response = _a.sent();
                    if (response.ErrorCode) {
                        return [2 /*return*/, null];
                    }
                    else {
                        return [2 /*return*/, response.Options];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = getMailboxCalendarConfiguration;
//# sourceMappingURL=getMailboxCalendarConfiguration.js.map

/***/ }),

/***/ 5250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
function getMailboxCalendarConfigurationOperation(options) {
    return ServiceRequest_1.makeServiceRequest("GetMailboxCalendarConfiguration", {}, options);
}
exports.default = getMailboxCalendarConfigurationOperation;


/***/ }),

/***/ 5251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(3413);
var setMailboxCalendarConfiguration_1 = __webpack_require__(5252);
exports.default = legacy_1.action('saveCalendarMailboxConfiguration')(function saveCalendarMailboxConfiguration(mailboxCalendarConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store_1.default.calendarConfiguration = mailboxCalendarConfiguration;
                    return [4 /*yield*/, setMailboxCalendarConfiguration_1.default(mailboxCalendarConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveCalendarMailboxConfiguration.js.map

/***/ }),

/***/ 5252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setMailboxCalendarConfigurationOperation_1 = __webpack_require__(5253);
var setMailboxCalendarConfigurationRequest_1 = __webpack_require__(3766);
var ServiceRequestUtils_1 = __webpack_require__(31);
function setMailboxCalendarConfiguration(options) {
    return setMailboxCalendarConfigurationOperation_1.default(setMailboxCalendarConfigurationRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Options: options,
    }));
}
exports.default = setMailboxCalendarConfiguration;
//# sourceMappingURL=setMailboxCalendarConfiguration.js.map

/***/ }),

/***/ 5253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var setMailboxCalendarConfigurationRequest_1 = __webpack_require__(3766);
function setMailboxCalendarConfigurationOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = setMailboxCalendarConfigurationRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("SetMailboxCalendarConfiguration", req, options);
}
exports.default = setMailboxCalendarConfigurationOperation;


/***/ }),

/***/ 5254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3413);
/**
 * Returns the calendar mailbox configuration object which is observable
 */
function getCalendarConfiguration() {
    return store_1.default.calendarConfiguration;
}
exports.default = getCalendarConfiguration;
//# sourceMappingURL=getCalendarConfiguration.js.map

/***/ }),

/***/ 5255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectWeatherShowOption_1 = __webpack_require__(5256);
var selectWeatherUnitOption_1 = __webpack_require__(5257);
var store_1 = __webpack_require__(2943);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var WeatherFull = /** @class */ (function (_super) {
    tslib_1.__extends(WeatherFull, _super);
    function WeatherFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onWeatherShowChange = function (ev, option) {
            selectWeatherShowOption_1.default(parseInt(option.key));
        };
        _this.onWeatherUnitChange = function (ev, option) {
            selectWeatherUnitOption_1.default(parseInt(option.key));
        };
        return _this;
    }
    WeatherFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, calendarConfiguration = _a.calendarConfiguration;
        if (!calendarConfiguration) {
            return null;
        }
        var isWeatherEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.weatherEnabled, calendarConfiguration.WeatherEnabled);
        var weatherUnit = owa_options_core_1.getFallbackValueIfNull(optionStore.weatherUnit, calendarConfiguration.WeatherUnit
            ? calendarConfiguration.WeatherUnit
            : 2 /* Fahrenheit */);
        return (React.createElement("div", null,
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + isWeatherEnabled, label: owa_options_strings_1.default.options_weather_toggleLabel, options: [
                    {
                        key: 2 /* Enabled */.toString(),
                        text: owa_options_strings_1.default.options_weather_enabled,
                    },
                    {
                        key: 1 /* Disabled */.toString(),
                        text: owa_options_strings_1.default.options_weather_disabled,
                    },
                ], onChange: this.onWeatherShowChange }),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + weatherUnit, label: owa_options_strings_1.default.options_weather_unitLabel, options: [
                    {
                        key: 2 /* Fahrenheit */.toString(),
                        text: owa_options_strings_1.default.options_weather_fahrenheit,
                    },
                    {
                        key: 1 /* Celsius */.toString(),
                        text: owa_options_strings_1.default.options_weather_celsius,
                    },
                ], onChange: this.onWeatherUnitChange })));
    };
    WeatherFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
        })
    ], WeatherFull);
    return WeatherFull;
}(React.Component));
exports.default = WeatherFull;
//# sourceMappingURL=WeatherFull.js.map

/***/ }),

/***/ 5256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2943);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectWeatherShowOption')(function selectWeatherShowOption(weatherEnabled, state) {
    var optionState = state.optionState;
    optionState.weatherEnabled = weatherEnabled;
}));
//# sourceMappingURL=selectWeatherShowOption.js.map

/***/ }),

/***/ 5257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2943);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectWeatherUnitOption')(function selectWeatherUnitOption(weatherUnit, state) {
    var optionState = state.optionState;
    optionState.weatherUnit = weatherUnit;
}));
//# sourceMappingURL=selectWeatherUnitOption.js.map

/***/ }),

/***/ 5258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(2943);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
})(function isWeatherOptionDirty(state) {
    if (!state.calendarConfiguration) {
        return false;
    }
    var weatherEnabled = owa_options_core_1.getFallbackValueIfNull(state.optionState.weatherEnabled, state.calendarConfiguration.WeatherEnabled);
    var weatherUnit = owa_options_core_1.getFallbackValueIfNull(state.optionState.weatherUnit, state.calendarConfiguration.WeatherUnit);
    return (weatherEnabled !== state.calendarConfiguration.WeatherEnabled ||
        weatherUnit !== state.calendarConfiguration.WeatherUnit);
});
//# sourceMappingURL=isWeatherOptionDirty.js.map

/***/ }),

/***/ 5259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardAppearanceOption_1 = __webpack_require__(5260);
var saveAppearanceOption_1 = __webpack_require__(5261);
var AppearanceFull_1 = __webpack_require__(5262);
var isAppearanceOptionDirty_1 = __webpack_require__(5264);
var React = __webpack_require__(3);
var AppearanceOption = {
    key: 'appearance',
    titleStringKey: 'optionTitle_appearance',
    searchTermsStringKey: 'optionTitle_appearance',
    fullOptionFormSettings: {
        render: function () { return React.createElement(AppearanceFull_1.default, null); },
        isDirty: isAppearanceOptionDirty_1.default,
        onSave: saveAppearanceOption_1.default,
        onDiscard: discardAppearanceOption_1.default,
    },
};
exports.default = AppearanceOption;
//# sourceMappingURL=AppearanceOption.js.map

/***/ }),

/***/ 5260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(3094);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardAppearanceOption')(function discardAppearanceOption(state) {
    var optionState = state.optionState;
    optionState.weekStartDay = null;
}));
//# sourceMappingURL=discardAppearanceOption.js.map

/***/ }),

/***/ 5261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3094);
var owa_session_store_1 = __webpack_require__(151);
var legacy_1 = __webpack_require__(1);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var saveAppearanceOption = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
    calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
})(legacy_1.action('saveAppearanceOption')(function saveAppearanceOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, calendarConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions, calendarConfiguration = state.calendarConfiguration;
                    // update the UserOptions so that changes reflect in current session
                    userOptions.WeekStartDay = owa_options_core_1.getFallbackValueIfNull(optionState.weekStartDay, calendarConfiguration.WeekStartDay);
                    calendarConfiguration.WeekStartDay = userOptions.WeekStartDay;
                    // save the new calendar configuration at server
                    return [4 /*yield*/, owa_calendar_configuration_1.saveCalendarMailboxConfiguration(calendarConfiguration)];
                case 1:
                    // save the new calendar configuration at server
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
exports.default = saveAppearanceOption;
//# sourceMappingURL=saveAppearanceOption.js.map

/***/ }),

/***/ 5262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectWeekStartDayOption_1 = __webpack_require__(5263);
var store_1 = __webpack_require__(3094);
var owa_options_core_1 = __webpack_require__(1736);
var Dropdown_1 = __webpack_require__(2652);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var owa_datetime_strings_1 = __webpack_require__(363);
var AppearanceFull = /** @class */ (function (_super) {
    tslib_1.__extends(AppearanceFull, _super);
    function AppearanceFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onWeekStartDayChange = function (option) {
            selectWeekStartDayOption_1.default(option.key);
        };
        return _this;
    }
    AppearanceFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, calendarConfiguration = _a.calendarConfiguration;
        if (!calendarConfiguration) {
            return null;
        }
        var weekStartDay = owa_options_core_1.getFallbackValueIfNull(optionStore.weekStartDay, calendarConfiguration.WeekStartDay);
        var dayOfweekOptions = [
            { key: 0, text: owa_datetime_strings_1.default.calendarDayOfWeek_Sunday },
            { key: 1, text: owa_datetime_strings_1.default.calendarDayOfWeek_Monday },
            { key: 2, text: owa_datetime_strings_1.default.calendarDayOfWeek_Tuesday },
            { key: 3, text: owa_datetime_strings_1.default.calendarDayOfWeek_Wednesday },
            { key: 4, text: owa_datetime_strings_1.default.calendarDayOfWeek_Thursday },
            { key: 5, text: owa_datetime_strings_1.default.calendarDayOfWeek_Friday },
            { key: 6, text: owa_datetime_strings_1.default.calendarDayOfWeek_Saturday },
        ];
        return (React.createElement(Dropdown_1.Dropdown, { selectedKey: weekStartDay, label: owa_options_strings_1.default.options_appearance_weekstartdayLabel, options: dayOfweekOptions, onChanged: this.onWeekStartDayChange }));
    };
    AppearanceFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
        })
    ], AppearanceFull);
    return AppearanceFull;
}(React.Component));
exports.default = AppearanceFull;
//# sourceMappingURL=AppearanceFull.js.map

/***/ }),

/***/ 5263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3094);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectWeekStartDayOption')(function selectWeekStartDayOption(weekStartDay, state) {
    var optionState = state.optionState;
    optionState.weekStartDay = weekStartDay;
}));
//# sourceMappingURL=selectWeekStartDayOption.js.map

/***/ }),

/***/ 5264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3094);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
})(function isAppearanceOptionDirty(state) {
    if (!state.calendarConfiguration) {
        return false;
    }
    var weekStartDay = owa_options_core_1.getFallbackValueIfNull(state.optionState.weekStartDay, state.calendarConfiguration.WeekStartDay);
    return weekStartDay !== state.calendarConfiguration.WeekStartDay;
});
//# sourceMappingURL=isAppearanceOptionDirty.js.map

/***/ }),

/***/ 5265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TxpOption_1 = __webpack_require__(5266);
var loadCalendarMailboxConfiguration_1 = __webpack_require__(3767);
/**
 * Automatic processing subcategory settings
 */
var automaticProcessingSubCategory = {
    key: 'automaticProcessing',
    titleStringKey: 'optionSubcategory_automaticProcessing',
    options: [TxpOption_1.default],
    onSelected: loadCalendarMailboxConfiguration_1.default,
};
exports.default = automaticProcessingSubCategory;
//# sourceMappingURL=automaticProcessingSubCategory.js.map

/***/ }),

/***/ 5266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discardTxpOption_1 = __webpack_require__(5267);
var saveTxpOption_1 = __webpack_require__(5268);
var TxpFull_1 = __webpack_require__(5269);
var isTxpOptionDirty_1 = __webpack_require__(5272);
var React = __webpack_require__(3);
/**
 * Txp options settings
 */
var TxpOption = {
    key: 'txp',
    titleStringKey: 'optionTitle_eventsForEmail',
    searchTermsStringKey: 'optionTitle_eventsForEmail',
    fullOptionFormSettings: {
        render: function () { return React.createElement(TxpFull_1.default, null); },
        isDirty: isTxpOptionDirty_1.default,
        onSave: saveTxpOption_1.default,
        onDiscard: discardTxpOption_1.default,
    },
};
exports.default = TxpOption;
//# sourceMappingURL=TxpOption.js.map

/***/ }),

/***/ 5267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(3095);
/**
 * Action called when we select discard in txp options page.  We reset the txp options in the store
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardTxpOption')(function discardTxpOption(state) {
    var optionState = state.optionState;
    optionState.CreateEventsFromEmailAsPrivate = null;
    optionState.EventsFromEmailEnabled = null;
    optionState.Events = {
        DiningEventsFromEmailEnabled: null,
        EntertainmentEventsFromEmailEnabled: null,
        FlightEventsFromEmailEnabled: null,
        HotelEventsFromEmailEnabled: null,
        InvoiceEventsFromEmailEnabled: null,
        PackageDeliveryEventsFromEmailEnabled: null,
        RentalCarEventsFromEmailEnabled: null,
    };
}));
//# sourceMappingURL=discardTxpOption.js.map

/***/ }),

/***/ 5268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3095);
var legacy_1 = __webpack_require__(1);
var owa_options_core_1 = __webpack_require__(1736);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var owa_calendar_configuration_2 = __webpack_require__(2730);
/**
 * Action called when we save the txp options
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveTxpOption')(function saveTxpOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, savedOptionState, mailboxConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState;
                    savedOptionState = owa_calendar_configuration_2.getCalendarConfiguration();
                    mailboxConfiguration = {
                        CreateEventsFromEmailAsPrivate: owa_options_core_1.getFallbackValueIfNull(optionState.CreateEventsFromEmailAsPrivate, savedOptionState.CreateEventsFromEmailAsPrivate),
                        EventsFromEmailEnabled: owa_options_core_1.getFallbackValueIfNull(optionState.EventsFromEmailEnabled, savedOptionState.EventsFromEmailEnabled),
                    };
                    // Push the rest of the events to the mailboxConfiguration
                    Object.keys(optionState.Events).map(function (eventType) {
                        var val = owa_options_core_1.getFallbackValueIfNull(optionState.Events[eventType], savedOptionState[eventType]);
                        mailboxConfiguration[eventType] = val;
                    });
                    return [4 /*yield*/, owa_calendar_configuration_1.saveCalendarMailboxConfiguration(mailboxConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveTxpOption.js.map

/***/ }),

/***/ 5269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(3095);
var owa_options_core_1 = __webpack_require__(1736);
var ChoiceGroup_1 = __webpack_require__(2613);
var owa_options_controls_1 = __webpack_require__(2661);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var react_1 = __webpack_require__(1546);
var updateTxpFlag_1 = __webpack_require__(3768);
var owa_calendar_configuration_1 = __webpack_require__(2730);
var TxpEventsPanel_1 = __webpack_require__(5270);
var ENABLE = 'enable';
var DISABLE = 'disable';
var TxpFull = /** @class */ (function (_super) {
    tslib_1.__extends(TxpFull, _super);
    function TxpFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The event handler for the radio button to enable or disable txp
         */
        _this.eventsToEmailUpdated = function (ev, option) {
            updateTxpFlag_1.default('EventsFromEmailEnabled', option.key == ENABLE);
        };
        /**
         * The event handler behind the OptionsCheckbox for setting the CreateEventsFromEmailAsPrivate flag
         */
        _this.updateCreateEventsFromEmailAsPrivateFlag = function (ev, checked) {
            updateTxpFlag_1.default('CreateEventsFromEmailAsPrivate', checked);
        };
        return _this;
    }
    TxpFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var mailboxCalendarConfiguration = owa_calendar_configuration_1.getCalendarConfiguration();
        if (!mailboxCalendarConfiguration) {
            return null;
        }
        // Initializing all the flags for the UI
        var EventsFromEmailEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.EventsFromEmailEnabled, mailboxCalendarConfiguration.EventsFromEmailEnabled);
        var CreateEventsFromEmailAsPrivate = owa_options_core_1.getFallbackValueIfNull(optionStore.CreateEventsFromEmailAsPrivate, mailboxCalendarConfiguration.CreateEventsFromEmailAsPrivate);
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_txp_description),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: EventsFromEmailEnabled ? ENABLE : DISABLE, options: [
                    {
                        key: DISABLE,
                        text: owa_options_strings_1.default.options_txp_disable,
                    },
                    {
                        key: ENABLE,
                        text: owa_options_strings_1.default.options_txp_enable,
                    },
                ], onChange: this.eventsToEmailUpdated }),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { label: owa_options_strings_1.default.options_txp_markEventsPrivate, checked: CreateEventsFromEmailAsPrivate, disabled: !EventsFromEmailEnabled, onChange: this.updateCreateEventsFromEmailAsPrivateFlag }),
            React.createElement(TxpEventsPanel_1.default, { formFlags: optionStore.Events, mailboxCalendarConfiguration: mailboxCalendarConfiguration, flagsDisabled: !EventsFromEmailEnabled })));
    };
    TxpFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
        })
    ], TxpFull);
    return TxpFull;
}(React.Component));
exports.default = TxpFull;
//# sourceMappingURL=TxpFull.js.map

/***/ }),

/***/ 5270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_controls_1 = __webpack_require__(2661);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var Label_1 = __webpack_require__(1559);
var updateTxpFlag_1 = __webpack_require__(3768);
var getTxpFlagInfo_1 = __webpack_require__(5271);
var TxpEventsPanel = /** @class */ (function (_super) {
    tslib_1.__extends(TxpEventsPanel, _super);
    function TxpEventsPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * On change handler for the OptionsCheckbox
         */
        _this.updateFlagFromCheckbox = function (flag) { return function (ev, checked) {
            updateTxpFlag_1.default(flag, checked);
        }; };
        return _this;
    }
    TxpEventsPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, formFlags = _a.formFlags, mailboxCalendarConfiguration = _a.mailboxCalendarConfiguration, flagsDisabled = _a.flagsDisabled;
        return (React.createElement("div", null,
            React.createElement(Label_1.Label, null, owa_options_strings_1.default.options_txp_addEventsTitle),
            getTxpFlagInfo_1.EventsInOptionsPageInOrder.map(function (eventType) {
                if (!getTxpFlagInfo_1.isEventTypeEnabled(eventType)) {
                    return null;
                }
                var checked = owa_options_core_1.getFallbackValueIfNull(formFlags[eventType], mailboxCalendarConfiguration[eventType]);
                return (React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: checked, disabled: flagsDisabled, onChange: _this.updateFlagFromCheckbox(eventType), label: getTxpFlagInfo_1.getLabelForTxpFlag(eventType) }));
            })));
    };
    TxpEventsPanel = tslib_1.__decorate([
        mobx_react_1.observer
    ], TxpEventsPanel);
    return TxpEventsPanel;
}(React.Component));
exports.default = TxpEventsPanel;
//# sourceMappingURL=TxpEventsPanel.js.map

/***/ }),

/***/ 5271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = __webpack_require__(1737);
var owa_controls_feature_flags_1 = __webpack_require__(33);
/**
 * Returns the string for the label of the checkbox fo the txp flag in the UI
 * @param flagName The name of the event flag
 */
function getLabelForTxpFlag(flagName) {
    switch (flagName) {
        case 'FlightEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_flights;
        case 'HotelEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_hotelReservations;
        case 'RentalCarEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_carRentals;
        case 'PackageDeliveryEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_packageDelivery;
        case 'DiningEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_diningReservations;
        case 'EntertainmentEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_events;
        case 'InvoiceEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_bills;
    }
}
exports.getLabelForTxpFlag = getLabelForTxpFlag;
/**
 * Checks the feature flags to determine if this event type is enabled
 * @param eventType The event type which should be validated
 */
function isEventTypeEnabled(eventType) {
    switch (eventType) {
        case 'DiningEventsFromEmailEnabled':
            return owa_controls_feature_flags_1.isControlFeatureEnabled('cal-txp-dining');
        case 'EntertainmentEventsFromEmailEnabled':
            return owa_controls_feature_flags_1.isControlFeatureEnabled('cal-txp-entertainment');
        case 'InvoiceEventsFromEmailEnabled':
            return owa_controls_feature_flags_1.isControlFeatureEnabled('cal-txp-invoice');
    }
    // All other events are enabled by default
    return true;
}
exports.isEventTypeEnabled = isEventTypeEnabled;
/**
 * Returns the list of all EventFlagTypes in the order they should be displayed in the UI
 */
exports.EventsInOptionsPageInOrder = [
    'FlightEventsFromEmailEnabled',
    'HotelEventsFromEmailEnabled',
    'RentalCarEventsFromEmailEnabled',
    'PackageDeliveryEventsFromEmailEnabled',
    'DiningEventsFromEmailEnabled',
    'EntertainmentEventsFromEmailEnabled',
    'InvoiceEventsFromEmailEnabled',
];
//# sourceMappingURL=getTxpFlagInfo.js.map

/***/ }),

/***/ 5272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = __webpack_require__(1736);
var store_1 = __webpack_require__(3095);
var legacy_1 = __webpack_require__(1);
var owa_calendar_configuration_1 = __webpack_require__(2730);
/**
 * Returns if the Txp options page is in dirty state (user made changes to it)
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(function isTxpOptionDirty(state) {
    var savedOptions = owa_calendar_configuration_1.getCalendarConfiguration();
    var formOptions = state.optionState;
    if (!savedOptions) {
        return false;
    }
    var EventsFromEmailEnabled = owa_options_core_1.getFallbackValueIfNull(formOptions.EventsFromEmailEnabled, savedOptions.EventsFromEmailEnabled);
    if (savedOptions.EventsFromEmailEnabled !== EventsFromEmailEnabled) {
        return true;
    }
    if (!EventsFromEmailEnabled) {
        // if savedOptions.EventsFromEmailEnabled == EventsFromEmailEnabled == false,
        // return not dirty since we don't have to check rest of the flags
        return false;
    }
    var CreateEventsFromEmailAsPrivate = owa_options_core_1.getFallbackValueIfNull(formOptions.CreateEventsFromEmailAsPrivate, savedOptions.CreateEventsFromEmailAsPrivate);
    if (CreateEventsFromEmailAsPrivate !== savedOptions.CreateEventsFromEmailAsPrivate) {
        return true;
    }
    var isEventFlagDirty = false;
    // Validate if the event flags are changed
    Object.keys(formOptions.Events).map(function (eventType) {
        var eventEnabled = owa_options_core_1.getFallbackValueIfNull(formOptions.Events[eventType], savedOptions[eventType]);
        if (eventEnabled !== savedOptions[eventType]) {
            isEventFlagDirty = true;
        }
    });
    return isEventFlagDirty;
});
//# sourceMappingURL=isTxpOptionDirty.js.map

/***/ }),

/***/ 5273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var satcheljs_1 = __webpack_require__(2);
var store_1 = __webpack_require__(2113);
exports.default = satcheljs_1.mutatorAction('setCategory', function setCategory(categoryKey, subcategoryKey, currentOptionKey) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = store_1.getStore();
            store.currentCategoryKey = categoryKey;
            store.currentSubCategoryKey = subcategoryKey;
            store.currentOptionKey = currentOptionKey;
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=setCategory.js.map

/***/ }),

/***/ 5274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var store_1 = __webpack_require__(2113);
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.mutatorAction('setSubCategoryState', function setSubCategoryState(subCategoryState) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = store_1.getStore();
            store.currentSubCategoryState = subCategoryState;
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=setSubCategoryState.js.map

/***/ }),

/***/ 5275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_workloads_1 = __webpack_require__(372);
var owa_options_general_1 = __webpack_require__(3724);
var owa_options_mail_1 = __webpack_require__(3378);
var owa_options_calendar_1 = __webpack_require__(3764);
function getDefaultCategory() {
    switch (owa_workloads_1.getOwaWorkload()) {
        case 1 /* Mail */:
        case 16 /* MailMini */:
            return owa_options_mail_1.MailOptions.key;
        case 2 /* Calendar */:
            return owa_options_calendar_1.CalendarOptions.key;
        default:
            return owa_options_general_1.GeneralOptions.key;
    }
}
exports.default = getDefaultCategory;
//# sourceMappingURL=getDefaultCategory.js.map

/***/ }),

/***/ 5276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var updateCategory_1 = __webpack_require__(3414);
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
exports.default = satcheljs_1.orchestratorAction('selectCategory', function selectCategory(category) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var currentSubCategoryKey;
        return tslib_1.__generator(this, function (_a) {
            currentSubCategoryKey = category.subcategories && category.subcategories[0] && category.subcategories[0].key;
            updateCategory_1.default(category.key, currentSubCategoryKey, null);
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=selectCategory.js.map

/***/ }),

/***/ 5277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var store_1 = __webpack_require__(2113);
var updateCategory_1 = __webpack_require__(3414);
exports.default = satcheljs_1.orchestratorAction('selectSubcategory', function selectSubcategory(subcategory) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = store_1.getStore();
            updateCategory_1.default(store.currentCategoryKey, subcategory.key, null);
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=selectSubcategory.js.map

/***/ }),

/***/ 5278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getAllOptions_1 = __webpack_require__(3771);
var mobx_1 = __webpack_require__(15);
var owa_workloads_1 = __webpack_require__(372);
var quickOptions = mobx_1.computed(function () {
    return getAllOptions_1.default()
        .filter(function (option) {
        return !!option.quickOptionSettings &&
            owa_workloads_1.getOwaWorkload() & option.quickOptionSettings.workloads;
    })
        .sort(function (a, b) { return a.quickOptionSettings.order - b.quickOptionSettings.order; });
});
exports.default = function () { return quickOptions.get(); };
//# sourceMappingURL=getQuickOptions.js.map

/***/ }),

/***/ 5279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var owa_options_store_1 = __webpack_require__(2641);
var owa_header_store_1 = __webpack_require__(1608);
var confirmDirtyOptionsAndPerformAction_1 = __webpack_require__(3186);
exports.default = satcheljs_1.orchestratorAction('hideFullOptions', function hideFullOptions(showQuickOptions) {
    var continueAfterConfirmCallback = function () {
        owa_options_store_1.setIsFullOptionsShown(false);
        if (showQuickOptions) {
            owa_header_store_1.toggleCharm(4 /* SettingsCharm */);
        }
    };
    confirmDirtyOptionsAndPerformAction_1.default(continueAfterConfirmCallback);
});
//# sourceMappingURL=hideFullOptions.js.map

/***/ }),

/***/ 5280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var owa_options_store_1 = __webpack_require__(2641);
var saveOrDiscardOptions_1 = __webpack_require__(3721);
exports.saveOptions = satcheljs_1.orchestratorAction('saveOptions', function saveOptions() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 2, 3]);
                    owa_options_store_1.setIsSaving(true);
                    return [4 /*yield*/, saveOrDiscardOptions_1.default(true)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    owa_options_store_1.setIsSaving(false);
                    return [7 /*endfinally*/];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveOptions.js.map

/***/ }),

/***/ 5281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var showFullOptions_1 = __webpack_require__(3772);
var confirmDirtyOptionsAndPerformAction_1 = __webpack_require__(3186);
exports.default = satcheljs_1.orchestratorAction('navigateToSearchSuggestion', function navigateToSearchSuggestion(category, subcategory, option) {
    var continueAfterConfirmCallback = function () {
        showFullOptions_1.default(category, subcategory, option);
    };
    confirmDirtyOptionsAndPerformAction_1.default(continueAfterConfirmCallback);
});
//# sourceMappingURL=navigateToSearchSuggestion.js.map

/***/ }),

/***/ 5282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var owa_options_store_1 = __webpack_require__(2641);
var confirmDirtyOptionsAndPerformAction_1 = __webpack_require__(3186);
exports.default = satcheljs_1.orchestratorAction('selectCategory', function selectCategory(category) {
    var continueAfterConfirmCallback = function () {
        owa_options_store_1.selectCategory(category);
    };
    confirmDirtyOptionsAndPerformAction_1.default(continueAfterConfirmCallback);
});
//# sourceMappingURL=selectCategory.js.map

/***/ }),

/***/ 5283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = __webpack_require__(2);
/* tslint:enable:forbid-import */
var owa_options_store_1 = __webpack_require__(2641);
var confirmDirtyOptionsAndPerformAction_1 = __webpack_require__(3186);
exports.default = satcheljs_1.orchestratorAction('selectSubcategory', function hideFullOptions(subcategory) {
    var continueAfterConfirmCallback = function () {
        owa_options_store_1.selectSubcategory(subcategory);
    };
    confirmDirtyOptionsAndPerformAction_1.default(continueAfterConfirmCallback);
});
//# sourceMappingURL=selectSubcategory.js.map

/***/ }),

/***/ 5284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var onQuickOptionToggle_1 = __webpack_require__(3773);
var satcheljs_1 = __webpack_require__(2);
var owa_analytics_1 = __webpack_require__(12);
var QUICK_SETTINGS_TOGGLE_USAGE_KEY = 'quickSettingsToggle';
exports.default = satcheljs_1.orchestrator(onQuickOptionToggle_1.default, function (actionMessage) {
    var option = actionMessage.option, isToggledOn = actionMessage.isToggledOn;
    owa_analytics_1.logUsage(QUICK_SETTINGS_TOGGLE_USAGE_KEY, {
        optionKey: option.key,
        isToggledOn: "" + isToggledOn,
    });
    var onToggle = option.quickOptionSettings.rendering.onToggle;
    if (onToggle) {
        onToggle(isToggledOn);
    }
});
//# sourceMappingURL=toggleQuickOption.js.map

/***/ }),

/***/ 5285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var CategoriesColumn_1 = __webpack_require__(5286);
var OptionsPane_1 = __webpack_require__(5302);
var OptionsPaneError_1 = __webpack_require__(5304);
var OptionsPaneLoading_1 = __webpack_require__(5307);
var SettingsFormHeader_1 = __webpack_require__(5310);
var SubCategoriesColumn_1 = __webpack_require__(5311);
var styling_1 = __webpack_require__(91);
var mobx_react_1 = __webpack_require__(11);
var Modal_1 = __webpack_require__(1743);
var owa_options_orchestration_1 = __webpack_require__(2794);
var owa_options_store_1 = __webpack_require__(2641);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var styles = __webpack_require__(2799);
var className = __webpack_require__(30).bind(styles);
var OptionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsFull, _super);
    function OptionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsFull.prototype.render = function () {
        var store = owa_options_store_1.getStore();
        var subcategoriesForCategory = owa_options_store_1.getCurrentCategory().subcategories;
        var selectedSubCategory = owa_options_store_1.getCurrentSubcategory() || {};
        var options = selectedSubCategory.options || [];
        return (React.createElement(Modal_1.Modal, { isOpen: store.isFullOptionsShown, onDismiss: this.hide, containerClassName: store.isFullOptionsShown
                ? styling_1.AnimationClassNames.slideUpIn20
                : styling_1.AnimationClassNames.slideDownOut20 },
            React.createElement("div", { className: styles.container },
                React.createElement(CategoriesColumn_1.default, null),
                React.createElement(SubCategoriesColumn_1.default, { subcategories: subcategoriesForCategory }),
                React.createElement("div", { className: className(styles.settingsPane, styling_1.AnimationClassNames.slideLeftIn20), key: store.currentSubCategoryKey },
                    React.createElement(SettingsFormHeader_1.default, { selectedSubCategory: selectedSubCategory }),
                    store.currentSubCategoryState === 0 /* Loading */ && (React.createElement(OptionsPaneLoading_1.default, null)),
                    store.currentSubCategoryState === 1 /* Loaded */ && (React.createElement(OptionsPane_1.default, { options: options })),
                    store.currentSubCategoryState === 2 /* Error */ && (React.createElement(OptionsPaneError_1.default, null))))));
    };
    OptionsFull.prototype.hide = function () {
        owa_options_orchestration_1.hideFullOptions();
    };
    OptionsFull = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionsFull);
    return OptionsFull;
}(React.Component));
exports.default = OptionsFull;
var optionsFullContainer;
function mountOptionsFullPopup() {
    if (!optionsFullContainer) {
        optionsFullContainer = document.createElement('div');
        document.body.appendChild(optionsFullContainer);
        ReactDOM.render(React.createElement(OptionsFull, null), optionsFullContainer);
    }
}
exports.mountOptionsFullPopup = mountOptionsFullPopup;
//# sourceMappingURL=OptionsFull.js.map

/***/ }),

/***/ 5286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_store_1 = __webpack_require__(2641);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var owa_options_orchestration_1 = __webpack_require__(2794);
var FullOptionSearch_1 = __webpack_require__(5287);
var FocusZone_1 = __webpack_require__(78);
var styles = __webpack_require__(2799);
var className = __webpack_require__(30).bind(styles);
var CategoryEntry = mobx_react_1.observer(function (props) {
    var buttonStyles = {
        root: className(styles.category, {
            selectedCategory: owa_options_store_1.getStore().currentCategoryKey === props.category.key,
        }),
        flexContainer: styles.flexContainer,
        label: styles.categoryLabel,
    };
    var iconProps = {
        iconName: props.category.icon,
        styles: {
            root: styles.categoryIcon,
        },
    };
    return (React.createElement(Button_1.ActionButton, { styles: buttonStyles, key: props.category.key, onClick: function () { return owa_options_orchestration_1.selectCategory(props.category); }, iconProps: iconProps, text: owa_options_strings_1.default[props.category.titleStringKey] }));
});
var CategoriesColumn = /** @class */ (function (_super) {
    tslib_1.__extends(CategoriesColumn, _super);
    function CategoriesColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoriesColumn.prototype.render = function () {
        return (React.createElement("div", { className: styles.categoriesColumn },
            React.createElement("span", { className: styles.title, role: "heading", "aria-level": 2 }, owa_options_strings_1.default.options_title),
            React.createElement(FullOptionSearch_1.default, null),
            React.createElement(FocusZone_1.FocusZone, { direction: FocusZone_1.FocusZoneDirection.vertical }, owa_options_store_1.collectedOptions().map(function (category) { return (React.createElement(CategoryEntry, { category: category, key: category.key })); })),
            React.createElement(Button_1.CommandButton, { className: styles.viewQuickSettings, onClick: this.goToQuickOptions, iconProps: {
                    iconName: "ChevronLeft" /* ChevronLeft */,
                    styles: {
                        root: className(styles.icon, 'flipForRtl'),
                    },
                }, text: owa_options_strings_1.default.optionsFull_goToQuickOptions })));
    };
    CategoriesColumn.prototype.goToQuickOptions = function () {
        owa_options_orchestration_1.hideFullOptions(true /* showQuickOptions */);
    };
    CategoriesColumn = tslib_1.__decorate([
        mobx_react_1.observer
    ], CategoriesColumn);
    return CategoriesColumn;
}(React.Component));
exports.default = CategoriesColumn;
//# sourceMappingURL=CategoriesColumn.js.map

/***/ }),

/***/ 5287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_store_1 = __webpack_require__(2641);
var owa_options_store_2 = __webpack_require__(2641);
var mobx_react_1 = __webpack_require__(11);
var SearchBox_1 = __webpack_require__(2141);
var Callout_1 = __webpack_require__(157);
var FocusZone_1 = __webpack_require__(78);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var filterOptions_1 = __webpack_require__(3774);
var OptionSearchSuggestion_1 = __webpack_require__(5300);
var styles = __webpack_require__(2799);
var FullOptionSearch = /** @class */ (function (_super) {
    tslib_1.__extends(FullOptionSearch, _super);
    function FullOptionSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSearchBoxKeyDown = function (ev) {
            if (ev.key === 'ArrowDown') {
                _this.suggestionFocusZone.focus();
                ev.stopPropagation();
                ev.preventDefault();
            }
        };
        _this.onFirstOptionKeyDown = function (ev) {
            switch (ev.key) {
                case 'ArrowUp':
                    if (ev.currentTarget.dataset.optionIndex === '0') {
                        _this.searchBox.focus();
                        break;
                    }
                    else {
                        return;
                    }
                case 'Escape':
                    owa_options_store_1.setSearchTerm('');
                    _this.searchBox.focus();
                    break;
                default:
                    // don't stop propagation or prevent default
                    return;
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this.searchBoxRef = function (ref) {
            _this.searchBox = ref;
            _this.searchBoxElement = ReactDOM.findDOMNode(ref);
        };
        _this.suggestionFocusZoneRef = function (ref) {
            _this.suggestionFocusZone = ref;
        };
        return _this;
    }
    FullOptionSearch.prototype.render = function () {
        var _this = this;
        var store = owa_options_store_2.getStore();
        var suggestedOptions = filterOptions_1.default(store.searchTerm);
        var showSuggestions = suggestedOptions && suggestedOptions.length > 0;
        return (React.createElement("div", { onKeyDown: showSuggestions && this.onSearchBoxKeyDown },
            React.createElement(SearchBox_1.SearchBox, { componentRef: this.searchBoxRef, labelText: owa_options_strings_1.default.optionsFull_searchPlaceholder, className: styles.searchBox, value: store.searchTerm, onChanged: owa_options_store_1.setSearchTerm }),
            showSuggestions && (React.createElement(Callout_1.Callout, { target: this.searchBoxElement, isBeakVisible: false, className: styles.suggestionCallout },
                React.createElement(FocusZone_1.FocusZone, { direction: FocusZone_1.FocusZoneDirection.vertical, componentRef: this.suggestionFocusZoneRef }, suggestedOptions.map(function (option, index) { return (React.createElement(OptionSearchSuggestion_1.default, { key: option.key, option: option, onKeyDown: _this.onFirstOptionKeyDown, "data-option-index": index })); }))))));
    };
    FullOptionSearch = tslib_1.__decorate([
        mobx_react_1.observer
    ], FullOptionSearch);
    return FullOptionSearch;
}(React.Component));
exports.default = FullOptionSearch;
//# sourceMappingURL=FullOptionSearch.js.map

/***/ }),

/***/ 5288:
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(5289);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),

/***/ 5289:
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(5290);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 5290:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(3415),
    arrayMap = __webpack_require__(5293),
    isArray = __webpack_require__(5294),
    isSymbol = __webpack_require__(5295);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 5291:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(5292);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 5292:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),

/***/ 5293:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 5294:
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 5295:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(5296),
    isObjectLike = __webpack_require__(5299);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 5296:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(3415),
    getRawTag = __webpack_require__(5297),
    objectToString = __webpack_require__(5298);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 5297:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(3415);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 5298:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5299:
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 5300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_orchestration_1 = __webpack_require__(2794);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var styles = __webpack_require__(2799);
var OptionSearchSuggestion = /** @class */ (function (_super) {
    tslib_1.__extends(OptionSearchSuggestion, _super);
    function OptionSearchSuggestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSuggestionClick = function () {
            var option = _this.props.option;
            owa_options_orchestration_1.navigateToSearchSuggestion(option.categoryKey, option.subcategoryKey, option.key);
        };
        return _this;
    }
    OptionSearchSuggestion.prototype.render = function () {
        var option = this.props.option;
        return (React.createElement(Button_1.CommandButton, tslib_1.__assign({}, this.props, { text: owa_options_strings_1.default[option.titleStringKey], onClick: this.onSuggestionClick, className: styles.suggestion })));
    };
    OptionSearchSuggestion = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionSearchSuggestion);
    return OptionSearchSuggestion;
}(React.Component));
exports.default = OptionSearchSuggestion;
//# sourceMappingURL=OptionSearchSuggestion.js.map

/***/ }),

/***/ 5301:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".qXfMpIrUN84St6chPqPyO{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;height:90vh;width:90vw;max-width:1280px;overflow-x:hidden}html[dir] .qXfMpIrUN84St6chPqPyO{background:\"[theme:white, default:#ffffff]\"}.qXfMpIrUN84St6chPqPyO>*{-webkit-box-sizing:border-box;box-sizing:border-box}._22iZPI0NO5yLVm7ZEwwWUB{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:220px;height:100%}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB{padding-top:17px;background-color:\"[theme:neutralLighter, default:#f4f4f4]\"}html[dir=ltr] ._22iZPI0NO5yLVm7ZEwwWUB{border-right:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir=rtl] ._22iZPI0NO5yLVm7ZEwwWUB{border-left:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:increment{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDowQzU1NDExQUNFQTExMUUwODVCRDlGMjgxNTUwOTY0MSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDowQzU1NDExOUNFQTExMUUwODVCRDlGMjgxNTUwOTY0MSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnbliksAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAACFJREFUCFtj/M/ACEd/mRj/MDP+aWb84wxGzSAuUBBJDQCreRGBIU9zHQAAAABJRU5ErkJggg==)}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:increment:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGNjMxOTJDNkNFQTAxMUUwOTEwQThBOUQ3OTU2MDhBRCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGNjMxOTJDNUNFQTAxMUUwOTEwQThBOUQ3OTU2MDhBRCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnVIpeYAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAACFJREFUCFtj/M/ACEd/mRj/MDP+aWb84wxGzSAuUBBJDQCreRGBIU9zHQAAAABJRU5ErkJggg==)}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:decrement{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyOTQ1MTFBOUNFQTExMUUwQjFCMUQ0QTY5Nzg0NkM4MyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyOTQ1MTFBOENFQTExMUUwQjFCMUQ0QTY5Nzg0NkM4MyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhHC5VgAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAACBJREFUCFtj+P+fAYH2M/y3Z/hnz/AHjIAMIBckiFADAIcKGtnX/NNJAAAAAElFTkSuQmCC)}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:decrement:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxRDlGMzQxNUNFQTExMUUwOUQ1RUMzMDcwNkI3NzQ4OSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxRDlGMzQxNENFQTExMUUwOUQ1RUMzMDcwNkI3NzQ4OSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Piwt9IAAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAACBJREFUCFtj+P+fAYH2M/y3Z/hnz/AHjIAMIBckiFADAIcKGtnX/NNJAAAAAElFTkSuQmCC)}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:increment{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCQUVGMjQ0M0NFQTAxMUUwODVFRkVGMkEyMDYzQjNCOSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCQUVGMjQ0MkNFQTAxMUUwODVFRkVGMkEyMDYzQjNCOSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pi1r31IAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIY+yDP+UGf848z4r5ERQxYAnBUQ8bRhSzUAAAAASUVORK5CYII=)}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:increment:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBODk4RUE4QUNFQTAxMUUwQjI0MUFCODBCNTk2MzdFMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBODk4RUE4OUNFQTAxMUUwQjI0MUFCODBCNTk2MzdFMSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrzuktcAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIY+yDP+UGf848z4r5ERQxYAnBUQ8bRhSzUAAAAASUVORK5CYII=)}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:decrement{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzVEMjUyMkNFQTAxMUUwQTc0NzgzNTNCNkQ3RkNFRCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzVEMjUyMUNFQTAxMUUwQTc0NzgzNTNCNkQ3RkNFRCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Psti8fgAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIb+NTL+cWb8oc74QZ4RQxYAoGUQ8fkWopYAAAAASUVORK5CYII=)}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:decrement:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpEM0ZDNDlGQ0NFQTAxMUUwQUY5RkJGN0ZBNEREREEyMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpEM0ZDNDlGQkNFQTAxMUUwQUY5RkJGN0ZBNEREREEyMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhWCNEUAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIb+NTL+cWb8oc74QZ4RQxYAoGUQ8fkWopYAAAAASUVORK5CYII=)}._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar{height:18px;width:18px}._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar:disabled{display:none}._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button,._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-corner{cursor:pointer}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-corner{background:transparent}._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:decrement,._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:decrement:hover,._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:increment,._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:increment:hover,._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:decrement,._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:decrement:hover,._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:increment,._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:increment:hover{height:18px;width:18px}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:decrement,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:decrement:hover,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:increment,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:horizontal:increment:hover,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:decrement,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:decrement:hover,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:increment,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-button:vertical:increment:hover{background-position:50%}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-track{background:transparent}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-thumb,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-thumb:hover{border-radius:9px;border:solid 6px transparent;background-clip:content-box}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-thumb{background-color:\"[theme:neutralTertiaryAlt, default:#c8c8c8]\"}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-thumb:hover{background-color:#98a3a6}._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-thumb:vertical{min-height:50px}._22iZPI0NO5yLVm7ZEwwWUB::-webkit-scrollbar-thumb:horizontal{min-width:50px}._22iZPI0NO5yLVm7ZEwwWUB .ZOSvR9HMptaRCzltth2tS{font-weight:600;font-size:21px;font-weight:100}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB .ZOSvR9HMptaRCzltth2tS{margin:0 20px}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB ._7gMTzWZHFW2-X2YQSPTYk{margin:15px 20px 12px;background:\"[theme:white, default:#ffffff]\"}._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR{height:36px;width:100%;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;cursor:pointer}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR{background:transparent}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR:hover ._2VV3vvwJY7ElpcLFdWRrtm,._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR:hover ._33kOrhBTfcJDt7Z1zho3cz{color:\"[theme:neutralPrimary, default:#333333]\"}._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR._3EQe4rNS6RGVZhdrfcQ0xJ,._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR:active{font-weight:600}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR._3EQe4rNS6RGVZhdrfcQ0xJ,html[dir] ._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR:active{background-color:\"[theme:themeLighter, default:#DEECF9]\"}._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR ._1yVwdO96cNCOi9Ed29UjwJ{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR ._33kOrhBTfcJDt7Z1zho3cz{-webkit-box-flex:0;-ms-flex:0;flex:0;-ms-flex-preferred-size:14px;flex-basis:14px}html[dir=ltr] ._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR ._33kOrhBTfcJDt7Z1zho3cz{margin-left:20px;margin-right:12px}html[dir=rtl] ._22iZPI0NO5yLVm7ZEwwWUB ._2Zp89qXMMDSbiFU092bdlR ._33kOrhBTfcJDt7Z1zho3cz{margin-right:20px;margin-left:12px}._22iZPI0NO5yLVm7ZEwwWUB .nPXuv-KG0gs3GFXZaoAXZ{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._22iZPI0NO5yLVm7ZEwwWUB .nPXuv-KG0gs3GFXZaoAXZ{margin-right:20px;margin-left:6px}html[dir=rtl] ._22iZPI0NO5yLVm7ZEwwWUB .nPXuv-KG0gs3GFXZaoAXZ{margin-left:20px;margin-right:6px}._22iZPI0NO5yLVm7ZEwwWUB .nPXuv-KG0gs3GFXZaoAXZ ._166Nf7WhGsIatqLBo0pLRJ{font-size:12px}html[dir] ._22iZPI0NO5yLVm7ZEwwWUB .nPXuv-KG0gs3GFXZaoAXZ ._166Nf7WhGsIatqLBo0pLRJ{margin-top:3px}html[dir=ltr] ._22iZPI0NO5yLVm7ZEwwWUB .nPXuv-KG0gs3GFXZaoAXZ ._166Nf7WhGsIatqLBo0pLRJ{margin-left:10px}html[dir=rtl] ._22iZPI0NO5yLVm7ZEwwWUB .nPXuv-KG0gs3GFXZaoAXZ ._166Nf7WhGsIatqLBo0pLRJ{margin-right:10px}._1dC--UHy36KfoYK7bO31E_{min-width:179px}._1dC--UHy36KfoYK7bO31E_ ._3OaQc_SuiriDAbX9ITw3l4{display:block;width:100%}html[dir] ._1dC--UHy36KfoYK7bO31E_ ._3OaQc_SuiriDAbX9ITw3l4:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}html[dir] ._1dC--UHy36KfoYK7bO31E_ ._3OaQc_SuiriDAbX9ITw3l4:active,html[dir] ._1dC--UHy36KfoYK7bO31E_ ._3OaQc_SuiriDAbX9ITw3l4:focus{background-color:\"[theme:themeLighter, default:#DEECF9]\"}._1AniWxXbFkF6Ldb0qdFzmW{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:200px;height:100%;overflow-x:hidden;overflow-y:auto;text-overflow:ellipsis}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW{padding-top:18px;padding-bottom:22px}html[dir=ltr] ._1AniWxXbFkF6Ldb0qdFzmW{border-right:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir=rtl] ._1AniWxXbFkF6Ldb0qdFzmW{border-left:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:increment{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDowQzU1NDExQUNFQTExMUUwODVCRDlGMjgxNTUwOTY0MSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDowQzU1NDExOUNFQTExMUUwODVCRDlGMjgxNTUwOTY0MSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnbliksAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAACFJREFUCFtj/M/ACEd/mRj/MDP+aWb84wxGzSAuUBBJDQCreRGBIU9zHQAAAABJRU5ErkJggg==)}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:increment:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGNjMxOTJDNkNFQTAxMUUwOTEwQThBOUQ3OTU2MDhBRCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGNjMxOTJDNUNFQTAxMUUwOTEwQThBOUQ3OTU2MDhBRCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnVIpeYAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAACFJREFUCFtj/M/ACEd/mRj/MDP+aWb84wxGzSAuUBBJDQCreRGBIU9zHQAAAABJRU5ErkJggg==)}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:decrement{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyOTQ1MTFBOUNFQTExMUUwQjFCMUQ0QTY5Nzg0NkM4MyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyOTQ1MTFBOENFQTExMUUwQjFCMUQ0QTY5Nzg0NkM4MyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhHC5VgAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAACBJREFUCFtj+P+fAYH2M/y3Z/hnz/AHjIAMIBckiFADAIcKGtnX/NNJAAAAAElFTkSuQmCC)}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:decrement:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxRDlGMzQxNUNFQTExMUUwOUQ1RUMzMDcwNkI3NzQ4OSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxRDlGMzQxNENFQTExMUUwOUQ1RUMzMDcwNkI3NzQ4OSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Piwt9IAAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAACBJREFUCFtj+P+fAYH2M/y3Z/hnz/AHjIAMIBckiFADAIcKGtnX/NNJAAAAAElFTkSuQmCC)}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:increment{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCQUVGMjQ0M0NFQTAxMUUwODVFRkVGMkEyMDYzQjNCOSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCQUVGMjQ0MkNFQTAxMUUwODVFRkVGMkEyMDYzQjNCOSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pi1r31IAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIY+yDP+UGf848z4r5ERQxYAnBUQ8bRhSzUAAAAASUVORK5CYII=)}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:increment:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBODk4RUE4QUNFQTAxMUUwQjI0MUFCODBCNTk2MzdFMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBODk4RUE4OUNFQTAxMUUwQjI0MUFCODBCNTk2MzdFMSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrzuktcAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIY+yDP+UGf848z4r5ERQxYAnBUQ8bRhSzUAAAAASUVORK5CYII=)}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:decrement{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzVEMjUyMkNFQTAxMUUwQTc0NzgzNTNCNkQ3RkNFRCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzVEMjUyMUNFQTAxMUUwQTc0NzgzNTNCNkQ3RkNFRCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Psti8fgAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIb+NTL+cWb8oc74QZ4RQxYAoGUQ8fkWopYAAAAASUVORK5CYII=)}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:decrement:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpEM0ZDNDlGQ0NFQTAxMUUwQUY5RkJGN0ZBNEREREEyMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpEM0ZDNDlGQkNFQTAxMUUwQUY5RkJGN0ZBNEREREEyMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhWCNEUAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIb+NTL+cWb8oc74QZ4RQxYAoGUQ8fkWopYAAAAASUVORK5CYII=)}._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar{height:18px;width:18px}._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar:disabled{display:none}._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button,._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-corner{cursor:pointer}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-corner{background:transparent}._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:decrement,._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:decrement:hover,._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:increment,._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:increment:hover,._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:decrement,._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:decrement:hover,._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:increment,._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:increment:hover{height:18px;width:18px}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:decrement,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:decrement:hover,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:increment,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:horizontal:increment:hover,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:decrement,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:decrement:hover,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:increment,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-button:vertical:increment:hover{background-position:50%}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-track{background:transparent}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-thumb,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-thumb:hover{border-radius:9px;border:solid 6px transparent;background-clip:content-box}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-thumb{background-color:\"[theme:neutralTertiaryAlt, default:#c8c8c8]\"}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-thumb:hover{background-color:#98a3a6}._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-thumb:vertical{min-height:50px}._1AniWxXbFkF6Ldb0qdFzmW::-webkit-scrollbar-thumb:horizontal{min-width:50px}._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G{min-height:36px;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;cursor:pointer}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G{background:transparent}html[dir=ltr] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G,html[dir=rtl] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G{padding-left:20px;padding-right:20px}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G._2T2T89ipk4Q278npB0Vz8K,._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G:active{font-weight:600}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G._2T2T89ipk4Q278npB0Vz8K,html[dir] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G:active{background-color:\"[theme:themeLighter, default:#DEECF9]\"}html[dir] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G .heGebXsDt2FNOucCkVyjE{margin:8px 0}._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G .heGebXsDt2FNOucCkVyjE .e9D7y7pykKEQCglTnnFb1{line-height:1}html[dir=ltr] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G .heGebXsDt2FNOucCkVyjE .e9D7y7pykKEQCglTnnFb1{text-align:left}html[dir=rtl] ._1AniWxXbFkF6Ldb0qdFzmW ._3k3UIu2_lQ5N5LQzdAIz2G .heGebXsDt2FNOucCkVyjE .e9D7y7pykKEQCglTnnFb1{text-align:right}.UfkPU70ry9_wuIKJ_R0Ni{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;height:100%;width:calc(90vw - 220px - 200px);max-width:860px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:63px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:calc(100% - 32px);-webkit-box-sizing:border-box;box-sizing:border-box}html[dir] .UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs{border-bottom:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] .UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs{margin-left:32px;padding-right:21px}html[dir=rtl] .UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs{margin-right:32px;padding-left:21px}.UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs ._8H6YYEESPKbWxNMY78Fwu{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-weight:600;font-size:21px;font-weight:100}.UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs ._223hPdMPjnIjokz4hbT3Lc{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs ._223hPdMPjnIjokz4hbT3Lc ._1UZXlvPELgquzxljbX0UYe{display:inline-block}html[dir] .UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs ._223hPdMPjnIjokz4hbT3Lc ._1UZXlvPELgquzxljbX0UYe{margin:2px}html[dir=ltr] .UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs ._223hPdMPjnIjokz4hbT3Lc>*{margin-left:16px}html[dir=rtl] .UfkPU70ry9_wuIKJ_R0Ni ._3O9j7O6oo-vHZrlM1roRYs ._223hPdMPjnIjokz4hbT3Lc>*{margin-right:16px}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS{overflow-x:hidden;overflow-y:auto;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;width:100%;max-width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;position:relative}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS{padding:0 32px}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:increment{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDowQzU1NDExQUNFQTExMUUwODVCRDlGMjgxNTUwOTY0MSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDowQzU1NDExOUNFQTExMUUwODVCRDlGMjgxNTUwOTY0MSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnbliksAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAACFJREFUCFtj/M/ACEd/mRj/MDP+aWb84wxGzSAuUBBJDQCreRGBIU9zHQAAAABJRU5ErkJggg==)}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:increment:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGNjMxOTJDNkNFQTAxMUUwOTEwQThBOUQ3OTU2MDhBRCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGNjMxOTJDNUNFQTAxMUUwOTEwQThBOUQ3OTU2MDhBRCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnVIpeYAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAACFJREFUCFtj/M/ACEd/mRj/MDP+aWb84wxGzSAuUBBJDQCreRGBIU9zHQAAAABJRU5ErkJggg==)}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:decrement{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyOTQ1MTFBOUNFQTExMUUwQjFCMUQ0QTY5Nzg0NkM4MyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyOTQ1MTFBOENFQTExMUUwQjFCMUQ0QTY5Nzg0NkM4MyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhHC5VgAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAACBJREFUCFtj+P+fAYH2M/y3Z/hnz/AHjIAMIBckiFADAIcKGtnX/NNJAAAAAElFTkSuQmCC)}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:decrement:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxRDlGMzQxNUNFQTExMUUwOUQ1RUMzMDcwNkI3NzQ4OSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxRDlGMzQxNENFQTExMUUwOUQ1RUMzMDcwNkI3NzQ4OSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Piwt9IAAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAACBJREFUCFtj+P+fAYH2M/y3Z/hnz/AHjIAMIBckiFADAIcKGtnX/NNJAAAAAElFTkSuQmCC)}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:increment{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCQUVGMjQ0M0NFQTAxMUUwODVFRkVGMkEyMDYzQjNCOSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCQUVGMjQ0MkNFQTAxMUUwODVFRkVGMkEyMDYzQjNCOSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pi1r31IAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIY+yDP+UGf848z4r5ERQxYAnBUQ8bRhSzUAAAAASUVORK5CYII=)}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:increment:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBODk4RUE4QUNFQTAxMUUwQjI0MUFCODBCNTk2MzdFMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBODk4RUE4OUNFQTAxMUUwQjI0MUFCODBCNTk2MzdFMSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrzuktcAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIY+yDP+UGf848z4r5ERQxYAnBUQ8bRhSzUAAAAASUVORK5CYII=)}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:decrement{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzVEMjUyMkNFQTAxMUUwQTc0NzgzNTNCNkQ3RkNFRCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzVEMjUyMUNFQTAxMUUwQTc0NzgzNTNCNkQ3RkNFRCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Psti8fgAAAAGUExURczT1v///w6Zot4AAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIb+NTL+cWb8oc74QZ4RQxYAoGUQ8fkWopYAAAAASUVORK5CYII=)}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:decrement:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpEM0ZDNDlGQ0NFQTAxMUUwQUY5RkJGN0ZBNEREREEyMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpEM0ZDNDlGQkNFQTAxMUUwQUY5RkJGN0ZBNEREREEyMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENDZGQ0I5RkQzQ0RFMDExQTgyMjkyMjdERUQwRkIxRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUZGQzk4NEE1Q0FFMDExOUI2OUQ1NEZFODhFQjY5MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhWCNEUAAAAGUExURZ20xP///xhJTcUAAAACdFJOU/8A5bcwSgAAABxJREFUCNdj/M/AiIb+NTL+cWb8oc74QZ4RQxYAoGUQ8fkWopYAAAAASUVORK5CYII=)}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar{height:18px;width:18px}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar:disabled{display:none}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button,.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-corner{cursor:pointer}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-corner{background:transparent}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:decrement,.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:decrement:hover,.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:increment,.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:increment:hover,.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:decrement,.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:decrement:hover,.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:increment,.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:increment:hover{height:18px;width:18px}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:decrement,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:decrement:hover,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:increment,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:horizontal:increment:hover,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:decrement,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:decrement:hover,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:increment,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-button:vertical:increment:hover{background-position:50%}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-track{background:transparent}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-thumb,html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-thumb:hover{border-radius:9px;border:solid 6px transparent;background-clip:content-box}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-thumb{background-color:\"[theme:neutralTertiaryAlt, default:#c8c8c8]\"}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-thumb:hover{background-color:#98a3a6}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-thumb:vertical{min-height:50px}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS::-webkit-scrollbar-thumb:horizontal{min-width:50px}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n{border-bottom:1px solid \"[theme:neutralLight, default:#eaeaea]\"}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n ._25su364MU8NrwRsziu-vhr{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n ._25su364MU8NrwRsziu-vhr{margin:18px 0 14px}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n ._25su364MU8NrwRsziu-vhr .ZOSvR9HMptaRCzltth2tS{font-size:17px;font-weight:300}html[dir=ltr] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n ._25su364MU8NrwRsziu-vhr .ZOSvR9HMptaRCzltth2tS{margin-right:10px}html[dir=rtl] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n ._25su364MU8NrwRsziu-vhr .ZOSvR9HMptaRCzltth2tS{margin-left:10px}.UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n ._2P96oGHvc1r30wc3Ai7c2B{position:relative}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n ._2P96oGHvc1r30wc3Ai7c2B{margin-bottom:26px}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n:last-child{padding-bottom:40px;border-bottom:0}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n label.ms-Label{margin-top:22px}html[dir] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n label.ms-Label:first-child{margin-top:0}html[dir=ltr] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n .ms-ChoiceField{padding-left:0}html[dir=rtl] .UfkPU70ry9_wuIKJ_R0Ni .EXpXXWDkglZE1NREQfUSS ._1ESvP8Y856TNzXHI2JGF4n .ms-ChoiceField{padding-right:0}", ""]);

// exports
exports.locals = {
	"container": "qXfMpIrUN84St6chPqPyO",
	"categoriesColumn": "_22iZPI0NO5yLVm7ZEwwWUB",
	"title": "ZOSvR9HMptaRCzltth2tS",
	"searchBox": "_7gMTzWZHFW2-X2YQSPTYk",
	"category": "_2Zp89qXMMDSbiFU092bdlR",
	"categoryIcon": "_33kOrhBTfcJDt7Z1zho3cz",
	"categoryLabel": "_2VV3vvwJY7ElpcLFdWRrtm",
	"selectedCategory": "_3EQe4rNS6RGVZhdrfcQ0xJ",
	"flexContainer": "_1yVwdO96cNCOi9Ed29UjwJ",
	"viewQuickSettings": "nPXuv-KG0gs3GFXZaoAXZ",
	"icon": "_166Nf7WhGsIatqLBo0pLRJ",
	"suggestionCallout": "_1dC--UHy36KfoYK7bO31E_",
	"suggestion": "_3OaQc_SuiriDAbX9ITw3l4",
	"optionsColumn": "_1AniWxXbFkF6Ldb0qdFzmW",
	"option": "_3k3UIu2_lQ5N5LQzdAIz2G",
	"selectedOption": "_2T2T89ipk4Q278npB0Vz8K",
	"optionFlexContainer": "heGebXsDt2FNOucCkVyjE",
	"optionLabel": "e9D7y7pykKEQCglTnnFb1",
	"settingsPane": "UfkPU70ry9_wuIKJ_R0Ni",
	"settingsHeader": "_3O9j7O6oo-vHZrlM1roRYs",
	"settingsTitle": "_8H6YYEESPKbWxNMY78Fwu",
	"settingsHeaderButtons": "_223hPdMPjnIjokz4hbT3Lc",
	"spinner": "_1UZXlvPELgquzxljbX0UYe",
	"settingsForm": "EXpXXWDkglZE1NREQfUSS",
	"optionEntry": "_1ESvP8Y856TNzXHI2JGF4n",
	"header": "_25su364MU8NrwRsziu-vhr",
	"formContainer": "_2P96oGHvc1r30wc3Ai7c2B"
};

/***/ }),

/***/ 5302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var OptionsForm_1 = __webpack_require__(5303);
var owa_options_store_1 = __webpack_require__(2641);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var styles = __webpack_require__(2799);
var OptionsPane = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPane, _super);
    function OptionsPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.optionFormRefs = {};
        return _this;
    }
    OptionsPane.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (ref) { return (_this.settingsForm = ref); }, className: styles.settingsForm }, this.props.options.map(function (option) { return (React.createElement(OptionsForm_1.default, { option: option, key: option.key, ref: function (ref) { return (_this.optionFormRefs[option.key] = ref); } })); })));
    };
    OptionsPane.prototype.componentDidMount = function () {
        this.scrollToSelectedOption();
    };
    OptionsPane.prototype.componentDidUpdate = function (prevProps) {
        if (this.props !== prevProps) {
            // We changed options, so reset the scroll position
            this.scrollToSelectedOption();
        }
    };
    OptionsPane.prototype.scrollToSelectedOption = function () {
        var selectedOption;
        var currentOptionKey = owa_options_store_1.getStore().currentOptionKey;
        if (currentOptionKey && (selectedOption = this.optionFormRefs[currentOptionKey])) {
            this.settingsForm.scrollTop = ReactDOM.findDOMNode(selectedOption).offsetTop;
        }
        else {
            this.settingsForm.scrollTop = 0;
        }
    };
    OptionsPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionsPane);
    return OptionsPane;
}(React.Component));
exports.default = OptionsPane;
//# sourceMappingURL=OptionsPane.js.map

/***/ }),

/***/ 5303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var styles = __webpack_require__(2799);
var OptionsForm = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsForm, _super);
    function OptionsForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsForm.prototype.render = function () {
        var option = this.props.option;
        var fullOptionFormSettings = option.fullOptionFormSettings, key = option.key;
        if (!fullOptionFormSettings) {
            return null;
        }
        var optionAriaId = "options-full-" + key;
        return (React.createElement("div", { className: styles.optionEntry },
            React.createElement("div", { className: styles.header, role: "heading", "aria-level": 4 },
                React.createElement("span", { className: styles.title, id: optionAriaId }, owa_options_strings_1.default[this.props.option.titleStringKey])),
            React.createElement("div", { className: styles.formContainer, "aria-labelledby": optionAriaId }, fullOptionFormSettings.render())));
    };
    OptionsForm = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionsForm);
    return OptionsForm;
}(React.Component));
exports.default = OptionsForm;
//# sourceMappingURL=OptionsForm.js.map

/***/ }),

/***/ 5304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var styles = __webpack_require__(5305);
var OptionsPaneError = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPaneError, _super);
    function OptionsPaneError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsPaneError.prototype.render = function () {
        return (React.createElement("div", { className: styles.messageContainer },
            React.createElement("div", { className: owa_options_strings_1.default.optionsFull_subCategory_error })));
    };
    return OptionsPaneError;
}(React.Component));
exports.default = OptionsPaneError;
//# sourceMappingURL=OptionsPaneError.js.map

/***/ }),

/***/ 5305:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5306);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5306:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1GvaaYVExelYtcmVS76hiW{position:absolute;top:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;width:100%}html[dir] ._1GvaaYVExelYtcmVS76hiW{text-align:center}html[dir=ltr] ._1GvaaYVExelYtcmVS76hiW{left:0}html[dir=rtl] ._1GvaaYVExelYtcmVS76hiW{right:0}._3aoFKl08hBcc2qVb_dDK_D{width:400px;font-size:17px;font-weight:300}", ""]);

// exports
exports.locals = {
	"messageContainer": "_1GvaaYVExelYtcmVS76hiW",
	"messageText": "_3aoFKl08hBcc2qVb_dDK_D"
};

/***/ }),

/***/ 5307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Spinner_1 = __webpack_require__(670);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var styles = __webpack_require__(5308);
var OptionsPaneLoading = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPaneLoading, _super);
    function OptionsPaneLoading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsPaneLoading.prototype.render = function () {
        return (React.createElement("div", { className: styles.messageContainer },
            React.createElement("div", null,
                React.createElement(Spinner_1.Spinner, { type: Spinner_1.SpinnerType.large })),
            React.createElement("div", { className: styles.messageText }, owa_options_strings_1.default.optionsFull_subCategory_loading)));
    };
    return OptionsPaneLoading;
}(React.Component));
exports.default = OptionsPaneLoading;
//# sourceMappingURL=OptionsPaneLoading.js.map

/***/ }),

/***/ 5308:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5309);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5309:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".ZbLyJEKRwAkG3s-vpnhKx{position:absolute;width:100%;height:100%;top:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}html[dir] .ZbLyJEKRwAkG3s-vpnhKx{border:0}html[dir=ltr] .ZbLyJEKRwAkG3s-vpnhKx{left:0}html[dir=rtl] .ZbLyJEKRwAkG3s-vpnhKx{right:0}._3yOGbSYIU7c3gJMHBfc0_i{font-size:12px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._3yOGbSYIU7c3gJMHBfc0_i{padding-top:20px}", ""]);

// exports
exports.locals = {
	"messageContainer": "ZbLyJEKRwAkG3s-vpnhKx",
	"messageText": "_3yOGbSYIU7c3gJMHBfc0_i"
};

/***/ }),

/***/ 5310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_orchestration_1 = __webpack_require__(2794);
var owa_options_orchestration_2 = __webpack_require__(2794);
var owa_options_store_1 = __webpack_require__(2641);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var Spinner_1 = __webpack_require__(670);
var owa_options_core_1 = __webpack_require__(1736);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var styles = __webpack_require__(2799);
var SettingsFormHeader = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsFormHeader, _super);
    function SettingsFormHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsFormHeader.prototype.render = function () {
        var store = owa_options_store_1.getStore();
        var selectedSubCategory = this.props.selectedSubCategory;
        var isDisabled = store.isSaving ||
            store.currentSubCategoryState !== 1 /* Loaded */ ||
            !this.isFormDirty();
        return (React.createElement("div", { className: styles.settingsHeader },
            React.createElement("div", { className: styles.settingsTitle, role: "heading", "aria-level": 3 }, owa_options_strings_1.default[selectedSubCategory.titleStringKey] || ''),
            React.createElement("div", { className: styles.settingsHeaderButtons },
                store.isSaving && (React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.large, className: styles.spinner })),
                !this.hideSaveDiscard() && [
                    React.createElement(Button_1.PrimaryButton, { text: owa_options_strings_1.default.optionsFull_save, disabled: isDisabled || this.shouldDisableSaveButton(), onClick: owa_options_orchestration_2.saveOptions, key: "save" }),
                    React.createElement(Button_1.DefaultButton, { text: owa_options_strings_1.default.optionsFull_cancel, disabled: isDisabled, onClick: owa_options_orchestration_2.discardOptions, key: "discard" }),
                ],
                React.createElement(Button_1.IconButton, { iconProps: {
                        iconName: "Cancel" /* Cancel */,
                    }, onClick: this.hide }))));
    };
    SettingsFormHeader.prototype.hide = function () {
        owa_options_orchestration_1.hideFullOptions();
    };
    SettingsFormHeader.prototype.isFormDirty = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return owa_options_core_1.isAnyOptionDirty(selectedSubCategory);
    };
    SettingsFormHeader.prototype.hideSaveDiscard = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return owa_options_core_1.hideSaveDiscardButtons(selectedSubCategory);
    };
    SettingsFormHeader.prototype.shouldDisableSaveButton = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return owa_options_core_1.shouldDisableSaveButton(selectedSubCategory);
    };
    SettingsFormHeader = tslib_1.__decorate([
        mobx_react_1.observer
    ], SettingsFormHeader);
    return SettingsFormHeader;
}(React.Component));
exports.default = SettingsFormHeader;
//# sourceMappingURL=SettingsFormHeader.js.map

/***/ }),

/***/ 5311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_options_orchestration_1 = __webpack_require__(2794);
var owa_options_store_1 = __webpack_require__(2641);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var owa_options_strings_1 = __webpack_require__(1737);
var React = __webpack_require__(3);
var styling_1 = __webpack_require__(91);
var FocusZone_1 = __webpack_require__(78);
var styles = __webpack_require__(2799);
var className = __webpack_require__(30).bind(styles);
var SubCategoryEntry = mobx_react_1.observer(function (props) {
    var buttonStyles = {
        root: className(styles.option, {
            selectedOption: owa_options_store_1.getStore().currentSubCategoryKey === props.subcategory.key,
        }),
        flexContainer: styles.optionFlexContainer,
        label: styles.optionLabel,
    };
    return (React.createElement(Button_1.BaseButton, { styles: buttonStyles, key: props.subcategory.key, onClick: function () { return owa_options_orchestration_1.selectSubcategory(props.subcategory); }, text: owa_options_strings_1.default[props.subcategory.titleStringKey] }));
});
var SubCategoriesColumn = /** @class */ (function (_super) {
    tslib_1.__extends(SubCategoriesColumn, _super);
    function SubCategoriesColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubCategoriesColumn.prototype.render = function () {
        return (React.createElement("div", { className: styles.optionsColumn },
            React.createElement(FocusZone_1.FocusZone, { direction: FocusZone_1.FocusZoneDirection.vertical, key: owa_options_store_1.getStore().currentCategoryKey, className: styling_1.AnimationClassNames.slideLeftIn20 }, this.props.subcategories.map(function (subcategory) { return (React.createElement(SubCategoryEntry, { subcategory: subcategory, key: subcategory.key })); }))));
    };
    SubCategoriesColumn = tslib_1.__decorate([
        mobx_react_1.observer
    ], SubCategoriesColumn);
    return SubCategoriesColumn;
}(React.Component));
exports.default = SubCategoriesColumn;
//# sourceMappingURL=SubCategoriesColumn.js.map

/***/ }),

/***/ 5312:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._2SU7hGqERfQtBMcn-xXolk{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._2SU7hGqERfQtBMcn-xXolk{margin-bottom:32px}html[dir=ltr] ._2SU7hGqERfQtBMcn-xXolk{margin-left:-4px}html[dir=rtl] ._2SU7hGqERfQtBMcn-xXolk{margin-right:-4px}._2SU7hGqERfQtBMcn-xXolk ._1VMyikmx4FSVmkXAPKakrA{font-size:12px}html[dir] ._2SU7hGqERfQtBMcn-xXolk ._1VMyikmx4FSVmkXAPKakrA{margin-top:3px}html[dir=ltr] ._2SU7hGqERfQtBMcn-xXolk ._1VMyikmx4FSVmkXAPKakrA{margin-left:10px}html[dir=rtl] ._2SU7hGqERfQtBMcn-xXolk ._1VMyikmx4FSVmkXAPKakrA{margin-right:10px}._2Hb4BXX4r14XKC8qZhjlxs{width:276px}html[dir] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ{margin:8px 0}._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap}._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%;height:44px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:14px;font-weight:400;font-weight:600}html[dir] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh{padding-top:2px}._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh._2CIpZcWtNOj2LYFLMT-N_Q{cursor:pointer}html[dir=ltr] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh._2CIpZcWtNOj2LYFLMT-N_Q{margin-left:-8px}html[dir=rtl] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh._2CIpZcWtNOj2LYFLMT-N_Q{margin-right:-8px}._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh ._2vACFCroAyhxkRAn03Y1Nr{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir=ltr] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh ._2vACFCroAyhxkRAn03Y1Nr ._3JeSGgKYGqjfzpYJTxf6UD{margin-left:10px}html[dir=rtl] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh ._2vACFCroAyhxkRAn03Y1Nr ._3JeSGgKYGqjfzpYJTxf6UD{margin-right:10px}html[dir] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .dtoAmI2z_mBI-wBLAVGCh .hqth89fa4gT9u1NtNQonj{margin-bottom:0}html[dir] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 ._2cd5z7bz_lkTm5Gveyg7IQ{padding:10px 0}html[dir=ltr] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 ._2cd5z7bz_lkTm5Gveyg7IQ ._1bL17jnQQ7XPzb05fkLGJ1{margin-right:5px}html[dir=rtl] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 ._2cd5z7bz_lkTm5Gveyg7IQ ._1bL17jnQQ7XPzb05fkLGJ1{margin-left:5px}html[dir] ._2Hb4BXX4r14XKC8qZhjlxs ._2SpWjEQ7UOoK2YmHG_F3BZ ._2qvlzm0NXfP2eSnptUQ_81 .ms-ChoiceFieldGroup{margin-top:-10px;margin-bottom:6px}", ""]);

// exports
exports.locals = {
	"viewFullSettings": "_2SU7hGqERfQtBMcn-xXolk",
	"icon": "_1VMyikmx4FSVmkXAPKakrA",
	"container": "_2Hb4BXX4r14XKC8qZhjlxs",
	"quickSettingsPanel": "_2SpWjEQ7UOoK2YmHG_F3BZ",
	"quickSetting": "_2qvlzm0NXfP2eSnptUQ_81",
	"quickSettingHeader": "dtoAmI2z_mBI-wBLAVGCh",
	"isSearch": "_2CIpZcWtNOj2LYFLMT-N_Q",
	"title": "_2vACFCroAyhxkRAn03Y1Nr",
	"infoIcon": "_3JeSGgKYGqjfzpYJTxf6UD",
	"toggle": "hqth89fa4gT9u1NtNQonj",
	"buttonBar": "_2cd5z7bz_lkTm5Gveyg7IQ",
	"button": "_1bL17jnQQ7XPzb05fkLGJ1"
};

/***/ }),

/***/ 5313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var TeachingBubble_1 = __webpack_require__(1627);
var Button_1 = __webpack_require__(62);
var owa_lightning_1 = __webpack_require__(638);
var owa_header_store_1 = __webpack_require__(1608);
var owa_analytics_1 = __webpack_require__(12);
var owa_configurator_strings_1 = __webpack_require__(1635);
var SettingPanelFirstRunCallout = /** @class */ (function (_super) {
    tslib_1.__extends(SettingPanelFirstRunCallout, _super);
    function SettingPanelFirstRunCallout(props) {
        var _this = _super.call(this, props) || this;
        _this.onGotIt = function () {
            owa_lightning_1.lighted(_this.props.lid);
        };
        _this.onNotNow = function () {
            owa_analytics_1.logUsage('SettingPanelFirstRunNotNow');
            owa_header_store_1.toggleCharm(4 /* SettingsCharm */);
            owa_lightning_1.lighted(_this.props.lid);
            owa_lightning_1.eventMgr.emit(owa_lightning_1.SettingPanelFirstRunCalloutDismissedEvent);
        };
        return _this;
    }
    SettingPanelFirstRunCallout.prototype.render = function () {
        var gotItButtonProps = {
            buttonType: Button_1.ButtonType.primary,
            children: owa_configurator_strings_1.default.callout_Gotit,
            onClick: this.onGotIt,
        };
        var notNowButtonProps = {
            children: owa_configurator_strings_1.default.callout_Notnow,
            onClick: this.onNotNow,
        };
        return (React.createElement(TeachingBubble_1.TeachingBubble, { calloutProps: {
                beakWidth: 15,
                directionalHint: 12 /* rightCenter */,
                gapSpace: 30,
            }, targetElement: this.props.target(), hasCloseIcon: true, headline: owa_configurator_strings_1.default.callout_Panel_Title, hasSmallHeadline: true, primaryButtonProps: gotItButtonProps, secondaryButtonProps: notNowButtonProps, onDismiss: this.onGotIt }, owa_configurator_strings_1.default.callout_Panel_Body));
    };
    SettingPanelFirstRunCallout = tslib_1.__decorate([
        mobx_react_1.observer,
        owa_lightning_1.lightable
    ], SettingPanelFirstRunCallout);
    return SettingPanelFirstRunCallout;
}(React.Component));
exports.SettingPanelFirstRunCallout = SettingPanelFirstRunCallout;
//# sourceMappingURL=SettingPanelFirstRunCallout.js.map

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
function getGuid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
exports.getGuid = getGuid;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileSelectionFilter_1 = __webpack_require__(1805);
exports.FileSelectionFilter = FileSelectionFilter_1.default;
var owa_bundling_1 = __webpack_require__(6);
var fileProvidersLoaded_1 = __webpack_require__(1806);
exports.fileProvidersLoaded = fileProvidersLoaded_1.fileProvidersLoaded;
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 2246));
});
// Exported actions
exports.lazyRemoveFileProvider = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.removeFileProvider; });
// Exported services
exports.lazyGetAllFileProvidersService = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getAllFileProvidersService; });
exports.lazyRemoveFileProviderService = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.removeFileProviderService; });
// Exported utils
exports.lazyCreateFileProvidersViewState = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.createFileProvidersViewState; });
exports.lazyGetAllFileProviders = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getAllFileProviders; });
// The store
var store_1 = __webpack_require__(1798);
exports.store = store_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DateValues_1 = __webpack_require__(361);
var TimeConstants_1 = __webpack_require__(1818);
var Utilities_1 = __webpack_require__(7);
/**
 * Returns a date offset from the given date by the specified number of days.
 * @param {Date} date - The origin date
 * @param {number} days - The number of days to offset. 'days' can be negative.
 * @return {Date} A new Date object offset from the origin date by the given number of days
 */
function addDays(date, days) {
    var result = new Date(date.getTime());
    result.setDate(result.getDate() + days);
    return result;
}
exports.addDays = addDays;
/**
 * Returns a date offset from the given date by the specified number of weeks.
 * @param {Date} date - The origin date
 * @param {number} weeks - The number of weeks to offset. 'weeks' can be negative.
 * @return {Date} A new Date object offset from the origin date by the given number of weeks
 */
function addWeeks(date, weeks) {
    return addDays(date, weeks * TimeConstants_1.default.DaysInOneWeek);
}
exports.addWeeks = addWeeks;
/**
 * Returns a date offset from the given date by the specified number of months.
 * The method tries to preserve the day-of-month; however, if the new month does not have enough days
 * to contain the original day-of-month, we'll use the last day of the new month.
 * @param {Date} date - The origin date
 * @param {number} months - The number of months to offset. 'months' can be negative.
 * @return {Date} A new Date object offset from the origin date by the given number of months
 */
function addMonths(date, months) {
    var result = new Date(date.getTime());
    var newMonth = result.getMonth() + months;
    result.setMonth(newMonth);
    // We want to maintain the same day-of-month, but that may not be possible if the new month doesn't have enough days.
    // Loop until we back up to a day the new month has.
    // (Weird modulo math is due to Javascript's treatment of negative numbers in modulo)
    if (result.getMonth() !== (newMonth % TimeConstants_1.default.MonthInOneYear + TimeConstants_1.default.MonthInOneYear) % TimeConstants_1.default.MonthInOneYear) {
        result = addDays(result, -result.getDate());
    }
    return result;
}
exports.addMonths = addMonths;
/**
 * Returns a date offset from the given date by the specified number of years.
 * The method tries to preserve the day-of-month; however, if the new month does not have enough days
 * to contain the original day-of-month, we'll use the last day of the new month.
 * @param {Date} date - The origin date
 * @param {number} years - The number of years to offset. 'years' can be negative.
 * @return {Date} A new Date object offset from the origin date by the given number of years
 */
function addYears(date, years) {
    var result = new Date(date.getTime());
    result.setFullYear(date.getFullYear() + years);
    // We want to maintain the same day-of-month, but that may not be possible if the new month doesn't have enough days.
    // Loop until we back up to a day the new month has.
    // (Weird modulo math is due to Javascript's treatment of negative numbers in modulo)
    if (result.getMonth() !== (date.getMonth() % TimeConstants_1.default.MonthInOneYear + TimeConstants_1.default.MonthInOneYear) % TimeConstants_1.default.MonthInOneYear) {
        result = addDays(result, -result.getDate());
    }
    return result;
}
exports.addYears = addYears;
/**
 * Returns a date that is the first day of the month of the provided date.
 * @param {Date} date - The origin date
 * @return {Date} A new Date object with the day set to the first day of the month.
 */
function getMonthStart(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
}
exports.getMonthStart = getMonthStart;
/**
 * Returns a date that is the last day of the month of the provided date.
 * @param {Date} date - The origin date
 * @return {Date} A new Date object with the day set to the last day of the month.
 */
function getMonthEnd(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0, 0, 0, 0, 0);
}
exports.getMonthEnd = getMonthEnd;
/**
 * Returns a date that is the first day of the year of the provided date.
 * @param {Date} date - The origin date
 * @return {Date} A new Date object with the day set to the first day of the year.
 */
function getYearStart(date) {
    return new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);
}
exports.getYearStart = getYearStart;
/**
 * Returns a date that is the last day of the year of the provided date.
 * @param {Date} date - The origin date
 * @return {Date} A new Date object with the day set to the last day of the year.
 */
function getYearEnd(date) {
    return new Date(date.getFullYear() + 1, 0, 0, 0, 0, 0, 0);
}
exports.getYearEnd = getYearEnd;
/**
 * Returns a date that is a copy of the given date, aside from the month changing to the given month.
 *  The method tries to preserve the day-of-month; however, if the new month does not have enough days
 * to contain the original day-of-month, we'll use the last day of the new month.
 * @param {Date} date - The origin date
 * @param {number} month - The 0-based index of the month to set on the date.
 * @return {Date} A new Date object with the given month set.
 */
function setMonth(date, month) {
    return addMonths(date, month - date.getMonth());
}
exports.setMonth = setMonth;
/**
 * Compares two dates, and returns true if the two dates (not accounting for time-of-day) are equal.
 * @return {boolean} True if the two dates represent the same date (regardless of time-of-day), false otherwise.
 */
function compareDates(date1, date2) {
    if (!date1 && !date2) {
        return true;
    }
    else if (!date1 || !date2) {
        return false;
    }
    else {
        return (date1.getFullYear() === date2.getFullYear()
            && date1.getMonth() === date2.getMonth()
            && date1.getDate() === date2.getDate());
    }
}
exports.compareDates = compareDates;
/**
 * Compare the date parts of two dates
 * @param {Date} date1 - The first date to compare
 * @param {Date} date2 - The second date to compare
 * @returns {Number} A negative value if date1 is earlier than date2, 0 if the dates are equal, or a positive value
 * if date1 is later than date2.
 */
function compareDatePart(date1, date2) {
    return getDatePartHashValue(date1) - getDatePartHashValue(date2);
}
exports.compareDatePart = compareDatePart;
/**
 * Gets the date range array including the specified date. The date range array is calculated as the list
 * of dates accounting for the specified first day of the week and date range type.
 * @param {Date} date - The input date
 * @param {DateRangeType} dateRangeType - The desired date range type, i.e., day, week, month, etc.
 * @param {DayOfWeek} dayOfWeek - The first day of the week.
 * @returns {Date[]} An array of dates representing the date range containing the specified date.
 */
function getDateRangeArray(date, dateRangeType, firstDayOfWeek) {
    var datesArray = new Array();
    var startDate;
    var endDate = null;
    switch (dateRangeType) {
        case DateValues_1.DateRangeType.Day:
            startDate = getDatePart(date);
            endDate = addDays(startDate, 1);
            break;
        case DateValues_1.DateRangeType.Week:
            startDate = getStartDateOfWeek(getDatePart(date), firstDayOfWeek);
            endDate = addDays(startDate, TimeConstants_1.default.DaysInOneWeek);
            break;
        case DateValues_1.DateRangeType.Month:
            startDate = new Date(date.getFullYear(), date.getMonth(), 1);
            endDate = addMonths(startDate, 1);
            break;
        default:
            return Utilities_1.assertNever(dateRangeType);
    }
    // Populate the dates array with the dates in range
    datesArray.push(startDate);
    var nextDate = addDays(startDate, 1);
    while (!compareDates(nextDate, endDate)) {
        datesArray.push(nextDate);
        nextDate = addDays(nextDate, 1);
    }
    return datesArray;
}
exports.getDateRangeArray = getDateRangeArray;
/**
 * Checks whether the specified date is in the given date range.
 * @param {Date} date - The origin date
 * @param {Date[]} dateRange - An array of dates to do the lookup on
 * @returns {bool} True if the date matches one of the dates in the specified array, false otherwise.
 */
function isInDateRangeArray(date, dateRange) {
    for (var _i = 0, dateRange_1 = dateRange; _i < dateRange_1.length; _i++) {
        var dateInRange = dateRange_1[_i];
        if (compareDates(date, dateInRange)) {
            return true;
        }
    }
    return false;
}
exports.isInDateRangeArray = isInDateRangeArray;
/**
 * Returns the week number for a date.
 * Week numbers are 1 - 52 (53) in a year
 * @param {navigatedDate} Date - A date to find the week number for.
 * @param {firstDayOfWeek} DayOfWeek - The first day of the week (0-6, Sunday = 0)
 * @param {firstWeekOfYear} FirstWeekOfYear - The first week of the year (1-2)
 * @return {weeksArray} The weeks number array for the current month.
 */
function getWeekNumbersInMonth(weeksInMonth, firstDayOfWeek, firstWeekOfYear, navigatedDate) {
    var selectedYear = navigatedDate.getFullYear();
    var selectedMonth = navigatedDate.getMonth();
    var dayOfMonth = 1;
    var fistDayOfMonth = new Date(selectedYear, selectedMonth, dayOfMonth);
    var endOfFirstWeek = dayOfMonth
        + (firstDayOfWeek + TimeConstants_1.default.DaysInOneWeek - 1)
        - adjustWeekDay(firstDayOfWeek, fistDayOfMonth.getDay());
    var endOfWeekRange = new Date(selectedYear, selectedMonth, endOfFirstWeek);
    dayOfMonth = endOfWeekRange.getDate();
    var weeksArray = [];
    for (var i = 0; i < weeksInMonth; i++) {
        // Get week number for end of week
        weeksArray.push(getWeekNumber(endOfWeekRange, firstDayOfWeek, firstWeekOfYear));
        dayOfMonth += TimeConstants_1.default.DaysInOneWeek;
        endOfWeekRange = new Date(selectedYear, selectedMonth, dayOfMonth);
    }
    return weeksArray;
}
exports.getWeekNumbersInMonth = getWeekNumbersInMonth;
/**
 * Returns the week number for a date.
 * Week numbers are 1 - 52 (53) in a year
 * @param {Date} date - A date to find the week number for.
 * @param {DayOfWeek} firstDayOfWeek - The first day of the week (0-6, Sunday = 0)
 * @param {firstWeekOfYear} firstWeekOfYear - The first week of the year (1-2)
 * @return {Number} The week's number in the year.
 */
function getWeekNumber(date, firstDayOfWeek, firstWeekOfYear) {
    // First four-day week of the year - minumum days count
    var fourDayWeek = 4;
    switch (firstWeekOfYear) {
        case DateValues_1.FirstWeekOfYear.FirstFullWeek:
            return getWeekOfYearFullDays(date, firstDayOfWeek, TimeConstants_1.default.DaysInOneWeek);
        case DateValues_1.FirstWeekOfYear.FirstFourDayWeek:
            return getWeekOfYearFullDays(date, firstDayOfWeek, fourDayWeek);
        default:
            return getFirstDayWeekOfYear(date, firstDayOfWeek);
    }
}
exports.getWeekNumber = getWeekNumber;
/**
 * Gets a new date with the time portion zeroed out, i.e., set to midnight
 * @param {Date} date - The origin date
 * @returns {Date} A new date with the time set to midnight
 */
function getDatePart(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
/**
 * Gets the date for the first day of the week based on the given date assuming
 * the specified first day of the week.
 * @param {Date} date - The date to find the beginning of the week date for.
 * @return {Date} A new date object representing the first day of the week containing the input date.
 */
function getStartDateOfWeek(date, firstDayOfWeek) {
    var daysOffset = firstDayOfWeek - date.getDay();
    if (daysOffset > 0) {
        // If first day of week is > date, go 1 week back, to ensure resulting date is in the past.
        daysOffset -= TimeConstants_1.default.DaysInOneWeek;
    }
    return addDays(date, daysOffset);
}
/**
 * Helper function to assist in date comparisons
 */
function getDatePartHashValue(date) {
    // Generate date hash value created as sum of Date (up to 31 = 5 bits), Month (up to 11 = 4 bits) and Year.
    /* tslint:disable:no-bitwise */
    return date.getDate() + (date.getMonth() << 5) + (date.getFullYear() << 9);
    /* tslint:enable:no-bitwise */
}
/**
* Helper function for getWeekNumber.
* Returns week number for a date
* @param {date} Date - current selected date.
* @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
* @param {numberOfFullDays} number - week settings.
* @return {Number} The week's number in the year.
*/
function getWeekOfYearFullDays(date, firstDayOfWeek, numberOfFullDays) {
    var dayOfYear = getDayOfYear(date) - 1;
    var dateWeekDay = date.getDay();
    var num = (date.getDay()) - (dayOfYear % TimeConstants_1.default.DaysInOneWeek);
    var lastDayOfyear = new Date(date.getFullYear(), DateValues_1.MonthOfYear.December, 31);
    var daysInYear = getDayOfYear(lastDayOfyear) - 1;
    var adjustedWeekDay = adjustWeekDay(firstDayOfWeek, dateWeekDay);
    var num2 = ((firstDayOfWeek - num) + (2 * TimeConstants_1.default.DaysInOneWeek)) % TimeConstants_1.default.DaysInOneWeek;
    if ((num2 !== 0) && (num2 >= numberOfFullDays)) {
        num2 -= TimeConstants_1.default.DaysInOneWeek;
    }
    var num3 = dayOfYear - num2;
    if (num3 < 0) {
        num -= daysInYear % TimeConstants_1.default.DaysInOneWeek;
        num2 = ((firstDayOfWeek - num) + (2 * TimeConstants_1.default.DaysInOneWeek)) % TimeConstants_1.default.DaysInOneWeek;
        if ((num2 !== 0) && (num2 + 1 >= numberOfFullDays)) {
            num2 -= TimeConstants_1.default.DaysInOneWeek;
        }
        num3 = daysInYear - num2;
    }
    return Math.floor((num3 / TimeConstants_1.default.DaysInOneWeek) + 1);
}
/**
* Helper function for getWeekNumber.
* Returns week number for a date
* @param {date} Date - current selected date.
* @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
* @return {Number} The week's number in the year.
*/
function getFirstDayWeekOfYear(date, firstDayOfWeek) {
    var num = getDayOfYear(date) - 1;
    var num2 = (date.getDay()) - (num % TimeConstants_1.default.DaysInOneWeek);
    var num3 = ((num2 - firstDayOfWeek) + 2 * TimeConstants_1.default.DaysInOneWeek) % TimeConstants_1.default.DaysInOneWeek;
    return Math.floor(((num + num3) / TimeConstants_1.default.DaysInOneWeek) + 1);
}
/**
* Helper function for getWeekNumber.
* Returns adjusted week day number when firstDayOfWeek is other than Sunday
* For Week Day Number comparison checks
* @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
* @param {dateWeekDay} DayOfWeek - shifts number forward to 1 week in case passed as true
* @return {DayOfWeek} The day of week adjusted to firstDayOfWeek. E.g. when FirstDyOfWeek is Monday (1), Sunday becomes = 7 (7 > 1).
*/
function adjustWeekDay(firstDayOfWeek, dateWeekDay) {
    return (firstDayOfWeek !== DateValues_1.DayOfWeek.Sunday && dateWeekDay < firstDayOfWeek) ? dateWeekDay + TimeConstants_1.default.DaysInOneWeek : dateWeekDay;
}
/**
 * Returns the day number for a date in a year
 * The number of days since January 1st in the particular year.
 * @param {Date} date - A date to find the day number for.
 * @return {Number} The day's number in the year.
 */
function getDayOfYear(date) {
    var month = date.getMonth();
    var year = date.getFullYear();
    var daysUntilDate = 0;
    for (var i = 0; i < month; i++) {
        daysUntilDate += daysInMonth((i + 1), year);
    }
    daysUntilDate += date.getDate();
    return daysUntilDate;
}
/**
 * Returns the number of days in the month
 * @param {number} month - The month number to target (months 1-12).
 * @param {number} year - The year to target.
 * @return {Number} The number of days in the month.
 */
function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
}
//# sourceMappingURL=DateMath.js.map

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(360), exports);
tslib_1.__exportStar(__webpack_require__(1780), exports);
tslib_1.__exportStar(__webpack_require__(1580), exports);
tslib_1.__exportStar(__webpack_require__(1781), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpinnerSize;
(function (SpinnerSize) {
    /**
     * 12px Spinner diameter
     */
    SpinnerSize[SpinnerSize["xSmall"] = 0] = "xSmall";
    /**
     * 16px Spinner diameter
     */
    SpinnerSize[SpinnerSize["small"] = 1] = "small";
    /**
     * 20px Spinner diameter
     */
    SpinnerSize[SpinnerSize["medium"] = 2] = "medium";
    /**
     * 28px Spinner diameter
     */
    SpinnerSize[SpinnerSize["large"] = 3] = "large";
})(SpinnerSize = exports.SpinnerSize || (exports.SpinnerSize = {}));
/**
 * Deprecated at v2.0.0, use 'SpinnerSize' instead.
 * @deprecated
 */
var SpinnerType;
(function (SpinnerType) {
    /**
     * Deprecated and will be removed at >= 2.0.0. Use SpinnerSize.medium instead.
     */
    SpinnerType[SpinnerType["normal"] = 0] = "normal";
    /**
     * Deprecated and will be removed at >= 2.0.0. Use SpinnerSize.large instead.
     */
    SpinnerType[SpinnerType["large"] = 1] = "large";
})(SpinnerType = exports.SpinnerType || (exports.SpinnerType = {}));
//# sourceMappingURL=Spinner.types.js.map

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKSPACE_CHARCODE = 8;
exports.TAB_CHARCODE = 9;
exports.ENTER_CHARCODE = 13;
exports.SPACE_CHARCODE = 32;
exports.PAGE_UP_CHARCODE = 33;
exports.PAGE_DOWN_CHARCODE = 34;
exports.END_CHARCODE = 35;
exports.HOME_CHARCODE = 36;
exports.LEFT_ARROW_CHARCODE = 37;
exports.UP_ARROW_CHARCODE = 38;
exports.RIGHT_ARROW_CHARCODE = 39;
exports.DOWN_ARROW_CHARCODE = 40;
exports.DELETE_CHARCODE = 46;
exports.K_CHARCODE = 75;
exports.ESC_CHARCODE = 27;
//# sourceMappingURL=KeyboardCharCodes.js.map

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lightning_1 = __webpack_require__(1621);
exports.lightable = lightning_1.lightable;
exports.lighted = lightning_1.lighted;
exports.eventMgr = lightning_1.eventMgr;
exports.SettingPanelFirstRunCalloutDismissedEvent = lightning_1.SettingPanelFirstRunCalloutDismissedEvent;
var LightningId_1 = __webpack_require__(1623);
exports.LightningId = LightningId_1.LightningId;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* tslint:disable:no-unused-variable */
var React = __webpack_require__(3);
/* tslint:enable:no-unused-variable */
var Utilities_1 = __webpack_require__(7);
var Button_1 = __webpack_require__(62);
var Image_1 = __webpack_require__(344);
var stylesImport = __webpack_require__(654);
var styles = stylesImport;
var TeachingBubbleContent = /** @class */ (function (_super) {
    tslib_1.__extends(TeachingBubbleContent, _super);
    // Constructor
    function TeachingBubbleContent(props) {
        var _this = _super.call(this, props) || this;
        _this._id = Utilities_1.getId('TeachingBubble');
        _this.state = {};
        return _this;
    }
    TeachingBubbleContent.prototype.render = function () {
        var _a = this.props, illustrationImage = _a.illustrationImage, primaryButtonProps = _a.primaryButtonProps, secondaryButtonProps = _a.secondaryButtonProps, headline = _a.headline, hasCondensedHeadline = _a.hasCondensedHeadline, hasCloseIcon = _a.hasCloseIcon, onDismiss = _a.onDismiss, closeButtonAriaLabel = _a.closeButtonAriaLabel, hasSmallHeadline = _a.hasSmallHeadline;
        var imageContent;
        var headerContent;
        var bodyContent;
        var footerContent;
        var closeButton;
        if (illustrationImage && illustrationImage.src) {
            imageContent = (React.createElement("div", { className: 'ms-TeachingBubble-header ms-TeachingBubble-image' },
                React.createElement(Image_1.Image, tslib_1.__assign({}, illustrationImage))));
        }
        if (headline) {
            headerContent = (React.createElement("div", { className: Utilities_1.css('ms-TeachingBubble-header', hasCondensedHeadline ?
                    'ms-TeachingBubble-header--condensed ' + styles.headerIsCondensed
                    : hasSmallHeadline
                        ? 'ms-TeachingBubble-header--small ' + styles.headerIsSmall
                        : 'ms-TeachingBubble-header--large ' + styles.headerIsLarge) },
                React.createElement("p", { className: Utilities_1.css('ms-TeachingBubble-headline', styles.headline) }, headline)));
        }
        if (this.props.children) {
            bodyContent = (React.createElement("div", { className: Utilities_1.css('ms-TeachingBubble-body', styles.body) },
                React.createElement("p", { className: Utilities_1.css('ms-TeachingBubble-subText', styles.subText) }, this.props.children)));
        }
        if (primaryButtonProps || secondaryButtonProps) {
            footerContent = (React.createElement("div", { className: Utilities_1.css('ms-TeachingBubble-footer', styles.footer) },
                primaryButtonProps && (React.createElement(Button_1.PrimaryButton, tslib_1.__assign({}, primaryButtonProps, { className: Utilities_1.css('ms-TeachingBubble-primaryButton', styles.primaryButton, primaryButtonProps.className) }))),
                secondaryButtonProps && (React.createElement(Button_1.DefaultButton, tslib_1.__assign({}, secondaryButtonProps, { className: Utilities_1.css('ms-TeachingBubble-secondaryButton', styles.secondaryButton, secondaryButtonProps.className) })))));
        }
        if (hasCloseIcon) {
            closeButton = (React.createElement(Button_1.IconButton, { className: Utilities_1.css('ms-TeachingBubble-closebutton', styles.closeButton), iconProps: { iconName: 'Cancel' }, title: closeButtonAriaLabel, ariaLabel: closeButtonAriaLabel, onClick: onDismiss }));
        }
        return (React.createElement("div", { className: Utilities_1.css('ms-TeachingBubble-content') },
            imageContent,
            closeButton,
            React.createElement("div", { className: Utilities_1.css('ms-TeachingBubble-bodycontent', styles.bodyContent) },
                headerContent,
                bodyContent,
                footerContent)));
    };
    // Specify default props values
    TeachingBubbleContent.defaultProps = {
        hasCondensedHeadline: false,
        imageProps: {
            imageFit: Image_1.ImageFit.cover,
            width: 364,
            height: 130
        }
    };
    return TeachingBubbleContent;
}(Utilities_1.BaseComponent));
exports.TeachingBubbleContent = TeachingBubbleContent;
//# sourceMappingURL=TeachingBubbleContent.js.map

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_3fcf9099{display:block;max-width:364px;border:0;-webkit-box-shadow:none !important;box-shadow:none !important}.bodyContent_3fcf9099{padding:20px}.headerIsLarge_3fcf9099:not(:last-child){margin-bottom:14px}.headerIsSmall_3fcf9099:not(:last-child){margin-bottom:14px}.headline_3fcf9099{margin:0;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.headerIsLarge_3fcf9099 .headline_3fcf9099{font-size:28px;font-weight:100;font-weight:100}.headerIsCondensed_3fcf9099 .headline_3fcf9099{font-size:14px;font-weight:400;font-weight:600}[dir='ltr'] .headerIsCondensed_3fcf9099 .headline_3fcf9099{margin-right:10px}[dir='rtl'] .headerIsCondensed_3fcf9099 .headline_3fcf9099{margin-left:10px}.headerIsSmall_3fcf9099 .headline_3fcf9099{font-size:14px;font-weight:400;font-weight:600}[dir='ltr'] .headerIsSmall_3fcf9099 .headline_3fcf9099{margin-right:10px}[dir='rtl'] .headerIsSmall_3fcf9099 .headline_3fcf9099{margin-left:10px}.body_3fcf9099:not(:last-child){margin-bottom:20px}.subText_3fcf9099{margin:0;font-size:14px;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";font-weight:300}.root_3fcf9099 .closeButton_3fcf9099{position:absolute;top:0;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";font-size:12px}[dir='ltr'] .root_3fcf9099 .closeButton_3fcf9099{right:0}[dir='rtl'] .root_3fcf9099 .closeButton_3fcf9099{left:0}html[dir='ltr'] .footer_3fcf9099 .ms-Button:not(:first-child){margin-left:20px}html[dir='rtl'] .footer_3fcf9099 .ms-Button:not(:first-child){margin-right:20px}.root_3fcf9099 .ms-Callout-main,.root_3fcf9099 .ms-Callout-beak,.root_3fcf9099 .ms-Callout-smallbeak{background:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.wideCallout_3fcf9099{max-width:456px}.wideCallout_3fcf9099 .ms-TeachingBubble-content{display:-webkit-box;display:-ms-flexbox;display:flex}.wideCallout_3fcf9099 .ms-TeachingBubble-image{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:20px;max-width:154px}.wideCallout_3fcf9099 .bodyContent_3fcf9099{max-width:302px}.root_3fcf9099 .primaryButton_3fcf9099{background-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";border-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.root_3fcf9099 .primaryButton_3fcf9099 .ms-Button-label{font-size:14px;font-weight:400;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.root_3fcf9099 .primaryButton_3fcf9099:hover{background-color:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": ";border-color:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": "}.root_3fcf9099 .primaryButton_3fcf9099:focus{background-color:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": ";border-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.root_3fcf9099 .primaryButton_3fcf9099:active{background-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";border-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.root_3fcf9099 .secondaryButton_3fcf9099{background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";border-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.root_3fcf9099 .secondaryButton_3fcf9099 .ms-Button-label{font-size:14px;font-weight:400;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.root_3fcf9099 .secondaryButton_3fcf9099:hover{background-color:" }, { "theme": "themeDarkAlt", "defaultValue": "#106ebe" }, { "rawString": ";border-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.root_3fcf9099 .secondaryButton_3fcf9099:focus{background-color:" }, { "theme": "themeDarkAlt", "defaultValue": "#106ebe" }, { "rawString": ";border-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.root_3fcf9099 .secondaryButton_3fcf9099:active{background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";border-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}\n" }]);
exports.root = "root_3fcf9099";
exports.bodyContent = "bodyContent_3fcf9099";
exports.headerIsLarge = "headerIsLarge_3fcf9099";
exports.headerIsSmall = "headerIsSmall_3fcf9099";
exports.headline = "headline_3fcf9099";
exports.headerIsCondensed = "headerIsCondensed_3fcf9099";
exports.body = "body_3fcf9099";
exports.subText = "subText_3fcf9099";
exports.closeButton = "closeButton_3fcf9099";
exports.footer = "footer_3fcf9099";
exports.wideCallout = "wideCallout_3fcf9099";
exports.primaryButton = "primaryButton_3fcf9099";
exports.secondaryButton = "secondaryButton_3fcf9099";
//# sourceMappingURL=TeachingBubble.scss.js.map

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1573), exports);
//# sourceMappingURL=Spinner.js.map

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DialogType;
(function (DialogType) {
    /** Standard dialog */
    DialogType[DialogType["normal"] = 0] = "normal";
    /** Dialog with large header banner */
    DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
    /** Dialog with an 'x' close button in the upper-right corner */
    DialogType[DialogType["close"] = 2] = "close";
})(DialogType = exports.DialogType || (exports.DialogType = {}));
//# sourceMappingURL=DialogContent.types.js.map

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".isOpen_a6c8430f{display:-webkit-box;display:-ms-flexbox;display:flex}.main_a6c8430f{width:288px}.button_a6c8430f.isClose_a6c8430f .ms-Icon.ms-Icon--Cancel{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";font-size:16px}.inner_a6c8430f{padding:0 28px 20px}.header_a6c8430f{position:relative;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.title_a6c8430f{margin:0;font-size:21px;font-weight:100;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";padding:20px 36px 20px 28px}[dir='rtl'] .title_a6c8430f{padding:20px 28px 20px 36px}.topButton_a6c8430f{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;position:absolute;top:0;padding:12px 12px 0 0}[dir='ltr'] .topButton_a6c8430f{right:0}[dir='rtl'] .topButton_a6c8430f{left:0}[dir='rtl'] .topButton_a6c8430f{padding:12px 0 0 12px}.topButton_a6c8430f>*{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.content_a6c8430f{position:relative;width:100%}.content_a6c8430f .ms-Button.ms-Button--compound{margin-bottom:20px}.content_a6c8430f .ms-Button.ms-Button--compound:last-child{margin-bottom:0}.subText_a6c8430f{margin:0 0 20px 0;padding-top:8px;font-size:12px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:300;line-height:1.5;word-wrap:break-word}.actions_a6c8430f{position:relative;width:100%;min-height:24px;line-height:24px;margin:20px 0 0;font-size:0}.actions_a6c8430f .ms-Button{line-height:normal}.actionsRight_a6c8430f{font-size:0}[dir='ltr'] .actionsRight_a6c8430f{text-align:right}[dir='rtl'] .actionsRight_a6c8430f{text-align:left}[dir='ltr'] .actionsRight_a6c8430f{margin-right:-4px}[dir='rtl'] .actionsRight_a6c8430f{margin-left:-4px}.actionsRight_a6c8430f .action_a6c8430f{margin:0px 4px}.isMultiline_a6c8430f .title_a6c8430f{font-size:28px}.isMultiline_a6c8430f .inner_a6c8430f{padding:0 20px 20px}.isLargeHeader_a6c8430f .header_a6c8430f{background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.isLargeHeader_a6c8430f .title_a6c8430f{font-size:28px;font-weight:100;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";padding:26px 28px 28px;margin-bottom:8px}.isLargeHeader_a6c8430f .subText_a6c8430f{font-size:14px}@media (min-width: 480px){.main_a6c8430f{width:auto;min-width:288px;max-width:340px}}\n" }]);
exports.isOpen = "isOpen_a6c8430f";
exports.main = "main_a6c8430f";
exports.button = "button_a6c8430f";
exports.isClose = "isClose_a6c8430f";
exports.inner = "inner_a6c8430f";
exports.header = "header_a6c8430f";
exports.title = "title_a6c8430f";
exports.topButton = "topButton_a6c8430f";
exports.content = "content_a6c8430f";
exports.subText = "subText_a6c8430f";
exports.actions = "actions_a6c8430f";
exports.actionsRight = "actionsRight_a6c8430f";
exports.action = "action_a6c8430f";
exports.isMultiline = "isMultiline_a6c8430f";
exports.isLargeHeader = "isLargeHeader_a6c8430f";
//# sourceMappingURL=Dialog.scss.js.map

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getPersonaPhoto_1 = __webpack_require__(1597);
var getHexConsumerIdForUser_1 = __webpack_require__(1579);
var Store_1 = __webpack_require__(327);
var getPersonaControlKey_1 = __webpack_require__(332);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var Persona_1 = __webpack_require__(234);
var styles = __webpack_require__(1600);
var classNames = __webpack_require__(30).bind(styles);
var PersonaControl = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaControl, _super);
    function PersonaControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PersonaControl.prototype.componentDidMount = function () {
        this.fetchPersonaPhoto(this.props);
    };
    PersonaControl.prototype.componentWillReceiveProps = function (nextProps) {
        this.fetchPersonaPhoto(nextProps);
    };
    PersonaControl.prototype.fetchPersonaPhoto = function (props) {
        if (props.emailAddress || props.name) {
            getPersonaPhoto_1.default(props.name, props.emailAddress, props.size, props.hexConsumerIdForUser || getHexConsumerIdForUser_1.default(props.emailAddress));
        }
    };
    PersonaControl.prototype.renderPersona = function (viewState) {
        var _a = this.props, className = _a.className, size = _a.size, name = _a.name, statusText = _a.statusText, showPersonaDetails = _a.showPersonaDetails, secondaryText = _a.secondaryText;
        var photoDisplayProps = {};
        if (viewState.personaBlob && viewState.personaBlob.blobUrl) {
            photoDisplayProps.imageUrl = viewState.personaBlob.blobUrl;
            photoDisplayProps.imageShouldFadeIn = false;
        }
        return (React.createElement(Persona_1.Persona, tslib_1.__assign({ className: classNames(className, styles.persona), presence: Persona_1.PersonaPresence.none, hidePersonaDetails: !showPersonaDetails, size: size, primaryText: name, secondaryText: secondaryText, tertiaryText: statusText }, photoDisplayProps)));
    };
    PersonaControl.prototype.render = function () {
        var personaControlKey = getPersonaControlKey_1.default(this.props.emailAddress, this.props.size, this.props.name);
        var viewState = Store_1.default.viewStates.get(personaControlKey);
        if (viewState) {
            return this.renderPersona(viewState);
        }
        else {
            return null;
        }
    };
    PersonaControl.defaultProps = {
        emailAddress: '',
        name: '',
        size: Persona_1.PersonaSize.regular,
        secondaryText: '',
        showPresence: true,
    };
    PersonaControl = tslib_1.__decorate([
        mobx_react_1.observer
    ], PersonaControl);
    return PersonaControl;
}(React.Component));
exports.default = PersonaControl;
//# sourceMappingURL=PersonaControl.js.map

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_110eb236{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0}.picker_110eb236{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": ";font-size:14px;position:relative}html[dir='ltr'] .picker_110eb236{text-align:left}html[dir='rtl'] .picker_110eb236{text-align:right}.holder_110eb236{-webkit-overflow-scrolling:touch;-webkit-box-sizing:border-box;box-sizing:border-box;display:none}.picker_110eb236.pickerIsOpened_110eb236 .holder_110eb236{-webkit-box-sizing:border-box;box-sizing:border-box;display:block}.pickerIsOpened_110eb236{position:relative}.frame_110eb236{padding:1px;position:relative}.wrap_110eb236{margin:-1px;padding:9px;display:-webkit-box;display:-ms-flexbox;display:flex}.dayPicker_110eb236{display:block}.header_110eb236{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:40px;line-height:44px}.monthAndYear_110eb236,.year_110eb236{display:inline-block;font-size:21px;font-weight:100;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";margin-top:-1px;font-weight:300;padding:0 5px}html[dir='ltr'] .monthAndYear_110eb236{margin-left:5px}html[dir='rtl'] .monthAndYear_110eb236{margin-right:5px}html[dir='ltr'] .year_110eb236{margin-left:5px}html[dir='rtl'] .year_110eb236{margin-right:5px}.table_110eb236{text-align:center;border-collapse:collapse;border-spacing:0;table-layout:fixed;font-size:inherit;margin-top:10px}.table_110eb236 td{margin:0;padding:0}.table_110eb236 td:hover{outline:1px solid transparent}.day_110eb236,.weekday_110eb236{width:40px;height:40px;padding:0;line-height:40px;font-size:15px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box}.dayIsToday_110eb236{position:relative;background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.dayIsToday_110eb236{border:1px solid WindowText}}.dayIsDisabled_110eb236:before{border-top-color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.dayIsUnfocused_110eb236,.dayIsDisabled_110eb236{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";font-weight:400}.dayIsFocused_110eb236:hover,.dayIsUnfocused_110eb236:hover{cursor:pointer;background:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": "}.day_110eb236.dayIsHighlighted_110eb236.dayIsFocused_110eb236::-moz-focus-inner{border:0}.day_110eb236.dayIsHighlighted_110eb236.dayIsFocused_110eb236{outline:transparent}.day_110eb236.dayIsHighlighted_110eb236.dayIsFocused_110eb236{position:relative}.ms-Fabric.is-focusVisible .day_110eb236.dayIsHighlighted_110eb236.dayIsFocused_110eb236:focus:after{content:'';position:absolute;top:1px;right:1px;bottom:1px;left:1px;pointer-events:none;border:1px solid " }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.day_110eb236.dayIsHighlighted_110eb236.dayIsFocused_110eb236::-moz-focus-inner{border:0}.day_110eb236.dayIsHighlighted_110eb236.dayIsFocused_110eb236{outline:transparent}.day_110eb236.dayIsHighlighted_110eb236.dayIsFocused_110eb236{position:relative}.ms-Fabric.is-focusVisible .day_110eb236.dayIsHighlighted_110eb236.dayIsFocused_110eb236:focus:after{content:'';position:absolute;top:1px;right:1px;bottom:1px;left:1px;pointer-events:none;border:1px solid WindowText}}.dayIsHighlighted_110eb236:hover,.pickerIsFocused_110eb236 .dayIsHighlighted_110eb236{cursor:pointer}@media screen and (-ms-high-contrast: active){.dayIsHighlighted_110eb236:hover,.pickerIsFocused_110eb236 .dayIsHighlighted_110eb236{border:2px solid Highlight}}.dayIsUnfocused_110eb236:active.day_110eb236,.dayIsFocused_110eb236:active.day_110eb236,.dayIsHighlighted_110eb236.day_110eb236{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": ";background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.dayIsHighlighted_110eb236.dayDisabled_110eb236,.dayIsHighlighted_110eb236.dayDisabled_110eb236:hover{background:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.dayIsToday_110eb236,.pickerIsFocused_110eb236 .dayIsToday_110eb236{position:relative;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";font-weight:600}.dayBackground_110eb236,.weekBackground_110eb236,.monthBackground_110eb236{background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.showWeekNumbers_110eb236 .weekNumbers_110eb236{position:absolute;margin-top:40px;border-right:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box;width:30px}.showWeekNumbers_110eb236 .weekNumbers_110eb236 .day_110eb236{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.showWeekNumbers_110eb236 .weekNumbers_110eb236 .day_110eb236.weekIsHighlighted_110eb236{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": "}.showWeekNumbers_110eb236 .table_110eb236:not(.weekNumbers_110eb236){margin-left:30px}.showWeekNumbers_110eb236 .table_110eb236 .day_110eb236,.showWeekNumbers_110eb236 .table_110eb236 .weekday_110eb236{width:30px}.monthComponents_110eb236,.yearComponents_110eb236,.decadeComponents_110eb236{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:3px}.yearComponents_110eb236{margin-left:3px}.prevMonth_110eb236,.nextMonth_110eb236,.prevYear_110eb236,.nextYear_110eb236,.prevDecade_110eb236,.nextDecade_110eb236{width:40px;height:40px;display:block;text-align:center;line-height:40px;text-align:center;font-size:16px;color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": ";position:relative;top:2px}.prevMonth_110eb236:hover,.nextMonth_110eb236:hover,.prevYear_110eb236:hover,.nextYear_110eb236:hover,.prevDecade_110eb236:hover,.nextDecade_110eb236:hover{color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": ";cursor:pointer;outline:1px solid transparent}.prevMonthIsDisabled_110eb236,.nextMonthIsDisabled_110eb236,.prevYearIsDisabled_110eb236,.nextYearIsDisabled_110eb236,.prevDecadeIsDisabled_110eb236,.nextDecadeIsDisabled_110eb236{visibility:hidden}.headerToggleView_110eb236:hover{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";cursor:pointer}.currentYear_110eb236,.currentDecade_110eb236{display:block;padding:0 5px;font-size:21px;font-weight:100;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";height:40px;line-height:40px;font-weight:300}html[dir='ltr'] .currentYear_110eb236,html[dir='ltr'] .currentDecade_110eb236{margin-left:5px}html[dir='rtl'] .currentYear_110eb236,html[dir='rtl'] .currentDecade_110eb236{margin-right:5px}.optionGrid_110eb236{position:relative;height:210px;width:280px;margin:12px 0 0 0}html[dir='rtl'] .optionGrid_110eb236{margin:12px 0 0 0}.monthOption_110eb236,.yearOption_110eb236{width:60px;height:60px;line-height:60px;cursor:pointer;margin:0 10px 10px 0;font-size:13px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";text-align:center}html[dir='ltr'] .monthOption_110eb236,html[dir='ltr'] .yearOption_110eb236{float:left}html[dir='rtl'] .monthOption_110eb236,html[dir='rtl'] .yearOption_110eb236{float:right}html[dir='rtl'] .monthOption_110eb236,html[dir='rtl'] .yearOption_110eb236{margin:0 0 10px 10px}.monthOption_110eb236:hover,.yearOption_110eb236:hover{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": ";background-color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";outline:1px solid transparent}.monthOption_110eb236.isHighlighted_110eb236,.yearOption_110eb236.isHighlighted_110eb236{background-color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.monthOptionIsDisabled_110eb236,.yearOptionIsDisabled_110eb236{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";pointer-events:none}.goToday_110eb236{bottom:9px;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";cursor:pointer;font-size:12px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";height:30px;line-height:30px;padding:0 10px;position:absolute !important}[dir='ltr'] .goToday_110eb236{right:13px}[dir='rtl'] .goToday_110eb236{left:13px}.goToday_110eb236:hover{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";outline:1px solid transparent}.goToday_110eb236:active{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}.wrap_110eb236.goTodaySpacing_110eb236{margin-bottom:30px}.root_110eb236.isPickingYears_110eb236 .dayPicker_110eb236,.root_110eb236.isPickingYears_110eb236 .monthComponents_110eb236{display:none}.root_110eb236.isPickingYears_110eb236 .monthPicker_110eb236{display:none}.root_110eb236.isPickingYears_110eb236 .yearPicker_110eb236{display:block}@media (min-device-width: 460px){.wrap_110eb236{padding:9px 8px}.dayPicker_110eb236,.monthPicker_110eb236{min-height:214px}.header_110eb236{height:28px;line-height:28px}.day_110eb236,.weekday_110eb236{width:28px;height:28px;line-height:28px;font-size:12px}.prevMonth_110eb236,.nextMonth_110eb236,.prevYear_110eb236,.nextYear_110eb236,.prevDecade_110eb236,.nextDecade_110eb236{font-size:14px;width:24px;height:24px;line-height:24px}.holder_110eb236{width:212px;height:auto}.monthAndYear_110eb236,.year_110eb236{font-size:17px;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.yearComponents_110eb236{margin-left:1px}.goToday_110eb236{padding:0 3px}.showWeekNumbers_110eb236 .weekNumbers_110eb236{margin-top:28px;width:26px;margin-left:-7px}.showWeekNumbers_110eb236 .table_110eb236:not(.weekNumbers_110eb236){margin-left:19px}.showWeekNumbers_110eb236 .table_110eb236 .day_110eb236,.showWeekNumbers_110eb236 .table_110eb236 .weekday_110eb236{width:26px}.monthPickerVisible_110eb236 .wrap_110eb236{padding:10px}.monthPickerVisible_110eb236 .dayPicker_110eb236{margin:-10px 0;padding:10px 0}.monthPickerVisible_110eb236 .dayPicker_110eb236{-webkit-box-sizing:border-box;box-sizing:border-box;width:212px;min-height:214px}html[dir='ltr'] .monthPickerVisible_110eb236 .dayPicker_110eb236{border-right:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}html[dir='rtl'] .monthPickerVisible_110eb236 .dayPicker_110eb236{border-left:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.monthPickerVisible_110eb236 .monthPicker_110eb236{display:block}.monthPickerVisible_110eb236 .optionGrid_110eb236{height:150px;width:212px}.monthPickerVisible_110eb236 .toggleMonthView_110eb236{display:none}.monthPickerVisible_110eb236 .currentYear_110eb236,.monthPickerVisible_110eb236 .currentDecade_110eb236{font-size:17px;margin:0;height:28px;line-height:26px;display:inline-block}.monthPickerVisible_110eb236 .monthOption_110eb236,.monthPickerVisible_110eb236 .yearOption_110eb236{width:40px;height:40px;line-height:40px;font-size:12px;margin:0 11px 11px 0}html[dir='rtl'] .monthPickerVisible_110eb236 .monthOption_110eb236,html[dir='rtl'] .monthPickerVisible_110eb236 .yearOption_110eb236{margin:0 0 11px 11px}.monthPickerVisible_110eb236 .monthOption_110eb236:hover,.monthPickerVisible_110eb236 .yearOption_110eb236:hover{outline:1px solid transparent}.monthPickerVisible_110eb236 .monthOption_110eb236:nth-child(4n+4),.monthPickerVisible_110eb236 .yearOption_110eb236:nth-child(4n+4){margin:0 0px 11px 0}html[dir='rtl'] .monthPickerVisible_110eb236 .monthOption_110eb236:nth-child(4n+4),html[dir='rtl'] .monthPickerVisible_110eb236 .yearOption_110eb236:nth-child(4n+4){margin:0 0 11px 0px}.monthPickerVisible_110eb236 .goToday_110eb236{-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;height:28px;line-height:28px;padding:0 10px;top:199px}[dir='ltr'] .monthPickerVisible_110eb236 .goToday_110eb236{right:8px}[dir='rtl'] .monthPickerVisible_110eb236 .goToday_110eb236{left:8px}html[dir='ltr'] .monthPickerVisible_110eb236 .goToday_110eb236{text-align:right}html[dir='rtl'] .monthPickerVisible_110eb236 .goToday_110eb236{text-align:left}.monthPickerVisible_110eb236 .wrap_110eb236.goTodaySpacing_110eb236{margin-bottom:0px}.monthPickerVisible_110eb236 .root_110eb236.isPickingYears_110eb236 .dayPicker_110eb236,.monthPickerVisible_110eb236 .root_110eb236.isPickingYears_110eb236 .monthComponents_110eb236{display:block}.monthPickerVisible_110eb236 .root_110eb236.isPickingYears_110eb236 .monthPicker_110eb236{display:none}.monthPickerVisible_110eb236 .root_110eb236.isPickingYears_110eb236 .yearPicker_110eb236{display:block}.calendarsInline_110eb236 .wrap_110eb236{padding:9px 12px}.calendarsInline_110eb236 .holder_110eb236{width:440px;height:auto}.calendarsInline_110eb236 .table_110eb236{margin-right:12px}.calendarsInline_110eb236 .dayPicker_110eb236{width:auto}.calendarsInline_110eb236 .monthPicker_110eb236{margin-left:13px}.calendarsInline_110eb236 .goToday_110eb236{padding:0 10px}[dir='ltr'] .calendarsInline_110eb236 .goToday_110eb236{right:13px}[dir='rtl'] .calendarsInline_110eb236 .goToday_110eb236{left:13px}.monthPickerOnly_110eb236 .wrap_110eb236{padding:10px}.monthPickerAsOverlay_110eb236 .wrap_110eb236{padding-top:4px;padding-bottom:4px}.monthPickerAsOverlay_110eb236 .holder_110eb236{height:240px}}@media (max-device-width: 459px){.holder_110eb236{width:300px}.calendarsInline_110eb236 .monthPicker_110eb236,.calendarsInline_110eb236 .yearPicker_110eb236{display:none}.yearComponents_110eb236{margin-top:2px}}.wrap_110eb236 span:focus::-moz-focus-inner,.wrap_110eb236 div:focus::-moz-focus-inner{border:0}.wrap_110eb236 span:focus,.wrap_110eb236 div:focus{outline:transparent}.wrap_110eb236 span:focus,.wrap_110eb236 div:focus{position:relative}.ms-Fabric.is-focusVisible .wrap_110eb236 span:focus:focus:after,.ms-Fabric.is-focusVisible .wrap_110eb236 div:focus:focus:after{content:'';position:absolute;top:1px;right:1px;bottom:1px;left:1px;pointer-events:none;border:1px solid " }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.goToday_110eb236{width:auto}.nextMonth_110eb236,.prevMonth_110eb236,.nextYear_110eb236,.prevYear_110eb236{display:inline-block}.nextMonth_110eb236:hover,.prevMonth_110eb236:hover,.nextYear_110eb236:hover,.prevYear_110eb236:hover{background-color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": "}.nextMonth_110eb236,.nextYear_110eb236{margin-left:3px}.monthIsHighlighted_110eb236{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.monthIsHighlighted_110eb236.monthOption_110eb236:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.monthIsCurrentMonth_110eb236{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.monthIsCurrentMonth_110eb236.monthOption_110eb236:hover{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.monthOption_110eb236:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.topLeftCornerDate_110eb236{border-radius:0}.topRightCornerDate_110eb236{border-radius:0}.bottomLeftCornerDate_110eb236{border-radius:0}.bottomRightCornerDate_110eb236{border-radius:0}.singleTopDate_110eb236{border-radius:0}.singleBottomDate_110eb236{border-radius:0}\n" }]);
exports.root = "root_110eb236";
exports.picker = "picker_110eb236";
exports.holder = "holder_110eb236";
exports.pickerIsOpened = "pickerIsOpened_110eb236";
exports.frame = "frame_110eb236";
exports.wrap = "wrap_110eb236";
exports.dayPicker = "dayPicker_110eb236";
exports.header = "header_110eb236";
exports.monthAndYear = "monthAndYear_110eb236";
exports.year = "year_110eb236";
exports.table = "table_110eb236";
exports.day = "day_110eb236";
exports.weekday = "weekday_110eb236";
exports.dayIsToday = "dayIsToday_110eb236";
exports.dayIsDisabled = "dayIsDisabled_110eb236";
exports.dayIsUnfocused = "dayIsUnfocused_110eb236";
exports.dayIsFocused = "dayIsFocused_110eb236";
exports.dayIsHighlighted = "dayIsHighlighted_110eb236";
exports.pickerIsFocused = "pickerIsFocused_110eb236";
exports.dayDisabled = "dayDisabled_110eb236";
exports.dayBackground = "dayBackground_110eb236";
exports.weekBackground = "weekBackground_110eb236";
exports.monthBackground = "monthBackground_110eb236";
exports.showWeekNumbers = "showWeekNumbers_110eb236";
exports.weekNumbers = "weekNumbers_110eb236";
exports.weekIsHighlighted = "weekIsHighlighted_110eb236";
exports.monthComponents = "monthComponents_110eb236";
exports.yearComponents = "yearComponents_110eb236";
exports.decadeComponents = "decadeComponents_110eb236";
exports.prevMonth = "prevMonth_110eb236";
exports.nextMonth = "nextMonth_110eb236";
exports.prevYear = "prevYear_110eb236";
exports.nextYear = "nextYear_110eb236";
exports.prevDecade = "prevDecade_110eb236";
exports.nextDecade = "nextDecade_110eb236";
exports.prevMonthIsDisabled = "prevMonthIsDisabled_110eb236";
exports.nextMonthIsDisabled = "nextMonthIsDisabled_110eb236";
exports.prevYearIsDisabled = "prevYearIsDisabled_110eb236";
exports.nextYearIsDisabled = "nextYearIsDisabled_110eb236";
exports.prevDecadeIsDisabled = "prevDecadeIsDisabled_110eb236";
exports.nextDecadeIsDisabled = "nextDecadeIsDisabled_110eb236";
exports.headerToggleView = "headerToggleView_110eb236";
exports.currentYear = "currentYear_110eb236";
exports.currentDecade = "currentDecade_110eb236";
exports.optionGrid = "optionGrid_110eb236";
exports.monthOption = "monthOption_110eb236";
exports.yearOption = "yearOption_110eb236";
exports.isHighlighted = "isHighlighted_110eb236";
exports.monthOptionIsDisabled = "monthOptionIsDisabled_110eb236";
exports.yearOptionIsDisabled = "yearOptionIsDisabled_110eb236";
exports.goToday = "goToday_110eb236";
exports.goTodaySpacing = "goTodaySpacing_110eb236";
exports.isPickingYears = "isPickingYears_110eb236";
exports.monthPicker = "monthPicker_110eb236";
exports.yearPicker = "yearPicker_110eb236";
exports.monthPickerVisible = "monthPickerVisible_110eb236";
exports.toggleMonthView = "toggleMonthView_110eb236";
exports.calendarsInline = "calendarsInline_110eb236";
exports.monthPickerOnly = "monthPickerOnly_110eb236";
exports.monthPickerAsOverlay = "monthPickerAsOverlay_110eb236";
exports.monthIsHighlighted = "monthIsHighlighted_110eb236";
exports.monthIsCurrentMonth = "monthIsCurrentMonth_110eb236";
exports.topLeftCornerDate = "topLeftCornerDate_110eb236";
exports.topRightCornerDate = "topRightCornerDate_110eb236";
exports.bottomLeftCornerDate = "bottomLeftCornerDate_110eb236";
exports.bottomRightCornerDate = "bottomRightCornerDate_110eb236";
exports.singleTopDate = "singleTopDate_110eb236";
exports.singleBottomDate = "singleBottomDate_110eb236";
//# sourceMappingURL=Calendar.scss.js.map

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ariaRoles_1 = __webpack_require__(1594);
exports.AriaRoles = ariaRoles_1.AriaRoles;
var generateNewId_1 = __webpack_require__(1595);
exports.generateNewId = generateNewId_1.generateNewId;
var generateDomPropertiesForAria_1 = __webpack_require__(1596);
exports.generateDomPropertiesForAria = generateDomPropertiesForAria_1.generateDomPropertiesForAria;
//# sourceMappingURL=index.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.Options.js